const europegeo = {
    type: 'FeatureCollection',
    features: [
      {
        type: 'Feature',
        properties: {
          NAME: 'Estonia',
          id: 0,
          label: 'Estonia',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.69,
          year: '2023',
          centroid: [25.0136, 58.5953],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [23.990829, 58.099998],
                [23.97805000000011, 58.097771],
                [23.962772, 58.09943],
                [23.952774, 58.103607],
                [23.944996000000117, 58.108604],
                [23.938885, 58.11444100000011],
                [23.938606, 58.122765],
                [23.939995, 58.131935],
                [23.94305, 58.139992],
                [23.94777, 58.147217],
                [23.955551, 58.152489],
                [23.964996, 58.156654],
                [23.97916, 58.15777],
                [23.994717, 58.1560970000001],
                [24.006386, 58.152771],
                [24.016109, 58.1486],
                [24.022186, 58.14275],
                [24.024719, 58.137215],
                [24.02528, 58.128876],
                [24.015831000000105, 58.11444100000011],
                [24.00972, 58.10833],
                [24.001663, 58.10332],
                [23.990829, 58.099998],
              ],
            ],
            [
              [
                [22.990829, 58.597771],
                [23.090832, 58.564438],
                [23.263054, 58.496101],
                [23.273052, 58.491936],
                [23.289165, 58.48220800000013],
                [23.31971700000014, 58.46166],
                [23.332218000000125, 58.449997],
                [23.332775, 58.441658],
                [23.328053000000125, 58.434433000000126],
                [23.2675, 58.429436],
                [23.250000000000114, 58.430275],
                [23.226105, 58.43665],
                [23.206104, 58.444992],
                [23.198051, 58.44971],
                [23.142494000000113, 58.44360400000011],
                [23.076942, 58.413879],
                [23.064163, 58.385826],
                [23.02861, 58.35777300000012],
                [22.756943, 58.240273000000116],
                [22.648884000000123, 58.23027],
                [22.58194, 58.24110400000012],
                [22.520554, 58.242218],
                [22.487495000000138, 58.242218],
                [22.474995, 58.241936],
                [22.37833, 58.223045],
                [22.36749600000013, 58.219711],
                [22.288609, 58.188042],
                [22.279163, 58.18387600000011],
                [22.2716640000001, 58.178604],
                [22.26722, 58.171379000000115],
                [22.266388, 58.163879],
                [22.2691650000001, 58.15638],
                [22.273609, 58.14971900000012],
                [22.276108, 58.142494],
                [22.264721, 58.102219],
                [22.261944, 58.09388000000013],
                [22.202496, 57.986107],
                [22.09916, 57.93055],
                [22.07333, 57.91666],
                [22.051662, 57.90971400000012],
                [22.037777, 57.908325000000104],
                [22.022221, 57.90971400000012],
                [22.01028, 57.91304800000012],
                [22.000553, 57.91694],
                [21.994160000000136, 57.922768],
                [21.980549, 57.958046],
                [21.98582800000014, 57.976379],
                [22.082218, 58.07666],
                [22.089718, 58.08194],
                [22.10055, 58.085266],
                [22.112495000000138, 58.08387800000014],
                [22.151108, 58.08638],
                [22.197216, 58.137497],
                [22.201385, 58.144714],
                [22.196941, 58.151382],
                [22.188606, 58.15638],
                [22.17694, 58.159431],
                [22.145275, 58.1586],
                [22.131664, 58.16082],
                [22.07861, 58.17083],
                [22.068607, 58.17471300000011],
                [21.884441, 58.25222],
                [21.869717, 58.262497],
                [21.84860600000013, 58.278877000000136],
                [21.84416, 58.28555300000011],
                [21.841385, 58.29305],
                [21.84388700000011, 58.299164],
                [21.874439, 58.339989],
                [21.885273, 58.343323],
                [21.899162, 58.342766],
                [21.955551, 58.34305],
                [22.0075, 58.35332],
                [22.006386, 58.359993],
                [21.99638, 58.381378],
                [21.916664, 58.4575],
                [21.910275, 58.46305100000012],
                [21.901939, 58.468048],
                [21.878052, 58.4741590000001],
                [21.867775, 58.478325],
                [21.85139, 58.48777],
                [21.83194, 58.50499700000012],
                [21.842773000000136, 58.50833100000011],
                [21.924995, 58.517212],
                [21.98472, 58.516388],
                [22.000553, 58.514999],
                [22.112495000000138, 58.492218],
                [22.18916300000012, 58.544998],
                [22.19833, 58.54943800000012],
                [22.327221, 58.577492],
                [22.501663, 58.602219],
                [22.62416, 58.59332300000011],
                [22.76833, 58.60027],
                [22.775761, 58.606155000000115],
                [22.80777400000011, 58.616386],
                [22.82361, 58.616936],
                [22.87166200000013, 58.617767],
                [22.905273, 58.61749300000014],
                [22.917217000000107, 58.61610400000012],
                [22.978882, 58.601105],
                [22.990829, 58.597771],
              ],
            ],
            [
              [
                [23.364998, 58.52999100000011],
                [23.227219000000105, 58.529716],
                [23.215271, 58.53305],
                [23.09110600000014, 58.580276],
                [23.07111, 58.588326],
                [23.06472, 58.59415400000012],
                [23.0602760000001, 58.60083],
                [23.057774, 58.60833000000014],
                [23.060829, 58.616386],
                [23.06861, 58.62165800000014],
                [23.140274, 58.665825],
                [23.149719, 58.670273],
                [23.173607000000118, 58.675827],
                [23.186382, 58.678047],
                [23.200829, 58.67916],
                [23.216385, 58.677773],
                [23.247459, 58.671051],
                [23.271385, 58.664436],
                [23.317219, 58.650826],
                [23.339165, 58.643326],
                [23.347218, 58.6386030000001],
                [23.394997, 58.5655440000001],
                [23.399162, 58.558884],
                [23.396385000000123, 58.550827],
                [23.376106, 58.53305],
                [23.364998, 58.52999100000011],
              ],
            ],
            [
              [
                [23.277222, 58.963051],
                [23.18055, 58.9611],
                [23.16472, 58.962769],
                [23.152496, 58.9658280000001],
                [23.14444, 58.970825],
                [23.138050000000135, 58.976654],
                [23.113331, 59.01721],
                [23.110828, 59.024712],
                [23.117218, 59.030823],
                [23.12666, 59.034996],
                [23.137775, 59.03833],
                [23.15083, 59.04055],
                [23.181385, 59.042221],
                [23.19216, 59.041985000000125],
                [23.325829000000113, 59.037498],
                [23.339718, 59.035271],
                [23.35194, 59.031937],
                [23.361942000000113, 59.02777100000014],
                [23.37027400000011, 59.023048],
                [23.38722, 59.00471],
                [23.391663, 58.99805],
                [23.392220000000123, 58.989716],
                [23.387497, 58.98276],
                [23.3811070000001, 58.976379],
                [23.36999500000013, 58.973045],
                [23.291943, 58.964157],
                [23.277222, 58.963051],
              ],
            ],
            [
              [
                [22.749718000000144, 59.000000000000114],
                [22.801109, 58.997215],
                [22.843052000000114, 59.00222],
                [22.860828, 59.001663],
                [22.929718, 58.98249],
                [22.952496, 58.96693],
                [23.04361, 58.851105],
                [23.04805, 58.844437],
                [23.045277, 58.83638],
                [23.0216640000001, 58.820549],
                [23.005276, 58.830551],
                [22.96082700000011, 58.84499],
                [22.948330000000112, 58.844437],
                [22.88444, 58.833054],
                [22.865551, 58.82444],
                [22.868328000000133, 58.818886],
                [22.882217, 58.816666],
                [22.888607, 58.810822000000144],
                [22.887218, 58.787773],
                [22.88444, 58.779716],
                [22.848053, 58.7736],
                [22.81583, 58.772766],
                [22.798332, 58.7736],
                [22.784443, 58.775826],
                [22.77805, 58.781662],
                [22.77722, 58.78999],
                [22.783333, 58.796104],
                [22.792774000000122, 58.80027],
                [22.803886, 58.803604],
                [22.823051, 58.81221],
                [22.829163, 58.81832900000012],
                [22.826385, 58.824165],
                [22.812496, 58.82638],
                [22.79805, 58.824997],
                [22.77583, 58.81860400000011],
                [22.74721, 58.80555],
                [22.739437, 58.80027],
                [22.721107, 58.781662],
                [22.70138, 58.753883],
                [22.692493, 58.73943300000013],
                [22.68972, 58.731102],
                [22.680828000000133, 58.716660000000104],
                [22.674717, 58.710548],
                [22.666939, 58.7052690000001],
                [22.646385000000123, 58.697769],
                [22.62416, 58.691101],
                [22.59555, 58.68832],
                [22.56527, 58.686653],
                [22.5475, 58.68721],
                [22.53167, 58.688599],
                [22.517776, 58.691101],
                [22.479996000000142, 58.69971],
                [22.469715, 58.703606],
                [22.465271, 58.710274],
                [22.46944, 58.715546],
                [22.47194, 58.76361],
                [22.44999700000011, 58.831383],
                [22.445549000000142, 58.838043],
                [22.426105, 58.85527],
                [22.404995, 58.871658],
                [22.390274, 58.8822100000001],
                [22.381939, 58.88694],
                [22.369717, 58.890274],
                [22.336109, 58.89222],
                [22.276943, 58.88943],
                [22.24555, 58.878601],
                [22.229439000000127, 58.87804],
                [22.177219, 58.88888500000013],
                [22.164997, 58.891937],
                [22.06361, 58.92360700000012],
                [22.05333, 58.927773],
                [22.044998, 58.932495],
                [22.04222, 58.939987],
                [22.046387, 58.945267000000115],
                [22.052219, 58.949715],
                [22.064999000000114, 58.95221700000013],
                [22.191105, 58.94748700000014],
                [22.375553, 58.95166],
                [22.434441, 58.966385],
                [22.468052, 58.978043],
                [22.487774000000115, 58.992218],
                [22.523609, 59.022491000000116],
                [22.575829000000113, 59.068604],
                [22.699162, 59.051384],
                [22.694717, 59.044159],
                [22.6986, 59.019989],
                [22.70305, 59.013611],
                [22.71971500000012, 59.003609],
                [22.733883, 59.001389],
                [22.749718000000144, 59.000000000000114],
              ],
            ],
            [
              [
                [25.780277, 59.628876000000105],
                [25.873051, 59.598877],
                [25.979996000000142, 59.632767],
                [26.03083, 59.622765],
                [26.04361, 59.619987],
                [26.078053, 59.600548],
                [26.263054000000125, 59.585823],
                [26.389717, 59.56166100000013],
                [26.458328000000108, 59.541107],
                [26.479996, 59.53388200000012],
                [26.496105000000114, 59.53277],
                [26.525276, 59.53638500000011],
                [26.538052, 59.539162],
                [26.56166500000012, 59.545273],
                [26.57249800000011, 59.54916],
                [26.578053, 59.55555],
                [26.58889, 59.55916],
                [26.621662, 59.557213],
                [26.65055100000012, 59.553322],
                [26.67582700000014, 59.547493],
                [26.736938, 59.522491],
                [26.772774, 59.503883],
                [26.817219, 59.48082],
                [26.84972, 59.469437],
                [26.860275, 59.46583],
                [26.8836060000001, 59.45916],
                [26.921383000000105, 59.45082900000011],
                [26.964718, 59.444992],
                [26.98083, 59.44388],
                [27.033333, 59.44249],
                [27.0875, 59.442215],
                [27.18527200000011, 59.446938],
                [27.391106, 59.448601],
                [27.427219, 59.44833],
                [27.4436070000001, 59.44721],
                [27.45805, 59.445267],
                [27.483051, 59.43943],
                [27.50999800000011, 59.434433000000126],
                [27.553051, 59.42860400000012],
                [27.848053, 59.40665400000012],
                [27.88055, 59.407768],
                [27.89527500000014, 59.409431],
                [27.933331000000123, 59.41721],
                [27.953884, 59.425270000000125],
                [27.97805, 59.440544],
                [27.99305, 59.45138500000013],
                [27.998882, 59.457771],
                [28.015831, 59.4786],
                [28.026386, 59.47499],
                [28.07611, 59.453323],
                [28.10944, 59.436104],
                [28.170273, 59.397774],
                [28.180828, 59.389435],
                [28.193886000000134, 59.375824],
                [28.195274, 59.369438],
                [28.19361, 59.363327],
                [28.17932100000013, 59.32823600000012],
                [28.170359, 59.30978],
                [28.158232000000112, 59.297653],
                [28.143995, 59.290802],
                [28.09549, 59.283947],
                [28.055418, 59.279202],
                [28.030111, 59.277092],
                [28.01113, 59.279728],
                [27.9958400000001, 59.284473],
                [27.97106, 59.287109],
                [27.951551, 59.28553000000011],
                [27.920444, 59.275509],
                [27.912537, 59.271820000000105],
                [27.879847, 59.22806],
                [27.837219, 59.150826],
                [27.810555, 59.102493],
                [27.803329, 59.085266],
                [27.792221, 59.063324],
                [27.788052000000107, 59.058601],
                [27.704994, 58.98582],
                [27.68943800000011, 58.97943],
                [27.596943000000124, 58.9313810000001],
                [27.549999000000128, 58.907768],
                [27.533886, 58.902214],
                [27.493607, 58.881935],
                [27.457218, 58.85249],
                [27.43944, 58.83416],
                [27.435551, 58.829437],
                [27.428608, 58.819160000000124],
                [27.426105, 58.81360600000011],
                [27.423050000000103, 58.80138],
                [27.421661, 58.78833],
                [27.421661, 58.78138],
                [27.451107, 58.686935],
                [27.488049, 58.576385],
                [27.490551, 58.570831],
                [27.495827, 58.55999],
                [27.500832, 58.548882000000106],
                [27.517498, 58.50972],
                [27.521385000000123, 58.498329000000126],
                [27.535275, 58.450829],
                [27.542496000000142, 58.413879],
                [27.543610000000115, 58.393883],
                [27.543331000000137, 58.373322],
                [27.541943, 58.36721],
                [27.539165, 58.361664],
                [27.534996, 58.356941],
                [27.5258290000001, 58.348045],
                [27.514999, 58.339989],
                [27.496662, 58.32888],
                [27.48582800000014, 58.32083100000011],
                [27.467216, 58.303047],
                [27.464718, 58.297775],
                [27.464439, 58.283882],
                [27.47166, 58.226379],
                [27.474163, 58.213882],
                [27.476662, 58.208603],
                [27.48055, 58.203606],
                [27.54888, 58.13694],
                [27.554165, 58.132767000000115],
                [27.56583000000012, 58.125267],
                [27.58, 58.11916],
                [27.60194, 58.109993000000145],
                [27.60972, 58.107216],
                [27.625275, 58.101662],
                [27.641106, 58.0961],
                [27.65, 58.094154],
                [27.663052, 58.087212000000136],
                [27.67332800000014, 58.07888000000014],
                [27.677219, 58.07416500000011],
                [27.680828, 58.062492],
                [27.686661, 57.965271],
                [27.77333, 57.902214],
                [27.784721, 57.89888],
                [27.805275, 57.891106],
                [27.80999800000012, 57.88888500000013],
                [27.817497000000117, 57.88388],
                [27.820274, 57.881104],
                [27.823051000000135, 57.873878000000104],
                [27.822773, 57.869713000000104],
                [27.82111, 57.865829],
                [27.813885, 57.860275000000115],
                [27.785275, 57.84833],
                [27.753052, 57.839157],
                [27.734993, 57.835548],
                [27.702217000000132, 57.831665],
                [27.673607000000118, 57.830276],
                [27.629997000000117, 57.828606],
                [27.577221, 57.82277],
                [27.55139, 57.819443],
                [27.545830000000137, 57.817772],
                [27.40583, 57.68499],
                [27.400829, 57.678047],
                [27.348053, 57.595543000000134],
                [27.34694, 57.5911],
                [27.34694, 57.586937],
                [27.348053, 57.58305400000012],
                [27.353329, 57.568604],
                [27.361664000000133, 57.547493000000145],
                [27.363331, 57.54416],
                [27.372059, 57.535637],
                [27.31028, 57.53138000000013],
                [27.08722, 57.56221],
                [27.080551, 57.563606],
                [27.07027, 57.567497],
                [27.051662000000135, 57.588326],
                [27.03944, 57.599716000000114],
                [27.03194, 57.604713],
                [27.01861, 57.611382000000106],
                [26.996105, 57.61832],
                [26.96999, 57.62332],
                [26.906105, 57.63304900000014],
                [26.898331, 57.633881],
                [26.883884, 57.633606],
                [26.873051, 57.630547],
                [26.69777, 57.575554],
                [26.63499, 57.555824],
                [26.626385, 57.55110200000013],
                [26.619995, 57.544998000000135],
                [26.615273000000116, 57.533051],
                [26.612774000000115, 57.529434],
                [26.60889, 57.526939],
                [26.60277600000012, 57.52582600000011],
                [26.53889, 57.522217000000126],
                [26.523609000000135, 57.52304800000013],
                [26.51139, 57.5261],
                [26.313332, 57.605],
                [26.299164, 57.611382000000106],
                [26.287498, 57.618881],
                [26.274166, 57.62971],
                [26.204441, 57.69499],
                [26.034996, 57.823326],
                [25.946941, 57.85388],
                [25.883053, 57.85583],
                [25.836384, 57.8605500000001],
                [25.80139, 57.865829],
                [25.62277200000011, 57.916382],
                [25.618053, 57.918327],
                [25.461105, 57.994438],
                [25.453327, 57.999435],
                [25.44944, 58.00582900000012],
                [25.444996, 58.020828],
                [25.439995, 58.026939],
                [25.436108, 58.029434],
                [25.42166, 58.03555],
                [25.30749900000012, 58.08138300000013],
                [25.301662000000135, 58.083054],
                [25.294998000000135, 58.084435],
                [25.28722, 58.08416],
                [25.27555500000011, 58.081665],
                [25.266941, 58.076942],
                [25.263054000000125, 58.06916],
                [25.264442, 58.061378000000104],
                [25.288887, 58.047218],
                [25.29472, 58.04138],
                [25.296944, 58.038048],
                [25.300274, 58.026939],
                [25.30055, 58.018883],
                [25.299999, 58.01416],
                [25.294441, 58.0075],
                [25.28583, 58.003052],
                [25.247215, 57.99249],
                [25.232494, 57.99276700000013],
                [25.223885, 57.997215],
                [25.215, 58.00582900000012],
                [25.210827, 58.01249700000011],
                [25.207218, 58.028046],
                [25.203884, 58.03916],
                [25.199718000000132, 58.04999500000014],
                [25.192493, 58.059433000000126],
                [25.179718, 58.070274],
                [25.169994, 58.07444],
                [25.163052, 58.07583],
                [25.139164, 58.07666],
                [25.12443900000011, 58.076103],
                [25.09166, 58.071663],
                [25.07, 58.065269],
                [25.060829, 58.061104],
                [25.03833, 58.050270000000125],
                [25.015831000000105, 58.039436],
                [24.723885, 57.964996],
                [24.56055, 57.95555],
                [24.553608, 57.954712],
                [24.542774000000122, 57.95166],
                [24.453049, 57.913322],
                [24.44332900000012, 57.904434],
                [24.441105000000107, 57.90082600000011],
                [24.438328, 57.89277],
                [24.433884, 57.88583],
                [24.42777, 57.879433],
                [24.420273, 57.874435],
                [24.4025, 57.87054400000011],
                [24.37305, 57.868881],
                [24.32444, 57.87027],
                [24.31498, 57.871826],
                [24.338051, 57.923882],
                [24.345829, 57.93943],
                [24.353886, 57.954712],
                [24.363052, 57.96888],
                [24.389996, 58.002777],
                [24.4008290000001, 58.016106],
                [24.41194, 58.029434],
                [24.426105, 58.040833],
                [24.433884, 58.046104],
                [24.456661, 58.076103],
                [24.46999, 58.122765],
                [24.471661, 58.131935],
                [24.471107, 58.1486],
                [24.468884000000116, 58.1560970000001],
                [24.452496, 58.18277],
                [24.469440000000134, 58.23916],
                [24.472771, 58.247215],
                [24.47916, 58.253326],
                [24.486938, 58.25861],
                [24.498051, 58.26166],
                [24.526665, 58.2741620000001],
                [24.542496, 58.284439],
                [24.55527500000011, 58.296944],
                [24.559998, 58.30387900000011],
                [24.561665, 58.31305],
                [24.559441, 58.320549],
                [24.55555, 58.327217],
                [24.541386, 58.33804],
                [24.51778, 58.35305000000011],
                [24.458885, 58.37833],
                [24.419716, 58.38666],
                [24.390553, 58.390831000000105],
                [24.362495, 58.39194],
                [24.348331000000144, 58.390831000000105],
                [24.335552, 58.3886],
                [24.326107, 58.38472],
                [24.30055, 58.359993],
                [24.29583, 58.352776],
                [24.29305, 58.33638],
                [24.293331, 58.328049],
                [24.291943, 58.318886],
                [24.28722, 58.311661],
                [24.28083, 58.30555],
                [24.246105, 58.27666],
                [24.238049, 58.271378],
                [24.110554, 58.232208],
                [24.100552000000107, 58.236382],
                [24.092773, 58.24138],
                [24.056664, 58.26777],
                [24.050552, 58.273605],
                [24.01083, 58.29861],
                [23.99305, 58.30777],
                [23.973328, 58.315826],
                [23.949718, 58.32249500000012],
                [23.937775, 58.32582900000011],
                [23.826385, 58.354713],
                [23.78167, 58.350273],
                [23.770832, 58.346939],
                [23.728607, 58.370827],
                [23.679161, 58.425552],
                [23.63082900000012, 58.5236],
                [23.61694, 58.5261],
                [23.524719, 58.558327],
                [23.50111, 58.576942],
                [23.495548, 58.69415],
                [23.523331, 58.73555],
                [23.529442, 58.741661],
                [23.538887, 58.746101000000124],
                [23.549442000000113, 58.7438810000001],
                [23.56944, 58.73555],
                [23.583332, 58.733047],
                [23.60083, 58.732491],
                [23.725552, 58.744713],
                [23.867496, 58.766388],
                [23.874996, 58.7686],
                [23.85722, 58.7786],
                [23.827221, 58.79111],
                [23.805275, 58.798607],
                [23.79139, 58.800827],
                [23.59166, 58.788048],
                [23.483051000000103, 58.80999],
                [23.420273, 58.903877000000136],
                [23.416107, 58.910545],
                [23.41555000000011, 58.91888],
                [23.431107, 58.93943000000013],
                [23.445549000000142, 58.9405440000001],
                [23.477219, 58.937492],
                [23.507500000000107, 58.93721],
                [23.57694, 58.947212],
                [23.58833, 58.950546],
                [23.637775, 58.970543000000134],
                [23.635551, 58.978043],
                [23.62833000000012, 59.000549],
                [23.623329, 59.015549],
                [23.617218, 59.021378],
                [23.590553000000114, 59.035271],
                [23.57222, 59.044159],
                [23.56028, 59.047493],
                [23.56472, 59.040833],
                [23.570831, 59.035271],
                [23.60139, 59.022766000000104],
                [23.60944, 59.01777],
                [23.611942, 59.010277],
                [23.6055530000001, 59.004166],
                [23.55638, 58.98777],
                [23.514164000000108, 58.981102],
                [23.46638, 58.98416],
                [23.45249600000011, 58.986382],
                [23.436108, 58.997215],
                [23.413609, 59.012772],
                [23.407219, 59.0186],
                [23.42833, 59.051933],
                [23.43305, 59.059158],
                [23.44083000000012, 59.064438],
                [23.482494, 59.08943],
                [23.465549, 59.191376],
                [23.463051, 59.19887],
                [23.464161, 59.206383],
                [23.470551, 59.212494],
                [23.49972, 59.225266],
                [23.51083, 59.228325],
                [23.613609, 59.23972],
                [23.711384, 59.231102000000135],
                [23.727219, 59.22971],
                [23.738605, 59.232765],
                [23.74499500000013, 59.23916],
                [23.742493, 59.24638],
                [23.736382, 59.25222],
                [23.725552, 59.264717],
                [23.721382, 59.27137800000014],
                [23.729439, 59.276657000000114],
                [23.742218, 59.278603],
                [23.830830000000105, 59.289719],
                [23.85694100000012, 59.284164],
                [23.891106, 59.27332300000012],
                [23.905273, 59.27082800000011],
                [23.936108000000104, 59.272217000000126],
                [24.027222, 59.287773],
                [24.024166, 59.356102],
                [24.02, 59.36277],
                [24.019444, 59.371101],
                [24.022774, 59.379158],
                [24.029163, 59.38527],
                [24.03722, 59.390549],
                [24.050274000000115, 59.392769],
                [24.064999, 59.393883],
                [24.08111, 59.39222],
                [24.105274, 59.385551],
                [24.12361, 59.37666],
                [24.148052, 59.36166400000013],
                [24.176662, 59.348328],
                [24.186661, 59.344154],
                [24.19916, 59.342766],
                [24.21221500000013, 59.344994],
                [24.318886000000134, 59.425827],
                [24.325275, 59.431938000000116],
                [24.32444, 59.45694],
                [24.329163000000108, 59.464157000000114],
                [24.339165, 59.468323],
                [24.350552, 59.47137500000014],
                [24.363609, 59.473602],
                [24.394718, 59.47499],
                [24.41083, 59.473320000000115],
                [24.536663, 59.457214000000135],
                [24.72277, 59.452774],
                [24.791943, 59.51028],
                [24.779163, 59.520271],
                [24.776943, 59.527489],
                [24.771664, 59.557495],
                [24.776665, 59.564438],
                [24.79, 59.566666],
                [24.801941, 59.563324],
                [24.860554, 59.545547],
                [24.868607, 59.54055000000011],
                [24.887218, 59.523048],
                [24.909439, 59.507217],
                [24.927494, 59.506386],
                [25.05055, 59.51194],
                [25.100552, 59.5261],
                [25.10722, 59.532211],
                [25.121941, 59.533333],
                [25.15444200000013, 59.53166],
                [25.25833, 59.51416],
                [25.282776, 59.509163],
                [25.318886, 59.498878],
                [25.358887, 59.490547],
                [25.392494, 59.485825],
                [25.405926, 59.49064],
                [25.490829, 59.561104],
                [25.486938, 59.5686],
                [25.46944, 59.648331],
                [25.471107, 59.656654],
                [25.476383000000112, 59.66304800000012],
                [25.49277, 59.66415400000011],
                [25.591663, 59.60388],
                [25.59916, 59.59833],
                [25.609997, 59.585548],
                [25.631939000000102, 59.568886],
                [25.64277, 59.565269],
                [25.655552, 59.562767],
                [25.673885, 59.562767],
                [25.700829000000113, 59.56832900000012],
                [25.709995, 59.57277],
                [25.715271, 59.579437],
                [25.715271, 59.5886],
                [25.71333, 59.59665700000011],
                [25.707771, 59.60305],
                [25.693329, 59.61416],
                [25.687775, 59.62054],
                [25.66916, 59.653603],
                [25.67472, 59.659988],
                [25.6836, 59.664711],
                [25.694439, 59.668327],
                [25.70916, 59.66666],
                [25.719994, 59.662766],
                [25.7675, 59.640831],
                [25.77471900000012, 59.635551000000135],
                [25.780277, 59.628876000000105],
              ],
            ],
          ],
        },
        id: 0,
        NAME: 'Estonia',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Poland',
          id: 1,
          label: 'Poland',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.614,
          year: '2023',
          centroid: [19.1451, 51.9194],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [18.851246, 49.517357],
              [18.852219, 49.527771],
              [18.847775, 49.554161],
              [18.839443, 49.594994],
              [18.811665, 49.672218],
              [18.809998, 49.674438],
              [18.786942, 49.681938],
              [18.634163, 49.737778],
              [18.57935, 49.814995],
              [18.581108, 49.907494],
              [18.579441, 49.912498],
              [18.577221, 49.914444],
              [18.557777, 49.921661],
              [18.553608, 49.92305],
              [18.549721, 49.922493],
              [18.350277, 49.938889],
              [18.270275, 49.957771],
              [18.094166, 50.038055],
              [18.053162, 50.055931],
              [18.009441, 50.011108],
              [17.933052, 49.979721],
              [17.922497, 49.976944],
              [17.913609, 49.976387],
              [17.887775, 49.976662],
              [17.882774, 49.976944],
              [17.867222, 49.98111],
              [17.843887, 49.988327],
              [17.836388, 49.990829],
              [17.657776, 50.108055],
              [17.60722, 50.147774],
              [17.60083, 50.153885],
              [17.597775, 50.158333],
              [17.59861, 50.161659],
              [17.600555, 50.164162],
              [17.607498, 50.170555],
              [17.614719, 50.172493],
              [17.623333, 50.172775],
              [17.63361, 50.171944],
              [17.651943, 50.171944],
              [17.691666, 50.178055],
              [17.698887, 50.179993],
              [17.762497, 50.205551],
              [17.763885, 50.208611],
              [17.764164, 50.211662],
              [17.763054, 50.231941],
              [17.762775, 50.234718],
              [17.753052, 50.297775],
              [17.726109, 50.318329],
              [17.722775, 50.319717],
              [17.703888, 50.323326],
              [17.69611, 50.321938],
              [17.694164, 50.319443],
              [17.693886, 50.316383],
              [17.695, 50.307777],
              [17.694443, 50.298882],
              [17.692219, 50.296661],
              [17.665554, 50.274719],
              [17.656666, 50.269997],
              [17.63361, 50.265549],
              [17.619999, 50.265549],
              [17.433052, 50.270271],
              [17.37833, 50.279442],
              [17.283607, 50.320274],
              [17.226944, 50.345276],
              [17.208611, 50.358055],
              [17.201942, 50.363884],
              [17.118053, 50.39666],
              [17.057777, 50.410553],
              [16.941387, 50.434998],
              [16.910831, 50.440132],
              [16.898609, 50.440277],
              [16.890274, 50.439438],
              [16.887497, 50.437492],
              [16.869999, 50.415833],
              [16.868053, 50.413055],
              [16.867496, 50.410553],
              [16.869442, 50.405273],
              [16.937496, 50.340553],
              [16.972775, 50.309998],
              [17.00222, 50.216942],
              [16.968609, 50.222771],
              [16.913609, 50.222496],
              [16.909164, 50.222221],
              [16.849998, 50.203331],
              [16.843887, 50.200272],
              [16.815552, 50.183884],
              [16.806942, 50.174995],
              [16.802935, 50.169651],
              [16.786663, 50.140549],
              [16.725277, 50.099716],
              [16.71833, 50.097771],
              [16.713886, 50.097496],
              [16.703888, 50.098328],
              [16.641941, 50.10833],
              [16.638054, 50.109444],
              [16.614441, 50.11972],
              [16.587776, 50.139999],
              [16.567497, 50.160553],
              [16.56361, 50.164719],
              [16.566387, 50.178055],
              [16.565277, 50.202217],
              [16.559166, 50.214165],
              [16.549999, 50.224998],
              [16.546108, 50.229164],
              [16.458611, 50.303604],
              [16.441387, 50.316666],
              [16.371944, 50.361107],
              [16.303055, 50.378052],
              [16.266109, 50.389717],
              [16.220554, 50.409439],
              [16.217499, 50.41111],
              [16.20583, 50.423882],
              [16.203331, 50.428604],
              [16.202774, 50.431389],
              [16.203888, 50.437775],
              [16.209164, 50.445549],
              [16.213886, 50.449715],
              [16.310833, 50.504166],
              [16.319164, 50.505272],
              [16.338333, 50.499161],
              [16.346664, 50.496941],
              [16.351944, 50.496384],
              [16.361111, 50.496384],
              [16.368332, 50.498604],
              [16.406666, 50.523048],
              [16.448055, 50.572777],
              [16.449165, 50.575829],
              [16.447777, 50.581108],
              [16.444443, 50.585548],
              [16.431389, 50.600555],
              [16.429165, 50.602493],
              [16.369999, 50.644165],
              [16.341942, 50.66111],
              [16.334999, 50.663887],
              [16.325554, 50.66555],
              [16.237499, 50.670555],
              [16.137497, 50.656105],
              [16.118053, 50.657799],
              [16.071388, 50.635551],
              [16.024441, 50.629997],
              [15.946943, 50.689438],
              [15.787498, 50.744164],
              [15.606667, 50.772774],
              [15.488333, 50.786659],
              [15.37972, 50.779442],
              [15.36972, 50.831665],
              [15.364166, 50.841385],
              [15.361944, 50.84333],
              [15.355555, 50.846107],
              [15.328888, 50.854721],
              [15.310555, 50.85833],
              [15.30361, 50.864166],
              [15.283333, 50.890831],
              [15.282221, 50.893326],
              [15.274443, 50.91111],
              [15.270832, 50.921387],
              [15.271944, 50.931107],
              [15.272778, 50.934441],
              [15.276943, 50.938889],
              [15.294167, 50.948608],
              [15.295277, 50.954163],
              [15.275276, 50.974998],
              [15.239443, 50.991943],
              [15.176943, 51.014717],
              [15.010555, 50.984161],
              [15.013887, 50.979721],
              [15.020555, 50.967773],
              [15.020555, 50.964722],
              [15.019165, 50.950554],
              [15.006943, 50.869995],
              [15.005278, 50.867218],
              [15.001665, 50.866386],
              [14.966665, 50.859161],
              [14.828333, 50.865829],
              [14.824999, 50.876389],
              [14.824165, 50.881943],
              [14.827776, 50.88694],
              [14.896944, 50.959442],
              [14.93111, 51.002495],
              [14.964722, 51.050827],
              [14.966389, 51.053604],
              [14.978888, 51.078331],
              [14.994444, 51.118607],
              [15.032221, 51.239166],
              [15.038887, 51.27166],
              [15.036388, 51.285553],
              [15.029999, 51.294716],
              [15.009722, 51.312492],
              [14.995554, 51.321106],
              [14.986111, 51.328888],
              [14.980555, 51.338333],
              [14.971666, 51.355553],
              [14.971666, 51.358887],
              [14.981833, 51.36805],
              [14.975555, 51.440826],
              [14.955832, 51.467499],
              [14.954166, 51.469719],
              [14.951111, 51.471382],
              [14.92111, 51.481941],
              [14.8375, 51.498604],
              [14.742777, 51.524994],
              [14.736111, 51.528053],
              [14.714998, 51.554722],
              [14.754444, 51.596939],
              [14.759998, 51.604439],
              [14.761389, 51.611382],
              [14.76111, 51.617218],
              [14.7575, 51.659439],
              [14.756388, 51.667496],
              [14.755278, 51.669998],
              [14.728333, 51.687775],
              [14.715832, 51.69416],
              [14.698055, 51.702217],
              [14.678333, 51.714165],
              [14.666943, 51.724159],
              [14.663332, 51.728607],
              [14.604721, 51.808884],
              [14.599443, 51.818604],
              [14.599165, 51.821388],
              [14.600555, 51.831383],
              [14.603333, 51.84111],
              [14.605, 51.843887],
              [14.61611, 51.853882],
              [14.640276, 51.862221],
              [14.645277, 51.864998],
              [14.648054, 51.866943],
              [14.687222, 51.894997],
              [14.692499, 51.898888],
              [14.71656, 51.941132],
              [14.718542, 51.945091],
              [14.760765, 52.069862],
              [14.713333, 52.239166],
              [14.710554, 52.243889],
              [14.703888, 52.249718],
              [14.692497, 52.25444],
              [14.655832, 52.260277],
              [14.601665, 52.271111],
              [14.596109, 52.274437],
              [14.581665, 52.28611],
              [14.578054, 52.29055],
              [14.534443, 52.394722],
              [14.534443, 52.397774],
              [14.537222, 52.406944],
              [14.543888, 52.424721],
              [14.54611, 52.426941],
              [14.548611, 52.428886],
              [14.559166, 52.432495],
              [14.567221, 52.433884],
              [14.582499, 52.438049],
              [14.587776, 52.441666],
              [14.623333, 52.477219],
              [14.636389, 52.490555],
              [14.63722, 52.497215],
              [14.641388, 52.57],
              [14.640276, 52.572495],
              [14.638332, 52.574715],
              [14.604334, 52.601723],
              [14.587221, 52.611938],
              [14.561666, 52.624443],
              [14.547499, 52.629997],
              [14.527777, 52.636108],
              [14.518332, 52.637772],
              [14.505833, 52.641388],
              [14.481943, 52.650833],
              [14.475555, 52.65416],
              [14.448332, 52.675278],
              [14.383333, 52.730827],
              [14.361111, 52.744995],
              [14.348888, 52.751663],
              [14.214443, 52.816666],
              [14.196388, 52.820549],
              [14.149166, 52.862778],
              [14.145555, 52.953888],
              [14.146111, 52.957497],
              [14.149443, 52.962776],
              [14.168888, 52.973328],
              [14.200277, 52.984718],
              [14.221943, 52.987495],
              [14.228888, 52.990273],
              [14.287777, 53.016106],
              [14.299702, 53.021431],
              [14.342222, 53.044998],
              [14.352499, 53.052773],
              [14.378054, 53.103882],
              [14.3825, 53.116386],
              [14.391689, 53.144165],
              [14.412777, 53.304443],
              [14.413261, 53.338959],
              [14.309721, 53.55555],
              [14.275627, 53.699066],
              [14.36611, 53.69944],
              [14.403332, 53.683327],
              [14.41361, 53.678886],
              [14.422499, 53.676666],
              [14.525, 53.660553],
              [14.554722, 53.678604],
              [14.619444, 53.764442],
              [14.621111, 53.771385],
              [14.614166, 53.816383],
              [14.584999, 53.844719],
              [14.576666, 53.850273],
              [14.558332, 53.857216],
              [14.548611, 53.85833],
              [14.485277, 53.863884],
              [14.468054, 53.865273],
              [14.412222, 53.866661],
              [14.414721, 53.864716],
              [14.416388, 53.859444],
              [14.413055, 53.846107],
              [14.407499, 53.842499],
              [14.341665, 53.804718],
              [14.337221, 53.804993],
              [14.289999, 53.822777],
              [14.266109, 53.836662],
              [14.218887, 53.869019],
              [14.215832, 53.899994],
              [14.225555, 53.928604],
              [14.24, 53.923882],
              [14.259722, 53.92083],
              [14.327776, 53.912498],
              [14.350277, 53.910553],
              [14.36972, 53.911385],
              [14.383055, 53.913055],
              [14.416666, 53.919167],
              [14.434166, 53.925827],
              [14.483332, 53.94722],
              [14.497776, 53.956108],
              [14.510832, 53.962219],
              [14.559444, 53.976662],
              [14.745277, 54.02861],
              [14.814444, 54.039162],
              [14.979721, 54.071388],
              [15.228054, 54.12944],
              [15.294722, 54.146111],
              [15.310833, 54.149437],
              [15.353888, 54.156387],
              [15.395859, 54.160629],
              [15.429443, 54.162216],
              [15.486944, 54.16555],
              [15.5, 54.167496],
              [15.65, 54.193054],
              [15.658333, 54.194717],
              [15.744444, 54.212219],
              [15.760277, 54.21611],
              [15.794167, 54.226105],
              [15.833332, 54.239998],
              [15.845276, 54.242775],
              [15.876389, 54.246384],
              [16.047775, 54.261665],
              [16.129162, 54.283104],
              [16.130823, 54.280197],
              [16.110466, 54.267319],
              [16.071663, 54.2575],
              [16.074165, 54.255554],
              [16.087498, 54.25222],
              [16.09222, 54.251938],
              [16.141666, 54.252777],
              [16.146385, 54.253052],
              [16.174721, 54.259163],
              [16.217777, 54.273605],
              [16.217232, 54.28809],
              [16.21557, 54.296814],
              [16.209339, 54.300552],
              [16.175274, 54.29266],
              [16.141106, 54.287052],
              [16.173716, 54.297646],
              [16.198538, 54.30637],
              [16.25732, 54.341473],
              [16.230318, 54.322361],
              [16.230526, 54.319038],
              [16.234056, 54.318207],
              [16.239666, 54.318417],
              [16.255035, 54.318001],
              [16.261061, 54.31966],
              [16.262722, 54.326725],
              [16.267084, 54.329216],
              [16.328053, 54.344994],
              [16.332775, 54.349442],
              [16.333611, 54.352776],
              [16.330555, 54.363609],
              [16.326111, 54.373604],
              [16.323608, 54.375549],
              [16.318607, 54.376389],
              [16.306389, 54.373604],
              [16.299721, 54.370827],
              [16.294998, 54.368332],
              [16.318333, 54.391106],
              [16.408222, 54.461525],
              [16.460552, 54.499718],
              [16.489529, 54.518669],
              [16.515553, 54.534164],
              [16.54361, 54.544716],
              [16.571663, 54.551109],
              [16.638611, 54.563606],
              [16.665276, 54.56694],
              [16.694443, 54.568604],
              [16.709442, 54.568886],
              [16.793331, 54.575829],
              [16.884163, 54.589722],
              [16.915276, 54.597771],
              [16.930553, 54.602219],
              [16.94833, 54.608604],
              [17.013332, 54.643883],
              [17.024998, 54.651108],
              [17.032219, 54.657776],
              [17.040833, 54.66333],
              [17.060276, 54.671661],
              [17.071388, 54.675278],
              [17.247219, 54.729164],
              [17.254997, 54.731384],
              [17.362221, 54.747772],
              [17.434166, 54.752777],
              [17.530552, 54.762215],
              [17.584442, 54.768608],
              [17.601387, 54.771385],
              [17.686607, 54.789093],
              [17.774441, 54.806389],
              [17.896942, 54.823883],
              [17.918888, 54.82666],
              [18.033607, 54.833611],
              [18.053055, 54.834442],
              [18.32972, 54.836937],
              [18.334999, 54.836662],
              [18.349998, 54.833611],
              [18.372776, 54.816109],
              [18.449333, 54.788273],
              [18.526833, 54.760773],
              [18.578165, 54.744106],
              [18.605833, 54.735607],
              [18.703888, 54.700272],
              [18.739998, 54.685272],
              [18.774719, 54.666382],
              [18.82972, 54.629997],
              [18.831944, 54.627777],
              [18.834721, 54.623055],
              [18.836388, 54.61805],
              [18.836388, 54.611938],
              [18.830555, 54.599716],
              [18.826942, 54.594162],
              [18.82333, 54.592773],
              [18.818054, 54.593048],
              [18.815552, 54.594994],
              [18.78611, 54.618607],
              [18.775833, 54.629166],
              [18.76833, 54.638054],
              [18.760277, 54.649437],
              [18.750832, 54.662773],
              [18.738888, 54.672775],
              [18.722775, 54.683884],
              [18.708054, 54.692772],
              [18.704441, 54.694443],
              [18.571943, 54.72966],
              [18.503942, 54.753498],
              [18.487274, 54.759331],
              [18.484276, 54.759827],
              [18.481775, 54.759331],
              [18.480276, 54.757996],
              [18.466944, 54.736832],
              [18.405277, 54.74305],
              [18.406109, 54.734444],
              [18.407776, 54.732216],
              [18.46833, 54.665833],
              [18.511387, 54.631104],
              [18.54361, 54.59333],
              [18.550278, 54.584442],
              [18.553608, 54.57972],
              [18.566109, 54.553329],
              [18.567219, 54.54805],
              [18.572498, 54.486107],
              [18.570831, 54.479439],
              [18.567776, 54.47361],
              [18.568054, 54.467499],
              [18.571941, 54.451385],
              [18.576664, 54.441666],
              [18.582775, 54.435272],
              [18.590553, 54.429718],
              [18.596664, 54.426109],
              [18.610832, 54.419998],
              [18.708332, 54.382774],
              [18.757774, 54.370827],
              [18.836388, 54.353333],
              [18.851109, 54.350273],
              [18.884998, 54.346107],
              [18.901386, 54.344994],
              [18.92083, 54.345551],
              [18.933887, 54.347221],
              [18.953888, 54.351662],
              [18.968052, 54.345551],
              [18.973053, 54.344719],
              [19.022778, 54.342216],
              [19.046387, 54.342216],
              [19.138885, 54.346664],
              [19.212498, 54.353882],
              [19.374443, 54.373604],
              [19.4175, 54.380554],
              [19.43972, 54.385826],
              [19.50972, 54.404442],
              [19.523888, 54.409721],
              [19.562775, 54.428886],
              [19.613331, 54.45472],
              [19.627258, 54.463272],
              [19.651108, 54.455826],
              [19.632639, 54.444477],
              [19.628052, 54.441666],
              [19.524441, 54.39666],
              [19.428333, 54.365273],
              [19.408051, 54.358887],
              [19.38583, 54.353607],
              [19.366386, 54.351387],
              [19.286942, 54.347496],
              [19.26833, 54.344719],
              [19.234444, 54.336937],
              [19.227493, 54.33194],
              [19.226662, 54.32888],
              [19.250553, 54.278877],
              [19.256107, 54.277496],
              [19.371109, 54.2686],
              [19.471664, 54.311104],
              [19.485828, 54.317215],
              [19.560833, 54.346382],
              [19.567219, 54.347496],
              [19.574997, 54.347496],
              [19.581108, 54.346382],
              [19.623608, 54.348877],
              [19.633884, 54.352219],
              [19.713608, 54.383331],
              [19.797007, 54.43755],
              [19.857704, 54.429909],
              [20.004166, 54.419159],
              [20.090553, 54.418602],
              [20.158607, 54.411934],
              [20.301388, 54.397774],
              [20.329082, 54.393833],
              [20.331182, 54.393532],
              [20.371662, 54.387772],
              [20.432774, 54.38166],
              [20.738884, 54.358047],
              [20.898052, 54.356102],
              [21.126385, 54.34166],
              [21.181938, 54.33638],
              [21.231937, 54.332771],
              [21.283607, 54.329994],
              [21.367218, 54.327217],
              [21.411942, 54.325829],
              [21.442493, 54.325554],
              [21.524166, 54.326942],
              [21.570435, 54.328209],
              [21.577515, 54.328403],
              [21.625553, 54.32972],
              [21.729996, 54.330826],
              [21.732765, 54.330845],
              [21.855553, 54.331665],
              [21.981937, 54.332771],
              [22.164997, 54.334991],
              [22.265553, 54.338043],
              [22.292496, 54.339432],
              [22.294336, 54.339672],
              [22.305275, 54.341103],
              [22.425552, 54.345543],
              [22.43391, 54.345543],
              [22.455551, 54.345543],
              [22.629997, 54.348877],
              [22.664162, 54.351105],
              [22.7575, 54.35833],
              [22.775829, 54.361107],
              [22.785885, 54.363838],
              [22.810829, 54.39444],
              [22.81361, 54.397491],
              [22.826664, 54.40332],
              [22.843609, 54.406937],
              [22.856106, 54.4086],
              [22.870274, 54.408043],
              [22.987495, 54.38916],
              [22.992771, 54.387772],
              [23, 54.383049],
              [23.001991, 54.381054],
              [23.003052, 54.37999],
              [23.115829, 54.304436],
              [23.204441, 54.287216],
              [23.333054, 54.247215],
              [23.350273, 54.238884],
              [23.361942, 54.231934],
              [23.456383, 54.175552],
              [23.45916, 54.172768],
              [23.48444, 54.138329],
              [23.49416, 54.11721],
              [23.51722, 54.047218],
              [23.517776, 54.030273],
              [23.508053, 53.960548],
              [23.50404, 53.947044],
              [23.502777, 53.94249],
              [23.503887, 53.921379],
              [23.507807, 53.907265],
              [23.512218, 53.89138],
              [23.539719, 53.840828],
              [23.580551, 53.731102],
              [23.590443, 53.694431],
              [23.590553, 53.692764],
              [23.594997, 53.677773],
              [23.608608, 53.637497],
              [23.613884, 53.623047],
              [23.620552, 53.604996],
              [23.640274, 53.559158],
              [23.669441, 53.501389],
              [23.674717, 53.491104],
              [23.68055, 53.481102],
              [23.70055, 53.453049],
              [23.785917, 53.314335],
              [23.858608, 53.195824],
              [23.933052, 53.01416],
              [23.933331, 53.009995],
              [23.927492, 52.948376],
              [23.931385, 52.858604],
              [23.93866, 52.774712],
              [23.939716, 52.770271],
              [23.941105, 52.749718],
              [23.94083, 52.732208],
              [23.937775, 52.719437],
              [23.933884, 52.712212],
              [23.928608, 52.7061],
              [23.91555, 52.695541],
              [23.908051, 52.690826],
              [23.883884, 52.678047],
              [23.753887, 52.615829],
              [23.74305, 52.613609],
              [23.736382, 52.613327],
              [23.721375, 52.615242],
              [23.710274, 52.616661],
              [23.688328, 52.61721],
              [23.655273, 52.610275],
              [23.633606, 52.605553],
              [23.597218, 52.596382],
              [23.523052, 52.573608],
              [23.503609, 52.567497],
              [23.417217, 52.525269],
              [23.397217, 52.514442],
              [23.377495, 52.498329],
              [23.249376, 52.375477],
              [23.24416, 52.37027],
              [23.1654, 52.282276],
              [23.191383, 52.234718],
              [23.19416, 52.231659],
              [23.206383, 52.225266],
              [23.223049, 52.221657],
              [23.297775, 52.211662],
              [23.340832, 52.208046],
              [23.353329, 52.206383],
              [23.35833, 52.204712],
              [23.594997, 52.111938],
              [23.638607, 52.079437],
              [23.660828, 52.006104],
              [23.627773, 51.95388],
              [23.625828, 51.950272],
              [23.613228, 51.917938],
              [23.611736, 51.913971],
              [23.558052, 51.752495],
              [23.547775, 51.686378],
              [23.556664, 51.670547],
              [23.556942, 51.666382],
              [23.555832, 51.663322],
              [23.552498, 51.660545],
              [23.534992, 51.653595],
              [23.539165, 51.592766],
              [23.559441, 51.546104],
              [23.561386, 51.542496],
              [23.563885, 51.539436],
              [23.571663, 51.535271],
              [23.578541, 51.532978],
              [23.581665, 51.531937],
              [23.604633, 51.527695],
              [23.611107, 51.503326],
              [23.614, 51.49675],
              [23.616665, 51.493607],
              [23.623608, 51.488602],
              [23.624754, 51.48822],
              [23.628609, 51.486938],
              [23.641417, 51.486938],
              [23.642494, 51.486938],
              [23.654163, 51.484718],
              [23.656887, 51.480968],
              [23.658607, 51.4786],
              [23.69305, 51.404709],
              [23.692493, 51.399994],
              [23.682217, 51.371101],
              [23.680275, 51.367493],
              [23.683884, 51.288605],
              [23.731937, 51.214714],
              [23.756664, 51.199432],
              [23.811108, 51.168884],
              [23.904442, 51.069443],
              [23.905552, 51.066666],
              [23.931665, 50.994072],
              [23.963882, 50.951935],
              [23.966385, 50.948875],
              [23.988327, 50.931107],
              [24.028885, 50.901657],
              [24.035553, 50.896942],
              [24.043888, 50.892769],
              [24.058609, 50.888046],
              [24.064384, 50.887001],
              [24.087776, 50.882767],
              [24.092773, 50.881104],
              [24.14222, 50.861107],
              [24.144718, 50.858047],
              [24.14444, 50.849434],
              [24.134441, 50.836937],
              [24.13055, 50.834991],
              [24.114719, 50.831383],
              [24.076942, 50.829437],
              [24.052498, 50.831383],
              [24.023678, 50.831783],
              [24.020113, 50.831722],
              [23.989162, 50.831108],
              [23.972771, 50.828049],
              [23.964439, 50.82444],
              [23.958885, 50.818604],
              [23.95694, 50.814995],
              [23.953327, 50.802773],
              [23.953115, 50.800724],
              [23.952496, 50.794716],
              [23.954716, 50.787216],
              [23.957218, 50.784164],
              [24.014721, 50.73999],
              [24.07222, 50.695824],
              [24.10722, 50.633606],
              [24.108414, 50.6259],
              [24.111385, 50.56694],
              [24.004997, 50.417213],
              [23.999439, 50.411659],
              [23.991661, 50.407211],
              [23.974716, 50.404709],
              [23.92944, 50.403603],
              [23.881496, 50.405411],
              [23.846943, 50.406654],
              [23.814442, 50.405823],
              [23.791943, 50.402489],
              [23.755833, 50.39444],
              [23.729225, 50.387413],
              [23.721107, 50.385269],
              [23.712259, 50.382137],
              [23.707771, 50.380547],
              [23.703884, 50.378326],
              [23.697495, 50.373047],
              [23.693886, 50.365829],
              [23.693182, 50.363255],
              [23.686253, 50.337929],
              [23.684994, 50.333328],
              [23.683416, 50.330395],
              [23.676941, 50.32444],
              [23.591106, 50.269157],
              [23.568886, 50.255829],
              [23.540276, 50.242779],
              [23.496105, 50.220825],
              [23.37833, 50.149719],
              [23.342823, 50.127491],
              [23.341942, 50.126938],
              [23.32444, 50.115273],
              [23.303608, 50.10083],
              [23.232773, 50.049995],
              [23.223606, 50.043327],
              [23.146107, 49.983047],
              [23.110828, 49.954994],
              [22.779999, 49.674995],
              [22.717216, 49.604439],
              [22.686068, 49.577095],
              [22.680828, 49.572495],
              [22.676105, 49.566383],
              [22.658051, 49.535828],
              [22.655273, 49.528046],
              [22.656105, 49.519714],
              [22.694439, 49.450829],
              [22.729439, 49.401657],
              [22.73041, 49.400532],
              [22.736382, 49.393608],
              [22.738327, 49.390274],
              [22.739437, 49.386658],
              [22.760277, 49.295273],
              [22.759998, 49.281937],
              [22.754719, 49.271103],
              [22.726662, 49.217766],
              [22.704994, 49.18055],
              [22.700829, 49.173607],
              [22.699997, 49.169716],
              [22.700272, 49.165543],
              [22.703606, 49.163048],
              [22.706659, 49.163048],
              [22.70916, 49.163048],
              [22.778053, 49.150543],
              [22.852776, 49.105827],
              [22.876106, 49.089989],
              [22.877773, 49.086655],
              [22.876106, 49.083054],
              [22.863052, 49.058884],
              [22.861956, 49.05011],
              [22.861385, 49.045547],
              [22.864162, 49.038605],
              [22.868328, 49.028877],
              [22.886074, 49.002914],
              [22.875275, 49.00222],
              [22.868885, 49.001938],
              [22.856384, 49.003326],
              [22.851662, 49.004715],
              [22.737774, 49.047218],
              [22.598053, 49.091103],
              [22.594929, 49.09145],
              [22.585552, 49.092491],
              [22.574165, 49.090828],
              [22.562775, 49.084991],
              [22.558052, 49.079437],
              [22.5425, 49.086388],
              [22.533054, 49.089439],
              [22.354721, 49.137497],
              [22.343052, 49.139442],
              [22.323887, 49.138611],
              [22.224998, 49.154716],
              [22.047497, 49.207771],
              [22.037777, 49.210831],
              [22.030277, 49.214996],
              [22.025833, 49.221107],
              [22.024719, 49.224716],
              [22.024166, 49.228882],
              [22.025276, 49.247215],
              [22.021385, 49.270271],
              [22.018887, 49.277496],
              [21.960278, 49.339165],
              [21.956944, 49.341385],
              [21.838055, 49.384438],
              [21.618889, 49.436386],
              [21.606388, 49.436661],
              [21.533607, 49.429718],
              [21.500832, 49.422218],
              [21.470833, 49.412773],
              [21.465832, 49.411385],
              [21.459442, 49.41111],
              [21.441109, 49.412498],
              [21.436386, 49.413887],
              [21.400845, 49.429054],
              [21.285, 49.456108],
              [21.278889, 49.456665],
              [21.076111, 49.423607],
              [21.066944, 49.420555],
              [21.051666, 49.412216],
              [21.049442, 49.408882],
              [21.035553, 49.359718],
              [20.984165, 49.310555],
              [20.980553, 49.308327],
              [20.95583, 49.301666],
              [20.916386, 49.296104],
              [20.910831, 49.296104],
              [20.812496, 49.330826],
              [20.740833, 49.388885],
              [20.602776, 49.395554],
              [20.360554, 49.393051],
              [20.327774, 49.383331],
              [20.206665, 49.340271],
              [20.143608, 49.314995],
              [20.103333, 49.248604],
              [20.093609, 49.213608],
              [20.091663, 49.196106],
              [20.089443, 49.183884],
              [20.084999, 49.177498],
              [20.081387, 49.175278],
              [20.074444, 49.175278],
              [20.064163, 49.177773],
              [20.039165, 49.188889],
              [20.020554, 49.19944],
              [20.002514, 49.213585],
              [19.995277, 49.221664],
              [19.984444, 49.225555],
              [19.97472, 49.227219],
              [19.936386, 49.23111],
              [19.916386, 49.228882],
              [19.913055, 49.227493],
              [19.907776, 49.224159],
              [19.86791, 49.197132],
              [19.846664, 49.19194],
              [19.839165, 49.191666],
              [19.794441, 49.196388],
              [19.789444, 49.196938],
              [19.778889, 49.201111],
              [19.771111, 49.206383],
              [19.766109, 49.213051],
              [19.765831, 49.215828],
              [19.773609, 49.233055],
              [19.798054, 49.252777],
              [19.821388, 49.271111],
              [19.824165, 49.272774],
              [19.826111, 49.275276],
              [19.826942, 49.278053],
              [19.826664, 49.28083],
              [19.804996, 49.364716],
              [19.791664, 49.404442],
              [19.790276, 49.406662],
              [19.786388, 49.408051],
              [19.781387, 49.408607],
              [19.768608, 49.408051],
              [19.710552, 49.397499],
              [19.658607, 49.406662],
              [19.579166, 49.45694],
              [19.574997, 49.461105],
              [19.535275, 49.535553],
              [19.520981, 49.574165],
              [19.475555, 49.599998],
              [19.447777, 49.60083],
              [19.276386, 49.530548],
              [19.270275, 49.527771],
              [19.264721, 49.524162],
              [19.244442, 49.509163],
              [19.240276, 49.50444],
              [19.203331, 49.444717],
              [19.195274, 49.430832],
              [19.198055, 49.418053],
              [19.185276, 49.409996],
              [19.163609, 49.400551],
              [19.155552, 49.399994],
              [19.031666, 49.391937],
              [18.993332, 49.39444],
              [18.978054, 49.39666],
              [18.973053, 49.400551],
              [18.971664, 49.402771],
              [18.970833, 49.405273],
              [18.96833, 49.456383],
              [18.968609, 49.481667],
              [18.851246, 49.517357],
            ],
          ],
        },
        id: 1,
        NAME: 'Poland',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Cyprus',
          id: 2,
          label: 'Cyprus',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.585,
          year: '2023',
          centroid: [33.4299, 35.1264],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [33.652618, 35.354103],
              [33.713051, 35.381943],
              [33.749161, 35.397217],
              [33.756943, 35.399719],
              [33.774994, 35.402222],
              [33.80722, 35.400276],
              [33.853607, 35.403053],
              [33.871109, 35.406387],
              [33.969719, 35.436104],
              [34.292221, 35.566666],
              [34.314163, 35.575554],
              [34.336662, 35.589439],
              [34.342499, 35.599159],
              [34.349998, 35.606941],
              [34.360275, 35.611938],
              [34.389442, 35.623886],
              [34.549438, 35.680832],
              [34.556938, 35.683327],
              [34.581665, 35.688606],
              [34.590271, 35.690277],
              [34.590553, 35.686943],
              [34.569717, 35.643608],
              [34.386665, 35.535271],
              [34.28083, 35.476944],
              [34.259438, 35.467499],
              [34.225273, 35.455551],
              [34.119995, 35.400833],
              [33.958054, 35.312775],
              [33.948326, 35.30722],
              [33.940552, 35.299438],
              [33.921387, 35.272774],
              [33.910553, 35.253052],
              [33.90583, 35.242218],
              [33.901939, 35.215828],
              [33.900276, 35.198051],
              [33.901665, 35.164444],
              [33.902496, 35.161659],
              [33.973885, 35.088051],
              [34.030548, 35.046387],
              [34.035553, 35.041382],
              [34.054443, 35.020554],
              [34.067215, 35.003883],
              [34.077217, 34.989998],
              [34.079163, 34.986938],
              [34.087219, 34.963882],
              [34.083328, 34.959442],
              [34.067215, 34.960274],
              [34.062775, 34.961662],
              [34.034721, 34.971939],
              [34.026108, 34.978607],
              [34.02166, 34.979996],
              [33.976944, 34.981384],
              [33.955826, 34.97805],
              [33.929443, 34.97361],
              [33.91333, 34.969444],
              [33.903053, 34.964165],
              [33.899162, 34.959717],
              [33.896385, 34.955551],
              [33.885277, 34.946106],
              [33.882217, 34.94416],
              [33.86805, 34.937775],
              [33.864166, 34.936661],
              [33.858887, 34.936661],
              [33.848328, 34.942497],
              [33.834717, 34.954163],
              [33.830276, 34.959442],
              [33.814438, 34.965828],
              [33.790276, 34.970276],
              [33.763054, 34.972771],
              [33.709999, 34.974159],
              [33.705276, 34.97361],
              [33.685272, 34.968048],
              [33.677498, 34.965553],
              [33.667496, 34.960274],
              [33.661942, 34.955551],
              [33.649719, 34.942215],
              [33.646111, 34.935555],
              [33.640549, 34.92083],
              [33.638611, 34.912773],
              [33.636108, 34.899994],
              [33.632774, 34.873886],
              [33.637772, 34.864998],
              [33.638054, 34.860832],
              [33.636108, 34.857773],
              [33.606667, 34.820274],
              [33.599998, 34.816666],
              [33.516388, 34.783607],
              [33.372772, 34.727776],
              [33.365273, 34.725273],
              [33.326385, 34.71611],
              [33.317215, 34.714722],
              [33.272293, 34.709549],
              [33.217216, 34.69944],
              [33.153053, 34.702499],
              [33.133606, 34.70166],
              [33.116943, 34.698608],
              [33.104996, 34.695274],
              [33.066666, 34.68222],
              [33.059715, 34.679161],
              [33.029999, 34.657776],
              [33.007023, 34.632397],
              [33.007023, 34.595886],
              [33.030838, 34.56255],
              [32.981625, 34.572071],
              [32.941936, 34.56255],
              [32.941936, 34.594299],
              [32.918125, 34.629223],
              [32.899075, 34.651447],
              [32.859444, 34.666107],
              [32.831108, 34.667496],
              [32.769165, 34.656944],
              [32.761108, 34.654716],
              [32.751663, 34.648888],
              [32.744438, 34.645828],
              [32.739998, 34.644997],
              [32.713882, 34.640274],
              [32.698326, 34.64222],
              [32.654716, 34.65361],
              [32.641663, 34.657219],
              [32.491943, 34.702217],
              [32.471107, 34.713051],
              [32.407494, 34.748886],
              [32.40416, 34.750832],
              [32.342773, 34.859993],
              [32.339996, 34.866661],
              [32.323326, 34.909439],
              [32.276382, 35.036942],
              [32.274162, 35.043884],
              [32.270271, 35.062492],
              [32.269165, 35.07444],
              [32.270554, 35.083328],
              [32.275276, 35.093605],
              [32.281944, 35.097221],
              [32.291939, 35.096664],
              [32.298332, 35.092499],
              [32.304718, 35.08416],
              [32.312492, 35.076942],
              [32.32666, 35.065552],
              [32.341385, 35.054443],
              [32.354164, 35.046387],
              [32.369164, 35.039719],
              [32.373604, 35.038605],
              [32.378609, 35.037773],
              [32.397774, 35.039444],
              [32.419998, 35.043053],
              [32.428055, 35.045273],
              [32.438606, 35.050278],
              [32.460274, 35.064438],
              [32.491661, 35.094162],
              [32.496109, 35.099716],
              [32.501938, 35.109161],
              [32.515831, 35.135826],
              [32.522217, 35.14444],
              [32.549164, 35.173607],
              [32.553604, 35.173332],
              [32.565552, 35.168884],
              [32.622215, 35.184166],
              [32.651382, 35.189163],
              [32.660553, 35.190277],
              [32.721939, 35.180832],
              [32.769722, 35.163887],
              [32.808609, 35.148331],
              [32.820549, 35.143883],
              [32.830551, 35.14222],
              [32.839722, 35.143608],
              [32.85833, 35.150551],
              [32.882774, 35.162216],
              [32.895828, 35.169716],
              [32.901939, 35.174164],
              [32.906944, 35.179443],
              [32.912773, 35.188606],
              [32.916939, 35.199997],
              [32.932098, 35.263626],
              [32.939163, 35.327499],
              [32.922886, 35.35828],
              [32.921299, 35.393208],
              [32.938763, 35.394001],
              [33.002777, 35.365555],
              [33.271942, 35.339722],
              [33.354439, 35.330276],
              [33.369438, 35.328606],
              [33.385277, 35.328331],
              [33.427498, 35.328049],
              [33.468048, 35.328049],
              [33.477219, 35.329163],
              [33.63166, 35.350273],
              [33.652618, 35.354103],
            ],
          ],
        },
        id: 2,
        NAME: 'Cyprus',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Czechia',
          id: 3,
          label: 'Czechia',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.44,
          year: '2023',
          centroid: [15.4729, 49.8175],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [16.960288120194576, 48.5969823268506],
                [16.499282667718774, 48.78580801044511],
                [16.02964725105022, 48.73389903420793],
                [15.253415561593982, 49.03907420510758],
                [14.901447381254057, 48.964401760445824],
                [14.338897739324722, 48.55530528420721],
                [13.595945672264577, 48.87717194273715],
                [13.031328973043514, 49.30706818297324],
                [12.521024204161193, 49.547415269562734],
                [12.415190870827445, 49.96912079528057],
                [12.240111118222671, 50.266337795607285],
                [12.966836785543194, 50.484076443069085],
                [13.338131951560285, 50.73323436136435],
                [14.056227654688172, 50.9269176295943],
                [14.307013380600637, 51.11726776794137],
                [14.570718214586066, 51.002339382524276],
                [15.01699588385867, 51.10667409932158],
                [15.490972120839729, 50.78472992614321],
                [16.23862674323857, 50.69773265237984],
                [16.176253289462267, 50.42260732685791],
                [16.719475945714436, 50.21574656839354],
                [16.86876915860566, 50.47397370055603],
                [17.55456709155112, 50.36214590107642],
                [17.64944502123899, 50.049038397819956],
                [18.392913852622172, 49.98862864847075],
                [18.853144158613617, 49.49622976337764],
                [18.554971144289482, 49.49501536721878],
                [18.399993523846177, 49.31500051533004],
                [18.170498488037964, 49.271514797556435],
                [18.104972771891852, 49.04398346617531],
                [17.913511590250465, 48.996492824899086],
                [17.88648481616181, 48.90347524677371],
                [17.545006951577108, 48.80001902932537],
                [17.101984897538898, 48.816968899117114],
                [16.960288120194576, 48.5969823268506],
              ],
            ],
          ],
        },
        id: 3,
        NAME: 'Czechia',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Malta',
          id: 4,
          label: 'Malta',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.342,
          year: '2023',
          centroid: [14.3754, 35.9375],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [14.562222, 35.820274],
                [14.519722000000115, 35.799995],
                [14.42389, 35.818604],
                [14.379721, 35.844444],
                [14.374998, 35.8475],
                [14.366943, 35.854721],
                [14.347221, 35.872498],
                [14.339443, 35.879715],
                [14.336388, 35.88388800000013],
                [14.333055000000115, 35.894997],
                [14.324999, 35.972771],
                [14.326387000000125, 35.97888],
                [14.332499, 35.981110000000115],
                [14.361666, 35.99139],
                [14.368332, 35.992493],
                [14.374998, 35.990829],
                [14.44333300000011, 35.960274],
                [14.510277, 35.92528],
                [14.54833200000013, 35.89222000000012],
                [14.563889, 35.877777],
                [14.57, 35.869438],
                [14.568054, 35.829437],
                [14.565832, 35.82416500000011],
                [14.562222, 35.820274],
              ],
            ],
            [
              [
                [14.2675, 36.011383],
                [14.251389000000131, 36.011383],
                [14.237221, 36.012772],
                [14.196943, 36.021942],
                [14.19111, 36.02444],
                [14.185833, 36.033333],
                [14.180832, 36.05527500000011],
                [14.181110000000103, 36.060829000000126],
                [14.190832, 36.066383],
                [14.208887000000118, 36.071663],
                [14.229166, 36.074997],
                [14.245832, 36.074165],
                [14.253332000000114, 36.073051],
                [14.314999, 36.053329],
                [14.320555, 36.051109],
                [14.34111, 36.033882],
                [14.34083, 36.02971600000012],
                [14.335833, 36.027222],
                [14.275, 36.01166500000011],
                [14.2675, 36.011383],
              ],
            ],
          ],
        },
        id: 4,
        NAME: 'Malta',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Germany',
          id: 5,
          label: 'Germany',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.329,
          year: '2023',
          centroid: [10.4515, 51.1657],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [8.710255, 47.69681],
                [8.678595, 47.693344],
                [8.67555, 47.697495],
                [8.6733, 47.70177100000012],
                [8.670277, 47.7075],
                [8.670555, 47.711105],
                [8.675278, 47.712494],
                [8.698889, 47.713608],
                [8.705, 47.71305100000012],
                [8.708332, 47.710548],
                [8.709721, 47.70694],
                [8.710255, 47.69681],
              ],
            ],
            [
              [
                [6.806389, 53.602219],
                [6.80472200000014, 53.60055],
                [6.799444, 53.601105],
                [6.796666, 53.602219],
                [6.775277000000131, 53.602219],
                [6.753055, 53.598328],
                [6.749166000000116, 53.597221],
                [6.72555, 53.58694],
                [6.723055, 53.584999],
                [6.72694, 53.580551],
                [6.746944, 53.56027200000011],
                [6.690555, 53.567497],
                [6.673333, 53.571388],
                [6.663888, 53.57583],
                [6.66, 53.580276],
                [6.658333000000141, 53.586105],
                [6.658610000000124, 53.593048],
                [6.661111000000119, 53.59861],
                [6.663055, 53.60083],
                [6.669444, 53.60388200000011],
                [6.747499, 53.618607],
                [6.75861, 53.618889],
                [6.77222, 53.616661000000136],
                [6.80417, 53.604439],
                [6.806389, 53.602219],
              ],
            ],
            [
              [
                [6.939444, 53.669441],
                [6.893611, 53.666382],
                [6.88278, 53.66693900000013],
                [6.878611, 53.6680530000001],
                [6.876389, 53.67027300000012],
                [6.878333, 53.672493],
                [6.881389, 53.674164],
                [6.898889000000111, 53.6775],
                [6.94361, 53.681107],
                [7.063611, 53.687218],
                [7.081111, 53.686943],
                [7.085555, 53.686104],
                [7.088333, 53.68416600000012],
                [7.088333, 53.681664],
                [7.08417, 53.679993],
                [6.939444, 53.669441],
              ],
            ],
            [
              [
                [7.242499000000123, 53.70444],
                [7.15861, 53.69888300000014],
                [7.148333, 53.699715],
                [7.14083, 53.70221700000013],
                [7.135833, 53.706108],
                [7.137221, 53.70888500000012],
                [7.14028, 53.710548],
                [7.175278, 53.720276],
                [7.201111, 53.72527],
                [7.298611, 53.726944],
                [7.32694, 53.72666],
                [7.336944, 53.725555],
                [7.340833, 53.724442000000124],
                [7.346944000000121, 53.721107],
                [7.345833, 53.71833],
                [7.327499000000103, 53.714722],
                [7.262777000000142, 53.705826000000116],
                [7.242499000000123, 53.70444],
              ],
            ],
            [
              [
                [8.19111, 53.724716],
                [8.124166000000116, 53.70888500000012],
                [8.12083200000012, 53.710274],
                [8.11999900000012, 53.713051],
                [8.124722, 53.72361],
                [8.129166, 53.72805],
                [8.13528, 53.731384],
                [8.14277600000014, 53.733604],
                [8.156387000000109, 53.73555],
                [8.17305, 53.734718],
                [8.18166, 53.732773],
                [8.188332, 53.72999600000014],
                [8.19333300000011, 53.726105],
                [8.19111, 53.724716],
              ],
            ],
            [
              [
                [7.622222, 53.7544400000001],
                [7.628611, 53.744438000000116],
                [7.628888, 53.742218],
                [7.621666000000118, 53.744438000000116],
                [7.60778, 53.746666],
                [7.586944, 53.748604],
                [7.575277, 53.748886],
                [7.51833, 53.74582700000013],
                [7.514166000000102, 53.744995],
                [7.51111, 53.743332],
                [7.478055, 53.722221],
                [7.473611000000119, 53.723053],
                [7.469166, 53.727219],
                [7.467777, 53.733055],
                [7.468611000000124, 53.73999800000013],
                [7.472221, 53.748604],
                [7.47889, 53.754997],
                [7.485833, 53.7575],
                [7.51583, 53.759995],
                [7.575555000000122, 53.761108],
                [7.609722, 53.760826],
                [7.615000000000123, 53.760277],
                [7.618333, 53.758888],
                [7.622222, 53.7544400000001],
              ],
            ],
            [
              [
                [7.75889, 53.76055],
                [7.669722, 53.754715],
                [7.66472, 53.75861],
                [7.664444, 53.76166],
                [7.665833, 53.764442],
                [7.669444, 53.769165],
                [7.674444, 53.77304800000013],
                [7.683888000000138, 53.77777100000014],
                [7.69861, 53.77916],
                [7.80472200000014, 53.77777100000014],
                [7.809999000000118, 53.777222],
                [7.812778, 53.77555100000012],
                [7.810833, 53.77304800000013],
                [7.807221000000141, 53.77194200000014],
                [7.75889, 53.76055],
              ],
            ],
            [
              [
                [8.425278000000105, 53.928055],
                [8.422222, 53.92638],
                [8.413055, 53.928055],
                [8.40694, 53.947777],
                [8.407776, 53.950829],
                [8.41166, 53.955551],
                [8.42277700000011, 53.96277600000013],
                [8.43111, 53.964722],
                [8.441111, 53.965553],
                [8.455, 53.96305100000012],
                [8.457222000000115, 53.96083],
                [8.425278000000105, 53.928055],
              ],
            ],
            [
              [
                [11.45917, 53.961105],
                [11.451387, 53.95916],
                [11.428888000000143, 53.961388],
                [11.42361, 53.96194],
                [11.3925, 53.968048],
                [11.388611, 53.969162],
                [11.377499, 53.974716],
                [11.37555, 53.976944],
                [11.373333, 53.98221600000011],
                [11.373888, 53.988609],
                [11.374998, 53.99166],
                [11.378611, 53.996666],
                [11.38444, 54.000275],
                [11.401667, 54.006943],
                [11.44444, 54.022217],
                [11.452776, 54.02389],
                [11.4625, 54.024719],
                [11.47305, 54.024719],
                [11.488609, 54.023048],
                [11.491665, 54.021385],
                [11.49528, 54.01666300000011],
                [11.49416, 54.00999500000012],
                [11.480276000000117, 53.984161],
                [11.4772210000001, 53.97888200000011],
                [11.469721, 53.968887],
                [11.467777000000126, 53.96666],
                [11.45917, 53.961105],
              ],
            ],
            [
              [
                [13.94028, 54.024994],
                [13.930832, 54.016388],
                [13.92583, 54.018326],
                [13.927221, 54.021385],
                [13.93444, 54.027771],
                [13.938889, 54.027496],
                [13.94028, 54.024994],
              ],
            ],
            [
              [
                [8.695555, 54.041107],
                [8.691944, 54.039993],
                [8.681665, 54.040833],
                [8.676666000000125, 54.044716],
                [8.673054, 54.04943800000012],
                [8.666111, 54.06388900000013],
                [8.6675, 54.073326],
                [8.66889, 54.075829],
                [8.67139, 54.077774],
                [8.67805, 54.08083],
                [8.690554000000134, 54.083611],
                [8.693333, 54.082497],
                [8.699999, 54.058609],
                [8.697498, 54.04361],
                [8.695555, 54.041107],
              ],
            ],
            [
              [
                [11.544167, 54.061386],
                [11.51111, 54.04860700000012],
                [11.51111, 54.051666],
                [11.514721000000122, 54.060555000000136],
                [11.528889, 54.076942000000145],
                [11.535831, 54.082497],
                [11.555832, 54.094719],
                [11.55944, 54.09583],
                [11.61242, 54.10458],
                [11.568054, 54.074715],
                [11.544167, 54.061386],
              ],
            ],
            [
              [
                [14.001317, 54.065361],
                [14.105, 53.998604],
                [14.181110000000103, 53.94805],
                [14.186943, 53.944717],
                [14.214167, 53.932495],
                [14.225555, 53.92860400000012],
                [14.21583, 53.899994000000106],
                [14.218887000000109, 53.869019],
                [14.195833, 53.874718],
                [14.19111, 53.87527],
                [14.0825, 53.873329],
                [14.045277, 53.872215],
                [14.037777, 53.869995],
                [14.029165, 53.8647160000001],
                [14.00805, 53.853882],
                [13.992498000000126, 53.84972],
                [13.949165000000107, 53.843605],
                [13.893055, 53.839439],
                [13.877499000000114, 53.84083],
                [13.82694, 53.850822],
                [13.823431, 53.853745],
                [13.825, 53.85833],
                [13.833332, 53.867493],
                [13.835554, 53.86972],
                [13.838888, 53.871384],
                [13.871944, 53.878052],
                [13.92916, 53.897499],
                [13.939631000000134, 53.91486400000014],
                [13.95757, 53.941113],
                [13.98207, 53.96255100000013],
                [14.012691, 53.94942],
                [14.03063, 53.9428630000001],
                [14.048565, 53.942425],
                [14.056003, 53.984863],
                [14.04769, 54.00542400000012],
                [14.014, 54.01417500000014],
                [14.00832, 54.026424],
                [13.998255, 54.039986],
                [13.97988, 54.05661],
                [13.954068, 54.060547],
                [13.929569, 54.063171],
                [13.918633, 54.054859000000135],
                [13.92607, 54.03648],
                [13.91222, 54.026665],
                [13.902777000000128, 54.01416000000012],
                [13.89805, 54.00972],
                [13.86055, 53.998604],
                [13.857498, 54.000275],
                [13.82278, 54.036659],
                [13.80868, 54.071613],
                [13.81743, 54.09785],
                [13.804192, 54.111092],
                [13.759998, 54.139717],
                [13.75861, 54.14222],
                [13.75611, 54.15027600000013],
                [13.757500000000107, 54.15721900000011],
                [13.759165, 54.159996],
                [13.763887000000125, 54.164444],
                [13.769722, 54.16777],
                [13.781111, 54.171104],
                [13.800554, 54.17139],
                [13.813055, 54.16861],
                [13.81805, 54.164719],
                [13.81944, 54.162216],
                [13.823055, 54.15471600000012],
                [13.825554, 54.143326],
                [13.828054000000122, 54.138329],
                [13.831665, 54.133888],
                [13.86611, 54.106667],
                [13.89238, 54.09029800000013],
                [13.921257, 54.081985],
                [13.93832, 54.077171],
                [13.96544, 54.073235],
                [14.001317, 54.065361],
              ],
            ],
            [
              [
                [10.979443, 54.380554],
                [10.994999, 54.381943],
                [11.017776, 54.380272],
                [11.016943, 54.378609],
                [11.013332, 54.377495],
                [11.003054000000134, 54.376938],
                [10.986111, 54.37805200000014],
                [10.979443, 54.380554],
              ],
            ],
            [
              [
                [12.729721, 54.41666],
                [12.68861, 54.41555],
                [12.68611, 54.418327],
                [12.696943, 54.424995],
                [12.70278, 54.428329],
                [12.706944, 54.427773],
                [12.727221, 54.42305],
                [12.731943000000115, 54.41888],
                [12.729721, 54.41666],
              ],
            ],
            [
              [
                [8.893055, 54.461937],
                [8.8375, 54.461662],
                [8.826944, 54.462776],
                [8.819443, 54.465271],
                [8.814722, 54.469162],
                [8.814165, 54.472496],
                [8.814165, 54.49777],
                [8.814999, 54.500832],
                [8.816944, 54.503052],
                [8.86222, 54.524162],
                [8.865833, 54.52527600000013],
                [8.921389, 54.524994],
                [8.942499, 54.523048],
                [8.960554, 54.519165],
                [8.954721, 54.509163000000115],
                [8.924999, 54.474159],
                [8.917776000000117, 54.467773000000136],
                [8.91472, 54.46611],
                [8.906944, 54.463882],
                [8.893055, 54.461937],
              ],
            ],
            [
              [
                [11.31278, 54.406944],
                [11.13917, 54.40666],
                [11.123888000000136, 54.406944],
                [11.021049000000119, 54.438759],
                [11.009998, 54.4461060000001],
                [11.008055, 54.448326],
                [11.005833, 54.45361],
                [11.006388000000129, 54.461662],
                [11.011389, 54.476944],
                [11.01861, 54.49082900000013],
                [11.025555, 54.50110600000011],
                [11.031944, 54.50804900000014],
                [11.04389, 54.518326000000116],
                [11.06472, 54.53416],
                [11.068888, 54.534996],
                [11.184166, 54.52],
                [11.229166000000134, 54.50471],
                [11.235277, 54.501389],
                [11.242777000000103, 54.49555],
                [11.24472, 54.49333200000012],
                [11.27393, 54.458736],
                [11.300554, 54.426384],
                [11.303888, 54.421661],
                [11.312222, 54.40972],
                [11.31278, 54.406944],
              ],
            ],
            [
              [
                [8.662777, 54.494164],
                [8.632776, 54.491386],
                [8.616388, 54.492775],
                [8.612499000000128, 54.493889],
                [8.61027700000011, 54.49582700000013],
                [8.59778, 54.508888],
                [8.591944, 54.515549],
                [8.59028, 54.524719],
                [8.59111, 54.52777100000014],
                [8.593054, 54.53],
                [8.599722, 54.53333],
                [8.64222100000012, 54.54583],
                [8.691387000000134, 54.55389],
                [8.702776, 54.55389],
                [8.710833, 54.55167],
                [8.71111100000013, 54.548607],
                [8.709721, 54.53249],
                [8.708332, 54.52972],
                [8.691944, 54.511383],
                [8.685555, 54.50471],
                [8.68028, 54.500832],
                [8.67111, 54.49582700000013],
                [8.662777, 54.494164],
              ],
            ],
            [
              [
                [13.07361, 54.488609],
                [13.063055, 54.465271],
                [13.060833, 54.469162],
                [13.06, 54.47639],
                [13.06111, 54.486382000000106],
                [13.063889000000131, 54.500000000000114],
                [13.096666000000141, 54.590553],
                [13.10389, 54.596939],
                [13.109999, 54.600273],
                [13.117498, 54.602776],
                [13.13694, 54.60416],
                [13.147499, 54.60416],
                [13.15138800000011, 54.602776],
                [13.154165, 54.60083],
                [13.155277, 54.598328],
                [13.158054000000106, 54.58416],
                [13.158054000000106, 54.581108],
                [13.110832, 54.533882],
                [13.10861, 54.531387],
                [13.07361, 54.488609],
              ],
            ],
            [
              [
                [13.383055, 54.638885],
                [13.391313, 54.60695],
                [13.40743, 54.588757],
                [13.433424, 54.57784],
                [13.456300000000113, 54.573158],
                [13.481774, 54.574718],
                [13.516088, 54.57679700000011],
                [13.59305, 54.584717000000126],
                [13.617777000000103, 54.586105],
                [13.633888000000127, 54.585831],
                [13.639166, 54.585274],
                [13.646944, 54.582771],
                [13.671665000000132, 54.56916],
                [13.676666, 54.56528],
                [13.678055, 54.562775],
                [13.679165, 54.542496],
                [13.677776, 54.53249],
                [13.675278000000105, 54.526382],
                [13.670277, 54.522217],
                [13.666943, 54.520828],
                [13.647499, 54.515549],
                [13.6408330000001, 54.512772],
                [13.591389, 54.486107],
                [13.585278, 54.482773],
                [13.581388, 54.477776],
                [13.57833, 54.472221000000104],
                [13.576387, 54.46249],
                [13.576792, 54.459988],
                [13.577776, 54.453888],
                [13.583611, 54.441666],
                [13.617498, 54.404160000000104],
                [13.620554, 54.402496],
                [13.631109, 54.40111],
                [13.646387000000118, 54.401382000000126],
                [13.666666, 54.402222],
                [13.676109, 54.40083],
                [13.7025, 54.388054000000125],
                [13.7075, 54.384163],
                [13.71388800000011, 54.37778],
                [13.73111, 54.354721],
                [13.743889000000138, 54.33111],
                [13.730833, 54.275833],
                [13.727499, 54.274437],
                [13.715, 54.27166],
                [13.711111, 54.272217],
                [13.695555, 54.280548000000124],
                [13.693888, 54.282776],
                [13.696388, 54.28416],
                [13.71083, 54.29694400000011],
                [13.712776000000133, 54.32111],
                [13.712221, 54.324165],
                [13.689444, 54.34833],
                [13.68444, 54.34916],
                [13.508333, 54.342773],
                [13.504444, 54.34166],
                [13.46944, 54.328331],
                [13.359444, 54.27471900000012],
                [13.35667, 54.273048],
                [13.355, 54.270271],
                [13.3575, 54.25972],
                [13.40305, 54.265274],
                [13.408333, 54.265274],
                [13.413332000000139, 54.26471700000013],
                [13.419998, 54.26138300000014],
                [13.421944, 54.25916],
                [13.42639, 54.25193800000011],
                [13.428888, 54.243889],
                [13.429443, 54.238052],
                [13.424444000000108, 54.23360400000013],
                [13.39777800000013, 54.221939],
                [13.393055, 54.221382],
                [13.31861, 54.248604000000114],
                [13.268055000000118, 54.254997],
                [13.25694, 54.256104],
                [13.249722, 54.258331],
                [13.156111, 54.30555],
                [13.12194, 54.330551],
                [13.118332, 54.333885],
                [13.117222, 54.339439],
                [13.117777, 54.343048],
                [13.129166, 54.36805],
                [13.130833, 54.370827],
                [13.134165, 54.37221],
                [13.141666, 54.37444],
                [13.15138800000011, 54.375275],
                [13.15667, 54.375275],
                [13.200554, 54.372772],
                [13.217222, 54.369995],
                [13.223055, 54.369438],
                [13.235832, 54.371666],
                [13.261389000000122, 54.378609],
                [13.265276, 54.380272],
                [13.2675, 54.38250000000011],
                [13.238983, 54.411472],
                [13.207789, 54.428108],
                [13.164639000000136, 54.434349],
                [13.228611, 54.464996],
                [13.23222, 54.485817],
                [13.167238, 54.51337100000012],
                [13.14696, 54.54560500000014],
                [13.231388, 54.552498],
                [13.25562, 54.551323],
                [13.30397, 54.550285],
                [13.337764, 54.5664],
                [13.3674, 54.580437],
                [13.377795, 54.55808],
                [13.394952000000103, 54.541965],
                [13.42043, 54.52169],
                [13.447461, 54.488937],
                [13.48385, 54.483738],
                [13.50309, 54.493095],
                [13.516607000000135, 54.51337100000012],
                [13.502570000000105, 54.549767],
                [13.459419, 54.550804],
                [13.426146, 54.570042],
                [13.383514, 54.57836],
                [13.374676, 54.610073],
                [13.35544, 54.60435500000011],
                [13.32972100000012, 54.582771],
                [13.310555, 54.57333],
                [13.286221, 54.565052],
                [13.282054, 54.56355300000013],
                [13.251389000000131, 54.557777],
                [13.246111, 54.557777],
                [13.24472, 54.559166],
                [13.224722, 54.63388800000013],
                [13.224722, 54.639999],
                [13.22611, 54.64305100000013],
                [13.230555, 54.64777400000014],
                [13.24472, 54.656662],
                [13.263332000000105, 54.666664],
                [13.27861, 54.671387],
                [13.29222, 54.673332],
                [13.36444, 54.67944],
                [13.383888, 54.68083200000012],
                [13.424166, 54.6827770000001],
                [13.429998, 54.68222],
                [13.43778, 54.679718],
                [13.443054000000132, 54.675827],
                [13.443609, 54.67305],
                [13.44194, 54.67055],
                [13.42861, 54.66027100000014],
                [13.422499, 54.656944],
                [13.397221, 54.65222200000011],
                [13.390554, 54.649162],
                [13.385555, 54.644997],
                [13.383055, 54.638885],
              ],
            ],
            [
              [
                [8.364443, 54.61332700000014],
                [8.353611, 54.612778],
                [8.34889, 54.613609],
                [8.342222, 54.616661000000136],
                [8.331944000000135, 54.623604000000114],
                [8.298054, 54.65860700000013],
                [8.294998000000135, 54.66333],
                [8.294443, 54.666664],
                [8.296665, 54.6722180000001],
                [8.30749900000012, 54.687218],
                [8.311943, 54.691383],
                [8.342777000000126, 54.707771],
                [8.349722, 54.71083],
                [8.35389, 54.711662],
                [8.35805, 54.710548],
                [8.4, 54.627777],
                [8.36805500000014, 54.61444100000011],
                [8.364443, 54.61332700000014],
              ],
            ],
            [
              [
                [8.567778, 54.68527],
                [8.56361, 54.68416600000012],
                [8.488333000000125, 54.685555000000136],
                [8.47833, 54.686943],
                [8.402498, 54.70472],
                [8.39694, 54.708328],
                [8.39694, 54.713882],
                [8.406387, 54.729439],
                [8.413332, 54.735832],
                [8.425833, 54.742218],
                [8.44472, 54.748329],
                [8.461666, 54.751938],
                [8.53861, 54.755272],
                [8.551109, 54.75388],
                [8.569721, 54.750275],
                [8.581944, 54.746941],
                [8.584721, 54.744995],
                [8.586943, 54.74305],
                [8.594721, 54.721382],
                [8.594999, 54.71833],
                [8.572222, 54.689438],
                [8.567778, 54.68527],
              ],
            ],
            [
              [
                [10.979443, 54.380554],
                [10.955555, 54.382774],
                [10.955832, 54.380272],
                [10.958887, 54.376938],
                [10.962776000000133, 54.375832000000116],
                [10.986944, 54.371941],
                [11.016943, 54.369995],
                [11.044722, 54.36972000000014],
                [11.07389, 54.376389],
                [11.094166, 54.210274],
                [11.094444, 54.203888],
                [11.093054000000109, 54.19749500000012],
                [11.064444, 54.179718],
                [11.055555, 54.17472],
                [10.8875, 54.09333],
                [10.877499, 54.088882],
                [10.86972, 54.087494000000106],
                [10.839443, 54.09],
                [10.824999, 54.09166],
                [10.801388, 54.08944],
                [10.76639, 54.061104000000114],
                [10.758055, 54.05194100000011],
                [10.754999, 54.046661],
                [10.754721, 54.039993],
                [10.756388, 54.034439],
                [10.763332, 54.022217],
                [10.770277, 54.012772],
                [10.783888, 54.00055],
                [10.789999, 53.99721],
                [10.801109, 53.99388900000014],
                [10.822222000000124, 53.994164000000126],
                [10.861387, 53.99388900000014],
                [10.870554, 53.991943],
                [10.879999, 53.987778],
                [10.88389, 53.98333],
                [10.884722, 53.98055],
                [10.889721000000122, 53.957771],
                [10.890554000000122, 53.950829],
                [10.863609, 53.916939],
                [10.818535, 53.890053],
                [10.898888000000113, 53.93110700000011],
                [10.90443, 53.957344],
                [10.964722, 53.98027],
                [11.013054000000125, 53.995277],
                [11.05539, 54.007355],
                [11.094721, 54.01361],
                [11.176943, 54.015831],
                [11.18222, 54.015274],
                [11.189444, 54.012497],
                [11.192221, 54.010551000000135],
                [11.196665, 53.99388900000014],
                [11.244165, 53.942497],
                [11.248888, 53.93860600000011],
                [11.252222, 53.93694],
                [11.263332, 53.933052],
                [11.271944, 53.931664],
                [11.412777, 53.919716],
                [11.480833, 53.960274],
                [11.49222200000014, 53.99305],
                [11.49333, 53.99611],
                [11.5175, 54.031944],
                [11.52444, 54.034721000000104],
                [11.528889, 54.034439],
                [11.54472, 54.026382],
                [11.554722, 54.026939],
                [11.573889, 54.032494],
                [11.57972100000012, 54.03611000000012],
                [11.625555, 54.075554],
                [11.62944, 54.08055100000013],
                [11.630278, 54.086662],
                [11.627499, 54.09166],
                [11.621387, 54.098053],
                [11.61861, 54.10305],
                [11.61972, 54.106110000000115],
                [11.626665000000116, 54.112778000000105],
                [11.63944, 54.12277200000011],
                [11.676109, 54.149994],
                [11.68278, 54.15277100000014],
                [11.69083, 54.15471600000012],
                [11.700277, 54.155548],
                [11.747499, 54.156387],
                [11.986111, 54.17333],
                [12.129721, 54.191109],
                [12.326944, 54.286659],
                [12.343611000000124, 54.29777],
                [12.356110000000115, 54.308609],
                [12.436943, 54.391106],
                [12.480555, 54.44416],
                [12.526943, 54.474159],
                [12.540554, 54.45888500000012],
                [12.63861100000014, 54.448944],
                [12.66044, 54.44611],
                [12.680777, 54.444942],
                [12.803333, 54.442497],
                [12.892776, 54.443329],
                [12.908609, 54.441383],
                [12.919722, 54.433884],
                [12.923611, 54.429718],
                [12.924166, 54.42694100000011],
                [12.923054, 54.42388],
                [12.920832000000132, 54.421661],
                [12.917500000000132, 54.419998000000135],
                [12.880554000000132, 54.411942],
                [12.758337, 54.41304400000013],
                [12.729240000000118, 54.423363],
                [12.7129, 54.42967],
                [12.694698, 54.42967],
                [12.676065, 54.42049800000012],
                [12.665316000000132, 54.408745],
                [12.643222, 54.413887],
                [12.465555000000109, 54.39582800000011],
                [12.462221000000113, 54.39444],
                [12.425833000000125, 54.37249800000012],
                [12.36666, 54.307495],
                [12.365, 54.304718],
                [12.364443, 54.30110900000011],
                [12.36972, 54.264999],
                [12.372499, 54.263054],
                [12.385555000000124, 54.25666],
                [12.40361, 54.249718],
                [12.412777, 54.247772],
                [12.445, 54.246941],
                [12.453054000000122, 54.248886],
                [12.455832, 54.250832],
                [12.452499, 54.252220000000136],
                [12.43639, 54.253883],
                [12.427221, 54.255829],
                [12.41805, 54.260826],
                [12.41416500000014, 54.265274],
                [12.413332000000139, 54.271111],
                [12.41555, 54.27722200000011],
                [12.420555, 54.285271],
                [12.427221, 54.29222],
                [12.4775, 54.329994],
                [12.482777, 54.333885],
                [12.54972, 54.3605500000001],
                [12.581944, 54.368332],
                [12.624722, 54.372772],
                [12.682777, 54.376106],
                [12.764721, 54.37249800000012],
                [13.02389, 54.399719],
                [13.113888, 54.279716],
                [13.117777, 54.275276],
                [13.12889, 54.271111],
                [13.2125, 54.25193800000011],
                [13.282221, 54.236664],
                [13.288055, 54.233055],
                [13.379166000000112, 54.174438],
                [13.4533330000001, 54.098053],
                [13.4558320000001, 54.096107],
                [13.47972, 54.088608],
                [13.494444000000101, 54.0861],
                [13.499722, 54.0861],
                [13.480000000000132, 54.116943000000106],
                [13.480555, 54.11972],
                [13.495554, 54.12416100000013],
                [13.706665, 54.171104],
                [13.71167, 54.17139],
                [13.71833, 54.16971600000011],
                [13.788887, 54.109718],
                [13.799721, 54.087494000000106],
                [13.79833200000013, 54.08083],
                [13.786110000000122, 54.049995],
                [13.829721, 53.986382],
                [13.86694, 53.905],
                [13.863609, 53.9033280000001],
                [13.82111, 53.87638900000013],
                [13.807499, 53.860832],
                [13.806110000000103, 53.85777300000012],
                [13.807499, 53.85527000000013],
                [13.813055, 53.845276000000126],
                [13.95917, 53.774994],
                [14.22389, 53.700829],
                [14.247499000000118, 53.69694],
                [14.26528, 53.697777],
                [14.275627, 53.699066],
                [14.30972, 53.55555],
                [14.413261, 53.33896],
                [14.412777, 53.30444],
                [14.391689, 53.144165],
                [14.3825, 53.116386],
                [14.378054, 53.103882],
                [14.352499, 53.052773],
                [14.342222, 53.044998000000135],
                [14.299702, 53.021431],
                [14.28777700000012, 53.016106],
                [14.22889, 52.990273000000116],
                [14.221943, 52.987495],
                [14.200277, 52.98472],
                [14.16889, 52.97333],
                [14.149443, 52.96277600000013],
                [14.146111, 52.9575],
                [14.145555000000115, 52.95389],
                [14.149166, 52.862778],
                [14.19639, 52.820549],
                [14.21444300000013, 52.81666600000011],
                [14.348888, 52.751663],
                [14.361111000000108, 52.744995],
                [14.383333, 52.73083],
                [14.448332, 52.675278],
                [14.475555, 52.654160000000104],
                [14.481943000000115, 52.65083],
                [14.505833, 52.641388],
                [14.518332, 52.637772],
                [14.527777, 52.636108],
                [14.54749900000013, 52.62999700000012],
                [14.561666000000116, 52.62444],
                [14.58722, 52.611938],
                [14.60433, 52.601723],
                [14.638332000000105, 52.574715],
                [14.640276, 52.572495],
                [14.641388, 52.57],
                [14.637220000000127, 52.497215],
                [14.636389000000122, 52.490555],
                [14.623333, 52.477219000000105],
                [14.587776, 52.44166600000011],
                [14.582499, 52.43805],
                [14.567221, 52.43388],
                [14.559166, 52.43249500000013],
                [14.54861, 52.42889],
                [14.54611, 52.426941],
                [14.54389, 52.42472],
                [14.53722, 52.406944],
                [14.534443, 52.397774],
                [14.534443, 52.394722000000115],
                [14.57805, 52.29055000000011],
                [14.58166, 52.28611000000012],
                [14.596109000000126, 52.274437],
                [14.601665, 52.271111],
                [14.65583, 52.26028],
                [14.692497, 52.25444],
                [14.70388800000012, 52.24971800000014],
                [14.710554000000116, 52.24388900000014],
                [14.713333, 52.239166000000125],
                [14.760765, 52.069862],
                [14.718542, 51.945091000000104],
                [14.71656, 51.941132],
                [14.692499, 51.89888800000011],
                [14.68722, 51.894997],
                [14.648054, 51.866943],
                [14.645277, 51.864998],
                [14.640276, 51.862221],
                [14.61611, 51.85388200000011],
                [14.605, 51.843887],
                [14.603333, 51.84111],
                [14.600555, 51.83138300000013],
                [14.599165, 51.821388],
                [14.599443000000122, 51.81860400000011],
                [14.60472, 51.80888],
                [14.663332, 51.728607],
                [14.666943, 51.724159],
                [14.678333, 51.714165],
                [14.698055000000124, 51.70222],
                [14.715832, 51.69416],
                [14.72833, 51.68777],
                [14.755278, 51.669998000000135],
                [14.756388, 51.667496],
                [14.757500000000107, 51.659439],
                [14.76111, 51.617218],
                [14.761389, 51.611382],
                [14.759998, 51.604439],
                [14.75444, 51.596939000000134],
                [14.714998, 51.554722],
                [14.73611, 51.528053000000114],
                [14.74278, 51.52499],
                [14.8375, 51.498604000000114],
                [14.92111, 51.481941],
                [14.95111, 51.471382],
                [14.95417, 51.469719],
                [14.95583, 51.467499],
                [14.975555, 51.440826],
                [14.981833, 51.36805],
                [14.971666, 51.358887],
                [14.971666, 51.355553],
                [14.980555, 51.338333],
                [14.986111000000108, 51.328888],
                [14.995554, 51.3211060000001],
                [15.009722, 51.312492],
                [15.03, 51.294716],
                [15.03639, 51.285553],
                [15.03889, 51.27166],
                [15.032221, 51.23917],
                [14.99444, 51.118607],
                [14.978888, 51.078331],
                [14.966389, 51.053604],
                [14.96472, 51.050827],
                [14.93111, 51.002495000000124],
                [14.896944000000133, 50.959442],
                [14.827776, 50.88694],
                [14.824165, 50.881943],
                [14.824999000000105, 50.876389],
                [14.8283330000001, 50.865829],
                [14.824999000000105, 50.856384],
                [14.804165, 50.820549],
                [14.801666, 50.81889],
                [14.776388, 50.818329],
                [14.76667, 50.818329],
                [14.739721, 50.823883],
                [14.717777, 50.829163],
                [14.65167, 50.847221],
                [14.62167, 50.85555],
                [14.61916, 50.8575],
                [14.61805500000014, 50.859993],
                [14.631388, 50.881104],
                [14.628332000000114, 50.92360700000012],
                [14.597221000000104, 50.982498],
                [14.569166, 51.005554],
                [14.491665, 51.03666],
                [14.30972, 51.053604],
                [14.302776, 51.051384],
                [14.28555, 51.037498],
                [14.265554, 51.0094380000001],
                [14.255554000000132, 50.99305],
                [14.254999, 50.990273000000116],
                [14.256109, 50.987778000000105],
                [14.31972100000013, 50.94694],
                [14.322777, 50.94527],
                [14.368332, 50.934998],
                [14.311388, 50.88222],
                [14.155554, 50.843048],
                [13.99472, 50.815277],
                [13.986666, 50.81360600000011],
                [13.904444, 50.789444],
                [13.902777000000128, 50.78694],
                [13.89111, 50.768883],
                [13.734165, 50.730827],
                [13.66944, 50.72583],
                [13.634722, 50.722221000000104],
                [13.582222, 50.709442],
                [13.541111, 50.68972],
                [13.510832, 50.65055100000012],
                [13.515554, 50.64694200000014],
                [13.519722000000115, 50.642776],
                [13.520277, 50.64],
                [13.518332, 50.637772],
                [13.4725, 50.60527],
                [13.463888, 50.60027],
                [13.458611, 50.600555],
                [13.436666, 50.60527],
                [13.416388, 50.61055],
                [13.413332000000139, 50.612221],
                [13.378332, 50.6294400000001],
                [13.25111, 50.59],
                [13.248055000000136, 50.588333],
                [13.224165, 50.564720000000136],
                [13.222221000000104, 50.558609],
                [13.222221000000104, 50.55555],
                [13.223888, 50.550278],
                [13.223888, 50.546944],
                [13.222776, 50.544167],
                [13.20889, 50.52388800000011],
                [13.20333, 50.51694],
                [13.19111, 50.50361],
                [13.18333200000012, 50.50193800000011],
                [13.079443, 50.498055],
                [13.01889, 50.442215],
                [13.011665, 50.436386],
                [12.991943, 50.421104],
                [12.985558, 50.41833],
                [12.950554000000125, 50.41111],
                [12.938889, 50.408882],
                [12.91722, 50.414719],
                [12.899721, 50.424438],
                [12.89694, 50.42610900000011],
                [12.85583, 50.442215],
                [12.83139, 50.45166],
                [12.818888, 50.454437],
                [12.77611, 50.44583],
                [12.768332, 50.44416],
                [12.74611, 50.434715],
                [12.73472, 50.42832900000013],
                [12.671389, 50.411942000000124],
                [12.623333, 50.411942000000124],
                [12.618610000000103, 50.411942000000124],
                [12.51861, 50.393883],
                [12.51222, 50.391106],
                [12.486111, 50.373055000000136],
                [12.398611, 50.309166],
                [12.325554, 50.236107],
                [12.323055, 50.2066650000001],
                [12.28417, 50.21527],
                [12.278055000000109, 50.22166],
                [12.195833000000107, 50.305832],
                [12.180277, 50.31638],
                [12.177221, 50.318054],
                [12.093704, 50.322533],
                [12.120832, 50.309441],
                [12.123333, 50.30749500000013],
                [12.208611, 50.169441],
                [12.209721, 50.16389],
                [12.20917, 50.160553],
                [12.196388, 50.143883],
                [12.193888000000129, 50.138054],
                [12.192499000000112, 50.13166],
                [12.206142, 50.106209],
                [12.265554000000122, 50.066109],
                [12.307499, 50.047493],
                [12.429443, 49.993889],
                [12.471109, 49.985832],
                [12.490000000000123, 49.976662],
                [12.492777, 49.975],
                [12.544167, 49.91805],
                [12.545555, 49.91555],
                [12.54722, 49.907219],
                [12.54694400000011, 49.8975],
                [12.469444, 49.784721000000104],
                [12.467499, 49.782219],
                [12.455555000000118, 49.695549],
                [12.47611, 49.690826],
                [12.508888, 49.682495],
                [12.513054, 49.68138900000014],
                [12.515554, 49.679443],
                [12.524443000000133, 49.66555],
                [12.554722, 49.616661],
                [12.578609, 49.560555000000136],
                [12.597776, 49.527496],
                [12.674444, 49.42499500000014],
                [12.78611, 49.34416],
                [12.795555, 49.33972],
                [12.80361, 49.337776],
                [12.87861, 49.328049000000135],
                [12.883333, 49.3274990000001],
                [12.887777, 49.327774],
                [12.891109, 49.328888],
                [12.893055, 49.331108],
                [12.885277, 49.33972],
                [12.88416500000011, 49.342216],
                [12.88416500000011, 49.345276000000126],
                [12.88611, 49.346939],
                [12.8908330000001, 49.346939],
                [12.945555, 49.339439],
                [12.957222000000115, 49.33639],
                [12.96666, 49.33194],
                [13.031111, 49.28777300000013],
                [13.173054, 49.16722],
                [13.314165, 49.103333000000134],
                [13.322777, 49.098328],
                [13.39528, 49.050278000000105],
                [13.396944, 49.04805],
                [13.40254, 49.006187],
                [13.50972, 48.9725],
                [13.564826, 48.973667],
                [13.580555, 48.970833],
                [13.587776, 48.966385],
                [13.59111, 48.959717],
                [13.593332, 48.956940000000145],
                [13.59972, 48.951942000000145],
                [13.605276000000117, 48.95082900000011],
                [13.626389000000131, 48.953331],
                [13.6275, 48.950554],
                [13.624998, 48.94749500000012],
                [13.625555, 48.93916300000012],
                [13.641109, 48.914162],
                [13.649166, 48.90610500000014],
                [13.655554000000109, 48.901108],
                [13.661943, 48.896385],
                [13.666666, 48.894722000000115],
                [13.677776, 48.884163],
                [13.691111, 48.878326],
                [13.707777, 48.880272],
                [13.719444000000124, 48.878326],
                [13.724443, 48.8794400000001],
                [13.731943, 48.88361],
                [13.736666, 48.883888],
                [13.740833, 48.88166],
                [13.7425, 48.87444],
                [13.745832, 48.867775],
                [13.753332, 48.85916],
                [13.756666, 48.85249],
                [13.761389, 48.84694],
                [13.763054000000125, 48.8436],
                [13.765554, 48.8408280000001],
                [13.76944, 48.838608],
                [13.77944, 48.83583],
                [13.78583, 48.830826000000116],
                [13.802776000000108, 48.810829],
                [13.81389, 48.800278],
                [13.815554, 48.796944],
                [13.815832, 48.79277000000013],
                [13.81278, 48.78527100000014],
                [13.812222, 48.78083],
                [13.815554, 48.77833],
                [13.832499, 48.774994],
                [13.833611, 48.7736],
                [13.81472, 48.73805],
                [13.826666, 48.643051],
                [13.82694400000014, 48.638885],
                [13.825277, 48.62527],
                [13.82278, 48.617218],
                [13.804998, 48.58416],
                [13.8025, 48.581108],
                [13.725996, 48.515587],
                [13.683054, 48.529442],
                [13.674721, 48.533051],
                [13.666943, 48.537216],
                [13.657776, 48.549164],
                [13.65167, 48.554161000000136],
                [13.602777000000117, 48.56805],
                [13.526943, 48.585],
                [13.51528, 48.58527400000014],
                [13.50528, 48.58305400000012],
                [13.450554, 48.568886],
                [13.441666, 48.565552],
                [13.435, 48.561104000000114],
                [13.43528, 48.556938],
                [13.443609, 48.55055],
                [13.4475, 48.544441],
                [13.457777, 48.517776],
                [13.457222, 48.51332900000011],
                [13.44, 48.43527],
                [13.435833, 48.423607],
                [13.423332, 48.393608],
                [13.421665, 48.389999],
                [13.419167, 48.38694],
                [13.394999, 48.366104],
                [13.334999, 48.328606],
                [13.31305, 48.315826],
                [13.291943, 48.307495],
                [13.27861, 48.30305],
                [13.258055000000127, 48.298882],
                [13.154444, 48.292221],
                [13.01777600000014, 48.2594380000001],
                [12.874998000000119, 48.204994],
                [12.867498, 48.200829],
                [12.7675, 48.131943],
                [12.76083, 48.12722],
                [12.75833, 48.123886],
                [12.755, 48.116943],
                [12.753332, 48.109161],
                [12.754444, 48.10555],
                [12.764166000000102, 48.085274],
                [12.768332, 48.079163],
                [12.79278, 48.059441000000106],
                [12.805555, 48.049721],
                [12.8375, 48.03],
                [12.853333, 48.01777600000014],
                [12.85833, 48.012215],
                [12.863194, 48],
                [12.865342, 47.99459800000011],
                [12.918888, 47.957771],
                [12.96666, 47.906944000000124],
                [13.008888, 47.854164],
                [12.97333, 47.813332],
                [12.967777, 47.80778],
                [12.94861, 47.79277000000013],
                [12.939722, 47.784721000000104],
                [12.912498000000141, 47.733055],
                [12.91139, 47.72916],
                [12.910831, 47.724442],
                [12.911943, 47.720833],
                [12.917500000000132, 47.715553],
                [12.923611, 47.714722],
                [12.98499900000013, 47.712219],
                [12.99111, 47.712494],
                [12.995554, 47.714165],
                [13.003332, 47.717773],
                [13.014166, 47.72416],
                [13.01916, 47.72527300000013],
                [13.024443, 47.724998],
                [13.034443, 47.722221],
                [13.058332, 47.70611],
                [13.074999000000105, 47.690277],
                [13.08, 47.684441000000106],
                [13.099998000000141, 47.645],
                [13.10027700000012, 47.640831000000105],
                [13.054998, 47.5],
                [13.053055, 47.496384],
                [13.050278, 47.49389],
                [13.01667, 47.470276],
                [13.011665, 47.469162],
                [13.004999000000112, 47.469444000000124],
                [12.96305500000011, 47.475555],
                [12.95269, 47.478477],
                [12.809721, 47.55222],
                [12.80361, 47.55722000000014],
                [12.78944, 47.579437],
                [12.78611, 47.585831],
                [12.787777, 47.589439],
                [12.800278, 47.613052],
                [12.808887, 47.616386],
                [12.814444, 47.616943],
                [12.827776, 47.616386],
                [12.83083, 47.618889],
                [12.82917, 47.622215],
                [12.82361, 47.62749],
                [12.74472, 47.68110700000011],
                [12.735554, 47.684166],
                [12.722776000000124, 47.684441000000106],
                [12.665833, 47.684998],
                [12.606943, 47.674438],
                [12.60278, 47.672775000000115],
                [12.596943, 47.66749600000014],
                [12.57639, 47.6441650000001],
                [12.56667, 47.64194],
                [12.518055, 47.632217],
                [12.51278, 47.633331],
                [12.508888, 47.63528],
                [12.455, 47.66777],
                [12.201111, 47.65749],
                [12.206856, 47.639534],
                [12.20778, 47.627220000000136],
                [12.206388, 47.618607],
                [12.20472, 47.61496],
                [12.199377, 47.61026],
                [12.195745000000102, 47.608124],
                [12.14139, 47.61110700000012],
                [12.111111, 47.6147160000001],
                [12.059999, 47.62055],
                [12.006388000000129, 47.624443],
                [11.919998, 47.614166],
                [11.68305400000014, 47.584717],
                [11.583611000000133, 47.527222],
                [11.57778, 47.52194200000014],
                [11.57444, 47.52],
                [11.554443000000106, 47.51555],
                [11.505278, 47.509163],
                [11.457499, 47.51221],
                [11.296389, 47.428886],
                [11.1125, 47.396942],
                [11.095554, 47.396111],
                [11.02861, 47.395271],
                [11.008333000000107, 47.395828],
                [10.98361, 47.398048],
                [10.978333, 47.399162],
                [10.97361, 47.400551],
                [10.971109, 47.40333],
                [10.909443, 47.518051],
                [10.690832, 47.55389],
                [10.569443, 47.540276],
                [10.484165, 47.582771],
                [10.484444, 47.58722],
                [10.482777000000112, 47.59055],
                [10.47805, 47.59194200000013],
                [10.472500000000139, 47.591385],
                [10.44361, 47.583885],
                [10.434166, 47.581383],
                [10.43, 47.57972],
                [10.426943, 47.57694],
                [10.436388, 47.52916],
                [10.458332, 47.49110400000012],
                [10.467499, 47.483604],
                [10.46917, 47.480553],
                [10.469721, 47.47639],
                [10.474165, 47.439720000000136],
                [10.47333, 47.435555000000136],
                [10.429722, 47.396111],
                [10.339998, 47.314995],
                [10.337221000000113, 47.312492000000134],
                [10.329443, 47.30832700000013],
                [10.274443, 47.28889],
                [10.232777, 47.276665],
                [10.22805, 47.275551],
                [10.221943, 47.27528],
                [10.173332, 47.274719],
                [10.21167, 47.322495],
                [10.23139, 47.36999500000013],
                [10.232777, 47.3736],
                [10.23139, 47.381386],
                [10.04305, 47.4952770000001],
                [9.955, 47.539719],
                [9.81361, 47.593605],
                [9.808332, 47.594719],
                [9.782499, 47.594444],
                [9.773611, 47.591385],
                [9.763054, 47.584717],
                [9.749443, 47.57083100000011],
                [9.74305500000014, 47.560829000000126],
                [9.73639, 47.546944],
                [9.7292, 47.535297],
                [9.692531, 47.52951400000012],
                [9.651506, 47.52951400000012],
                [9.610482, 47.52951400000012],
                [9.607064, 47.52951400000012],
                [9.577914, 47.537418],
                [9.566724, 47.54045],
                [9.478322000000105, 47.57585],
                [9.261095, 47.662842],
                [9.086943, 47.684998],
                [9.07833, 47.685829],
                [9.0425, 47.688889],
                [9.02417, 47.6877750000001],
                [9.004999, 47.682495],
                [8.996666000000118, 47.679161],
                [8.98555, 47.672775000000115],
                [8.973331, 47.66749600000014],
                [8.94778, 47.65749],
                [8.934166, 47.653053],
                [8.917776000000117, 47.650551],
                [8.904999, 47.650276],
                [8.89278, 47.651382],
                [8.883299000000136, 47.654148],
                [8.855833, 47.698883],
                [8.835278, 47.718048],
                [8.808887, 47.73583200000013],
                [8.804165, 47.73722],
                [8.799999000000128, 47.735275],
                [8.777777, 47.722771],
                [8.772221, 47.717499],
                [8.772778, 47.713333],
                [8.774721000000113, 47.710274],
                [8.800133, 47.681725],
                [8.761389000000122, 47.692215],
                [8.74528, 47.695],
                [8.720222, 47.69662],
                [8.729166, 47.70388800000012],
                [8.730698, 47.705673],
                [8.734165, 47.709717000000126],
                [8.734999, 47.713882000000126],
                [8.736944000000108, 47.75444],
                [8.736944000000108, 47.758049],
                [8.734999, 47.761383],
                [8.685555, 47.786659],
                [8.661388000000102, 47.79805],
                [8.61472, 47.803604],
                [8.60861, 47.804161],
                [8.56611, 47.806938],
                [8.559721, 47.806389],
                [8.479443, 47.7725],
                [8.47611, 47.7699970000001],
                [8.47333, 47.76749400000011],
                [8.406666, 47.70388800000012],
                [8.407221, 47.699715],
                [8.413332, 47.67832900000013],
                [8.424721, 47.66944100000012],
                [8.47555, 47.646942],
                [8.495277, 47.647217],
                [8.51833, 47.64971900000012],
                [8.52583, 47.65361],
                [8.52805, 47.65694],
                [8.536943000000122, 47.664444],
                [8.545832, 47.66749600000014],
                [8.55139, 47.66833],
                [8.580555000000118, 47.668610000000115],
                [8.610254, 47.667732000000115],
                [8.620832, 47.66111],
                [8.626944, 47.656105],
                [8.629444, 47.6533280000001],
                [8.630833, 47.64971900000012],
                [8.629166, 47.646111],
                [8.594721, 47.601662],
                [8.591389, 47.599442],
                [8.57642, 47.59137],
                [8.569430000000125, 47.598537000000135],
                [8.565554, 47.61444100000011],
                [8.562222, 47.621384],
                [8.558332, 47.623329],
                [8.53139, 47.63277],
                [8.519999, 47.634163000000115],
                [8.51111, 47.631104],
                [8.477499, 47.612221],
                [8.464998, 47.602493],
                [8.435833, 47.57361],
                [8.3908330000001, 47.57999400000011],
                [8.2925, 47.605827],
                [8.28805, 47.611664],
                [8.283333, 47.613052],
                [8.240833, 47.619438],
                [8.205555, 47.62167],
                [8.198889, 47.62167],
                [8.19333300000011, 47.620827],
                [8.18528, 47.617218],
                [8.11083200000013, 47.581108],
                [8.108055, 47.578331],
                [8.103888, 47.571938],
                [8.102499, 47.568329],
                [8.09972, 47.56555200000014],
                [8.092222, 47.561661],
                [8.086666, 47.560555],
                [8.033333000000141, 47.556107],
                [7.93194, 47.55222],
                [7.91889, 47.552773],
                [7.91361, 47.55389],
                [7.906388, 47.558052],
                [7.769722, 47.553329],
                [7.697223, 47.543327],
                [7.656111000000124, 47.55055],
                [7.621111, 47.5611],
                [7.666666, 47.57416500000011],
                [7.669999, 47.576385],
                [7.671944, 47.579437],
                [7.676944, 47.603607],
                [7.674444, 47.606384000000105],
                [7.64055, 47.603882],
                [7.588268, 47.58448],
                [7.589747, 47.5926970000001],
                [7.589722000000108, 47.60194400000012],
                [7.585833, 47.60833],
                [7.567222, 47.636665],
                [7.56111, 47.641663],
                [7.540277000000117, 47.655],
                [7.528889, 47.66083],
                [7.521944, 47.66555],
                [7.51944, 47.66833],
                [7.513333000000102, 47.68694],
                [7.510833, 47.703331],
                [7.526667, 47.788055],
                [7.557221, 47.862778000000105],
                [7.584167, 47.903328],
                [7.622222, 47.96916],
                [7.624166, 47.97694400000012],
                [7.624444, 47.98610700000012],
                [7.622499000000118, 47.993889],
                [7.618518, 48],
                [7.61361, 48.006104],
                [7.583888, 48.02722200000011],
                [7.574444, 48.034439],
                [7.571666, 48.037216000000114],
                [7.56919, 48.044777],
                [7.56667, 48.059998],
                [7.568889000000127, 48.085274],
                [7.569722000000127, 48.08916],
                [7.576898, 48.113152],
                [7.578888, 48.11972000000014],
                [7.580832, 48.122772],
                [7.607729, 48.164185],
                [7.693333, 48.276382],
                [7.746111, 48.330551],
                [7.750833, 48.3366620000001],
                [7.75177, 48.345406],
                [7.743055, 48.371109000000104],
                [7.736666, 48.389442000000145],
                [7.736666, 48.3986],
                [7.745403000000124, 48.42495],
                [7.80222, 48.575829],
                [7.88, 48.66416],
                [7.96194400000013, 48.7241590000001],
                [8.092222, 48.803604],
                [8.103888, 48.816666],
                [8.10639, 48.82222],
                [8.110277, 48.8408280000001],
                [8.112499, 48.846382],
                [8.121666, 48.864998],
                [8.135832, 48.890831],
                [8.139166, 48.895554],
                [8.190554, 48.951942000000145],
                [8.20611, 48.95888],
                [8.22608, 48.964417],
                [8.155554000000109, 48.97639],
                [8.051943, 49.005272],
                [8.039721, 49.01111],
                [7.938611, 49.048882],
                [7.933332000000121, 49.048882],
                [7.821388, 49.046387],
                [7.737499, 49.04277],
                [7.66889, 49.04222],
                [7.652089, 49.04493700000012],
                [7.63028, 49.065277],
                [7.625833000000114, 49.06916],
                [7.486944, 49.164162],
                [7.432500000000118, 49.175827],
                [7.423611, 49.1772160000001],
                [7.41361, 49.17694100000011],
                [7.38361, 49.173332],
                [7.375278, 49.171944],
                [7.371944, 49.17083],
                [7.369015, 49.16878],
                [7.367222, 49.160553],
                [7.361666, 49.14444],
                [7.36, 49.14222],
                [7.29167, 49.11222],
                [7.287777, 49.111107],
                [7.151667, 49.121109000000104],
                [7.090555, 49.127495],
                [7.019444, 49.187492],
                [6.934166, 49.219719],
                [6.930555, 49.22083],
                [6.920555, 49.220551],
                [6.853889, 49.218048000000124],
                [6.8475, 49.215271],
                [6.843055, 49.211388],
                [6.841389, 49.20888500000012],
                [6.840278, 49.206108],
                [6.84111, 49.203331000000105],
                [6.849722, 49.190552],
                [6.855000000000132, 49.183884],
                [6.859722, 49.179993],
                [6.861111, 49.177773],
                [6.861111, 49.174995],
                [6.85944400000011, 49.172493000000145],
                [6.844166, 49.158333],
                [6.838888, 49.154999],
                [6.831388, 49.15305],
                [6.82194, 49.153885],
                [6.735, 49.165276],
                [6.730833, 49.166107],
                [6.727500000000134, 49.167496],
                [6.723611, 49.171661],
                [6.715, 49.18305],
                [6.714167, 49.185829],
                [6.714722, 49.18888900000013],
                [6.716389000000106, 49.191383],
                [6.686944, 49.244995],
                [6.594722000000104, 49.363052],
                [6.546111, 49.41944],
                [6.540555, 49.425827],
                [6.532222, 49.43083200000012],
                [6.50833, 49.442772],
                [6.468333, 49.461388],
                [6.416111, 49.47583],
                [6.41139, 49.47555],
                [6.36217, 49.45939],
                [6.362778, 49.489166000000125],
                [6.356486, 49.525864],
                [6.420833, 49.665833],
                [6.466110000000128, 49.691109],
                [6.47305, 49.693604],
                [6.48472, 49.69611],
                [6.505835, 49.706627],
                [6.524722000000111, 49.80555],
                [6.524444, 49.808609],
                [6.522222, 49.811104],
                [6.481944, 49.811104],
                [6.42972200000014, 49.808884],
                [6.395555, 49.817772],
                [6.321111, 49.84833],
                [6.315938000000131, 49.85531600000013],
                [6.25528, 49.880554],
                [6.250278, 49.884163],
                [6.234166, 49.8975],
                [6.175278, 49.949997],
                [6.173055, 49.95222],
                [6.14055500000012, 49.993889],
                [6.130555000000129, 50.013885],
                [6.11333, 50.055832],
                [6.112778, 50.05888],
                [6.118333, 50.09083],
                [6.128055, 50.116386],
                [6.13028, 50.121941],
                [6.134414, 50.127846],
                [6.13972200000012, 50.15444200000013],
                [6.16389, 50.221382],
                [6.165555, 50.22361],
                [6.173333, 50.232498],
                [6.280833, 50.283607],
                [6.34972, 50.31277],
                [6.398204, 50.32317],
                [6.37444, 50.44055],
                [6.37361, 50.443329],
                [6.371111, 50.448326],
                [6.344444, 50.484161],
                [6.333888000000115, 50.48972],
                [6.3175, 50.49638],
                [6.30944, 50.498055],
                [6.264722, 50.497772],
                [6.247777, 50.589165],
                [6.27055, 50.61582900000013],
                [6.27167, 50.61860700000011],
                [6.270833, 50.621384],
                [6.268611, 50.623604],
                [6.16722, 50.656387],
                [6.05472200000014, 50.72361000000012],
                [6.011798, 50.757271],
                [6.008055000000127, 50.802216],
                [6.013333, 50.838608],
                [6.013888000000122, 50.84166],
                [6.026111, 50.847771],
                [6.04611, 50.851944],
                [6.051666, 50.851944],
                [6.056389, 50.848328],
                [6.060833, 50.847496],
                [6.064722, 50.848328],
                [6.06778, 50.849716],
                [6.071666, 50.85416],
                [6.08417, 50.870552],
                [6.084722, 50.873604],
                [6.081388, 50.91360500000013],
                [6.080277000000137, 50.915833],
                [6.02833, 50.97666],
                [6.025555, 50.978333],
                [6.0175, 50.98027],
                [5.948889, 50.984993],
                [5.944722, 50.984993],
                [5.9325, 50.982216],
                [5.908055, 50.973885],
                [5.900277, 50.971939],
                [5.891666, 50.972771],
                [5.869444000000101, 51.018883],
                [5.864166, 51.04361],
                [5.86472, 51.046104],
                [5.866944, 51.0480500000001],
                [5.902499, 51.06305],
                [5.906944000000124, 51.063889],
                [5.910277, 51.062492],
                [6.00305, 51.08416],
                [6.0975, 51.131104],
                [6.090278, 51.168884],
                [6.083611000000133, 51.17166],
                [6.079444000000137, 51.175827],
                [6.07667, 51.18110700000011],
                [6.074721, 51.189995000000124],
                [6.071388, 51.211662],
                [6.071666, 51.215],
                [6.072222, 51.218048],
                [6.076388, 51.240273],
                [6.07889, 51.242493],
                [6.143055, 51.29527300000012],
                [6.222221000000104, 51.36166400000013],
                [6.222777, 51.364716],
                [6.222221000000104, 51.46583],
                [6.221944, 51.468887],
                [6.2075, 51.509995],
                [6.202222, 51.51694],
                [6.15861, 51.55832700000013],
                [6.136666, 51.569160000000124],
                [6.131389, 51.572495],
                [6.094166, 51.604439],
                [6.093055000000106, 51.60721600000011],
                [6.028889, 51.706665],
                [5.95205, 51.747528],
                [5.980833, 51.760277],
                [5.985833, 51.763885],
                [5.986666, 51.766937],
                [5.984722, 51.780548],
                [5.98139, 51.785271],
                [5.964722, 51.80555],
                [5.9625, 51.807777],
                [6.00305, 51.82999],
                [6.12361, 51.888054],
                [6.182221, 51.895271],
                [6.35111, 51.848053],
                [6.462777, 51.853607],
                [6.5275, 51.874443],
                [6.594722000000104, 51.896111],
                [6.67611, 51.91389],
                [6.685555, 51.914162],
                [6.691667, 51.91111000000012],
                [6.69361, 51.90888200000012],
                [6.701944, 51.90361],
                [6.720555, 51.89777400000014],
                [6.724444, 51.898048],
                [6.746388, 51.906105],
                [6.776944, 51.921387],
                [6.789166, 51.928055],
                [6.828888, 51.965553],
                [6.8308320000001, 51.971382],
                [6.83, 51.97749],
                [6.826111, 51.98860900000011],
                [6.80055, 52.00722],
                [6.794444, 52.010277],
                [6.728611, 52.035271],
                [6.73639, 52.07666000000012],
                [6.759428, 52.114563],
                [6.8425, 52.117775],
                [6.8525, 52.11833],
                [6.860555, 52.12028],
                [6.86861, 52.125549],
                [6.87194, 52.130272],
                [6.87472, 52.13916],
                [6.876111, 52.148605],
                [6.8775, 52.151382],
                [6.901111, 52.171387],
                [6.904166, 52.17305],
                [6.96472, 52.190277],
                [7.042222, 52.23166700000013],
                [7.053094, 52.23776],
                [7.031388, 52.268883],
                [7.028055, 52.276939],
                [7.028055, 52.280273000000136],
                [7.028889, 52.286942],
                [7.032222, 52.298882000000106],
                [7.038055, 52.31277],
                [7.058114000000103, 52.337639],
                [7.069722, 52.35277600000012],
                [7.071111, 52.358887],
                [7.065555, 52.385826],
                [7.061944, 52.39361],
                [7.058888, 52.398605],
                [6.99083, 52.459717],
                [6.987499, 52.4611],
                [6.983889, 52.46],
                [6.973888, 52.448608],
                [6.965833, 52.443054],
                [6.95417, 52.436386],
                [6.950833, 52.43499800000012],
                [6.94611, 52.434441],
                [6.76444400000014, 52.45916],
                [6.753333000000111, 52.462776],
                [6.705555, 52.485832],
                [6.7025, 52.490555],
                [6.688889, 52.54916400000013],
                [6.690277, 52.551941],
                [6.7225, 52.559441000000106],
                [6.75611, 52.563332],
                [6.75944, 52.56472],
                [6.760833, 52.56721],
                [6.729444, 52.616104],
                [6.72611, 52.62111],
                [6.718923000000132, 52.626785],
                [6.720833, 52.62944],
                [6.756666, 52.6491620000001],
                [6.76805, 52.65222],
                [6.78167, 52.654160000000104],
                [6.894722000000115, 52.653053],
                [6.902222, 52.651939],
                [6.905555000000106, 52.650551],
                [6.91305, 52.6449970000001],
                [6.916944, 52.640549000000135],
                [6.920278, 52.63888500000013],
                [7.025, 52.63250000000011],
                [7.030833, 52.63250000000011],
                [7.035832000000141, 52.632774],
                [7.043333000000132, 52.63499500000012],
                [7.048055, 52.63888500000013],
                [7.051666, 52.643608],
                [7.055277, 52.651939],
                [7.058888, 52.663887],
                [7.063611, 52.72138200000012],
                [7.065277, 52.75222],
                [7.064722, 52.76861],
                [7.065555, 52.78583],
                [7.066944, 52.799164],
                [7.069722, 52.814995],
                [7.076944, 52.82444],
                [7.091067000000123, 52.836906],
                [7.133055, 52.888885],
                [7.179722, 52.93416600000012],
                [7.19333, 52.95722],
                [7.197778, 52.965],
                [7.200277, 52.970551],
                [7.210278, 53.001938],
                [7.211666, 53.015831],
                [7.207222, 53.17610900000011],
                [7.208364, 53.242805],
                [7.245000000000118, 53.311386],
                [7.25, 53.315277],
                [7.256389, 53.31832900000012],
                [7.271944000000133, 53.319160000000124],
                [7.320000000000107, 53.317497],
                [7.329721, 53.316383],
                [7.336944, 53.31388900000013],
                [7.3425, 53.310272],
                [7.346389, 53.30555],
                [7.351944000000117, 53.3022160000001],
                [7.355277, 53.300827],
                [7.364444, 53.29916],
                [7.358611, 53.308609],
                [7.35111, 53.317497],
                [7.341666, 53.32222],
                [7.3325, 53.32388300000014],
                [7.226944, 53.336388],
                [7.183888, 53.3408280000001],
                [7.126389, 53.34],
                [7.0925, 53.338051],
                [7.073333, 53.336105],
                [7.058055, 53.337219],
                [7.05055, 53.339722],
                [7.04777700000011, 53.34166],
                [7.043333000000132, 53.34583],
                [7.024166, 53.364998],
                [7.019444, 53.372215],
                [7.016388, 53.380554],
                [7.0158330000001, 53.38361],
                [7.014444, 53.404999],
                [7.015555, 53.414719],
                [7.021944, 53.44249700000012],
                [7.031388, 53.47943900000013],
                [7.033333000000141, 53.485275],
                [7.088055000000111, 53.582771],
                [7.09611, 53.591942],
                [7.101944, 53.595276],
                [7.184722000000136, 53.64222],
                [7.226944, 53.664993],
                [7.23722, 53.669441],
                [7.29583, 53.685272],
                [7.34111, 53.688606],
                [7.450555, 53.687492],
                [7.4675, 53.686943],
                [7.4725, 53.686386],
                [7.484444, 53.68305],
                [7.508333000000107, 53.672493],
                [7.51861, 53.671661],
                [7.581666, 53.681389],
                [7.698333, 53.70027],
                [7.843333, 53.714165],
                [7.882500000000107, 53.7175],
                [7.9075, 53.719444000000124],
                [7.949166, 53.7175],
                [7.981667, 53.715271],
                [8.008333, 53.709999],
                [8.020277, 53.7066650000001],
                [8.026388, 53.70361],
                [8.028610000000128, 53.701385],
                [8.02972, 53.69861],
                [8.023888, 53.691666],
                [8.022499, 53.68888900000013],
                [8.021666, 53.685829],
                [8.022221, 53.676109],
                [8.024721, 53.67083],
                [8.04611, 53.636383],
                [8.058054, 53.626389],
                [8.123888, 53.584717000000126],
                [8.157221, 53.56472],
                [8.159443, 53.562492000000134],
                [8.162498, 53.5577770000001],
                [8.165833, 53.549721],
                [8.166666, 53.54333],
                [8.16833, 53.527222],
                [8.168055, 53.524437],
                [8.163332, 53.520554],
                [8.13528, 53.51138300000014],
                [8.12361, 53.50804900000014],
                [8.10305, 53.504166],
                [8.084444, 53.501938],
                [8.06333, 53.502777],
                [8.061388, 53.500549],
                [8.06167, 53.497498],
                [8.066111, 53.479996],
                [8.06972100000013, 53.472221000000104],
                [8.075832, 53.462494],
                [8.080276, 53.45805400000012],
                [8.097776, 53.44444],
                [8.204721, 53.404160000000104],
                [8.20861, 53.403053],
                [8.22305, 53.40083],
                [8.23444400000011, 53.40055100000012],
                [8.244165, 53.401382000000126],
                [8.248333, 53.402222],
                [8.281111, 53.416939],
                [8.28916, 53.422493000000145],
                [8.29278, 53.42722],
                [8.309721, 53.451385],
                [8.313055, 53.456383],
                [8.314999, 53.46611],
                [8.319721, 53.498886],
                [8.320555, 53.509163000000115],
                [8.319721, 53.515274],
                [8.314722, 53.522499],
                [8.308611, 53.525551],
                [8.303333, 53.526108],
                [8.293333, 53.52528],
                [8.272778, 53.520828],
                [8.263611, 53.519722],
                [8.237499, 53.518608],
                [8.233055, 53.51944],
                [8.231943000000115, 53.522217],
                [8.232222, 53.532219],
                [8.236944, 53.5577770000001],
                [8.243055, 53.586105],
                [8.26111, 53.60305],
                [8.272778, 53.60999],
                [8.283333, 53.613884],
                [8.306110000000103, 53.616943],
                [8.323055, 53.616943],
                [8.341389, 53.613609],
                [8.494444, 53.55499300000014],
                [8.51833, 53.513611],
                [8.508333000000107, 53.50555400000013],
                [8.503887, 53.50138900000013],
                [8.496387, 53.491943],
                [8.49111, 53.484444],
                [8.488333000000125, 53.479164],
                [8.485277, 53.470276000000126],
                [8.48278, 53.453888],
                [8.484165, 53.418327],
                [8.485277, 53.406105],
                [8.488609, 53.38166],
                [8.490833, 53.373055],
                [8.497776, 53.360275000000115],
                [8.503054, 53.354164],
                [8.506666, 53.36249500000014],
                [8.508055, 53.372498],
                [8.505833, 53.424995],
                [8.504999000000112, 53.434441],
                [8.49861, 53.450554],
                [8.496111, 53.462494],
                [8.498055, 53.471939],
                [8.501665000000116, 53.4805530000001],
                [8.506388, 53.488052],
                [8.511389, 53.492218],
                [8.560867, 53.515434],
                [8.565554, 53.521385],
                [8.56833300000011, 53.526939],
                [8.56833300000011, 53.53333],
                [8.567499, 53.53611],
                [8.55778, 53.550552],
                [8.511734000000104, 53.617218],
                [8.49472, 53.64194],
                [8.488333000000125, 53.651665],
                [8.485554, 53.66],
                [8.483055, 53.671944],
                [8.482222, 53.681107],
                [8.483332, 53.690277],
                [8.487778, 53.701942],
                [8.54805, 53.818329],
                [8.574444, 53.851387],
                [8.580276, 53.85860400000013],
                [8.60111, 53.87749],
                [8.604166, 53.87944],
                [8.611944, 53.88166],
                [8.6525, 53.891388],
                [8.66555, 53.893883],
                [8.680555, 53.894722],
                [8.683887, 53.89305100000013],
                [8.706388, 53.875832],
                [8.71139, 53.87167],
                [8.713055, 53.866104],
                [8.71472, 53.86388],
                [8.7280540000001, 53.85777300000012],
                [8.756388, 53.846664],
                [8.775555, 53.84055],
                [8.797222, 53.835831],
                [8.85305, 53.82972],
                [8.9075, 53.828049],
                [9.02055, 53.846664],
                [9.105276000000117, 53.863327],
                [9.128887, 53.866104],
                [9.213055, 53.864998],
                [9.218887, 53.8647160000001],
                [9.27611, 53.858887],
                [9.279999, 53.85777300000012],
                [9.283333, 53.856384000000105],
                [9.29416700000013, 53.849159],
                [9.32028, 53.83027600000014],
                [9.324444, 53.82611],
                [9.35139, 53.7980500000001],
                [9.379444, 53.760826],
                [9.408888, 53.730553],
                [9.415833, 53.724442000000124],
                [9.547777, 53.61055],
                [9.562222, 53.598328],
                [9.573055, 53.59111],
                [9.582777, 53.586105],
                [9.672777, 53.55555],
                [9.695833, 53.550278000000105],
                [9.764746, 53.543732],
                [9.802221, 53.534721],
                [9.811388, 53.533051],
                [9.821665, 53.53249],
                [9.826387000000125, 53.533051],
                [9.83, 53.53444],
                [9.832499, 53.536385],
                [9.833887, 53.53889],
                [9.833887, 53.542221],
                [9.830276, 53.54666],
                [9.82472, 53.550278000000105],
                [9.82083, 53.551666],
                [9.783888, 53.561386],
                [9.774166, 53.5627750000001],
                [9.741083, 53.565],
                [9.724165, 53.56555],
                [9.699444, 53.568329],
                [9.68194, 53.5719380000001],
                [9.66361, 53.578606],
                [9.57528, 53.613609],
                [9.56111, 53.621666],
                [9.54666, 53.6336060000001],
                [9.437777, 53.739441],
                [9.430555, 53.748604],
                [9.417221, 53.77111100000013],
                [9.407776, 53.792221],
                [9.394444, 53.821388],
                [9.393055, 53.823883],
                [9.337776, 53.852776],
                [9.327776, 53.857216],
                [9.286388, 53.874443],
                [9.27833, 53.876663],
                [9.234444, 53.88638300000014],
                [9.220833, 53.888885],
                [9.205276, 53.890549],
                [9.063055000000134, 53.898048],
                [8.993055, 53.89111],
                [8.983332000000132, 53.890274],
                [8.967222, 53.895],
                [8.9475, 53.907219],
                [8.9275, 53.919716],
                [8.913887, 53.92860400000012],
                [8.899721, 53.94082600000013],
                [8.883055, 53.961105],
                [8.849998, 54.008888],
                [8.837221, 54.02833],
                [8.836111, 54.031105],
                [8.840555, 54.03527100000014],
                [8.846666, 54.03860500000013],
                [8.85417, 54.041107],
                [8.86611, 54.044167],
                [8.880833, 54.04527300000012],
                [8.890554, 54.044167],
                [8.926666, 54.03722],
                [8.945555000000127, 54.030548],
                [8.960554, 54.022217],
                [8.971109, 54.01778],
                [8.97889, 54.018608],
                [9.000555, 54.026108000000136],
                [9.003054, 54.02805],
                [9.01111, 54.043884000000105],
                [9.012777000000142, 54.049995],
                [9.017221, 54.084999],
                [8.971109, 54.131660000000124],
                [8.85861, 54.123886],
                [8.8475, 54.13110400000011],
                [8.844721000000106, 54.133049],
                [8.829721, 54.148048],
                [8.824999, 54.155273],
                [8.812777, 54.174995],
                [8.816387, 54.189995],
                [8.823332, 54.207222],
                [8.841389000000106, 54.250549],
                [8.842777, 54.253326],
                [8.845276, 54.255272000000105],
                [8.85305, 54.2575],
                [8.88361, 54.294167],
                [8.83, 54.29333],
                [8.695555, 54.270271],
                [8.694166, 54.26777600000014],
                [8.691111, 54.26611],
                [8.679998000000126, 54.26611],
                [8.669443, 54.26694],
                [8.655554, 54.269440000000145],
                [8.643610000000137, 54.273048],
                [8.631666, 54.27916],
                [8.611944, 54.30138],
                [8.60722, 54.308609],
                [8.603054, 54.316383],
                [8.60028, 54.324715],
                [8.59916, 54.330551],
                [8.599443, 54.333885],
                [8.62194, 54.378609],
                [8.633888, 54.392776],
                [8.63889, 54.39666],
                [8.646111000000133, 54.3991620000001],
                [8.650833, 54.399719],
                [8.76861, 54.410828],
                [8.823332, 54.41555],
                [8.828054, 54.41472],
                [8.831388, 54.41305],
                [8.837776000000133, 54.40666],
                [8.840555, 54.404999],
                [8.845833, 54.404442],
                [8.85555, 54.405548],
                [8.886944, 54.414162],
                [8.99472, 54.451942000000145],
                [9.004999, 54.46027400000014],
                [9.015, 54.471939],
                [9.01639, 54.474716000000114],
                [9.019444, 54.49305],
                [9.016943, 54.498329],
                [9.005554, 54.508606],
                [8.967777, 54.541107000000125],
                [8.960278, 54.543610000000115],
                [8.946943, 54.54639],
                [8.940277, 54.549438],
                [8.921665, 54.559441],
                [8.916111, 54.562775],
                [8.850832, 54.620827],
                [8.814165, 54.668327],
                [8.804998, 54.685555000000136],
                [8.75444, 54.711662],
                [8.734444, 54.721107],
                [8.696943, 54.746941],
                [8.655554, 54.80082700000014],
                [8.648611, 54.810272],
                [8.645555000000115, 54.814995],
                [8.64222100000012, 54.826385],
                [8.640554, 54.838051],
                [8.573443, 54.850273],
                [8.57728, 54.861107],
                [8.58055, 54.867878],
                [8.545610000000124, 54.870605],
                [8.39011, 54.86694],
                [8.3025, 54.859993],
                [8.30055, 54.857498],
                [8.298054, 54.848328],
                [8.294443, 54.82527],
                [8.292221, 54.78944400000012],
                [8.29361, 54.783607],
                [8.299999, 54.773888],
                [8.30055, 54.76749400000011],
                [8.29861, 54.740273000000116],
                [8.29833200000013, 54.738884],
                [8.28833, 54.737495],
                [8.282221000000106, 54.744164],
                [8.281111, 54.746941],
                [8.280554, 54.752777],
                [8.280554, 54.774994],
                [8.281387, 54.81805],
                [8.282776, 54.83527400000014],
                [8.291111, 54.894722],
                [8.295555, 54.906387],
                [8.30361, 54.926384],
                [8.310833000000116, 54.93972],
                [8.373333, 55.033333],
                [8.383055000000127, 55.04527300000012],
                [8.3933320000001, 55.053055],
                [8.405, 55.056664],
                [8.41111, 55.056389],
                [8.447222000000124, 55.053055],
                [8.459444000000133, 55.049721],
                [8.46305500000011, 55.04805],
                [8.438332, 55.024162],
                [8.421665000000132, 55.013054],
                [8.41028, 55.00944],
                [8.40111, 55.008049],
                [8.397499, 55.00666],
                [8.371944, 54.994164000000126],
                [8.35389, 54.973053],
                [8.3522210000001, 54.966942],
                [8.352777000000117, 54.95138500000013],
                [8.41663, 54.926727],
                [8.41846, 54.9179],
                [8.421297, 54.91356],
                [8.426464, 54.91022900000013],
                [8.430631, 54.908562],
                [8.456798, 54.900558],
                [8.465631, 54.899391],
                [8.490464, 54.900558],
                [8.598331, 54.9059],
                [8.602464, 54.91356],
                [8.602797000000123, 54.917725],
                [8.66454, 54.913094],
                [8.68611, 54.898888],
                [8.699444, 54.892776],
                [8.719444, 54.891106],
                [8.754721000000131, 54.897217],
                [8.763054, 54.898888],
                [8.785831, 54.9061],
                [8.82889, 54.9138870000001],
                [8.8413010000001, 54.913689],
                [8.919998000000135, 54.908051],
                [8.94111, 54.905548],
                [9.168888, 54.86499800000013],
                [9.22416, 54.853607],
                [9.23361, 54.845551000000114],
                [9.22805, 54.83416],
                [9.23361, 54.82444],
                [9.243055, 54.816383],
                [9.253611, 54.80888],
                [9.342777, 54.808609000000104],
                [9.358889, 54.812492],
                [9.36861, 54.820831],
                [9.368889, 54.82278],
                [9.378611, 54.82972000000012],
                [9.3925, 54.83527400000014],
                [9.414721, 54.833328],
                [9.445358, 54.825401],
                [9.441944, 54.819717],
                [9.437498, 54.80778],
                [9.43916, 54.80222],
                [9.5783330000001, 54.825554],
                [9.660555, 54.812218],
                [9.78555, 54.78611],
                [9.88972, 54.788887],
                [9.89639, 54.79166],
                [9.905832, 54.79277],
                [9.916666, 54.791107],
                [9.935833, 54.781944],
                [9.96194, 54.76861],
                [9.97278, 54.761108],
                [9.976665, 54.75666],
                [10.036943, 54.67115],
                [10.037777, 54.665321],
                [10.039999, 54.633072],
                [10.0325, 54.555275],
                [10.01083, 54.52888],
                [10.00639, 54.524719],
                [10.000323, 54.520866000000126],
                [9.970554, 54.5075],
                [9.89305, 54.481941],
                [9.871111, 54.477493],
                [9.849998, 54.479164],
                [9.845276, 54.478607],
                [9.843332, 54.476105],
                [9.843611, 54.473053],
                [9.85194, 54.464439],
                [9.863609, 54.457497],
                [9.870277, 54.45444],
                [9.878332, 54.452774],
                [9.89333, 54.453888],
                [10.006666, 54.474236],
                [10.101387, 54.48888],
                [10.110832, 54.48999800000013],
                [10.126944, 54.489716],
                [10.368332000000123, 54.43555],
                [10.60972, 54.3605500000001],
                [10.633055, 54.349998],
                [10.638887000000125, 54.34666],
                [10.643055, 54.34222],
                [10.646111, 54.337219],
                [10.652222, 54.330826000000116],
                [10.679165, 54.312492000000134],
                [10.685833, 54.309441000000106],
                [10.690554, 54.30832700000013],
                [10.706665, 54.30694],
                [10.765, 54.306664],
                [10.78, 54.3077770000001],
                [10.78777700000012, 54.309715],
                [10.802221, 54.314995000000124],
                [10.82111, 54.323608],
                [10.827499000000103, 54.326942],
                [10.835833, 54.332222000000115],
                [10.843054, 54.338608],
                [10.88528, 54.361938],
                [10.936666, 54.38361],
                [10.945833, 54.38499500000012],
                [10.95167, 54.38472000000013],
                [10.979443, 54.380554],
              ],
            ],
          ],
        },
        id: 5,
        NAME: 'Germany',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Bulgaria',
          id: 6,
          label: 'Bulgaria',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.281,
          year: '2023',
          centroid: [25.4858, 42.7339],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [27.879166, 42.841103],
              [27.894997, 42.802498],
              [27.898605, 42.785271],
              [27.899441, 42.774155],
              [27.898331, 42.707222],
              [27.896938, 42.702766],
              [27.893055, 42.701111],
              [27.888054, 42.701111],
              [27.80555, 42.708054],
              [27.777493, 42.713051],
              [27.766388, 42.714165],
              [27.736938, 42.712494],
              [27.728886, 42.709717],
              [27.6325, 42.631653],
              [27.514996, 42.556389],
              [27.506386, 42.54805],
              [27.495831, 42.535828],
              [27.450554, 42.48082],
              [27.448605, 42.476944],
              [27.44833, 42.469994],
              [27.450829, 42.464165],
              [27.464993, 42.449432],
              [27.50555, 42.431107],
              [27.51083, 42.431107],
              [27.514164, 42.433327],
              [27.530273, 42.445],
              [27.553883, 42.448875],
              [27.616665, 42.44722],
              [27.679165, 42.41832],
              [27.704163, 42.399994],
              [27.700272, 42.398331],
              [27.698051, 42.394997],
              [27.698887, 42.387772],
              [27.703888, 42.368889],
              [27.750832, 42.262497],
              [27.759995, 42.246101],
              [27.780552, 42.227219],
              [27.85722, 42.164162],
              [27.899162, 42.133606],
              [27.938889, 42.103043],
              [27.968609, 42.072495],
              [27.996941, 42.0411],
              [28.004166, 42.033051],
              [28.022221, 41.998055],
              [28.021381, 41.990273],
              [28.013054, 41.982216],
              [27.971104, 41.984154],
              [27.903606, 41.994713],
              [27.869717, 42.005547],
              [27.864441, 42.005547],
              [27.834721, 42.001938],
              [27.830273, 42.001389],
              [27.70583, 41.977486],
              [27.638054, 41.958321],
              [27.628609, 41.953331],
              [27.595551, 41.935555],
              [27.581661, 41.913048],
              [27.580555, 41.909431],
              [27.576664, 41.907776],
              [27.57222, 41.907219],
              [27.566666, 41.907776],
              [27.556107, 41.910553],
              [27.441109, 41.976944],
              [27.413052, 41.993607],
              [27.41, 41.995827],
              [27.394997, 42.008041],
              [27.391937, 42.010544],
              [27.373055, 42.039986],
              [27.365555, 42.059166],
              [27.364162, 42.062218],
              [27.361664, 42.064995],
              [27.313332, 42.089432],
              [27.304993, 42.093323],
              [27.292217, 42.098885],
              [27.287777, 42.100548],
              [27.282494, 42.102219],
              [27.233051, 42.109993],
              [27.070271, 42.089989],
              [27.043053, 42.085831],
              [27.031384, 42.081383],
              [26.962221, 42.003323],
              [26.935555, 42.006943],
              [26.93055, 42.006943],
              [26.621384, 41.973053],
              [26.572777, 41.939438],
              [26.568083, 41.935966],
              [26.566383, 41.934708],
              [26.560593, 41.928925],
              [26.575294, 41.898643],
              [26.565826, 41.871384],
              [26.558331, 41.851662],
              [26.547218, 41.83416],
              [26.544994, 41.830826],
              [26.542217, 41.828049],
              [26.538052, 41.826935],
              [26.528332, 41.826111],
              [26.477776, 41.824158],
              [26.467773, 41.824158],
              [26.446663, 41.824997],
              [26.391388, 41.823875],
              [26.38166, 41.823044],
              [26.377499, 41.821938],
              [26.374722, 41.819153],
              [26.350277, 41.79332],
              [26.345551, 41.786652],
              [26.339993, 41.774712],
              [26.332771, 41.753052],
              [26.331944, 41.748878],
              [26.332222, 41.741379],
              [26.333611, 41.738319],
              [26.342773, 41.727486],
              [26.350262, 41.719997],
              [26.355827, 41.714432],
              [26.361095, 41.711052],
              [26.309715, 41.707764],
              [26.294167, 41.708054],
              [26.277222, 41.709991],
              [26.264996, 41.715828],
              [26.236961, 41.737267],
              [26.234772, 41.740028],
              [26.222759, 41.7435],
              [26.177498, 41.748055],
              [26.171944, 41.748322],
              [26.163052, 41.746666],
              [26.138611, 41.739159],
              [26.08083, 41.71666],
              [26.074444, 41.711937],
              [26.066109, 41.697495],
              [26.065826, 41.685822],
              [26.068604, 41.660271],
              [26.099159, 41.628876],
              [26.10305, 41.627213],
              [26.117493, 41.628609],
              [26.129719, 41.63221],
              [26.13472, 41.63221],
              [26.137215, 41.629433],
              [26.181664, 41.54332],
              [26.183884, 41.536942],
              [26.198051, 41.439438],
              [26.139996, 41.354713],
              [25.987778, 41.321106],
              [25.97916, 41.319443],
              [25.905552, 41.311104],
              [25.886662, 41.309166],
              [25.881104, 41.309708],
              [25.814159, 41.336098],
              [25.653049, 41.317772],
              [25.567776, 41.32222],
              [25.559441, 41.32],
              [25.549995, 41.313042],
              [25.503609, 41.289444],
              [25.344994, 41.250542],
              [25.335831, 41.249161],
              [25.285, 41.24305],
              [25.279716, 41.24305],
              [25.243889, 41.252769],
              [25.239441, 41.254433],
              [25.190826, 41.301453],
              [25.185833, 41.305275],
              [25.163052, 41.31749],
              [25.061192, 41.362572],
              [25.036507, 41.370438],
              [24.903889, 41.411942],
              [24.898888, 41.411942],
              [24.819443, 41.404999],
              [24.817497, 41.402496],
              [24.812496, 41.378326],
              [24.809444, 41.352219],
              [24.767776, 41.370552],
              [24.612499, 41.430275],
              [24.608887, 41.43222],
              [24.603333, 41.437492],
              [24.567497, 41.489441],
              [24.564442, 41.503326],
              [24.46611, 41.551941],
              [24.307777, 41.546387],
              [24.304722, 41.548607],
              [24.269444, 41.57],
              [24.263885, 41.570549],
              [24.253887, 41.57],
              [24.245552, 41.567772],
              [24.215275, 41.554993],
              [24.199993, 41.543785],
              [24.157219, 41.541107],
              [24.101665, 41.550827],
              [24.0975, 41.551109],
              [24.09333, 41.549995],
              [24.080276, 41.541107],
              [24.064999, 41.524437],
              [24.063053, 41.520828],
              [24.063053, 41.51722],
              [24.066387, 41.485275],
              [23.978886, 41.441109],
              [23.974442, 41.440552],
              [23.886387, 41.451942],
              [23.796387, 41.436661],
              [23.738331, 41.408607],
              [23.63583, 41.378052],
              [23.631107, 41.377495],
              [23.598053, 41.380829],
              [23.551109, 41.391663],
              [23.538887, 41.397217],
              [23.440552, 41.409439],
              [23.29472, 41.406105],
              [23.285275, 41.404716],
              [23.273888, 41.399719],
              [23.231388, 41.377495],
              [23.228333, 41.374992],
              [23.226387, 41.366943],
              [23.230274, 41.353333],
              [23.229443, 41.349716],
              [23.227219, 41.346382],
              [23.214722, 41.336937],
              [23.201111, 41.329163],
              [23.189442, 41.324715],
              [23.180832, 41.322777],
              [23.119999, 41.320831],
              [23.094444, 41.320549],
              [22.975555, 41.335548],
              [22.935604, 41.342125],
              [22.942497, 41.344719],
              [22.955555, 41.35305],
              [22.960831, 41.358604],
              [22.964722, 41.366104],
              [22.966663, 41.374161],
              [22.959164, 41.476387],
              [22.951664, 41.59861],
              [22.951664, 41.626106],
              [22.952499, 41.634438],
              [22.956387, 41.641663],
              [22.986942, 41.665833],
              [23.011387, 41.690826],
              [23.018608, 41.699997],
              [23.02972, 41.71666],
              [23.031387, 41.720551],
              [23.032776, 41.728333],
              [23.029999, 41.734718],
              [23.014721, 41.762215],
              [23.012775, 41.765274],
              [23.00972, 41.767494],
              [22.999722, 41.770271],
              [22.972221, 41.771942],
              [22.967499, 41.773605],
              [22.961941, 41.77861],
              [22.942497, 41.807777],
              [22.899441, 41.879166],
              [22.895832, 41.885277],
              [22.878052, 41.934715],
              [22.875832, 41.941666],
              [22.828609, 42.026939],
              [22.817497, 42.027771],
              [22.685833, 42.065277],
              [22.609444, 42.103333],
              [22.521111, 42.148605],
              [22.517776, 42.150833],
              [22.407776, 42.279442],
              [22.365276, 42.323883],
              [22.410831, 42.335274],
              [22.459442, 42.363052],
              [22.519444, 42.399162],
              [22.522221, 42.402222],
              [22.536388, 42.423332],
              [22.538055, 42.427498],
              [22.558052, 42.479164],
              [22.558887, 42.487495],
              [22.549442, 42.510277],
              [22.544441, 42.515549],
              [22.522499, 42.531105],
              [22.472221, 42.564995],
              [22.464165, 42.568886],
              [22.44722, 42.599442],
              [22.440277, 42.81472],
              [22.44083, 42.818604],
              [22.442219, 42.821663],
              [22.44833, 42.82666],
              [22.514164, 42.873055],
              [22.520832, 42.87722],
              [22.524998, 42.878609],
              [22.585831, 42.892776],
              [22.603886, 42.896111],
              [22.614998, 42.894722],
              [22.654999, 42.884995],
              [22.66222, 42.880829],
              [22.73333, 42.889717],
              [22.741943, 42.891663],
              [22.745552, 42.893608],
              [22.966389, 43.101662],
              [22.990555, 43.133049],
              [22.99361, 43.141663],
              [23.004997, 43.192772],
              [22.940552, 43.210548],
              [22.907497, 43.228607],
              [22.904442, 43.230827],
              [22.84972, 43.282219],
              [22.847221, 43.284996],
              [22.845554, 43.288055],
              [22.845276, 43.291664],
              [22.834999, 43.325829],
              [22.833054, 43.328888],
              [22.824997, 43.336388],
              [22.766666, 43.385826],
              [22.761944, 43.387497],
              [22.724163, 43.399994],
              [22.718609, 43.401382],
              [22.669167, 43.415833],
              [22.628052, 43.430832],
              [22.550552, 43.46833],
              [22.543331, 43.472496],
              [22.536388, 43.480827],
              [22.414165, 43.709442],
              [22.406666, 43.725555],
              [22.367222, 43.826942],
              [22.416943, 44.006943],
              [22.420277, 44.009438],
              [22.536942, 44.057777],
              [22.552776, 44.063889],
              [22.614719, 44.117493],
              [22.614998, 44.121666],
              [22.619164, 44.169998],
              [22.650276, 44.211937],
              [22.653332, 44.214439],
              [22.676388, 44.224716],
              [22.681435, 44.224701],
              [22.686386, 44.218887],
              [22.696941, 44.212219],
              [22.907497, 44.113609],
              [22.921665, 44.108604],
              [22.945274, 44.104439],
              [22.951385, 44.103607],
              [22.997444, 44.100632],
              [23.003609, 44.099442],
              [23.021942, 44.092773],
              [23.03722, 44.084442],
              [23.044167, 44.076111],
              [23.046108, 44.06916],
              [23.044441, 44.060555],
              [23.042774, 44.056664],
              [23.032497, 44.044716],
              [23.003407, 44.017799],
              [22.995831, 44.01416],
              [22.987499, 44.011665],
              [22.98222, 44.011383],
              [22.959431, 44.012276],
              [22.919857, 44.002838],
              [22.906944, 43.998886],
              [22.88472, 43.988052],
              [22.879719, 43.981667],
              [22.843243, 43.90506],
              [22.840687, 43.888283],
              [22.847618, 43.86821],
              [22.857471, 43.853256],
              [22.863331, 43.848328],
              [22.875275, 43.842499],
              [22.894444, 43.836105],
              [22.966942, 43.81694],
              [23.063602, 43.802177],
              [23.071457, 43.802177],
              [23.138885, 43.808327],
              [23.147499, 43.811104],
              [23.162109, 43.81823],
              [23.198608, 43.831383],
              [23.224499, 43.838661],
              [23.255142, 43.846321],
              [23.269009, 43.849243],
              [23.283607, 43.85083],
              [23.418224, 43.856171],
              [23.427147, 43.855232],
              [23.446663, 43.851105],
              [23.50703, 43.83773],
              [23.516003, 43.835381],
              [23.528042, 43.825523],
              [23.539352, 43.819328],
              [23.570274, 43.806938],
              [23.601665, 43.798607],
              [23.612499, 43.796104],
              [23.629719, 43.794998],
              [23.774166, 43.78833],
              [23.987499, 43.744164],
              [24.067982, 43.720627],
              [24.116077, 43.699913],
              [24.155617, 43.689911],
              [24.179996, 43.684715],
              [24.185833, 43.684441],
              [24.195553, 43.685272],
              [24.224163, 43.689438],
              [24.257221, 43.694443],
              [24.286388, 43.697495],
              [24.307777, 43.697495],
              [24.319706, 43.696632],
              [24.343052, 43.69416],
              [24.352497, 43.695549],
              [24.360832, 43.698051],
              [24.364719, 43.699715],
              [24.405277, 43.719719],
              [24.43861, 43.736382],
              [24.457775, 43.74472],
              [24.497219, 43.760277],
              [24.506386, 43.762215],
              [24.52861, 43.761108],
              [24.562496, 43.759163],
              [24.598331, 43.753883],
              [24.613331, 43.749161],
              [24.686932, 43.718384],
              [24.705555, 43.715271],
              [24.722775, 43.714165],
              [24.79361, 43.712776],
              [24.881386, 43.712219],
              [25.022751, 43.71019],
              [25.224716, 43.687485],
              [25.261944, 43.678055],
              [25.275272, 43.672493],
              [25.314442, 43.652222],
              [25.339439, 43.636932],
              [25.348885, 43.62999],
              [25.363049, 43.624718],
              [25.375275, 43.622765],
              [25.380711, 43.622437],
              [25.396111, 43.623322],
              [25.416111, 43.624718],
              [25.430229, 43.626778],
              [25.440952, 43.630112],
              [25.463852, 43.639206],
              [25.53194, 43.6436],
              [25.609161, 43.662209],
              [25.681339, 43.69043],
              [25.731377, 43.694077],
              [25.739246, 43.695122],
              [25.760551, 43.701111],
              [25.772495, 43.705544],
              [25.786942, 43.713051],
              [25.878262, 43.778824],
              [25.8825, 43.792213],
              [25.887238, 43.799103],
              [25.89027, 43.801941],
              [25.938049, 43.844719],
              [25.947495, 43.852219],
              [26.085278, 43.949715],
              [26.111664, 43.968323],
              [26.128609, 43.979156],
              [26.144161, 43.986382],
              [26.301941, 44.030823],
              [26.381943, 44.04332],
              [26.391388, 44.044434],
              [26.413036, 44.043129],
              [26.438416, 44.041306],
              [26.478611, 44.049431],
              [26.671104, 44.071938],
              [26.79472, 44.095276],
              [26.840832, 44.115555],
              [26.890205, 44.131989],
              [26.913403, 44.136124],
              [27.036427, 44.147339],
              [27.111111, 44.140831],
              [27.165833, 44.12999],
              [27.187492, 44.124435],
              [27.199715, 44.122208],
              [27.222775, 44.119987],
              [27.237778, 44.121666],
              [27.250549, 44.124985],
              [27.272713, 44.132149],
              [27.278889, 44.105553],
              [27.279716, 44.102219],
              [27.29055, 44.088051],
              [27.299995, 44.080544],
              [27.396111, 44.024155],
              [27.399998, 44.021935],
              [27.416943, 44.020554],
              [27.475826, 44.01944],
              [27.614162, 44.023598],
              [27.623333, 44.025269],
              [27.629719, 44.030266],
              [27.631943, 44.0336],
              [27.64222, 44.040276],
              [27.650555, 44.043053],
              [27.656109, 44.042496],
              [27.660828, 44.040833],
              [27.673882, 44.035271],
              [27.676941, 44.032776],
              [27.67944, 44.029999],
              [27.684715, 44.020821],
              [27.698353, 43.993607],
              [27.706944, 43.977219],
              [27.711662, 43.971657],
              [27.717773, 43.966942],
              [27.730827, 43.961098],
              [27.736382, 43.959717],
              [27.747215, 43.95916],
              [27.806107, 43.964165],
              [27.820271, 43.965828],
              [27.833328, 43.969162],
              [27.852776, 43.977486],
              [27.86805, 43.984154],
              [27.914444, 44.004433],
              [27.918884, 44.005547],
              [27.927773, 44.002769],
              [27.944717, 43.987221],
              [27.951664, 43.978882],
              [27.95472, 43.972771],
              [27.957771, 43.958878],
              [27.958328, 43.951653],
              [27.962215, 43.938332],
              [27.991108, 43.871666],
              [27.997215, 43.859154],
              [28.001942, 43.8536],
              [28.029716, 43.839165],
              [28.047218, 43.831657],
              [28.133053, 43.801659],
              [28.181942, 43.785271],
              [28.235554, 43.769997],
              [28.257771, 43.764435],
              [28.403889, 43.750275],
              [28.484997, 43.744164],
              [28.583244, 43.747765],
              [28.576382, 43.733047],
              [28.57, 43.689713],
              [28.572777, 43.600822],
              [28.57333, 43.597488],
              [28.578606, 43.588326],
              [28.585548, 43.579987],
              [28.593884, 43.57222],
              [28.598328, 43.566666],
              [28.603611, 43.557487],
              [28.605827, 43.551102],
              [28.606384, 43.543877],
              [28.606384, 43.536385],
              [28.605553, 43.532219],
              [28.602219, 43.523331],
              [28.596661, 43.511101],
              [28.588329, 43.495544],
              [28.561382, 43.458321],
              [28.553883, 43.448318],
              [28.54166, 43.437775],
              [28.525555, 43.425819],
              [28.479443, 43.393326],
              [28.453331, 43.385277],
              [28.431389, 43.389435],
              [28.412216, 43.396378],
              [28.404716, 43.400551],
              [28.394722, 43.407776],
              [28.381943, 43.413322],
              [28.376659, 43.414986],
              [28.34166, 43.421097],
              [28.330273, 43.422211],
              [28.299721, 43.421654],
              [28.152493, 43.404999],
              [28.148331, 43.403885],
              [28.1325, 43.398041],
              [28.121941, 43.39193],
              [28.093327, 43.369713],
              [28.085548, 43.360268],
              [28.080273, 43.349152],
              [28.071663, 43.322777],
              [28.055275, 43.284714],
              [28.051388, 43.276932],
              [28.015831, 43.225822],
              [27.945, 43.167213],
              [27.888882, 43.041382],
              [27.88583, 43.032494],
              [27.886387, 43.014153],
              [27.896381, 42.924988],
              [27.903606, 42.894722],
              [27.90416, 42.887497],
              [27.901665, 42.855553],
              [27.879166, 42.841103],
            ],
          ],
        },
        id: 6,
        NAME: 'Bulgaria',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Netherlands',
          id: 7,
          label: 'Netherlands',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.263,
          year: '2023',
          centroid: [5.2913, 52.1326],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [3.76417, 51.345276],
                [3.861944, 51.339165],
                [3.86722200000014, 51.339996],
                [3.961389000000111, 51.36972],
                [4.198055, 51.374443],
                [4.205277, 51.37389],
                [4.210833, 51.372498],
                [4.215, 51.3702770000001],
                [4.2175, 51.36833200000012],
                [4.23889800000012, 51.350426],
                [4.228333000000134, 51.340553000000114],
                [4.215, 51.33027600000014],
                [4.17305, 51.300552],
                [4.161388000000102, 51.29416700000013],
                [4.127777, 51.278885],
                [4.062222, 51.25222],
                [3.9525, 51.214439],
                [3.903611, 51.205826000000116],
                [3.8975, 51.205276],
                [3.890277, 51.205826000000116],
                [3.806389000000138, 51.216942],
                [3.796111, 51.220276],
                [3.793889, 51.22305300000011],
                [3.79083, 51.233055],
                [3.79083, 51.23722],
                [3.79639, 51.259438],
                [3.793056, 51.26194],
                [3.782777, 51.2649990000001],
                [3.669167, 51.29277],
                [3.608055, 51.304161000000136],
                [3.600833, 51.304718],
                [3.595555, 51.303886],
                [3.524722, 51.28833],
                [3.52111, 51.285828],
                [3.52028, 51.281387],
                [3.520833, 51.277496],
                [3.5225, 51.2741620000001],
                [3.524444, 51.263054000000125],
                [3.524167, 51.25055],
                [3.520833, 51.248055],
                [3.483611, 51.243332],
                [3.465833, 51.241943],
                [3.45194400000014, 51.242493],
                [3.439167, 51.244438],
                [3.434166, 51.246109],
                [3.388324, 51.26867700000014],
                [3.380833, 51.273605],
                [3.379444, 51.276939],
                [3.373611, 51.309998],
                [3.37087, 51.3738560000001],
                [3.40667, 51.385551],
                [3.519444, 51.411385],
                [3.538333000000137, 51.411942000000124],
                [3.550278000000105, 51.409721],
                [3.639722, 51.381660000000124],
                [3.72139, 51.35583],
                [3.735000000000127, 51.35],
                [3.740555, 51.34861],
                [3.76417, 51.345276],
              ],
            ],
            [
              [
                [5.763888, 52.415276],
                [5.754167, 52.412498],
                [5.720833, 52.41305],
                [5.693889, 52.408051],
                [5.638888000000122, 52.388611],
                [5.62444, 52.379715],
                [5.611944000000108, 52.36972],
                [5.57778, 52.369438000000116],
                [5.573055, 52.36805],
                [5.565000000000111, 52.36360900000011],
                [5.546111, 52.351944],
                [5.544999, 52.347496],
                [5.545555, 52.343887],
                [5.559166, 52.325829],
                [5.559722, 52.32222],
                [5.53889, 52.290276],
                [5.534166, 52.283333],
                [5.529722000000106, 52.28138700000011],
                [5.516944000000137, 52.27805],
                [5.428611, 52.26416000000012],
                [5.415833, 52.26416000000012],
                [5.404444000000126, 52.266937],
                [5.3975, 52.271942],
                [5.369721, 52.287498],
                [5.357778, 52.294167],
                [5.330555, 52.30917],
                [5.305555, 52.317772],
                [5.27861, 52.325829],
                [5.24861, 52.3325],
                [5.21194400000013, 52.34],
                [5.192778, 52.339439],
                [5.187222, 52.338608],
                [5.1775, 52.335548],
                [5.165833000000134, 52.334442],
                [5.160832, 52.335274],
                [5.156111, 52.33721900000012],
                [5.151944, 52.339439],
                [5.145833, 52.344719],
                [5.141944000000137, 52.35083],
                [5.135555000000124, 52.380272],
                [5.137777000000142, 52.382774],
                [5.168192, 52.393799000000115],
                [5.181110000000103, 52.405548],
                [5.203055, 52.414719],
                [5.296389, 52.45166000000012],
                [5.381944, 52.484444],
                [5.41309600000011, 52.49332],
                [5.45117, 52.509445],
                [5.454558, 52.524216],
                [5.456944, 52.5283280000001],
                [5.47805, 52.548882],
                [5.573333, 52.588333],
                [5.643611, 52.601105],
                [5.827222, 52.570549],
                [5.831388000000118, 52.56832900000012],
                [5.839444, 52.561104],
                [5.85556, 52.544167],
                [5.861388, 52.534996],
                [5.862928, 52.522232],
                [5.85556, 52.492493],
                [5.8475, 52.482498],
                [5.831111, 52.46333],
                [5.798333, 52.43055],
                [5.795278, 52.427498],
                [5.786666000000139, 52.423607],
                [5.763888, 52.415276],
              ],
            ],
            [
              [
                [5.423333, 52.636383],
                [5.44861, 52.61555],
                [5.457222, 52.60721600000011],
                [5.477221, 52.58416],
                [5.485555, 52.572777],
                [5.486111, 52.568886],
                [5.48527700000011, 52.565277],
                [5.46455, 52.560211],
                [5.447742, 52.53826],
                [5.447398, 52.51305],
                [5.439482, 52.50839600000012],
                [5.42691, 52.501411],
                [5.409215, 52.495358000000124],
                [5.377765, 52.4885220000001],
                [5.304445000000101, 52.457642],
                [5.190362, 52.41527],
                [5.180584000000124, 52.409214000000134],
                [5.174065, 52.404556],
                [5.168076, 52.397217000000126],
                [5.15777, 52.392914],
                [5.134019, 52.383137],
                [5.067196, 52.38626],
                [5.059339, 52.38877100000013],
                [5.054624, 52.39128],
                [5.051795, 52.394115],
                [5.050538, 52.39663],
                [5.052738, 52.400715],
                [5.08313, 52.415245],
                [5.093333, 52.436104],
                [5.095555, 52.436386],
                [5.10305, 52.44138],
                [5.105833000000132, 52.444443],
                [5.111388, 52.469994],
                [5.111666, 52.474159],
                [5.10743, 52.48853300000013],
                [5.104218, 52.497684],
                [5.100493, 52.50513500000011],
                [5.07162, 52.547043000000144],
                [5.048341000000107, 52.566135],
                [5.045547, 52.57265500000011],
                [5.03576900000013, 52.605247],
                [5.033441, 52.613167],
                [5.032509, 52.619217000000106],
                [5.033441, 52.6262],
                [5.03949, 52.633652],
                [5.046944, 52.636913],
                [5.05486, 52.638309],
                [5.101424, 52.63784],
                [5.1126000000001, 52.63226],
                [5.120516000000123, 52.6262],
                [5.126569, 52.619682],
                [5.13588, 52.61596],
                [5.142401, 52.61596],
                [5.149386, 52.616890000000126],
                [5.16382, 52.620617],
                [5.201072000000124, 52.633186],
                [5.22575, 52.642967],
                [5.23972, 52.650883],
                [5.247637, 52.656471],
                [5.25275900000014, 52.662056],
                [5.256949, 52.669041],
                [5.259278, 52.67696],
                [5.260675, 52.68301],
                [5.296389, 52.69111],
                [5.302221, 52.690552],
                [5.33, 52.68278],
                [5.378333000000111, 52.668327],
                [5.382222, 52.666107],
                [5.423333, 52.636383],
              ],
            ],
            [
              [
                [4.76472200000012, 52.990273000000116],
                [4.753611, 52.988609],
                [4.73861, 52.98972],
                [4.727777, 52.99305],
                [4.720555, 52.997772],
                [4.71583, 53.00388],
                [4.708333, 53.020554],
                [4.70667, 53.035828],
                [4.70805, 53.044441],
                [4.713888, 53.056107],
                [4.721666000000141, 53.06611],
                [4.743333, 53.0861],
                [4.853333, 53.18138900000014],
                [4.859722, 53.185829],
                [4.868889, 53.18833],
                [4.879167000000109, 53.186386],
                [4.883333, 53.184166],
                [4.885833000000105, 53.181664],
                [4.912222, 53.141937],
                [4.912222, 53.09861],
                [4.90889, 53.090553000000114],
                [4.90333, 53.08416],
                [4.876666000000114, 53.056938],
                [4.858611, 53.039162],
                [4.804722, 53.006943],
                [4.787499000000139, 52.998886],
                [4.76472200000012, 52.990273000000116],
              ],
            ],
            [
              [
                [4.957222000000115, 53.237778],
                [4.889722, 53.210831],
                [4.883055, 53.21194],
                [4.879999, 53.214439],
                [4.88111, 53.21916],
                [4.883333, 53.2225],
                [4.893055, 53.230827],
                [4.912222, 53.242493],
                [4.964722, 53.270828],
                [4.989444, 53.283333],
                [5.002222, 53.289162],
                [5.011666, 53.292496],
                [5.05472200000014, 53.304718],
                [5.07944, 53.310829],
                [5.09389, 53.309998],
                [5.099722, 53.308609],
                [5.104722, 53.306664],
                [5.106388, 53.30333],
                [5.103889, 53.29999],
                [4.957222000000115, 53.237778],
              ],
            ],
            [
              [
                [5.213055, 53.34999800000014],
                [5.20055, 53.349442000000124],
                [5.186666000000116, 53.349716],
                [5.174999, 53.35249],
                [5.16861, 53.357773],
                [5.16722, 53.361107],
                [5.166666000000134, 53.364998],
                [5.16889, 53.373886],
                [5.171111, 53.377495],
                [5.179999, 53.38110400000011],
                [5.218055, 53.39388300000013],
                [5.22805, 53.39666],
                [5.53972, 53.44944],
                [5.556666000000121, 53.451942000000145],
                [5.574721, 53.452774],
                [5.579721, 53.450829],
                [5.58194, 53.44778],
                [5.579721, 53.44249700000012],
                [5.577499000000103, 53.43916300000012],
                [5.574166, 53.436104000000114],
                [5.570555, 53.433609000000104],
                [5.56111, 53.43027500000011],
                [5.35333, 53.38110400000011],
                [5.311388, 53.371666],
                [5.213055, 53.34999800000014],
              ],
            ],
            [
              [
                [6.871666, 53.416107],
                [6.901667, 53.35027300000013],
                [6.939722, 53.324715],
                [6.945277, 53.321388],
                [7.078333, 53.26111],
                [7.088611000000128, 53.25694],
                [7.10111, 53.253883],
                [7.190277, 53.240273],
                [7.201111, 53.23972],
                [7.205277, 53.240829],
                [7.208364, 53.242805],
                [7.207222, 53.17610900000011],
                [7.211666, 53.015831],
                [7.210278, 53.001938],
                [7.200277, 52.970551],
                [7.197778, 52.965],
                [7.19333, 52.95722],
                [7.179722, 52.93416600000012],
                [7.133055, 52.888885],
                [7.091067000000123, 52.836906],
                [7.076944, 52.82444],
                [7.069722, 52.814995],
                [7.066944, 52.799164],
                [7.065555, 52.78583],
                [7.064722, 52.76861],
                [7.065277, 52.75222],
                [7.063611, 52.72138200000012],
                [7.058888, 52.663887],
                [7.055277, 52.651939],
                [7.051666, 52.643608],
                [7.048055, 52.63888500000013],
                [7.043333000000132, 52.63499500000012],
                [7.035832000000141, 52.632774],
                [7.030833, 52.63250000000011],
                [7.025, 52.63250000000011],
                [6.920278, 52.63888500000013],
                [6.916944, 52.640549000000135],
                [6.91305, 52.6449970000001],
                [6.905555000000106, 52.650551],
                [6.902222, 52.651939],
                [6.894722000000115, 52.653053],
                [6.78167, 52.654160000000104],
                [6.76805, 52.65222],
                [6.756666, 52.6491620000001],
                [6.720833, 52.62944],
                [6.718923000000132, 52.626785],
                [6.72611, 52.62111],
                [6.729444, 52.616104],
                [6.760833, 52.56721],
                [6.75944, 52.56472],
                [6.75611, 52.563332],
                [6.7225, 52.559441000000106],
                [6.690277, 52.551941],
                [6.688889, 52.54916400000013],
                [6.7025, 52.490555],
                [6.705555, 52.485832],
                [6.753333000000111, 52.462776],
                [6.76444400000014, 52.45916],
                [6.94611, 52.434441],
                [6.950833, 52.43499800000012],
                [6.95417, 52.436386],
                [6.965833, 52.443054],
                [6.973888, 52.448608],
                [6.983889, 52.46],
                [6.987499, 52.4611],
                [6.99083, 52.459717],
                [7.058888, 52.398605],
                [7.061944, 52.39361],
                [7.065555, 52.385826],
                [7.071111, 52.358887],
                [7.069722, 52.35277600000012],
                [7.058114000000103, 52.337639],
                [7.038055, 52.31277],
                [7.032222, 52.298882000000106],
                [7.028889, 52.286942],
                [7.028055, 52.280273000000136],
                [7.028055, 52.276939],
                [7.031388, 52.268883],
                [7.053094, 52.23776],
                [7.042222, 52.23166700000013],
                [6.96472, 52.190277],
                [6.904166, 52.17305],
                [6.901111, 52.171387],
                [6.8775, 52.151382],
                [6.876111, 52.148605],
                [6.87472, 52.13916],
                [6.87194, 52.130272],
                [6.86861, 52.125549],
                [6.860555, 52.12028],
                [6.8525, 52.11833],
                [6.8425, 52.117775],
                [6.759428, 52.114563],
                [6.73639, 52.07666000000012],
                [6.728611, 52.035271],
                [6.794444, 52.010277],
                [6.80055, 52.00722],
                [6.826111, 51.98860900000011],
                [6.83, 51.97749],
                [6.8308320000001, 51.971382],
                [6.828888, 51.965553],
                [6.789166, 51.928055],
                [6.776944, 51.921387],
                [6.746388, 51.906105],
                [6.724444, 51.898048],
                [6.720555, 51.89777400000014],
                [6.701944, 51.90361],
                [6.69361, 51.90888200000012],
                [6.691667, 51.91111000000012],
                [6.685555, 51.914162],
                [6.67611, 51.91389],
                [6.594722000000104, 51.896111],
                [6.5275, 51.874443],
                [6.462777, 51.853607],
                [6.35111, 51.848053],
                [6.182221, 51.895271],
                [6.12361, 51.888054],
                [6.00305, 51.82999],
                [5.9625, 51.807777],
                [5.964722, 51.80555],
                [5.98139, 51.785271],
                [5.984722, 51.780548],
                [5.986666, 51.766937],
                [5.985833, 51.763885],
                [5.980833, 51.760277],
                [5.95205, 51.747528],
                [6.028889, 51.706665],
                [6.093055000000106, 51.60721600000011],
                [6.094166, 51.604439],
                [6.131389, 51.572495],
                [6.136666, 51.569160000000124],
                [6.15861, 51.55832700000013],
                [6.202222, 51.51694],
                [6.2075, 51.509995],
                [6.221944, 51.468887],
                [6.222221000000104, 51.46583],
                [6.222777, 51.364716],
                [6.222221000000104, 51.36166400000013],
                [6.143055, 51.29527300000012],
                [6.07889, 51.242493],
                [6.076388, 51.240273],
                [6.072222, 51.218048],
                [6.071666, 51.215],
                [6.071388, 51.211662],
                [6.074721, 51.189995000000124],
                [6.07667, 51.18110700000011],
                [6.079444000000137, 51.175827],
                [6.083611000000133, 51.17166],
                [6.090278, 51.168884],
                [6.0975, 51.131104],
                [6.00305, 51.08416],
                [5.910277, 51.062492],
                [5.906944000000124, 51.063889],
                [5.902499, 51.06305],
                [5.866944, 51.0480500000001],
                [5.86472, 51.046104],
                [5.864166, 51.04361],
                [5.869444000000101, 51.018883],
                [5.891666, 50.972771],
                [5.900277, 50.971939],
                [5.908055, 50.973885],
                [5.9325, 50.982216],
                [5.944722, 50.984993],
                [5.948889, 50.984993],
                [6.0175, 50.98027],
                [6.025555, 50.978333],
                [6.02833, 50.97666],
                [6.080277000000137, 50.915833],
                [6.081388, 50.91360500000013],
                [6.084722, 50.873604],
                [6.08417, 50.870552],
                [6.071666, 50.85416],
                [6.06778, 50.849716],
                [6.064722, 50.848328],
                [6.060833, 50.847496],
                [6.056389, 50.848328],
                [6.051666, 50.851944],
                [6.04611, 50.851944],
                [6.026111, 50.847771],
                [6.013888000000122, 50.84166],
                [6.013333, 50.838608],
                [6.008055000000127, 50.802216],
                [6.011798, 50.757271],
                [5.92639, 50.756104],
                [5.898918, 50.753883],
                [5.870555, 50.760826],
                [5.7975, 50.76944],
                [5.742499, 50.76028],
                [5.737222, 50.75944],
                [5.69861, 50.75777],
                [5.691911, 50.760559],
                [5.701388, 50.774437],
                [5.705560000000105, 50.7819520000001],
                [5.705, 50.78583],
                [5.701944, 50.80583200000012],
                [5.69394, 50.80881],
                [5.68361, 50.811386],
                [5.655555, 50.822495],
                [5.65167, 50.824715],
                [5.6408330000001, 50.839722],
                [5.638055000000122, 50.846664],
                [5.6375, 50.85027300000013],
                [5.638888000000122, 50.85889],
                [5.640555, 50.86305],
                [5.65, 50.87694],
                [5.657499, 50.88027],
                [5.758055, 50.959999],
                [5.764166000000102, 50.98999800000013],
                [5.776944, 51.025833],
                [5.818055, 51.114998],
                [5.84833, 51.139442000000145],
                [5.851388, 51.14222000000012],
                [5.855111, 51.148338],
                [5.855000000000132, 51.151108],
                [5.849171000000126, 51.15638],
                [5.834444, 51.165833],
                [5.754167, 51.189995000000124],
                [5.644722, 51.203606],
                [5.568334000000107, 51.22071],
                [5.557777, 51.26388500000013],
                [5.553333, 51.269722],
                [5.550278, 51.2725],
                [5.520833, 51.291107],
                [5.510833, 51.294441],
                [5.504444, 51.29527300000012],
                [5.497222, 51.29610400000013],
                [5.485833000000127, 51.294998000000135],
                [5.475555, 51.286942],
                [5.467777, 51.282776000000126],
                [5.411388, 51.266937],
                [5.406111, 51.266106],
                [5.4, 51.265549000000135],
                [5.32972100000012, 51.26221],
                [5.23897, 51.262283],
                [5.238889, 51.304718],
                [5.2375, 51.308327],
                [5.233611, 51.31055],
                [5.223332, 51.31388900000013],
                [5.201111000000139, 51.319717],
                [5.194444, 51.32],
                [5.189166, 51.31916],
                [5.168056, 51.31443800000011],
                [5.155, 51.315826],
                [5.143888, 51.318604],
                [5.14, 51.320831],
                [5.083055, 51.385826],
                [5.07861, 51.391663],
                [5.077222, 51.395271],
                [5.07667, 51.398888],
                [5.077777, 51.403328],
                [5.08, 51.406944000000124],
                [5.085833, 51.41277300000013],
                [5.08944, 51.41527600000012],
                [5.101110000000119, 51.42722],
                [5.103333, 51.43055],
                [5.104444000000115, 51.434998],
                [5.096110000000124, 51.44611],
                [5.08028, 51.466942],
                [5.073333000000105, 51.471664],
                [5.041389, 51.486664],
                [5.03555, 51.487221],
                [5.02361100000013, 51.48111],
                [5.016944, 51.47555],
                [5.01527700000014, 51.471664],
                [5.012777, 51.45416300000011],
                [5.00944, 51.446388],
                [5, 51.437775],
                [4.989444, 51.43055],
                [4.955555, 51.409996],
                [4.940277, 51.401382],
                [4.93611, 51.39944],
                [4.929999, 51.398605],
                [4.85305, 51.414444],
                [4.832777000000135, 51.429993],
                [4.844722000000104, 51.461388],
                [4.84611, 51.477493],
                [4.845555000000104, 51.48111],
                [4.825833, 51.492218],
                [4.80694, 51.499443],
                [4.788333, 51.503052],
                [4.781111, 51.50361],
                [4.769166, 51.502777],
                [4.757222, 51.496666],
                [4.705555, 51.469444],
                [4.69861, 51.464439],
                [4.67111, 51.44416],
                [4.668611, 51.440826],
                [4.670833, 51.433609],
                [4.673055, 51.430832],
                [4.67139, 51.42776],
                [4.650555, 51.423332],
                [4.644722, 51.4230500000001],
                [4.546944, 51.425827],
                [4.541944000000115, 51.42667],
                [4.53722, 51.432495],
                [4.535277, 51.43972],
                [4.535277, 51.443886000000134],
                [4.53805, 51.4524990000001],
                [4.543333, 51.458885],
                [4.544999, 51.462776],
                [4.549999, 51.474998],
                [4.55083, 51.47944],
                [4.549444, 51.48277300000012],
                [4.545555, 51.484993000000145],
                [4.53972, 51.48555],
                [4.486666000000127, 51.480827],
                [4.481944, 51.47944],
                [4.3975, 51.452774],
                [4.393888, 51.450272],
                [4.396667, 51.416939],
                [4.401388, 51.41083],
                [4.417777, 51.39833],
                [4.43639, 51.378883],
                [4.437778, 51.3752750000001],
                [4.431666, 51.364441],
                [4.428055, 51.361938],
                [4.418611000000112, 51.35916],
                [4.40722, 51.357773],
                [4.388055, 51.357498],
                [4.35889, 51.359993],
                [4.346944, 51.36249500000014],
                [4.279674000000114, 51.376595],
                [4.252368, 51.375145],
                [4.202499000000103, 51.405],
                [4.05611, 51.425827],
                [3.928889, 51.434998],
                [3.92778, 51.43055],
                [3.92555, 51.426941],
                [3.906666, 51.399994],
                [3.899722, 51.395],
                [3.82972, 51.389717],
                [3.823055, 51.39],
                [3.573055000000124, 51.444443],
                [3.543333000000132, 51.454437],
                [3.533611, 51.458054],
                [3.4525, 51.521111],
                [3.443055, 51.528885],
                [3.440555, 51.531662],
                [3.440833, 51.535828],
                [3.446389, 51.541939],
                [3.45333, 51.54694],
                [3.465, 51.55332900000013],
                [3.485555, 51.563332],
                [3.510833000000105, 51.57444],
                [3.523889, 51.579994],
                [3.555277, 51.592216],
                [3.568889, 51.597221],
                [3.580277000000137, 51.59861],
                [3.6919, 51.6003070000001],
                [3.832778, 51.606667],
                [3.837222, 51.606667],
                [3.868889, 51.6013870000001],
                [3.872777, 51.59916],
                [3.89333, 51.58444200000014],
                [3.898056, 51.578606],
                [3.903611, 51.568886],
                [3.902778, 51.565277],
                [3.899167, 51.5627750000001],
                [3.865278, 51.54666],
                [3.843534, 51.554028],
                [3.820555, 51.54916400000013],
                [3.865850000000137, 51.538662],
                [3.886337, 51.54304900000011],
                [3.921389, 51.54916400000013],
                [3.92861, 51.548332],
                [3.93444, 51.54694],
                [4.006666, 51.525276],
                [4.040277000000117, 51.51277],
                [4.055833, 51.50555],
                [4.067499, 51.49499500000013],
                [4.06917, 51.491661000000136],
                [4.081944, 51.46916],
                [4.095833000000141, 51.45138500000013],
                [4.111111, 51.443604],
                [4.125555, 51.438332000000116],
                [4.145833, 51.43583],
                [4.152222, 51.435555],
                [4.23805, 51.43471],
                [4.243333, 51.435555],
                [4.252777, 51.438606],
                [4.26428, 51.44397],
                [4.277222000000108, 51.445274],
                [4.281944, 51.446663],
                [4.28611, 51.448608],
                [4.289166000000137, 51.45166000000012],
                [4.291389, 51.45499400000011],
                [4.293611, 51.46833],
                [4.292222, 51.47583],
                [4.290833, 51.47916],
                [4.284721, 51.48832700000014],
                [4.266944, 51.508331],
                [4.262777, 51.510551],
                [4.22963, 51.518616],
                [4.215278000000126, 51.516388],
                [4.203888, 51.514999],
                [4.082777, 51.53083],
                [3.995555000000138, 51.579437],
                [3.99, 51.584717],
                [3.990833, 51.588333],
                [3.994166000000121, 51.590828],
                [4.003055, 51.594444000000124],
                [4.041944, 51.60527],
                [4.062222, 51.610275000000115],
                [4.0791660000001, 51.612495],
                [4.169722, 51.605553],
                [4.19028, 51.60083],
                [4.195833000000107, 51.59916],
                [4.20751, 51.589478],
                [4.208611, 51.59],
                [4.209444, 51.594444000000124],
                [4.20583, 51.60083],
                [4.20111, 51.606667],
                [4.196388, 51.612495],
                [4.186167, 51.617043],
                [4.16583, 51.615273000000116],
                [4.153889000000106, 51.614441],
                [4.13972, 51.614998],
                [4.13472, 51.61610400000012],
                [4.113333, 51.630272],
                [4.110555, 51.63694],
                [4.10614, 51.650978],
                [4.10305, 51.647774],
                [4.09611, 51.642776],
                [4.088611, 51.63832900000011],
                [4.076111, 51.63250000000011],
                [4.066388000000131, 51.629715],
                [4.019722, 51.61972000000014],
                [4.008888, 51.617775],
                [3.98, 51.614716],
                [3.9675, 51.614441],
                [3.903889, 51.63361],
                [3.899167, 51.635277],
                [3.761944000000142, 51.674995],
                [3.71266, 51.674675],
                [3.704444, 51.67694100000011],
                [3.696389, 51.681389],
                [3.687778, 51.68943800000011],
                [3.68611, 51.692772000000105],
                [3.685555000000136, 51.69639],
                [3.687500000000114, 51.709717],
                [3.689167, 51.713608000000136],
                [3.693611, 51.720833],
                [3.7033330000001, 51.728607],
                [3.71417, 51.733887],
                [3.723611000000119, 51.73666],
                [3.777778, 51.746109],
                [3.783889000000102, 51.74666600000012],
                [3.8125, 51.74472],
                [3.82486, 51.74229],
                [3.87861, 51.743889],
                [3.885278, 51.743889],
                [3.95583, 51.735832],
                [3.968611, 51.73360400000013],
                [3.975833, 51.728882],
                [4.004444, 51.71],
                [4.06694, 51.679443],
                [4.104166, 51.661942],
                [4.112778000000105, 51.67083],
                [4.11611, 51.67333200000013],
                [4.124444, 51.67722],
                [4.155833, 51.68388],
                [4.167754000000116, 51.68557],
                [4.127222, 51.706665],
                [4.059722000000136, 51.75138900000013],
                [4.056666, 51.75804900000014],
                [4.03083, 51.78666],
                [4.027778000000126, 51.78916],
                [4.019722, 51.793610000000115],
                [4.005278, 51.798882],
                [3.993055, 51.801384],
                [3.980556, 51.802773000000116],
                [3.95583, 51.801666],
                [3.874189, 51.78637],
                [3.866111, 51.80722],
                [3.865278, 51.810829],
                [3.865555, 51.814995],
                [3.867777, 51.81860400000011],
                [3.880833000000109, 51.823883],
                [3.98333, 51.846382],
                [3.995, 51.847771],
                [4.006666, 51.846664],
                [4.015555, 51.842773],
                [4.0275, 51.836105],
                [4.06111, 51.860275],
                [4.01667, 51.9675],
                [4.011944, 51.97777600000012],
                [4.012221, 51.981667],
                [4.014999000000103, 51.984718],
                [4.021111, 51.988052],
                [4.0388880000001, 51.98749500000014],
                [4.044444000000112, 51.986107],
                [4.05917, 51.984718],
                [4.08, 51.983887],
                [4.09944, 51.98416],
                [4.111111, 51.98555],
                [4.125555, 51.989716],
                [4.138055, 51.99582700000013],
                [4.149444, 52.002495],
                [4.362222, 52.17166],
                [4.36861, 52.177216],
                [4.4, 52.205826],
                [4.408889, 52.214722],
                [4.420555, 52.226662],
                [4.428888, 52.236107],
                [4.44167, 52.252495],
                [4.49449, 52.32721700000013],
                [4.517777000000137, 52.360832],
                [4.53889, 52.39222],
                [4.542777000000115, 52.399719],
                [4.55111, 52.41971600000011],
                [4.568055000000129, 52.44916500000011],
                [4.576944, 52.458054],
                [4.584431, 52.461502],
                [4.657958, 52.453125],
                [4.706849, 52.427227],
                [4.845252, 52.410198],
                [4.88598, 52.390373],
                [4.90688, 52.37416],
                [4.952402, 52.373123],
                [4.991944000000103, 52.361107],
                [5.126944, 52.330276],
                [5.23667, 52.312492],
                [5.249166, 52.311943],
                [5.254722, 52.310555000000136],
                [5.289444, 52.301666],
                [5.298611, 52.297775],
                [5.3025, 52.29583],
                [5.330442000000119, 52.27582600000011],
                [5.337777, 52.275551],
                [5.36389, 52.271111],
                [5.375278, 52.26916],
                [5.383888, 52.264999],
                [5.4075, 52.25194],
                [5.4175, 52.249161],
                [5.424444, 52.2486],
                [5.43055500000014, 52.249161],
                [5.523889000000111, 52.26416000000012],
                [5.53361, 52.26722],
                [5.54417, 52.274162],
                [5.55305, 52.283333],
                [5.562499000000116, 52.297493000000145],
                [5.570000000000107, 52.313049],
                [5.57778, 52.32278],
                [5.585, 52.327774],
                [5.624722, 52.354164],
                [5.62944, 52.356384],
                [5.67055, 52.371384],
                [5.687485, 52.377464],
                [5.702777, 52.382774],
                [5.722221, 52.388329],
                [5.73249, 52.390091],
                [5.734459, 52.390625],
                [5.743055, 52.393051],
                [5.756389, 52.398048],
                [5.76667, 52.40190100000012],
                [5.774166, 52.405273],
                [5.810262, 52.426094],
                [5.81478, 52.429115],
                [5.819638000000111, 52.432556],
                [5.849999, 52.46139],
                [5.8525, 52.46472],
                [5.878055, 52.50944],
                [5.872415000000103, 52.523415],
                [5.8475, 52.568054],
                [5.84861, 52.587494],
                [5.855000000000132, 52.606911],
                [5.758888, 52.60667],
                [5.678888, 52.60721600000011],
                [5.664721, 52.60833],
                [5.601944000000117, 52.65583],
                [5.599444, 52.65860700000013],
                [5.598888, 52.662498],
                [5.595277, 52.74082900000013],
                [5.59722, 52.753609],
                [5.599166000000139, 52.757774],
                [5.619166, 52.779442],
                [5.659166000000141, 52.818329],
                [5.668611, 52.82638500000013],
                [5.676944000000105, 52.830551],
                [5.71835, 52.83802],
                [5.714444000000128, 52.840271],
                [5.651388, 52.85527],
                [5.645833, 52.85555],
                [5.595, 52.848328],
                [5.588888, 52.842216],
                [5.586666, 52.83861],
                [5.583611, 52.836105],
                [5.574721, 52.83194],
                [5.563333, 52.830826],
                [5.418611000000112, 52.851662],
                [5.412499, 52.85305],
                [5.39805, 52.85860400000013],
                [5.374166000000116, 52.872215],
                [5.36861, 52.877777],
                [5.363333000000125, 52.887215],
                [5.365833, 52.89111],
                [5.371944, 52.89666],
                [5.393611000000135, 52.90638700000011],
                [5.403889, 52.90888200000012],
                [5.412777, 52.912773],
                [5.41361, 52.91722],
                [5.418611000000112, 52.94944],
                [5.42055, 52.964439],
                [5.411388, 53.028885],
                [5.407777, 53.035],
                [5.375555, 53.070549],
                [5.364166000000125, 53.07027],
                [5.339167, 53.065552],
                [5.303055, 53.052773],
                [5.289444, 53.047218],
                [5.263055000000122, 53.035271],
                [5.19831, 52.995316],
                [5.100277000000119, 52.948051],
                [5.09167, 52.885826],
                [5.126111, 52.82249500000012],
                [5.193055, 52.7544400000001],
                [5.197222, 52.756386],
                [5.202222, 52.7575],
                [5.21611, 52.7575],
                [5.230833, 52.75610400000011],
                [5.27833, 52.750832],
                [5.286111000000119, 52.746109],
                [5.29055, 52.74082900000013],
                [5.292500000000132, 52.737778000000105],
                [5.29555, 52.73111],
                [5.304166, 52.706940000000145],
                [5.302221, 52.702774],
                [5.255305000000135, 52.691589],
                [5.24167, 52.660553],
                [5.230277, 52.65361],
                [5.196666, 52.637772],
                [5.167777, 52.62888],
                [5.147222, 52.623886],
                [5.141944000000137, 52.622772],
                [5.135, 52.622772],
                [5.133055, 52.626106],
                [5.106388, 52.64222],
                [5.101388, 52.64416],
                [5.055833, 52.64278],
                [5.05, 52.641937],
                [5.040833, 52.63861],
                [5.033333, 52.634163],
                [5.028889, 52.62666300000012],
                [5.028055000000109, 52.61972000000014],
                [5.02861, 52.615829],
                [5.0425, 52.573883],
                [5.047777, 52.564163],
                [5.067778, 52.541382],
                [5.087222, 52.517776],
                [5.091944, 52.5075],
                [5.092777, 52.50027],
                [5.090278, 52.433327],
                [5.078055, 52.416107],
                [5.046369, 52.40263],
                [5.028333, 52.375832],
                [5.0225, 52.3752750000001],
                [5.016388, 52.375832],
                [4.92139, 52.386108],
                [4.908333000000141, 52.388329],
                [4.875527, 52.415604],
                [4.82579, 52.425697],
                [4.71315600000014, 52.441013],
                [4.66846, 52.465885],
                [4.58, 52.471664],
                [4.579444, 52.475555],
                [4.588611, 52.48944100000011],
                [4.598332, 52.513885],
                [4.62222, 52.596664],
                [4.631944, 52.634163],
                [4.63611, 52.65222],
                [4.63583, 52.68055],
                [4.654166, 52.751663],
                [4.73, 52.948051],
                [4.734166, 52.955551],
                [4.74139, 52.960548],
                [4.749722000000133, 52.962494],
                [4.773889, 52.964722],
                [4.793056, 52.96527100000014],
                [4.796111, 52.964439],
                [4.809444, 52.953606],
                [4.809999, 52.942497],
                [4.8075, 52.939163],
                [4.805833000000121, 52.934998],
                [4.80694, 52.92749800000013],
                [4.808611, 52.92416400000013],
                [4.813333, 52.91833],
                [4.82639, 52.911942],
                [4.83611100000013, 52.90833],
                [4.8625, 52.89999],
                [4.872499000000118, 52.897217],
                [4.8875, 52.896111],
                [4.90472, 52.898048],
                [4.9325, 52.902496],
                [4.943055000000129, 52.905],
                [5.085833, 52.955276],
                [5.10305, 52.963051],
                [5.180277000000103, 53.00305200000014],
                [5.184206000000131, 53.005531],
                [5.224444, 53.032494],
                [5.24667, 53.046944],
                [5.254722, 53.051384],
                [5.301666, 53.07278],
                [5.32722200000012, 53.07944],
                [5.360833, 53.084442],
                [5.37861, 53.09166],
                [5.38611, 53.096664],
                [5.38861, 53.1],
                [5.4025, 53.121384],
                [5.411111, 53.14027],
                [5.416944, 53.163055],
                [5.415, 53.169998],
                [5.415277000000117, 53.174164],
                [5.442499, 53.21194],
                [5.458611, 53.226105],
                [5.46611, 53.230827],
                [5.573333, 53.288055],
                [5.58611100000013, 53.294716],
                [5.599166000000139, 53.30028],
                [5.890833, 53.38222],
                [5.98166700000013, 53.398888],
                [6.0925, 53.410828],
                [6.1725, 53.413605],
                [6.183332, 53.413887],
                [6.187288, 53.41243],
                [6.19472, 53.41],
                [6.29694400000011, 53.401939],
                [6.4525, 53.425278],
                [6.6975, 53.461937],
                [6.72111, 53.46472200000011],
                [6.741944000000103, 53.46583],
                [6.7775, 53.45916],
                [6.855000000000132, 53.43943800000011],
                [6.862778000000105, 53.437218],
                [6.869166, 53.43388],
                [6.87139, 53.431938],
                [6.870832, 53.42222],
                [6.871666, 53.416107],
              ],
            ],
            [
              [
                [5.699166, 53.462776],
                [5.720555, 53.461662],
                [5.804999, 53.463882],
                [5.854722, 53.46694200000013],
                [5.905, 53.469719],
                [5.937222000000133, 53.470551000000114],
                [5.951388, 53.46888700000011],
                [5.955555, 53.46666],
                [5.95611, 53.462776],
                [5.948055000000124, 53.458611],
                [5.81139, 53.438889],
                [5.798333, 53.438606],
                [5.77722, 53.440552],
                [5.771388, 53.442215],
                [5.74861, 53.44416],
                [5.737222, 53.44249700000012],
                [5.683888, 53.425278],
                [5.662499, 53.426384],
                [5.65, 53.429161000000136],
                [5.637777, 53.435829000000126],
                [5.633055000000127, 53.441666],
                [5.6325, 53.445549],
                [5.633333, 53.448051],
                [5.65361, 53.469719],
                [5.657499, 53.472221000000104],
                [5.663055, 53.473053],
                [5.668888, 53.471664],
                [5.674444, 53.466385],
                [5.699166, 53.462776],
              ],
            ],
            [
              [
                [6.134999000000107, 53.45361],
                [6.13028, 53.45361],
                [6.126389, 53.458328],
                [6.11639, 53.471939],
                [6.117222, 53.474998],
                [6.119444, 53.477219000000105],
                [6.13611, 53.491386],
                [6.144722, 53.496384],
                [6.148889, 53.497498],
                [6.158055, 53.49916],
                [6.303333, 53.51138300000014],
                [6.314722, 53.511108],
                [6.3325, 53.50804900000014],
                [6.339444, 53.504997],
                [6.34111, 53.502777],
                [6.34028, 53.50027],
                [6.3375, 53.498604],
                [6.272499, 53.484444],
                [6.234722, 53.47639],
                [6.225555, 53.474998],
                [6.16305, 53.471664],
                [6.15278, 53.467216],
                [6.134999000000107, 53.45361],
              ],
            ],
          ],
        },
        id: 7,
        NAME: 'Netherlands',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Ireland',
          id: 8,
          label: 'Ireland',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.26,
          year: '2023',
          centroid: [-8.2439, 53.4129],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [-9.65639, 53.222221],
                [-9.663334, 53.221382],
                [-9.68861, 53.222771],
                [-9.695557, 53.223328],
                [-9.70389, 53.22694400000012],
                [-9.709723, 53.232498000000135],
                [-9.72556, 53.263885],
                [-9.72472, 53.26805],
                [-9.67056, 53.28166],
                [-9.664446, 53.281944],
                [-9.660833, 53.279999],
                [-9.64194, 53.25193800000011],
                [-9.64861, 53.22694400000012],
                [-9.65639, 53.222221],
              ],
            ],
            [
              [
                [-9.964169, 54.018608],
                [-9.940556, 53.997772],
                [-9.93611, 53.99139],
                [-9.92389, 53.950554000000125],
                [-9.92389, 53.945831],
                [-9.92611, 53.923882],
                [-9.940834, 53.886665],
                [-9.943335, 53.883331],
                [-9.95056, 53.878326],
                [-9.955, 53.876663],
                [-9.96139, 53.875832],
                [-9.978613, 53.87944],
                [-10.05556, 53.909439],
                [-10.06139, 53.919716],
                [-10.062778, 53.923332],
                [-10.062778, 53.927773000000116],
                [-10.15222, 53.959717000000126],
                [-10.17417, 53.96083],
                [-10.26417, 53.96860500000014],
                [-10.268612, 53.974998],
                [-10.26556, 53.977776],
                [-10.19667, 54.00833100000011],
                [-10.18944, 54.008888],
                [-10.15889, 54.009163],
                [-10.125, 54.00166300000012],
                [-10.119522, 54],
                [-10.06917, 54.02166],
                [-10.06306, 54.0225],
                [-9.974167, 54.021942],
                [-9.96806, 54.02082800000011],
                [-9.964169, 54.018608],
              ],
            ],
            [
              [
                [-8.43694, 54.944443],
                [-8.44333, 54.943886000000134],
                [-8.448891, 54.945274],
                [-8.4525, 54.947777],
                [-8.454723, 54.95083],
                [-8.45389, 54.95499],
                [-8.450556, 54.957771],
                [-8.44417, 54.9574970000001],
                [-8.43861, 54.955276],
                [-8.43639, 54.951942],
                [-8.435, 54.948326],
                [-8.43694, 54.944443],
              ],
            ],
            [
              [
                [-8.518612, 54.964165],
                [-8.526669, 54.963882000000126],
                [-8.553057, 54.965828],
                [-8.558334, 54.966660000000104],
                [-8.562223, 54.96971900000011],
                [-8.56444, 54.972771],
                [-8.56361, 54.988884],
                [-8.55028, 55.008331],
                [-8.54695, 55.01194],
                [-8.538612, 55.015831],
                [-8.530834, 55.015549],
                [-8.526945, 55.013885],
                [-8.493334, 54.99749800000012],
                [-8.49056, 54.99472],
                [-8.484446, 54.97583],
                [-8.48556, 54.971382],
                [-8.48944, 54.969994],
                [-8.518612, 54.964165],
              ],
            ],
            [
              [
                [-7.40639, 54.953331],
                [-7.44389, 54.8825],
                [-7.458056, 54.857773],
                [-7.482839, 54.82993],
                [-7.553334, 54.762772],
                [-7.73917, 54.710548],
                [-7.819167, 54.731110000000115],
                [-7.824445, 54.73444400000011],
                [-7.82972, 54.7355500000001],
                [-7.843056, 54.733604],
                [-7.92528, 54.702217],
                [-7.927501, 54.69888300000014],
                [-7.91389, 54.671104],
                [-7.90639, 54.664444],
                [-7.855278, 54.63472],
                [-7.849445, 54.633049],
                [-7.7775, 54.62693800000011],
                [-7.752223, 54.594444],
                [-7.833611, 54.55389],
                [-7.95083, 54.53221900000011],
                [-8.04695, 54.507217],
                [-8.17167, 54.463879000000134],
                [-8.15944, 54.44194],
                [-8.15667, 54.438606],
                [-8.065556, 54.372772],
                [-8.05583, 54.36639],
                [-8.045279, 54.361382],
                [-8.030279, 54.35721600000011],
                [-7.94139, 54.299438],
                [-7.90028, 54.294167],
                [-7.878056, 54.28916],
                [-7.875556, 54.28583],
                [-7.874722, 54.282494],
                [-7.86944, 54.253052],
                [-7.86917, 54.23111],
                [-7.8675, 54.2241590000001],
                [-7.86194, 54.218048],
                [-7.85139, 54.212219],
                [-7.82056, 54.19916500000011],
                [-7.81556, 54.19916500000011],
                [-7.74778, 54.200272],
                [-7.7025, 54.2024990000001],
                [-7.69694, 54.2024990000001],
                [-7.62778, 54.16971600000011],
                [-7.624445, 54.16638200000011],
                [-7.62306, 54.16305],
                [-7.624167, 54.155548],
                [-7.62361, 54.148888],
                [-7.620001, 54.14611100000013],
                [-7.610001, 54.142494],
                [-7.55944, 54.126938],
                [-7.330278, 54.113052],
                [-7.313334, 54.11249500000014],
                [-7.28694, 54.121941000000106],
                [-7.280834, 54.124992000000134],
                [-7.14583, 54.225273],
                [-7.14139, 54.252495],
                [-7.1425, 54.255829],
                [-7.145, 54.25888800000013],
                [-7.175556, 54.28916],
                [-7.16083, 54.336662],
                [-7.05833, 54.41],
                [-7.03639, 54.417221],
                [-7.030834, 54.41777],
                [-7.02528, 54.41693900000013],
                [-6.974445, 54.401665],
                [-6.92694, 54.37916600000011],
                [-6.91722, 54.373604],
                [-6.87611, 54.345276],
                [-6.87, 54.33888],
                [-6.85056, 54.291939],
                [-6.851667, 54.28749800000014],
                [-6.73472, 54.18361],
                [-6.65556, 54.065277],
                [-6.632501, 54.04527300000012],
                [-6.625, 54.039162],
                [-6.620001, 54.03722],
                [-6.608056, 54.042221],
                [-6.60583, 54.044441],
                [-6.5675, 54.05082700000014],
                [-6.4475, 54.058327],
                [-6.365834, 54.09944],
                [-6.36611, 54.10249],
                [-6.36528, 54.105553],
                [-6.363611, 54.108604],
                [-6.360001, 54.11166400000013],
                [-6.355, 54.114166],
                [-6.34972, 54.115555],
                [-6.33889, 54.115555],
                [-6.288611, 54.108604],
                [-6.278611, 54.107216],
                [-6.2725, 54.10499600000014],
                [-6.2675, 54.101944],
                [-6.26697, 54.099831],
                [-6.27083, 54.097771],
                [-6.26972, 54.093605],
                [-6.240834, 54.074715],
                [-6.17056, 54.036942],
                [-6.158334, 54.030548],
                [-6.14528, 54.02861],
                [-6.133889, 54.03139],
                [-6.12861, 54.029716],
                [-6.10528, 54.002777],
                [-6.10333, 53.999443],
                [-6.10306, 53.995827],
                [-6.105, 53.992218],
                [-6.10833, 53.989166000000125],
                [-6.120833, 53.982773],
                [-6.13806, 53.974998],
                [-6.14861, 53.972221],
                [-6.155001, 53.972221],
                [-6.1625, 53.972771],
                [-6.22806, 53.987778],
                [-6.288611, 54.00444],
                [-6.31194, 54.009438],
                [-6.33028, 54.013054],
                [-6.344167, 54.01444],
                [-6.35056, 54.013885],
                [-6.35556, 54.01221],
                [-6.35889, 54.009438],
                [-6.38083, 53.953606],
                [-6.38194, 53.94944],
                [-6.38083, 53.91722],
                [-6.37944, 53.909439],
                [-6.37361, 53.89971900000012],
                [-6.36222, 53.888054],
                [-6.351667, 53.88083],
                [-6.345, 53.87638900000013],
                [-6.33694, 53.871941],
                [-6.325556, 53.869164],
                [-6.28972, 53.86388],
                [-6.255, 53.833611],
                [-6.240001, 53.782776],
                [-6.24694, 53.754166],
                [-6.25097, 53.728249],
                [-6.25111, 53.719444000000124],
                [-6.241127, 53.681198],
                [-6.23639, 53.671387],
                [-6.21417, 53.635551],
                [-6.14917, 53.59027100000014],
                [-6.14444, 53.58833],
                [-6.123889, 53.585831],
                [-6.10139, 53.583054],
                [-6.081112, 53.56360600000011],
                [-6.0775, 53.548332],
                [-6.076945, 53.53999],
                [-6.077778, 53.525833],
                [-6.07889, 53.522499],
                [-6.14972, 53.386108],
                [-6.159167, 53.382774],
                [-6.22472, 53.35388],
                [-6.22444, 53.35166],
                [-6.22083, 53.342216],
                [-6.18028, 53.307495],
                [-6.11056, 53.252495],
                [-6.03556, 53.11388],
                [-6.03361, 53.10611],
                [-6.013056, 52.945],
                [-6.06944, 52.865829],
                [-6.1075, 52.839996],
                [-6.1175, 52.832222],
                [-6.120001, 52.828888],
                [-6.1375, 52.80167],
                [-6.14528, 52.787498],
                [-6.14833, 52.77916],
                [-6.15056, 52.766106],
                [-6.14778, 52.738327],
                [-6.19111, 52.695831],
                [-6.19667, 52.68943800000011],
                [-6.21417, 52.667496],
                [-6.218056, 52.66027],
                [-6.22222, 52.643326],
                [-6.22278, 52.62999700000012],
                [-6.22028, 52.618607],
                [-6.21667, 52.611938],
                [-6.21111, 52.606384],
                [-6.20917, 52.60305],
                [-6.201112, 52.580551],
                [-6.2, 52.564163],
                [-6.200278, 52.555275],
                [-6.20333, 52.547775000000115],
                [-6.21111, 52.53833],
                [-6.23028, 52.51722000000012],
                [-6.244722, 52.502777],
                [-6.361945, 52.392776],
                [-6.459723, 52.37610600000011],
                [-6.46667, 52.377777],
                [-6.475, 52.37444],
                [-6.498889, 52.356110000000115],
                [-6.4975, 52.351944],
                [-6.41167, 52.285828],
                [-6.40833, 52.284164],
                [-6.38194, 52.27722200000011],
                [-6.33361, 52.251106],
                [-6.329722, 52.248886],
                [-6.321667, 52.240273],
                [-6.31944, 52.23722],
                [-6.32528, 52.22583],
                [-6.329722, 52.219162],
                [-6.357779, 52.18055],
                [-6.361112, 52.17749800000013],
                [-6.366389, 52.176666],
                [-6.3725, 52.17610900000011],
                [-6.38667, 52.176941],
                [-6.39833, 52.179443000000106],
                [-6.400278, 52.182495],
                [-6.46667, 52.193054],
                [-6.62278, 52.192215],
                [-6.78944, 52.216942],
                [-6.818334, 52.187218],
                [-6.82889, 52.17194400000011],
                [-6.83278, 52.169716],
                [-6.87056, 52.163055],
                [-6.9025, 52.166382],
                [-6.91306, 52.20305],
                [-6.91639, 52.20916],
                [-6.97944, 52.276665],
                [-6.994722, 52.282776000000126],
                [-6.99612, 52.282242],
                [-6.998889, 52.276108000000136],
                [-6.998056, 52.2725],
                [-6.995382, 52.269821],
                [-6.98889, 52.26416000000012],
                [-6.97389, 52.233604],
                [-6.97056, 52.221939000000134],
                [-6.97417, 52.168053],
                [-6.998334, 52.140831000000105],
                [-7.00528, 52.13611],
                [-7.03639, 52.13277],
                [-7.100834, 52.128883],
                [-7.105834, 52.13055400000013],
                [-7.10694, 52.134163000000115],
                [-7.160278, 52.15028],
                [-7.36889, 52.134163000000115],
                [-7.435, 52.126106],
                [-7.578889, 52.100273],
                [-7.62028, 52.06472],
                [-7.60194, 52.06305],
                [-7.5675, 52.059166],
                [-7.54806, 52.056389],
                [-7.546112, 52.05305],
                [-7.54556, 52.048882],
                [-7.585, 51.99472],
                [-7.58833, 51.991661],
                [-7.71278, 51.93888900000013],
                [-7.725278, 51.93777],
                [-7.811945, 51.941666],
                [-7.81778, 51.942772],
                [-7.823611, 51.944443],
                [-7.83167, 51.948326],
                [-7.85134, 51.976799],
                [-7.85139, 51.961105],
                [-7.85167, 51.948326],
                [-7.85389, 51.940277],
                [-7.88917, 51.890274],
                [-8.01833, 51.834717000000126],
                [-8.08667, 51.810829],
                [-8.16639, 51.792221],
                [-8.172224, 51.791664],
                [-8.23333, 51.79583000000014],
                [-8.239, 51.804108],
                [-8.2415, 51.805107000000135],
                [-8.24383, 51.80677],
                [-8.24433, 51.81144000000012],
                [-8.226667, 51.83138300000013],
                [-8.22222, 51.833611],
                [-8.206945, 51.8366620000001],
                [-8.18111, 51.84861],
                [-8.175556, 51.854439],
                [-8.210556, 51.88444],
                [-8.286667, 51.889442000000145],
                [-8.365835, 51.89222],
                [-8.38278, 51.89277600000014],
                [-8.38593, 51.89205900000013],
                [-8.415279, 51.88528],
                [-8.421112, 51.88389],
                [-8.42944, 51.880554],
                [-8.42831, 51.879524],
                [-8.426668, 51.878052],
                [-8.419445, 51.87693800000011],
                [-8.399445, 51.87555],
                [-8.37195, 51.876389],
                [-8.35778, 51.87555],
                [-8.346111, 51.873886],
                [-8.341112, 51.871666],
                [-8.334723, 51.866943],
                [-8.30433, 51.820381],
                [-8.297001, 51.803719],
                [-8.297168, 51.801216],
                [-8.296946, 51.760826],
                [-8.308334, 51.744995],
                [-8.31306, 51.738609],
                [-8.339724, 51.72277100000014],
                [-8.34889, 51.719444],
                [-8.417778, 51.706383],
                [-8.52417, 51.665276],
                [-8.54139, 51.648331],
                [-8.557501, 51.633888],
                [-8.694168, 51.573608],
                [-8.69917, 51.572495],
                [-8.73722, 51.576111],
                [-8.88278, 51.56721],
                [-8.98389, 51.559715],
                [-9.11222, 51.54805],
                [-9.16361, 51.51777600000014],
                [-9.22611, 51.484161],
                [-9.23417, 51.48055],
                [-9.35278, 51.470551],
                [-9.366667, 51.469719],
                [-9.378334, 51.470833],
                [-9.45472, 51.53083],
                [-9.63833, 51.50944],
                [-9.703611, 51.469994],
                [-9.703611, 51.46721600000012],
                [-9.7075, 51.464996],
                [-9.716946, 51.46194],
                [-9.76806, 51.451942],
                [-9.79806, 51.44722000000013],
                [-9.807516, 51.44622],
                [-9.817501, 51.445549],
                [-9.816668, 51.473053],
                [-9.800835, 51.490273],
                [-9.77472, 51.50193800000011],
                [-9.71667, 51.525551],
                [-9.7025, 51.52944200000013],
                [-9.67972, 51.537773],
                [-9.67056, 51.541382],
                [-9.65361, 51.548882000000106],
                [-9.64972, 51.551109],
                [-9.593889, 51.589722],
                [-9.591946, 51.609993],
                [-9.68111, 51.579994],
                [-9.785278, 51.548607],
                [-9.80528, 51.54277000000013],
                [-9.82944, 51.539993],
                [-9.83611, 51.54055000000011],
                [-9.84111, 51.541939],
                [-9.84472, 51.544167],
                [-9.84472, 51.547775],
                [-9.77917, 51.583885],
                [-9.74528, 51.599442000000124],
                [-9.613001, 51.64222],
                [-9.607, 51.643723],
                [-9.550556, 51.658333],
                [-9.525278, 51.660828],
                [-9.515, 51.66333],
                [-9.47056, 51.676384],
                [-9.46139, 51.680832],
                [-9.45167, 51.68805],
                [-9.45, 51.690826],
                [-9.44195, 51.712776],
                [-9.45167, 51.724716000000114],
                [-9.53556, 51.750000000000114],
                [-9.54861, 51.719994],
                [-9.55139, 51.717216],
                [-9.62694, 51.687996],
                [-9.630112, 51.686829],
                [-9.660779, 51.680164],
                [-9.66711, 51.678829],
                [-9.7775, 51.65778],
                [-9.806391, 51.653885000000116],
                [-9.93028, 51.62916600000011],
                [-9.93028, 51.62555],
                [-9.932501, 51.62221],
                [-9.935556, 51.61972000000014],
                [-9.946667, 51.613884],
                [-10.02583, 51.595276],
                [-10.03694, 51.593048],
                [-10.04361, 51.592773],
                [-10.1325, 51.59333],
                [-10.130001, 51.61222],
                [-10.06028, 51.64361],
                [-9.98806, 51.677773],
                [-9.98083, 51.708328],
                [-9.991667, 51.710548],
                [-9.99611, 51.712494],
                [-9.998056, 51.71583],
                [-9.99667, 51.719444],
                [-9.976667, 51.729164],
                [-9.971945, 51.731384000000105],
                [-9.905556, 51.757774],
                [-9.776669, 51.800827],
                [-9.592501, 51.86472],
                [-9.57917, 51.86999500000013],
                [-9.5775, 51.87221],
                [-9.583612, 51.873604000000114],
                [-9.642223, 51.869438],
                [-9.68833, 51.86111],
                [-9.71, 51.856384],
                [-9.939167, 51.799438],
                [-10.05139, 51.77111100000013],
                [-10.10195, 51.752220000000136],
                [-10.18278, 51.78583],
                [-10.172501, 51.81222],
                [-10.17472, 51.820549],
                [-10.17639, 51.82416500000011],
                [-10.17889, 51.826942],
                [-10.200279, 51.845833],
                [-10.205278, 51.847221],
                [-10.21194, 51.847771],
                [-10.23056, 51.845551],
                [-10.24528, 51.84111],
                [-10.24889, 51.838882000000126],
                [-10.338593, 51.78292],
                [-10.35389, 51.842773],
                [-10.371946, 51.87888],
                [-10.263613, 51.988052],
                [-10.249445, 51.99305],
                [-10.12389, 52.02555100000012],
                [-10.10167, 52.03083],
                [-10.091112, 52.033333],
                [-10.05695, 52.038605],
                [-9.98667, 52.049995],
                [-9.801111, 52.122772],
                [-9.75778, 52.148605],
                [-9.76306, 52.150551],
                [-9.81139, 52.1525],
                [-9.844168, 52.151939],
                [-9.872501, 52.151382],
                [-9.88667, 52.150551],
                [-9.942501, 52.144722],
                [-10.025, 52.13611],
                [-10.05389, 52.131386],
                [-10.093056, 52.123604],
                [-10.18472, 52.107216],
                [-10.275, 52.10833],
                [-10.33, 52.113327],
                [-10.36583, 52.111664],
                [-10.38167, 52.103882],
                [-10.436668, 52.092216],
                [-10.444168, 52.092499],
                [-10.44945, 52.09388700000011],
                [-10.465557, 52.10194400000012],
                [-10.470001, 52.107498],
                [-10.473612, 52.129166],
                [-10.47472, 52.145554],
                [-10.466946, 52.176666],
                [-10.464724, 52.179718],
                [-10.46083, 52.18222],
                [-10.35972, 52.229721],
                [-10.265, 52.26749400000011],
                [-10.25056, 52.271385],
                [-10.20417, 52.281105],
                [-10.169445, 52.287498],
                [-10.162779, 52.287773],
                [-10.158335, 52.285828],
                [-10.156946, 52.282219],
                [-10.156946, 52.27389],
                [-10.15722, 52.270271],
                [-9.95195, 52.23111],
                [-9.94583, 52.23027],
                [-9.92028, 52.229996],
                [-9.88389, 52.229996],
                [-9.746946, 52.243332],
                [-9.740835, 52.24472000000014],
                [-9.742224, 52.247772],
                [-9.749445, 52.25305200000014],
                [-9.76917, 52.26416000000012],
                [-9.781946, 52.265274],
                [-9.78722, 52.26444],
                [-9.83583, 52.286659],
                [-9.83972, 52.379715],
                [-9.76278, 52.44277],
                [-9.68028, 52.51277],
                [-9.67556, 52.545273],
                [-9.67389, 52.54805],
                [-9.65556, 52.559715],
                [-9.651669, 52.56194],
                [-9.628889, 52.569160000000124],
                [-9.616667, 52.570831],
                [-9.36861, 52.57972],
                [-9.365002, 52.578331],
                [-9.36132, 52.575615],
                [-9.357592, 52.569168],
                [-9.33167, 52.57111],
                [-9.2225, 52.584999],
                [-8.98389, 52.630554],
                [-8.81833, 52.66555],
                [-8.84889, 52.689995],
                [-8.946945, 52.72361],
                [-9.028057, 52.730553],
                [-9.03333, 52.719162],
                [-9.065556, 52.688606],
                [-9.09083, 52.667221],
                [-9.12917, 52.635277],
                [-9.14695, 52.622772],
                [-9.15556, 52.619164000000126],
                [-9.16694, 52.61666],
                [-9.17972, 52.615829],
                [-9.241667, 52.613327],
                [-9.48056, 52.616943],
                [-9.554167, 52.638054],
                [-9.69417, 52.602219],
                [-9.70167, 52.597771],
                [-9.704723, 52.59499],
                [-9.70667, 52.591385000000116],
                [-9.70667, 52.58777600000013],
                [-9.701389, 52.581665],
                [-9.703056, 52.578049],
                [-9.707779, 52.57638],
                [-9.795279, 52.560829],
                [-9.886112, 52.550278000000105],
                [-9.900278, 52.54999500000014],
                [-9.92639, 52.55249800000013],
                [-9.932501, 52.553604],
                [-9.93639, 52.55583200000012],
                [-9.934168, 52.558884],
                [-9.91556, 52.570831],
                [-9.91111, 52.572495],
                [-9.84806, 52.58888],
                [-9.821667, 52.590828],
                [-9.81167, 52.593887],
                [-9.735001, 52.63888500000013],
                [-9.7275, 52.643326],
                [-9.565001, 52.74582700000013],
                [-9.485834, 52.80055],
                [-9.405556, 52.88638],
                [-9.394724, 52.926666],
                [-9.46083, 52.926941],
                [-9.467779, 52.92749800000013],
                [-9.47139, 52.92999300000014],
                [-9.473612, 52.93305],
                [-9.475, 52.936943],
                [-9.473333, 52.940552],
                [-9.280834, 53.139717],
                [-9.26667, 53.14944],
                [-9.26056, 53.15027600000013],
                [-9.25361, 53.149719],
                [-9.23167, 53.143051],
                [-9.19722, 53.127495000000124],
                [-9.17361, 53.11388],
                [-9.15417, 53.106941],
                [-9.06944, 53.117218],
                [-9.00148, 53.145592],
                [-9.03417, 53.15722],
                [-9.04333, 53.16055300000011],
                [-9.04611, 53.16333],
                [-9.04361, 53.166664],
                [-9.0375, 53.16749600000014],
                [-8.981112, 53.16333],
                [-8.980835, 53.15916],
                [-8.978613, 53.15583],
                [-8.944168, 53.139717],
                [-8.938057, 53.140549],
                [-8.934723, 53.143326000000116],
                [-8.94111, 53.26416],
                [-8.96028, 53.26722000000012],
                [-9.032778, 53.27166],
                [-9.04028, 53.27166],
                [-9.04639, 53.27055400000012],
                [-9.05528, 53.26694],
                [-9.10056, 53.258049],
                [-9.16778, 53.248329000000126],
                [-9.20222, 53.24638],
                [-9.22972, 53.245552],
                [-9.3, 53.24472],
                [-9.43889, 53.23389],
                [-9.44611, 53.233055],
                [-9.477501, 53.224716],
                [-9.4975, 53.223053],
                [-9.60806, 53.232216],
                [-9.618057, 53.23610700000012],
                [-9.62389, 53.241661000000136],
                [-9.62528, 53.24528],
                [-9.624168, 53.25361],
                [-9.61028, 53.29916],
                [-9.588335, 53.319443],
                [-9.582224, 53.3186],
                [-9.5775, 53.319717],
                [-9.57361, 53.322495],
                [-9.55778, 53.335548],
                [-9.55611, 53.339165],
                [-9.555, 53.37917],
                [-9.563334, 53.38333],
                [-9.648056, 53.386108],
                [-9.655001, 53.385826],
                [-9.663612, 53.38166],
                [-9.699722, 53.361382],
                [-9.703611, 53.355553],
                [-9.70639, 53.342773],
                [-9.711113, 53.336388],
                [-9.74028, 53.311943],
                [-9.744167, 53.309715],
                [-9.77972, 53.294716],
                [-9.786667, 53.294167],
                [-9.901945, 53.314720000000136],
                [-9.90472, 53.31721],
                [-9.904446, 53.32194],
                [-9.88728, 53.35077300000012],
                [-9.88311, 53.35377],
                [-9.84361, 53.36860700000011],
                [-9.81889, 53.37138],
                [-9.808889, 53.374992],
                [-9.80028, 53.37917],
                [-9.789446, 53.38666500000011],
                [-9.78472, 53.393051],
                [-9.786112, 53.39666],
                [-9.79722, 53.41333],
                [-9.80611, 53.417221],
                [-9.81361, 53.417221],
                [-9.88167, 53.409164],
                [-9.921334, 53.39338],
                [-9.92233, 53.38855000000012],
                [-9.923335, 53.38605100000012],
                [-9.92517, 53.384384],
                [-9.95917, 53.371941000000106],
                [-9.96639, 53.371941000000106],
                [-10.013056, 53.378609],
                [-10.175835, 53.407776],
                [-10.17722, 53.4116590000001],
                [-10.20167, 53.540833],
                [-10.198612, 53.543884],
                [-10.18611, 53.550278000000105],
                [-10.03611, 53.60055],
                [-10.000557, 53.60555],
                [-9.99445, 53.606384],
                [-9.87611, 53.61083200000013],
                [-9.79945, 53.596382],
                [-9.78889, 53.594444],
                [-9.781113, 53.593887],
                [-9.704723, 53.594994],
                [-9.69917, 53.595833],
                [-9.69528, 53.59861],
                [-9.69748, 53.60254700000013],
                [-9.76389, 53.60194],
                [-9.77917, 53.602493],
                [-9.79945, 53.604721],
                [-9.819723, 53.61083200000013],
                [-9.86278, 53.62722],
                [-9.90472, 53.643326],
                [-9.91306, 53.6475],
                [-9.91445, 53.650551],
                [-9.92445, 53.691383],
                [-9.906389, 53.75861],
                [-9.896946, 53.762497],
                [-9.851946, 53.76944],
                [-9.84639, 53.770271],
                [-9.68417, 53.784164],
                [-9.63444, 53.783333],
                [-9.630001, 53.78083],
                [-9.62444, 53.779442],
                [-9.61, 53.778885000000116],
                [-9.587778, 53.784439000000134],
                [-9.56806, 53.795273],
                [-9.56944, 53.799438],
                [-9.581945, 53.80055],
                [-9.588057, 53.80194],
                [-9.617224, 53.811943],
                [-9.62028, 53.814995],
                [-9.614168, 53.83527400000014],
                [-9.61028, 53.837776],
                [-9.60167, 53.841385],
                [-9.589169, 53.843048],
                [-9.57806, 53.845833],
                [-9.56139, 53.8597180000001],
                [-9.56639, 53.890831000000105],
                [-9.56778, 53.894722],
                [-9.6975, 53.89666000000011],
                [-9.72556, 53.895828],
                [-9.76445, 53.89444],
                [-9.77083, 53.893608],
                [-9.775278, 53.89194],
                [-9.77917, 53.88971700000013],
                [-9.785002, 53.883606],
                [-9.79306, 53.879166],
                [-9.81778, 53.871109],
                [-9.84139, 53.866943],
                [-9.89667, 53.85860400000013],
                [-9.91, 53.857498],
                [-9.936668, 53.8647160000001],
                [-9.940556, 53.866943],
                [-9.94278, 53.869995],
                [-9.91278, 53.94944],
                [-9.90833, 53.95138],
                [-9.896389, 53.953606],
                [-9.864779, 53.951496],
                [-9.861112, 53.951496],
                [-9.817501, 53.941383],
                [-9.81194, 53.93972],
                [-9.809723, 53.93666100000013],
                [-9.80778, 53.928886],
                [-9.81111, 53.92610900000011],
                [-9.8125, 53.923332],
                [-9.80583, 53.913605],
                [-9.80278, 53.91083],
                [-9.7975, 53.909439],
                [-9.791945, 53.909996],
                [-9.785002, 53.914719],
                [-9.78472, 53.91944100000012],
                [-9.787779, 53.9419400000001],
                [-9.79139, 53.948883],
                [-9.82894, 53.979774],
                [-9.85328, 53.99844],
                [-9.935835, 54.060829],
                [-9.93861, 54.110832],
                [-9.92639, 54.123886],
                [-9.94883, 54.18005],
                [-9.950667, 54.181717000000106],
                [-10.00611, 54.21889],
                [-10.013056, 54.219444],
                [-10.017223, 54.217216],
                [-10.083612, 54.148605],
                [-10.07167, 54.125549],
                [-10.06444, 54.095551000000114],
                [-10.06444, 54.09166],
                [-10.06695, 54.088608],
                [-10.078611, 54.08638800000011],
                [-10.08639, 54.08638800000011],
                [-10.10583, 54.088882],
                [-10.116667, 54.09166],
                [-10.12444, 54.09638200000012],
                [-10.127501, 54.09916],
                [-10.128889, 54.111938],
                [-10.11222, 54.229996],
                [-10.08167, 54.257217],
                [-10.06444, 54.269440000000145],
                [-10.00889, 54.300827],
                [-10.003056, 54.30138],
                [-9.99778, 54.300827],
                [-9.88583, 54.260826],
                [-9.88417, 54.258331],
                [-9.89417, 54.24555],
                [-9.905556, 54.23360400000013],
                [-9.92389, 54.221382],
                [-9.93, 54.220276000000126],
                [-9.942501, 54.21833],
                [-9.95056, 54.218605],
                [-9.95889, 54.22222],
                [-9.962778, 54.224998],
                [-9.96722, 54.23138],
                [-9.971111, 54.23333],
                [-9.976667, 54.235275],
                [-9.982779, 54.233887],
                [-9.98389, 54.23027000000013],
                [-9.98306, 54.225555],
                [-9.979445, 54.21833],
                [-9.974167, 54.21333],
                [-9.9625, 54.210274],
                [-9.92028, 54.20694],
                [-9.898056, 54.20694],
                [-9.892778, 54.208054],
                [-9.88889, 54.21054800000013],
                [-9.871113, 54.225555],
                [-9.851946, 54.269440000000145],
                [-9.84694, 54.31139],
                [-9.848333, 54.315552],
                [-9.84806, 54.319717],
                [-9.84639, 54.322777],
                [-9.843334, 54.32555],
                [-9.83861, 54.32777],
                [-9.803057, 54.333885],
                [-9.79667, 54.33472],
                [-9.753056, 54.328331],
                [-9.740557, 54.32555],
                [-9.58722, 54.3127750000001],
                [-9.4975, 54.313049],
                [-9.33639, 54.3169400000001],
                [-9.26583, 54.297493],
                [-9.211945, 54.27471900000012],
                [-9.209723, 54.27166],
                [-9.19806, 54.23693800000012],
                [-9.150557, 54.177773],
                [-9.131773, 54.159683],
                [-9.135, 54.171944],
                [-9.13139, 54.20082900000011],
                [-9.060556, 54.279716],
                [-9.056391, 54.281944],
                [-9.047501, 54.285553],
                [-9.04139, 54.286942],
                [-9.02639, 54.286659],
                [-8.93694, 54.283607],
                [-8.93028, 54.282776],
                [-8.91833, 54.280273],
                [-8.91389, 54.2783280000001],
                [-8.74861, 54.263329],
                [-8.62, 54.257217],
                [-8.47806, 54.273048],
                [-8.471668, 54.27388800000011],
                [-8.511112, 54.322495],
                [-8.519445, 54.326111],
                [-8.529446, 54.329163],
                [-8.58389, 54.339439],
                [-8.59167, 54.339722],
                [-8.604445, 54.338051],
                [-8.62667, 54.333054],
                [-8.647223, 54.33111],
                [-8.66639, 54.33777600000013],
                [-8.66861, 54.34166],
                [-8.669168, 54.345276],
                [-8.668335, 54.349442000000124],
                [-8.66167, 54.35527],
                [-8.65111, 54.36222],
                [-8.43445, 54.447495],
                [-8.395557, 54.461937],
                [-8.38098, 54.467087],
                [-8.34833, 54.469994],
                [-8.28444, 54.473328],
                [-8.268057, 54.51944],
                [-8.26611, 54.524162],
                [-8.20111, 54.573051000000135],
                [-8.17, 54.591385],
                [-8.188334, 54.6336060000001],
                [-8.39056, 54.624443],
                [-8.559723, 54.61332700000014],
                [-8.58445, 54.609718],
                [-8.62667, 54.61777500000011],
                [-8.68, 54.628052],
                [-8.702778, 54.64222000000012],
                [-8.74861, 54.648048],
                [-8.788334, 54.657494],
                [-8.79139, 54.659721000000104],
                [-8.800835, 54.691666],
                [-8.79972, 54.695274],
                [-8.79639, 54.698051],
                [-8.74417, 54.72527300000013],
                [-8.73528, 54.729439],
                [-8.669168, 54.75972000000013],
                [-8.62361, 54.76944],
                [-8.61806, 54.770554],
                [-8.533611, 54.784439],
                [-8.52639, 54.784721],
                [-8.490835, 54.79361],
                [-8.36861, 54.831940000000145],
                [-8.35389, 54.839439],
                [-8.31583, 54.86972],
                [-8.31417, 54.872772],
                [-8.31611, 54.87638900000013],
                [-8.335556, 54.901108],
                [-8.339169, 54.90361000000013],
                [-8.34556, 54.905],
                [-8.3525, 54.905273],
                [-8.37195, 54.903053],
                [-8.38333, 54.900551],
                [-8.38194, 54.89222],
                [-8.37861, 54.88472],
                [-8.38139, 54.8811],
                [-8.38611, 54.879997],
                [-8.396946, 54.882774],
                [-8.4375, 54.89694],
                [-8.45667, 54.9138870000001],
                [-8.45833, 54.921104],
                [-8.459723, 54.93833],
                [-8.4, 54.93354],
                [-8.38512, 54.941982],
                [-8.40289, 54.952869],
                [-8.427325, 54.96664],
                [-8.457779, 54.99499500000013],
                [-8.45667, 54.998604000000114],
                [-8.3175, 55.108887],
                [-8.181667, 55.141937],
                [-8.022223, 55.181664000000126],
                [-7.98145, 55.216457],
                [-7.94591, 55.19646],
                [-7.899699, 55.177803],
                [-7.872595, 55.199131],
                [-7.859266, 55.22179],
                [-7.79351, 55.243118],
                [-7.796173, 55.220013],
                [-7.81439, 55.203129],
                [-7.810835, 55.176472],
                [-7.770847, 55.183578],
                [-7.712197, 55.1587],
                [-7.70287, 55.14581],
                [-7.696646, 55.128929],
                [-7.70211, 55.11073],
                [-7.705, 55.09805],
                [-7.70389, 55.094162],
                [-7.696667, 55.093048],
                [-7.693334, 55.095276],
                [-7.66778, 55.141937],
                [-7.6675, 55.146385],
                [-7.67667, 55.16777],
                [-7.69861, 55.214165],
                [-7.70556, 55.21888700000011],
                [-7.71111, 55.220551000000114],
                [-7.71667, 55.219719],
                [-7.720278, 55.21666],
                [-7.721667, 55.20805],
                [-7.721111, 55.19472],
                [-7.71131, 55.173805],
                [-7.715751, 55.171139],
                [-7.73797, 55.179138],
                [-7.75352, 55.1898],
                [-7.788175, 55.2013510000001],
                [-7.79173, 55.21201700000012],
                [-7.76507, 55.230679],
                [-7.73663, 55.245785],
                [-7.69861, 55.26194],
                [-7.67, 55.271942],
                [-7.6575, 55.274437],
                [-7.63639, 55.26805100000013],
                [-7.62861, 55.263054],
                [-7.528611, 55.12805],
                [-7.525278, 55.120552],
                [-7.526112, 55.111938],
                [-7.53056, 55.09583],
                [-7.538611, 55.086662],
                [-7.544445, 55.085274],
                [-7.56361, 55.083054],
                [-7.575, 55.075554],
                [-7.598333, 55.061104],
                [-7.616667, 55.053886],
                [-7.63639, 55.03833],
                [-7.683056, 54.955276],
                [-7.683333, 54.95166],
                [-7.68139, 54.948326],
                [-7.66333, 54.95388800000012],
                [-7.64417, 54.961105],
                [-7.608334, 54.982216],
                [-7.57583, 55.00499700000012],
                [-7.56361, 55.012215],
                [-7.521945, 55.02833],
                [-7.51722, 55.029999],
                [-7.506667, 55.033051000000114],
                [-7.47778, 55.039444],
                [-7.47139, 55.039719000000105],
                [-7.46, 55.042496],
                [-7.4525, 55.047493],
                [-7.446945, 55.053604],
                [-7.446112, 55.057777],
                [-7.45417, 55.127777],
                [-7.45583, 55.135551000000135],
                [-7.51472, 55.179718],
                [-7.525278, 55.186386],
                [-7.54472, 55.19444],
                [-7.54972, 55.200554],
                [-7.551111, 55.204163],
                [-7.55056, 55.20888],
                [-7.5475, 55.21694200000013],
                [-7.51194, 55.274437],
                [-7.391389, 55.29027600000012],
                [-7.354445, 55.33361100000013],
                [-7.39889, 55.37722],
                [-7.393889, 55.37944],
                [-7.37944, 55.380272000000105],
                [-7.373889, 55.379715],
                [-7.240834, 55.351944],
                [-7.190834, 55.333885],
                [-7.1825, 55.329437],
                [-7.05194, 55.27166000000011],
                [-6.956112, 55.249443],
                [-6.93861, 55.241104],
                [-6.931667, 55.235832],
                [-6.935834, 55.219719],
                [-6.953611, 55.211662],
                [-7.067223, 55.174438],
                [-7.14417, 55.15083],
                [-7.15917, 55.14583],
                [-7.18361, 55.131943],
                [-7.1975, 55.121384],
                [-7.25251, 55.070595],
                [-7.32639, 55.04527300000012],
                [-7.40639, 54.953331],
              ],
            ],
          ],
        },
        id: 8,
        NAME: 'Ireland',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Greece',
          id: 9,
          label: 'Greece',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.258,
          year: '2023',
          centroid: [21.8243, 39.0742],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [24.128609, 34.85666700000013],
                [24.128609, 34.808884],
                [24.119164000000126, 34.809166],
                [24.08333, 34.82444],
                [24.069443, 34.8324970000001],
                [24.0627750000001, 34.8366620000001],
                [24.04472, 34.849998],
                [24.044998, 34.85416],
                [24.074718, 34.868607],
                [24.10555, 34.865829],
                [24.12361, 34.86083200000013],
                [24.127777, 34.859161],
                [24.128609, 34.85666700000013],
              ],
            ],
            [
              [
                [26.900555, 35.358887],
                [26.880554, 35.34333],
                [26.85666700000013, 35.350555],
                [26.853333000000134, 35.35249],
                [26.85055, 35.357498],
                [26.84972, 35.372215],
                [26.898052, 35.42],
                [26.901665, 35.421661],
                [26.99694, 35.434441],
                [27.016109000000142, 35.43222000000014],
                [27.019997000000103, 35.430832],
                [26.998333, 35.40416],
                [26.964443, 35.392776],
                [26.900555, 35.358887],
              ],
            ],
            [
              [
                [23.858608, 35.52166],
                [23.97138600000011, 35.51471700000013],
                [23.99555, 35.515549],
                [24.03861000000012, 35.52871700000014],
                [24.042942, 35.530548000000124],
                [24.069611000000123, 35.54805],
                [24.071276, 35.549553],
                [24.071775000000116, 35.551552],
                [24.08333, 35.568054],
                [24.07888800000012, 35.573608],
                [24.0775, 35.57666],
                [24.07777, 35.580551],
                [24.079166, 35.58361100000013],
                [24.084999, 35.588333],
                [24.118053, 35.599998],
                [24.12611, 35.601944],
                [24.13528, 35.599998],
                [24.172222, 35.590553],
                [24.18055, 35.587219],
                [24.205276, 35.54277],
                [24.205276, 35.53889],
                [24.203888, 35.534996],
                [24.187222, 35.509995],
                [24.18388700000014, 35.508331],
                [24.169441, 35.502777],
                [24.161942, 35.50027],
                [24.140553, 35.503326],
                [24.128777, 35.49738],
                [24.11394, 35.498215],
                [24.111441, 35.497719],
                [24.109444, 35.496719],
                [24.106108, 35.493885],
                [24.103109, 35.49055],
                [24.102608, 35.488384],
                [24.103943, 35.48672],
                [24.105942, 35.48555],
                [24.174164, 35.453606],
                [24.18388700000014, 35.45111],
                [24.266109000000142, 35.36722],
                [24.271942000000138, 35.36249500000014],
                [24.285, 35.358604],
                [24.319721, 35.35166],
                [24.334442, 35.351105],
                [24.348053, 35.35166],
                [24.366108, 35.35305],
                [24.464722, 35.361938],
                [24.484165, 35.364716],
                [24.496666, 35.366661],
                [24.588608, 35.38110400000011],
                [24.600555, 35.38361],
                [24.60805, 35.386108],
                [24.61805, 35.39138800000012],
                [24.629444, 35.40055100000012],
                [24.78889, 35.408882],
                [24.963333, 35.404442],
                [25.04639, 35.383888],
                [25.04472, 35.37971],
                [25.045277, 35.369438000000116],
                [25.048611, 35.35583],
                [25.049999, 35.35278],
                [25.054996, 35.347771],
                [25.063889, 35.344719],
                [25.201385, 35.334442],
                [25.280552, 35.33388500000012],
                [25.302498, 35.335548],
                [25.363052, 35.33583],
                [25.377220000000136, 35.335548],
                [25.38749700000011, 35.333328],
                [25.390274, 35.33083],
                [25.39694, 35.315277],
                [25.40472, 35.30778],
                [25.429996, 35.294441],
                [25.445274, 35.29166],
                [25.46333, 35.292496],
                [25.491108, 35.29860700000012],
                [25.564442, 35.318604],
                [25.618053, 35.333328],
                [25.658054000000106, 35.3425],
                [25.662777, 35.3425],
                [25.7666660000001, 35.334717],
                [25.768887, 35.331940000000145],
                [25.767220000000123, 35.328049],
                [25.765274, 35.324715],
                [25.75777, 35.31611],
                [25.746109, 35.30722],
                [25.732777000000112, 35.300278],
                [25.73, 35.29805],
                [25.728333, 35.294167],
                [25.722775000000127, 35.263885],
                [25.728333, 35.259163],
                [25.73305, 35.257774],
                [25.737221, 35.2586060000001],
                [25.739441000000113, 35.26194],
                [25.741386, 35.269722],
                [25.741386, 35.2736],
                [25.742758, 35.286358],
                [25.754139000000123, 35.28257],
                [25.756208, 35.27118],
                [25.755173, 35.25359300000014],
                [25.739307, 35.23187],
                [25.71833, 35.219162],
                [25.71722, 35.214722],
                [25.71027800000013, 35.174438],
                [25.710831, 35.171104],
                [25.717499, 35.15916],
                [25.7280540000001, 35.14194],
                [25.75666, 35.12638900000013],
                [25.78, 35.115555],
                [25.788055, 35.112221],
                [25.797497, 35.1097180000001],
                [25.80805, 35.10805],
                [25.81583, 35.109993000000145],
                [25.82805, 35.11833],
                [25.866943, 35.152222],
                [25.896111, 35.176941],
                [26.02666, 35.224442],
                [26.030552, 35.22555],
                [26.039997, 35.22527300000013],
                [26.093052, 35.21666],
                [26.111942000000113, 35.205276],
                [26.217777, 35.24055],
                [26.301109, 35.28305],
                [26.29055, 35.131104],
                [26.275, 35.087494],
                [26.241943, 35.039719],
                [26.237499, 35.033607],
                [26.205555, 35.02166],
                [26.142498, 34.99916100000013],
                [26.13861100000014, 34.998055],
                [26.11972, 34.992775],
                [26.110832, 34.992218],
                [26.10611, 34.993332],
                [26.102776, 34.995552],
                [26.101109000000122, 35.00222],
                [26.101109000000122, 35.00610400000011],
                [26.09972, 35.009163],
                [26.095, 35.01416],
                [26.086666, 35.017494],
                [25.987499000000128, 35.033051],
                [25.59694, 35.00972000000013],
                [25.589443, 35.00722],
                [25.582222, 35.0044400000001],
                [25.560833, 34.996109],
                [25.557499, 34.994438000000116],
                [25.552219, 34.989441],
                [25.513332, 34.98194100000012],
                [25.50444, 34.981384],
                [25.33527800000013, 34.984993],
                [25.188053, 34.95221700000013],
                [25.016941, 34.93083],
                [24.928055, 34.93055],
                [24.82111, 34.937492],
                [24.752777, 34.94221],
                [24.75583, 34.95027],
                [24.762775, 35.015831],
                [24.759163, 35.033051],
                [24.7561070000001, 35.046661],
                [24.744164, 35.0711060000001],
                [24.739998, 35.076385],
                [24.723053, 35.09055],
                [24.698608, 35.096664],
                [24.69361, 35.096939],
                [24.685833000000116, 35.094994],
                [24.676941, 35.09416],
                [24.638611, 35.095276000000126],
                [24.588608, 35.096939],
                [24.565552, 35.098053],
                [24.560833, 35.103333],
                [24.547775, 35.119438],
                [24.535553, 35.135826],
                [24.526665, 35.142494],
                [24.399441, 35.18694],
                [24.385555, 35.19082600000013],
                [24.19666, 35.200272],
                [24.192219000000136, 35.200272],
                [24.139721, 35.199715],
                [24.10083, 35.197777],
                [24.070553, 35.19082600000013],
                [24.053333, 35.189995000000124],
                [24.04888, 35.189995000000124],
                [24.03833, 35.191109],
                [24.029442, 35.194160000000124],
                [24.026108, 35.19611],
                [23.946663, 35.221107],
                [23.89027, 35.23389],
                [23.824165, 35.246666],
                [23.81944, 35.24638],
                [23.702221, 35.233604],
                [23.694443, 35.23111],
                [23.681942000000106, 35.224442],
                [23.598331, 35.23055],
                [23.593609, 35.231941],
                [23.586666, 35.23583200000013],
                [23.521111, 35.288055],
                [23.519997000000103, 35.30194100000011],
                [23.569164, 35.526665],
                [23.582497, 35.569160000000124],
                [23.58388, 35.573051],
                [23.59388700000011, 35.59222],
                [23.606388, 35.613327],
                [23.608608, 35.61083],
                [23.609444, 35.60721600000011],
                [23.609722, 35.603607000000125],
                [23.609997, 35.567497],
                [23.613609, 35.52694],
                [23.616108, 35.52055400000012],
                [23.618332000000123, 35.51777600000014],
                [23.649166, 35.499718],
                [23.656944000000124, 35.496384],
                [23.666664, 35.496109000000104],
                [23.704441, 35.50193800000011],
                [23.718887, 35.5075],
                [23.724998, 35.511665],
                [23.727497, 35.514442000000145],
                [23.731941, 35.546104],
                [23.73028, 35.56316],
                [23.72694, 35.574715],
                [23.711388, 35.604164],
                [23.708054, 35.64416],
                [23.708332, 35.648331],
                [23.709442, 35.651939],
                [23.71722000000011, 35.66555],
                [23.738609, 35.68555],
                [23.741665000000125, 35.68777],
                [23.748608000000104, 35.686386],
                [23.77055, 35.67110400000013],
                [23.775555, 35.666107],
                [23.775276, 35.661942],
                [23.77277800000013, 35.659164],
                [23.76694, 35.648888],
                [23.76694, 35.645271],
                [23.772221, 35.613327],
                [23.781944, 35.564438],
                [23.784443, 35.554443000000106],
                [23.787498, 35.548332],
                [23.7925, 35.54333],
                [23.799721, 35.54028],
                [23.84361, 35.52388800000011],
                [23.848331, 35.522499],
                [23.858608, 35.52166],
              ],
            ],
            [
              [
                [27.157497, 35.44583100000011],
                [27.142220000000123, 35.399719],
                [27.12166600000012, 35.428604],
                [27.067497000000117, 35.592773],
                [27.066387, 35.596382],
                [27.06611, 35.604996],
                [27.067776, 35.60833],
                [27.12028, 35.66693900000013],
                [27.15833, 35.71888700000011],
                [27.16249800000014, 35.724716000000114],
                [27.163055, 35.728882],
                [27.158607, 35.746941000000106],
                [27.158607, 35.76944],
                [27.16, 35.79583],
                [27.213333, 35.825554000000125],
                [27.21722000000011, 35.826942],
                [27.22805, 35.82638500000013],
                [27.23139, 35.82444],
                [27.230831, 35.811104],
                [27.215553, 35.724716000000114],
                [27.212498, 35.718048000000124],
                [27.177498000000128, 35.601105],
                [27.202221, 35.47805],
                [27.16222, 35.45111],
                [27.157497, 35.44583100000011],
              ],
            ],
            [
              [
                [23.332222, 35.825272],
                [23.329998000000103, 35.82249500000012],
                [23.325554000000125, 35.82333],
                [23.298054, 35.8511],
                [23.29583, 35.853882],
                [23.278889000000106, 35.88388800000013],
                [23.27333, 35.89638500000012],
                [23.273052, 35.89999],
                [23.275833, 35.899162],
                [23.28083, 35.893883],
                [23.303333, 35.887497],
                [23.31416, 35.883331],
                [23.31778, 35.881386],
                [23.325832, 35.87221],
                [23.32917, 35.866104],
                [23.331944, 35.852219],
                [23.332222, 35.825272],
              ],
            ],
            [
              [
                [23.049442, 36.13694],
                [23.045830000000137, 36.135826],
                [23.040554, 36.136108],
                [22.997219, 36.141937],
                [22.988052, 36.14611100000013],
                [22.929996, 36.17805],
                [22.922775, 36.185829],
                [22.91222, 36.19944],
                [22.91111, 36.20277],
                [22.906387, 36.22583],
                [22.89583, 36.31832900000012],
                [22.895275, 36.325829],
                [22.926109, 36.377495],
                [22.929443, 36.3794400000001],
                [22.951664000000108, 36.386108],
                [22.958054, 36.381943],
                [22.95916, 36.378609],
                [22.95694, 36.377495],
                [22.97, 36.354164],
                [22.987778, 36.32499700000011],
                [22.989998, 36.32222],
                [23.00555400000013, 36.307495],
                [23.00972, 36.30583200000012],
                [23.02027500000014, 36.303886],
                [23.085552, 36.25944],
                [23.101387000000102, 36.248604000000114],
                [23.10722, 36.243889],
                [23.10833, 36.23694],
                [23.05722, 36.145],
                [23.049442, 36.13694],
              ],
            ],
            [
              [
                [25.83888, 36.34805],
                [25.778606, 36.345551],
                [25.767773, 36.346931],
                [25.73889, 36.35499600000014],
                [25.731667, 36.362778000000105],
                [25.730270000000132, 36.366096],
                [25.730270000000132, 36.36971],
                [25.733604000000128, 36.377495],
                [25.767220000000123, 36.40083],
                [25.771111, 36.40193],
                [25.798328, 36.389153000000135],
                [25.85693700000013, 36.358887],
                [25.85693700000013, 36.35499600000014],
                [25.854443, 36.352219],
                [25.851662, 36.3499910000001],
                [25.847775, 36.348885],
                [25.83888, 36.34805],
              ],
            ],
            [
              [
                [25.399162, 36.39444],
                [25.394722, 36.39444],
                [25.391663, 36.39666],
                [25.390831000000105, 36.403885000000116],
                [25.391388, 36.408051],
                [25.393887, 36.410828],
                [25.397778, 36.411942],
                [25.401665, 36.411942],
                [25.406666, 36.41055300000011],
                [25.41, 36.408333],
                [25.410275, 36.404709],
                [25.4086, 36.40083],
                [25.40611, 36.398041],
                [25.399162, 36.39444],
              ],
            ],
            [
              [
                [27.78666, 35.890549],
                [27.781387, 35.890274],
                [27.76861, 35.893608],
                [27.73305, 35.91111],
                [27.730274, 35.91333],
                [27.72861, 35.916664],
                [27.722221, 35.929718],
                [27.719166, 35.94082600000013],
                [27.72138600000011, 35.94944],
                [27.730831000000137, 35.97888],
                [27.740829000000133, 36.10443900000013],
                [27.719719, 36.1661],
                [27.788883000000112, 36.251656],
                [27.80305, 36.268326],
                [27.805832, 36.27055400000012],
                [27.876106, 36.31971],
                [27.895828, 36.332222],
                [27.909161, 36.339722],
                [28.068333, 36.404999],
                [28.107494, 36.41861],
                [28.207222000000115, 36.44249],
                [28.210831, 36.452492],
                [28.21277, 36.455544000000145],
                [28.21583, 36.45776400000011],
                [28.21917, 36.456940000000145],
                [28.22583, 36.453049],
                [28.23389, 36.441376],
                [28.238049, 36.431107],
                [28.206944, 36.343597],
                [28.186939, 36.29999],
                [28.141388, 36.210541],
                [28.12277, 36.185822000000144],
                [28.063606, 36.111931],
                [28.009163, 36.068886],
                [27.95666100000011, 36.044991],
                [27.945827, 36.03471400000012],
                [27.931664, 36.0186],
                [27.906109, 35.98805],
                [27.898888000000113, 35.975555],
                [27.89277600000014, 35.96083],
                [27.865555, 35.93222],
                [27.842777000000126, 35.91360500000013],
                [27.839443, 35.911659],
                [27.79972, 35.893326],
                [27.78666, 35.890549],
              ],
            ],
            [
              [
                [27.40027, 36.372498],
                [27.395554, 36.371666],
                [27.317776, 36.410828],
                [27.297497, 36.42221100000012],
                [27.29472, 36.42443100000014],
                [27.29583, 36.461098000000106],
                [27.297771, 36.4644320000001],
                [27.303055, 36.46916],
                [27.354443, 36.476662],
                [27.358887, 36.475548],
                [27.362221, 36.47361000000012],
                [27.44305, 36.41111],
                [27.445827000000122, 36.4086],
                [27.447495000000117, 36.40554],
                [27.44722, 36.401665],
                [27.438889, 36.39138800000012],
                [27.4175, 36.37665600000014],
                [27.413326, 36.37554],
                [27.40027, 36.372498],
              ],
            ],
            [
              [
                [25.457771, 36.33361],
                [25.44722000000013, 36.329163],
                [25.420267, 36.33901],
                [25.38485, 36.3446],
                [25.41944, 36.362488],
                [25.430054, 36.3968],
                [25.41607, 36.43036],
                [25.391371, 36.456924],
                [25.37055, 36.463608000000136],
                [25.369164, 36.46666],
                [25.368889, 36.470276000000126],
                [25.371941, 36.472488],
                [25.3825, 36.477219000000105],
                [25.400272, 36.474442],
                [25.421104, 36.469994],
                [25.427498, 36.465546],
                [25.45083, 36.446938],
                [25.453606, 36.44444],
                [25.48, 36.4161],
                [25.486382, 36.408051],
                [25.488888, 36.397774],
                [25.484997000000135, 36.3591540000001],
                [25.46917, 36.34332300000011],
                [25.457771, 36.33361],
              ],
            ],
            [
              [
                [26.342216, 36.506386],
                [26.31805, 36.50471],
                [26.312492, 36.50499],
                [26.304440000000113, 36.507767],
                [26.297218, 36.511101],
                [26.288609000000122, 36.518044],
                [26.286942, 36.52111],
                [26.270554, 36.55610700000011],
                [26.26221500000014, 36.576935],
                [26.259995000000117, 36.58416],
                [26.260830000000112, 36.58833],
                [26.262497, 36.59166],
                [26.26527, 36.59388000000013],
                [26.38028, 36.640266],
                [26.385551, 36.640549],
                [26.40610900000013, 36.63388],
                [26.409443000000124, 36.63221],
                [26.458328000000108, 36.600822],
                [26.46054800000013, 36.59805300000011],
                [26.472218, 36.57998700000013],
                [26.471104, 36.578331],
                [26.466660000000104, 36.576378],
                [26.405827, 36.565269],
                [26.35416, 36.51944],
                [26.35583, 36.51166],
                [26.35583, 36.508041],
                [26.342216, 36.506386],
              ],
            ],
            [
              [
                [27.854717, 36.527222],
                [27.840275, 36.524994000000106],
                [27.796661, 36.551941],
                [27.79055, 36.55610700000011],
                [27.764996, 36.574997],
                [27.768887, 36.585831],
                [27.812492, 36.62805200000014],
                [27.82694, 36.641388],
                [27.834438, 36.64444],
                [27.851109000000122, 36.649155],
                [27.85527, 36.650269],
                [27.859718, 36.650269],
                [27.865555, 36.641388],
                [27.866665, 36.637772],
                [27.872772, 36.61472],
                [27.876106, 36.59861],
                [27.87638900000013, 36.594437],
                [27.87527, 36.542763],
                [27.873882, 36.538879],
                [27.858051, 36.528885],
                [27.854717, 36.527222],
              ],
            ],
            [
              [
                [24.950275, 36.590553],
                [24.94555, 36.590553],
                [24.924442000000113, 36.59333],
                [24.915276, 36.596107],
                [24.85694100000012, 36.636383],
                [24.851387000000102, 36.64111],
                [24.8425, 36.651939],
                [24.84111000000013, 36.654999],
                [24.840832, 36.65888],
                [24.843887, 36.659721000000104],
                [24.85555, 36.661942],
                [24.85972, 36.662498],
                [24.868889000000138, 36.66138500000011],
                [24.938332, 36.632774],
                [24.95333, 36.62138],
                [24.954720000000123, 36.618332],
                [24.9625, 36.5991590000001],
                [24.961388000000113, 36.59471900000011],
                [24.958332, 36.592499],
                [24.950275, 36.590553],
              ],
            ],
            [
              [
                [25.089722, 36.63388],
                [25.07694, 36.63194],
                [25.06694, 36.63388],
                [25.063606, 36.63582],
                [25.063889, 36.639992],
                [25.102219, 36.69333],
                [25.141388, 36.7158280000001],
                [25.145828, 36.71666],
                [25.18777, 36.71666],
                [25.188332, 36.714722],
                [25.18416600000012, 36.705544],
                [25.156666, 36.675545],
                [25.13528, 36.660553],
                [25.119717, 36.650269],
                [25.099716, 36.639153],
                [25.089722, 36.63388],
              ],
            ],
            [
              [
                [21.785831000000144, 36.736938],
                [21.775, 36.69778],
                [21.76722, 36.701385],
                [21.75055300000014, 36.712494000000106],
                [21.748886, 36.715553],
                [21.748608, 36.719162],
                [21.74944, 36.722771],
                [21.757500000000107, 36.752495000000124],
                [21.760555000000124, 36.754997],
                [21.764442, 36.754997],
                [21.783333, 36.74333200000012],
                [21.785553, 36.74082900000013],
                [21.785831000000144, 36.736938],
              ],
            ],
            [
              [
                [24.413609, 36.66027100000014],
                [24.33083, 36.649994],
                [24.32694, 36.651108000000136],
                [24.324718, 36.652771],
                [24.32278, 36.659721000000104],
                [24.323055, 36.667496],
                [24.34055, 36.73305],
                [24.34389, 36.74082900000013],
                [24.349163, 36.746109],
                [24.352776, 36.74777200000011],
                [24.513332, 36.767494],
                [24.526943, 36.767494],
                [24.535831000000144, 36.764717],
                [24.548054, 36.7594380000001],
                [24.549442000000113, 36.75639],
                [24.550552, 36.700554],
                [24.548332, 36.691666],
                [24.544441, 36.684441],
                [24.54055, 36.677773],
                [24.53805, 36.674995],
                [24.53472, 36.67305],
                [24.476944, 36.662773],
                [24.413609, 36.66027100000014],
              ],
            ],
            [
              [
                [25.385551, 36.651665],
                [25.357777, 36.644997],
                [25.342773000000136, 36.651665],
                [25.33972200000011, 36.65416],
                [25.25861, 36.728882],
                [25.26194, 36.762772],
                [25.26416, 36.76638800000012],
                [25.275829, 36.78138000000013],
                [25.279160000000104, 36.783333],
                [25.30305, 36.789162],
                [25.308048, 36.788322],
                [25.32611100000014, 36.775826],
                [25.407219, 36.717766],
                [25.40833, 36.715271],
                [25.39222, 36.66111000000012],
                [25.389439, 36.652771],
                [25.385551, 36.651665],
              ],
            ],
            [
              [
                [24.66277700000012, 36.747498],
                [24.658607, 36.746666],
                [24.648609, 36.746941000000106],
                [24.62833000000012, 36.74944],
                [24.624996000000124, 36.751389],
                [24.62055, 36.756943],
                [24.609722, 36.778328],
                [24.611942, 36.781662],
                [24.619999, 36.78805],
                [24.62389, 36.789444],
                [24.64222, 36.7888870000001],
                [24.645554, 36.787498],
                [24.66527600000012, 36.776382000000126],
                [24.670277, 36.767494],
                [24.67083, 36.759995],
                [24.670277, 36.755829],
                [24.665833, 36.749718],
                [24.66277700000012, 36.747498],
              ],
            ],
            [
              [
                [21.698608, 36.739166],
                [21.693886, 36.73888],
                [21.69611, 36.772499],
                [21.699165, 36.785828],
                [21.704441, 36.796661],
                [21.70722, 36.799164],
                [21.728333, 36.79277],
                [21.728611000000114, 36.789162],
                [21.720554000000106, 36.770271],
                [21.71860900000013, 36.766937],
                [21.701111, 36.741943000000106],
                [21.698608, 36.739166],
              ],
            ],
            [
              [
                [24.558609000000104, 36.77555100000012],
                [24.549721, 36.774719],
                [24.544441, 36.77527600000013],
                [24.53805, 36.77971600000012],
                [24.53167, 36.78777300000013],
                [24.522221, 36.804993],
                [24.521111, 36.81221800000014],
                [24.521111, 36.823883],
                [24.522778, 36.827774],
                [24.559166, 36.848328],
                [24.562496, 36.84861000000012],
                [24.591942, 36.833885],
                [24.59916, 36.823883],
                [24.594997, 36.807777],
                [24.5925, 36.798882],
                [24.577774, 36.781662],
                [24.574718000000132, 36.779442],
                [24.558609000000104, 36.77555100000012],
              ],
            ],
            [
              [
                [25.459995, 36.82222],
                [25.45194, 36.820267],
                [25.432774, 36.820541000000105],
                [25.420277, 36.827766],
                [25.420830000000137, 36.83194],
                [25.422497, 36.835831],
                [25.4741590000001, 36.869164],
                [25.481384, 36.849152],
                [25.48333, 36.846931],
                [25.48333, 36.843323],
                [25.47944, 36.833611],
                [25.47694, 36.830826],
                [25.459995, 36.82222],
              ],
            ],
            [
              [
                [25.826664, 36.779709],
                [25.79444, 36.764153000000135],
                [25.769444, 36.764435],
                [25.761387000000127, 36.76722],
                [25.740273, 36.77777100000014],
                [25.736938000000123, 36.78443],
                [25.738605, 36.787491],
                [25.839439, 36.840546],
                [25.961941, 36.889435],
                [25.97666, 36.874161],
                [25.920551, 36.8361],
                [25.826664, 36.779709],
              ],
            ],
            [
              [
                [26.965832, 36.681664],
                [26.971386, 36.672211],
                [26.96666, 36.672493000000145],
                [26.953053, 36.675278],
                [26.946384000000137, 36.67915],
                [26.92305, 36.7061],
                [26.92083, 36.708878],
                [26.91861, 36.7161],
                [26.917770000000132, 36.755272],
                [26.921944, 36.761101],
                [27.060833000000116, 36.837212000000136],
                [27.06415900000013, 36.838875],
                [27.152493000000106, 36.881386],
                [27.168053, 36.887215],
                [27.177498000000128, 36.88888],
                [27.284443, 36.900551],
                [27.340549000000124, 36.88528],
                [27.346661, 36.881104],
                [27.35277600000012, 36.872208],
                [27.355553, 36.865273],
                [27.35527, 36.858887],
                [27.344166, 36.849442],
                [27.32944, 36.842766],
                [27.302498, 36.837494],
                [27.27944200000013, 36.83416],
                [27.243332, 36.82693],
                [27.218327, 36.8197100000001],
                [27.03611, 36.766106],
                [27.028049, 36.763611],
                [26.992222, 36.751389],
                [26.980553, 36.746941000000106],
                [26.97416, 36.742775],
                [26.971943000000124, 36.740273000000116],
                [26.970551, 36.736382],
                [26.96639, 36.70361],
                [26.965832, 36.681664],
              ],
            ],
            [
              [
                [25.680832, 36.878052],
                [25.672771, 36.87638900000013],
                [25.612778000000105, 36.88083],
                [25.609997, 36.883324],
                [25.60916, 36.886658],
                [25.614716, 36.891930000000116],
                [25.638882, 36.9033280000001],
                [25.651939, 36.906097],
                [25.668884, 36.899437],
                [25.671661, 36.89693],
                [25.683048, 36.883881],
                [25.68388, 36.880272],
                [25.680832, 36.878052],
              ],
            ],
            [
              [
                [25.076664000000108, 36.951935],
                [25.071663, 36.943871],
                [25.068886000000134, 36.946091],
                [25.027222, 36.981934],
                [25.024998, 36.98471100000012],
                [25.023605, 36.999146],
                [25.024162, 37.003319],
                [25.025829, 37.0072100000001],
                [25.034161, 37.014702],
                [25.05444, 37.03138],
                [25.057499, 37.0336],
                [25.06083, 37.035255],
                [25.079163000000108, 37.042480000000126],
                [25.083881, 37.042480000000126],
                [25.086941, 37.040543],
                [25.076664000000108, 36.951935],
              ],
            ],
            [
              [
                [24.711941, 36.903053000000114],
                [24.708054, 36.903053000000114],
                [24.695000000000107, 36.91555],
                [24.683052, 36.930275],
                [24.660275, 36.979721],
                [24.64, 37.029160000000104],
                [24.641109000000142, 37.042221],
                [24.649719, 37.04361],
                [24.661942000000124, 37.041382],
                [24.703053000000125, 37.029716],
                [24.70666, 37.027771],
                [24.740833, 36.99166],
                [24.74528, 36.986382],
                [24.765274, 36.958328],
                [24.766666, 36.955276],
                [24.76694, 36.95138],
                [24.76583, 36.9469380000001],
                [24.76111, 36.94082600000013],
                [24.73389, 36.918884],
                [24.724163, 36.91166],
                [24.711941, 36.903053000000114],
              ],
            ],
            [
              [
                [26.97555, 36.924431],
                [26.969719, 36.924431],
                [26.946384000000137, 36.928055],
                [26.935555000000136, 36.932213],
                [26.919167, 36.946663],
                [26.88194, 37.068886],
                [26.886662, 37.07332],
                [26.890831, 37.07638],
                [26.960548, 37.056107],
                [26.985828, 37.044167],
                [27.04832800000014, 36.993607],
                [27.049995, 36.99055],
                [27.049995, 36.949158000000125],
                [27.049438, 36.94611],
                [27.04583, 36.944153],
                [26.97555, 36.924431],
              ],
            ],
            [
              [
                [25.83444, 37.09304],
                [25.831944, 37.090271],
                [25.819443, 37.091385],
                [25.801662, 37.099442],
                [25.793884, 37.103043],
                [25.79055, 37.10499600000014],
                [25.783051, 37.116653],
                [25.78249, 37.119987],
                [25.785, 37.121384],
                [25.82555, 37.125542],
                [25.837215, 37.112488],
                [25.838608, 37.10944400000011],
                [25.836105, 37.096931],
                [25.83444, 37.09304],
              ],
            ],
            [
              [
                [25.250275, 37.008324],
                [25.191383, 36.973885],
                [25.165833, 36.979439],
                [25.152493, 36.98389],
                [25.123333, 36.994164000000126],
                [25.12027400000011, 36.996666],
                [25.10527, 37.011658],
                [25.0991590000001, 37.023888],
                [25.098328, 37.027489],
                [25.098885, 37.03138],
                [25.109997000000135, 37.057213],
                [25.132771000000105, 37.09332],
                [25.151382, 37.111931],
                [25.16333, 37.12166600000012],
                [25.22361, 37.140831],
                [25.2686, 37.138611],
                [25.284443, 37.128319],
                [25.26833, 37.052773],
                [25.26416, 37.039162],
                [25.250275, 37.008324],
              ],
            ],
            [
              [
                [26.886662, 37.09665700000011],
                [26.863888, 37.095276],
                [26.853886, 37.09665700000011],
                [26.849442, 37.097771],
                [26.820553, 37.11055],
                [26.769444, 37.169434],
                [26.768330000000105, 37.173325],
                [26.76916100000011, 37.176384],
                [26.778049, 37.187775],
                [26.7808270000001, 37.189995],
                [26.78555, 37.190819],
                [26.820553, 37.18721800000014],
                [26.855, 37.18277],
                [26.85833, 37.181107],
                [26.860554, 37.17722],
                [26.87249800000012, 37.150551],
                [26.888882, 37.1091540000001],
                [26.88972, 37.10166],
                [26.889164, 37.09861],
                [26.886662, 37.09665700000011],
              ],
            ],
            [
              [
                [25.461388, 36.919434],
                [25.45277, 36.91832000000011],
                [25.436939, 36.91999],
                [25.433331, 36.922211],
                [25.342773000000136, 37.07194],
                [25.341106, 37.075],
                [25.34666, 37.08638800000011],
                [25.349716000000114, 37.088608],
                [25.4961, 37.186378000000104],
                [25.503052, 37.189995],
                [25.50694, 37.191109],
                [25.535275000000127, 37.197777],
                [25.539444000000117, 37.198601],
                [25.54472, 37.198044],
                [25.54805, 37.19611],
                [25.565552, 37.180832],
                [25.576664, 37.16805],
                [25.583054, 37.159988],
                [25.59583, 37.135818],
                [25.600552, 37.118889],
                [25.600552, 37.11527],
                [25.59944, 37.106934],
                [25.59027, 37.057213],
                [25.58721500000013, 37.044167],
                [25.580273, 37.015549000000135],
                [25.556664, 36.957764],
                [25.554165, 36.95498700000013],
                [25.551105, 36.952766],
                [25.486382, 36.927773000000116],
                [25.461388, 36.919434],
              ],
            ],
            [
              [
                [24.53500000000014, 37.182495],
                [24.534164, 37.130554],
                [24.509163, 37.112778000000105],
                [24.501389, 37.11027],
                [24.49499900000012, 37.12166600000012],
                [24.492222, 37.12389],
                [24.460278, 37.135826],
                [24.45611, 37.136108],
                [24.43944, 37.132217],
                [24.433609, 37.127777],
                [24.42194400000011, 37.12389],
                [24.416943, 37.12444],
                [24.414719, 37.12722],
                [24.41528, 37.13110400000011],
                [24.421108, 37.156387],
                [24.430832000000123, 37.17139],
                [24.441944, 37.184166],
                [24.460278, 37.19583100000011],
                [24.479443, 37.201942],
                [24.492222, 37.202774],
                [24.515831, 37.201111],
                [24.531109, 37.19194],
                [24.533333, 37.18916300000012],
                [24.53472, 37.186104],
                [24.53500000000014, 37.182495],
              ],
            ],
            [
              [
                [26.767494, 37.186935],
                [26.763611, 37.185555],
                [26.759995, 37.186661],
                [26.76499600000011, 37.196663],
                [26.772221, 37.206657],
                [26.774998, 37.20887800000014],
                [26.779716, 37.209717000000126],
                [26.787495, 37.20694],
                [26.788609, 37.202209],
                [26.767494, 37.186935],
              ],
            ],
            [
              [
                [23.15667, 37.240273],
                [23.134998, 37.237221],
                [23.129719, 37.237495],
                [23.123333000000116, 37.241661000000136],
                [23.097775, 37.270828],
                [23.096107, 37.27388800000011],
                [23.096943000000124, 37.277496],
                [23.099442000000124, 37.278885],
                [23.115276, 37.28333],
                [23.119442, 37.28416],
                [23.125275, 37.28333],
                [23.13472000000013, 37.28],
                [23.150555, 37.27277400000014],
                [23.16027, 37.266388],
                [23.166111, 37.261665],
                [23.168331, 37.25888800000013],
                [23.166943000000117, 37.255829],
                [23.16222, 37.245552],
                [23.16027, 37.242218],
                [23.15667, 37.240273],
              ],
            ],
            [
              [
                [23.410831, 37.300827],
                [23.400276, 37.296104],
                [23.377777, 37.298607],
                [23.373886, 37.299721],
                [23.374443, 37.30249800000013],
                [23.385555, 37.31139],
                [23.388885, 37.313049],
                [23.4775, 37.35277600000012],
                [23.516109, 37.36472],
                [23.520554, 37.36555],
                [23.552498, 37.369438000000116],
                [23.561665, 37.36888900000014],
                [23.582497, 37.36610400000012],
                [23.583332, 37.36417],
                [23.575275, 37.356110000000115],
                [23.5, 37.316666],
                [23.496387, 37.315277],
                [23.44944, 37.313049],
                [23.414719000000105, 37.302216],
                [23.410831, 37.300827],
              ],
            ],
            [
              [
                [24.37944, 37.30583200000012],
                [24.374722, 37.30555],
                [24.37055, 37.30722],
                [24.367496, 37.309441000000106],
                [24.366665, 37.313049],
                [24.367496, 37.42360700000012],
                [24.36861, 37.427216],
                [24.371944, 37.433609000000104],
                [24.398609, 37.45916],
                [24.410275, 37.46833],
                [24.43861, 37.481941],
                [24.44278, 37.481667],
                [24.442497, 37.474716000000114],
                [24.44083000000012, 37.47083],
                [24.43055, 37.442215],
                [24.433331000000123, 37.43972],
                [24.445274, 37.431389],
                [24.46305500000011, 37.427498],
                [24.472221, 37.42694100000011],
                [24.48222, 37.408882],
                [24.483608, 37.40583],
                [24.48333, 37.39804800000013],
                [24.48167, 37.39388300000013],
                [24.44611, 37.3513870000001],
                [24.41639, 37.325554],
                [24.401665, 37.314163],
                [24.383331, 37.30694],
                [24.37944, 37.30583200000012],
              ],
            ],
            [
              [
                [25.359161, 37.40778],
                [25.3555530000001, 37.407219],
                [25.328053, 37.41776],
                [25.30999800000012, 37.469994],
                [25.309166, 37.473328],
                [25.310272, 37.481667],
                [25.313889, 37.488045],
                [25.331661, 37.495544],
                [25.349442, 37.501389],
                [25.401108, 37.49333200000012],
                [25.46054800000013, 37.472214],
                [25.463608, 37.469719],
                [25.463608, 37.46583],
                [25.462215, 37.449997],
                [25.461105, 37.446381],
                [25.457771, 37.44444],
                [25.371105, 37.410553],
                [25.359161, 37.40778],
              ],
            ],
            [
              [
                [24.952499, 37.385551000000135],
                [24.88444, 37.363609],
                [24.895275, 37.4952770000001],
                [24.89167, 37.497215],
                [24.889442, 37.500000000000114],
                [24.887775, 37.503052],
                [24.88694, 37.509995],
                [24.889721, 37.51249700000011],
                [24.909721, 37.5094380000001],
                [24.924999, 37.504997],
                [24.933331, 37.501389],
                [24.93972, 37.496384],
                [24.944164, 37.491104],
                [24.95111100000014, 37.475273],
                [24.971664, 37.406105],
                [24.9725, 37.402771],
                [24.969997, 37.399719],
                [24.95583, 37.38721],
                [24.952499, 37.385551000000135],
              ],
            ],
            [
              [
                [23.497776, 37.50471],
                [23.48389, 37.503883],
                [23.451942, 37.509163000000115],
                [23.44749800000011, 37.510826],
                [23.43305, 37.522774],
                [23.432777, 37.526665],
                [23.483608, 37.53777300000013],
                [23.518055, 37.525833],
                [23.5225, 37.524162],
                [23.523331, 37.520828],
                [23.515553000000125, 37.512772],
                [23.50972000000013, 37.50804900000014],
                [23.506386000000134, 37.506386],
                [23.497776, 37.50471],
              ],
            ],
            [
              [
                [25.228333, 37.534431],
                [25.205830000000105, 37.527222],
                [25.195827, 37.52748900000012],
                [25.168327, 37.532776],
                [25.113888, 37.551102],
                [24.994999, 37.639999],
                [24.97889, 37.662498],
                [24.975, 37.671944],
                [24.97583, 37.675552],
                [24.97972, 37.676666],
                [25.010551, 37.67749800000013],
                [25.04222, 37.676659],
                [25.053883, 37.67582],
                [25.07444, 37.652489],
                [25.083054, 37.649155],
                [25.137215, 37.644722],
                [25.184998, 37.641930000000116],
                [25.190552, 37.64111],
                [25.214165, 37.63221],
                [25.238888, 37.621941],
                [25.247498, 37.61444100000011],
                [25.250275, 37.611931],
                [25.25528, 37.591660000000104],
                [25.25555, 37.58387800000014],
                [25.254993, 37.579987],
                [25.231667, 37.536385],
                [25.228333, 37.534431],
              ],
            ],
            [
              [
                [24.29861, 37.526382],
                [24.285275, 37.524719],
                [24.27972000000011, 37.525551],
                [24.276943, 37.528053],
                [24.275276000000133, 37.53110500000014],
                [24.269165, 37.588882000000126],
                [24.269722000000115, 37.593048],
                [24.273609, 37.60833],
                [24.276108, 37.617218],
                [24.281666, 37.627777],
                [24.285831, 37.63472],
                [24.29833, 37.654999],
                [24.300831, 37.657776000000126],
                [24.327221, 37.677773],
                [24.334442, 37.68083200000012],
                [24.35083, 37.68222],
                [24.367222, 37.68222],
                [24.37028, 37.68222],
                [24.3941650000001, 37.673332],
                [24.41139, 37.654999],
                [24.41139, 37.651382],
                [24.397221, 37.619164000000126],
                [24.393055000000118, 37.612495],
                [24.381386, 37.596939],
                [24.371387, 37.58554800000013],
                [24.365833, 37.580551],
                [24.31472, 37.53611],
                [24.308887, 37.531662],
                [24.29861, 37.526382],
              ],
            ],
            [
              [
                [26.020828, 37.514435],
                [25.98416, 37.506943],
                [25.98083, 37.508881],
                [25.976944, 37.51499200000012],
                [25.975552, 37.5186],
                [25.974716000000114, 37.526932],
                [25.974716000000114, 37.53138],
                [25.981937, 37.544167],
                [25.98416, 37.54694400000011],
                [26.046944, 37.616379],
                [26.06444, 37.62999],
                [26.06805, 37.63194],
                [26.08083, 37.635544],
                [26.312492, 37.67999],
                [26.351383, 37.686378],
                [26.361111, 37.68666100000013],
                [26.361664000000133, 37.68333],
                [26.36055, 37.679436],
                [26.356937, 37.672493],
                [26.32333, 37.63472],
                [26.308331, 37.618889],
                [26.302498, 37.61444100000011],
                [26.267494000000113, 37.591103],
                [26.214993, 37.55888],
                [26.020828, 37.514435],
              ],
            ],
            [
              [
                [23.513054000000125, 37.691666],
                [23.486111, 37.6772160000001],
                [23.476387000000102, 37.679161],
                [23.464722, 37.68861],
                [23.431664, 37.73333000000014],
                [23.42388, 37.756386000000134],
                [23.423611, 37.75999],
                [23.425552, 37.762497],
                [23.428886, 37.764442],
                [23.465, 37.768051],
                [23.508053, 37.770271],
                [23.54166400000014, 37.77082800000011],
                [23.55722, 37.76722],
                [23.56389, 37.762772],
                [23.56472, 37.759438],
                [23.563332, 37.756386000000134],
                [23.558887, 37.75],
                [23.523609, 37.703606],
                [23.513054000000125, 37.691666],
              ],
            ],
            [
              [
                [27.06944, 37.711937],
                [27.06415900000013, 37.70694],
                [27.060555, 37.705269],
                [27.039719, 37.702766],
                [26.895554000000118, 37.665276],
                [26.81805, 37.636658],
                [26.753883, 37.691376],
                [26.746384, 37.694443],
                [26.711388000000113, 37.708321000000126],
                [26.705555000000118, 37.708321000000126],
                [26.68693900000011, 37.70498700000013],
                [26.649715, 37.698318],
                [26.641106, 37.696106],
                [26.62333, 37.687218],
                [26.620548, 37.684998],
                [26.613331, 37.680275],
                [26.59722, 37.67499],
                [26.59360900000013, 37.676941],
                [26.58166100000011, 37.685822],
                [26.580555, 37.688599],
                [26.571663000000115, 37.730553],
                [26.572777, 37.7341540000001],
                [26.59583, 37.7572100000001],
                [26.598885, 37.759438],
                [26.66555, 37.79054300000013],
                [26.66972, 37.791939],
                [26.729717, 37.808044],
                [26.743332000000123, 37.811104000000114],
                [26.748608, 37.811378],
                [26.988888, 37.781937],
                [27.02860600000014, 37.77166],
                [27.06694, 37.727219],
                [27.06944, 37.711937],
              ],
            ],
            [
              [
                [20.898052, 37.80527500000011],
                [20.99249600000013, 37.72527300000013],
                [20.99861, 37.713882],
                [20.994442, 37.698608],
                [20.943333, 37.71972],
                [20.924164000000133, 37.728607000000125],
                [20.91527600000012, 37.731667],
                [20.89583, 37.731110000000115],
                [20.87833, 37.728333],
                [20.87028, 37.726105],
                [20.866943, 37.72416],
                [20.84111, 37.687218],
                [20.83972200000011, 37.68333],
                [20.836109000000135, 37.64638500000012],
                [20.831108, 37.64638500000012],
                [20.812222, 37.651665],
                [20.808609000000104, 37.65361],
                [20.713608, 37.722771],
                [20.703331000000105, 37.732773],
                [20.629997000000117, 37.80888],
                [20.62722, 37.81749700000012],
                [20.61999900000012, 37.8475],
                [20.621944, 37.860832],
                [20.62861, 37.875549],
                [20.64333, 37.89833],
                [20.67833, 37.920555],
                [20.699718000000132, 37.930275],
                [20.702774, 37.92805],
                [20.79416700000013, 37.84888500000011],
                [20.863331, 37.829163],
                [20.886387000000127, 37.81443800000011],
                [20.898052, 37.80527500000011],
              ],
            ],
            [
              [
                [24.791664, 37.998329000000126],
                [24.962776, 37.872498],
                [24.998608, 37.767776],
                [24.998886, 37.76388500000013],
                [24.997219, 37.75999],
                [24.985832, 37.733604],
                [24.96027800000013, 37.685555000000136],
                [24.947498, 37.69305400000013],
                [24.91666400000014, 37.715553],
                [24.914444000000117, 37.718048],
                [24.873055, 37.76638800000012],
                [24.830555, 37.81443800000011],
                [24.768608, 37.871109],
                [24.765553, 37.873604],
                [24.752777, 37.87833],
                [24.736942000000113, 37.881104],
                [24.716942, 37.873329],
                [24.71333, 37.872772],
                [24.69361, 37.926941],
                [24.69028, 37.95138500000013],
                [24.69055200000014, 37.955551],
                [24.692219, 37.95944200000014],
                [24.69694, 37.965828],
                [24.703331, 37.96971900000011],
                [24.743889, 37.99055],
                [24.778053000000114, 37.996941],
                [24.791664, 37.998329000000126],
              ],
            ],
            [
              [
                [23.462498, 37.87861],
                [23.45833, 37.877777],
                [23.448055, 37.87944],
                [23.409164, 37.893326000000116],
                [23.405552000000114, 37.895271],
                [23.40361, 37.906944000000124],
                [23.410275, 37.929161],
                [23.437496000000124, 37.98583200000013],
                [23.484997, 37.999443],
                [23.49361, 38.000832000000116],
                [23.50111, 37.999161],
                [23.50611, 37.998055],
                [23.519444, 37.99499500000013],
                [23.524441, 37.993607],
                [23.538887, 37.98583200000013],
                [23.54055, 37.982773],
                [23.547222, 37.931938000000116],
                [23.54611, 37.929718],
                [23.540276, 37.920555],
                [23.53722, 37.918053],
                [23.469444000000124, 37.882217],
                [23.462498, 37.87861],
              ],
            ],
            [
              [
                [20.612499, 38.39416],
                [20.68055, 38.2775],
                [20.811665, 38.121384],
                [20.813332000000116, 38.118332],
                [20.81361, 38.114441],
                [20.811943, 38.105553],
                [20.796665, 38.066666],
                [20.7925, 38.060272],
                [20.78805, 38.059441],
                [20.734997, 38.060829],
                [20.557777, 38.090553],
                [20.51722, 38.10249],
                [20.512775, 38.103882],
                [20.377777, 38.156662],
                [20.344444000000124, 38.174995],
                [20.34139, 38.17722],
                [20.34, 38.184441],
                [20.340832, 38.196938],
                [20.34222, 38.20082900000011],
                [20.356110000000115, 38.231941],
                [20.398609, 38.325554000000125],
                [20.44083, 38.32805],
                [20.442776, 38.324997],
                [20.47361, 38.309166],
                [20.478611, 38.308052],
                [20.483608, 38.30832700000013],
                [20.487221, 38.309715],
                [20.500553, 38.317215],
                [20.507221, 38.32111],
                [20.516388, 38.32777],
                [20.53639, 38.34471900000011],
                [20.54472, 38.3575],
                [20.546665, 38.361107],
                [20.547497, 38.36472],
                [20.550552, 38.387772],
                [20.547775000000115, 38.39416],
                [20.539719, 38.409439],
                [20.534443000000124, 38.43278],
                [20.533886, 38.436661],
                [20.536942000000124, 38.467773],
                [20.539165, 38.470551000000114],
                [20.543053, 38.471939],
                [20.548332, 38.471939],
                [20.562222000000133, 38.471107],
                [20.57111, 38.468048000000124],
                [20.612499, 38.39416],
              ],
            ],
            [
              [
                [20.735554, 38.309998],
                [20.719719, 38.305275],
                [20.714722, 38.306389],
                [20.707222, 38.309998],
                [20.699444, 38.317497],
                [20.67083, 38.35305],
                [20.644722, 38.398048],
                [20.61555, 38.462494000000106],
                [20.61333100000013, 38.469162],
                [20.614166000000125, 38.47361],
                [20.648888000000113, 38.5002750000001],
                [20.65667, 38.50110600000011],
                [20.671108, 38.49333200000012],
                [20.706387, 38.444717],
                [20.708054, 38.44194],
                [20.743332, 38.37249800000012],
                [20.761108, 38.325272],
                [20.760277, 38.321663],
                [20.735554, 38.309998],
              ],
            ],
            [
              [
                [26.02555500000011, 38.17694],
                [26.014721, 38.14944],
                [25.996105, 38.15527],
                [25.971661, 38.163605],
                [25.964722, 38.167496],
                [25.924995, 38.19471],
                [25.86416, 38.238319],
                [25.862495, 38.241379],
                [25.862495, 38.246101000000124],
                [25.864441, 38.253876],
                [25.869164000000126, 38.26388],
                [25.873882, 38.26944],
                [25.906384, 38.29027600000012],
                [25.9180530000001, 38.294716],
                [25.93666, 38.297211],
                [25.942493, 38.297211],
                [25.991665, 38.34388000000013],
                [25.989716, 38.375275],
                [25.989162, 38.38388],
                [25.988049, 38.387497],
                [25.945827, 38.455269],
                [25.939442, 38.45943],
                [25.91666, 38.46832300000011],
                [25.907776000000126, 38.470551000000114],
                [25.89222, 38.471931],
                [25.888054, 38.47361],
                [25.88166, 38.47778],
                [25.860828, 38.493889],
                [25.851944, 38.500832],
                [25.845833, 38.5094380000001],
                [25.827221, 38.53611],
                [25.82555, 38.539444],
                [25.824997, 38.54361],
                [25.84360900000013, 38.570541000000105],
                [25.851109, 38.578049000000135],
                [25.861664, 38.583611],
                [25.86999900000012, 38.586388],
                [25.88472, 38.588875],
                [26.001389, 38.601379],
                [26.13861100000014, 38.564995],
                [26.1508290000001, 38.556107],
                [26.157776, 38.547768],
                [26.159443, 38.544434],
                [26.160553, 38.53804800000012],
                [26.13888, 38.431664],
                [26.13361, 38.417496],
                [26.133327, 38.408333],
                [26.146111, 38.363602],
                [26.16138500000011, 38.329163],
                [26.163052, 38.326111],
                [26.16111, 38.305275],
                [26.160275, 38.30138],
                [26.10222, 38.246941],
                [26.035553000000107, 38.191933],
                [26.027222, 38.18027],
                [26.02555500000011, 38.17694],
              ],
            ],
            [
              [
                [20.903053, 38.545555],
                [20.899441, 38.54417],
                [20.89611, 38.545273],
                [20.899166, 38.56638],
                [20.914165, 38.58332800000011],
                [20.935833, 38.60416],
                [20.938889, 38.60527000000013],
                [20.94139, 38.602493],
                [20.939999, 38.59389],
                [20.903053, 38.545555],
              ],
            ],
            [
              [
                [25.599995, 38.531937],
                [25.561939, 38.530823],
                [25.52722200000011, 38.592766],
                [25.52722200000011, 38.59637500000014],
                [25.52916, 38.59970900000013],
                [25.53194, 38.60194400000012],
                [25.56611, 38.60833],
                [25.591942, 38.600822],
                [25.61055, 38.592499],
                [25.613331, 38.589989],
                [25.61694, 38.583611],
                [25.620274, 38.577209],
                [25.609997, 38.542496],
                [25.608887, 38.53887900000012],
                [25.60722, 38.53555300000011],
                [25.60416, 38.533333],
                [25.599995, 38.531937],
              ],
            ],
            [
              [
                [20.643608, 38.581108],
                [20.543610000000115, 38.564438],
                [20.542774, 38.56777],
                [20.542221, 38.58833],
                [20.557777, 38.683884],
                [20.559166, 38.688049],
                [20.60166500000014, 38.778885],
                [20.64305, 38.826942000000145],
                [20.648331, 38.832222],
                [20.655552000000114, 38.835548],
                [20.701385, 38.834717],
                [20.709721, 38.832222],
                [20.715832, 38.827774],
                [20.729443, 38.80749500000013],
                [20.730000000000132, 38.803886],
                [20.72416, 38.634995],
                [20.72305, 38.62638900000013],
                [20.72055, 38.623604000000114],
                [20.643608, 38.581108],
              ],
            ],
            [
              [
                [24.683052, 38.79805],
                [24.683609, 38.779716],
                [24.680832, 38.776939],
                [24.65916, 38.76749400000011],
                [24.646942000000138, 38.76416000000012],
                [24.626389, 38.765274],
                [24.62055, 38.766388],
                [24.616943000000106, 38.768326],
                [24.612499000000128, 38.773605],
                [24.60472, 38.78527],
                [24.598053, 38.78972],
                [24.592777, 38.789993],
                [24.57111, 38.780548],
                [24.56694, 38.773605],
                [24.56694, 38.7699970000001],
                [24.568886, 38.76082600000012],
                [24.553333, 38.768326],
                [24.53472, 38.78361],
                [24.456665, 38.88082900000012],
                [24.45027, 38.89694200000014],
                [24.449718, 38.946938],
                [24.450832, 38.950554000000125],
                [24.45277, 38.95388800000012],
                [24.45833, 38.962776],
                [24.46083, 38.965553],
                [24.477219, 38.97555],
                [24.480831, 38.977219],
                [24.48472, 38.978607],
                [24.489998, 38.97805],
                [24.502499, 38.972771],
                [24.50611, 38.970833],
                [24.577499, 38.926109],
                [24.66555, 38.824165],
                [24.67916, 38.80749500000013],
                [24.681389000000138, 38.804718],
                [24.683052, 38.79805],
              ],
            ],
            [
              [
                [23.46194, 38.853333],
                [23.471386, 38.8425],
                [23.516109, 38.811386],
                [23.59194200000013, 38.764717],
                [23.765274, 38.706665],
                [23.84666, 38.68222],
                [23.946663, 38.662773],
                [23.95111100000014, 38.66333],
                [24.0075, 38.67305],
                [24.153889, 38.64666],
                [24.15361, 38.57332600000012],
                [24.187222, 38.39249400000011],
                [24.247219, 38.231941],
                [24.25722, 38.217773000000136],
                [24.25944, 38.214996],
                [24.269165, 38.204437],
                [24.299164, 38.189995],
                [24.334721, 38.160271],
                [24.338886, 38.158607],
                [24.427776, 38.144165],
                [24.460552, 38.13888500000013],
                [24.465832, 38.138329],
                [24.47583, 38.138054000000125],
                [24.553886, 38.141106],
                [24.568607, 38.147499],
                [24.590553000000114, 38.064163],
                [24.590832, 38.060272],
                [24.589443, 38.04805],
                [24.588333, 38.039719000000105],
                [24.58721900000012, 38.03166],
                [24.586109, 38.02722200000011],
                [24.57583, 38.00416600000011],
                [24.564163, 37.98722],
                [24.516941, 37.95611],
                [24.513332, 37.95416],
                [24.504444, 37.953331],
                [24.483055, 37.955551],
                [24.47805, 37.95694],
                [24.387218000000132, 37.993607],
                [24.32611, 38.044716],
                [24.208611, 38.156662],
                [24.148609000000135, 38.215271],
                [24.11083200000013, 38.28833],
                [24.049999000000128, 38.365829],
                [24.056942000000106, 38.373886],
                [24.059166, 38.37722],
                [24.058887, 38.381104],
                [24.05722, 38.384163],
                [24.049721, 38.391937],
                [24.04472, 38.393051],
                [24.000000000000114, 38.401665],
                [23.99472, 38.401939],
                [23.9780540000001, 38.39249400000011],
                [23.970554, 38.38944],
                [23.938332000000116, 38.38666500000011],
                [23.905277, 38.38499500000012],
                [23.80583, 38.38916000000012],
                [23.773331, 38.39222],
                [23.673332, 38.41],
                [23.64222, 38.418884000000105],
                [23.61694, 38.45221700000013],
                [23.61805, 38.470551000000114],
                [23.62138700000014, 38.472496],
                [23.62638900000013, 38.478333],
                [23.63694, 38.503052],
                [23.63749700000011, 38.507217],
                [23.631943, 38.52527600000013],
                [23.625832, 38.541664],
                [23.623608, 38.544441],
                [23.59861, 38.57000000000011],
                [23.595554, 38.57249500000012],
                [23.492222, 38.632217],
                [23.33138700000012, 38.742493],
                [23.2, 38.830826],
                [23.19611, 38.832771],
                [23.1575, 38.847496],
                [23.148052, 38.850273],
                [23.137218, 38.852219000000105],
                [23.132774, 38.85166],
                [23.128887000000134, 38.850273],
                [23.125832000000116, 38.848053],
                [23.118053, 38.845276],
                [23.098053000000107, 38.839439],
                [22.833054000000118, 38.823051],
                [22.830276, 38.82527],
                [22.829998, 38.829163],
                [22.832497, 38.83749],
                [22.837776, 38.84888500000011],
                [22.844997, 38.861382000000106],
                [22.84889, 38.862778000000105],
                [22.929996, 38.891663],
                [23.09666, 38.9836],
                [23.129719, 39.003326],
                [23.279442, 39.036659],
                [23.2925, 39.03889],
                [23.29972, 39.03860500000013],
                [23.310555, 39.036659],
                [23.314999, 39.034996],
                [23.370831, 39.0075],
                [23.374722, 39.00555],
                [23.376942, 39.002777],
                [23.377777, 38.999443],
                [23.376663, 38.99472],
                [23.374722, 38.991386],
                [23.374165, 38.984161],
                [23.375832, 38.977219],
                [23.37861, 38.970833],
                [23.446388, 38.872498],
                [23.46194, 38.853333],
              ],
            ],
            [
              [
                [23.736664, 39.074715],
                [23.724442, 39.071388],
                [23.709442, 39.07388300000014],
                [23.66277700000012, 39.086105],
                [23.657776, 39.092773],
                [23.59083, 39.197495],
                [23.589996, 39.200829],
                [23.59083, 39.20444],
                [23.59388700000011, 39.206665],
                [23.598331, 39.207497],
                [23.610832, 39.204994],
                [23.783054, 39.126106],
                [23.786663, 39.124161],
                [23.78889, 39.12138],
                [23.789165, 39.117775],
                [23.787777, 39.114166],
                [23.775276, 39.099442000000124],
                [23.77027500000014, 39.09360500000014],
                [23.753887, 39.08361100000013],
                [23.736664, 39.074715],
              ],
            ],
            [
              [
                [23.50861, 39.159721],
                [23.455830000000105, 39.13],
                [23.3975, 39.14388300000013],
                [23.393608, 39.1449970000001],
                [23.392498, 39.152222],
                [23.393887, 39.16],
                [23.395832, 39.16333],
                [23.444443, 39.198883],
                [23.461388, 39.208328],
                [23.47166, 39.20805400000012],
                [23.486942, 39.20527600000014],
                [23.489998, 39.203049],
                [23.501389, 39.193329],
                [23.506664, 39.188332],
                [23.509998, 39.18222],
                [23.51194, 39.17555],
                [23.512218, 39.171661],
                [23.510555000000124, 39.16305],
                [23.50861, 39.159721],
              ],
            ],
            [
              [
                [20.198330000000112, 39.17444],
                [20.17805, 39.174164],
                [20.16555, 39.177498],
                [20.16277700000012, 39.179443],
                [20.136665, 39.200554],
                [20.12416500000012, 39.22138200000012],
                [20.1227760000001, 39.232773],
                [20.123608, 39.236382000000106],
                [20.133331, 39.239441],
                [20.13749700000011, 39.240273],
                [20.165, 39.222496],
                [20.187496, 39.203049],
                [20.19944, 39.186386],
                [20.202221, 39.17582700000014],
                [20.198330000000112, 39.17444],
              ],
            ],
            [
              [
                [23.862499, 39.13666500000011],
                [23.855553, 39.133049],
                [23.85139, 39.13472000000013],
                [23.836109, 39.14166300000011],
                [23.83361, 39.14804800000013],
                [23.8341640000001, 39.152222],
                [23.92361, 39.260277],
                [23.949165, 39.28916],
                [23.953609, 39.289719],
                [23.95666, 39.28749800000014],
                [23.95666, 39.284996],
                [23.978611, 39.267776],
                [23.979443000000117, 39.26416],
                [23.9780540000001, 39.260277],
                [23.921665, 39.178604],
                [23.904442, 39.163605],
                [23.862499, 39.13666500000011],
              ],
            ],
            [
              [
                [26.37722, 39.273598],
                [26.377773, 39.26944],
                [26.379993, 39.266663],
                [26.383327, 39.26471],
                [26.405, 39.253876],
                [26.474716, 39.21944],
                [26.528332, 39.154160000000104],
                [26.606667, 39.053322],
                [26.61222, 39.044167],
                [26.618332, 39.026108000000136],
                [26.618889000000138, 39.02193],
                [26.61694, 39.01526600000011],
                [26.614441, 39.012497],
                [26.525272, 38.974152],
                [26.51833, 38.972488],
                [26.450554000000125, 38.968323],
                [26.39027, 38.9711],
                [26.323887000000127, 38.977776],
                [26.187492000000134, 39.01722000000012],
                [26.136387000000127, 39.040276],
                [26.089165, 39.07222],
                [26.086941, 39.07499700000011],
                [26.08861, 39.078049],
                [26.107777000000112, 39.090828],
                [26.112495, 39.09166],
                [26.117222, 39.090828],
                [26.167500000000132, 39.10277600000012],
                [26.276939, 39.15638000000013],
                [26.28611000000012, 39.16776],
                [26.29277, 39.176384],
                [26.293327, 39.18055],
                [26.292217, 39.184166],
                [26.286942, 39.18943800000011],
                [26.261662, 39.202492],
                [26.252499, 39.204430000000116],
                [26.24055, 39.204430000000116],
                [26.235271000000125, 39.204163],
                [26.199162000000115, 39.20111],
                [26.172497, 39.19471],
                [26.16528, 39.19111],
                [26.16111, 39.18499800000012],
                [26.157776, 39.16916700000013],
                [26.153606, 39.1586],
                [26.112221, 39.11222],
                [26.109718, 39.10971],
                [26.084721, 39.089722],
                [26.077496, 39.086098],
                [26.06805, 39.084435],
                [26.062775, 39.084717],
                [26.045277, 39.089432],
                [25.988106, 39.105164],
                [25.889996, 39.141106],
                [25.86416, 39.153603],
                [25.83666, 39.178055],
                [25.833881, 39.18055],
                [25.832222000000115, 39.1836],
                [25.854717000000107, 39.250000000000114],
                [25.856384, 39.253052],
                [25.861938, 39.258041],
                [25.880276, 39.27111100000013],
                [25.907776000000126, 39.286942000000124],
                [25.92388, 39.291939],
                [25.921944, 39.28415700000011],
                [25.922497, 39.28],
                [25.924721, 39.277222],
                [25.928883, 39.275826],
                [25.95027, 39.273888],
                [25.97861, 39.271935],
                [25.98444400000011, 39.27166000000011],
                [26.169167, 39.323601],
                [26.172771, 39.325554000000125],
                [26.175831, 39.327766],
                [26.17639, 39.33194],
                [26.170830000000137, 39.345551],
                [26.16499, 39.36777500000011],
                [26.165833, 39.371941],
                [26.178329000000133, 39.37498],
                [26.221661, 39.383041],
                [26.22749, 39.383041],
                [26.323887000000127, 39.37443],
                [26.396111000000133, 39.341103],
                [26.419994, 39.32583],
                [26.414719, 39.32249],
                [26.395, 39.305832],
                [26.392494, 39.30305],
                [26.379719, 39.285271],
                [26.37722, 39.273598],
              ],
            ],
            [
              [
                [24.992496, 39.466385],
                [24.98889, 39.464722],
                [24.985832, 39.46611000000013],
                [24.979443, 39.478607000000125],
                [24.97639, 39.484718],
                [24.969719, 39.508049],
                [24.97138600000011, 39.51666],
                [24.976665, 39.533333],
                [24.978333, 39.537216],
                [24.995831000000123, 39.55888],
                [25.000000000000114, 39.561722],
                [25.001942, 39.562752],
                [25.006386, 39.56331],
                [25.01527, 39.56081400000011],
                [25.027222, 39.55608400000011],
                [25.044994, 39.545815],
                [25.052498, 39.537766],
                [25.05360800000011, 39.530823],
                [25.04972, 39.523315],
                [25.03138, 39.50359],
                [24.992496, 39.466385],
              ],
            ],
            [
              [
                [19.926109, 39.794441],
                [19.94694, 39.78360700000013],
                [19.95055, 39.774437],
                [19.95055, 39.76221],
                [19.94278, 39.744164000000126],
                [19.929165, 39.73111],
                [19.92639, 39.728607],
                [19.91611, 39.722771],
                [19.91222, 39.721382],
                [19.875553, 39.71611],
                [19.848888, 39.705826],
                [19.842499, 39.70277],
                [19.839996, 39.699997],
                [19.83861, 39.695831],
                [19.839443, 39.67638],
                [19.846664, 39.649162],
                [19.927776, 39.477219],
                [19.931942000000106, 39.47166],
                [20.018055, 39.434441],
                [20.027775, 39.431938],
                [20.03278, 39.43222],
                [20.048054, 39.436943],
                [20.057499, 39.44221],
                [20.063332, 39.44722],
                [20.067497, 39.453606],
                [20.071663, 39.453606],
                [20.07472, 39.451385],
                [20.12166600000012, 39.377777],
                [20.122219, 39.373886],
                [20.1202770000001, 39.370552],
                [20.114998000000128, 39.364998],
                [20.111664000000133, 39.36305],
                [20.079720000000123, 39.368332],
                [19.88416, 39.444443],
                [19.880276, 39.44638800000013],
                [19.87527, 39.45166],
                [19.854721, 39.483887],
                [19.85305, 39.486938],
                [19.85083, 39.49389],
                [19.846943, 39.519722000000115],
                [19.84722, 39.535828],
                [19.84972, 39.54277],
                [19.84417, 39.55194],
                [19.823330000000112, 39.57611],
                [19.818333, 39.581383],
                [19.806389000000138, 39.590553000000114],
                [19.740276, 39.624718],
                [19.675831, 39.674721],
                [19.673332, 39.677216],
                [19.641388, 39.744438],
                [19.639999000000103, 39.75666],
                [19.65083, 39.7725],
                [19.67305, 39.7930530000001],
                [19.692219000000136, 39.794998],
                [19.696941, 39.794441],
                [19.791664, 39.790276],
                [19.796665, 39.79055000000011],
                [19.80389, 39.793884000000105],
                [19.855, 39.81833],
                [19.864998, 39.81694],
                [19.926109, 39.794441],
              ],
            ],
            [
              [
                [19.404163, 39.843605],
                [19.39361, 39.838333],
                [19.388054000000125, 39.838608],
                [19.384163, 39.840271],
                [19.377777, 39.844719],
                [19.37611, 39.847771],
                [19.377777, 39.865555],
                [19.37889, 39.86860700000011],
                [19.381664, 39.871109],
                [19.4225, 39.8702770000001],
                [19.42778, 39.869995],
                [19.430553, 39.86749300000014],
                [19.428608, 39.86388],
                [19.404163, 39.843605],
              ],
            ],
            [
              [
                [25.44167, 40.00471],
                [25.39194, 39.952209],
                [25.356667, 39.91055300000011],
                [25.351662, 39.90416],
                [25.338055, 39.879990000000134],
                [25.336388000000113, 39.876099],
                [25.33833, 39.85082200000011],
                [25.33972200000011, 39.847771],
                [25.34888500000011, 39.836937],
                [25.351944, 39.83443],
                [25.3555530000001, 39.8325],
                [25.365273, 39.825554],
                [25.373608, 39.814438],
                [25.372498, 39.810822],
                [25.355827, 39.78638500000011],
                [25.338882, 39.788879],
                [25.317776, 39.793877],
                [25.308331, 39.796944],
                [25.30083100000013, 39.800819],
                [25.29416700000013, 39.805275],
                [25.29194, 39.808044],
                [25.266937, 39.86805],
                [25.27833, 39.888878],
                [25.279442, 39.89248700000013],
                [25.279160000000104, 39.896378],
                [25.26777, 39.909988],
                [25.264996, 39.91221],
                [25.25972000000013, 39.913605],
                [25.239716, 39.91387900000012],
                [25.235271000000125, 39.91304800000012],
                [25.228611000000114, 39.909157],
                [25.213608, 39.896935],
                [25.207771, 39.889153000000135],
                [25.18194, 39.854713],
                [25.178608, 39.84665700000011],
                [25.178608, 39.84304],
                [25.201664, 39.827492],
                [25.221943000000124, 39.810555000000136],
                [25.227219, 39.805275],
                [25.22666, 39.80138],
                [25.22305, 39.799431],
                [25.168327, 39.799721],
                [25.16249, 39.800819],
                [25.06694, 39.8425],
                [25.06083, 39.848053],
                [25.05444, 39.86055],
                [25.043053, 39.96332600000011],
                [25.045277, 39.983597],
                [25.049995, 39.9897160000001],
                [25.1325, 40.005272],
                [25.1402700000001, 40.00665300000014],
                [25.22666, 40.003052],
                [25.23193700000013, 40.002495],
                [25.27194, 39.988319],
                [25.368607, 40.00583],
                [25.447777, 40.0336],
                [25.451382, 40.033875],
                [25.453606, 40.03138],
                [25.445553, 40.00972],
                [25.44167, 40.00471],
              ],
            ],
            [
              [
                [25.60166, 40.398041],
                [25.566383, 40.39777400000014],
                [25.557499, 40.40137],
                [25.515831, 40.422493],
                [25.490273, 40.436935],
                [25.464165, 40.45498700000013],
                [25.460831, 40.457764],
                [25.44389, 40.475822],
                [25.494164000000126, 40.49638],
                [25.525555, 40.506943],
                [25.542770000000132, 40.510544],
                [25.55583, 40.511658],
                [25.571384000000137, 40.5113750000001],
                [25.57944, 40.50999500000012],
                [25.65721900000011, 40.49305],
                [25.69027, 40.471375],
                [25.69471700000014, 40.466103],
                [25.695553, 40.462494],
                [25.69611, 40.428322],
                [25.695000000000107, 40.424721],
                [25.69194, 40.422493],
                [25.66, 40.4124910000001],
                [25.606110000000115, 40.398598000000106],
                [25.60166, 40.398041],
              ],
            ],
            [
              [
                [24.773331, 40.631660000000124],
                [24.766388, 40.611382000000106],
                [24.671108, 40.578888],
                [24.64361, 40.570831],
                [24.642776, 40.574165],
                [24.638885, 40.579994],
                [24.601665, 40.610275],
                [24.59111, 40.616661],
                [24.575275, 40.62416100000013],
                [24.56944, 40.6252750000001],
                [24.53361, 40.62055],
                [24.52972, 40.62166600000012],
                [24.51361, 40.63694],
                [24.511944, 40.64],
                [24.50944, 40.658051],
                [24.52166, 40.692772],
                [24.53361, 40.714165],
                [24.540833000000134, 40.723885],
                [24.565552, 40.75055],
                [24.596943, 40.776939],
                [24.600555, 40.778885],
                [24.621387, 40.789993],
                [24.641109000000142, 40.796661],
                [24.645275, 40.797775],
                [24.65472000000011, 40.796387],
                [24.696663, 40.780548000000124],
                [24.73333, 40.765549],
                [24.761387000000127, 40.749161],
                [24.763885, 40.731941],
                [24.773331, 40.631660000000124],
              ],
            ],
            [
              [
                [26.29416700000013, 41.708054],
                [26.30971, 41.707764],
                [26.36109, 41.711052],
                [26.39833, 41.690819],
                [26.519444000000135, 41.63361],
                [26.570271, 41.611382],
                [26.604443, 41.546097],
                [26.63583, 41.419716],
                [26.636387, 41.416382],
                [26.636662, 41.408875],
                [26.63721500000014, 41.37861],
                [26.636662, 41.36693600000012],
                [26.635277, 41.358887],
                [26.633884, 41.35443900000013],
                [26.63166, 41.350822],
                [26.617775, 41.336937],
                [26.611382, 41.332497],
                [26.603611000000114, 41.32943],
                [26.41527600000012, 41.2594380000001],
                [26.38472, 41.253319],
                [26.379719, 41.253319],
                [26.368607, 41.254166],
                [26.35833, 41.256943],
                [26.325, 41.234711],
                [26.323887000000127, 41.09304],
                [26.36722200000014, 41.03333],
                [26.37388, 41.028603],
                [26.3752750000001, 41.025551],
                [26.375549, 41.02193],
                [26.361382000000106, 40.955826],
                [26.35944, 40.951935000000105],
                [26.28749, 40.90193],
                [26.251106, 40.888611],
                [26.213608, 40.877213],
                [26.173328, 40.8186],
                [26.129993, 40.75555],
                [26.124722, 40.75],
                [26.118332, 40.745544],
                [26.107777000000112, 40.73972],
                [26.090549, 40.73610700000012],
                [26.067219, 40.734154],
                [26.051804, 40.734375],
                [26.04472, 40.735825],
                [26.038326, 40.743332],
                [26.035, 40.75721],
                [26.028332, 40.792213],
                [26.041943, 40.807213],
                [26.022778, 40.82972],
                [25.911659, 40.847771],
                [25.80555, 40.85248600000011],
                [25.771111, 40.851379],
                [25.748608, 40.84805],
                [25.719994, 40.84583],
                [25.682217, 40.852219],
                [25.580555, 40.869431],
                [25.501389, 40.886658],
                [25.41944, 40.90527],
                [25.35611, 40.93693],
                [25.347775000000127, 40.94082],
                [25.320553, 40.945267000000115],
                [25.304165000000125, 40.946663],
                [25.300278, 40.945267000000115],
                [25.235554, 40.938332000000116],
                [25.17639, 40.94193],
                [25.13528, 40.951935000000105],
                [25.132217, 40.954430000000116],
                [25.129166, 40.960541],
                [25.132771000000105, 40.973328],
                [25.135551, 40.976379],
                [25.15583, 40.986931],
                [25.16639, 40.991379],
                [25.166111, 40.994164],
                [25.14777800000013, 41.00832],
                [25.14333, 41.010277],
                [25.138054, 41.01137],
                [25.07451, 41.00762],
                [25.039951, 41.004845],
                [25.03545000000014, 41.004272],
                [24.887497, 40.91555],
                [24.858608, 40.8949970000001],
                [24.801344, 40.85197],
                [24.780277, 40.851944],
                [24.632221, 40.857773],
                [24.627499000000114, 40.858604],
                [24.623055, 40.864166],
                [24.59916, 40.898331],
                [24.568886, 40.948051],
                [24.566666, 40.950554],
                [24.561386, 40.951942000000145],
                [24.507774, 40.954994],
                [24.43111, 40.94416],
                [24.398052, 40.936943],
                [24.390553, 40.934166],
                [24.337219, 40.895271],
                [24.320274, 40.880554],
                [24.317497000000117, 40.877777],
                [24.31583, 40.873886],
                [24.311386, 40.84833],
                [24.31583, 40.828888],
                [24.15667, 40.742493],
                [24.149166, 40.73944100000011],
                [24.096664, 40.71916],
                [24.084164, 40.71611],
                [24.06861, 40.71611],
                [24.051941, 40.717773],
                [23.994442, 40.728333000000134],
                [23.989166, 40.729721],
                [23.96611, 40.737495],
                [23.915833000000134, 40.754997],
                [23.908333, 40.75889],
                [23.88666, 40.775276],
                [23.846107, 40.787216000000114],
                [23.836666, 40.78638500000011],
                [23.735275, 40.754997],
                [23.723053, 40.746666],
                [23.717499, 40.741386],
                [23.712219, 40.73555],
                [23.696388, 40.712776],
                [23.689163, 40.69194],
                [23.687775, 40.679718],
                [23.690277, 40.6730500000001],
                [23.794998, 40.58305400000012],
                [23.823055, 40.50833100000011],
                [23.818607, 40.49110400000012],
                [23.82027, 40.4763870000001],
                [23.824718000000132, 40.463051],
                [23.828053, 40.45694],
                [23.834999, 40.448883],
                [23.858608, 40.42194],
                [23.874165, 40.406662],
                [23.88333, 40.399437],
                [23.887218, 40.397499],
                [23.922775, 40.384163],
                [23.961109000000135, 40.37861],
                [24.001942, 40.38444],
                [24.00583300000011, 40.385826],
                [24.169167, 40.352493],
                [24.181942, 40.34722],
                [24.238052, 40.31416300000012],
                [24.24110800000011, 40.311661],
                [24.37611, 40.187218],
                [24.386944, 40.17694100000011],
                [24.393055000000118, 40.16861],
                [24.396385000000123, 40.162498],
                [24.39833, 40.151939],
                [24.3966640000001, 40.143326],
                [24.393887, 40.140274],
                [24.390274, 40.13861],
                [24.320553, 40.11972000000014],
                [24.31111, 40.11888900000014],
                [24.30611, 40.11888900000014],
                [24.301109, 40.119995],
                [24.29722, 40.121941],
                [24.292774, 40.127495],
                [24.29083, 40.134163],
                [24.29055, 40.141937],
                [24.284721, 40.15444200000013],
                [24.171665, 40.272774],
                [24.169167, 40.27527600000013],
                [24.159443, 40.281944000000124],
                [24.14972, 40.28416],
                [24.124165, 40.28999],
                [24.113888, 40.28999],
                [24.095554000000106, 40.28777300000013],
                [24.051941, 40.292221],
                [24.04694400000011, 40.29361],
                [24.02972, 40.300278],
                [24.00138900000013, 40.313332000000116],
                [23.993889, 40.317215],
                [23.96888700000011, 40.33166],
                [23.96583, 40.33416],
                [23.95666, 40.345276000000126],
                [23.947498, 40.352493],
                [23.936943, 40.35860400000013],
                [23.924164, 40.363884],
                [23.907776, 40.367218],
                [23.850555, 40.373329],
                [23.832222, 40.371109000000104],
                [23.73166700000013, 40.35194400000012],
                [23.727776, 40.35055],
                [23.708332, 40.335274],
                [23.698887, 40.322777],
                [23.69694, 40.319443],
                [23.69278, 40.30638900000014],
                [23.691109, 40.297775],
                [23.69916, 40.274719],
                [23.704998000000103, 40.262215],
                [23.72472, 40.24082900000013],
                [23.773888000000113, 40.196106],
                [23.784443, 40.189720000000136],
                [23.793331, 40.19111],
                [23.79805, 40.19194],
                [23.879997, 40.17388],
                [23.906109, 40.16444400000012],
                [23.91, 40.162498],
                [23.974442, 40.12916600000011],
                [23.989719, 40.113884],
                [23.99222200000014, 40.111107],
                [24.014721000000122, 40.030548000000124],
                [24.015, 40.01138300000014],
                [24.013885, 40.00694],
                [23.992775, 39.95499400000011],
                [23.989719, 39.952774],
                [23.985832, 39.951385],
                [23.942219, 39.943329],
                [23.932220000000143, 39.943054],
                [23.899998, 39.968048],
                [23.826942, 40.025551],
                [23.7905540000001, 40.080276],
                [23.791664, 40.08888],
                [23.789997, 40.091942],
                [23.762497, 40.12471800000014],
                [23.72555, 40.1680530000001],
                [23.703053000000125, 40.191666],
                [23.671108, 40.21833],
                [23.653053, 40.228607],
                [23.638885, 40.23305],
                [23.413609, 40.281387],
                [23.403332, 40.281662],
                [23.398888000000113, 40.28083],
                [23.38833, 40.275551],
                [23.376663, 40.265549],
                [23.353611, 40.2452770000001],
                [23.33833, 40.22778],
                [23.331944, 40.217773],
                [23.330276, 40.213608],
                [23.329998000000103, 40.209442],
                [23.33166, 40.202774],
                [23.368053, 40.14388300000013],
                [23.479721, 40.045273],
                [23.498886, 40.031662],
                [23.51083, 40.026108],
                [23.595833, 39.999718],
                [23.61278, 39.994438],
                [23.675552, 39.971382],
                [23.74778, 39.932777],
                [23.748886, 39.92555],
                [23.746666, 39.92222],
                [23.743332, 39.920555],
                [23.72694, 39.91583],
                [23.71, 39.911942],
                [23.64361, 39.916107],
                [23.612221, 39.919441],
                [23.595833, 39.921944],
                [23.436943, 39.97110700000013],
                [23.37944, 39.99277500000011],
                [23.320831000000112, 40.119164000000126],
                [23.324165000000107, 40.126938],
                [23.32444, 40.176384],
                [23.323608, 40.18777],
                [23.320553, 40.20166],
                [23.31444, 40.218048000000124],
                [23.311108, 40.224159],
                [23.305553, 40.229164],
                [23.298332, 40.233887],
                [23.290833, 40.237778000000105],
                [23.26527, 40.248055],
                [23.26083, 40.249718],
                [23.177498, 40.273048],
                [23.11083, 40.299164],
                [22.899441000000138, 40.39666],
                [22.843609, 40.474998],
                [22.863052, 40.50388],
                [22.87444, 40.50278],
                [22.88888, 40.50388],
                [22.92222, 40.512497],
                [22.946663, 40.519722],
                [22.96472, 40.52833],
                [22.973888, 40.535553],
                [22.98111, 40.544716],
                [22.98222, 40.549164],
                [22.978611, 40.558884],
                [22.950275, 40.619438],
                [22.946663, 40.625549],
                [22.941387000000134, 40.630554],
                [22.91166, 40.642776],
                [22.901386000000116, 40.645],
                [22.896385, 40.645],
                [22.865833000000123, 40.638611],
                [22.861942, 40.6294400000001],
                [22.862778000000105, 40.62611],
                [22.862499000000128, 40.62194],
                [22.85944400000011, 40.597496],
                [22.85389, 40.592216],
                [22.81694, 40.569717],
                [22.813332, 40.567772000000105],
                [22.704441, 40.518326],
                [22.652775, 40.510277],
                [22.59111, 40.47666],
                [22.582497, 40.463333],
                [22.583611, 40.459999],
                [22.611111, 40.407776],
                [22.621109, 40.393326],
                [22.629997, 40.38305],
                [22.612499, 40.291664],
                [22.604164, 40.2775],
                [22.548885, 40.160553],
                [22.547775, 40.156105],
                [22.54722, 40.147774],
                [22.548885, 40.133049],
                [22.568886, 40.05722],
                [22.595, 40.012215],
                [22.61583, 39.99555],
                [22.625826, 39.98917],
                [22.686386, 39.96611],
                [22.70305, 39.958885],
                [22.709721000000116, 39.95472],
                [22.712219, 39.95194],
                [22.852219, 39.79361],
                [22.856388, 39.784164],
                [22.85944400000011, 39.77389],
                [22.86055, 39.751106],
                [22.864998000000128, 39.729721],
                [22.867496, 39.723328],
                [22.91305, 39.618889],
                [22.924442, 39.593605],
                [22.929443, 39.584442],
                [22.93861, 39.577499],
                [22.945553, 39.57332600000012],
                [23.020832, 39.529160000000104],
                [23.025276, 39.527496],
                [23.118053, 39.45694],
                [23.138054000000125, 39.439995000000124],
                [23.25861, 39.331665],
                [23.267776, 39.32111],
                [23.27639, 39.309998],
                [23.326664000000108, 39.226944],
                [23.328331, 39.22388500000011],
                [23.34333, 39.192772000000105],
                [23.345, 39.185829000000126],
                [23.345, 39.178055],
                [23.341389, 39.170555],
                [23.325275, 39.154442],
                [23.31583, 39.14804800000013],
                [23.206108, 39.10527],
                [23.16111000000012, 39.09360500000014],
                [23.122498, 39.08777600000013],
                [23.090275000000133, 39.085548],
                [23.085278, 39.085274],
                [23.080555, 39.086105],
                [23.05805, 39.093887],
                [23.054443000000106, 39.09583],
                [23.052776, 39.098885],
                [23.054165, 39.10305],
                [23.069721, 39.13361],
                [23.073887, 39.140549000000135],
                [23.07889, 39.146385],
                [23.086109, 39.14944],
                [23.10972, 39.152496],
                [23.115276, 39.14361],
                [23.116943, 39.140549000000135],
                [23.114441, 39.13222],
                [23.108055, 39.121941],
                [23.10555, 39.119164],
                [23.098331, 39.104164],
                [23.10083, 39.10166],
                [23.105, 39.10249],
                [23.174442000000113, 39.130272],
                [23.210831, 39.15083],
                [23.213333, 39.15361],
                [23.22166, 39.177498],
                [23.222221000000104, 39.181664000000126],
                [23.221107, 39.18499800000012],
                [23.178608, 39.25555400000013],
                [23.16333, 39.27111100000013],
                [23.160831000000144, 39.273605],
                [23.122776, 39.304161],
                [23.119720000000143, 39.30638900000014],
                [22.99528, 39.352776],
                [22.94611, 39.36055],
                [22.94166600000011, 39.35972],
                [22.937775, 39.358604],
                [22.829720000000123, 39.273888],
                [22.826664, 39.271385],
                [22.82222, 39.265274],
                [22.81694, 39.253883],
                [22.81694, 39.24583],
                [22.81805400000013, 39.23888],
                [22.8225, 39.217499],
                [22.824718000000132, 39.206940000000145],
                [22.833885000000123, 39.18805],
                [22.85028, 39.161385],
                [22.854443, 39.15583],
                [22.858608, 39.155548],
                [22.8752750000001, 39.17083],
                [22.877499, 39.174164],
                [22.876389, 39.177773],
                [22.91333, 39.156387],
                [22.965275, 39.11860700000011],
                [22.973888, 39.107498],
                [22.99528, 39.068054],
                [22.994999, 39.04277000000013],
                [23.03416, 39.03611],
                [23.072777, 39.036942],
                [23.05139, 39.016388],
                [23.00972, 38.977776],
                [22.937775, 38.92860400000012],
                [22.833054000000118, 38.891106],
                [22.759998, 38.871109],
                [22.755554, 38.8702770000001],
                [22.750832000000116, 38.869995],
                [22.734444, 38.871384],
                [22.682997, 38.8785],
                [22.678165, 38.879993],
                [22.658886, 38.885277],
                [22.654163, 38.890549],
                [22.653332, 38.894165],
                [22.651665, 38.89694200000014],
                [22.646942, 38.9025],
                [22.643330000000105, 38.904442],
                [22.616943, 38.90916],
                [22.611942000000113, 38.908882],
                [22.526943, 38.8825],
                [22.523888, 38.880272],
                [22.523609, 38.87610600000011],
                [22.52305200000012, 38.860832],
                [22.52333, 38.857216],
                [22.553608, 38.83416],
                [22.558052, 38.832497],
                [22.57917, 38.825829],
                [22.584721, 38.825],
                [22.60611, 38.82361],
                [22.610275, 38.82444],
                [22.617775, 38.827499],
                [22.66855, 38.83044100000012],
                [22.713333, 38.823051],
                [22.756664, 38.787498],
                [22.771942, 38.779999],
                [22.953609, 38.75166300000012],
                [23.063889, 38.692497],
                [23.06861, 38.68332700000013],
                [23.09222000000011, 38.648331],
                [23.105831, 38.631386],
                [23.10889, 38.629166],
                [23.113331, 38.627495],
                [23.117496, 38.628052],
                [23.13361, 38.63277],
                [23.167774000000122, 38.64305100000013],
                [23.185833, 38.650833],
                [23.189163, 38.652771],
                [23.19222, 38.655],
                [23.1936070000001, 38.65916],
                [23.192776, 38.66249800000014],
                [23.281387, 38.65416],
                [23.286942000000124, 38.6533280000001],
                [23.316109, 38.645271],
                [23.318886000000134, 38.64277600000014],
                [23.333885, 38.623329],
                [23.33555200000012, 38.62028],
                [23.33833, 38.609993000000145],
                [23.33833, 38.605827],
                [23.336941, 38.60194400000012],
                [23.305553, 38.56749700000012],
                [23.335, 38.53805],
                [23.338886, 38.53611],
                [23.399441, 38.507774],
                [23.465832, 38.498886],
                [23.534721, 38.49944],
                [23.592499, 38.463333],
                [23.59333, 38.446106],
                [23.601944, 38.431107],
                [23.655552, 38.361382],
                [23.658607, 38.359161],
                [23.675552, 38.34861],
                [23.79916, 38.323883],
                [23.851109, 38.313049],
                [23.926666000000125, 38.294998],
                [23.960552, 38.281662],
                [24.073887, 38.196938],
                [24.07416, 38.193054],
                [24.06889, 38.159164],
                [24.060555, 38.143051],
                [24.00555400000013, 38.067772],
                [24.01083, 37.971382],
                [24.030552, 37.872498],
                [24.056664, 37.845276000000126],
                [24.086109, 37.799995],
                [24.086941000000138, 37.79639],
                [24.090275000000133, 37.77861],
                [24.089722, 37.774719],
                [24.069443, 37.689438],
                [24.06222, 37.676941],
                [24.040833, 37.65583],
                [24.03444, 37.651665],
                [24.030277, 37.651939],
                [23.950832, 37.669716],
                [23.94444, 37.67416],
                [23.92444, 37.720276],
                [23.907776, 37.761108],
                [23.887497, 37.782776],
                [23.861664000000133, 37.804161000000136],
                [23.847221, 37.812218],
                [23.821663000000115, 37.82278],
                [23.817219000000136, 37.82444],
                [23.774441, 37.834442],
                [23.562496, 37.966942],
                [23.559444, 37.969162],
                [23.555553, 37.978607],
                [23.556389, 37.98221600000011],
                [23.56361, 37.985275],
                [23.570831, 37.98832700000014],
                [23.588055, 38.00055],
                [23.592499, 38.00666],
                [23.5975, 38.018608],
                [23.598331, 38.026939],
                [23.597221000000104, 38.02944200000013],
                [23.586109000000135, 38.03889],
                [23.578053, 38.042496],
                [23.57222, 38.043327],
                [23.515553000000125, 38.04055000000011],
                [23.507774, 38.038055],
                [23.458611000000133, 38.02055],
                [23.428333000000123, 38.00388],
                [23.425831, 38.001106],
                [23.418888, 37.991943],
                [23.412220000000104, 37.979996],
                [23.33166, 37.97805],
                [23.248333, 37.977776],
                [23.23555, 37.97555],
                [23.231667, 37.9741590000001],
                [23.176668, 37.951942],
                [23.15361, 37.9327770000001],
                [23.14444, 37.92610900000011],
                [23.134163, 37.92083000000014],
                [23.126389, 37.918053],
                [23.109165, 37.91527600000012],
                [23.063889, 37.91277300000013],
                [23.035275, 37.918610000000115],
                [23.01694, 37.923607],
                [23.011665, 37.91833],
                [22.992222, 37.884163000000115],
                [22.991386, 37.88055400000013],
                [23.0025, 37.85139],
                [23.00472, 37.84888500000011],
                [23.012218000000132, 37.844994],
                [23.021595000000104, 37.841873],
                [23.063053, 37.839439],
                [23.083611000000133, 37.838608000000136],
                [23.103611, 37.84166],
                [23.14861, 37.758049],
                [23.161388, 37.61999500000013],
                [23.16222, 37.616661000000136],
                [23.169998000000135, 37.611664],
                [23.195831, 37.59528],
                [23.2775, 37.553329],
                [23.322777, 37.53249],
                [23.328609, 37.531662],
                [23.336666, 37.533607],
                [23.35833, 37.54277],
                [23.364998, 37.54639],
                [23.366386, 37.550278],
                [23.360554, 37.56666600000011],
                [23.346664, 37.586388],
                [23.329441, 37.60444],
                [23.32638500000013, 37.60666700000013],
                [23.40583, 37.58833],
                [23.421801, 37.527229],
                [23.445553, 37.50471],
                [23.49833, 37.476944],
                [23.520832, 37.461662],
                [23.521942, 37.458328],
                [23.525276, 37.439163],
                [23.522778, 37.436386],
                [23.513611, 37.429443],
                [23.506664, 37.42582700000014],
                [23.499165, 37.42333200000013],
                [23.422222, 37.410271],
                [23.413055, 37.409164],
                [23.39194, 37.41111000000012],
                [23.381386, 37.41333],
                [23.354443000000117, 37.416107],
                [23.270554, 37.40083],
                [23.231667, 37.380554],
                [23.22972, 37.37722],
                [23.19611, 37.313332],
                [23.201664, 37.304443000000106],
                [23.204166, 37.29805],
                [23.20111100000014, 37.29583000000014],
                [23.18222, 37.290276],
                [23.177219, 37.29055000000011],
                [23.153889, 37.296104],
                [23.149719, 37.297493],
                [23.070274, 37.35305],
                [23.066387, 37.358604],
                [23.066387, 37.393051],
                [23.069443, 37.395271],
                [23.073608, 37.396111],
                [23.07777, 37.39444],
                [23.084442000000138, 37.390274],
                [23.08889, 37.389717],
                [23.10611, 37.39249400000011],
                [23.136944, 37.41805],
                [23.136108, 37.437218],
                [23.128887000000134, 37.448051],
                [22.97916400000014, 37.515831000000105],
                [22.931942, 37.53416],
                [22.927498, 37.53583],
                [22.779999, 37.589996],
                [22.774719, 37.590271],
                [22.762218, 37.588882000000126],
                [22.74361, 37.58194],
                [22.73055, 37.57416500000011],
                [22.72583, 37.568329],
                [22.722775, 37.561386],
                [22.723053000000107, 37.54972],
                [22.727497, 37.487221],
                [22.728611, 37.483887],
                [22.75861, 37.408051],
                [22.80917, 37.345551],
                [22.911388000000102, 37.19416],
                [22.91166, 37.19055200000014],
                [22.907497, 37.18055],
                [22.9025, 37.17472],
                [22.90055500000011, 37.171104],
                [22.895275, 37.141937],
                [22.896111000000133, 37.130554],
                [22.901943, 37.11805],
                [22.90721900000011, 37.113052],
                [22.910275, 37.11166400000013],
                [22.92, 37.110832],
                [22.926941, 37.11860700000011],
                [22.930275, 37.1202770000001],
                [22.93499800000012, 37.12055],
                [22.954441, 37.11860700000011],
                [22.957222, 37.116104],
                [23.006386, 37.024719],
                [23.00916, 36.99055],
                [23.014164, 36.9377750000001],
                [23.014999, 36.934441000000106],
                [23.052776, 36.868607],
                [23.090832, 36.82249500000012],
                [23.11417, 36.774719],
                [23.114998, 36.771385],
                [23.11305, 36.768051],
                [23.086941000000138, 36.748329],
                [23.066944, 36.73999800000013],
                [23.062222, 36.74110400000012],
                [23.052776, 36.740555],
                [23.032219, 36.732773],
                [23.030277, 36.729164],
                [23.026665, 36.716385],
                [23.02861, 36.65666],
                [23.032776, 36.635551],
                [23.03388600000011, 36.63222],
                [23.036942, 36.626106],
                [23.07889, 36.57666],
                [23.109997, 36.562492000000134],
                [23.200554, 36.455826],
                [23.204166, 36.449997],
                [23.20444, 36.446388],
                [23.203053, 36.437775],
                [23.201385, 36.43388],
                [23.19833, 36.431938],
                [23.140274, 36.426109],
                [23.135277, 36.426384],
                [23.09, 36.439995],
                [22.972775000000127, 36.518883],
                [22.969719, 36.52111],
                [22.967499, 36.523605],
                [22.95472, 36.54805],
                [22.88805, 36.647217],
                [22.788055, 36.79583],
                [22.785553, 36.798607],
                [22.781944, 36.80055],
                [22.77277800000013, 36.80222],
                [22.73055, 36.805832],
                [22.643608, 36.804993],
                [22.63416, 36.804443],
                [22.62611, 36.802498],
                [22.59610700000013, 36.792221],
                [22.588886, 36.789162],
                [22.57278, 36.773888],
                [22.51277, 36.66777000000013],
                [22.482498, 36.60611],
                [22.479443, 36.592773],
                [22.480553, 36.532219],
                [22.482498, 36.525551],
                [22.48555, 36.51944],
                [22.49361, 36.50444],
                [22.495831, 36.501663],
                [22.5, 36.499058],
                [22.502499, 36.497498],
                [22.504166, 36.494438],
                [22.50611, 36.487778],
                [22.50722, 36.47277100000014],
                [22.507774, 36.465271],
                [22.508331, 36.453049],
                [22.5075, 36.44861],
                [22.488888, 36.386108],
                [22.476665, 36.40277100000014],
                [22.3975, 36.47388500000011],
                [22.377499, 36.535553],
                [22.35611, 36.69944],
                [22.29694400000011, 36.814995],
                [22.24361, 36.873329],
                [22.185555, 36.892776],
                [22.146385, 36.950829],
                [22.160553, 37.002495],
                [22.158886, 37.01332900000011],
                [22.156387, 37.019722],
                [22.152775, 37.02166],
                [22.147778, 37.022774],
                [22.120831, 37.026665],
                [22.073055, 37.03083],
                [22.063053, 37.03083],
                [22.05, 37.029160000000104],
                [22.02916, 37.024719],
                [21.97944, 37.00722],
                [21.953609, 36.99749800000012],
                [21.937496, 36.987778],
                [21.933052, 36.981384],
                [21.926388, 36.96666],
                [21.922775000000115, 36.866661],
                [21.923054, 36.862778],
                [21.92555, 36.84861000000012],
                [21.931389000000138, 36.820549],
                [21.933052, 36.81749700000012],
                [21.937775, 36.81221800000014],
                [21.949718, 36.80305],
                [21.961666, 36.7980500000001],
                [21.93805300000014, 36.762215],
                [21.881386, 36.720276],
                [21.876663, 36.72138200000012],
                [21.873608, 36.72361],
                [21.868889, 36.728882],
                [21.84638600000011, 36.7594380000001],
                [21.83277500000014, 36.779442],
                [21.82944, 36.78555300000011],
                [21.827499, 36.792221],
                [21.82694, 36.79972],
                [21.825275, 36.802773],
                [21.82222, 36.804993],
                [21.818333, 36.806107],
                [21.809719, 36.805832],
                [21.770275, 36.800278],
                [21.76722, 36.798607],
                [21.765274, 36.795],
                [21.764164000000108, 36.79055],
                [21.704441, 36.815277],
                [21.70277, 36.818054],
                [21.691387, 36.84333],
                [21.68639, 36.87055],
                [21.68666500000012, 36.8825],
                [21.688053, 36.89111],
                [21.69722, 36.91416],
                [21.706944, 36.919716],
                [21.711388, 36.92610900000011],
                [21.712776000000133, 36.92999300000014],
                [21.713608, 36.933609],
                [21.711941000000138, 36.944443],
                [21.707775, 36.950272],
                [21.6375, 37.009438],
                [21.612221, 37.026939],
                [21.58194, 37.061104000000114],
                [21.580276, 37.066666],
                [21.564999, 37.145],
                [21.56416, 37.1525],
                [21.566109, 37.161385],
                [21.577221, 37.193886000000134],
                [21.578888, 37.197777],
                [21.585552, 37.20694],
                [21.590553, 37.212219],
                [21.605, 37.2241590000001],
                [21.630276, 37.234444],
                [21.66972, 37.268326],
                [21.674999000000128, 37.2736],
                [21.694721, 37.305275],
                [21.695831, 37.309715],
                [21.696388, 37.325829],
                [21.681389, 37.376389],
                [21.659721000000104, 37.423882],
                [21.64971900000012, 37.44194],
                [21.604721, 37.50471],
                [21.580555, 37.53083],
                [21.57222000000013, 37.538055],
                [21.557777, 37.54972],
                [21.532497, 37.56694],
                [21.40111, 37.651665],
                [21.29361, 37.77861],
                [21.276943, 37.789162],
                [21.234444, 37.80888],
                [21.21833, 37.815552],
                [21.209442, 37.818604],
                [21.174164, 37.82611],
                [21.146942000000138, 37.82972],
                [21.1202770000001, 37.834717],
                [21.109997, 37.840553000000114],
                [21.106388, 37.846664],
                [21.106388, 37.85443900000013],
                [21.10944400000011, 37.876938],
                [21.112499000000128, 37.89444],
                [21.124165, 37.929443000000106],
                [21.127499, 37.93694],
                [21.13361, 37.941109],
                [21.13888, 37.940826],
                [21.1425, 37.939163],
                [21.14917, 37.930832],
                [21.152775000000133, 37.928886],
                [21.163609, 37.926941],
                [21.17778, 37.927773000000116],
                [21.19055200000014, 37.930275],
                [21.207222, 37.93972],
                [21.216389, 37.94583],
                [21.283607, 37.994164000000126],
                [21.31583000000012, 38.028885],
                [21.367222, 38.114166],
                [21.373886, 38.13694],
                [21.373886, 38.152496],
                [21.372776, 38.1638870000001],
                [21.38444, 38.21139],
                [21.445, 38.20082900000011],
                [21.473331, 38.18972],
                [21.48305, 38.183327],
                [21.52972000000011, 38.1616590000001],
                [21.539719, 38.159439000000134],
                [21.59528, 38.148888],
                [21.612499, 38.152222],
                [21.641666, 38.158882],
                [21.66833, 38.16805],
                [21.671665000000132, 38.169998000000135],
                [21.676941, 38.175278],
                [21.715832, 38.21666],
                [21.722221, 38.226662],
                [21.732498, 38.248886],
                [21.740276, 38.2736],
                [21.742775, 38.276665],
                [21.773609, 38.303886],
                [21.779999, 38.308052],
                [21.84889, 38.338333],
                [21.85833, 38.340828],
                [21.958611, 38.329437],
                [22.02138, 38.309715],
                [22.02471900000012, 38.30360400000012],
                [22.026386, 38.29277],
                [22.02833, 38.28583],
                [22.04222, 38.273888],
                [22.17139, 38.20361],
                [22.174999, 38.20166000000012],
                [22.215553000000114, 38.185272],
                [22.224442, 38.181938],
                [22.37833, 38.146385],
                [22.455555, 38.133331],
                [22.536942, 38.113327],
                [22.652222, 38.076111],
                [22.709999, 38.04943800000012],
                [22.721664, 38.043884000000105],
                [22.72472, 38.041664],
                [22.729443, 38.03638500000011],
                [22.761108, 38.006386],
                [22.799442000000113, 37.971382],
                [22.857498, 37.941109],
                [22.86805, 37.938049],
                [22.908054000000106, 37.938049],
                [22.943054, 37.94360400000011],
                [22.954998000000103, 37.9469380000001],
                [22.958332, 37.948608],
                [22.96611, 37.95694],
                [22.97222, 37.966942],
                [22.978886, 37.98221600000011],
                [22.97722, 37.985275],
                [22.949165000000107, 38.00166300000012],
                [22.907776, 38.022217],
                [22.89055, 38.029999],
                [22.8727760000001, 38.031105],
                [22.869164, 38.02944200000013],
                [22.858887, 38.029999],
                [22.85389, 38.03138700000011],
                [22.85472, 38.034721000000104],
                [22.85805, 38.036659],
                [22.881386, 38.049995],
                [22.944443, 38.079163],
                [22.952499000000103, 38.081108],
                [22.9625, 38.080826000000116],
                [22.995831, 38.07222],
                [23.008888000000127, 38.067497],
                [23.0191650000001, 38.061386],
                [23.023609, 38.059715],
                [23.04555, 38.058327],
                [23.05916600000012, 38.057495],
                [23.097775, 38.058609],
                [23.1025, 38.058884],
                [23.11413, 38.06077],
                [23.124722000000133, 38.062492],
                [23.16889, 38.07444],
                [23.209999, 38.095551],
                [23.216389, 38.099716],
                [23.21833, 38.10305],
                [23.22639, 38.14944],
                [23.226109, 38.153053],
                [23.223053, 38.155548],
                [23.120552, 38.209717],
                [23.116108, 38.2111],
                [23.025276, 38.217499],
                [22.966942, 38.213608000000136],
                [22.943054, 38.20805],
                [22.944443, 38.186943],
                [22.92333, 38.19500000000011],
                [22.835278, 38.226387],
                [22.78139, 38.23333],
                [22.765553, 38.244438],
                [22.68972, 38.323608],
                [22.587776, 38.330551],
                [22.533886, 38.34499],
                [22.510277, 38.375275],
                [22.463886, 38.424721],
                [22.46083, 38.4272160000001],
                [22.4175, 38.44444],
                [22.413055, 38.446106],
                [22.40333, 38.448051],
                [22.400555, 38.44554900000014],
                [22.37833, 38.391937],
                [22.376942, 38.388054],
                [22.377777, 38.38472],
                [22.388332, 38.363609],
                [22.39666, 38.35083],
                [22.39638, 38.347771],
                [22.393608, 38.345276],
                [22.38194, 38.33583],
                [22.37861, 38.33416],
                [22.368332, 38.33416],
                [22.193886, 38.337219],
                [22.168331, 38.346939000000134],
                [22.12555, 38.37138],
                [22.042774, 38.398048],
                [21.97555, 38.40666],
                [21.947777, 38.409439],
                [21.713055, 38.35305],
                [21.660275, 38.354721],
                [21.636665, 38.35416],
                [21.595833, 38.34360500000014],
                [21.546665, 38.319717],
                [21.53333, 38.312218],
                [21.463886, 38.36666],
                [21.36555, 38.43305],
                [21.35055, 38.43278],
                [21.339443, 38.3949970000001],
                [21.334999, 38.38861],
                [21.26694, 38.339165],
                [21.238331, 38.321663],
                [21.176109, 38.298882],
                [21.171944, 38.29805],
                [21.160831, 38.29916400000013],
                [21.147778, 38.304161],
                [21.108887, 38.34805300000011],
                [21.108608, 38.36305],
                [21.11055, 38.36972000000014],
                [21.12694, 38.379715],
                [21.13555, 38.38666500000011],
                [21.139721, 38.393051],
                [21.139442, 38.396942],
                [21.1227760000001, 38.429718],
                [21.116386, 38.438049],
                [21.110815, 38.43415],
                [21.108913, 38.430569],
                [21.105000000000132, 38.429173],
                [21.10278, 38.429443],
                [21.106388, 38.430832],
                [21.108887, 38.433884],
                [21.110832, 38.437218],
                [21.112499000000128, 38.44527],
                [21.11138, 38.44888300000014],
                [21.086388, 38.503052],
                [20.98944, 38.669998],
                [20.986385, 38.672218],
                [20.901108, 38.73194100000012],
                [20.80972, 38.759438],
                [20.774719, 38.75722],
                [20.769722000000115, 38.75833100000011],
                [20.766666, 38.76082600000012],
                [20.76416, 38.76332900000011],
                [20.733330000000137, 38.797775],
                [20.73222, 38.801109],
                [20.732777, 38.809441],
                [20.74972, 38.909721],
                [20.781109, 38.93166],
                [20.970276, 38.94194],
                [21.02972, 38.93055],
                [21.03167, 38.927498],
                [21.031944, 38.915833],
                [21.031109, 38.911385],
                [21.02583, 38.90610500000014],
                [21.024067, 38.902756],
                [21.02583, 38.895828],
                [21.028889, 38.89361],
                [21.04583, 38.88304900000014],
                [21.049442000000113, 38.88110400000011],
                [21.08333, 38.864166],
                [21.086941, 38.86388],
                [21.140831, 38.931938000000116],
                [21.166386000000102, 38.975273],
                [21.164997, 38.982498000000135],
                [21.16333, 38.985275],
                [21.149998, 39.00193800000011],
                [21.138611, 39.015549],
                [21.109165000000132, 39.04666],
                [21.106110000000115, 39.048882000000106],
                [21.09861, 39.053055],
                [21.094166, 39.054718],
                [21.083050000000128, 39.056664],
                [21.045277000000112, 39.013329],
                [20.933052, 39.05805],
                [20.82611100000014, 39.113884],
                [20.821663, 39.114441],
                [20.817776, 39.11305],
                [20.774719, 39.085274],
                [20.7575, 39.02055400000012],
                [20.787498, 38.997772],
                [20.824165, 38.974716],
                [20.82722, 38.9725],
                [20.82972, 38.969719],
                [20.83083, 38.966385],
                [20.83055, 38.962219],
                [20.82917, 38.95832800000011],
                [20.824718, 38.9574970000001],
                [20.740833, 38.94971],
                [20.735832, 38.95082900000011],
                [20.73194100000012, 38.9524990000001],
                [20.72472, 38.96054800000013],
                [20.712219, 38.977219],
                [20.703331000000105, 38.992493],
                [20.702221, 38.995827],
                [20.7025, 39],
                [20.711109, 39.006104],
                [20.713608, 39.009163],
                [20.71527, 39.012497],
                [20.71527, 39.02055400000012],
                [20.703888, 39.046104],
                [20.694721, 39.061943],
                [20.688053, 39.070274],
                [20.67639, 39.07972],
                [20.534443000000124, 39.185829000000126],
                [20.480274, 39.273605],
                [20.46694200000013, 39.275833],
                [20.385555000000124, 39.284439000000134],
                [20.34861, 39.28749800000014],
                [20.34333, 39.288605],
                [20.30444, 39.31472],
                [20.298332, 39.31916],
                [20.290276, 39.32666],
                [20.214165, 39.43777],
                [20.215275, 39.439995000000124],
                [20.24528, 39.441383],
                [20.227776, 39.51944],
                [20.18861, 39.619164],
                [20.176109, 39.628052],
                [20.16527600000012, 39.63388800000013],
                [20.063332, 39.67999300000014],
                [20.059444, 39.681664],
                [20.054165, 39.6827770000001],
                [20.010029, 39.6912],
                [20.013332, 39.69472],
                [20.021111, 39.697495],
                [20.031944, 39.69722000000013],
                [20.090553000000114, 39.68139],
                [20.09388700000011, 39.679161],
                [20.09861, 39.673882],
                [20.105000000000132, 39.66944100000012],
                [20.14139, 39.656105],
                [20.166664, 39.65028],
                [20.193333, 39.64527],
                [20.199165000000107, 39.644722],
                [20.21833, 39.64638500000012],
                [20.221664, 39.64833],
                [20.314720000000136, 39.72361],
                [20.317497, 39.726105],
                [20.319443, 39.729439],
                [20.320831, 39.733604],
                [20.318054, 39.739998],
                [20.29805, 39.771942],
                [20.289444, 39.803055],
                [20.29139, 39.806664],
                [20.29472, 39.808609],
                [20.302219, 39.811661],
                [20.306129, 39.812119],
                [20.371666, 39.788887],
                [20.37611, 39.787498],
                [20.381386000000134, 39.78722],
                [20.385277, 39.78860500000013],
                [20.401943, 39.799164],
                [20.407219, 39.804443],
                [20.41222, 39.815826],
                [20.41444, 39.82444],
                [20.415276, 39.836937],
                [20.41222, 39.84333],
                [20.408886, 39.84916],
                [20.36972, 39.89138800000012],
                [20.338055, 39.921661],
                [20.336388, 39.92472],
                [20.314720000000136, 39.990273],
                [20.316109, 39.993332],
                [20.421944, 40.05805],
                [20.43861, 40.068054],
                [20.449997, 40.072495],
                [20.461571, 40.074165],
                [20.476944, 40.066109],
                [20.48222, 40.064995000000124],
                [20.555832, 40.066383],
                [20.583332, 40.070549],
                [20.604721, 40.075272],
                [20.621387, 40.085274],
                [20.657219, 40.091385000000116],
                [20.665276, 40.094162],
                [20.671944, 40.09805300000011],
                [20.67388, 40.1013870000001],
                [20.721107, 40.223053],
                [20.721386, 40.227219],
                [20.72083, 40.24666600000012],
                [20.714722, 40.255272],
                [20.71083, 40.265],
                [20.71194, 40.273888],
                [20.713055, 40.278328],
                [20.715, 40.281662],
                [20.733330000000137, 40.305275],
                [20.740276, 40.309166],
                [20.75861, 40.31194],
                [20.78722, 40.394722],
                [20.791924, 40.43154],
                [20.833332, 40.462219],
                [20.910831, 40.46527100000014],
                [20.914165, 40.463051],
                [20.918610000000115, 40.461662],
                [20.93694, 40.464439],
                [20.945553, 40.466942],
                [20.948887, 40.468887],
                [20.951942, 40.471382],
                [21.041386, 40.561943],
                [21.042774000000122, 40.56611],
                [21.053055, 40.618607],
                [21.053608, 40.62277],
                [21.054165, 40.661942000000124],
                [21.053055, 40.673332],
                [21.051941000000113, 40.676666],
                [21.046665, 40.685829],
                [21.036587, 40.698563],
                [21.028889, 40.708054],
                [21.020832, 40.715553],
                [20.98389, 40.7930530000001],
                [20.98349, 40.855888],
                [21.12155, 40.85722],
                [21.150833, 40.857498],
                [21.31472, 40.86860700000011],
                [21.343052, 40.871941000000106],
                [21.35667, 40.87444],
                [21.36861, 40.878326],
                [21.380554, 40.888054000000125],
                [21.399719, 40.906944],
                [21.405552, 40.9116590000001],
                [21.41555, 40.91777],
                [21.41972, 40.91916700000013],
                [21.513611, 40.910553],
                [21.52972000000011, 40.908882],
                [21.533607, 40.90721900000011],
                [21.53666, 40.90471600000012],
                [21.54833, 40.891106],
                [21.570000000000107, 40.874992],
                [21.573608, 40.873055],
                [21.57972, 40.872215],
                [21.599998, 40.87277200000011],
                [21.78028, 40.928886],
                [21.792221, 40.93278],
                [21.911942000000124, 41.049438],
                [21.913609, 41.05332900000013],
                [21.913887000000102, 41.056938000000116],
                [21.91055, 41.067215],
                [21.90916, 41.07444],
                [21.916111000000114, 41.095276],
                [21.97361, 41.12999700000012],
                [21.98055, 41.1336060000001],
                [22.20555, 41.16777000000013],
                [22.256664000000114, 41.171387],
                [22.26249700000011, 41.17055],
                [22.304722, 41.15333],
                [22.34333, 41.134438],
                [22.434719, 41.12138],
                [22.450275, 41.12138],
                [22.484722, 41.12138],
                [22.58083, 41.11999500000013],
                [22.585552, 41.119438],
                [22.590275, 41.11999500000013],
                [22.720554000000106, 41.14277600000014],
                [22.72916, 41.144722],
                [22.73583, 41.14888800000011],
                [22.741943, 41.159164],
                [22.74361, 41.16333],
                [22.758053, 41.22777600000012],
                [22.76154300000013, 41.25174],
                [22.765274, 41.296661],
                [22.76361, 41.29972],
                [22.760555, 41.30194],
                [22.759441, 41.30527],
                [22.75972, 41.309441],
                [22.763988, 41.315315],
                [22.772221, 41.32444],
                [22.78139, 41.33166],
                [22.803886, 41.346939],
                [22.813053, 41.34861000000012],
                [22.926388, 41.343048],
                [22.935604, 41.342125],
                [22.97555, 41.335548],
                [23.094444000000124, 41.320549],
                [23.119999, 41.32083100000011],
                [23.180832, 41.32278],
                [23.189442, 41.32471],
                [23.20111100000014, 41.32916300000011],
                [23.21472200000011, 41.336937],
                [23.227219000000105, 41.34638],
                [23.229443, 41.34972],
                [23.230274, 41.353333],
                [23.22639, 41.366943],
                [23.228333, 41.374992],
                [23.231388, 41.37749],
                [23.273888, 41.39971900000012],
                [23.285275, 41.404716],
                [23.29472, 41.406105],
                [23.440552, 41.409439],
                [23.538887, 41.397217],
                [23.551109, 41.391663],
                [23.598053, 41.38083],
                [23.631107, 41.37749],
                [23.63583, 41.378052],
                [23.73833100000013, 41.408607],
                [23.796387, 41.43666100000013],
                [23.886387, 41.451942],
                [23.974442, 41.440552],
                [23.97889, 41.441109],
                [24.06639, 41.485275],
                [24.06305, 41.51722],
                [24.06305, 41.52082800000011],
                [24.064999, 41.524437],
                [24.080276, 41.541107],
                [24.09333, 41.549995],
                [24.0975, 41.551109],
                [24.10166, 41.55082700000014],
                [24.157219, 41.541107],
                [24.19999, 41.54378500000013],
                [24.215275, 41.554993],
                [24.24555, 41.567772],
                [24.25389, 41.57],
                [24.26388, 41.57054900000014],
                [24.269444, 41.57],
                [24.304722, 41.54860700000012],
                [24.307777, 41.546387],
                [24.46611000000013, 41.55194100000011],
                [24.564442, 41.503326],
                [24.567497, 41.489441],
                [24.603333, 41.437492000000134],
                [24.608887, 41.43222],
                [24.612499000000128, 41.430275],
                [24.76777600000014, 41.37055],
                [24.809444, 41.352219000000105],
                [24.812496000000124, 41.378326],
                [24.817497, 41.4025],
                [24.819443, 41.405],
                [24.898888, 41.41194],
                [24.903889, 41.41194],
                [25.036507, 41.37044],
                [25.061192, 41.362572],
                [25.163052, 41.31749],
                [25.185833, 41.30527],
                [25.19083, 41.301453],
                [25.239441, 41.254433],
                [25.24389, 41.252769],
                [25.27971600000012, 41.24305],
                [25.28500000000014, 41.24305],
                [25.335831, 41.24916100000013],
                [25.344994, 41.250542],
                [25.50361, 41.289444],
                [25.549995, 41.31304200000011],
                [25.559441, 41.32000000000011],
                [25.567776, 41.32222],
                [25.653049, 41.317772000000105],
                [25.814159, 41.336098000000106],
                [25.881104, 41.309708000000114],
                [25.886662, 41.309166],
                [25.90555, 41.3111],
                [25.97916, 41.31944],
                [25.987778000000105, 41.3211060000001],
                [26.139996, 41.354713],
                [26.198051, 41.439438],
                [26.183884, 41.536942],
                [26.181664, 41.54332],
                [26.137215, 41.629433],
                [26.13472, 41.63221],
                [26.12972, 41.63221],
                [26.117493, 41.628609],
                [26.10305, 41.627213],
                [26.0991590000001, 41.628876],
                [26.068604, 41.660271],
                [26.065826, 41.685822],
                [26.066109, 41.69749500000012],
                [26.074444, 41.711937],
                [26.08083, 41.716660000000104],
                [26.13861100000014, 41.739159],
                [26.163052, 41.746666],
                [26.17194, 41.748322],
                [26.177498000000128, 41.748055000000136],
                [26.22275900000011, 41.7435],
                [26.234772, 41.740028],
                [26.23696, 41.73727],
                [26.264996, 41.71583],
                [26.277222, 41.709991],
                [26.29416700000013, 41.708054],
              ],
            ],
          ],
        },
        id: 9,
        NAME: 'Greece',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Romania',
          id: 10,
          label: 'Romania',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.234,
          year: '2023',
          centroid: [24.9668, 45.9432],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [20.726955, 46.17556],
              [20.719997, 46.187492],
              [20.720554, 46.191666],
              [20.75333, 46.238884],
              [20.761387, 46.246941],
              [20.783054, 46.259438],
              [20.795898, 46.265724],
              [20.820274, 46.274719],
              [20.82972, 46.277222],
              [20.846386, 46.27916],
              [20.86861, 46.276108],
              [20.989719, 46.254715],
              [21.03611, 46.245277],
              [21.048332, 46.239998],
              [21.053608, 46.238884],
              [21.059444, 46.239166],
              [21.08083, 46.246941],
              [21.176666, 46.295555],
              [21.178055, 46.299164],
              [21.178608, 46.326942],
              [21.185276, 46.362495],
              [21.191387, 46.381386],
              [21.19722, 46.391388],
              [21.208332, 46.402222],
              [21.219166, 46.408333],
              [21.288887, 46.460548],
              [21.29361, 46.532494],
              [21.30722, 46.588051],
              [21.308887, 46.59166],
              [21.324718, 46.616943],
              [21.326664, 46.619995],
              [21.329441, 46.622772],
              [21.441944, 46.681938],
              [21.449997, 46.685272],
              [21.45472, 46.685555],
              [21.467499, 46.685829],
              [21.489407, 46.684532],
              [21.493889, 46.686943],
              [21.521942, 46.712776],
              [21.526943, 46.718605],
              [21.528332, 46.722221],
              [21.529163, 46.726387],
              [21.528053, 46.729996],
              [21.521664, 46.734718],
              [21.502777, 46.739998],
              [21.494999, 46.743889],
              [21.489166, 46.749161],
              [21.488052, 46.752777],
              [21.493053, 46.763054],
              [21.519722, 46.815277],
              [21.526386, 46.825272],
              [21.529163, 46.828049],
              [21.545555, 46.839439],
              [21.613331, 46.884163],
              [21.67083, 46.961388],
              [21.691944, 46.994164],
              [21.695831, 47.000832],
              [21.695274, 47.004997],
              [21.693607, 47.008049],
              [21.690277, 47.010551],
              [21.655502, 47.020866],
              [21.653332, 47.022499],
              [21.651665, 47.025551],
              [21.651108, 47.029716],
              [21.653889, 47.032494],
              [21.709999, 47.07972],
              [21.734997, 47.094719],
              [21.751389, 47.101662],
              [21.769997, 47.106941],
              [21.782219, 47.112221],
              [21.790833, 47.120277],
              [21.844719, 47.184998],
              [21.84861, 47.191666],
              [21.84861, 47.203888],
              [21.846943, 47.211937],
              [21.84333, 47.21833],
              [21.84111, 47.225555],
              [21.841663, 47.234718],
              [21.843052, 47.238327],
              [21.869164, 47.293327],
              [21.874165, 47.299721],
              [21.922497, 47.354439],
              [21.925552, 47.357216],
              [21.932499, 47.361382],
              [21.937222, 47.362778],
              [21.962498, 47.36805],
              [21.985554, 47.369995],
              [21.996387, 47.371666],
              [22.004719, 47.374992],
              [22.0075, 47.377777],
              [22.00972, 47.380829],
              [22.013054, 47.388054],
              [22.015553, 47.395828],
              [22.020554, 47.425278],
              [22.021942, 47.445274],
              [22.018608, 47.456383],
              [22.009998, 47.473053],
              [22.006664, 47.484161],
              [22.006107, 47.496941],
              [22.010277, 47.508606],
              [22.015274, 47.514442],
              [22.023888, 47.522499],
              [22.032497, 47.530273],
              [22.043053, 47.536942],
              [22.118008, 47.57811],
              [22.158607, 47.585548],
              [22.177219, 47.59111],
              [22.186386, 47.59861],
              [22.189838, 47.603958],
              [22.19083, 47.626663],
              [22.191944, 47.630829],
              [22.224163, 47.677773],
              [22.226387, 47.680832],
              [22.270554, 47.723885],
              [22.276943, 47.728607],
              [22.318886, 47.745827],
              [22.323055, 47.747498],
              [22.445274, 47.793327],
              [22.454441, 47.796387],
              [22.472775, 47.796944],
              [22.489441, 47.794167],
              [22.5, 47.790852],
              [22.503609, 47.789719],
              [22.546944, 47.768051],
              [22.557499, 47.766106],
              [22.594997, 47.766937],
              [22.612221, 47.768608],
              [22.634163, 47.77166],
              [22.65361, 47.776382],
              [22.774441, 47.836388],
              [22.780277, 47.84166],
              [22.782497, 47.844719],
              [22.782776, 47.849159],
              [22.894804, 47.95454],
              [22.896111, 47.953888],
              [22.929996, 47.960548],
              [23.043331, 47.99305],
              [23.084442, 48.011108],
              [23.091106, 48.015831],
              [23.09972, 48.028877],
              [23.104717, 48.039719],
              [23.110828, 48.054436],
              [23.114162, 48.071106],
              [23.119164, 48.08194],
              [23.123886, 48.088326],
              [23.129719, 48.093605],
              [23.147774, 48.104164],
              [23.15694, 48.107216],
              [23.168053, 48.108604],
              [23.180275, 48.108047],
              [23.256386, 48.091934],
              [23.264999, 48.088326],
              [23.276943, 48.078331],
              [23.281387, 48.07222],
              [23.29361, 48.049164],
              [23.296108, 48.046387],
              [23.299442, 48.043884],
              [23.30722, 48.039993],
              [23.356106, 48.021103],
              [23.410275, 48.000549],
              [23.480553, 47.977493],
              [23.487499, 47.977219],
              [23.497776, 47.978333],
              [23.509163, 47.98333],
              [23.512218, 47.985832],
              [23.514267, 47.989338],
              [23.566097, 47.999992],
              [23.823887, 47.966942],
              [23.969719, 47.961388],
              [24.026665, 47.95694],
              [24.038055, 47.954994],
              [24.089443, 47.938049],
              [24.096386, 47.933609],
              [24.109444, 47.919716],
              [24.116386, 47.915276],
              [24.125553, 47.911942],
              [24.131107, 47.910828],
              [24.136944, 47.909996],
              [24.244164, 47.90361],
              [24.249722, 47.90416],
              [24.326942, 47.928886],
              [24.412498, 47.956108],
              [24.427776, 47.95916],
              [24.433331, 47.959717],
              [24.453888, 47.958611],
              [24.556389, 47.953049],
              [24.572289, 47.949478],
              [24.588333, 47.945831],
              [24.609997, 47.936943],
              [24.620831, 47.93055],
              [24.668053, 47.902222],
              [24.672775, 47.89666],
              [24.673885, 47.892776],
              [24.673332, 47.888329],
              [24.66861, 47.87722],
              [24.668053, 47.872498],
              [24.668888, 47.868889],
              [24.670555, 47.865555],
              [24.676109, 47.860275],
              [24.693886, 47.849159],
              [24.709999, 47.84111],
              [24.723888, 47.836105],
              [24.770275, 47.820549],
              [24.802776, 47.817772],
              [24.812775, 47.814995],
              [24.816387, 47.813049],
              [24.822777, 47.808052],
              [24.832497, 47.797493],
              [24.863331, 47.759995],
              [24.891941, 47.721382],
              [24.894444, 47.718605],
              [24.901386, 47.714165],
              [24.906666, 47.712776],
              [24.919441, 47.711662],
              [24.928917, 47.713142],
              [24.953609, 47.719444],
              [24.968887, 47.722221],
              [24.999506, 47.724461],
              [25.029716, 47.728867],
              [25.049438, 47.73333],
              [25.085548, 47.744431],
              [25.109997, 47.75499],
              [25.123882, 47.763878],
              [25.148331, 47.784431],
              [25.156937, 47.792763],
              [25.161659, 47.798882],
              [25.17083, 47.816666],
              [25.17944, 47.829987],
              [25.218601, 47.870827],
              [25.23027, 47.881371],
              [25.237774, 47.885544],
              [25.254993, 47.89193],
              [25.326103, 47.915268],
              [25.34166, 47.918053],
              [25.501659, 47.933327],
              [25.524998, 47.934708],
              [25.568329, 47.935822],
              [25.588608, 47.934433],
              [25.646107, 47.933594],
              [25.773331, 47.93499],
              [25.783333, 47.937202],
              [25.791943, 47.940262],
              [25.817219, 47.955269],
              [25.833328, 47.962494],
              [25.843327, 47.964432],
              [25.922215, 47.974709],
              [26.037216, 47.983597],
              [26.102711, 47.981716],
              [26.114998, 47.981361],
              [26.149998, 47.982201],
              [26.167213, 47.988312],
              [26.183601, 47.995537],
              [26.194717, 48.001663],
              [26.197773, 48.00444],
              [26.272221, 48.076103],
              [26.322498, 48.162491],
              [26.322498, 48.166664],
              [26.318607, 48.172768],
              [26.317116, 48.176022],
              [26.315552, 48.179436],
              [26.314907, 48.186165],
              [26.463051, 48.217209],
              [26.474716, 48.217766],
              [26.499161, 48.215271],
              [26.515831, 48.211662],
              [26.524166, 48.208046],
              [26.52972, 48.207497],
              [26.534721, 48.208603],
              [26.567776, 48.222488],
              [26.634995, 48.257164],
              [26.704163, 48.263885],
              [26.808609, 48.249435],
              [26.825829, 48.244156],
              [26.954716, 48.185547],
              [27.000553, 48.155548],
              [27.158604, 47.985817],
              [27.200829, 47.902199],
              [27.211102, 47.845818],
              [27.238323, 47.785255],
              [27.280273, 47.693047],
              [27.297215, 47.661377],
              [27.298317, 47.66],
              [27.299438, 47.6586],
              [27.32777, 47.636658],
              [27.361191, 47.616978],
              [27.433331, 47.565262],
              [27.472916, 47.485977],
              [27.576103, 47.366096],
              [27.628326, 47.311928],
              [27.634163, 47.306931],
              [27.64138, 47.302483],
              [27.67944, 47.293877],
              [27.712494, 47.287209],
              [27.718601, 47.287209],
              [27.720778, 47.285671],
              [27.725269, 47.282494],
              [27.742214, 47.262772],
              [27.784718, 47.204987],
              [27.78611, 47.201653],
              [27.798054, 47.152489],
              [27.861382, 47.102486],
              [27.939995, 47.044991],
              [27.940893, 47.044476],
              [27.943886, 47.042763],
              [27.955872, 47.041542],
              [27.98966, 47.030838],
              [28.007771, 47.024712],
              [28.033886, 47.015549],
              [28.07111, 46.991096],
              [28.07972, 46.983597],
              [28.08194, 46.980537],
              [28.084721, 46.973877],
              [28.10638, 46.920273],
              [28.115826, 46.887772],
              [28.119717, 46.854404],
              [28.117493, 46.849434],
              [28.114716, 46.84137],
              [28.114716, 46.837212],
              [28.116108, 46.833878],
              [28.174435, 46.739716],
              [28.20388, 46.698601],
              [28.217495, 46.682213],
              [28.229713, 46.672493],
              [28.23315, 46.667683],
              [28.233883, 46.666656],
              [28.245827, 46.615822],
              [28.246958, 46.606525],
              [28.247211, 46.604439],
              [28.252499, 46.435822],
              [28.250111, 46.430672],
              [28.245544, 46.42083],
              [28.193604, 46.330269],
              [28.138882, 46.190536],
              [28.115829, 46.124718],
              [28.108326, 46.102291],
              [28.091385, 46.075829],
              [28.084438, 46.011658],
              [28.085831, 46.004166],
              [28.09277, 45.991653],
              [28.094994, 45.988884],
              [28.097387, 45.984425],
              [28.10722, 45.966103],
              [28.120274, 45.921928],
              [28.163609, 45.725548],
              [28.164436, 45.721657],
              [28.164993, 45.71804],
              [28.166939, 45.670273],
              [28.16666, 45.6661],
              [28.162495, 45.631927],
              [28.161102, 45.628036],
              [28.158604, 45.624985],
              [28.154995, 45.623047],
              [28.145662, 45.620529],
              [28.12888, 45.62027],
              [28.06916, 45.583321],
              [28.17194, 45.474709],
              [28.176941, 45.469437],
              [28.211311, 45.450111],
              [28.21484, 45.448647],
              [28.218601, 45.449997],
              [28.229324, 45.449207],
              [28.272774, 45.435547],
              [28.27916, 45.430817],
              [28.281109, 45.42804],
              [28.283886, 45.421371],
              [28.284992, 45.413872],
              [28.284161, 45.409424],
              [28.283926, 45.398788],
              [28.283886, 45.396935],
              [28.285275, 45.389435],
              [28.287777, 45.382767],
              [28.29472, 45.37027],
              [28.303608, 45.354996],
              [28.310799, 45.344677],
              [28.311939, 45.34304],
              [28.316666, 45.337494],
              [28.33083, 45.324997],
              [28.343327, 45.315536],
              [28.375828, 45.300545],
              [28.574715, 45.24276],
              [28.688328, 45.220818],
              [28.694714, 45.219986],
              [28.695932, 45.219986],
              [28.700846, 45.219986],
              [28.706657, 45.219986],
              [28.785275, 45.229996],
              [28.797218, 45.234711],
              [28.799622, 45.237656],
              [28.799721, 45.240822],
              [28.84861, 45.301659],
              [28.968052, 45.321106],
              [29.217216, 45.424721],
              [29.226109, 45.426941],
              [29.318886, 45.438889],
              [29.324162, 45.439156],
              [29.411385, 45.435822],
              [29.503326, 45.412766],
              [29.51833, 45.4086],
              [29.571938, 45.392487],
              [29.589439, 45.385544],
              [29.603333, 45.376938],
              [29.636944, 45.350266],
              [29.644997, 45.342499],
              [29.654999, 45.327766],
              [29.667217, 45.301659],
              [29.67083, 45.287491],
              [29.672497, 45.276375],
              [29.671944, 45.268044],
              [29.664331, 45.211803],
              [29.632214, 45.215828],
              [29.626942, 45.215271],
              [29.623882, 45.213051],
              [29.62447, 45.211285],
              [29.624992, 45.209717],
              [29.641106, 45.173882],
              [29.660275, 45.112762],
              [29.64138, 44.981934],
              [29.613049, 44.851662],
              [29.607494, 44.840828],
              [29.599716, 44.837494],
              [29.549438, 44.820267],
              [29.450829, 44.808884],
              [29.389996, 44.802216],
              [29.353046, 44.799721],
              [29.340069, 44.799721],
              [29.330547, 44.799721],
              [29.250832, 44.79583],
              [29.214161, 44.793053],
              [29.067493, 44.822762],
              [29.051941, 44.842484],
              [29.049995, 44.845543],
              [29.044994, 44.858887],
              [29.038326, 44.911934],
              [29.039436, 44.92054],
              [29.04277, 44.927773],
              [29.051105, 44.936371],
              [29.063885, 44.945534],
              [29.07111, 44.949425],
              [29.084721, 44.952766],
              [29.095276, 44.953606],
              [29.10416, 44.955826],
              [29.110271, 44.960541],
              [29.111664, 44.964706],
              [29.111938, 44.96888],
              [29.109715, 44.971657],
              [29.099442, 44.978325],
              [29.047215, 45.002769],
              [29.04166, 45.003609],
              [28.98999, 45.006104],
              [28.979713, 45.006104],
              [28.975552, 45.004715],
              [28.899998, 44.96666],
              [28.873882, 44.948601],
              [28.868324, 44.943047],
              [28.866383, 44.939713],
              [28.862217, 44.927773],
              [28.861107, 44.919159],
              [28.862492, 44.881653],
              [28.863605, 44.878319],
              [28.869991, 44.873604],
              [28.89027, 44.865273],
              [28.897217, 44.861107],
              [28.944996, 44.830269],
              [28.949715, 44.824715],
              [28.949715, 44.821381],
              [28.926941, 44.778328],
              [28.907219, 44.755547],
              [28.896107, 44.755272],
              [28.872215, 44.751099],
              [28.859715, 44.746941],
              [28.798328, 44.719437],
              [28.793327, 44.713326],
              [28.783051, 44.697487],
              [28.781109, 44.693871],
              [28.779716, 44.669434],
              [28.779142, 44.657059],
              [28.783886, 44.647484],
              [28.789928, 44.642387],
              [28.79277, 44.639992],
              [28.799164, 44.639435],
              [28.814159, 44.641373],
              [28.843609, 44.645821],
              [28.851662, 44.648598],
              [28.85833, 44.653046],
              [28.904442, 44.684433],
              [28.907494, 44.686646],
              [28.909992, 44.689713],
              [28.9104, 44.692337],
              [28.90527, 44.698318],
              [28.898331, 44.70694],
              [28.899715, 44.710815],
              [28.90416, 44.709984],
              [28.930027, 44.701225],
              [28.954163, 44.699158],
              [28.95916, 44.697762],
              [28.987774, 44.688881],
              [28.99194, 44.687202],
              [28.994717, 44.684708],
              [28.995274, 44.680817],
              [28.993881, 44.676941],
              [28.972218, 44.645546],
              [28.969711, 44.642487],
              [28.955273, 44.630814],
              [28.951656, 44.628876],
              [28.946938, 44.627762],
              [28.943604, 44.62999],
              [28.94138, 44.633041],
              [28.942219, 44.636658],
              [28.958324, 44.656647],
              [28.969162, 44.662491],
              [28.975269, 44.667206],
              [28.98027, 44.673325],
              [28.981663, 44.677216],
              [28.981167, 44.678406],
              [28.98027, 44.68055],
              [28.976936, 44.68277],
              [28.960274, 44.689713],
              [28.954437, 44.68998],
              [28.819672, 44.616951],
              [28.796518, 44.630844],
              [28.767494, 44.629715],
              [28.763611, 44.628052],
              [28.760551, 44.625275],
              [28.755833, 44.61805],
              [28.75444, 44.614441],
              [28.7575, 44.519722],
              [28.803219, 44.525768],
              [28.813051, 44.537106],
              [28.927773, 44.617493],
              [28.913052, 44.588051],
              [28.881943, 44.542213],
              [28.871666, 44.52916],
              [28.845276, 44.497208],
              [28.831387, 44.482216],
              [28.825272, 44.476944],
              [28.805664, 44.463833],
              [28.803165, 44.462826],
              [28.790161, 44.455326],
              [28.758053, 44.431389],
              [28.745548, 44.42083],
              [28.65416, 44.339432],
              [28.645271, 44.331383],
              [28.642773, 44.328049],
              [28.634995, 44.311935],
              [28.629993, 44.298607],
              [28.629166, 44.294434],
              [28.628883, 44.271935],
              [28.632771, 44.157494],
              [28.660275, 43.975548],
              [28.647221, 43.95443],
              [28.613605, 43.881653],
              [28.594994, 43.831657],
              [28.585278, 43.800819],
              [28.579437, 43.764709],
              [28.579437, 43.758041],
              [28.583244, 43.747765],
              [28.484997, 43.744164],
              [28.403889, 43.750275],
              [28.257771, 43.764435],
              [28.235554, 43.769997],
              [28.181942, 43.785271],
              [28.133053, 43.801659],
              [28.047218, 43.831657],
              [28.029716, 43.839165],
              [28.001942, 43.8536],
              [27.997215, 43.859154],
              [27.991108, 43.871666],
              [27.962215, 43.938332],
              [27.958328, 43.951653],
              [27.957771, 43.958878],
              [27.95472, 43.972771],
              [27.951664, 43.978882],
              [27.944717, 43.987221],
              [27.927773, 44.002769],
              [27.918884, 44.005547],
              [27.914444, 44.004433],
              [27.86805, 43.984154],
              [27.852776, 43.977486],
              [27.833328, 43.969162],
              [27.820271, 43.965828],
              [27.806107, 43.964165],
              [27.747215, 43.95916],
              [27.736382, 43.959717],
              [27.730827, 43.961098],
              [27.717773, 43.966942],
              [27.711662, 43.971657],
              [27.706944, 43.977219],
              [27.698353, 43.993607],
              [27.684715, 44.020821],
              [27.67944, 44.029999],
              [27.676941, 44.032776],
              [27.673882, 44.035271],
              [27.660828, 44.040833],
              [27.656109, 44.042496],
              [27.650555, 44.043053],
              [27.64222, 44.040276],
              [27.631943, 44.0336],
              [27.629719, 44.030266],
              [27.623333, 44.025269],
              [27.614162, 44.023598],
              [27.475826, 44.01944],
              [27.416943, 44.020554],
              [27.399998, 44.021935],
              [27.396111, 44.024155],
              [27.299995, 44.080544],
              [27.29055, 44.088051],
              [27.279716, 44.102219],
              [27.278889, 44.105553],
              [27.272713, 44.132149],
              [27.250549, 44.124985],
              [27.237778, 44.121666],
              [27.222775, 44.119987],
              [27.199715, 44.122208],
              [27.187492, 44.124435],
              [27.165833, 44.12999],
              [27.111111, 44.140831],
              [27.036427, 44.147339],
              [26.913403, 44.136124],
              [26.890205, 44.131989],
              [26.840832, 44.115555],
              [26.79472, 44.095276],
              [26.671104, 44.071938],
              [26.478611, 44.049431],
              [26.438416, 44.041306],
              [26.413036, 44.043129],
              [26.391388, 44.044434],
              [26.381943, 44.04332],
              [26.301941, 44.030823],
              [26.144161, 43.986382],
              [26.128609, 43.979156],
              [26.111664, 43.968323],
              [26.085278, 43.949715],
              [25.947495, 43.852219],
              [25.938049, 43.844719],
              [25.89027, 43.801941],
              [25.887238, 43.799103],
              [25.8825, 43.792213],
              [25.878262, 43.778824],
              [25.786942, 43.713051],
              [25.772495, 43.705544],
              [25.760551, 43.701111],
              [25.739246, 43.695122],
              [25.731377, 43.694077],
              [25.681339, 43.69043],
              [25.609161, 43.662209],
              [25.53194, 43.6436],
              [25.463852, 43.639206],
              [25.440952, 43.630112],
              [25.430229, 43.626778],
              [25.416111, 43.624718],
              [25.396111, 43.623322],
              [25.380711, 43.622437],
              [25.375275, 43.622765],
              [25.363049, 43.624718],
              [25.348885, 43.62999],
              [25.339439, 43.636932],
              [25.314442, 43.652222],
              [25.275272, 43.672493],
              [25.261944, 43.678055],
              [25.224716, 43.687485],
              [25.022751, 43.71019],
              [24.881386, 43.712219],
              [24.79361, 43.712776],
              [24.722775, 43.714165],
              [24.705555, 43.715271],
              [24.686932, 43.718384],
              [24.613331, 43.749161],
              [24.598331, 43.753883],
              [24.562496, 43.759163],
              [24.52861, 43.761108],
              [24.506386, 43.762215],
              [24.497219, 43.760277],
              [24.457775, 43.74472],
              [24.43861, 43.736382],
              [24.405277, 43.719719],
              [24.364719, 43.699715],
              [24.360832, 43.698051],
              [24.352497, 43.695549],
              [24.343052, 43.69416],
              [24.319706, 43.696632],
              [24.307777, 43.697495],
              [24.286388, 43.697495],
              [24.257221, 43.694443],
              [24.224163, 43.689438],
              [24.195553, 43.685272],
              [24.185833, 43.684441],
              [24.179996, 43.684715],
              [24.155617, 43.689911],
              [24.116077, 43.699913],
              [24.067982, 43.720627],
              [23.987499, 43.744164],
              [23.774166, 43.78833],
              [23.629719, 43.794998],
              [23.612499, 43.796104],
              [23.601665, 43.798607],
              [23.570274, 43.806938],
              [23.539352, 43.819328],
              [23.528042, 43.825523],
              [23.516003, 43.835381],
              [23.50703, 43.83773],
              [23.446663, 43.851105],
              [23.427147, 43.855232],
              [23.418224, 43.856171],
              [23.283607, 43.85083],
              [23.269009, 43.849243],
              [23.255142, 43.846321],
              [23.224499, 43.838661],
              [23.198608, 43.831383],
              [23.162109, 43.81823],
              [23.147499, 43.811104],
              [23.138885, 43.808327],
              [23.071457, 43.802177],
              [23.063602, 43.802177],
              [22.966942, 43.81694],
              [22.894444, 43.836105],
              [22.875275, 43.842499],
              [22.863331, 43.848328],
              [22.857471, 43.853256],
              [22.847618, 43.86821],
              [22.840687, 43.888283],
              [22.843243, 43.90506],
              [22.879719, 43.981667],
              [22.88472, 43.988052],
              [22.906944, 43.998886],
              [22.919857, 44.002838],
              [22.959431, 44.012276],
              [22.98222, 44.011383],
              [22.987499, 44.011665],
              [22.995831, 44.01416],
              [23.003407, 44.017799],
              [23.032497, 44.044716],
              [23.042774, 44.056664],
              [23.044441, 44.060555],
              [23.046108, 44.06916],
              [23.044167, 44.076111],
              [23.03722, 44.084442],
              [23.021942, 44.092773],
              [23.003609, 44.099442],
              [22.997444, 44.100632],
              [22.951385, 44.103607],
              [22.945274, 44.104439],
              [22.921665, 44.108604],
              [22.907497, 44.113609],
              [22.696941, 44.212219],
              [22.686386, 44.218887],
              [22.681435, 44.224701],
              [22.691666, 44.26416],
              [22.691109, 44.27166],
              [22.687496, 44.277771],
              [22.680832, 44.282494],
              [22.672775, 44.286385],
              [22.657776, 44.29055],
              [22.641109, 44.294167],
              [22.616676, 44.298035],
              [22.591942, 44.300827],
              [22.576111, 44.304718],
              [22.567219, 44.308327],
              [22.549721, 44.323051],
              [22.536942, 44.336388],
              [22.529999, 44.345276],
              [22.463333, 44.449997],
              [22.461712, 44.453201],
              [22.457333, 44.466698],
              [22.457333, 44.474358],
              [22.459999, 44.482216],
              [22.463055, 44.484444],
              [22.582222, 44.546104],
              [22.590275, 44.549164],
              [22.609444, 44.552216],
              [22.621387, 44.551109],
              [22.6325, 44.548607],
              [22.645554, 44.543053],
              [22.667774, 44.530548],
              [22.677219, 44.527222],
              [22.686817, 44.523979],
              [22.699585, 44.522522],
              [22.709164, 44.523888],
              [22.734722, 44.531662],
              [22.743053, 44.534439],
              [22.754444, 44.539719],
              [22.76088, 44.544411],
              [22.763432, 44.547325],
              [22.765255, 44.551338],
              [22.765781, 44.555199],
              [22.764893, 44.559006],
              [22.762703, 44.56192],
              [22.71722, 44.602493],
              [22.713886, 44.604721],
              [22.709999, 44.606667],
              [22.671944, 44.618889],
              [22.659721, 44.619995],
              [22.644444, 44.618607],
              [22.622219, 44.618889],
              [22.609722, 44.620552],
              [22.604721, 44.622215],
              [22.592499, 44.628052],
              [22.574444, 44.638611],
              [22.543053, 44.658607],
              [22.519722, 44.674721],
              [22.508053, 44.684715],
              [22.496944, 44.695],
              [22.489998, 44.703331],
              [22.479164, 44.710274],
              [22.469719, 44.713608],
              [22.457775, 44.715553],
              [22.436386, 44.714439],
              [22.431664, 44.713333],
              [22.423611, 44.710274],
              [22.320553, 44.668327],
              [22.31361, 44.664162],
              [22.308609, 44.657776],
              [22.303608, 44.645828],
              [22.297775, 44.635826],
              [22.273331, 44.604164],
              [22.25861, 44.585274],
              [22.187222, 44.493889],
              [22.176941, 44.481941],
              [22.168888, 44.478607],
              [22.146385, 44.479164],
              [22.128609, 44.481384],
              [22.106667, 44.490273],
              [22.09111, 44.498329],
              [22.084442, 44.503052],
              [22.039444, 44.551666],
              [22.035553, 44.557495],
              [22.033333, 44.564438],
              [22.031261, 44.589424],
              [22.029163, 44.593887],
              [22.003887, 44.628609],
              [22.001389, 44.631104],
              [21.993889, 44.635551],
              [21.988888, 44.63694],
              [21.909164, 44.649437],
              [21.783607, 44.661942],
              [21.738609, 44.656944],
              [21.729721, 44.654716],
              [21.655552, 44.656944],
              [21.649441, 44.657776],
              [21.639721, 44.660828],
              [21.632221, 44.664993],
              [21.622776, 44.672218],
              [21.618332, 44.678329],
              [21.614998, 44.688606],
              [21.614719, 44.692215],
              [21.614719, 44.697495],
              [21.616386, 44.710274],
              [21.61565, 44.717705],
              [21.604164, 44.747498],
              [21.600277, 44.753609],
              [21.594997, 44.758888],
              [21.588333, 44.763329],
              [21.565552, 44.77166],
              [21.543053, 44.776382],
              [21.524441, 44.778328],
              [21.47472, 44.777771],
              [21.453609, 44.776665],
              [21.405869, 44.779732],
              [21.400398, 44.780823],
              [21.394196, 44.785934],
              [21.362091, 44.823143],
              [21.363052, 44.833057],
              [21.366108, 44.864441],
              [21.373055, 44.868607],
              [21.400276, 44.874992],
              [21.415276, 44.877495],
              [21.444443, 44.876389],
              [21.462776, 44.874443],
              [21.478886, 44.875275],
              [21.50222, 44.879715],
              [21.548611, 44.889442],
              [21.552776, 44.890831],
              [21.555832, 44.893326],
              [21.558609, 44.896111],
              [21.559719, 44.900551],
              [21.559719, 44.908607],
              [21.556389, 44.91861],
              [21.551388, 44.928055],
              [21.546944, 44.933884],
              [21.540833, 44.938606],
              [21.527775, 44.94416],
              [21.475555, 44.961662],
              [21.470833, 44.963051],
              [21.459164, 44.964439],
              [21.441109, 44.960274],
              [21.429722, 44.961662],
              [21.408886, 44.971107],
              [21.405552, 44.973328],
              [21.37611, 44.996666],
              [21.371109, 45.00222],
              [21.366943, 45.008331],
              [21.367222, 45.015549],
              [21.369442, 45.018608],
              [21.372776, 45.020828],
              [21.381943, 45.023331],
              [21.443054, 45.053604],
              [21.512775, 45.123329],
              [21.514164, 45.126938],
              [21.516109, 45.139717],
              [21.515274, 45.147774],
              [21.513611, 45.151108],
              [21.482777, 45.183609],
              [21.47337, 45.187447],
              [21.416664, 45.214722],
              [21.404999, 45.21611],
              [21.351387, 45.217773],
              [21.276386, 45.229721],
              [21.267498, 45.232773],
              [21.048885, 45.316383],
              [20.986664, 45.345833],
              [20.808331, 45.478882],
              [20.794167, 45.507774],
              [20.76833, 45.602219],
              [20.766666, 45.609993],
              [20.766941, 45.619164],
              [20.76833, 45.622772],
              [20.772499, 45.629166],
              [20.780552, 45.637497],
              [20.796108, 45.649437],
              [20.798885, 45.656662],
              [20.804722, 45.744164],
              [20.804443, 45.757217],
              [20.801388, 45.76416],
              [20.79583, 45.769165],
              [20.788055, 45.773048],
              [20.782776, 45.773888],
              [20.776943, 45.773605],
              [20.773052, 45.771942],
              [20.767498, 45.766663],
              [20.764164, 45.75972],
              [20.757774, 45.750275],
              [20.747776, 45.743607],
              [20.738609, 45.741104],
              [20.727497, 45.739998],
              [20.721664, 45.740555],
              [20.713333, 45.743889],
              [20.709999, 45.746109],
              [20.664165, 45.795555],
              [20.660553, 45.801941],
              [20.656944, 45.813049],
              [20.656944, 45.830826],
              [20.654999, 45.833885],
              [20.591663, 45.894165],
              [20.578888, 45.903328],
              [20.561943, 45.909996],
              [20.545555, 45.912498],
              [20.526665, 45.912216],
              [20.515553, 45.913055],
              [20.506386, 45.915833],
              [20.378052, 45.97805],
              [20.368332, 45.984993],
              [20.360832, 45.993332],
              [20.355, 46.003052],
              [20.352776, 46.010277],
              [20.353611, 46.023605],
              [20.352497, 46.027222],
              [20.321388, 46.063606],
              [20.306664, 46.076111],
              [20.261024, 46.114853],
              [20.264442, 46.130272],
              [20.270832, 46.139717],
              [20.276665, 46.144722],
              [20.285275, 46.146942],
              [20.340275, 46.159439],
              [20.48695, 46.181107],
              [20.535275, 46.17305],
              [20.563332, 46.164993],
              [20.582775, 46.154999],
              [20.619442, 46.131386],
              [20.624722, 46.130272],
              [20.679443, 46.14222],
              [20.69589, 46.150391],
              [20.706387, 46.156662],
              [20.720554, 46.16555],
              [20.72583, 46.171104],
              [20.726955, 46.17556],
            ],
          ],
        },
        id: 10,
        NAME: 'Romania',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Italy',
          id: 11,
          label: 'Italy',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.225,
          year: '2023',
          centroid: [12.5674, 41.8719],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [12.127777, 47.001663000000121],
                [12.13611, 46.966942],
                [12.160276000000124, 46.92805],
                [12.181389000000138, 46.909721],
                [12.189722, 46.906105000000139],
                [12.232222, 46.888885],
                [12.301666, 46.84111],
                [12.378611, 46.72666],
                [12.388887000000125, 46.715553],
                [12.398333, 46.708328],
                [12.410276, 46.70277],
                [12.440554, 46.690826000000129],
                [12.486174000000119, 46.682365000000118],
                [12.554443, 46.661659],
                [12.590277, 46.658882000000119],
                [12.692499, 46.659721000000104],
                [12.728054, 46.642494],
                [12.732498, 46.64111],
                [12.73860900000011, 46.640274],
                [12.743332, 46.641388],
                [12.747929000000113, 46.644493],
                [12.753332, 46.648331],
                [12.76222, 46.651108000000136],
                [12.768888, 46.650833],
                [12.787777, 46.644997],
                [12.82361, 46.632217],
                [12.827499, 46.630272000000105],
                [13.2575, 46.56194],
                [13.428888, 46.56305],
                [13.551943, 46.55666],
                [13.558054, 46.555832],
                [13.611111000000108, 46.548050000000103],
                [13.718655, 46.526611000000116],
                [13.719444000000124, 46.522774],
                [13.718887, 46.51416],
                [13.711111, 46.492775],
                [13.69805, 46.46027400000014],
                [13.694721, 46.453331000000105],
                [13.689444, 46.447495],
                [13.685833, 46.44555],
                [13.657776, 46.449715],
                [13.511389, 46.384720000000129],
                [13.44083, 46.346382],
                [13.383055, 46.297218],
                [13.383888, 46.293053],
                [13.413055, 46.21583],
                [13.416111, 46.21333],
                [13.42055, 46.211662000000103],
                [13.425833, 46.21139],
                [13.450832000000105, 46.21611],
                [13.455, 46.217773000000136],
                [13.464998, 46.229439000000127],
                [13.485832, 46.232498],
                [13.491110000000106, 46.231384000000105],
                [13.55055, 46.218048],
                [13.657776, 46.187492],
                [13.664444, 46.183052],
                [13.669167, 46.177498],
                [13.669167, 46.17333200000013],
                [13.666943, 46.170273],
                [13.650555, 46.148605],
                [13.645832, 46.142494],
                [13.593611, 46.10527],
                [13.56861, 46.090553],
                [13.560276, 46.087494000000106],
                [13.555, 46.086937],
                [13.545555, 46.084160000000111],
                [13.538887000000102, 46.07944],
                [13.521944000000133, 46.063332],
                [13.479443, 46.013329000000113],
                [13.480000000000132, 46.01111],
                [13.502777, 45.99055],
                [13.516943, 45.981941],
                [13.53805, 45.969162],
                [13.5425, 45.967499],
                [13.560276, 45.972771],
                [13.564165000000116, 45.974442],
                [13.570833000000107, 45.97916],
                [13.580555, 45.991104],
                [13.584721, 45.992493],
                [13.601944000000117, 45.993607],
                [13.626944, 45.992218],
                [13.632221, 45.991104],
                [13.635, 45.988609],
                [13.636665, 45.985275],
                [13.6375, 45.974716],
                [13.635555, 45.952217],
                [13.633888000000127, 45.943604000000107],
                [13.618610000000103, 45.911385],
                [13.614443000000108, 45.904716],
                [13.611666, 45.902222],
                [13.593332, 45.892220000000123],
                [13.59111, 45.88916],
                [13.589167, 45.885551],
                [13.577776, 45.854164],
                [13.578888, 45.84638],
                [13.595833, 45.813606],
                [13.598055, 45.810829000000126],
                [13.610554, 45.80555],
                [13.697498, 45.784164],
                [13.784443, 45.756104000000107],
                [13.788887, 45.754440000000102],
                [13.796389, 45.750275000000101],
                [13.835278, 45.717773],
                [13.916943, 45.640274],
                [13.919167, 45.637497],
                [13.918610000000115, 45.63389],
                [13.863609, 45.589165],
                [13.850832, 45.585274],
                [13.827776, 45.584442],
                [13.802221, 45.586388],
                [13.716944, 45.596107],
                [13.785000000000139, 45.601105],
                [13.798054, 45.60527],
                [13.804443, 45.609993000000145],
                [13.804722, 45.613609],
                [13.73722, 45.693054000000132],
                [13.734165, 45.695549000000142],
                [13.656111, 45.753609],
                [13.632221, 45.769165],
                [13.627777, 45.77083],
                [13.579473, 45.78196000000014],
                [13.549999, 45.787216],
                [13.535276000000124, 45.779442],
                [13.528889000000106, 45.774719],
                [13.524443000000133, 45.763611],
                [13.523888, 45.758888],
                [13.523054000000116, 45.746666],
                [13.522778, 45.741943000000106],
                [13.523611, 45.739166],
                [13.530277, 45.734718],
                [13.529165, 45.724716],
                [13.49944, 45.70944],
                [13.433611, 45.67833],
                [13.424166, 45.676109],
                [13.392221, 45.672493],
                [13.386389, 45.67305],
                [13.377499, 45.67638],
                [13.376665000000116, 45.679993],
                [13.381388, 45.680275],
                [13.38722, 45.679443],
                [13.39194, 45.68055],
                [13.406111, 45.684166000000118],
                [13.409443, 45.686104],
                [13.423611000000108, 45.694443],
                [13.426943000000108, 45.696663000000115],
                [13.42861, 45.705276],
                [13.428333, 45.70944],
                [13.414165000000139, 45.722221],
                [13.411110000000122, 45.724442000000124],
                [13.40667, 45.726105],
                [13.367943, 45.73744],
                [13.216944000000126, 45.776939],
                [13.193333, 45.778053],
                [13.13111, 45.771942000000138],
                [13.126389, 45.77083],
                [13.114443, 45.765549000000135],
                [13.111666000000127, 45.763054000000125],
                [13.072222, 45.717773],
                [13.07, 45.714722],
                [13.06944, 45.709999],
                [13.073332, 45.696106],
                [13.096109, 45.651665],
                [13.089443, 45.637497],
                [13.086111, 45.635551],
                [13.06361, 45.63389],
                [13.000832000000116, 45.629997000000117],
                [12.922499, 45.618332],
                [12.86389, 45.595551],
                [12.798887, 45.568886000000134],
                [12.706944, 45.5311],
                [12.638054, 45.502220000000136],
                [12.617222, 45.494438],
                [12.5875, 45.483887],
                [12.425278, 45.43222],
                [12.420555, 45.431107],
                [12.41472, 45.431938],
                [12.41305, 45.435272],
                [12.412777, 45.439163000000121],
                [12.415277000000117, 45.44694],
                [12.422222, 45.456383],
                [12.43778, 45.476105000000132],
                [12.448055, 45.483604000000128],
                [12.451666, 45.48555],
                [12.456388000000118, 45.48778],
                [12.484999, 45.50027],
                [12.500277, 45.502777],
                [12.502222, 45.503052],
                [12.504999, 45.49694],
                [12.504166, 45.49472],
                [12.49472, 45.49249],
                [12.49194, 45.489716000000101],
                [12.492777, 45.486938],
                [12.497221, 45.485275],
                [12.509722, 45.485275],
                [12.514444, 45.486382000000106],
                [12.522499, 45.489716000000101],
                [12.577499000000103, 45.538055],
                [12.582499, 45.543884],
                [12.581388, 45.54666],
                [12.501944, 45.56916],
                [12.496666000000118, 45.56916],
                [12.48, 45.565826],
                [12.394444, 45.533051],
                [12.292776, 45.478607],
                [12.281387000000109, 45.468048000000124],
                [12.158333, 45.313889],
                [12.154682, 45.305084],
                [12.151943, 45.294441],
                [12.16111, 45.263885],
                [12.233332, 45.197495000000117],
                [12.361944, 45.056107],
                [12.443704000000139, 45.008236],
                [12.48444, 44.98583],
                [12.489166, 44.98722],
                [12.496387000000141, 44.98805],
                [12.51111, 44.986938],
                [12.51861, 44.98389],
                [12.521666, 44.981384],
                [12.535276000000124, 44.968605000000139],
                [12.539165, 44.961105],
                [12.538887000000102, 44.956383],
                [12.489166, 44.867493],
                [12.481388, 44.85416],
                [12.474722, 44.844719],
                [12.454721, 44.821938],
                [12.45194400000014, 44.81916],
                [12.446249, 44.815742],
                [12.44222, 44.814163000000121],
                [12.426388, 44.851662],
                [12.427221, 44.8555530000001],
                [12.433887, 44.864998],
                [12.440554, 44.87944],
                [12.442499, 44.8875],
                [12.440554, 44.894997],
                [12.433887, 44.899437],
                [12.428888, 44.900551],
                [12.415833000000134, 44.901108],
                [12.41194, 44.899437],
                [12.39138800000012, 44.872772],
                [12.389166000000102, 44.86972],
                [12.389444, 44.865555],
                [12.396944, 44.791382000000112],
                [12.356110000000115, 44.80389],
                [12.30722, 44.842216],
                [12.289721, 44.842499],
                [12.28555, 44.84083],
                [12.278055000000109, 44.827499000000103],
                [12.263887, 44.784164],
                [12.25916, 44.768326],
                [12.249722, 44.73194],
                [12.245554, 44.715828000000101],
                [12.24444, 44.701942000000145],
                [12.246387, 44.685829],
                [12.28, 44.476105000000132],
                [12.28889, 44.451660000000118],
                [12.349998, 44.286942],
                [12.356943000000115, 44.269722],
                [12.368332, 44.246666],
                [12.41555, 44.19583],
                [12.429165000000125, 44.182777000000101],
                [12.44639, 44.16777],
                [12.51861, 44.109993],
                [12.545832, 44.088608000000136],
                [12.681665000000123, 43.991104000000121],
                [12.697777, 43.983887],
                [12.72055, 43.976944],
                [12.74055, 43.972221],
                [12.753574, 43.971001],
                [12.764721, 43.970276],
                [12.810555, 43.965553],
                [12.815554, 43.964439],
                [12.824165, 43.961388],
                [12.903055, 43.924721],
                [13.049444, 43.840271],
                [13.0625, 43.83138300000013],
                [13.12555, 43.78666],
                [13.17118, 43.754059],
                [13.193333, 43.735832],
                [13.288055, 43.679443],
                [13.302500000000123, 43.67139],
                [13.35667, 43.649162000000103],
                [13.426109, 43.622772],
                [13.468054, 43.610275000000115],
                [13.479166, 43.60972],
                [13.487221, 43.611938],
                [13.546665, 43.604721],
                [13.557499000000121, 43.59861],
                [13.599443000000122, 43.57],
                [13.621666, 43.553886],
                [13.62389, 43.551666],
                [13.625832, 43.539993],
                [13.624166, 43.536385000000109],
                [13.61972, 43.530548000000124],
                [13.618610000000103, 43.526665],
                [13.62361, 43.501663],
                [13.6275, 43.491104],
                [13.63361, 43.48166700000013],
                [13.71167, 43.350555],
                [13.84805, 43.078331],
                [13.862499000000128, 43.00639],
                [13.870832, 42.97333],
                [13.876389, 42.955551000000128],
                [13.8825, 42.94221],
                [13.897499, 42.91333],
                [13.905554, 42.901382],
                [13.923611, 42.844719000000111],
                [13.939722, 42.803604000000121],
                [13.985277, 42.714165],
                [13.989166000000125, 42.70805],
                [14.016666, 42.669998000000135],
                [14.058332, 42.61972],
                [14.074999000000105, 42.600273000000129],
                [14.130554, 42.541107],
                [14.199999, 42.482498000000135],
                [14.50417, 42.261383],
                [14.561943, 42.22083],
                [14.569721, 42.216942],
                [14.60472, 42.204994],
                [14.628887, 42.198883000000137],
                [14.66139, 42.189163],
                [14.712221, 42.173882000000106],
                [14.715555, 42.17194],
                [14.718611, 42.165276],
                [14.718611, 42.16111],
                [14.714998, 42.14194],
                [14.720554000000106, 42.107498000000135],
                [14.722776, 42.10055],
                [14.733332, 42.090271],
                [14.739721, 42.085548000000131],
                [14.754721, 42.077774],
                [14.762182, 42.074783],
                [14.824999000000105, 42.045273],
                [14.8375, 42.040276000000119],
                [14.88889, 42.021660000000111],
                [14.89917, 42.01944],
                [14.939722, 42.015831],
                [14.996387, 42.004440000000102],
                [15.023888000000113, 41.987778000000105],
                [15.028055, 41.981941],
                [15.055832000000123, 41.956940000000145],
                [15.06972, 41.94861],
                [15.099165, 41.937218],
                [15.14192, 41.928024],
                [15.153889, 41.925552],
                [15.170832, 41.92333200000013],
                [15.37305, 41.905548],
                [15.396387000000118, 41.903885],
                [15.413055, 41.903885],
                [15.455555, 41.906387],
                [15.497221000000138, 41.909164],
                [15.6, 41.923607000000118],
                [15.6675, 41.91916700000013],
                [15.67555, 41.915833000000134],
                [15.68667, 41.914162],
                [15.759998, 41.91666],
                [15.770555, 41.917221],
                [15.856943000000115, 41.925278],
                [15.91361, 41.935272],
                [16.013054, 41.946663],
                [16.018055, 41.94722],
                [16.030277, 41.946388000000127],
                [16.053886, 41.943886],
                [16.0825, 41.936104000000114],
                [16.14194, 41.914162],
                [16.14527500000014, 41.912216],
                [16.1475, 41.909164],
                [16.18777, 41.842773],
                [16.194721, 41.827217],
                [16.19611, 41.823883],
                [16.195831, 41.80110900000011],
                [16.19527, 41.79666],
                [16.189999000000114, 41.781105],
                [16.164997, 41.75777],
                [16.138885, 41.740555],
                [16.030552, 41.676941],
                [15.986111, 41.655548],
                [15.974443000000122, 41.650833],
                [15.943609, 41.642776],
                [15.93194, 41.638329],
                [15.924721, 41.63472],
                [15.914999, 41.628052],
                [15.9, 41.616386],
                [15.895277, 41.610275000000115],
                [15.891666, 41.593048000000124],
                [15.89028, 41.583885000000123],
                [15.889721, 41.571106],
                [15.891109000000142, 41.559441],
                [15.895555000000115, 41.536942],
                [15.90111, 41.5236],
                [15.919998000000135, 41.493607],
                [15.932499000000121, 41.47805],
                [15.981667, 41.441940000000102],
                [15.988333, 41.437492000000134],
                [16.03305, 41.418884],
                [16.076111, 41.40749],
                [16.094444, 41.401939],
                [16.192219000000136, 41.365555],
                [16.491943, 41.25222],
                [16.657776, 41.191383],
                [16.78889, 41.154716],
                [17.04972, 41.08194],
                [17.17972200000014, 41.031387],
                [17.18777, 41.027771],
                [17.255, 40.989441],
                [17.28278, 40.973053],
                [17.29277, 40.96666],
                [17.301941000000113, 40.959717],
                [17.321941, 40.942772000000105],
                [17.471943, 40.829994],
                [17.475277, 40.827774],
                [17.496387, 40.819717],
                [17.76111, 40.730827],
                [17.937222, 40.678604000000121],
                [18.011665, 40.64444],
                [18.013611, 40.641663],
                [18.026108, 40.612221],
                [18.036388000000102, 40.579720000000123],
                [18.035275, 40.575829],
                [18.038609, 40.556938],
                [18.039719, 40.553604],
                [18.08166, 40.524994],
                [18.1275, 40.494438000000116],
                [18.274719, 40.410828],
                [18.423611, 40.289719],
                [18.426109, 40.287216],
                [18.44083, 40.265],
                [18.459721, 40.23111],
                [18.51222, 40.136665000000107],
                [18.512775, 40.132774],
                [18.514999, 40.107216000000108],
                [18.513885, 40.09861],
                [18.479721, 40.045273],
                [18.474442, 40.03999],
                [18.46778, 40.03583],
                [18.447498, 40.029716],
                [18.44028, 40.026382],
                [18.41972, 39.995827],
                [18.417774, 39.992218],
                [18.399441000000138, 39.936104],
                [18.395, 39.913887000000102],
                [18.39472, 39.909721],
                [18.39722, 39.903053],
                [18.401108, 39.896942000000138],
                [18.40166, 39.893326],
                [18.39139, 39.818054000000132],
                [18.390831, 39.814438],
                [18.378052, 39.800552],
                [18.372498, 39.79583],
                [18.349442, 39.791939000000127],
                [18.331387, 39.804993],
                [18.328053, 39.80722],
                [18.306942, 39.81916],
                [18.303055, 39.820831],
                [18.265831, 39.8316650000001],
                [18.24861, 39.833054000000118],
                [18.226944, 39.833328],
                [18.19944, 39.837494000000106],
                [18.179165, 39.846107],
                [18.175278000000105, 39.847771],
                [18.15583, 39.856667],
                [18.08527800000013, 39.900833],
                [18.078888, 39.904999],
                [18.049164, 39.928329],
                [18.04389, 39.93361],
                [18.035, 39.944443],
                [17.99472, 39.994164],
                [17.994164, 39.998055000000136],
                [17.996666, 40.001106],
                [18.000832, 40.001938000000109],
                [18.009998, 39.999161],
                [18.014442, 40.0],
                [18.019722000000115, 40.005554000000132],
                [18.022221000000116, 40.01361],
                [18.022221000000116, 40.017776],
                [18.01555, 40.094162],
                [18.015, 40.097771],
                [18.009163, 40.10667],
                [17.90639, 40.254997],
                [17.859165, 40.283607],
                [17.855274, 40.285271],
                [17.785, 40.29444100000012],
                [17.762775, 40.296661],
                [17.67889, 40.30389],
                [17.66805, 40.304161],
                [17.636387, 40.303329],
                [17.55, 40.29972],
                [17.509441, 40.296944],
                [17.504166, 40.298050000000103],
                [17.392776, 40.330551],
                [17.204441, 40.407219],
                [17.2025, 40.410271000000137],
                [17.203053, 40.414719000000105],
                [17.205276, 40.41777],
                [17.245831, 40.454994],
                [17.268055, 40.47333],
                [17.289997, 40.469719000000111],
                [17.31028, 40.471107],
                [17.317497, 40.474716],
                [17.321941, 40.48055],
                [17.326111000000139, 40.49139],
                [17.324165, 40.494438000000116],
                [17.315552, 40.497498],
                [17.31028, 40.49833],
                [17.089722, 40.520828000000108],
                [17.07888800000012, 40.521111],
                [17.068886000000134, 40.519997000000103],
                [17.046944, 40.515274],
                [17.017776, 40.506386000000134],
                [16.998333, 40.498886],
                [16.94722, 40.47083],
                [16.937222, 40.464722],
                [16.924999, 40.455551],
                [16.913609000000122, 40.445549000000142],
                [16.874165, 40.405273000000136],
                [16.863796, 40.390350000000126],
                [16.797497, 40.318604],
                [16.785553, 40.304161],
                [16.7525, 40.252777],
                [16.746944, 40.236938],
                [16.746387, 40.232498],
                [16.741665, 40.216385],
                [16.738609, 40.208611],
                [16.695274, 40.152771],
                [16.680832, 40.141388],
                [16.64135, 40.1183],
                [16.637218, 40.115829],
                [16.622776000000101, 40.103882000000112],
                [16.617222, 40.09861],
                [16.607777, 40.087219],
                [16.60472, 40.079437],
                [16.59916, 40.04555],
                [16.59972, 40.041664],
                [16.60805, 40.001389000000131],
                [16.61138, 39.991104],
                [16.563332, 39.898048],
                [16.536663, 39.871941000000106],
                [16.500275, 39.823883000000137],
                [16.498055, 39.820831],
                [16.491665000000125, 39.806389],
                [16.488609, 39.79361],
                [16.486664, 39.779999],
                [16.486664, 39.767494000000113],
                [16.49055, 39.749161],
                [16.52805, 39.665833],
                [16.531944, 39.659996],
                [16.5430530000001, 39.65028],
                [16.554165, 39.644722],
                [16.56277, 39.641663],
                [16.59694, 39.62971],
                [16.626389, 39.622772],
                [16.741386, 39.617218],
                [16.823608, 39.568604],
                [16.963055, 39.492775],
                [17.03416, 39.466110000000128],
                [17.139999, 39.402771],
                [17.151108000000136, 39.389999],
                [17.138611000000139, 39.370827],
                [17.133331, 39.360275],
                [17.116943, 39.318886000000134],
                [17.114998, 39.310272000000111],
                [17.10889, 39.263054],
                [17.116108, 39.10249],
                [17.117222, 39.09499],
                [17.138885, 39.05805],
                [17.144722, 39.049438],
                [17.149719000000118, 39.044167],
                [17.166664, 39.033882000000119],
                [17.169167, 38.997772],
                [17.169167, 38.96333],
                [17.126942, 38.91944100000012],
                [17.103611, 38.895271],
                [17.10111, 38.90833],
                [17.09528, 38.91305],
                [17.091389, 38.914719],
                [16.978333, 38.938606],
                [16.973331, 38.939438],
                [16.962498, 38.93972],
                [16.94333, 38.937775],
                [16.929443, 38.93583],
                [16.841427, 38.918610000000115],
                [16.828331, 38.91555],
                [16.730831, 38.875549],
                [16.621109, 38.82194],
                [16.608887, 38.813332],
                [16.594997, 38.80082700000014],
                [16.57361, 38.779716],
                [16.549999, 38.742493],
                [16.538887, 38.722496],
                [16.53389, 38.71194],
                [16.531944, 38.703331],
                [16.533333, 38.699997],
                [16.548885, 38.6486],
                [16.56166, 38.602776],
                [16.57, 38.55416],
                [16.575, 38.520271],
                [16.576664, 38.454636000000107],
                [16.576111, 38.442497],
                [16.571388000000127, 38.431389],
                [16.56694, 38.425278],
                [16.532776000000126, 38.391663000000108],
                [16.515553, 38.37694],
                [16.49055, 38.358055],
                [16.470554000000106, 38.346382],
                [16.448887, 38.33694],
                [16.414165, 38.32444],
                [16.364441000000113, 38.311104],
                [16.352497, 38.30722],
                [16.333885, 38.299721],
                [16.32694, 38.296104],
                [16.1655540000001, 38.13916],
                [16.161110000000122, 38.133049],
                [16.158333, 38.126389],
                [16.154999, 38.114441],
                [16.14527500000014, 38.0775],
                [16.141388, 38.060829],
                [16.138885, 38.047775],
                [16.138885, 38.035271000000137],
                [16.137775, 38.026382],
                [16.133331000000112, 38.015274],
                [16.116665000000125, 37.979721],
                [16.110275, 37.970833],
                [16.087776, 37.94611],
                [16.06889, 37.928329000000133],
                [16.062496, 37.924164000000133],
                [16.04888, 37.922218],
                [15.996111, 37.918884],
                [15.947222, 37.922493],
                [15.922777, 37.927773000000116],
                [15.866665, 37.92610900000011],
                [15.79472, 37.919167],
                [15.781111, 37.916939],
                [15.77583, 37.916939],
                [15.756109, 37.920830000000137],
                [15.72028, 37.931107000000111],
                [15.675278, 37.952217],
                [15.66889, 37.95638300000013],
                [15.663610000000119, 37.961388],
                [15.64028, 37.992218],
                [15.636389, 37.998055],
                [15.631666000000109, 38.011665],
                [15.632221, 38.016388],
                [15.645277, 38.063049],
                [15.63722, 38.17555],
                [15.629444, 38.19138],
                [15.626665, 38.198051],
                [15.626665, 38.206383],
                [15.628332000000114, 38.224159],
                [15.628887, 38.228607],
                [15.630554, 38.232216],
                [15.654444, 38.240273],
                [15.706944, 38.256386],
                [15.72361, 38.255272],
                [15.733055, 38.256386],
                [15.741665000000125, 38.258606],
                [15.76028, 38.26611],
                [15.793055, 38.280548000000124],
                [15.796389, 38.28249],
                [15.809721, 38.295273],
                [15.820833, 38.309715],
                [15.895555000000115, 38.451942000000145],
                [15.906111, 38.472771],
                [15.92063, 38.518036],
                [15.924166, 38.53249],
                [15.925278, 38.541382000000112],
                [15.919998000000135, 38.55055],
                [15.894722000000115, 38.57611],
                [15.876944, 38.59333],
                [15.851665, 38.61055],
                [15.839443, 38.614998],
                [15.8283330000001, 38.62055],
                [15.827221, 38.623886],
                [15.82778, 38.628326],
                [15.832777, 38.63916],
                [15.83917, 38.648331],
                [15.847221, 38.65583],
                [15.856388, 38.662498000000141],
                [15.982498, 38.720833],
                [15.98639, 38.722496],
                [16.023609, 38.723885],
                [16.045277, 38.72361],
                [16.067497, 38.720833],
                [16.088055000000111, 38.71722],
                [16.099163, 38.711662],
                [16.10416, 38.71083],
                [16.129166000000112, 38.715553],
                [16.171944, 38.740829],
                [16.178608, 38.744995],
                [16.18111, 38.747498000000121],
                [16.195, 38.76916],
                [16.2066650000001, 38.79388],
                [16.209442, 38.801666],
                [16.2175, 38.829720000000123],
                [16.219997, 38.843048000000124],
                [16.221107, 38.868607],
                [16.2225, 38.91083],
                [16.221107, 38.922493],
                [16.219166, 38.925278],
                [16.216389, 38.926941],
                [16.194164000000114, 38.931938000000116],
                [16.162220000000104, 38.945274],
                [16.151943000000131, 38.951111],
                [16.101109, 39.019440000000145],
                [16.09833, 39.026108000000136],
                [16.064163, 39.129166000000112],
                [16.056942000000106, 39.179718],
                [16.057499, 39.192772000000105],
                [16.05611, 39.224998],
                [16.053333, 39.256386],
                [16.038055, 39.330276],
                [16.034443000000124, 39.344994],
                [16.031387, 39.351105],
                [15.988333, 39.43666],
                [15.97972, 39.451942],
                [15.977777, 39.454994],
                [15.933611, 39.510551000000135],
                [15.919722, 39.522499],
                [15.903889, 39.533882],
                [15.853054, 39.609993],
                [15.808887000000141, 39.677773000000116],
                [15.806944, 39.680832],
                [15.80028, 39.705551],
                [15.799444, 39.709442000000138],
                [15.787498, 39.792496],
                [15.782221, 39.849998000000141],
                [15.783888000000104, 39.858604],
                [15.783054, 39.866661],
                [15.77833, 39.876106000000107],
                [15.754999, 39.918884],
                [15.748333, 39.92722],
                [15.728888, 39.95694],
                [15.712221, 39.979721],
                [15.666666, 40.03083],
                [15.660831, 40.035271],
                [15.642258, 40.042931],
                [15.625555, 40.059715],
                [15.611944, 40.069443],
                [15.588333, 40.073608],
                [15.577776, 40.075272],
                [15.565832, 40.07638],
                [15.555555, 40.075829],
                [15.519722, 40.073326],
                [15.51111, 40.071388],
                [15.504166000000112, 40.067772],
                [15.458611000000133, 40.02861],
                [15.42305, 39.994995],
                [15.416943, 39.990273],
                [15.412777, 39.990273],
                [15.365276000000108, 39.996941],
                [15.359722, 39.997772],
                [15.355833, 39.999443],
                [15.33861, 40.00944],
                [15.313055000000134, 40.031387],
                [15.270277, 40.06721],
                [15.258333, 40.07638],
                [15.145832, 40.155548],
                [15.128887000000134, 40.165833000000134],
                [15.1175, 40.171387],
                [15.106943, 40.17305],
                [15.096666, 40.172493000000145],
                [15.012499000000105, 40.19555],
                [14.941944, 40.23416],
                [14.927221, 40.271111000000133],
                [14.964167, 40.341385],
                [14.987778, 40.35527],
                [14.98972, 40.35833],
                [14.991943, 40.366661000000136],
                [14.993055, 40.375549],
                [14.992777, 40.392220000000123],
                [14.990555, 40.399162],
                [14.964443000000131, 40.445831],
                [14.903889000000106, 40.551666000000125],
                [14.892776, 40.565826],
                [14.839443, 40.623329],
                [14.831944, 40.6311],
                [14.825832000000105, 40.635826],
                [14.776943000000131, 40.672218],
                [14.77277800000013, 40.673882],
                [14.76222, 40.67555],
                [14.74472, 40.676384],
                [14.687167, 40.639336],
                [14.62861, 40.64944],
                [14.62167, 40.645828],
                [14.575528, 40.611755],
                [14.504721, 40.61972],
                [14.455353, 40.617008],
                [14.401943000000131, 40.6],
                [14.327296, 40.57301],
                [14.326639, 40.594681],
                [14.339117, 40.61832],
                [14.35444, 40.627777],
                [14.359165, 40.626663],
                [14.364443000000108, 40.626663],
                [14.373888, 40.628326000000129],
                [14.384722, 40.633606],
                [14.397221, 40.642494],
                [14.469999, 40.695549],
                [14.475555, 40.700829000000113],
                [14.477221, 40.704163000000108],
                [14.477499000000137, 40.708885],
                [14.476944, 40.712494],
                [14.475277000000119, 40.71583],
                [14.471943000000124, 40.721939],
                [14.458055, 40.742775000000108],
                [14.44749800000011, 40.753052],
                [14.3175, 40.823326],
                [14.30639, 40.829163],
                [14.28555, 40.836937],
                [14.2666660000001, 40.84166],
                [14.261665, 40.841110000000128],
                [14.22611, 40.827774],
                [14.216944000000126, 40.821106],
                [14.210554, 40.811943],
                [14.16694, 40.806938],
                [14.073889, 40.82194],
                [14.047222, 40.860275000000115],
                [14.046389, 40.864166],
                [14.030554000000109, 40.898048000000131],
                [14.026943000000131, 40.904442],
                [14.01777600000014, 40.919716],
                [13.99444, 40.956108],
                [13.983889, 40.970551000000114],
                [13.9, 41.078049000000135],
                [13.837221000000113, 41.152496],
                [13.802221, 41.189720000000136],
                [13.79389, 41.19694],
                [13.77583, 41.211105],
                [13.737654, 41.23474],
                [13.719721000000106, 41.247498],
                [13.713055000000111, 41.251389],
                [13.70805, 41.252777],
                [13.647221, 41.259438000000102],
                [13.641109, 41.259995],
                [13.620832, 41.257774],
                [13.608055, 41.254166],
                [13.56861, 41.23888],
                [13.564999, 41.237221],
                [13.294167, 41.295555],
                [13.276943, 41.295555],
                [13.2666660000001, 41.294716000000108],
                [13.21111100000013, 41.282494],
                [13.17, 41.26888300000013],
                [13.146944000000133, 41.259163],
                [13.12472, 41.248886],
                [13.108889, 41.237778000000105],
                [13.031944, 41.255272],
                [13.027222000000108, 41.265],
                [13.009722, 41.292221],
                [13.00111, 41.303604],
                [12.98389, 41.322495000000117],
                [12.97611, 41.33027600000014],
                [12.951944, 41.35305000000011],
                [12.93222, 41.37028],
                [12.913055, 41.383606],
                [12.892221, 41.395554000000118],
                [12.855, 41.409996],
                [12.67166, 41.45916],
                [12.66, 41.459442000000138],
                [12.646387000000118, 41.456383],
                [12.576111, 41.50722],
                [12.517776, 41.567772],
                [12.471943, 41.607216],
                [12.45194400000014, 41.624161000000129],
                [12.44222, 41.631104000000107],
                [12.356943000000115, 41.691666000000112],
                [12.345833, 41.697220000000129],
                [12.217222, 41.782494],
                [12.214443, 41.79361],
                [12.209721, 41.812218],
                [12.204443, 41.821663000000115],
                [12.179722, 41.864998],
                [12.17583, 41.871109],
                [12.16472, 41.885277],
                [12.152222, 41.898888],
                [12.129721, 41.91861],
                [12.116943000000106, 41.927498],
                [12.021111, 41.985832],
                [11.91944, 42.033882],
                [11.905554, 42.03805],
                [11.893055000000118, 42.038605],
                [11.8775, 42.036942000000124],
                [11.862221, 42.031105000000139],
                [11.838610000000131, 42.028610000000128],
                [11.833055, 42.028328],
                [11.82833, 42.029442],
                [11.823055, 42.034721],
                [11.804998000000126, 42.057495],
                [11.745832, 42.1325],
                [11.739166, 42.149719000000118],
                [11.73688, 42.155708],
                [11.73555, 42.160271000000137],
                [11.725555, 42.18222],
                [11.703888, 42.224442000000124],
                [11.63528, 42.292496],
                [11.62944, 42.29722],
                [11.623055, 42.301666000000125],
                [11.534166000000141, 42.342773000000136],
                [11.4975, 42.357498],
                [11.451317000000131, 42.37418],
                [11.387499, 42.400276000000133],
                [11.37472, 42.405],
                [11.364443, 42.406662],
                [11.264999, 42.41833],
                [11.259443, 42.418884],
                [11.23166700000013, 42.417496000000142],
                [11.206944, 42.413605],
                [11.205, 42.409996],
                [11.201387000000125, 42.39444],
                [11.202221, 42.387215],
                [11.18472, 42.36749],
                [11.181944, 42.364998000000128],
                [11.178333, 42.363327],
                [11.173887, 42.364716000000101],
                [11.106667, 42.389717000000132],
                [11.09889, 42.393051],
                [11.096109000000126, 42.395554],
                [11.088055, 42.407776],
                [11.083332, 42.42889],
                [11.085833, 42.431664],
                [11.097776, 42.44138],
                [11.105276, 42.44472],
                [11.114166, 42.443329],
                [11.122499000000118, 42.440277],
                [11.133055, 42.439438],
                [11.15472, 42.439163],
                [11.163055, 42.442215],
                [11.168333, 42.44749],
                [11.172499, 42.453606],
                [11.180832, 42.47583],
                [11.18694, 42.493889],
                [11.188889, 42.50222],
                [11.189722, 42.506386],
                [11.18833, 42.514160000000118],
                [11.181665, 42.527222000000108],
                [11.15805, 42.554993],
                [11.08027600000014, 42.63222],
                [10.973888000000102, 42.718887000000109],
                [10.9575, 42.729996],
                [10.931665000000123, 42.74333],
                [10.919443, 42.748329],
                [10.88944400000014, 42.758888000000127],
                [10.862499, 42.76694],
                [10.764444, 42.82471],
                [10.768610000000137, 42.835831],
                [10.771387, 42.848053000000107],
                [10.779444, 42.887497],
                [10.778055, 42.89555],
                [10.775276000000133, 42.902496],
                [10.767776, 42.910553],
                [10.742777, 42.924438000000123],
                [10.734999, 42.928055],
                [10.72639, 42.931107],
                [10.68778, 42.944717],
                [10.673611000000108, 42.948326],
                [10.588888000000111, 42.9575],
                [10.531387000000109, 43.044716000000108],
                [10.535276, 43.060829000000126],
                [10.540833, 43.123329],
                [10.542776, 43.145828],
                [10.542500000000132, 43.154442],
                [10.538332, 43.180832000000123],
                [10.530277, 43.22361],
                [10.522221, 43.249161],
                [10.51444400000014, 43.265831],
                [10.422777, 43.398048],
                [10.38361, 43.441109],
                [10.371666000000118, 43.450554000000125],
                [10.357498, 43.458611],
                [10.332222, 43.468048],
                [10.323055, 43.475273],
                [10.321388000000127, 43.478607],
                [10.298332, 43.533607],
                [10.29555, 43.54055000000011],
                [10.293333, 43.54805],
                [10.287607, 43.591301000000101],
                [10.276388, 43.689163],
                [10.276943000000131, 43.698326],
                [10.276943000000131, 43.714439],
                [10.275, 43.734993],
                [10.273333, 43.751663],
                [10.26861, 43.792496000000142],
                [10.266388, 43.79972],
                [10.252222, 43.84333],
                [10.239166000000125, 43.874443],
                [10.233332, 43.8836060000001],
                [10.221943, 43.898048],
                [10.209444000000133, 43.911942],
                [10.179443000000106, 43.944717],
                [10.11611, 44.0],
                [10.107498, 44.007500000000107],
                [10.09083, 44.01861],
                [10.068609, 44.029999],
                [10.050833000000125, 44.03611],
                [10.027334, 44.044174],
                [9.983606, 44.053879],
                [9.714996, 44.114716000000101],
                [9.66111, 44.140831000000105],
                [9.37278, 44.285271000000137],
                [9.340277, 44.30778],
                [9.332777000000135, 44.31166],
                [9.23361, 44.346382],
                [9.228611000000114, 44.347496],
                [8.815554, 44.42555],
                [8.76111, 44.429443],
                [8.748888000000136, 44.429161000000136],
                [8.74361, 44.428329],
                [8.735277, 44.425278],
                [8.64, 44.388329],
                [8.498888, 44.324715],
                [8.491665000000125, 44.320549000000142],
                [8.44944, 44.287773],
                [8.438889, 44.276939],
                [8.43805, 44.27277400000014],
                [8.44389, 44.26777600000014],
                [8.445555, 44.264442000000145],
                [8.44611, 44.26028],
                [8.44472, 44.25666],
                [8.415277, 44.190277],
                [8.39944, 44.178329000000133],
                [8.391109, 44.175278000000105],
                [8.332222, 44.158607],
                [8.310276, 44.1561],
                [8.2925, 44.150833],
                [8.280277, 44.145554],
                [8.267776, 44.136108],
                [8.236666, 44.103333],
                [8.231943000000115, 44.0975],
                [8.158054, 43.994438000000116],
                [8.155277000000126, 43.986938],
                [8.154444000000126, 43.978333],
                [8.1575, 43.971382],
                [8.161943000000122, 43.965553],
                [8.1655540000001, 43.958885],
                [8.1655540000001, 43.955276],
                [8.06778, 43.89305],
                [7.94889, 43.846382],
                [7.91389, 43.839996],
                [7.77277800000013, 43.815277],
                [7.740833, 43.797218],
                [7.736944000000108, 43.795273],
                [7.675278, 43.779716],
                [7.669444, 43.77916],
                [7.658610000000124, 43.779716],
                [7.613889, 43.788887000000102],
                [7.592222, 43.791664],
                [7.579721, 43.791664],
                [7.574444, 43.790833],
                [7.531935, 43.78204],
                [7.528055, 43.788605],
                [7.512500000000102, 43.82111],
                [7.49861, 43.849442],
                [7.493333, 43.862221],
                [7.492222, 43.869438],
                [7.493333, 43.877777],
                [7.495, 43.88166],
                [7.50111, 43.88694],
                [7.59833, 43.964722],
                [7.657222, 44.005272],
                [7.66, 44.00833],
                [7.70417, 44.07222],
                [7.70833, 44.07944],
                [7.709045000000117, 44.091309000000138],
                [7.66889, 44.122772],
                [7.661666, 44.131104],
                [7.658333, 44.137215],
                [7.657777000000124, 44.144722],
                [7.66222, 44.170830000000137],
                [7.61472, 44.180275],
                [7.52028, 44.1561],
                [7.466389000000106, 44.138611],
                [7.423055, 44.126663],
                [7.418888, 44.125549],
                [7.353333000000134, 44.131104],
                [7.348332, 44.131943],
                [7.031388, 44.246941],
                [6.9763880000001, 44.284164],
                [6.878888, 44.373604],
                [6.876944, 44.376663],
                [6.853611000000114, 44.517776],
                [6.852777, 44.540833],
                [6.950833, 44.664719000000105],
                [6.970555000000104, 44.684715],
                [6.980277, 44.691666],
                [7.02833, 44.74472],
                [7.031666, 44.83138300000013],
                [7.009999, 44.848610000000122],
                [7.002777, 44.852776],
                [6.973888, 44.862778],
                [6.964444, 44.865829],
                [6.948333, 44.869995],
                [6.936388, 44.871384],
                [6.917777, 44.861938000000123],
                [6.904444, 44.859161],
                [6.89222100000012, 44.860275],
                [6.85777800000011, 44.866661000000136],
                [6.84083, 44.874161],
                [6.775277000000131, 44.905548000000124],
                [6.751111, 44.91722],
                [6.746944, 44.91944],
                [6.661666, 45.039993],
                [6.61976, 45.110138],
                [6.621666000000118, 45.11388],
                [6.627222000000131, 45.11944],
                [6.634121, 45.124001],
                [6.637777, 45.126106000000107],
                [6.675833, 45.143883],
                [6.688889, 45.147774],
                [6.6975, 45.150276000000133],
                [6.760833, 45.168327],
                [6.771944, 45.16805],
                [6.816388000000131, 45.156387],
                [6.826944, 45.149719],
                [6.939444, 45.179443],
                [7.064722, 45.223053],
                [7.124999000000116, 45.254997],
                [7.127777, 45.25777],
                [7.129167, 45.262215],
                [7.15861, 45.377495],
                [7.146944, 45.43055],
                [7.089159, 45.47686],
                [7.002777, 45.516106],
                [6.99944, 45.518326000000116],
                [6.98972, 45.53333],
                [6.969444, 45.596939],
                [6.814166000000114, 45.72194],
                [6.809722000000136, 45.727776000000119],
                [6.80778, 45.73444400000011],
                [6.798970000000111, 45.78067],
                [6.79972, 45.796661],
                [6.807221000000141, 45.827217],
                [6.808888, 45.831383],
                [6.81861, 45.839165],
                [6.869721, 45.855827],
                [6.874999, 45.85611],
                [6.896111000000133, 45.850273],
                [6.908055, 45.849442],
                [6.92222, 45.852219000000105],
                [6.943889, 45.85833],
                [6.973055, 45.868889],
                [6.980833, 45.872215],
                [6.987499, 45.876938],
                [6.99667, 45.885551],
                [7.03805, 45.931938000000116],
                [7.062778, 45.90916],
                [7.077777, 45.896942],
                [7.091110000000128, 45.88749700000011],
                [7.099444, 45.883606],
                [7.105, 45.882217],
                [7.117499, 45.880829000000119],
                [7.183055, 45.879166],
                [7.188611, 45.879166],
                [7.19694, 45.882217],
                [7.23028, 45.898048],
                [7.291111, 45.92194400000011],
                [7.295555, 45.92305],
                [7.300278, 45.923882],
                [7.338888, 45.920555],
                [7.378888000000131, 45.914719],
                [7.3933320000001, 45.916107000000125],
                [7.429722, 45.929443000000106],
                [7.45805, 45.941109],
                [7.536666000000139, 45.98166700000013],
                [7.647499, 45.98111],
                [7.653055, 45.979996],
                [7.709167, 45.943329],
                [7.743333, 45.93222],
                [7.78389, 45.923607],
                [7.8483, 45.918755],
                [7.855742, 45.919052],
                [7.86639, 45.948326],
                [7.876666, 45.972496],
                [7.88194, 45.977776],
                [7.9025, 45.991104],
                [7.911111, 45.994164000000126],
                [7.95, 45.994164000000126],
                [7.97305, 45.996941],
                [7.998055000000136, 46.00222],
                [8.00861, 46.008331000000112],
                [8.014721, 46.013329000000113],
                [8.148888000000113, 46.14944],
                [8.150276, 46.153053],
                [8.158888000000104, 46.176666000000125],
                [8.159443, 46.180832],
                [8.158333, 46.188889],
                [8.14389, 46.219719],
                [8.139999, 46.226105000000132],
                [8.299999, 46.419716],
                [8.30278, 46.422493000000145],
                [8.306110000000103, 46.424721],
                [8.35722, 46.45],
                [8.365276, 46.45361],
                [8.430277, 46.463051],
                [8.436388, 46.463333],
                [8.447498, 46.461937],
                [8.45167, 46.459999],
                [8.459999, 46.452217000000132],
                [8.461666, 46.44444],
                [8.46611, 46.37722],
                [8.465832, 46.36805],
                [8.45833, 46.33416],
                [8.447498, 46.323326],
                [8.443333, 46.31721],
                [8.434999, 46.295273],
                [8.434166, 46.29111],
                [8.444443, 46.248604000000114],
                [8.445555, 46.245827],
                [8.460554000000116, 46.23333],
                [8.61389, 46.122215],
                [8.617777, 46.120277000000101],
                [8.691944, 46.10139],
                [8.70111, 46.10083],
                [8.714998, 46.10249],
                [8.723610000000122, 46.105553],
                [8.728855000000124, 46.108589],
                [8.747221, 46.121109],
                [8.818333, 46.100555],
                [8.826111, 46.09666],
                [8.835278, 46.089439],
                [8.844166, 46.08194],
                [8.846666, 46.079163],
                [8.85055, 46.072495],
                [8.85333, 46.061104000000114],
                [8.852499, 46.056938],
                [8.849998, 46.054443],
                [8.82361, 46.036110000000122],
                [8.816944, 46.03166],
                [8.813055, 45.988609],
                [8.82667, 45.984161],
                [8.895555, 45.955826],
                [8.9, 45.94971],
                [8.926666, 45.900833],
                [8.93639, 45.876938],
                [8.936666, 45.872772],
                [8.93611, 45.868889],
                [8.951111000000139, 45.845276000000126],
                [8.998333, 45.82944],
                [9.03666, 45.837776],
                [9.083887, 45.895554],
                [9.085554, 45.899162],
                [9.085554, 45.901939],
                [9.081388, 45.912498000000141],
                [9.079443, 45.915833],
                [9.066666000000112, 45.924164000000133],
                [9.031944000000124, 45.931664],
                [9.025, 45.935829],
                [9.0175, 45.94416],
                [8.996666000000118, 45.973328],
                [8.998055, 45.976944],
                [9.016666, 46.0225],
                [9.035831, 46.05722],
                [9.083332, 46.121109],
                [9.132221, 46.160271],
                [9.144439, 46.168049],
                [9.158609, 46.171661],
                [9.17722, 46.176941],
                [9.18055500000014, 46.17916],
                [9.189444, 46.186661],
                [9.238609, 46.2305530000001],
                [9.24341, 46.23671],
                [9.276667, 46.292496000000142],
                [9.291943000000117, 46.323051],
                [9.293333, 46.32666],
                [9.29749900000013, 46.348885],
                [9.296944, 46.35305],
                [9.282221, 46.419998000000135],
                [9.280554, 46.423332],
                [9.272778, 46.428329],
                [9.256943, 46.431389],
                [9.253054000000134, 46.433327],
                [9.25, 46.440277],
                [9.249722000000133, 46.448051],
                [9.273611, 46.487778000000105],
                [9.281944, 46.495827000000133],
                [9.288887, 46.500275000000101],
                [9.296944, 46.503883],
                [9.302221, 46.50471],
                [9.360832, 46.50861],
                [9.37278, 46.5075],
                [9.455, 46.472496],
                [9.450277, 46.426666],
                [9.45666, 46.387772],
                [9.458611, 46.384720000000129],
                [9.521387000000118, 46.319717],
                [9.5425, 46.306938000000116],
                [9.547222, 46.30555],
                [9.581944, 46.29694400000011],
                [9.624722000000133, 46.291939],
                [9.696943, 46.297218],
                [9.708332, 46.298332],
                [9.714998, 46.302773000000116],
                [9.770555, 46.342209],
                [9.81305, 46.35833],
                [9.85278, 46.369720000000143],
                [9.904999, 46.383049],
                [9.911110000000122, 46.383331000000112],
                [9.943888, 46.379997000000117],
                [9.949999000000105, 46.379166000000112],
                [9.984722, 46.361938],
                [9.991943000000106, 46.357773],
                [9.99361, 46.354439],
                [9.991388, 46.346664],
                [9.981943000000115, 46.33472],
                [9.982498, 46.331383],
                [9.994999, 46.291664],
                [10.05722, 46.22805],
                [10.063055, 46.222771000000137],
                [10.066666000000112, 46.221107000000131],
                [10.07278, 46.220276000000126],
                [10.078609, 46.22055],
                [10.129999, 46.227219000000105],
                [10.133888000000127, 46.228882],
                [10.1408330000001, 46.23333],
                [10.16972, 46.25444],
                [10.172499, 46.257217],
                [10.17639, 46.26833],
                [10.17722, 46.272499],
                [10.153889, 46.390274],
                [10.092777000000126, 46.423332],
                [10.088610000000131, 46.424164],
                [10.067221, 46.432495],
                [10.055555, 46.438332],
                [10.049166, 46.443054000000132],
                [10.046665, 46.445831],
                [10.045, 46.449165],
                [10.044443, 46.453331000000105],
                [10.04416700000013, 46.498055],
                [10.044722, 46.507217],
                [10.050278, 46.53999],
                [10.0525, 46.54305],
                [10.11916, 46.61138],
                [10.18111, 46.632217],
                [10.233332, 46.639999],
                [10.238609, 46.638885],
                [10.241665000000125, 46.636665],
                [10.253611, 46.622215],
                [10.254166000000112, 46.61805],
                [10.253054000000134, 46.613884],
                [10.24694, 46.599442],
                [10.245277, 46.59111],
                [10.245554, 46.587219],
                [10.247499, 46.583885],
                [10.301666, 46.555832],
                [10.305555, 46.55389],
                [10.337221000000113, 46.549438],
                [10.44972, 46.53916],
                [10.457531, 46.5425],
                [10.465277, 46.54639],
                [10.471109000000126, 46.55167],
                [10.47555, 46.562492],
                [10.485277, 46.590553],
                [10.486111000000108, 46.594719],
                [10.486666, 46.615273],
                [10.486387, 46.619438],
                [10.470833, 46.635826],
                [10.447498, 46.763054000000125],
                [10.471235, 46.871353],
                [10.474443000000122, 46.86694],
                [10.477777000000117, 46.864441],
                [10.49778, 46.855270000000132],
                [10.560833, 46.84861],
                [10.566387, 46.849159],
                [10.59972, 46.857773],
                [10.6425, 46.868889],
                [10.651388, 46.87194],
                [10.666943000000117, 46.874718],
                [10.679443, 46.874718],
                [10.684721, 46.873604],
                [10.689444, 46.872215],
                [10.758055, 46.838882],
                [10.764444, 46.83416],
                [10.76611, 46.826385],
                [10.764444, 46.82278],
                [10.791666, 46.801384],
                [10.83417, 46.786942],
                [10.887777, 46.771111],
                [11.014721, 46.7725],
                [11.018888, 46.774162000000103],
                [11.07028, 46.82194],
                [11.072498, 46.824997],
                [11.096666, 46.881660000000124],
                [11.09805, 46.885277],
                [11.09889, 46.89444],
                [11.094721, 46.905],
                [11.094444, 46.90916],
                [11.096666, 46.912498000000141],
                [11.099443, 46.91499],
                [11.11167, 46.924995],
                [11.11805500000014, 46.929993],
                [11.164444, 46.962219],
                [11.17139, 46.966660000000104],
                [11.186388, 46.97028],
                [11.483889, 47.01416],
                [11.61528, 47.013054],
                [11.62861, 47.012497],
                [11.7066650000001, 46.998604000000114],
                [11.71361, 46.994164000000126],
                [11.725832, 46.979996],
                [11.73639, 46.977776],
                [11.755833, 46.977493],
                [11.766666, 46.978882],
                [12.075277, 47.05944],
                [12.140131, 47.084812],
                [12.183054, 47.094444000000124],
                [12.189165000000116, 47.09472],
                [12.221666, 47.088333],
                [12.22611, 47.086662],
                [12.23111, 47.080826000000116],
                [12.230833, 47.07222],
                [12.223888, 47.063049],
                [12.204443, 47.039162],
                [12.19861, 47.033882000000119],
                [12.189999, 47.029999],
                [12.185276, 47.028885],
                [12.152777000000128, 47.024437],
                [12.138332, 47.020828],
                [12.134165, 47.019165],
                [12.128887, 47.013329],
                [12.127222, 47.00972],
                [12.127777, 47.001663000000121],
              ],
              [
                [12.45917, 43.896111],
                [12.464722000000108, 43.895554000000118],
                [12.474443, 43.897217],
                [12.48778, 43.90583],
                [12.494999, 43.914719000000105],
                [12.496387000000141, 43.923332],
                [12.510555, 43.939163],
                [12.511665, 43.943329000000119],
                [12.510277, 43.982773],
                [12.50999800000011, 43.986938],
                [12.505554, 43.98860900000011],
                [12.492777, 43.989166],
                [12.47167, 43.986938],
                [12.4625, 43.984718],
                [12.453888, 43.981667],
                [12.450554, 43.979721],
                [12.415798, 43.95795],
                [12.408888, 43.954994],
                [12.404999, 43.948326],
                [12.403889, 43.926666],
                [12.407822, 43.913658],
                [12.41222, 43.906105],
                [12.416388, 43.904716],
                [12.45917, 43.896111],
              ],
              [
                [12.445090330888604, 41.90311752178485],
                [12.456660170953796, 41.901426024699163],
                [12.451653339580503, 41.907989033391232],
                [12.445090330888604, 41.90311752178485],
              ],
            ],
            [
              [
                [12.422777, 45.420555],
                [12.425833000000125, 45.41861],
                [12.427221, 45.415276],
                [12.421944, 45.414162],
                [12.37829, 45.419754],
                [12.373888, 45.416107],
                [12.345276, 45.384720000000129],
                [12.336111, 45.372498],
                [12.328333, 45.35944400000011],
                [12.32667, 45.35583],
                [12.32361, 45.343887],
                [12.316387, 45.350555],
                [12.360832, 45.415833000000134],
                [12.368332, 45.424164],
                [12.37333, 45.428055],
                [12.379444, 45.429718],
                [12.390554, 45.430832],
                [12.402222, 45.429718],
                [12.422777, 45.420555],
              ],
            ],
            [
              [
                [9.84417, 43.034439000000134],
                [9.816111, 43.004440000000102],
                [9.81361, 43.005272],
                [9.806944000000101, 43.00972],
                [9.804443000000106, 43.012497],
                [9.799166, 43.022217000000126],
                [9.795277, 43.032776],
                [9.802776, 43.060272],
                [9.804165, 43.063889],
                [9.823055000000124, 43.077499000000103],
                [9.828054, 43.077499000000103],
                [9.831665, 43.075554],
                [9.834166, 43.07278],
                [9.851387, 43.052498],
                [9.846388, 43.037498],
                [9.84417, 43.034439000000134],
              ],
            ],
            [
              [
                [10.441111, 42.844444],
                [10.43111, 42.721664],
                [10.429443, 42.71333],
                [10.426943, 42.710831],
                [10.423054, 42.70888],
                [10.41861, 42.708611],
                [10.35472, 42.759163000000115],
                [10.34805, 42.763329],
                [10.34361, 42.765],
                [10.338055, 42.765549],
                [10.299721, 42.75972],
                [10.23472, 42.746384],
                [10.209166, 42.735275],
                [10.16028, 42.729439000000127],
                [10.149166, 42.72972],
                [10.13917, 42.731667],
                [10.1275, 42.737221],
                [10.12167, 42.741943],
                [10.116943, 42.747498],
                [10.104166, 42.765274],
                [10.101944000000117, 42.772499],
                [10.100555, 42.780548000000124],
                [10.101387, 42.78916],
                [10.10805, 42.797218],
                [10.11472, 42.801666],
                [10.126665, 42.80639],
                [10.145, 42.810829],
                [10.182777000000101, 42.813606000000107],
                [10.208611000000133, 42.809166],
                [10.218332, 42.802498000000128],
                [10.22361, 42.797218],
                [10.23111, 42.79333],
                [10.23583, 42.79222],
                [10.349443, 42.801941],
                [10.35389, 42.803055],
                [10.359722, 42.808052],
                [10.376944, 42.825829],
                [10.379166, 42.82888800000012],
                [10.391666, 42.852493],
                [10.394444, 42.85972],
                [10.406944000000124, 42.868889000000138],
                [10.411388000000102, 42.870277],
                [10.416943, 42.870552],
                [10.43611, 42.857216000000108],
                [10.439165000000116, 42.854721],
                [10.44028, 42.851105],
                [10.441111, 42.844444],
              ],
            ],
            [
              [
                [10.08833, 42.57222],
                [10.083332, 42.571388000000127],
                [10.075277, 42.57499700000011],
                [10.06944, 42.591942],
                [10.079721, 42.61555],
                [10.081944000000135, 42.61889],
                [10.0875, 42.617775],
                [10.08972, 42.614998],
                [10.101665, 42.5936],
                [10.098888, 42.58361],
                [10.097221000000104, 42.57972],
                [10.08833, 42.57222],
              ],
            ],
            [
              [
                [10.915833, 42.32527],
                [10.912222, 42.32361],
                [10.904165, 42.326942000000145],
                [10.868889, 42.355827],
                [10.866388, 42.358604000000128],
                [10.864443000000108, 42.36583],
                [10.877777, 42.388054],
                [10.881388, 42.388885],
                [10.89194300000014, 42.38694],
                [10.896111, 42.385551],
                [10.911943, 42.371666000000118],
                [10.914444, 42.368889],
                [10.928055, 42.339439],
                [10.92639, 42.335831],
                [10.91861, 42.327774],
                [10.915833, 42.32527],
              ],
            ],
            [
              [
                [10.316666, 42.317497],
                [10.305555, 42.31694],
                [10.294998, 42.317772000000105],
                [10.291943000000117, 42.32],
                [10.2897210000001, 42.323051],
                [10.28861, 42.32666],
                [10.28861, 42.338882],
                [10.289444000000117, 42.343048000000124],
                [10.293055, 42.349998],
                [10.296944, 42.351662],
                [10.301943000000108, 42.352493],
                [10.315277, 42.349159],
                [10.323055, 42.345833],
                [10.326111, 42.34333],
                [10.3283330000001, 42.328331],
                [10.3283330000001, 42.324715],
                [10.316666, 42.317497],
              ],
            ],
            [
              [
                [9.513332, 41.14666],
                [9.562498000000119, 41.117775000000108],
                [9.633888, 40.989166],
                [9.51444400000014, 40.929718],
                [9.50444, 40.92222],
                [9.50361, 40.91805],
                [9.505833, 40.915276],
                [9.509443, 40.91333],
                [9.526943000000131, 40.912498],
                [9.566387, 40.91305],
                [9.612778000000105, 40.921104],
                [9.659166, 40.85249],
                [9.746944, 40.682495],
                [9.75111, 40.66777],
                [9.751944, 40.659439000000134],
                [9.75111, 40.655273],
                [9.742498, 40.638611],
                [9.742777, 40.629997],
                [9.749443, 40.599159],
                [9.75111, 40.59583],
                [9.795277, 40.54833200000013],
                [9.803333, 40.540833000000134],
                [9.806944000000101, 40.537498],
                [9.814165, 40.535553],
                [9.82111, 40.53166],
                [9.82416, 40.529442],
                [9.825832, 40.526108],
                [9.825554000000125, 40.52166],
                [9.80944, 40.46833],
                [9.800278000000105, 40.442497],
                [9.77194, 40.394722],
                [9.764444, 40.386665],
                [9.758055000000127, 40.382217],
                [9.750832, 40.378883],
                [9.74222200000014, 40.376389000000131],
                [9.727499, 40.369438],
                [9.711388000000113, 40.358604000000128],
                [9.69972, 40.349442],
                [9.657221, 40.308327],
                [9.63694, 40.282219000000111],
                [9.62583, 40.262772],
                [9.623055, 40.255554],
                [9.622499, 40.251389],
                [9.62194, 40.237778000000105],
                [9.62333, 40.199715],
                [9.63, 40.186661],
                [9.652222, 40.144997000000103],
                [9.661388, 40.133331000000112],
                [9.692499, 40.106941],
                [9.70417, 40.097496],
                [9.713610000000131, 40.04055],
                [9.695, 39.935272],
                [9.674721, 39.808884],
                [9.670555, 39.779442000000131],
                [9.67028, 39.75694],
                [9.671665, 39.749161],
                [9.673887, 39.741661000000136],
                [9.675554, 39.738609],
                [9.676388, 39.73027],
                [9.675554, 39.712776000000133],
                [9.651667, 39.549164],
                [9.64222100000012, 39.486382],
                [9.630833, 39.430275],
                [9.600277000000119, 39.332771],
                [9.568054000000132, 39.2305530000001],
                [9.567221000000131, 39.22639],
                [9.563889000000131, 39.19722],
                [9.564165, 39.19305],
                [9.576944, 39.18471],
                [9.5791660000001, 39.181938],
                [9.579443, 39.178604],
                [9.569166000000109, 39.150551000000121],
                [9.565277, 39.14416],
                [9.556665000000123, 39.13721],
                [9.52167, 39.118332],
                [9.442636000000107, 39.12442],
                [9.410555000000102, 39.140831],
                [9.392221, 39.156944],
                [9.389444, 39.159164],
                [9.36611, 39.177498],
                [9.342499, 39.19416],
                [9.321665, 39.205826],
                [9.295277000000112, 39.213882],
                [9.018332, 39.266388],
                [9.01417, 39.265],
                [9.01111, 39.262772],
                [9.01055, 39.258606],
                [9.013332, 39.126389],
                [9.016109000000142, 39.10166],
                [9.02083, 39.083054],
                [9.02417, 39.076385],
                [9.043333, 39.044998],
                [9.006943, 38.98805],
                [8.906944, 38.90583],
                [8.897221, 38.89944],
                [8.859165, 38.879166],
                [8.85555, 38.877495000000124],
                [8.850277, 38.876938],
                [8.839722, 38.878052],
                [8.715277, 38.923607],
                [8.708055, 38.919998],
                [8.646387, 38.89027],
                [8.615833000000123, 38.918610000000115],
                [8.566387, 39.009995],
                [8.55139, 39.04999],
                [8.509776000000102, 39.06055],
                [8.507442, 39.061386],
                [8.501444000000106, 39.062218],
                [8.49861, 39.061718],
                [8.496444, 39.060715],
                [8.477276, 39.042885],
                [8.475777, 39.04121],
                [8.474777, 39.03938],
                [8.47011, 39.022717],
                [8.44916, 39.00944],
                [8.451185000000123, 38.992798],
                [8.449999, 38.98832700000014],
                [8.441944, 38.969719],
                [8.43111, 38.959717000000126],
                [8.41111, 38.957222],
                [8.40694, 38.958611],
                [8.404165, 38.961105],
                [8.361944, 39.02499],
                [8.35805, 39.035553],
                [8.346388000000104, 39.071938000000102],
                [8.345276000000126, 39.075554],
                [8.349722, 39.090553],
                [8.356667, 39.10833],
                [8.358332, 39.111382],
                [8.3625, 39.112778],
                [8.424444, 39.107773],
                [8.427221, 39.106384],
                [8.44472, 39.0925],
                [8.452221, 39.084717],
                [8.450999, 39.096161],
                [8.452665, 39.090996000000132],
                [8.454332, 39.086826],
                [8.45533, 39.085995],
                [8.461, 39.085331],
                [8.4625, 39.086998],
                [8.469000000000108, 39.095661000000121],
                [8.468665000000101, 39.097664],
                [8.459166, 39.117496],
                [8.43444, 39.160271],
                [8.429722, 39.165833000000134],
                [8.39694, 39.200554],
                [8.36611, 39.226105000000132],
                [8.424166000000127, 39.268883],
                [8.430277, 39.27777],
                [8.43361, 39.28916],
                [8.43361, 39.293884],
                [8.431944000000101, 39.301666],
                [8.418610000000115, 39.339439],
                [8.414721, 39.340828],
                [8.397499, 39.340553],
                [8.3933320000001, 39.341942],
                [8.386944, 39.35055],
                [8.371944, 39.371109000000104],
                [8.371111, 39.374718],
                [8.391943, 39.44722],
                [8.413055, 39.493607000000111],
                [8.44944, 39.628052],
                [8.447222000000124, 39.635277],
                [8.446665, 39.639442],
                [8.443333, 39.681938000000116],
                [8.44278, 39.75666],
                [8.444443, 39.75972],
                [8.448055000000124, 39.761383],
                [8.453054, 39.76221],
                [8.457777, 39.761383],
                [8.461111, 39.759438],
                [8.466389000000106, 39.75444],
                [8.49, 39.721939000000134],
                [8.50444, 39.72555],
                [8.52361100000013, 39.75222],
                [8.541943000000117, 39.779442000000131],
                [8.551666, 39.816666],
                [8.55722, 39.84499],
                [8.557499, 39.854164],
                [8.55666, 39.866104000000121],
                [8.553055, 39.872498],
                [8.548611, 39.878052],
                [8.526943000000131, 39.898048],
                [8.51805, 39.904999],
                [8.509722, 39.908051],
                [8.470554000000106, 39.91305],
                [8.458611000000133, 39.91333],
                [8.455, 39.911385],
                [8.442221, 39.902771000000143],
                [8.437498, 39.897499],
                [8.422499, 39.891663],
                [8.398611, 39.89666],
                [8.39583, 39.898888],
                [8.394722, 39.9025],
                [8.394722, 39.907219000000111],
                [8.398611, 39.9461060000001],
                [8.407499, 39.998604000000114],
                [8.41028, 40.014999],
                [8.464443, 40.143326],
                [8.461666, 40.22666],
                [8.457222000000115, 40.321388],
                [8.36722200000014, 40.492775],
                [8.306389, 40.58416],
                [8.301109, 40.589165],
                [8.293333, 40.592499],
                [8.201387, 40.615555],
                [8.190554, 40.616386],
                [8.172222, 40.598328],
                [8.167776, 40.592499],
                [8.166666, 40.588882],
                [8.16722, 40.584717],
                [8.16639, 40.580551000000128],
                [8.16139, 40.56611],
                [8.159443, 40.56277],
                [8.150276, 40.57833],
                [8.148333, 40.581665],
                [8.144444000000135, 40.592216],
                [8.14333, 40.605],
                [8.14361, 40.621666000000118],
                [8.146111, 40.624161000000129],
                [8.159721000000104, 40.6325],
                [8.17833, 40.636383000000137],
                [8.172222, 40.692215],
                [8.149721000000113, 40.721382],
                [8.148888000000113, 40.744164000000126],
                [8.192499, 40.913605],
                [8.228333, 40.94138],
                [8.227499000000137, 40.937492],
                [8.228054, 40.933327],
                [8.231388, 40.911385],
                [8.233055, 40.908051],
                [8.278055, 40.864441],
                [8.290833000000134, 40.855553],
                [8.304998000000126, 40.84805],
                [8.309166, 40.84666],
                [8.356388, 40.836105],
                [8.4575, 40.82194],
                [8.48, 40.820274],
                [8.505278, 40.823608],
                [8.543055, 40.831383],
                [8.579721, 40.84],
                [8.600832, 40.84666],
                [8.60472, 40.84833],
                [8.610832, 40.852776000000119],
                [8.617777, 40.861382],
                [8.623333, 40.87555],
                [8.627222, 40.881943],
                [8.63472, 40.889999000000103],
                [8.64222100000012, 40.89361],
                [8.650555000000111, 40.896385],
                [8.692221, 40.910271],
                [8.710554, 40.91444],
                [8.740276000000108, 40.91555],
                [8.751665, 40.914993],
                [8.7666660000001, 40.912216],
                [8.775276, 40.914993],
                [8.789999000000137, 40.921944],
                [8.810276000000101, 40.934441],
                [8.843887, 40.959717],
                [8.853888, 40.970551000000114],
                [8.858332, 40.97639],
                [8.872776, 40.997498],
                [8.874166000000116, 41.001389000000131],
                [9.010832, 41.121109000000104],
                [9.014444, 41.122772],
                [9.040277, 41.129715],
                [9.04389, 41.130554],
                [9.049444, 41.130829],
                [9.05416, 41.129997000000117],
                [9.160831, 41.191666],
                [9.16, 41.236382],
                [9.1625, 41.238327],
                [9.175554, 41.245827000000133],
                [9.233055, 41.254715],
                [9.513332, 41.14666],
              ],
            ],
            [
              [
                [8.339167, 41.062492000000134],
                [8.33055, 41.055275],
                [8.32805, 41.054718],
                [8.309444, 41.059166],
                [8.28833, 41.061661],
                [8.283888, 41.060272000000111],
                [8.2675, 41.054718],
                [8.240833, 41.030273],
                [8.24472, 40.986107],
                [8.22416, 40.986382000000106],
                [8.21528, 40.992493],
                [8.21417, 41.00444],
                [8.230833000000132, 41.04277],
                [8.28833, 41.099998],
                [8.314165000000116, 41.117218],
                [8.32111, 41.12138],
                [8.32472, 41.120277],
                [8.345276000000126, 41.094994],
                [8.347221000000104, 41.091660000000104],
                [8.346943, 41.088051000000121],
                [8.340555000000109, 41.066109],
                [8.339167, 41.062492000000134],
              ],
            ],
            [
              [
                [12.964167, 40.883888],
                [12.960278, 40.88222],
                [12.955, 40.883049],
                [12.952221, 40.885551000000135],
                [12.949999, 40.88833],
                [12.94583, 40.895828000000108],
                [12.944166, 40.899162000000103],
                [12.94611, 40.906387],
                [12.950277000000142, 40.91777],
                [12.953333, 40.919441],
                [12.97, 40.92722],
                [12.98805, 40.931389],
                [12.97555, 40.8975],
                [12.974165, 40.894722000000115],
                [12.964167, 40.883888],
              ],
            ],
            [
              [
                [13.951387000000125, 40.70138500000013],
                [13.891666, 40.69194],
                [13.863609, 40.701111],
                [13.856667, 40.704994000000113],
                [13.851944, 40.710548000000131],
                [13.85389, 40.73472],
                [13.86611, 40.75777],
                [13.879166, 40.76111],
                [13.88444, 40.76028],
                [13.943333, 40.743889],
                [13.948055000000124, 40.742493],
                [13.950832, 40.740273],
                [13.953609, 40.737778],
                [13.958332, 40.73055],
                [13.964998, 40.718605],
                [13.964998, 40.714439],
                [13.951387000000125, 40.70138500000013],
              ],
            ],
            [
              [
                [14.210554, 40.56055],
                [14.241388, 40.554993],
                [14.246387000000141, 40.55555],
                [14.249722, 40.557495000000131],
                [14.258333, 40.55971],
                [14.261665, 40.55778],
                [14.26194, 40.55555],
                [14.256666000000109, 40.551109],
                [14.254721000000131, 40.54805],
                [14.253611, 40.54416700000013],
                [14.250832, 40.542496],
                [14.24472, 40.546944],
                [14.239443, 40.547775],
                [14.23083, 40.545555],
                [14.219444, 40.540833000000134],
                [14.202499, 40.535828],
                [14.197222, 40.5366590000001],
                [14.19555, 40.539993],
                [14.19778, 40.553055],
                [14.19889, 40.55722],
                [14.200832, 40.560272],
                [14.210554, 40.56055],
              ],
            ],
            [
              [
                [8.292221, 39.093605000000139],
                [8.28722, 39.092773],
                [8.276667, 39.093605000000139],
                [8.25389, 39.103607000000125],
                [8.25111, 39.10583],
                [8.221109, 39.141937],
                [8.219999, 39.145554],
                [8.221388, 39.161942],
                [8.22389, 39.164719],
                [8.24361, 39.17222],
                [8.30278, 39.189995],
                [8.304443, 39.187492],
                [8.306665, 39.14416],
                [8.306389, 39.13222],
                [8.305555, 39.115273000000116],
                [8.304165000000125, 39.107216000000108],
                [8.295555, 39.095276],
                [8.292221, 39.093605000000139],
              ],
            ],
            [
              [
                [15.21361, 38.770554],
                [15.208332, 38.770554],
                [15.191387, 38.780548],
                [15.189165, 38.787498],
                [15.190277, 38.79055],
                [15.209444, 38.808052],
                [15.212221000000113, 38.81055],
                [15.216389, 38.811661],
                [15.227499000000137, 38.811104000000114],
                [15.239166, 38.806107],
                [15.241943000000106, 38.803604],
                [15.241943000000106, 38.799438000000123],
                [15.22972, 38.78083],
                [15.226944, 38.77833],
                [15.217777, 38.77166],
                [15.21361, 38.770554],
              ],
            ],
            [
              [
                [13.17333200000013, 38.690277],
                [13.158609, 38.688889],
                [13.154722000000106, 38.68972],
                [13.151943, 38.691940000000102],
                [13.152222, 38.695831],
                [13.16222, 38.714439],
                [13.165277, 38.716385000000116],
                [13.172777, 38.719719000000111],
                [13.18111, 38.721107],
                [13.184999, 38.719444000000124],
                [13.195555, 38.71388],
                [13.198332000000107, 38.711388],
                [13.19861, 38.707222000000115],
                [13.195833000000107, 38.70472],
                [13.180832, 38.693604000000107],
                [13.17778, 38.691666],
                [13.17333200000013, 38.690277],
              ],
            ],
            [
              [
                [14.868332000000123, 38.531387],
                [14.86472, 38.529716000000121],
                [14.854166, 38.531387],
                [14.835278, 38.540276],
                [14.796944, 38.55861],
                [14.79361, 38.56472],
                [14.79472, 38.56777],
                [14.803888, 38.58138300000013],
                [14.808611, 38.58194],
                [14.864166, 38.579437],
                [14.86861, 38.578049000000135],
                [14.873333, 38.572777],
                [14.873888, 38.56916],
                [14.873333, 38.564438],
                [14.868332000000123, 38.531387],
              ],
            ],
            [
              [
                [14.95528, 38.445549000000142],
                [14.950554, 38.445],
                [14.91222, 38.46611],
                [14.906111, 38.47083],
                [14.901667, 38.476105],
                [14.898054000000116, 38.486382],
                [14.898611, 38.490273000000116],
                [14.903889000000106, 38.509438000000102],
                [14.909166, 38.514717],
                [14.91222, 38.516663],
                [14.916111, 38.518326],
                [14.923887, 38.52],
                [14.957499, 38.52166],
                [14.961943, 38.520271],
                [14.963888, 38.517494],
                [14.96611, 38.510551],
                [14.963055, 38.452499],
                [14.96222, 38.449165],
                [14.95917, 38.44722],
                [14.95528, 38.445549000000142],
              ],
            ],
            [
              [
                [14.98889, 38.364166000000125],
                [14.983610000000112, 38.364166000000125],
                [14.979721, 38.365829],
                [14.95611, 38.379997000000117],
                [14.953054, 38.381943],
                [14.941111, 38.399437],
                [14.940277, 38.40305],
                [14.945555, 38.418327],
                [14.958887, 38.431107],
                [14.9625, 38.431938],
                [14.966389, 38.430275000000108],
                [14.99667, 38.395271],
                [15.004166, 38.379166000000112],
                [15.004166, 38.374992],
                [15.0, 38.368889000000138],
                [14.993055, 38.365273],
                [14.98889, 38.364166000000125],
              ],
            ],
            [
              [
                [15.528889, 38.13694],
                [15.50944, 38.089439],
                [15.504721, 38.078888],
                [15.502499, 38.075829],
                [15.497776, 38.07027],
                [15.427776, 38.000832000000116],
                [15.371387, 37.946663],
                [15.366665, 37.941109],
                [15.235277, 37.785271],
                [15.219721, 37.764442],
                [15.218054000000109, 37.711388],
                [15.2175, 37.70694],
                [15.20083, 37.651382],
                [15.178055, 37.575554000000125],
                [15.169722, 37.56333],
                [15.1675, 37.560272000000111],
                [15.156944, 37.548607],
                [15.154444000000126, 37.546104],
                [15.145555, 37.539444],
                [15.11861, 37.51944],
                [15.098331, 37.498604],
                [15.093611000000124, 37.49305],
                [15.091389000000106, 37.489998000000128],
                [15.08667, 37.479439],
                [15.08583, 37.463051],
                [15.091110000000128, 37.35804],
                [15.091944, 37.349716],
                [15.093887, 37.342773],
                [15.186943, 37.18388],
                [15.203888, 37.15749],
                [15.229443, 37.126106000000107],
                [15.23194, 37.123604],
                [15.251665, 37.111664000000133],
                [15.25611, 37.11027],
                [15.266109000000142, 37.108604],
                [15.29305, 37.10805],
                [15.2975, 37.106667],
                [15.303333, 37.102219],
                [15.305832, 37.095551000000114],
                [15.316111, 37.0430530000001],
                [15.316666000000112, 37.008888],
                [15.26222, 36.98167],
                [15.21417, 36.955276],
                [15.180277000000103, 36.935272000000111],
                [15.152777, 36.916382],
                [15.148611, 36.910271],
                [15.110277, 36.839996],
                [15.094721000000106, 36.79972],
                [15.095554000000106, 36.783607],
                [15.096388, 36.779716000000121],
                [15.104443, 36.755829],
                [15.113888, 36.745552],
                [15.119165, 36.736382],
                [15.135832000000107, 36.685272],
                [15.13611, 36.677773],
                [15.131943, 36.66666],
                [15.097221, 36.653885],
                [15.08583, 36.64972],
                [15.081388, 36.649162],
                [15.049166000000127, 36.68222],
                [15.038332, 36.691666],
                [15.027777, 36.69722],
                [15.019444, 36.69999700000011],
                [14.900833, 36.724998000000141],
                [14.890833, 36.72666],
                [14.868055, 36.728333],
                [14.858332000000132, 36.727776000000119],
                [14.813889000000131, 36.715],
                [14.77916, 36.70444],
                [14.721388, 36.718605],
                [14.55361, 36.780273],
                [14.460554, 36.830826],
                [14.457777, 36.837494],
                [14.44111, 36.873329],
                [14.421944, 36.9025],
                [14.414165, 36.91416],
                [14.410276, 36.919716],
                [14.39389, 36.942497],
                [14.37361, 36.966385000000116],
                [14.35368, 36.983864],
                [14.340555, 36.994720000000143],
                [14.283888, 37.036942],
                [14.268888, 37.04805],
                [14.245832, 37.062218],
                [14.15361, 37.096382000000119],
                [14.136389, 37.10166],
                [14.10972, 37.108887],
                [14.093887, 37.110832],
                [13.99805, 37.11027],
                [13.955755, 37.100349],
                [13.934999, 37.094719],
                [13.929722, 37.094719],
                [13.89472, 37.097771],
                [13.880554, 37.101105],
                [13.73833, 37.157776],
                [13.67305, 37.18972],
                [13.669998, 37.19194],
                [13.661943, 37.199165000000107],
                [13.655277, 37.20638300000013],
                [13.651388, 37.212219],
                [13.643888000000118, 37.219994],
                [13.571665, 37.272499],
                [13.56194, 37.27916],
                [13.543333, 37.28333],
                [13.50528, 37.287216000000114],
                [13.412777, 37.324165],
                [13.33, 37.361107],
                [13.27861, 37.389999000000103],
                [13.273333, 37.394722],
                [13.268888000000118, 37.404716000000121],
                [13.256666000000109, 37.421944],
                [13.218332, 37.45527600000014],
                [13.16667, 37.48778],
                [13.158888, 37.491104],
                [13.149166, 37.49305],
                [13.085833, 37.49305],
                [12.99, 37.536942000000124],
                [12.98, 37.546104],
                [12.970833, 37.552498],
                [12.953609000000142, 37.562218000000144],
                [12.925278000000105, 37.57249],
                [12.920555, 37.573608],
                [12.8025, 37.579994000000113],
                [12.783054, 37.578049000000135],
                [12.75611, 37.573051000000135],
                [12.734999, 37.567772],
                [12.7225, 37.564438],
                [12.688332, 37.556107000000111],
                [12.674444, 37.554161],
                [12.665277, 37.55555],
                [12.657499, 37.558609],
                [12.65083, 37.562492],
                [12.51417, 37.658882000000119],
                [12.468332, 37.699165],
                [12.424721, 37.789162],
                [12.422222, 37.796104],
                [12.422777, 37.799995],
                [12.426666000000125, 37.805275000000108],
                [12.43555, 37.80971],
                [12.439444, 37.808052],
                [12.441666, 37.806107],
                [12.452499, 37.811104000000114],
                [12.458055, 37.815826],
                [12.461666, 37.822495000000117],
                [12.478333, 37.863327],
                [12.47889, 37.872498],
                [12.4780540000001, 37.876106],
                [12.47611, 37.879166],
                [12.466389, 37.916107000000125],
                [12.50528, 38.00972],
                [12.515, 38.02055],
                [12.556389000000138, 38.059715],
                [12.559999, 38.061386],
                [12.73361, 38.139717],
                [12.821665, 38.068886],
                [12.875832, 38.030273000000136],
                [12.892221, 38.024437],
                [12.896666, 38.023331],
                [12.906666, 38.023048],
                [12.916666, 38.023888000000113],
                [12.930555, 38.02583],
                [12.955555, 38.032776000000126],
                [13.01916, 38.058884],
                [13.05583, 38.074715],
                [13.06278, 38.07861],
                [13.07028, 38.086388],
                [13.07249800000011, 38.089439],
                [13.07361, 38.098053],
                [13.064165, 38.121384],
                [13.06, 38.12722],
                [13.05472200000014, 38.131943],
                [13.05333, 38.135277],
                [13.054165, 38.138611],
                [13.091665, 38.17889],
                [13.100832, 38.185272],
                [13.104443, 38.186943],
                [13.316666, 38.21833],
                [13.320555, 38.21666],
                [13.356943, 38.188332000000116],
                [13.35889, 38.185555],
                [13.368889000000138, 38.16666],
                [13.375277, 38.153885000000116],
                [13.375277, 38.149719],
                [13.36861, 38.140831],
                [13.362778, 38.128609],
                [13.363609, 38.124718],
                [13.36972, 38.116104000000121],
                [13.372499, 38.11360900000011],
                [13.382500000000107, 38.107498],
                [13.711388, 37.976662],
                [13.752499, 37.971382],
                [13.768888, 37.970551],
                [13.791111, 37.972221],
                [13.820986000000119, 37.978737],
                [13.886665, 37.998055],
                [13.910276000000124, 38.006386],
                [13.916943, 38.009995000000117],
                [13.919443000000115, 38.012497],
                [13.940832, 38.027771],
                [13.947777, 38.031387000000109],
                [14.013887, 38.035828],
                [14.132776, 38.02277400000014],
                [14.242777, 38.01221],
                [14.31194, 38.01221],
                [14.36555, 38.018051],
                [14.37028, 38.018608],
                [14.519444, 38.042770000000132],
                [14.633055000000127, 38.07222],
                [14.637220000000127, 38.073326],
                [14.643888, 38.07666],
                [14.659721, 38.086937],
                [14.784721000000104, 38.154442],
                [14.87444, 38.170555],
                [14.963610000000131, 38.159721],
                [14.975277, 38.154716000000121],
                [15.074999, 38.121666],
                [15.08667, 38.120827000000133],
                [15.090832, 38.121666],
                [15.102499, 38.125832],
                [15.15083, 38.145554],
                [15.30167, 38.207222],
                [15.507221000000129, 38.29055],
                [15.523611, 38.295273],
                [15.540277000000117, 38.297493],
                [15.551388, 38.296387],
                [15.64805, 38.271660000000111],
                [15.652498, 38.27027],
                [15.65389, 38.26694],
                [15.65167, 38.263885],
                [15.64435, 38.260963],
                [15.61278, 38.251389000000131],
                [15.603611, 38.250000000000114],
                [15.587221000000113, 38.24528],
                [15.577221000000122, 38.239716000000101],
                [15.572498, 38.233887],
                [15.56805, 38.22805000000011],
                [15.559999, 38.21027400000014],
                [15.528889, 38.13694],
              ],
            ],
            [
              [
                [12.073889000000122, 37.953606],
                [12.077221000000122, 37.94472],
                [12.047222, 37.95388800000012],
                [12.043888, 37.95611],
                [12.02916, 37.983604],
                [12.029999, 37.986938],
                [12.059166, 37.989166000000125],
                [12.06055, 37.986664],
                [12.073889000000122, 37.953606],
              ],
            ],
            [
              [
                [12.354166, 37.9061],
                [12.349443, 37.905548],
                [12.292500000000132, 37.916664],
                [12.283888000000104, 37.919167],
                [12.272221, 37.932777000000101],
                [12.271387000000118, 37.936386],
                [12.273888000000113, 37.938889],
                [12.279165, 37.939163],
                [12.312777, 37.939438],
                [12.334444000000133, 37.935555],
                [12.33917, 37.934441000000106],
                [12.364721, 37.92305],
                [12.366388000000143, 37.91972],
                [12.363888, 37.912216],
                [12.357777, 37.907776],
                [12.354166, 37.9061],
              ],
            ],
            [
              [
                [12.01583, 36.738327],
                [12.000555000000134, 36.737495000000138],
                [11.993055, 36.73860900000011],
                [11.98722, 36.740555],
                [11.953609000000142, 36.761383],
                [11.92639, 36.793884],
                [11.92277700000011, 36.80416],
                [11.921665000000132, 36.81638],
                [11.923611, 36.821938],
                [11.930832000000123, 36.82972],
                [11.934999000000118, 36.833054],
                [11.940277, 36.835548],
                [11.94722, 36.836662000000103],
                [11.954721, 36.836937],
                [11.962221, 36.8361],
                [11.996666, 36.83028],
                [12.007500000000107, 36.825272],
                [12.048332, 36.796944],
                [12.050554, 36.79361],
                [12.055555, 36.771111000000133],
                [12.054165, 36.761665],
                [12.05139, 36.756943],
                [12.047777, 36.753052],
                [12.038332000000139, 36.747215],
                [12.027777, 36.74222],
                [12.01583, 36.738327],
              ],
            ],
          ],
        },
        id: 11,
        NAME: 'Italy',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Slovenia',
          id: 12,
          label: 'Slovenia',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.176,
          year: '2023',
          centroid: [14.9955, 46.1512],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [13.718655, 46.526611],
              [13.77611, 46.518326],
              [13.845554, 46.519997],
              [13.936943, 46.515831],
              [14.079721, 46.489716],
              [14.084721, 46.488609],
              [14.112499, 46.48111],
              [14.119165, 46.476662],
              [14.12611, 46.467773],
              [14.131666, 46.458328],
              [14.150555, 46.443886],
              [14.154165, 46.44194],
              [14.159443, 46.440826],
              [14.478054, 46.419441],
              [14.544998, 46.407494],
              [14.811666, 46.509995],
              [14.814722, 46.512772],
              [14.824999, 46.541382],
              [14.832499, 46.566666],
              [14.834999, 46.574715],
              [14.864443, 46.610832],
              [14.870554, 46.615829],
              [15.045832, 46.652222],
              [15.064444, 46.651939],
              [15.074408, 46.648571],
              [15.100555, 46.656105],
              [15.105276, 46.657219],
              [15.139444, 46.657219],
              [15.406111, 46.652496],
              [15.602499, 46.686661],
              [15.806665, 46.718605],
              [15.832777, 46.722221],
              [15.849722, 46.723328],
              [15.868332, 46.723053],
              [15.988054, 46.751106],
              [15.987778, 46.759163],
              [15.985554, 46.826942],
              [15.985554, 46.831108],
              [15.988609, 46.833611],
              [15.99361, 46.834717],
              [16.009308, 46.835487],
              [16.111805, 46.86972],
              [16.136387, 46.859993],
              [16.140831, 46.85833],
              [16.145554, 46.85833],
              [16.175831, 46.862495],
              [16.180832, 46.863609],
              [16.191666, 46.86972],
              [16.226944, 46.875832],
              [16.231941, 46.876663],
              [16.269722, 46.874443],
              [16.293331, 46.870827],
              [16.303055, 46.867775],
              [16.346107, 46.846939],
              [16.348888, 46.844444],
              [16.350555, 46.84111],
              [16.350555, 46.836937],
              [16.337219, 46.809166],
              [16.318886, 46.799995],
              [16.315277, 46.797775],
              [16.313889, 46.793884],
              [16.313889, 46.785553],
              [16.324165, 46.757217],
              [16.326385, 46.75444],
              [16.356388, 46.721382],
              [16.359444, 46.718887],
              [16.364998, 46.719162],
              [16.375328, 46.722771],
              [16.385555, 46.70166],
              [16.408607, 46.658882],
              [16.529442, 46.510277],
              [16.532497, 46.507774],
              [16.607872, 46.476234],
              [16.599258, 46.47496],
              [16.584721, 46.473053],
              [16.572498, 46.475273],
              [16.556412, 46.478905],
              [16.517792, 46.491646],
              [16.498055, 46.501389],
              [16.494438, 46.503326],
              [16.495831, 46.5075],
              [16.49361, 46.510551],
              [16.466389, 46.520271],
              [16.461388, 46.52166],
              [16.384163, 46.535828],
              [16.335552, 46.533882],
              [16.292507, 46.530815],
              [16.267498, 46.514442],
              [16.258331, 46.506943],
              [16.251858, 46.498924],
              [16.249443, 46.490273],
              [16.25, 46.486107],
              [16.266109, 46.419441],
              [16.139999, 46.406662],
              [16.13583, 46.405273],
              [16.075924, 46.384331],
              [16.074718, 46.372498],
              [16.074165, 46.363609],
              [16.077499, 46.352776],
              [16.079441, 46.349998],
              [16.083332, 46.33416],
              [16.081108, 46.331108],
              [16.077774, 46.328888],
              [16.01722, 46.29805],
              [15.797777, 46.23333],
              [15.695276, 46.225273],
              [15.676666, 46.226662],
              [15.671389, 46.226387],
              [15.661388, 46.223885],
              [15.654722, 46.219444],
              [15.649166, 46.213882],
              [15.611944, 46.166939],
              [15.60111, 46.146111],
              [15.599722, 46.142494],
              [15.606388, 46.115829],
              [15.629444, 46.086937],
              [15.636389, 46.082222],
              [15.656944, 46.069443],
              [15.661388, 46.067215],
              [15.679165, 46.065826],
              [15.706944, 46.057495],
              [15.711666, 46.055832],
              [15.714722, 46.053604],
              [15.718332, 46.047218],
              [15.719444, 46.038887],
              [15.724443, 45.938606],
              [15.697777, 45.844162],
              [15.694443, 45.841942],
              [15.656666, 45.823326],
              [15.650833, 45.823051],
              [15.646387, 45.823883],
              [15.634722, 45.82972],
              [15.624722, 45.836662],
              [15.620277, 45.842216],
              [15.614721, 45.847496],
              [15.609444, 45.84861],
              [15.602777, 45.84861],
              [15.499443, 45.835831],
              [15.333887, 45.766388],
              [15.322498, 45.761383],
              [15.309166, 45.751938],
              [15.29611, 45.737495],
              [15.291943, 45.73111],
              [15.281666, 45.705826],
              [15.280832, 45.701385],
              [15.283333, 45.694717],
              [15.289721, 45.689163],
              [15.294167, 45.687775],
              [15.302776, 45.690826],
              [15.304998, 45.693886],
              [15.304998, 45.698051],
              [15.304165, 45.706383],
              [15.348331, 45.715553],
              [15.35861, 45.714439],
              [15.365555, 45.709717],
              [15.367498, 45.70694],
              [15.368055, 45.702774],
              [15.352591, 45.651756],
              [15.307089, 45.629868],
              [15.293999, 45.594536],
              [15.302677, 45.54097],
              [15.304165, 45.537773],
              [15.306358, 45.534805],
              [15.277222, 45.462776],
              [15.174458, 45.425819],
              [15.162794, 45.426643],
              [15.150555, 45.431938],
              [15.093504, 45.470261],
              [15.090555, 45.472771],
              [14.979067, 45.500473],
              [14.918644, 45.493149],
              [14.91361, 45.481667],
              [14.91132, 45.4785],
              [14.907776, 45.476662],
              [14.863714, 45.468658],
              [14.831673, 45.465454],
              [14.822975, 45.464767],
              [14.818054, 45.46611],
              [14.72361, 45.531387],
              [14.62611, 45.606941],
              [14.615555, 45.617218],
              [14.609722, 45.626938],
              [14.609444, 45.63916],
              [14.612221, 45.664162],
              [14.611666, 45.669167],
              [14.609722, 45.671944],
              [14.606667, 45.674438],
              [14.601387, 45.675278],
              [14.576944, 45.669441],
              [14.564999, 45.664993],
              [14.562498, 45.661659],
              [14.535, 45.612221],
              [14.501389, 45.551666],
              [14.495832, 45.541664],
              [14.485832, 45.529716],
              [14.419722, 45.494164],
              [14.407221, 45.489166],
              [14.397499, 45.486938],
              [14.387499, 45.485275],
              [14.13722, 45.475273],
              [13.995832, 45.471939],
              [13.989166, 45.462776],
              [13.986666, 45.459999],
              [13.981388, 45.458885],
              [13.952499, 45.456665],
              [13.906944, 45.453331],
              [13.703609, 45.44416],
              [13.678888, 45.445],
              [13.668055, 45.446388],
              [13.647778, 45.451111],
              [13.639444, 45.453888],
              [13.626944, 45.458885],
              [13.607498, 45.468605],
              [13.595276, 45.477776],
              [13.59174, 45.481697],
              [13.589443, 45.516937],
              [13.665833, 45.543053],
              [13.74472, 45.54583],
              [13.749443, 45.546944],
              [13.752222, 45.549721],
              [13.753332, 45.553604],
              [13.716944, 45.596107],
              [13.802221, 45.586388],
              [13.827776, 45.584442],
              [13.850832, 45.585274],
              [13.863609, 45.589165],
              [13.91861, 45.633888],
              [13.919167, 45.637497],
              [13.916943, 45.640274],
              [13.835278, 45.717773],
              [13.796389, 45.750275],
              [13.788887, 45.75444],
              [13.784443, 45.756104],
              [13.697498, 45.784164],
              [13.610554, 45.80555],
              [13.598055, 45.810829],
              [13.595833, 45.813606],
              [13.578888, 45.846382],
              [13.577776, 45.854164],
              [13.589167, 45.885551],
              [13.59111, 45.88916],
              [13.593332, 45.89222],
              [13.611666, 45.902222],
              [13.614443, 45.904716],
              [13.61861, 45.911385],
              [13.633888, 45.943604],
              [13.635555, 45.952217],
              [13.637499, 45.974716],
              [13.636665, 45.985275],
              [13.634998, 45.988609],
              [13.632221, 45.991104],
              [13.626944, 45.992218],
              [13.601944, 45.993607],
              [13.584721, 45.992493],
              [13.580555, 45.991104],
              [13.570833, 45.979164],
              [13.564165, 45.974442],
              [13.560276, 45.972771],
              [13.5425, 45.967499],
              [13.538055, 45.969162],
              [13.516943, 45.981941],
              [13.502777, 45.990555],
              [13.48, 46.011108],
              [13.479443, 46.013329],
              [13.521944, 46.063332],
              [13.538887, 46.079437],
              [13.545555, 46.08416],
              [13.554998, 46.086937],
              [13.560276, 46.087494],
              [13.568609, 46.090553],
              [13.593611, 46.10527],
              [13.645832, 46.142494],
              [13.650555, 46.148605],
              [13.666943, 46.170273],
              [13.669167, 46.173332],
              [13.669167, 46.177498],
              [13.664444, 46.183052],
              [13.657776, 46.187492],
              [13.550554, 46.218048],
              [13.49111, 46.231384],
              [13.485832, 46.232498],
              [13.464998, 46.229439],
              [13.455, 46.217773],
              [13.450832, 46.21611],
              [13.425833, 46.211388],
              [13.420555, 46.211662],
              [13.416111, 46.213333],
              [13.413055, 46.215828],
              [13.383888, 46.293053],
              [13.383055, 46.297218],
              [13.440832, 46.346382],
              [13.511389, 46.38472],
              [13.657776, 46.449715],
              [13.685833, 46.445549],
              [13.689444, 46.447495],
              [13.694721, 46.453331],
              [13.698055, 46.460274],
              [13.711111, 46.492775],
              [13.718887, 46.51416],
              [13.719444, 46.522774],
              [13.718655, 46.526611],
            ],
          ],
        },
        id: 12,
        NAME: 'Slovenia',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Spain',
          id: 13,
          label: 'Spain',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.158,
          year: '2023',
          centroid: [-3.7492, 40.4637],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [-2.925278, 35.26666300000011],
                [-2.93694, 35.263054],
                [-2.94444, 35.26332900000011],
                [-2.950278, 35.264717],
                [-2.959445, 35.271111],
                [-2.962778, 35.274994],
                [-2.967223, 35.284439],
                [-2.97083, 35.294716],
                [-2.971111, 35.306389],
                [-2.969167, 35.312492],
                [-2.962778, 35.32138800000013],
                [-2.958611, 35.32499700000011],
                [-2.946945, 35.329163],
                [-2.93056, 35.29555],
                [-2.91472, 35.2736],
                [-2.925278, 35.26666300000011],
              ],
            ],
            [
              [
                [-5.31944, 35.87693800000011],
                [-5.345834, 35.841660000000104],
                [-5.35444, 35.847221],
                [-5.375834, 35.869438],
                [-5.37861, 35.873604000000114],
                [-5.386945, 35.88694],
                [-5.39139, 35.896942],
                [-5.395556, 35.909164],
                [-5.395557, 35.916336000000115],
                [-5.37306, 35.9180530000001],
                [-5.36528, 35.9180530000001],
                [-5.357779, 35.916382],
                [-5.345, 35.9125],
                [-5.3225, 35.895828],
                [-5.31944, 35.87693800000011],
              ],
            ],
            [
              [
                [-3.036111, 35.912773],
                [-3.04639, 35.907776],
                [-3.051111, 35.909721000000104],
                [-3.051111, 35.915833],
                [-3.048611, 35.919716],
                [-3.038333, 35.92499],
                [-3.02722, 35.924438],
                [-3.02722, 35.919441],
                [-3.036111, 35.912773],
              ],
            ],
            [
              [
                [-6.925, 37.17083],
                [-6.92139, 37.162216],
                [-6.927501, 37.163605],
                [-6.933333, 37.166939],
                [-6.95417, 37.180275],
                [-6.958889, 37.184441],
                [-6.96972, 37.203606],
                [-6.97306, 37.210274],
                [-6.964723, 37.212219],
                [-6.95833, 37.21054800000013],
                [-6.948611, 37.203331],
                [-6.925, 37.17083],
              ],
            ],
            [
              [
                [1.57778, 38.6877750000001],
                [1.586667, 38.672493],
                [1.588055, 38.66722],
                [1.576111, 38.655548000000124],
                [1.56944, 38.65416],
                [1.556389, 38.65416],
                [1.530555, 38.65416],
                [1.524167, 38.654716],
                [1.518055000000118, 38.656944],
                [1.505278, 38.66944],
                [1.49444, 38.675552],
                [1.463055, 38.685555],
                [1.456666, 38.68694],
                [1.443889, 38.6827770000001],
                [1.390278000000137, 38.64333],
                [1.386389, 38.64777400000014],
                [1.385556, 38.658051000000114],
                [1.383611, 38.68305],
                [1.383055, 38.693886],
                [1.383055, 38.715553],
                [1.383055, 38.720551],
                [1.399167, 38.737778],
                [1.445278, 38.74110400000012],
                [1.573056, 38.691383],
                [1.57778, 38.6877750000001],
              ],
            ],
            [
              [
                [1.531667, 38.951942],
                [1.405833, 38.845551000000114],
                [1.371944, 38.830826],
                [1.36805500000014, 38.851105],
                [1.361666000000127, 38.86055],
                [1.3575, 38.86499800000013],
                [1.35278, 38.86833200000012],
                [1.34639, 38.871109],
                [1.277222, 38.87971],
                [1.270555, 38.878052],
                [1.257500000000107, 38.863609],
                [1.252500000000111, 38.85916],
                [1.24611, 38.86027],
                [1.2225, 38.87416100000013],
                [1.211944, 38.89833],
                [1.227778, 38.948051000000135],
                [1.2425, 38.968048],
                [1.29416700000013, 39.03138700000011],
                [1.303611000000103, 39.03860500000013],
                [1.329167, 39.055275],
                [1.3625, 39.072777],
                [1.472778, 39.10527],
                [1.519722, 39.118332],
                [1.545833, 39.11805],
                [1.600555, 39.096107],
                [1.605278, 39.09166],
                [1.609167, 39.081383],
                [1.615, 39.02833],
                [1.531667, 38.951942],
              ],
            ],
            [
              [
                [3.247777, 39.73472],
                [3.260833, 39.733604],
                [3.275, 39.737778],
                [3.29333, 39.745827],
                [3.32361, 39.759438],
                [3.333333, 39.76611],
                [3.343889, 39.77583],
                [3.382778, 39.773331],
                [3.439722, 39.750275],
                [3.480278, 39.721664],
                [3.479722, 39.711105],
                [3.463611, 39.661385],
                [3.4475, 39.640274],
                [3.3775, 39.552773],
                [3.371666, 39.549164],
                [3.331944, 39.526382000000126],
                [3.320278, 39.520554],
                [3.30555500000014, 39.50222],
                [3.288055, 39.4675],
                [3.266944, 39.412773],
                [3.241944000000103, 39.36444100000011],
                [3.081944000000135, 39.273048],
                [3.063611, 39.263611],
                [3.05694, 39.263054],
                [3.029166, 39.283051],
                [2.98555, 39.31860400000011],
                [2.829722, 39.353333000000134],
                [2.799444, 39.36055],
                [2.78639, 39.36472],
                [2.781389, 39.369164000000126],
                [2.75528, 39.392494],
                [2.745555, 39.40638700000011],
                [2.743055, 39.411659],
                [2.727777, 39.47305],
                [2.741666000000123, 39.49082900000013],
                [2.746388, 39.49472],
                [2.752778, 39.496666],
                [2.754722, 39.502495],
                [2.753611, 39.5075],
                [2.745000000000118, 39.515831],
                [2.73639, 39.523888],
                [2.731667, 39.527496],
                [2.694444, 39.55194],
                [2.675278, 39.559441],
                [2.6625, 39.563606],
                [2.656111, 39.56443800000011],
                [2.546389, 39.524719],
                [2.542500000000132, 39.520271],
                [2.436944, 39.52166],
                [2.38917, 39.524994],
                [2.364166, 39.555832],
                [2.386111000000142, 39.612778],
                [2.538611, 39.700272],
                [2.683888, 39.793884000000105],
                [2.777778, 39.844719],
                [2.987778, 39.91111],
                [3.071389, 39.921944],
                [3.096944, 39.911385],
                [3.091944, 39.901382000000126],
                [3.088889000000108, 39.89138800000012],
                [3.089444, 39.885826],
                [3.124444, 39.812218],
                [3.134722, 39.79222],
                [3.13833, 39.787498],
                [3.151944000000128, 39.77583],
                [3.180833, 39.75999500000012],
                [3.241389, 39.736107],
                [3.247777, 39.73472],
              ],
            ],
            [
              [
                [4.273333, 39.96139],
                [4.315555, 39.878883],
                [4.316944, 39.846107],
                [4.313889, 39.83194],
                [4.299999000000128, 39.814163],
                [4.29528, 39.810555000000136],
                [4.289166000000137, 39.807495],
                [4.276388, 39.806389],
                [4.263055000000122, 39.808884],
                [4.25667, 39.810555000000136],
                [4.238333, 39.81611],
                [4.116388, 39.86833200000012],
                [4.100833000000137, 39.877777],
                [4.09083, 39.88472],
                [4.088333, 39.89055],
                [4.084722000000113, 39.895554],
                [4.079721, 39.89916],
                [4.041111, 39.91555],
                [4.02861, 39.92],
                [3.98472, 39.93027],
                [3.965555, 39.93361],
                [3.938333, 39.93249500000013],
                [3.924166000000127, 39.92916],
                [3.91111, 39.925827],
                [3.891111, 39.92083],
                [3.884722, 39.920273],
                [3.878055000000131, 39.92],
                [3.826666, 39.922493],
                [3.796944, 40.01722000000012],
                [3.83139, 40.052773000000116],
                [3.83611100000013, 40.056389],
                [3.868333, 40.05805],
                [3.9375, 40.058884],
                [4.122499000000118, 40.05610700000011],
                [4.174444, 40.050278000000105],
                [4.241388, 39.993607],
                [4.273333, 39.96139],
              ],
            ],
            [
              [
                [-7.85556, 43.759995],
                [-7.85056, 43.71472200000011],
                [-7.81111, 43.724159],
                [-7.79389, 43.72972],
                [-7.724445, 43.747498],
                [-7.685556, 43.748604],
                [-7.51667, 43.73444],
                [-7.463612, 43.72639],
                [-7.365834, 43.676109],
                [-7.36139, 43.672218],
                [-7.337778, 43.64582800000011],
                [-7.32917, 43.631386000000134],
                [-7.29861, 43.59805300000011],
                [-7.293334, 43.594162],
                [-7.25389, 43.565277],
                [-7.240834, 43.55916600000012],
                [-7.21139, 43.564995000000124],
                [-7.198056, 43.56472],
                [-7.045279, 43.559441000000106],
                [-7.038611, 43.557495],
                [-7.036112, 43.54694],
                [-7.03389, 43.537216000000114],
                [-7.044819, 43.490402],
                [-7.01917, 43.539719000000105],
                [-6.99944, 43.560829],
                [-6.94333, 43.57777],
                [-6.76667, 43.567772],
                [-6.60083, 43.55832700000013],
                [-6.48139, 43.55499300000014],
                [-6.34278, 43.55694],
                [-6.29583, 43.569443],
                [-6.10861, 43.56166100000013],
                [-6.095, 43.561943],
                [-6.07583, 43.56582600000013],
                [-5.94472, 43.593887],
                [-5.88333, 43.62333],
                [-5.854167, 43.64804800000013],
                [-5.778611, 43.617218],
                [-5.758334, 43.594162],
                [-5.748889, 43.586662],
                [-5.733334, 43.576385],
                [-5.69056, 43.548332],
                [-5.67778, 43.543884000000105],
                [-5.670834, 43.54361],
                [-5.64972, 43.544716],
                [-5.64194, 43.545273],
                [-5.61, 43.550278000000105],
                [-5.54889, 43.552216],
                [-5.459723, 43.553886],
                [-5.398056, 43.55249800000013],
                [-5.288611, 43.53388200000012],
                [-5.27111, 43.52499],
                [-5.259167, 43.518326],
                [-5.23444, 43.495552],
                [-5.214445, 43.479721],
                [-5.2075, 43.477776],
                [-5.19417, 43.47805],
                [-5.05639, 43.469994],
                [-4.98, 43.461105],
                [-4.88194, 43.448608],
                [-4.760556, 43.428329],
                [-4.74694, 43.4230500000001],
                [-4.73333, 43.41917],
                [-4.656667, 43.408607],
                [-4.6375, 43.406662],
                [-4.59472, 43.403053],
                [-4.51455, 43.396347000000105],
                [-4.50111, 43.401108],
                [-4.42472, 43.40166],
                [-4.39, 43.397774],
                [-4.31556, 43.390549],
                [-4.273056, 43.390549],
                [-4.22389, 43.39611100000013],
                [-4.212778, 43.397774],
                [-4.12194, 43.41638200000011],
                [-4.05139, 43.44249700000012],
                [-3.944723, 43.46777],
                [-3.81028, 43.492493],
                [-3.79, 43.491386],
                [-3.785, 43.487778],
                [-3.766389, 43.469994],
                [-3.585556, 43.51028],
                [-3.55361, 43.50805],
                [-3.546112, 43.505829],
                [-3.451389, 43.465553],
                [-3.32528, 43.418327],
                [-3.22472, 43.39694200000014],
                [-3.15059, 43.353561],
                [-3.022223, 43.357498],
                [-3.0025, 43.383331],
                [-2.94139, 43.435555],
                [-2.92778, 43.43583],
                [-2.85639, 43.432777],
                [-2.80778, 43.430275],
                [-2.73556, 43.426384],
                [-2.56528, 43.39027],
                [-2.513889, 43.378609],
                [-2.507223, 43.376663],
                [-2.48972, 43.361382],
                [-2.48556, 43.356384],
                [-2.464723, 43.34111],
                [-2.45222, 43.334717],
                [-2.354167, 43.305832],
                [-2.347778, 43.304443],
                [-2.29556, 43.29610400000013],
                [-2.170278, 43.291107],
                [-2.15639, 43.291107],
                [-2.12194, 43.296661],
                [-1.97472, 43.332497],
                [-1.83917, 43.380554],
                [-1.79472, 43.391663],
                [-1.787778, 43.39222],
                [-1.78083, 43.388885],
                [-1.78088, 43.359924],
                [-1.776945, 43.3425],
                [-1.73038, 43.29898100000014],
                [-1.711389, 43.304161000000136],
                [-1.69278, 43.30778],
                [-1.65556, 43.309441],
                [-1.50361, 43.287773],
                [-1.40889, 43.27304800000013],
                [-1.39139, 43.262772],
                [-1.38417, 43.25305200000014],
                [-1.3825, 43.24721],
                [-1.38278, 43.217773],
                [-1.385, 43.20166],
                [-1.41139, 43.136665],
                [-1.42222, 43.123604000000114],
                [-1.429445, 43.116386],
                [-1.45167, 43.10305],
                [-1.45861, 43.10305],
                [-1.46889, 43.095833],
                [-1.4725, 43.09111],
                [-1.47056, 43.085831],
                [-1.45, 43.056664000000126],
                [-1.445833, 43.051666000000125],
                [-1.43444, 43.045555],
                [-1.42778, 43.04361],
                [-1.398056, 43.03805],
                [-1.360278, 43.031662],
                [-1.346667, 43.034721],
                [-1.34306, 43.039162],
                [-1.300278, 43.071663],
                [-1.200556, 43.04583],
                [-1.07278, 43.00639],
                [-0.99361, 42.976105],
                [-0.946389, 42.955826000000116],
                [-0.93417, 42.9525],
                [-0.81861, 42.946106],
                [-0.79056, 42.9525],
                [-0.786945, 42.95694],
                [-0.76694, 42.964722],
                [-0.76, 42.96611],
                [-0.746667, 42.965553],
                [-0.742778, 42.9611],
                [-0.72417, 42.937218],
                [-0.722778, 42.922493000000145],
                [-0.72332, 42.918945],
                [-0.73278, 42.909164],
                [-0.73389, 42.90444200000013],
                [-0.73194, 42.899162],
                [-0.72389, 42.891388],
                [-0.718889, 42.88666500000011],
                [-0.712778, 42.88250000000011],
                [-0.562222, 42.781387],
                [-0.54944, 42.77861],
                [-0.39194, 42.796387],
                [-0.323611, 42.82666],
                [-0.31778, 42.83111],
                [-0.315, 42.835831],
                [-0.308739, 42.848381],
                [-0.30556, 42.844162],
                [-0.300833, 42.839439],
                [-0.2625, 42.817497],
                [-0.20556, 42.794167],
                [-0.18, 42.78444],
                [-0.151944, 42.776657],
                [-0.12361, 42.7575],
                [-0.063056, 42.71583],
                [-0.060833, 42.70916],
                [-0.06194, 42.703331],
                [-0.06194, 42.69778],
                [-0.057222, 42.69416],
                [-0.05056, 42.69194],
                [-0.00556, 42.68499800000012],
                [0, 42.68544],
                [0.008333, 42.68693],
                [0.111944000000108, 42.709442],
                [0.14417, 42.722221000000104],
                [0.172222, 42.73333],
                [0.178611, 42.735275],
                [0.186389, 42.7347180000001],
                [0.261944000000142, 42.717499],
                [0.269722000000115, 42.707771],
                [0.2725, 42.702499],
                [0.43278, 42.686661],
                [0.501667000000111, 42.69138],
                [0.509167, 42.69194],
                [0.56, 42.69583100000011],
                [0.59556, 42.695],
                [0.661667, 42.69194],
                [0.675506, 42.688484],
                [0.680000000000121, 42.693329],
                [0.683056, 42.70805],
                [0.683889, 42.713051],
                [0.681389000000138, 42.72943900000013],
                [0.668056, 42.748055000000136],
                [0.655555000000106, 42.754166],
                [0.651944, 42.784996],
                [0.66778, 42.839165],
                [0.692778, 42.853607],
                [0.712222, 42.858604],
                [0.72, 42.859161],
                [0.823611000000142, 42.833054],
                [0.896944, 42.813049],
                [1.085, 42.785271],
                [1.091666, 42.78444],
                [1.121111, 42.768608],
                [1.132222000000127, 42.760826],
                [1.1400000000001, 42.753052],
                [1.1408330000001, 42.741661],
                [1.137778000000139, 42.73693800000012],
                [1.1408330000001, 42.731941],
                [1.144722, 42.727776],
                [1.150833, 42.72361000000012],
                [1.17389, 42.709717],
                [1.321666, 42.714996],
                [1.328333, 42.719994],
                [1.359167000000127, 42.715271],
                [1.390278000000137, 42.688332000000116],
                [1.41722, 42.65083],
                [1.445833000000107, 42.601944],
                [1.43444, 42.576385],
                [1.42139, 42.54583],
                [1.424166, 42.493332],
                [1.448333, 42.45083],
                [1.454722, 42.44167],
                [1.512222000000122, 42.436386],
                [1.53333, 42.436104],
                [1.54167, 42.43722],
                [1.65444, 42.467773],
                [1.661111, 42.471382],
                [1.718889000000104, 42.503052],
                [1.723611, 42.50944],
                [1.78, 42.48832700000014],
                [1.851389, 42.469994],
                [1.906389000000104, 42.446938],
                [1.95917, 42.41083],
                [1.968889, 42.384163000000115],
                [1.976666000000137, 42.374718],
                [1.987778000000105, 42.367775],
                [2.004722000000129, 42.357216],
                [2.017222, 42.35305000000011],
                [2.023889000000111, 42.352219000000105],
                [2.062222, 42.356941],
                [2.093611, 42.364166],
                [2.116944, 42.383331],
                [2.123055000000136, 42.393326000000116],
                [2.124166, 42.39833],
                [2.129167000000109, 42.408051],
                [2.137777, 42.417221],
                [2.151389, 42.421387],
                [2.2625, 42.436661],
                [2.269166, 42.43722],
                [2.280534, 42.434288],
                [2.332222, 42.418053],
                [2.438889, 42.38055400000013],
                [2.442778, 42.37638900000013],
                [2.46972, 42.353333],
                [2.484722, 42.343048000000124],
                [2.525833, 42.333328],
                [2.54194, 42.332497],
                [2.666389, 42.34194200000013],
                [2.674444000000108, 42.357216],
                [2.656944, 42.37944],
                [2.65722, 42.38444],
                [2.678333, 42.401665],
                [2.724722, 42.41944100000012],
                [2.95, 42.48055],
                [3.045278, 42.474716],
                [3.047778000000108, 42.46971900000011],
                [3.049444000000108, 42.459717000000126],
                [3.075833, 42.439438],
                [3.092222, 42.42999300000014],
                [3.106111, 42.429161],
                [3.158333000000141, 42.433327],
                [3.17111100000011, 42.435555],
                [3.177655000000129, 42.436806],
                [3.169167, 42.42610900000011],
                [3.159166000000141, 42.3825],
                [3.159166000000141, 42.378883],
                [3.166111000000114, 42.361938],
                [3.170833, 42.357498],
                [3.189444, 42.344994],
                [3.193889, 42.342216],
                [3.198333, 42.34083],
                [3.2025, 42.342499],
                [3.2025, 42.34610700000013],
                [3.206666, 42.348328],
                [3.218055, 42.349442],
                [3.234167, 42.349716000000114],
                [3.266388, 42.344444],
                [3.279722, 42.339439],
                [3.317222, 42.324997],
                [3.319167, 42.32139],
                [3.317778, 42.317772000000105],
                [3.286666, 42.267776],
                [3.279722, 42.258049],
                [3.266388, 42.243332],
                [3.262777, 42.240829],
                [3.218611, 42.232498],
                [3.208889, 42.234993],
                [3.196666000000107, 42.24139],
                [3.185, 42.251938],
                [3.182222000000138, 42.255829],
                [3.178333, 42.259163],
                [3.164444, 42.263054000000125],
                [3.158611, 42.262497],
                [3.153611, 42.261383],
                [3.142222, 42.253609],
                [3.119722, 42.22888],
                [3.11638900000014, 42.221382],
                [3.11444, 42.214165],
                [3.110833000000127, 42.196663000000115],
                [3.110278, 42.19221],
                [3.11444, 42.151939],
                [3.119722, 42.13694],
                [3.133889, 42.118332],
                [3.14333, 42.115829],
                [3.148056, 42.116661000000136],
                [3.162222, 42.115555],
                [3.166944000000115, 42.11444100000011],
                [3.179444, 42.107216],
                [3.185, 42.1011],
                [3.208889, 42.071938],
                [3.21333, 42.061104],
                [3.220555, 41.94694],
                [3.201666000000102, 41.892776],
                [3.175278, 41.867493],
                [3.123611, 41.84861],
                [3.011944, 41.773048],
                [2.946389, 41.724716],
                [2.939444, 41.719994],
                [2.931944000000101, 41.71583],
                [2.7175, 41.627495000000124],
                [2.676666, 41.612778000000105],
                [2.605833, 41.5908280000001],
                [2.557777000000101, 41.57721700000013],
                [2.53778, 41.57027],
                [2.273056, 41.463333],
                [2.261111, 41.456383],
                [2.253889, 41.449997],
                [2.248888, 41.444717],
                [2.24278, 41.437492000000134],
                [2.16472, 41.342499],
                [2.153055, 41.315277],
                [2.149444, 41.308609000000104],
                [2.123888000000136, 41.29277],
                [2.11083, 41.285828],
                [2.07833, 41.27527600000013],
                [2.054166, 41.26861],
                [2.016944000000137, 41.263054000000125],
                [2.0075, 41.263054000000125],
                [1.998055, 41.263329],
                [1.89, 41.25110600000011],
                [1.76167, 41.218605],
                [1.701389, 41.20555100000013],
                [1.675833000000125, 41.20166],
                [1.651389, 41.199165],
                [1.616389, 41.195831],
                [1.531944, 41.184998],
                [1.498333, 41.178604],
                [1.3225, 41.12944],
                [1.205, 41.101387],
                [1.039444, 41.062492000000134],
                [0.993055, 41.04805],
                [0.964444, 41.032776],
                [0.94333, 41.016663],
                [0.936389, 41.0075],
                [0.92472, 40.991104],
                [0.905555, 40.984993],
                [0.893333, 40.975555],
                [0.704167, 40.813049],
                [0.70028, 40.80555],
                [0.699444, 40.801941],
                [0.698889, 40.798332],
                [0.7, 40.794716],
                [0.713055, 40.783333],
                [0.723055, 40.775833],
                [0.73805, 40.766388],
                [0.838611000000128, 40.73027],
                [0.8575, 40.728607],
                [0.867222, 40.731384],
                [0.873333000000116, 40.7336],
                [0.88861, 40.73055],
                [0.895, 40.728333000000134],
                [0.9, 40.724442],
                [0.902778000000126, 40.719719],
                [0.885278, 40.702774],
                [0.864167, 40.684441],
                [0.85167, 40.67610900000011],
                [0.689722, 40.571663],
                [0.671111, 40.564163],
                [0.6575, 40.561386],
                [0.64333, 40.560272],
                [0.629444, 40.563332],
                [0.623055, 40.565552],
                [0.60722, 40.575829],
                [0.60805, 40.58055100000013],
                [0.615, 40.593605],
                [0.621667, 40.59166],
                [0.6275, 40.588882],
                [0.634444, 40.589439],
                [0.709167, 40.59583],
                [0.73805, 40.639717],
                [0.73139, 40.64027],
                [0.696667, 40.63749700000011],
                [0.616667, 40.626389],
                [0.603611000000114, 40.623604],
                [0.58917, 40.61278],
                [0.541944, 40.56916],
                [0.51917, 40.533882],
                [0.518939000000103, 40.52874],
                [0.458333, 40.44722],
                [0.358333, 40.30305],
                [0.354444, 40.298607],
                [0.280556, 40.23666],
                [0.213056, 40.183601000000124],
                [0.048889, 40.036102],
                [0.04611100000011, 40.03138],
                [0.032778, 40.007767000000115],
                [-0.03722, 39.893326],
                [-0.08444, 39.85139],
                [-0.10722, 39.82861],
                [-0.115833, 39.818604],
                [-0.179167, 39.736107],
                [-0.31472, 39.519722000000115],
                [-0.32056, 39.509995],
                [-0.326111, 39.49472],
                [-0.337222, 39.440552],
                [-0.338056, 39.435555000000136],
                [-0.24111, 39.14388300000013],
                [-0.195, 39.053604],
                [-0.1825, 39.02916],
                [-0.14333, 38.978333000000134],
                [-0.09222, 38.929718],
                [-0.07, 38.908882],
                [-0.06, 38.901108],
                [-0.04917, 38.894165],
                [-0.033063, 38.884254],
                [0.008889, 38.86221300000011],
                [0.029167, 38.857208],
                [0.048611, 38.858879000000115],
                [0.055, 38.86109900000014],
                [0.061389000000133, 38.861656],
                [0.06778, 38.860268],
                [0.086389, 38.854988],
                [0.14777800000013, 38.828323],
                [0.195556, 38.805824],
                [0.201389, 38.801659],
                [0.215278, 38.758041000000105],
                [0.207222, 38.73221],
                [0.164167, 38.697487],
                [0.14417, 38.684708],
                [0.041667, 38.638046],
                [-0.006667, 38.62861],
                [-0.0175, 38.622498],
                [-0.05028, 38.595551],
                [-0.055278, 38.59111],
                [-0.138611, 38.53805],
                [-0.15167, 38.53583],
                [-0.288611, 38.486382],
                [-0.30056, 38.481667],
                [-0.31722, 38.473053],
                [-0.322778, 38.46999],
                [-0.37194, 38.441666],
                [-0.38667, 38.430832],
                [-0.51167, 38.324997],
                [-0.600278, 38.185272],
                [-0.656667, 38.046944],
                [-0.749167, 37.89222],
                [-0.75194, 37.887215],
                [-0.75944, 37.86193800000012],
                [-0.760556, 37.856941],
                [-0.76102, 37.845955],
                [-0.80139, 37.801384],
                [-0.84194, 37.748886],
                [-0.858333, 37.72166],
                [-0.86, 37.71666],
                [-0.8575, 37.711937],
                [-0.81417, 37.664719000000105],
                [-0.804722, 37.657219],
                [-0.786945, 37.64777400000014],
                [-0.74083, 37.630272000000105],
                [-0.73472, 37.62944],
                [-0.721944, 37.63582600000012],
                [-0.71833, 37.640549],
                [-0.71833, 37.64555400000012],
                [-0.710278, 37.643883],
                [-0.69667, 37.6325],
                [-0.70833, 37.616386],
                [-0.715556, 37.606941],
                [-0.73139, 37.5975],
                [-0.744167, 37.593887],
                [-0.915, 37.552216],
                [-0.92167, 37.551384],
                [-0.9525, 37.555832],
                [-0.976111, 37.572777],
                [-0.97972, 37.576942],
                [-1.048333, 37.57916300000011],
                [-1.23861, 37.575272],
                [-1.3275, 37.558052],
                [-1.350833, 37.549438],
                [-1.44278, 37.494438],
                [-1.45389, 37.48749],
                [-1.46278, 37.479164],
                [-1.471945, 37.465553000000114],
                [-1.48389, 37.44111],
                [-1.48556, 37.436104000000114],
                [-1.50944, 37.421944],
                [-1.56778, 37.399719],
                [-1.633415, 37.376862],
                [-1.64361, 37.372772],
                [-1.678889, 37.349442000000124],
                [-1.68917, 37.3425],
                [-1.791111, 37.232216],
                [-1.79806, 37.22277],
                [-1.80917, 37.2024990000001],
                [-1.81167, 37.196388],
                [-1.81611, 37.18138900000014],
                [-1.82361, 37.150833],
                [-1.825556, 37.130554],
                [-1.82778, 37.11944],
                [-1.846667, 37.081940000000145],
                [-1.902222, 36.972221],
                [-1.928889, 36.93972],
                [-1.93528, 36.938889],
                [-1.98639, 36.895828],
                [-1.998889, 36.88416],
                [-2.058333, 36.810555],
                [-2.059167, 36.80555],
                [-2.05889, 36.789719],
                [-2.06, 36.779442],
                [-2.06361, 36.774994],
                [-2.116667, 36.73555],
                [-2.129167, 36.731384],
                [-2.1875, 36.716385],
                [-2.19667, 36.72444],
                [-2.217223, 36.745552],
                [-2.23111, 36.764442],
                [-2.281389, 36.82000000000011],
                [-2.28667, 36.823608],
                [-2.29861, 36.829437],
                [-2.34389, 36.840271],
                [-2.350278, 36.84083],
                [-2.481945, 36.82999400000011],
                [-2.55528, 36.81472],
                [-2.56056, 36.811386],
                [-2.578333, 36.79305],
                [-2.590278, 36.779999],
                [-2.59556, 36.769722000000115],
                [-2.59722, 36.764717],
                [-2.60056, 36.752777],
                [-2.6, 36.747215],
                [-2.60556, 36.736938],
                [-2.616667, 36.722221],
                [-2.63944, 36.701111],
                [-2.650278, 36.69444],
                [-2.6925, 36.685272],
                [-2.7225, 36.681664],
                [-2.768889, 36.678329],
                [-2.859445, 36.69527],
                [-2.87417, 36.705276],
                [-2.878889, 36.710274],
                [-2.881389, 36.715553],
                [-2.888056, 36.724716],
                [-2.89611, 36.733604],
                [-2.91806, 36.744995],
                [-2.928889, 36.749718],
                [-3.125, 36.7502750000001],
                [-3.230834, 36.748055],
                [-3.25917, 36.746941000000106],
                [-3.3275, 36.739716],
                [-3.34639, 36.734718],
                [-3.35556, 36.726944],
                [-3.36, 36.721939],
                [-3.36056, 36.716942],
                [-3.36361, 36.71221900000012],
                [-3.418334, 36.69444],
                [-3.43278, 36.692772],
                [-3.452778, 36.691666],
                [-3.467223, 36.69221],
                [-3.47972, 36.69444],
                [-3.486667, 36.696663000000115],
                [-3.529445, 36.7158280000001],
                [-3.59528, 36.746941000000106],
                [-3.607778, 36.74582700000013],
                [-3.63972, 36.740555],
                [-3.66944, 36.733604],
                [-3.67556, 36.730553],
                [-3.69444, 36.728333],
                [-3.72556, 36.72861],
                [-3.78556, 36.74249300000014],
                [-3.81639, 36.75],
                [-3.84889, 36.752495000000124],
                [-4.024723, 36.741386],
                [-4.17049, 36.719864],
                [-4.23972, 36.713333],
                [-4.32167, 36.710548],
                [-4.327778, 36.710548],
                [-4.35972, 36.7175],
                [-4.39167, 36.723053],
                [-4.398334, 36.722221],
                [-4.40472, 36.720276],
                [-4.43417, 36.69944],
                [-4.43694, 36.694717],
                [-4.46194, 36.65583],
                [-4.485278, 36.62221],
                [-4.495001, 36.60833],
                [-4.633056, 36.510551],
                [-4.646389, 36.506104],
                [-4.70833, 36.488609],
                [-4.714723, 36.487778],
                [-4.754168, 36.485832],
                [-4.76139, 36.48555],
                [-4.781667, 36.487221],
                [-4.794168, 36.490273],
                [-4.81361, 36.496384],
                [-4.832223, 36.498886],
                [-4.852501, 36.500832],
                [-4.87806, 36.500832],
                [-4.91389, 36.498886],
                [-4.940001, 36.491661],
                [-5.07361, 36.448883],
                [-5.086667, 36.44416],
                [-5.16528, 36.415276],
                [-5.171945, 36.412773],
                [-5.176667, 36.409721],
                [-5.219167, 36.370552],
                [-5.311389, 36.233604],
                [-5.31361, 36.228607],
                [-5.326112, 36.19749],
                [-5.33333, 36.17194400000011],
                [-5.334508, 36.16256],
                [-5.355799, 36.163307],
                [-5.38139, 36.178329],
                [-5.395278, 36.179443000000106],
                [-5.41611, 36.17889],
                [-5.4225, 36.177773000000116],
                [-5.431667, 36.169167],
                [-5.44528, 36.143883],
                [-5.44389, 36.133606],
                [-5.431667, 36.08388500000012],
                [-5.42194, 36.075829],
                [-5.42528, 36.070831],
                [-5.44889, 36.05222],
                [-5.61361, 36.006104],
                [-5.79722, 36.073883],
                [-5.807222, 36.08055],
                [-5.81111, 36.085],
                [-5.822223, 36.098328],
                [-5.82917, 36.107773],
                [-5.83639, 36.116386],
                [-5.84028, 36.12083],
                [-5.854167, 36.134995],
                [-5.87944, 36.16055],
                [-5.88417, 36.16416],
                [-5.91139, 36.179161],
                [-5.91833, 36.18110700000011],
                [-6.025556, 36.184441000000106],
                [-6.03267, 36.181156],
                [-6.0375, 36.180275],
                [-6.050834, 36.19194],
                [-6.158334, 36.305275],
                [-6.22694, 36.40471600000012],
                [-6.26139, 36.469994],
                [-6.26306, 36.481667],
                [-6.24972, 36.46833],
                [-6.239722, 36.461937],
                [-6.233334, 36.46138800000011],
                [-6.22611, 36.463608000000136],
                [-6.22, 36.46694200000013],
                [-6.21528, 36.470833],
                [-6.172778, 36.512215],
                [-6.17667, 36.516663],
                [-6.230834, 36.574997],
                [-6.238056, 36.58138300000013],
                [-6.2975, 36.613884],
                [-6.33722, 36.620552],
                [-6.361945, 36.61639],
                [-6.36833, 36.616943],
                [-6.38667, 36.623886],
                [-6.3925, 36.626389],
                [-6.40083, 36.634163],
                [-6.427501, 36.68278],
                [-6.432501, 36.69221],
                [-6.435, 36.69722],
                [-6.44361, 36.718887],
                [-6.441668, 36.739441],
                [-6.437222, 36.74360700000011],
                [-6.35556, 36.860832],
                [-6.578889, 37.01944],
                [-6.725834, 37.091942],
                [-6.904723, 37.16555],
                [-6.95992, 37.221836],
                [-6.978722, 37.212608],
                [-6.97223, 37.17775],
                [-6.99684, 37.19107],
                [-7.053334, 37.213051],
                [-7.080278, 37.217499],
                [-7.12722, 37.220551],
                [-7.17333, 37.217216],
                [-7.258612, 37.208054],
                [-7.28472, 37.20499400000011],
                [-7.32556, 37.19722000000013],
                [-7.34056, 37.188889],
                [-7.339445, 37.183609],
                [-7.344445, 37.179718],
                [-7.35639, 37.175827],
                [-7.384167, 37.16971600000011],
                [-7.39861, 37.180832],
                [-7.40944, 37.20166000000012],
                [-7.43185, 37.253189],
                [-7.43472, 37.366943],
                [-7.44722, 37.41861],
                [-7.46139, 37.457222],
                [-7.47139, 37.481384000000105],
                [-7.48472, 37.498886],
                [-7.503056, 37.522499],
                [-7.512534, 37.528549],
                [-7.524445, 37.552498],
                [-7.446945, 37.69944],
                [-7.42306, 37.74388900000014],
                [-7.394723, 37.7649990000001],
                [-7.379168, 37.77444],
                [-7.320001, 37.815277],
                [-7.285, 37.860275],
                [-7.27833, 37.87083],
                [-7.25361, 37.92832900000013],
                [-7.25194, 37.933609],
                [-7.25194, 37.95944200000014],
                [-7.25472, 37.974716],
                [-7.259445, 37.98166700000013],
                [-7.25444, 37.987495],
                [-7.24556, 37.990829],
                [-7.21083, 37.996941],
                [-7.12361, 38.00999500000012],
                [-7.006667, 38.028053000000114],
                [-7.00139, 38.034164],
                [-6.95167, 38.14],
                [-6.94389, 38.162773],
                [-6.939167, 38.17805],
                [-6.93375, 38.209068],
                [-6.94056, 38.217773000000136],
                [-6.947779, 38.21833],
                [-6.96139, 38.21583],
                [-6.993334, 38.209442],
                [-7.01028, 38.200554],
                [-7.01167, 38.195549],
                [-7.01694, 38.19166600000011],
                [-7.02833, 38.187492],
                [-7.081112, 38.17472],
                [-7.08778, 38.174438],
                [-7.10111, 38.184166],
                [-7.10222, 38.18916300000012],
                [-7.13, 38.22583],
                [-7.145, 38.246109],
                [-7.16972, 38.284439],
                [-7.192223, 38.320274],
                [-7.274445, 38.41666],
                [-7.280834, 38.4222180000001],
                [-7.28889, 38.42694100000011],
                [-7.304167, 38.435829],
                [-7.313056, 38.439995],
                [-7.32111, 38.44944],
                [-7.267222, 38.703331],
                [-7.265556, 38.708328],
                [-7.260279, 38.72305300000011],
                [-7.257223, 38.728333],
                [-7.24556, 38.73389],
                [-7.207355, 38.749268],
                [-7.16417, 38.781944],
                [-7.08417, 38.835548],
                [-7.06, 38.86055],
                [-6.956944, 39.019997],
                [-6.95479, 39.026382],
                [-6.961112, 39.056664],
                [-6.98278, 39.09138],
                [-7.005, 39.10721600000011],
                [-7.02139, 39.11639],
                [-7.040278, 39.12277200000011],
                [-7.05056, 39.124161],
                [-7.05667, 39.11805],
                [-7.065556, 39.114716],
                [-7.10278, 39.104721],
                [-7.115834, 39.104164],
                [-7.13389, 39.108604],
                [-7.1425, 39.111107],
                [-7.149167, 39.116661],
                [-7.24278, 39.213051],
                [-7.31361, 39.34471900000011],
                [-7.32278, 39.388329],
                [-7.371389, 39.491386],
                [-7.38, 39.496109],
                [-7.499722, 39.599716000000114],
                [-7.505834, 39.605827],
                [-7.523056, 39.633331],
                [-7.526945, 39.64],
                [-7.5325, 39.669418],
                [-7.41472, 39.649162],
                [-7.4075, 39.64833],
                [-7.3375, 39.643883],
                [-7.33083, 39.644722],
                [-7.32556, 39.648605],
                [-7.307222, 39.656662],
                [-7.266945, 39.67194400000011],
                [-7.260279, 39.672218],
                [-7.205556, 39.66722],
                [-7.166112, 39.661942000000124],
                [-7.1525, 39.658882],
                [-7.146111, 39.658607],
                [-7.05763, 39.662254],
                [-7.04812, 39.665253],
                [-7.01722, 39.67499500000014],
                [-6.989722, 39.724716],
                [-6.87083, 40.01028],
                [-6.87056, 40.02166000000011],
                [-6.8825, 40.044167],
                [-6.928889, 40.101662],
                [-6.93472, 40.1075],
                [-6.9425, 40.112778],
                [-6.95056, 40.11666],
                [-6.96, 40.115829],
                [-6.97806, 40.117775],
                [-6.98722, 40.120552],
                [-7.004723, 40.126106],
                [-7.013056, 40.139442],
                [-7.02722, 40.18777],
                [-7.01083, 40.222771],
                [-7.005834, 40.23083],
                [-6.946526, 40.25898],
                [-6.91028, 40.256386],
                [-6.88278, 40.260277],
                [-6.873889, 40.263329],
                [-6.862303, 40.271523000000116],
                [-6.83111, 40.317215],
                [-6.815556, 40.38777],
                [-6.79611, 40.52444],
                [-6.81944, 40.73333],
                [-6.801667, 40.848885],
                [-6.79972, 40.856110000000115],
                [-6.803889, 40.874161],
                [-6.85722, 40.94749500000012],
                [-6.865556, 40.956383],
                [-6.87167, 40.95916],
                [-6.891389, 40.974716000000114],
                [-6.92944, 41.013054],
                [-6.931667, 41.01805100000013],
                [-6.92441, 41.03096],
                [-6.848333, 41.02861000000013],
                [-6.835, 41.031662],
                [-6.805556, 41.045555],
                [-6.780278, 41.06360600000011],
                [-6.768612, 41.07777],
                [-6.75444, 41.102493],
                [-6.75417, 41.112495],
                [-6.75333, 41.136665],
                [-6.690556, 41.208054],
                [-6.686389, 41.212494000000106],
                [-6.64389, 41.24472],
                [-6.618056, 41.246384],
                [-6.59833, 41.244164],
                [-6.58, 41.239716],
                [-6.558333, 41.242218],
                [-6.51028, 41.265],
                [-6.438056, 41.318886],
                [-6.357779, 41.38055400000013],
                [-6.29583, 41.436104],
                [-6.217501, 41.52944200000013],
                [-6.210556, 41.538887],
                [-6.203611, 41.548332],
                [-6.191389, 41.569717],
                [-6.18875, 41.576057000000105],
                [-6.18722, 41.57972000000012],
                [-6.19444, 41.593048000000124],
                [-6.25222, 41.637772],
                [-6.26, 41.643051],
                [-6.303612, 41.66333],
                [-6.34722, 41.67222],
                [-6.42472, 41.679718],
                [-6.434167, 41.680275],
                [-6.452778, 41.67472],
                [-6.469167, 41.666664],
                [-6.4975, 41.65749],
                [-6.50611, 41.661385],
                [-6.539445, 41.679443],
                [-6.55139, 41.691109],
                [-6.55222, 41.698051000000135],
                [-6.547501, 41.764999],
                [-6.52806, 41.839439],
                [-6.548612, 41.921944],
                [-6.594167, 41.95361],
                [-6.6025, 41.94888],
                [-6.618334, 41.940552],
                [-6.6875, 41.936661],
                [-6.696945, 41.936661],
                [-6.71694, 41.936661],
                [-6.90611, 41.944717],
                [-6.93611, 41.94944],
                [-6.94472, 41.952774],
                [-6.982848, 41.973862],
                [-7.003056, 41.9566650000001],
                [-7.01444, 41.952499],
                [-7.05611, 41.95111],
                [-7.063056, 41.951385],
                [-7.0775, 41.957497],
                [-7.08167, 41.96138800000011],
                [-7.081112, 41.966385],
                [-7.092501, 41.98027],
                [-7.10528, 41.986938],
                [-7.125556, 41.99305],
                [-7.13361, 41.994995],
                [-7.14, 41.994164],
                [-7.18278, 41.979439],
                [-7.187222, 41.975273],
                [-7.183056, 41.93777],
                [-7.17472, 41.928055],
                [-7.17361, 41.922775],
                [-7.18694, 41.898331],
                [-7.200556, 41.88361],
                [-7.207348, 41.883835],
                [-7.26833, 41.863609],
                [-7.331112, 41.84499],
                [-7.41056, 41.823326],
                [-7.426667, 41.82222],
                [-7.607779, 41.83111],
                [-7.611945, 41.834999],
                [-7.609167, 41.845551],
                [-7.59806, 41.865273],
                [-7.686389, 41.903053],
                [-7.6925, 41.904999],
                [-7.70583, 41.904442],
                [-7.759445, 41.8975],
                [-7.84917, 41.864441],
                [-7.866945, 41.85555],
                [-7.873334, 41.85249],
                [-7.88, 41.85277600000012],
                [-7.921112, 41.880829],
                [-7.93222, 41.87471800000014],
                [-8.035278, 41.827217],
                [-8.055065, 41.81952],
                [-8.067501, 41.815277],
                [-8.08778, 41.809441000000106],
                [-8.13167, 41.80916600000012],
                [-8.140556, 41.80916600000012],
                [-8.163807, 41.817184],
                [-8.16167, 41.8275],
                [-8.16, 41.842773],
                [-8.16111, 41.857498],
                [-8.16528, 41.86305],
                [-8.175556, 41.871109],
                [-8.181114, 41.87249800000012],
                [-8.187778, 41.873886],
                [-8.201117, 41.87249800000012],
                [-8.20472, 41.87471800000014],
                [-8.217779, 41.903885],
                [-8.219168, 41.90861],
                [-8.218613, 41.9136],
                [-8.212778, 41.92388],
                [-8.20472, 41.933609000000104],
                [-8.16528, 41.974442],
                [-8.134724, 41.99889],
                [-8.10889, 42.008606],
                [-8.09556, 42.013329],
                [-8.08944, 42.01639],
                [-8.085, 42.020271],
                [-8.0825, 42.02527600000013],
                [-8.08167, 42.03],
                [-8.079723, 42.054161],
                [-8.085556, 42.06472],
                [-8.09, 42.068886000000134],
                [-8.19444, 42.1486],
                [-8.201223, 42.15274],
                [-8.25194, 42.13861],
                [-8.31056, 42.103607],
                [-8.44611, 42.084717000000126],
                [-8.47361, 42.084717000000126],
                [-8.51472, 42.08332800000011],
                [-8.521389, 42.082771],
                [-8.606945, 42.059166],
                [-8.62083, 42.05360400000012],
                [-8.64, 42.045273],
                [-8.73861, 41.97138200000012],
                [-8.743057, 41.96666],
                [-8.74445, 41.961937],
                [-8.74501, 41.952499],
                [-8.757223, 41.940552],
                [-8.77278, 41.929443],
                [-8.78389, 41.922775],
                [-8.816443, 41.92018900000011],
                [-8.84804, 41.899582],
                [-8.86528, 41.87555],
                [-8.871946, 41.875832000000116],
                [-8.881668, 41.88333100000011],
                [-8.88833, 41.933609000000104],
                [-8.898613, 42.108055],
                [-8.89639, 42.11305],
                [-8.810835, 42.186943],
                [-8.77389, 42.213108],
                [-8.75889, 42.219440000000134],
                [-8.722778, 42.240273000000116],
                [-8.64417, 42.28833],
                [-8.58, 42.34638200000012],
                [-8.57972, 42.351662],
                [-8.6, 42.353607],
                [-8.61972, 42.349998],
                [-8.632223, 42.340553000000114],
                [-8.653057, 42.319717],
                [-8.656389, 42.314995],
                [-8.65806, 42.30971],
                [-8.65, 42.301384],
                [-8.649723, 42.29583],
                [-8.65472, 42.292221],
                [-8.683613, 42.27971600000012],
                [-8.76083, 42.259163],
                [-8.79411, 42.253384],
                [-8.85722, 42.24777200000011],
                [-8.86389, 42.248055],
                [-8.869167, 42.251389],
                [-8.85278, 42.2961],
                [-8.821945, 42.328331],
                [-8.793612, 42.337776],
                [-8.69222, 42.400833],
                [-8.67195, 42.414444],
                [-8.65611, 42.427773000000116],
                [-8.689167, 42.439438],
                [-8.70306, 42.435829],
                [-8.742224, 42.416664],
                [-8.751667, 42.408607],
                [-8.775167, 42.399994000000106],
                [-8.777168, 42.39716],
                [-8.784667, 42.395332],
                [-8.84083, 42.391388],
                [-8.879168, 42.41944100000012],
                [-8.88194, 42.423882],
                [-8.908335, 42.467499],
                [-8.90389, 42.48277],
                [-8.89139, 42.496666],
                [-8.88611, 42.50027],
                [-8.871668, 42.500832000000116],
                [-8.86444, 42.499718],
                [-8.85889, 42.49638],
                [-8.85639, 42.491661000000136],
                [-8.855001, 42.486664],
                [-8.856668, 42.47888200000011],
                [-8.85806, 42.473885],
                [-8.864723, 42.471382],
                [-8.870001, 42.46833],
                [-8.872501, 42.46333],
                [-8.86945, 42.453606],
                [-8.862501, 42.45388800000012],
                [-8.836113, 42.46194],
                [-8.81444, 42.491661000000136],
                [-8.80972, 42.519440000000145],
                [-8.825556, 42.535828],
                [-8.833612, 42.550278],
                [-8.83417, 42.555275],
                [-8.827778, 42.574715],
                [-8.8225, 42.578331000000105],
                [-8.81583, 42.576942],
                [-8.81056, 42.57388300000014],
                [-8.80444, 42.576111],
                [-8.77889, 42.596107],
                [-8.74695, 42.638054000000125],
                [-8.71972, 42.675278],
                [-8.719446, 42.69583100000011],
                [-8.72155, 42.7011490000001],
                [-8.85139, 42.66111],
                [-8.91833, 42.628326],
                [-8.92333, 42.6252750000001],
                [-8.935, 42.61055],
                [-8.93639, 42.604721],
                [-8.93528, 42.59999800000014],
                [-8.943056, 42.586105],
                [-8.99556, 42.532494],
                [-9.016945, 42.52138],
                [-9.02333, 42.521111],
                [-9.03583, 42.525276],
                [-9.04139, 42.528885],
                [-9.06139, 42.57944],
                [-9.056667, 42.609993],
                [-9.03472, 42.67083],
                [-9.024723, 42.69444],
                [-9.020279, 42.70472],
                [-9.00639, 42.720833],
                [-8.92, 42.784721],
                [-8.911667, 42.79333],
                [-9.00861, 42.776382],
                [-9.08667, 42.740273],
                [-9.10583, 42.75249],
                [-9.123335, 42.768883],
                [-9.140278, 42.794998],
                [-9.13593, 42.79916400000013],
                [-9.12667, 42.80249800000013],
                [-9.12444, 42.839996],
                [-9.14389, 42.893326],
                [-9.16278, 42.925827],
                [-9.185001, 42.9525],
                [-9.19139, 42.94999700000011],
                [-9.257223, 42.915833],
                [-9.270557, 42.911659],
                [-9.293335, 42.922493000000145],
                [-9.259167, 43.04722],
                [-9.209446, 43.152771],
                [-9.206945, 43.15749],
                [-9.16972, 43.185829],
                [-9.145279, 43.193054],
                [-9.13194, 43.196663],
                [-9.125557, 43.197495],
                [-9.089445, 43.190552],
                [-9.03528, 43.20388800000012],
                [-8.952223, 43.23055],
                [-8.935835, 43.239441],
                [-8.979168, 43.27082800000011],
                [-8.981668, 43.27611],
                [-8.980278, 43.28139],
                [-8.96889, 43.28611000000012],
                [-8.95028, 43.29361],
                [-8.87639, 43.319717],
                [-8.824446, 43.32721700000013],
                [-8.78278, 43.303055],
                [-8.72417, 43.291107],
                [-8.70139, 43.287216],
                [-8.68944, 43.292221],
                [-8.6575, 43.303329],
                [-8.40556, 43.38472],
                [-8.329723, 43.403885000000116],
                [-8.265556, 43.55277],
                [-8.006668, 43.703888],
                [-7.898056, 43.76416],
                [-7.865834, 43.772217],
                [-7.85611, 43.765],
                [-7.85556, 43.759995],
              ],
            ],
          ],
        },
        id: 13,
        NAME: 'Spain',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Hungary',
          id: 14,
          label: 'Hungary',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.154,
          year: '2023',
          centroid: [19.5033, 47.1625],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [18.81702, 45.912964],
              [18.807499, 45.902771],
              [18.779999, 45.894722],
              [18.723331, 45.909439],
              [18.715553, 45.913605],
              [18.622219, 45.856941],
              [18.614719, 45.845833],
              [18.601665, 45.830276],
              [18.595276, 45.825554],
              [18.559444, 45.801666],
              [18.551666, 45.798332],
              [18.443333, 45.752777],
              [18.424164, 45.749161],
              [18.407497, 45.748329],
              [18.335831, 45.754166],
              [18.329441, 45.754715],
              [18.26083, 45.762497],
              [18.250553, 45.764442],
              [18.242775, 45.768326],
              [18.238052, 45.773888],
              [18.230831, 45.778328],
              [18.220833, 45.781105],
              [18.201942, 45.783333],
              [18.189163, 45.784439],
              [18.153332, 45.787216],
              [18.006386, 45.786942],
              [17.880833, 45.783882],
              [17.669441, 45.834999],
              [17.66, 45.838333],
              [17.657219, 45.840828],
              [17.652695, 45.853134],
              [17.649441, 45.877495],
              [17.640274, 45.893051],
              [17.62611, 45.90583],
              [17.591663, 45.93222],
              [17.585278, 45.936943],
              [17.576664, 45.940552],
              [17.458611, 45.954437],
              [17.427776, 45.952499],
              [17.432858, 45.945427],
              [17.434166, 45.943604],
              [17.434719, 45.93972],
              [17.431664, 45.937218],
              [17.423332, 45.934441],
              [17.418053, 45.934715],
              [17.389442, 45.938049],
              [17.358608, 45.949997],
              [17.351109, 45.953331],
              [17.311386, 45.975273],
              [17.256943, 46.01722],
              [17.255554, 46.020554],
              [17.25861, 46.023048],
              [17.254719, 46.053329],
              [17.239441, 46.083611],
              [17.23, 46.097221],
              [17.185555, 46.151939],
              [17.179996, 46.157219],
              [17.157497, 46.177773],
              [17.153889, 46.179993],
              [17.149719, 46.181664],
              [17.040276, 46.214165],
              [16.973053, 46.233604],
              [16.937771, 46.249451],
              [16.91972, 46.259995],
              [16.892776, 46.282494],
              [16.889999, 46.284996],
              [16.880577, 46.304504],
              [16.879025, 46.308571],
              [16.878887, 46.337494],
              [16.87833, 46.34111],
              [16.873886, 46.346939],
              [16.866108, 46.355827],
              [16.840553, 46.369995],
              [16.801388, 46.391388],
              [16.66111, 46.465553],
              [16.628609, 46.474998],
              [16.607872, 46.476234],
              [16.532497, 46.507774],
              [16.529442, 46.510277],
              [16.408607, 46.658882],
              [16.385555, 46.70166],
              [16.375328, 46.722771],
              [16.364998, 46.719162],
              [16.359444, 46.718887],
              [16.356388, 46.721382],
              [16.326385, 46.75444],
              [16.324165, 46.757217],
              [16.313889, 46.785553],
              [16.313889, 46.793884],
              [16.315277, 46.797775],
              [16.318886, 46.799995],
              [16.337219, 46.809166],
              [16.350555, 46.836937],
              [16.350555, 46.84111],
              [16.348888, 46.844444],
              [16.346107, 46.846939],
              [16.303055, 46.867775],
              [16.293331, 46.870827],
              [16.269722, 46.874443],
              [16.231941, 46.876663],
              [16.226944, 46.875832],
              [16.191666, 46.86972],
              [16.180832, 46.863609],
              [16.175831, 46.862495],
              [16.145554, 46.85833],
              [16.140831, 46.85833],
              [16.136387, 46.859993],
              [16.111805, 46.86972],
              [16.136108, 46.877777],
              [16.139721, 46.879997],
              [16.253609, 46.958328],
              [16.276665, 46.988052],
              [16.302776, 47.011383],
              [16.346943, 47.009995],
              [16.412498, 47.007774],
              [16.445, 47.004715],
              [16.481388, 47.000549],
              [16.497776, 47.00222],
              [16.506943, 47.004715],
              [16.510555, 47.00666],
              [16.510555, 47.009995],
              [16.505554, 47.114998],
              [16.466942, 47.146942],
              [16.461666, 47.146385],
              [16.456108, 47.146942],
              [16.452499, 47.148888],
              [16.421944, 47.205826],
              [16.420555, 47.20916],
              [16.420555, 47.213333],
              [16.444721, 47.244438],
              [16.469166, 47.257774],
              [16.47361, 47.259438],
              [16.477219, 47.261383],
              [16.491665, 47.279999],
              [16.491108, 47.283882],
              [16.456387, 47.368889],
              [16.450554, 47.407219],
              [16.450554, 47.41111],
              [16.451942, 47.415276],
              [16.454998, 47.41777],
              [16.459164, 47.419167],
              [16.470833, 47.419716],
              [16.482777, 47.418053],
              [16.592499, 47.425278],
              [16.655205, 47.458153],
              [16.705276, 47.521111],
              [16.713886, 47.543884],
              [16.668888, 47.611664],
              [16.663887, 47.617218],
              [16.648888, 47.629715],
              [16.645275, 47.631943],
              [16.636665, 47.63472],
              [16.630833, 47.635826],
              [16.624722, 47.635826],
              [16.602497, 47.628609],
              [16.590832, 47.629166],
              [16.493053, 47.64666],
              [16.44833, 47.659721],
              [16.429443, 47.666107],
              [16.425831, 47.668327],
              [16.426941, 47.671387],
              [16.450554, 47.698051],
              [16.555832, 47.756104],
              [16.561386, 47.75666],
              [16.612221, 47.759163],
              [16.635555, 47.760277],
              [16.715832, 47.734718],
              [16.723331, 47.730553],
              [16.725555, 47.727493],
              [16.729164, 47.713051],
              [16.734444, 47.703331],
              [16.737221, 47.700829],
              [16.7575, 47.686943],
              [16.761944, 47.685272],
              [16.768608, 47.684715],
              [16.824444, 47.683884],
              [16.910831, 47.690826],
              [16.955276, 47.694717],
              [17.053886, 47.709442],
              [17.071663, 47.728607],
              [17.068607, 47.768326],
              [17.058609, 47.789444],
              [17.054996, 47.799721],
              [17.054443, 47.847221],
              [17.060555, 47.876938],
              [17.108055, 47.971382],
              [17.146942, 48],
              [17.166386, 48.012497],
              [17.176388, 48.01944],
              [17.180832, 48.021111],
              [17.19083, 48.023048],
              [17.236664, 48.025833],
              [17.241713, 48.025551],
              [17.251656, 48.024994],
              [17.254166, 48.016106],
              [17.26083, 48.007217],
              [17.264442, 48.004997],
              [17.273331, 48.001663],
              [17.311943, 47.998055],
              [17.335831, 47.998329],
              [17.340553, 47.997498],
              [17.355553, 47.988884],
              [17.411884, 47.944748],
              [17.442219, 47.916664],
              [17.447498, 47.91111],
              [17.448887, 47.907776],
              [17.457775, 47.895828],
              [17.466389, 47.888329],
              [17.485867, 47.877968],
              [17.712219, 47.770554],
              [17.784409, 47.746803],
              [17.790161, 47.746056],
              [17.896942, 47.747551],
              [17.901386, 47.749161],
              [17.916386, 47.75222],
              [17.976109, 47.763611],
              [18.086109, 47.759438],
              [18.119164, 47.756943],
              [18.131664, 47.755272],
              [18.195831, 47.747772],
              [18.297222, 47.737221],
              [18.312222, 47.737778],
              [18.337498, 47.740829],
              [18.378609, 47.747215],
              [18.41333, 47.753883],
              [18.446941, 47.766937],
              [18.451664, 47.767776],
              [18.540833, 47.767494],
              [18.597221, 47.763054],
              [18.636944, 47.759163],
              [18.655277, 47.758606],
              [18.67083, 47.760826],
              [18.675278, 47.762497],
              [18.690552, 47.770271],
              [18.720554, 47.78611],
              [18.726944, 47.791107],
              [18.732498, 47.797218],
              [18.738609, 47.807495],
              [18.749729, 47.813156],
              [18.765831, 47.815552],
              [18.788055, 47.817215],
              [18.84972, 47.817772],
              [18.855831, 47.830276],
              [18.853611, 47.833054],
              [18.82, 47.855553],
              [18.792221, 47.86972],
              [18.787777, 47.871666],
              [18.774441, 47.873329],
              [18.769997, 47.874992],
              [18.766941, 47.877777],
              [18.759441, 47.90361],
              [18.758888, 47.907494],
              [18.75972, 47.921661],
              [18.760555, 47.926109],
              [18.771664, 47.965553],
              [18.827366, 48.036125],
              [18.841576, 48.047195],
              [18.849098, 48.051064],
              [18.904503, 48.057693],
              [18.910069, 48.058258],
              [18.965675, 48.059799],
              [18.989799, 48.067101],
              [19.00127, 48.068954],
              [19.041714, 48.070641],
              [19.13945, 48.061676],
              [19.208336, 48.059448],
              [19.460548, 48.085831],
              [19.472218, 48.087219],
              [19.476383, 48.089165],
              [19.480553, 48.095551],
              [19.494442, 48.127495],
              [19.498608, 48.138329],
              [19.501663, 48.150276],
              [19.50861, 48.17305],
              [19.524166, 48.205826],
              [19.532513, 48.210861],
              [19.540016, 48.213196],
              [19.630554, 48.233887],
              [19.644444, 48.233887],
              [19.66222, 48.231941],
              [19.754997, 48.209442],
              [19.783607, 48.201111],
              [19.787777, 48.199165],
              [19.791111, 48.196938],
              [19.7925, 48.193054],
              [19.788887, 48.181664],
              [19.90361, 48.131943],
              [19.907776, 48.130272],
              [19.912498, 48.129715],
              [19.91861, 48.129997],
              [19.937775, 48.135277],
              [19.941944, 48.137215],
              [19.963608, 48.150276],
              [19.974442, 48.156662],
              [20.004997, 48.172775],
              [20.015274, 48.174995],
              [20.05933, 48.176308],
              [20.09333, 48.198326],
              [20.140553, 48.226105],
              [20.235554, 48.274994],
              [20.276386, 48.256104],
              [20.280277, 48.254166],
              [20.286663, 48.253883],
              [20.291943, 48.254715],
              [20.299721, 48.258606],
              [20.317219, 48.269722],
              [20.340832, 48.28611],
              [20.359165, 48.300278],
              [20.366943, 48.308884],
              [20.400555, 48.355553],
              [20.40361, 48.362778],
              [20.405277, 48.371109],
              [20.411942, 48.394165],
              [20.416386, 48.405273],
              [20.435833, 48.433609],
              [20.443607, 48.442215],
              [20.458611, 48.455276],
              [20.499443, 48.483059],
              [20.500832, 48.50444],
              [20.539719, 48.536942],
              [20.645275, 48.559998],
              [20.660553, 48.563332],
              [20.713333, 48.56916],
              [20.811665, 48.57666],
              [20.818607, 48.576385],
              [20.830276, 48.574997],
              [20.839165, 48.571663],
              [20.847775, 48.563606],
              [20.869999, 48.550827],
              [20.940277, 48.526382],
              [20.949718, 48.523605],
              [20.955276, 48.522499],
              [21.084442, 48.513611],
              [21.153332, 48.511108],
              [21.253887, 48.522217],
              [21.308712, 48.54805],
              [21.43111, 48.576111],
              [21.442776, 48.575272],
              [21.447777, 48.573883],
              [21.507221, 48.548882],
              [21.614166, 48.498329],
              [21.616665, 48.495552],
              [21.620552, 48.488884],
              [21.621666, 48.485275],
              [21.622776, 48.476944],
              [21.622776, 48.46833],
              [21.628052, 48.44944],
              [21.712776, 48.361382],
              [21.718609, 48.356384],
              [21.726665, 48.352493],
              [21.731388, 48.351105],
              [21.777496, 48.340828],
              [21.784443, 48.340553],
              [21.824165, 48.340271],
              [21.828331, 48.342216],
              [21.835831, 48.351105],
              [21.845276, 48.358604],
              [21.848888, 48.361382],
              [21.853054, 48.363052],
              [21.862778, 48.365555],
              [21.935833, 48.379166],
              [21.964996, 48.381943],
              [22.029442, 48.387497],
              [22.056664, 48.386665],
              [22.073055, 48.383606],
              [22.085831, 48.378052],
              [22.096107, 48.376389],
              [22.101665, 48.37722],
              [22.110832, 48.380272],
              [22.150555, 48.408607],
              [22.151442, 48.411919],
              [22.171715, 48.409058],
              [22.205551, 48.41777],
              [22.217216, 48.418602],
              [22.228882, 48.416939],
              [22.268887, 48.407211],
              [22.271385, 48.40416],
              [22.271111, 48.400543],
              [22.269444, 48.396942],
              [22.270275, 48.359993],
              [22.347775, 48.274994],
              [22.378609, 48.245544],
              [22.383331, 48.244156],
              [22.454716, 48.243607],
              [22.484718, 48.250549],
              [22.489716, 48.251663],
              [22.495827, 48.251106],
              [22.5, 48.249355],
              [22.504444, 48.24749],
              [22.507774, 48.24527],
              [22.574718, 48.18721],
              [22.597218, 48.147774],
              [22.598331, 48.143883],
              [22.60194, 48.128601],
              [22.602497, 48.115829],
              [22.604996, 48.113052],
              [22.611532, 48.108433],
              [22.621151, 48.101639],
              [22.630289, 48.099052],
              [22.643522, 48.09531],
              [22.650551, 48.093323],
              [22.670551, 48.092216],
              [22.680828, 48.094154],
              [22.697216, 48.101387],
              [22.737774, 48.114441],
              [22.78194, 48.117493],
              [22.788052, 48.117767],
              [22.79361, 48.116661],
              [22.797497, 48.114716],
              [22.84444, 48.084717],
              [22.846464, 48.083221],
              [22.85083, 48.079994],
              [22.879997, 48.049721],
              [22.882496, 48.046944],
              [22.886108, 48.040276],
              [22.88694, 48.036659],
              [22.886662, 48.031937],
              [22.881107, 48.02166],
              [22.859165, 47.993889],
              [22.894804, 47.95454],
              [22.782776, 47.849159],
              [22.782497, 47.844719],
              [22.780277, 47.84166],
              [22.774441, 47.836388],
              [22.65361, 47.776382],
              [22.634163, 47.77166],
              [22.612221, 47.768608],
              [22.594997, 47.766937],
              [22.557499, 47.766106],
              [22.546944, 47.768051],
              [22.503609, 47.789719],
              [22.5, 47.790852],
              [22.489441, 47.794167],
              [22.472775, 47.796944],
              [22.454441, 47.796387],
              [22.445274, 47.793327],
              [22.323055, 47.747498],
              [22.318886, 47.745827],
              [22.276943, 47.728607],
              [22.270554, 47.723885],
              [22.226387, 47.680832],
              [22.224163, 47.677773],
              [22.191944, 47.630829],
              [22.19083, 47.626663],
              [22.189838, 47.603958],
              [22.186386, 47.59861],
              [22.177219, 47.59111],
              [22.158607, 47.585548],
              [22.118008, 47.57811],
              [22.043053, 47.536942],
              [22.032497, 47.530273],
              [22.023888, 47.522499],
              [22.015274, 47.514442],
              [22.010277, 47.508606],
              [22.006107, 47.496941],
              [22.006664, 47.484161],
              [22.009998, 47.473053],
              [22.018608, 47.456383],
              [22.021942, 47.445274],
              [22.020554, 47.425278],
              [22.015553, 47.395828],
              [22.013054, 47.388054],
              [22.00972, 47.380829],
              [22.0075, 47.377777],
              [22.004719, 47.374992],
              [21.996387, 47.371666],
              [21.985554, 47.369995],
              [21.962498, 47.36805],
              [21.937222, 47.362778],
              [21.932499, 47.361382],
              [21.925552, 47.357216],
              [21.922497, 47.354439],
              [21.874165, 47.299721],
              [21.869164, 47.293327],
              [21.843052, 47.238327],
              [21.841663, 47.234718],
              [21.84111, 47.225555],
              [21.84333, 47.21833],
              [21.846943, 47.211937],
              [21.84861, 47.203888],
              [21.84861, 47.191666],
              [21.844719, 47.184998],
              [21.790833, 47.120277],
              [21.782219, 47.112221],
              [21.769997, 47.106941],
              [21.751389, 47.101662],
              [21.734997, 47.094719],
              [21.709999, 47.07972],
              [21.653889, 47.032494],
              [21.651108, 47.029716],
              [21.651665, 47.025551],
              [21.653332, 47.022499],
              [21.655502, 47.020866],
              [21.690277, 47.010551],
              [21.693607, 47.008049],
              [21.695274, 47.004997],
              [21.695831, 47.000832],
              [21.691944, 46.994164],
              [21.67083, 46.961388],
              [21.613331, 46.884163],
              [21.545555, 46.839439],
              [21.529163, 46.828049],
              [21.526386, 46.825272],
              [21.519722, 46.815277],
              [21.493053, 46.763054],
              [21.488052, 46.752777],
              [21.489166, 46.749161],
              [21.494999, 46.743889],
              [21.502777, 46.739998],
              [21.521664, 46.734718],
              [21.528053, 46.729996],
              [21.529163, 46.726387],
              [21.528332, 46.722221],
              [21.526943, 46.718605],
              [21.521942, 46.712776],
              [21.493889, 46.686943],
              [21.489407, 46.684532],
              [21.467499, 46.685829],
              [21.45472, 46.685555],
              [21.449997, 46.685272],
              [21.441944, 46.681938],
              [21.329441, 46.622772],
              [21.326664, 46.619995],
              [21.324718, 46.616943],
              [21.308887, 46.59166],
              [21.30722, 46.588051],
              [21.29361, 46.532494],
              [21.288887, 46.460548],
              [21.219166, 46.408333],
              [21.208332, 46.402222],
              [21.19722, 46.391388],
              [21.191387, 46.381386],
              [21.185276, 46.362495],
              [21.178608, 46.326942],
              [21.178055, 46.299164],
              [21.176666, 46.295555],
              [21.08083, 46.246941],
              [21.059444, 46.239166],
              [21.053608, 46.238884],
              [21.048332, 46.239998],
              [21.03611, 46.245277],
              [20.989719, 46.254715],
              [20.86861, 46.276108],
              [20.846386, 46.27916],
              [20.82972, 46.277222],
              [20.820274, 46.274719],
              [20.795898, 46.265724],
              [20.783054, 46.259438],
              [20.761387, 46.246941],
              [20.75333, 46.238884],
              [20.720554, 46.191666],
              [20.719997, 46.187492],
              [20.726955, 46.17556],
              [20.72583, 46.171104],
              [20.720554, 46.16555],
              [20.706387, 46.156662],
              [20.69589, 46.150391],
              [20.679443, 46.14222],
              [20.624722, 46.130272],
              [20.619442, 46.131386],
              [20.582775, 46.154999],
              [20.563332, 46.164993],
              [20.535275, 46.17305],
              [20.48695, 46.181107],
              [20.340275, 46.159439],
              [20.285275, 46.146942],
              [20.276665, 46.144722],
              [20.270832, 46.139717],
              [20.264442, 46.130272],
              [20.261024, 46.114853],
              [20.257774, 46.11805],
              [20.20472, 46.149719],
              [20.200832, 46.151382],
              [20.118332, 46.166939],
              [20.112221, 46.167496],
              [19.961109, 46.17083],
              [19.859722, 46.155273],
              [19.850277, 46.152771],
              [19.845833, 46.151382],
              [19.842499, 46.149162],
              [19.74472, 46.162216],
              [19.70372, 46.176392],
              [19.672775, 46.180832],
              [19.660275, 46.181389],
              [19.570553, 46.173607],
              [19.559998, 46.171944],
              [19.50861, 46.143883],
              [19.505833, 46.141106],
              [19.504444, 46.137497],
              [19.506386, 46.134438],
              [19.517498, 46.123886],
              [19.518887, 46.120277],
              [19.517498, 46.116661],
              [19.511387, 46.111664],
              [19.46722, 46.078606],
              [19.460552, 46.074165],
              [19.286388, 45.989441],
              [19.281666, 45.988327],
              [19.16111, 45.986664],
              [19.155277, 45.987221],
              [19.151386, 45.988884],
              [19.148609, 45.991661],
              [19.136387, 46.014999],
              [19.130554, 46.019997],
              [19.123886, 46.023605],
              [19.119164, 46.024994],
              [19.107498, 46.025833],
              [19.096386, 46.024437],
              [19.087776, 46.021385],
              [19.080555, 46.01722],
              [19.012775, 45.968887],
              [19.006664, 45.963882],
              [18.995552, 45.952499],
              [18.858887, 45.91111],
              [18.835831, 45.91111],
              [18.81702, 45.912964],
            ],
          ],
        },
        id: 14,
        NAME: 'Hungary',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Belgium',
          id: 15,
          label: 'Belgium',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.145,
          year: '2023',
          centroid: [4.4699, 50.5039],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [4.302375, 51.263184],
              [4.309677, 51.262032],
              [4.327703, 51.290123],
              [4.290481, 51.307682],
              [4.283055, 51.317215],
              [4.280181, 51.3442],
              [4.260985, 51.355434],
              [4.252368, 51.375145],
              [4.279674, 51.376595],
              [4.346944, 51.362495],
              [4.358889, 51.359993],
              [4.388055, 51.357498],
              [4.407222, 51.357773],
              [4.418611, 51.359161],
              [4.428055, 51.361938],
              [4.431666, 51.364441],
              [4.437778, 51.375275],
              [4.436388, 51.378883],
              [4.417777, 51.398331],
              [4.401388, 51.410828],
              [4.396667, 51.416939],
              [4.393888, 51.450272],
              [4.397499, 51.452774],
              [4.481944, 51.479439],
              [4.486666, 51.480827],
              [4.539721, 51.48555],
              [4.545555, 51.484993],
              [4.549444, 51.482773],
              [4.550833, 51.479439],
              [4.549999, 51.474998],
              [4.544999, 51.462776],
              [4.543333, 51.458885],
              [4.538055, 51.452499],
              [4.535277, 51.443886],
              [4.535277, 51.43972],
              [4.537222, 51.432495],
              [4.541944, 51.426666],
              [4.546944, 51.425827],
              [4.644722, 51.42305],
              [4.650555, 51.423332],
              [4.671388, 51.427757],
              [4.673055, 51.430832],
              [4.670833, 51.433609],
              [4.668611, 51.440826],
              [4.671111, 51.44416],
              [4.69861, 51.464439],
              [4.705555, 51.469444],
              [4.757222, 51.496666],
              [4.769166, 51.502777],
              [4.781111, 51.503609],
              [4.788333, 51.503052],
              [4.806944, 51.499443],
              [4.825833, 51.492218],
              [4.845555, 51.48111],
              [4.84611, 51.477493],
              [4.844722, 51.461388],
              [4.832777, 51.429993],
              [4.853055, 51.414444],
              [4.929999, 51.398605],
              [4.93611, 51.399437],
              [4.940277, 51.401382],
              [4.955555, 51.409996],
              [4.989444, 51.43055],
              [5, 51.437775],
              [5.009444, 51.446388],
              [5.012777, 51.454163],
              [5.015277, 51.471664],
              [5.016944, 51.475555],
              [5.023611, 51.48111],
              [5.035555, 51.487221],
              [5.041389, 51.486664],
              [5.073333, 51.471664],
              [5.080277, 51.466942],
              [5.09611, 51.446106],
              [5.104444, 51.434998],
              [5.103333, 51.43055],
              [5.10111, 51.427216],
              [5.089444, 51.415276],
              [5.085833, 51.412773],
              [5.08, 51.406944],
              [5.077777, 51.403328],
              [5.076666, 51.398888],
              [5.077222, 51.395271],
              [5.07861, 51.391663],
              [5.083055, 51.385826],
              [5.139999, 51.320831],
              [5.143888, 51.318604],
              [5.155, 51.315826],
              [5.168056, 51.314438],
              [5.189166, 51.31916],
              [5.194444, 51.32],
              [5.201111, 51.319717],
              [5.223332, 51.313889],
              [5.233611, 51.310555],
              [5.237499, 51.308327],
              [5.238889, 51.304718],
              [5.238974, 51.262283],
              [5.329721, 51.262215],
              [5.4, 51.265549],
              [5.406111, 51.266106],
              [5.411388, 51.266937],
              [5.467777, 51.282776],
              [5.475555, 51.286942],
              [5.485833, 51.294998],
              [5.497222, 51.296104],
              [5.504444, 51.295273],
              [5.510833, 51.294441],
              [5.520833, 51.291107],
              [5.550278, 51.272499],
              [5.553333, 51.269722],
              [5.557777, 51.263885],
              [5.568334, 51.220711],
              [5.644722, 51.203606],
              [5.754167, 51.189995],
              [5.834444, 51.165833],
              [5.849171, 51.15638],
              [5.855, 51.151108],
              [5.855111, 51.148338],
              [5.851388, 51.14222],
              [5.848332, 51.139442],
              [5.818055, 51.114998],
              [5.776944, 51.025833],
              [5.764166, 50.989998],
              [5.758055, 50.959999],
              [5.657499, 50.880272],
              [5.65, 50.876938],
              [5.640555, 50.863052],
              [5.638888, 50.858887],
              [5.6375, 50.850273],
              [5.638055, 50.846664],
              [5.640833, 50.839722],
              [5.651667, 50.824715],
              [5.655555, 50.822495],
              [5.683611, 50.811386],
              [5.69394, 50.808815],
              [5.701944, 50.805832],
              [5.705, 50.785828],
              [5.70556, 50.781952],
              [5.701388, 50.774437],
              [5.691911, 50.760559],
              [5.69861, 50.757774],
              [5.737222, 50.759438],
              [5.742499, 50.760277],
              [5.7975, 50.76944],
              [5.870555, 50.760826],
              [5.898918, 50.753883],
              [5.926389, 50.756104],
              [6.011798, 50.757271],
              [6.054722, 50.72361],
              [6.167222, 50.656387],
              [6.268611, 50.623604],
              [6.270833, 50.621384],
              [6.271667, 50.618607],
              [6.270555, 50.615829],
              [6.247777, 50.589165],
              [6.264722, 50.497772],
              [6.309444, 50.498055],
              [6.317499, 50.496384],
              [6.333888, 50.489716],
              [6.344444, 50.484161],
              [6.371111, 50.448326],
              [6.37361, 50.443329],
              [6.374444, 50.440552],
              [6.398204, 50.323174],
              [6.349722, 50.312775],
              [6.280833, 50.283607],
              [6.173333, 50.232498],
              [6.165555, 50.22361],
              [6.163888, 50.221382],
              [6.139722, 50.154442],
              [6.134414, 50.127846],
              [6.12, 50.131943],
              [6.033889, 50.159164],
              [6.031111, 50.160828],
              [6.02861, 50.166107],
              [6.026256, 50.181252],
              [6.021944, 50.18222],
              [6.013888, 50.181389],
              [5.976388, 50.171387],
              [5.969722, 50.16861],
              [5.891666, 50.10611],
              [5.889444, 50.104164],
              [5.886666, 50.098885],
              [5.883055, 50.080551],
              [5.883055, 50.077217],
              [5.834444, 49.986938],
              [5.791389, 49.962494],
              [5.777499, 49.957771],
              [5.774722, 49.956108],
              [5.770833, 49.95166],
              [5.747777, 49.907494],
              [5.734444, 49.834999],
              [5.746666, 49.795273],
              [5.748055, 49.79277],
              [5.750833, 49.791107],
              [5.764999, 49.789993],
              [5.790277, 49.78083],
              [5.869444, 49.719719],
              [5.87615, 49.709885],
              [5.899166, 49.662773],
              [5.900277, 49.640549],
              [5.863055, 49.571663],
              [5.837777, 49.550278],
              [5.834167, 49.549164],
              [5.80788, 49.545044],
              [5.792222, 49.54583],
              [5.702222, 49.543053],
              [5.631944, 49.535828],
              [5.593333, 49.526382],
              [5.530555, 49.511108],
              [5.514444, 49.508888],
              [5.4775, 49.504166],
              [5.473055, 49.506104],
              [5.470277, 49.508888],
              [5.463611, 49.517776],
              [5.465278, 49.52166],
              [5.473888, 49.530548],
              [5.47611, 49.534164],
              [5.475555, 49.537773],
              [5.474166, 49.541107],
              [5.437778, 49.599998],
              [5.427221, 49.606941],
              [5.415, 49.613327],
              [5.398611, 49.621384],
              [5.392305, 49.622551],
              [5.331111, 49.656662],
              [4.996666, 49.802498],
              [4.984444, 49.804718],
              [4.959167, 49.802216],
              [4.944722, 49.79361],
              [4.935277, 49.790833],
              [4.924444, 49.789444],
              [4.912777, 49.788887],
              [4.906666, 49.789719],
              [4.873055, 49.797218],
              [4.863889, 49.80722],
              [4.820833, 49.992775],
              [4.838888, 50.06916],
              [4.853333, 50.095551],
              [4.880555, 50.126389],
              [4.883333, 50.129166],
              [4.8875, 50.131104],
              [4.894444, 50.136108],
              [4.894722, 50.140274],
              [4.882777, 50.154716],
              [4.832503, 50.16861],
              [4.819166, 50.167221],
              [4.814722, 50.165833],
              [4.763055, 50.135551],
              [4.696944, 50.090828],
              [4.693055, 50.083328],
              [4.688055, 50.071106],
              [4.687778, 50.067215],
              [4.693889, 50.061943],
              [4.697499, 50.05555],
              [4.694444, 50.041939],
              [4.679722, 50.001938],
              [4.673611, 49.996384],
              [4.510555, 49.947495],
              [4.464167, 49.938889],
              [4.458333, 49.938606],
              [4.445833, 49.940552],
              [4.430007, 49.945007],
              [4.413333, 49.949165],
              [4.317222, 49.969719],
              [4.248055, 49.964439],
              [4.231111, 49.962494],
              [4.215261, 49.959602],
              [4.183055, 49.976387],
              [4.174179, 49.979881],
              [4.149238, 49.978371],
              [4.147222, 50.009995],
              [4.171389, 50.137215],
              [4.194444, 50.237495],
              [4.165, 50.283051],
              [4.038333, 50.355553],
              [4.033177, 50.35643],
              [3.983889, 50.345276],
              [3.889722, 50.339996],
              [3.774722, 50.353882],
              [3.676944, 50.395271],
              [3.671667, 50.433327],
              [3.670555, 50.440826],
              [3.668889, 50.44416],
              [3.660555, 50.456383],
              [3.657728, 50.45887],
              [3.654444, 50.461662],
              [3.620155, 50.490044],
              [3.607778, 50.495827],
              [3.518055, 50.518883],
              [3.456666, 50.511383],
              [3.4525, 50.509438],
              [3.372777, 50.494995],
              [3.367222, 50.495552],
              [3.298611, 50.523048],
              [3.295555, 50.525551],
              [3.28, 50.53833],
              [3.278611, 50.541664],
              [3.243055, 50.660271],
              [3.242222, 50.668053],
              [3.197778, 50.727219],
              [3.187222, 50.746666],
              [3.182874, 50.75705],
              [3.164722, 50.780548],
              [3.162222, 50.783607],
              [3.154444, 50.78833],
              [3.149722, 50.789993],
              [3.143333, 50.790833],
              [3.116389, 50.791664],
              [3.050833, 50.780273],
              [3.041667, 50.777222],
              [3.026988, 50.769844],
              [3.02, 50.770554],
              [3.008611, 50.769165],
              [2.960556, 50.7575],
              [2.943055, 50.741386],
              [2.898056, 50.703049],
              [2.867503, 50.713379],
              [2.781944, 50.755554],
              [2.650555, 50.816109],
              [2.597777, 50.925827],
              [2.5975, 50.995827],
              [2.541667, 51.09111],
              [2.550833, 51.092499],
              [2.560277, 51.095551],
              [2.863055, 51.213333],
              [2.955277, 51.249718],
              [3.02, 51.276382],
              [3.095277, 51.311386],
              [3.112778, 51.318329],
              [3.131667, 51.324165],
              [3.179722, 51.336105],
              [3.370866, 51.373856],
              [3.373611, 51.309998],
              [3.379444, 51.276939],
              [3.380833, 51.273605],
              [3.388324, 51.268677],
              [3.434166, 51.246109],
              [3.439167, 51.244438],
              [3.451944, 51.242493],
              [3.465833, 51.241943],
              [3.483611, 51.243332],
              [3.520833, 51.248055],
              [3.524167, 51.250549],
              [3.524444, 51.263054],
              [3.5225, 51.274162],
              [3.520833, 51.277496],
              [3.520278, 51.281387],
              [3.521111, 51.285828],
              [3.524722, 51.28833],
              [3.595555, 51.303886],
              [3.600833, 51.304718],
              [3.608055, 51.304161],
              [3.669167, 51.29277],
              [3.782777, 51.264999],
              [3.793056, 51.26194],
              [3.796389, 51.259438],
              [3.790833, 51.237221],
              [3.790833, 51.233055],
              [3.793889, 51.223053],
              [3.796111, 51.220276],
              [3.806389, 51.216942],
              [3.890277, 51.205826],
              [3.8975, 51.205276],
              [3.903611, 51.205826],
              [3.9525, 51.214439],
              [4.062222, 51.25222],
              [4.127777, 51.278885],
              [4.161388, 51.294167],
              [4.173055, 51.300552],
              [4.214999, 51.330276],
              [4.228333, 51.340553],
              [4.238898, 51.350426],
              [4.255836, 51.336239],
              [4.26356, 51.317043],
              [4.280649, 51.301125],
              [4.309444, 51.290276],
              [4.312499, 51.287498],
              [4.313055, 51.283882],
              [4.300079, 51.267651],
              [4.302375, 51.263184],
            ],
          ],
        },
        id: 15,
        NAME: 'Belgium',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Croatia',
          id: 16,
          label: 'Croatia',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.134,
          year: '2023',
          centroid: [15.2, 45.1],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [16.903889, 42.72610500000013],
                [16.89444, 42.724716000000114],
                [16.83583, 42.727776],
                [16.830276, 42.728882],
                [16.82222, 42.732216],
                [16.812496000000124, 42.74333],
                [16.813889, 42.76805100000013],
                [16.818333, 42.775551],
                [16.86083, 42.777771],
                [16.865276, 42.777771],
                [16.871387, 42.7775],
                [16.927219, 42.773605],
                [16.93278, 42.772499],
                [16.93972, 42.768326000000116],
                [16.940277, 42.760277],
                [16.927219, 42.741104],
                [16.91555, 42.73111],
                [16.911942, 42.729164],
                [16.903889, 42.72610500000013],
              ],
            ],
            [
              [
                [17.744999, 42.69194],
                [17.74, 42.69166600000011],
                [17.727497, 42.69832600000012],
                [17.699718, 42.705551],
                [17.689442, 42.707771],
                [17.63472000000013, 42.71833],
                [17.61138, 42.720551000000114],
                [17.548611, 42.728333],
                [17.372498, 42.757217],
                [17.358608, 42.761665],
                [17.334721, 42.772499],
                [17.328609, 42.777222],
                [17.321663, 42.788055],
                [17.325275, 42.78999],
                [17.363052, 42.802216],
                [17.378052, 42.801941],
                [17.39944, 42.797775000000115],
                [17.662498, 42.736664],
                [17.667221, 42.735275],
                [17.7305530000001, 42.71],
                [17.740276, 42.703049],
                [17.746109, 42.69416],
                [17.744999, 42.69194],
              ],
            ],
            [
              [
                [16.820553, 42.959999],
                [16.863331, 42.956108],
                [16.873608, 42.95694],
                [16.896385, 42.961937],
                [16.911388, 42.968887],
                [16.940552, 42.97333],
                [16.965553000000114, 42.97639],
                [17.01972, 42.97666],
                [17.04472, 42.97527],
                [17.13583, 42.961937],
                [17.183609, 42.91861],
                [17.134441, 42.911659],
                [17.123886, 42.91138500000011],
                [16.981972, 42.928719000000115],
                [16.94111, 42.91138500000011],
                [16.866108, 42.89777400000014],
                [16.831665, 42.903885],
                [16.72361000000012, 42.919441],
                [16.67222, 42.926109],
                [16.660887, 42.921288],
                [16.64082, 42.929462000000115],
                [16.669064, 42.949532],
                [16.70771200000013, 42.956963],
                [16.694334, 42.969597],
                [16.633053, 42.981110000000115],
                [16.63472, 42.983604],
                [16.64333, 42.98666400000013],
                [16.68611, 42.99082900000013],
                [16.72111, 42.984993],
                [16.733608000000117, 42.97999600000014],
                [16.75694, 42.972771],
                [16.772221, 42.969162],
                [16.820553, 42.959999],
              ],
            ],
            [
              [
                [17.298885, 43.006943],
                [17.42610900000011, 42.959999],
                [17.439163, 42.954994],
                [17.4425, 42.953049],
                [17.448055000000124, 42.94778],
                [17.52277800000013, 42.92027300000012],
                [17.661663, 42.87471800000014],
                [17.653053, 42.88694],
                [17.64984, 42.8890760000001],
                [17.684444, 42.918884000000105],
                [17.687775, 42.921661],
                [17.698055, 42.9272160000001],
                [17.714996, 42.92694100000011],
                [17.744442, 42.92027300000012],
                [17.797497, 42.903885],
                [17.84111, 42.870277],
                [17.845276, 42.85972],
                [17.8475, 42.85666700000013],
                [17.87666300000012, 42.823608],
                [17.882774, 42.81916],
                [17.959999, 42.77916],
                [17.98222, 42.76805100000013],
                [17.998886, 42.76138300000014],
                [18.160553, 42.695],
                [18.221943000000124, 42.648888],
                [18.231941, 42.64222],
                [18.264999000000103, 42.6202770000001],
                [18.268608, 42.618332],
                [18.276943, 42.61555],
                [18.28805, 42.614441],
                [18.302498, 42.616943000000106],
                [18.311665, 42.619438000000116],
                [18.335278, 42.62888],
                [18.34666, 42.62917],
                [18.362499000000128, 42.626663],
                [18.397499, 42.614441],
                [18.411942000000124, 42.606384],
                [18.455555, 42.56583],
                [18.453331, 42.521111],
                [18.453331, 42.512497],
                [18.455276, 42.50027],
                [18.460278, 42.48694],
                [18.466389, 42.477776],
                [18.479443000000117, 42.46527100000014],
                [18.49805, 42.451111],
                [18.503197, 42.44944],
                [18.519165, 42.43527200000011],
                [18.521942, 42.432495],
                [18.524998, 42.426384],
                [18.526108000000136, 42.39833],
                [18.524166, 42.39666000000011],
                [18.513054, 42.398888],
                [18.50444, 42.4061],
                [18.357067, 42.496559],
                [18.214722, 42.57944],
                [18.057777, 42.663605],
                [17.87722, 42.767776],
                [17.750000000000114, 42.79916400000013],
                [17.735275, 42.794998],
                [17.5525, 42.840828],
                [17.439163, 42.873886],
                [17.365, 42.915276],
                [17.218052, 42.979164],
                [17.20361, 42.98305],
                [17.198608, 42.983604],
                [17.194721, 42.98194100000012],
                [17.188889, 42.976944],
                [17.18528, 42.97499800000014],
                [17.17388, 42.97499800000014],
                [17.14527500000014, 42.97666],
                [17.071663, 42.986382],
                [17.013054, 43.005272],
                [17.011665, 43.007217],
                [17.004166, 43.046661],
                [17.006664000000114, 43.047775],
                [17.015831, 43.048882],
                [17.26888700000012, 43.01194],
                [17.298885, 43.006943],
              ],
            ],
            [
              [
                [16.20833, 43.022217000000126],
                [16.09333, 43.009995],
                [16.06444, 43.01055],
                [16.050552, 43.06305],
                [16.066109, 43.070274],
                [16.084999, 43.0774990000001],
                [16.103611, 43.081108],
                [16.113888, 43.082222],
                [16.13972, 43.0824970000001],
                [16.184998, 43.08166],
                [16.230553, 43.078331],
                [16.24694, 43.073883],
                [16.25194, 43.07249500000012],
                [16.25333, 43.06916],
                [16.254719, 43.062492],
                [16.252499, 43.05971],
                [16.211388, 43.024719],
                [16.20833, 43.022217000000126],
              ],
            ],
            [
              [
                [16.562035, 43.23085],
                [16.57764200000014, 43.21301],
                [16.595482, 43.218216],
                [16.613331, 43.21388],
                [16.64751, 43.2167280000001],
                [16.660145000000114, 43.211525],
                [16.66222, 43.200272],
                [16.690619, 43.18254100000013],
                [16.699537000000134, 43.166187],
                [16.7196, 43.161728],
                [16.811108, 43.161385],
                [16.961388000000113, 43.149162],
                [17.116386, 43.13611],
                [17.15664, 43.137943],
                [17.19008300000013, 43.126053],
                [17.16407, 43.120106],
                [17.109997000000135, 43.116386],
                [17.057777, 43.112495],
                [16.879719, 43.12055],
                [16.74785, 43.13125600000012],
                [16.666111, 43.119164],
                [16.654163, 43.11972],
                [16.53389, 43.143608],
                [16.464722, 43.160271],
                [16.43055, 43.16944],
                [16.37861, 43.188889],
                [16.374443, 43.19082600000013],
                [16.373055000000136, 43.194160000000124],
                [16.37611, 43.196663],
                [16.379997, 43.198051],
                [16.457222000000115, 43.210274],
                [16.47583, 43.21194],
                [16.51744, 43.207809],
                [16.561293, 43.181053],
                [16.582102, 43.18402500000013],
                [16.55312, 43.21301],
                [16.524872, 43.22193],
                [16.527845, 43.229362],
                [16.54419700000011, 43.224903],
                [16.550142000000108, 43.23308],
                [16.562035, 43.23085],
              ],
            ],
            [
              [
                [16.851665, 43.26916],
                [16.843052, 43.26666300000011],
                [16.826111, 43.26749400000011],
                [16.793331000000137, 43.268608],
                [16.716389, 43.266106],
                [16.706108, 43.265274],
                [16.687222000000133, 43.26166500000011],
                [16.628887, 43.26194],
                [16.577499, 43.268608],
                [16.519722, 43.276382],
                [16.487778, 43.28527],
                [16.418610000000115, 43.31277],
                [16.410831, 43.316666],
                [16.408054, 43.31916],
                [16.40472, 43.325554],
                [16.40472, 43.32972000000012],
                [16.42639, 43.38916],
                [16.429996, 43.391106],
                [16.436108, 43.390831],
                [16.601109, 43.379166],
                [16.700275, 43.36860700000011],
                [16.753052, 43.362778000000105],
                [16.776108, 43.35944400000011],
                [16.805275, 43.352219],
                [16.80944, 43.350555],
                [16.879719, 43.32166],
                [16.883888, 43.319717],
                [16.886665000000107, 43.31721],
                [16.888611, 43.310272],
                [16.887218, 43.297775],
                [16.851665, 43.26916],
              ],
            ],
            [
              [
                [16.390553, 43.332771],
                [16.377220000000136, 43.329163],
                [16.37167, 43.329994],
                [16.314442, 43.34583],
                [16.20861, 43.382774],
                [16.205830000000105, 43.385277],
                [16.19778, 43.403885000000116],
                [16.19722, 43.40749],
                [16.19833, 43.41166],
                [16.206944, 43.41416],
                [16.239441, 43.4138870000001],
                [16.25194, 43.41277300000013],
                [16.27972000000011, 43.408333],
                [16.326385, 43.394165],
                [16.33055, 43.39222],
                [16.389721000000122, 43.340553000000114],
                [16.391109, 43.33721900000012],
                [16.390553, 43.332771],
              ],
            ],
            [
              [
                [15.687498, 43.630829],
                [15.68444, 43.630554],
                [15.666943, 43.63694],
                [15.640833, 43.65083],
                [15.608889, 43.672218],
                [15.606667, 43.674995],
                [15.61055, 43.67555],
                [15.628054, 43.67333200000013],
                [15.631943, 43.67305],
                [15.662222, 43.665833000000134],
                [15.665554, 43.663887],
                [15.703054, 43.63666500000011],
                [15.687498, 43.630829],
              ],
            ],
            [
              [
                [15.34639, 43.80888],
                [15.376669, 43.775925],
                [15.327776, 43.78999],
                [15.253887, 43.8366620000001],
                [15.242498, 43.845833],
                [15.240276, 43.84861],
                [15.227221, 43.866104],
                [15.225832, 43.869438],
                [15.225, 43.873055],
                [15.227499000000137, 43.876106],
                [15.232498, 43.87666300000012],
                [15.238609, 43.874992],
                [15.250832, 43.860275],
                [15.256388, 43.85527],
                [15.26639, 43.84861],
                [15.293333, 43.836105],
                [15.32361, 43.82471],
                [15.34083, 43.813889],
                [15.34639, 43.80888],
              ],
            ],
            [
              [
                [15.44666500000011, 43.887215],
                [15.442221, 43.88611],
                [15.415, 43.889999],
                [15.409443, 43.89111],
                [15.35111, 43.92638],
                [15.302776, 43.95916000000011],
                [15.262499, 44.002495],
                [15.260832, 44.00666],
                [15.265554, 44.00972000000013],
                [15.271944000000133, 44.010826],
                [15.282776, 44.010277],
                [15.376944, 43.968048],
                [15.383055000000127, 43.963333],
                [15.444721, 43.8975],
                [15.448055, 43.890831],
                [15.44666500000011, 43.887215],
              ],
            ],
            [
              [
                [15.250555, 44.01666300000011],
                [15.244165000000123, 44.0149990000001],
                [15.179165, 44.05055],
                [15.129999000000112, 44.084442],
                [15.069443, 44.13277],
                [15.062222, 44.15361000000013],
                [15.062498000000119, 44.157219],
                [15.067499, 44.15749],
                [15.156111, 44.108887],
                [15.172777, 44.099716000000114],
                [15.243055, 44.05305],
                [15.248333, 44.047775],
                [15.25611, 44.022774],
                [15.250555, 44.01666300000011],
              ],
            ],
            [
              [
                [14.855276, 44.175278000000105],
                [14.992498, 44.083611],
                [15.0214, 44.071758],
                [15.026441, 44.042675000000145],
                [15.03666, 44.026939],
                [15.050278000000105, 44.01388500000013],
                [15.0825, 43.986938],
                [15.085554000000116, 43.98444400000011],
                [15.0947, 43.98243],
                [15.098855, 43.985989],
                [15.118146000000138, 43.976791],
                [15.120223, 43.96462200000013],
                [15.125269, 43.959282],
                [15.143055, 43.95166],
                [15.184328, 43.9263380000001],
                [15.216389, 43.911942],
                [15.222776, 43.907494],
                [15.22639, 43.901108000000136],
                [15.22389, 43.898048],
                [15.217222, 43.890831],
                [15.19417, 43.871109000000104],
                [15.18861, 43.871941],
                [15.179998, 43.87527],
                [15.148333, 43.889999],
                [15.137499, 43.89638500000012],
                [15.108055, 43.919998],
                [15.09972, 43.92749800000013],
                [15.071665, 43.9575],
                [15.05722, 43.973885],
                [15.047222, 43.988884],
                [15.03611, 44.003609],
                [15.028889, 44.01194],
                [14.989443000000108, 44.05555],
                [14.977777000000117, 44.065277],
                [14.97139, 44.07],
                [14.935923000000116, 44.090458],
                [14.916943, 44.109161],
                [14.881943, 44.130272],
                [14.86796, 44.13052],
                [14.860243000000139, 44.12992900000012],
                [14.848966, 44.135567],
                [14.83056, 44.1418],
                [14.821364, 44.14595400000013],
                [14.816319, 44.152782],
                [14.816913, 44.15902],
                [14.821364, 44.16346],
                [14.824630000000127, 44.16317],
                [14.824332, 44.155453],
                [14.835314, 44.14625200000012],
                [14.84511, 44.14595400000013],
                [14.85015, 44.150406],
                [14.860837, 44.143581],
                [14.871387, 44.142776],
                [14.859999, 44.156944000000124],
                [14.85389, 44.166107000000125],
                [14.852499000000137, 44.173607],
                [14.855276, 44.175278000000105],
              ],
            ],
            [
              [
                [14.838655, 44.60950100000014],
                [14.872221, 44.606941],
                [14.87555, 44.609161],
                [14.909166, 44.607773],
                [14.92861, 44.598328],
                [14.96027800000013, 44.579163],
                [14.969755, 44.558628],
                [14.98815500000012, 44.542011],
                [15.00834, 44.53281],
                [15.039999000000137, 44.525551],
                [15.043055, 44.523048],
                [15.047499, 44.51722000000012],
                [15.07305, 44.481941],
                [15.074999, 44.478882],
                [15.07222, 44.477219000000105],
                [15.062498000000119, 44.47972],
                [15.054443000000106, 44.48360400000013],
                [15.037718, 44.49660100000011],
                [15.017241, 44.499275],
                [15.010832, 44.51416],
                [14.992607, 44.52420400000011],
                [14.97035, 44.528358],
                [14.9469, 44.54557000000011],
                [14.916038, 44.550915],
                [14.914257000000134, 44.542305],
                [14.936219, 44.536964],
                [14.992311, 44.487995],
                [15.058196000000123, 44.42656],
                [15.097668, 44.408161],
                [15.071848000000102, 44.43071700000013],
                [15.050183, 44.44496],
                [15.042764, 44.475533],
                [15.046389, 44.476662],
                [15.051666, 44.476387],
                [15.055832000000123, 44.47472],
                [15.085278, 44.458611],
                [15.116943, 44.43944],
                [15.240555, 44.35027],
                [15.250000000000114, 44.339165],
                [15.251389, 44.33583],
                [15.248888, 44.327774],
                [15.219166, 44.30583],
                [15.174534, 44.318237],
                [15.174166, 44.29610400000013],
                [15.168888, 44.29555],
                [15.140276, 44.303886],
                [15.132500000000107, 44.30778],
                [15.125277, 44.311943],
                [15.10972, 44.32361],
                [15.101665, 44.331383],
                [15.09861, 44.338051],
                [15.091435, 44.367504],
                [15.112210000000118, 44.37225],
                [15.116959000000122, 44.37878],
                [15.102714000000105, 44.38946],
                [15.078971, 44.396587],
                [15.063539, 44.39065],
                [15.035641, 44.39302],
                [15.023499, 44.421051],
                [14.976284, 44.45594],
                [14.907246, 44.480892],
                [14.898672, 44.49375],
                [14.91783, 44.504887],
                [14.74472, 44.675552],
                [14.736666, 44.68777],
                [14.73361, 44.69416],
                [14.73278, 44.698051],
                [14.73499900000013, 44.70027],
                [14.73944, 44.69861],
                [14.745277, 44.69444],
                [14.789049, 44.660946],
                [14.838655, 44.60950100000014],
              ],
            ],
            [
              [
                [14.521944, 44.474159],
                [14.516666, 44.473328],
                [14.51111, 44.474159],
                [14.367498000000126, 44.59027100000014],
                [14.347776, 44.655273000000136],
                [14.336111, 44.699165],
                [14.335278, 44.707222],
                [14.3375, 44.710274],
                [14.343332, 44.710274],
                [14.380554, 44.69778],
                [14.384998, 44.696106],
                [14.39083, 44.691383],
                [14.39305, 44.688332],
                [14.395277000000135, 44.681389],
                [14.395555, 44.67305],
                [14.39389, 44.659439],
                [14.39416, 44.62999700000012],
                [14.39667, 44.623055],
                [14.407221, 44.60388200000011],
                [14.416111, 44.59221600000012],
                [14.42639, 44.581665],
                [14.476665, 44.53583],
                [14.489721, 44.526665],
                [14.50417, 44.522499],
                [14.515833, 44.51249700000011],
                [14.530554, 44.497772],
                [14.534443, 44.491661],
                [14.534443, 44.487495],
                [14.529999, 44.477219000000105],
                [14.521944, 44.474159],
              ],
            ],
            [
              [
                [14.757311, 44.80375300000014],
                [14.778726, 44.79248],
                [14.825219, 44.762333],
                [14.861944, 44.72166],
                [14.865276, 44.7066650000001],
                [14.861111, 44.705276],
                [14.846666000000141, 44.702499],
                [14.840832, 44.703331000000105],
                [14.836666, 44.704994],
                [14.74111, 44.762772],
                [14.699828, 44.764023],
                [14.65925, 44.794735],
                [14.687993, 44.79530000000011],
                [14.699828, 44.806572],
                [14.726944, 44.79722],
                [14.710278, 44.820274],
                [14.695276, 44.829437],
                [14.686666, 44.836937],
                [14.684999, 44.840271],
                [14.68694, 44.84333],
                [14.72361, 44.853333000000134],
                [14.74499900000012, 44.8475],
                [14.758888, 44.83861],
                [14.757311, 44.80375300000014],
              ],
            ],
            [
              [
                [14.455074, 44.909698000000105],
                [14.445271, 44.87865],
                [14.45944, 44.8274990000001],
                [14.46569, 44.809216000000106],
                [14.459159, 44.780621],
                [14.473864000000106, 44.760197],
                [14.47055, 44.740555],
                [14.475497, 44.700562],
                [14.506388000000129, 44.67083],
                [14.52916, 44.640274],
                [14.531387, 44.63333100000011],
                [14.529999, 44.630554],
                [14.518332, 44.615273],
                [14.51528, 44.612778],
                [14.493332, 44.606384],
                [14.488054, 44.605827],
                [14.483889, 44.607773],
                [14.451111, 44.626389],
                [14.38944400000014, 44.695],
                [14.388902, 44.73242],
                [14.3742, 44.74876],
                [14.365211, 44.797775],
                [14.331388, 44.849716],
                [14.316195, 44.886822],
                [14.294137, 44.9072460000001],
                [14.29659, 44.93175500000012],
                [14.308842, 44.947277],
                [14.339443, 44.91722],
                [14.343332, 44.91499],
                [14.359165, 44.907776],
                [14.365, 44.906944],
                [14.387499, 44.90583],
                [14.39277600000014, 44.906662],
                [14.396944, 44.908051000000114],
                [14.399166, 44.91111],
                [14.400276, 44.91528],
                [14.3925, 44.95611],
                [14.357222, 45.0386],
                [14.353888, 45.04527300000012],
                [14.35166500000014, 45.04833200000013],
                [14.343054, 45.05555],
                [14.339167, 45.05778],
                [14.32111, 45.06388900000013],
                [14.313889, 45.06805400000013],
                [14.308054, 45.073051],
                [14.27528, 45.103333],
                [14.273611, 45.11499800000013],
                [14.273333, 45.119164],
                [14.27611, 45.126663],
                [14.305832, 45.167496],
                [14.31167, 45.172775000000115],
                [14.315277, 45.174995],
                [14.32, 45.175827],
                [14.34833, 45.168327],
                [14.35778, 45.16527600000012],
                [14.363609, 45.16055300000011],
                [14.36972, 45.151382],
                [14.368610000000103, 45.147217],
                [14.365, 45.145271],
                [14.362221, 45.142494],
                [14.358055, 45.136108],
                [14.353888, 45.119164],
                [14.358889, 45.101105],
                [14.376944, 45.052498],
                [14.41, 45.004715],
                [14.418888, 44.99305],
                [14.42639, 44.98472],
                [14.464061, 44.9824],
                [14.476315, 44.95953],
                [14.462426, 44.950542],
                [14.455074, 44.909698000000105],
              ],
            ],
            [
              [
                [14.755833, 44.941383],
                [14.73361, 44.939995000000124],
                [14.721388, 44.940277],
                [14.69833, 44.947777],
                [14.643055, 44.966942],
                [14.638611, 44.96860500000014],
                [14.56291, 45.01998],
                [14.486944, 45.033333],
                [14.47972, 45.037498],
                [14.46361, 45.04805],
                [14.439444, 45.067497],
                [14.433332, 45.072495],
                [14.428888, 45.07833],
                [14.428055, 45.0861],
                [14.429165, 45.090271],
                [14.46406, 45.12455],
                [14.523697, 45.144974],
                [14.53916, 45.23944100000011],
                [14.549166, 45.246109000000104],
                [14.5525, 45.248329000000126],
                [14.557777, 45.24805],
                [14.583055, 45.241943],
                [14.588055, 45.240555],
                [14.59166, 45.238609],
                [14.595554, 45.232216],
                [14.657776, 45.12277],
                [14.704166, 45.068329],
                [14.7925, 45.009163],
                [14.80666, 44.99638],
                [14.813332, 44.987778],
                [14.815554, 44.98055],
                [14.814444, 44.97666],
                [14.804998, 44.969444000000124],
                [14.760555, 44.942497],
                [14.755833, 44.941383],
              ],
            ],
            [
              [
                [16.5725, 46.475273],
                [16.584721, 46.473053],
                [16.599258, 46.47496],
                [16.6078720000001, 46.476234],
                [16.628609, 46.47499800000014],
                [16.66111, 46.465553000000114],
                [16.80139, 46.391388],
                [16.840553, 46.369995],
                [16.866108, 46.355827],
                [16.873886, 46.346939000000134],
                [16.87833, 46.34111000000013],
                [16.878887000000134, 46.337494],
                [16.879025, 46.308571],
                [16.880577, 46.304504],
                [16.889999000000103, 46.284996],
                [16.892776, 46.28249],
                [16.91972, 46.259995],
                [16.937771, 46.249451],
                [16.973053, 46.23360400000013],
                [17.04027600000012, 46.214165],
                [17.14971900000012, 46.181664000000126],
                [17.153889, 46.179993],
                [17.157497, 46.177773],
                [17.179996, 46.15721900000011],
                [17.185555000000136, 46.151939],
                [17.23, 46.097221],
                [17.239441, 46.083611],
                [17.254719, 46.053329],
                [17.25861, 46.023048],
                [17.255554, 46.02055],
                [17.256943, 46.01722],
                [17.311386, 45.975273],
                [17.351109, 45.953331],
                [17.358608, 45.949997],
                [17.389442, 45.938049],
                [17.418053, 45.934715],
                [17.423332, 45.934441000000106],
                [17.431664, 45.937218],
                [17.43472, 45.93972],
                [17.434166, 45.94360400000011],
                [17.432858, 45.94542700000011],
                [17.427776, 45.9525],
                [17.458611, 45.954437],
                [17.576664, 45.94055],
                [17.585278, 45.93694],
                [17.591663, 45.93222],
                [17.62611, 45.90583],
                [17.64027, 45.89305100000013],
                [17.649441000000138, 45.87749],
                [17.652695, 45.853134000000125],
                [17.65721900000011, 45.84083],
                [17.66, 45.83833],
                [17.669441, 45.835],
                [17.880833, 45.783882],
                [18.00639, 45.786942],
                [18.153332, 45.787216],
                [18.189163, 45.784439],
                [18.201942, 45.783333],
                [18.220833, 45.78110500000014],
                [18.230831, 45.778328],
                [18.23805, 45.773888],
                [18.242775, 45.768326],
                [18.25055300000014, 45.764442],
                [18.260830000000112, 45.762497],
                [18.32944, 45.754715],
                [18.335831, 45.75417],
                [18.407497, 45.748329],
                [18.424164, 45.749161],
                [18.443333, 45.752777],
                [18.551666, 45.79833200000013],
                [18.559444, 45.801666000000125],
                [18.595276, 45.825554],
                [18.601665, 45.83027600000014],
                [18.614719, 45.845833],
                [18.62222, 45.856941],
                [18.715553000000114, 45.913605],
                [18.723331, 45.90944],
                [18.78, 45.894722],
                [18.807499, 45.902771],
                [18.817020000000127, 45.91296],
                [18.831654, 45.877129],
                [18.833054, 45.873886],
                [18.88305, 45.828888],
                [18.88972, 45.824997],
                [18.90361, 45.82027],
                [18.90888600000011, 45.81944],
                [18.924442, 45.811943],
                [18.955276, 45.784721],
                [18.957489, 45.781944],
                [18.95861, 45.77861],
                [18.96948, 45.671616],
                [18.969166, 45.667496],
                [18.968357, 45.66301700000014],
                [18.960552, 45.65416],
                [18.939163, 45.630829],
                [18.933609, 45.62527],
                [18.912498, 45.623329000000126],
                [18.909458, 45.620758],
                [18.907215, 45.613281],
                [18.90083, 45.5774990000001],
                [18.902496, 45.570274],
                [18.904785, 45.56728],
                [18.925346000000104, 45.54784400000011],
                [18.933018, 45.541855],
                [18.942181, 45.53868100000011],
                [18.955269, 45.537186],
                [18.965366, 45.53868100000011],
                [18.973969, 45.5413],
                [18.99694, 45.558052],
                [18.999771000000123, 45.561119],
                [19.003887000000134, 45.562492],
                [19.01416, 45.563889],
                [19.02052300000014, 45.56298800000013],
                [19.024719, 45.561386],
                [19.09587, 45.521851],
                [19.099987, 45.515869],
                [19.101673, 45.50895],
                [19.0998, 45.49979],
                [19.094753, 45.493805],
                [19.08784, 45.48950200000013],
                [19.07389, 45.486107],
                [19.057545, 45.48558],
                [19.051666000000125, 45.48666],
                [19.0425, 45.4897160000001],
                [19.030621, 45.49548],
                [19.02052300000014, 45.49866500000013],
                [19.010239, 45.49717],
                [19, 45.49083],
                [18.997711, 45.48745],
                [18.996387, 45.48333],
                [18.978054, 45.389717],
                [18.98032400000011, 45.378624],
                [18.98860900000011, 45.370827],
                [19.1125, 45.29805],
                [19.138611, 45.2875],
                [19.190205, 45.270332],
                [19.260521, 45.247429],
                [19.285004, 45.2434080000001],
                [19.320339, 45.2383650000001],
                [19.34446, 45.235001000000125],
                [19.356667, 45.234161],
                [19.38896, 45.235748000000115],
                [19.400093, 45.23583200000013],
                [19.418331, 45.234718],
                [19.423885, 45.22583],
                [19.426109, 45.21],
                [19.42444, 45.18916],
                [19.422775, 45.179993],
                [19.41583, 45.175827],
                [19.41111, 45.174995],
                [19.3525, 45.173332],
                [19.261665, 45.180275],
                [19.250832000000116, 45.182777],
                [19.24722, 45.18471],
                [19.234997000000135, 45.198883],
                [19.21833, 45.208332],
                [19.207331, 45.2116620000001],
                [19.187496, 45.216942],
                [19.171108, 45.216385],
                [19.163609, 45.212219],
                [19.104164, 45.09666],
                [19.115555, 45.031944],
                [19.05083100000013, 44.928055],
                [19.04305, 44.931664],
                [19.036663, 44.932495],
                [19.0325, 44.93083200000012],
                [19.013611, 44.916664],
                [19.01083, 44.91416],
                [19.00611, 44.907776],
                [19.004444, 44.904442],
                [19.004719, 44.900276],
                [19.00944, 44.894440000000145],
                [19.015831, 44.889442000000145],
                [19.02861, 44.880272000000105],
                [19.039719, 44.86138],
                [19.02972000000011, 44.860275],
                [18.96833, 44.853607],
                [18.957222, 44.85305],
                [18.861111000000108, 44.85860400000013],
                [18.849998, 44.860832],
                [18.841389, 44.863609],
                [18.834442, 44.86805],
                [18.794167, 44.894997],
                [18.788055, 44.89971900000012],
                [18.768055, 44.915833],
                [18.761108, 44.938889],
                [18.763885, 44.945],
                [18.773609, 44.944443],
                [18.780552, 44.940277],
                [18.79, 44.938889],
                [18.797775000000115, 44.94221],
                [18.800831, 44.949715],
                [18.79583, 44.989998],
                [18.794167, 44.99721],
                [18.634163, 45.083328],
                [18.41917, 45.108887],
                [18.269722, 45.136665],
                [18.25194, 45.138885],
                [18.233055, 45.135826],
                [18.216663, 45.12971],
                [18.211388, 45.123329],
                [18.210278, 45.114716],
                [18.212776000000133, 45.107773],
                [18.2175, 45.102219000000105],
                [18.218052, 45.095276],
                [18.212776000000133, 45.088882],
                [18.205555, 45.084999],
                [18.197498, 45.0816650000001],
                [18.179165, 45.077774],
                [18.166943, 45.07861],
                [18.130276, 45.082222],
                [18.119999, 45.083328],
                [18.110832, 45.0861],
                [18.070274, 45.104439],
                [17.93305, 45.08027600000014],
                [17.912498, 45.06805400000013],
                [17.87361, 45.050278],
                [17.863888, 45.04833200000013],
                [17.851944, 45.04943800000012],
                [17.832775, 45.05555],
                [17.75805300000013, 45.086662],
                [17.689999, 45.12277],
                [17.596386, 45.108887],
                [17.51955, 45.109512],
                [17.494164000000126, 45.109993],
                [17.48389, 45.111107],
                [17.484444, 45.11805],
                [17.48111, 45.13110400000011],
                [17.2825, 45.176384],
                [17.246666, 45.153053],
                [17.24055, 45.148605],
                [17.230553, 45.14666000000011],
                [17.188332, 45.148048],
                [17.177219, 45.148605],
                [17.07111, 45.188332000000116],
                [17.049999, 45.20138500000013],
                [17.043610000000115, 45.206108],
                [17.04027600000012, 45.212494],
                [17.036388000000102, 45.227219],
                [16.913925, 45.26594],
                [16.846436, 45.20203],
                [16.846882, 45.198456],
                [16.845989, 45.194435],
                [16.838390000000118, 45.190414],
                [16.82444, 45.187492],
                [16.812496000000124, 45.187492],
                [16.682777, 45.20499400000011],
                [16.662777, 45.210274],
                [16.629662, 45.22081],
                [16.60195, 45.230194],
                [16.58988, 45.230194],
                [16.54116, 45.227066],
                [16.530437, 45.22617300000013],
                [16.526386, 45.224442],
                [16.508537000000103, 45.21455],
                [16.50228, 45.20963300000011],
                [16.476387000000102, 45.18583],
                [16.417805, 45.12426],
                [16.366402, 45.04202],
                [16.3597, 45.016548],
                [16.35702, 45.00849900000014],
                [16.35121, 45.003586],
                [16.342712, 45.0009],
                [16.291759, 44.999115],
                [16.26388, 45.00833100000011],
                [16.248055, 45.0149990000001],
                [16.220276, 45.02833],
                [16.209721, 45.034439],
                [16.19722, 45.044441],
                [16.116108, 45.12166600000012],
                [16.109444, 45.13082900000012],
                [16.03611, 45.205826],
                [16.023052, 45.214996],
                [16.015274, 45.21833],
                [15.936666000000116, 45.228607],
                [15.924999, 45.22805],
                [15.8825, 45.2225],
                [15.834166, 45.21194],
                [15.823332, 45.205276],
                [15.81111, 45.195549],
                [15.802500000000123, 45.18805],
                [15.794167, 45.179993],
                [15.786665, 45.171944],
                [15.781111, 45.161942000000124],
                [15.76555, 45.082222],
                [15.76472, 45.07361],
                [15.764999, 45.056389],
                [15.769165, 44.92277],
                [15.743610000000103, 44.82999400000011],
                [15.738888, 44.82416500000011],
                [15.736387, 44.81694],
                [15.736944000000108, 44.812492],
                [15.742222, 44.803604],
                [15.759998, 44.783882],
                [15.7675, 44.776108],
                [15.854721, 44.71444],
                [15.85889, 44.712494000000106],
                [15.864166, 44.71138800000011],
                [15.874998, 44.710274],
                [15.92861, 44.71221900000012],
                [15.939444, 44.710548],
                [15.943888, 44.708611],
                [15.956944000000135, 44.69999700000011],
                [15.961666, 44.693886],
                [16.010555, 44.616943],
                [16.03333, 44.574165],
                [16.07416, 44.530548000000124],
                [16.111664, 44.51138300000014],
                [16.119164000000126, 44.50694],
                [16.126389, 44.498604000000114],
                [16.133331000000112, 44.48610700000012],
                [16.198055, 44.353607000000125],
                [16.19194, 44.31388900000013],
                [16.14333, 44.20416],
                [16.14305, 44.19944],
                [16.14555, 44.196663],
                [16.15, 44.194443],
                [16.16, 44.192772],
                [16.172222, 44.192215],
                [16.199165, 44.195274],
                [16.214443, 44.197495],
                [16.238052, 44.198326],
                [16.249294, 44.19673200000011],
                [16.265, 44.189438],
                [16.280277, 44.176941],
                [16.302219, 44.157219],
                [16.309444, 44.148605],
                [16.31694, 44.135826],
                [16.322498, 44.122215],
                [16.323055, 44.11805],
                [16.32972, 44.104164],
                [16.338886, 44.09333],
                [16.35472, 44.08166],
                [16.415554, 44.043327],
                [16.426666, 44.036942],
                [16.438889, 44.031944],
                [16.463608, 44.026665],
                [16.504719, 44.02304800000013],
                [16.516109, 44.021942],
                [16.52972, 44.017776],
                [16.53722, 44.013611],
                [16.6425, 43.916382],
                [16.650276000000133, 43.908051000000114],
                [16.696663, 43.85611],
                [16.70138500000013, 43.85055],
                [16.707222, 43.84111],
                [16.711941, 43.82638500000013],
                [16.82972, 43.725555],
                [16.937496, 43.621666],
                [16.95583, 43.603333],
                [16.97639, 43.586105],
                [17.04639, 43.54055000000011],
                [17.05972, 43.531944],
                [17.071388, 43.526382],
                [17.098331000000144, 43.51361],
                [17.114998, 43.50694],
                [17.160275, 43.497772],
                [17.223331, 43.47805],
                [17.247776, 43.46833],
                [17.261665000000107, 43.459717000000126],
                [17.269444, 43.451942],
                [17.271111, 43.448608],
                [17.271942, 43.444443],
                [17.270275, 43.436386],
                [17.26194, 43.42860400000012],
                [17.25722100000013, 43.422775],
                [17.25611, 43.414444],
                [17.277222, 43.332771],
                [17.27916, 43.32527],
                [17.285553, 43.30722],
                [17.289719, 43.296944],
                [17.298054, 43.28083],
                [17.309444, 43.270554],
                [17.43472, 43.179443000000106],
                [17.55916600000012, 43.11777500000011],
                [17.571388000000127, 43.112221],
                [17.589443, 43.102219000000105],
                [17.63028, 43.07694],
                [17.643055, 43.063889],
                [17.649719, 43.054993],
                [17.659164, 43.039444],
                [17.664719, 43.02916],
                [17.670555, 43.016663],
                [17.680832, 42.992775],
                [17.688015, 42.9746090000001],
                [17.683609000000104, 42.967216],
                [17.676666000000125, 42.963333],
                [17.668331, 42.960548],
                [17.578526, 42.94382],
                [17.533054, 42.947495],
                [17.51916, 42.951942],
                [17.511665, 42.955826000000116],
                [17.487778, 42.97499800000014],
                [17.47361, 42.98749500000014],
                [17.471664, 42.990555],
                [17.470554, 43.017776],
                [17.454998000000103, 43.033333],
                [17.33027600000014, 43.11444100000011],
                [17.32278, 43.118332],
                [17.25166, 43.15416],
                [17.2225, 43.161385],
                [17.18305, 43.17166],
                [17.178886, 43.173332],
                [17.174721, 43.175278000000105],
                [17.131386, 43.198883],
                [17.073055000000124, 43.23389],
                [17.06333, 43.248055],
                [17.049164, 43.268608],
                [17.040833, 43.276382],
                [16.939999, 43.364716],
                [16.88444, 43.403053],
                [16.878887000000134, 43.40416],
                [16.86083, 43.405273],
                [16.83805500000011, 43.405273],
                [16.81361, 43.406944000000124],
                [16.764164, 43.411385],
                [16.736385, 43.416107000000125],
                [16.64, 43.44028],
                [16.63555, 43.44194],
                [16.618889, 43.448883],
                [16.499165, 43.503052],
                [16.465553, 43.5283280000001],
                [16.473053000000107, 43.531944],
                [16.473053000000107, 43.534996],
                [16.465275000000133, 43.53889],
                [16.433331000000123, 43.545273],
                [16.427776, 43.546104],
                [16.359722, 43.550827],
                [16.348331000000144, 43.550827],
                [16.310276, 43.543053],
                [16.190552, 43.511665],
                [16.17055, 43.495827],
                [16.169998, 43.488052],
                [16.116108, 43.476662],
                [16.105831, 43.47555],
                [16.094444, 43.47555],
                [16.039444, 43.48111],
                [16.034443000000124, 43.482498000000135],
                [15.988333, 43.50444],
                [15.926666000000125, 43.556664],
                [15.9175, 43.56832900000012],
                [15.91555, 43.571388],
                [15.91528, 43.622772],
                [15.91528, 43.626938],
                [15.917221, 43.630554],
                [15.922222, 43.631104],
                [15.931389, 43.62805200000014],
                [15.936943, 43.62722],
                [15.957777000000135, 43.62916600000011],
                [15.967499, 43.630829],
                [15.96917, 43.63361],
                [15.940832, 43.683609000000104],
                [15.787498, 43.754997],
                [15.783333, 43.756660000000124],
                [15.778889, 43.756660000000124],
                [15.688889, 43.77888],
                [15.599443, 43.84528],
                [15.533888, 43.88194],
                [15.533054, 43.88972],
                [15.530832, 43.89277600000014],
                [15.520128000000113, 43.898834],
                [15.49694, 43.91027100000014],
                [15.484999, 43.915833],
                [15.463055, 43.919716],
                [15.451944, 43.925552],
                [15.405554000000109, 43.96527],
                [15.281666, 44.073051],
                [15.23222, 44.119164],
                [15.151667, 44.196388],
                [15.157914, 44.22119],
                [15.11333, 44.26028],
                [15.113888, 44.263885],
                [15.12083200000012, 44.278053000000114],
                [15.123888, 44.28083],
                [15.138332, 44.283333],
                [15.14333, 44.282219],
                [15.146944, 44.279999],
                [15.151943, 44.27472],
                [15.174534, 44.24612000000013],
                [15.203888, 44.25499700000012],
                [15.206587, 44.263927],
                [15.18878, 44.285294],
                [15.208367, 44.2847],
                [15.213116, 44.29242],
                [15.23211, 44.282921],
                [15.284166, 44.246666],
                [15.289444, 44.24721],
                [15.292221, 44.24971800000014],
                [15.29361, 44.25361],
                [15.292776, 44.2575],
                [15.28, 44.30583],
                [15.261788, 44.32447100000013],
                [15.268910000000119, 44.330406],
                [15.287905, 44.32387],
                [15.34189, 44.28749],
                [15.385055, 44.270164],
                [15.414444, 44.25999500000012],
                [15.50611, 44.25416600000011],
                [15.522778, 44.254715],
                [15.527498, 44.255829],
                [15.529999, 44.258888],
                [15.529722, 44.263054],
                [15.52611, 44.269440000000145],
                [15.520555, 44.274437],
                [15.515554, 44.275551],
                [15.503332, 44.276108000000136],
                [15.48139, 44.274994],
                [15.475832, 44.276108000000136],
                [15.451111, 44.282494],
                [15.44611, 44.28388],
                [15.27667, 44.364441],
                [15.264444, 44.373886],
                [15.181665, 44.438606],
                [15.14083, 44.473053],
                [15.095833, 44.51805100000013],
                [15.025276, 44.56360600000011],
                [15.020277, 44.564995000000124],
                [15.00861, 44.56472],
                [15.000832, 44.56860400000011],
                [14.990555, 44.579437],
                [14.975832000000139, 44.596107],
                [14.966389, 44.60721600000011],
                [14.926388, 44.654999],
                [14.896111000000133, 44.69194],
                [14.893332, 44.69861],
                [14.888611, 44.712494000000106],
                [14.88694, 44.71999],
                [14.87889, 44.805275],
                [14.878332, 44.81749700000012],
                [14.87805, 44.83833],
                [14.879166, 44.851662],
                [14.881943, 44.859161],
                [14.891943, 44.88611],
                [14.896111000000133, 44.89277600000014],
                [14.907776, 44.908051000000114],
                [14.911388000000102, 44.91499],
                [14.91917, 44.949165],
                [14.920832, 44.966942],
                [14.91861, 44.973885],
                [14.8425, 45.11166400000013],
                [14.839443, 45.114166],
                [14.824999000000105, 45.11749300000014],
                [14.81916600000011, 45.11833200000012],
                [14.800278, 45.123055],
                [14.757500000000107, 45.134163000000115],
                [14.748055, 45.137215],
                [14.732222, 45.14444],
                [14.717499, 45.15277100000014],
                [14.674444, 45.18222000000014],
                [14.585, 45.25222],
                [14.482777, 45.311104],
                [14.4558320000001, 45.319160000000124],
                [14.441387, 45.323326],
                [14.329443, 45.354439],
                [14.324999, 45.353333],
                [14.318888000000129, 45.34805300000011],
                [14.292776, 45.32499700000011],
                [14.288055, 45.318886],
                [14.282776, 45.30805],
                [14.253887, 45.231941],
                [14.246944, 45.2074970000001],
                [14.245832, 45.203331],
                [14.250000000000114, 45.188889],
                [14.23972, 45.16416],
                [14.231667, 45.145828],
                [14.23, 45.142494],
                [14.21666, 45.123329],
                [14.176388, 45.085548],
                [14.169722, 45.080826],
                [14.16528, 45.07972000000012],
                [14.15416, 45.079994],
                [14.153889, 45.07222],
                [14.155832, 45.03944400000012],
                [14.16555, 45.002495],
                [14.166801000000135, 45],
                [14.16889, 44.995827],
                [14.170555, 44.988609],
                [14.16694, 44.981384],
                [14.148611, 44.96416],
                [14.145832, 44.961662],
                [14.14138800000012, 44.961388],
                [14.0875, 44.961388],
                [13.997499, 44.89638500000012],
                [13.992222, 44.88472],
                [13.976387, 44.84888],
                [13.975277, 44.844994],
                [13.974998, 44.825272],
                [13.97666500000014, 44.822777],
                [13.994165, 44.818054],
                [13.996387, 44.815277],
                [13.997221, 44.811386],
                [13.995554, 44.808052],
                [13.91222, 44.770554],
                [13.907221000000106, 44.770828],
                [13.899166, 44.77444],
                [13.820833, 44.85443900000013],
                [13.813055, 44.865829],
                [13.82944300000014, 44.866104],
                [13.842222, 44.876106],
                [13.84333, 44.879997],
                [13.841665, 44.883331],
                [13.756943, 44.981384],
                [13.68111, 45.051384],
                [13.60305, 45.157776],
                [13.595554, 45.24721],
                [13.594444, 45.254166],
                [13.575832, 45.30028],
                [13.533609, 45.401665],
                [13.496387, 45.49083],
                [13.504444, 45.504166],
                [13.50722, 45.506660000000124],
                [13.51111, 45.506386],
                [13.555, 45.494438],
                [13.59174000000013, 45.481697],
                [13.595276000000126, 45.477776],
                [13.607498000000135, 45.468605],
                [13.626944, 45.45888500000012],
                [13.63944400000014, 45.453888],
                [13.647778, 45.45111],
                [13.668055, 45.44639],
                [13.678888, 45.445],
                [13.703609000000142, 45.44416],
                [13.906944000000124, 45.453331],
                [13.952499000000103, 45.456665],
                [13.98139, 45.45888500000012],
                [13.986666, 45.46],
                [13.989166000000125, 45.462776],
                [13.995832, 45.471939],
                [14.13722, 45.475273],
                [14.387499, 45.485275],
                [14.3975, 45.486938],
                [14.407221, 45.489166],
                [14.41972, 45.494164],
                [14.485832, 45.529716],
                [14.495832, 45.541664],
                [14.501389, 45.551666],
                [14.535, 45.612221],
                [14.562498, 45.661659],
                [14.564999, 45.664993],
                [14.57694400000014, 45.669441],
                [14.60139, 45.675278],
                [14.606667, 45.67443800000012],
                [14.609722, 45.671944],
                [14.61167, 45.669167],
                [14.612221, 45.664162],
                [14.609444, 45.63916000000012],
                [14.609722, 45.62693800000011],
                [14.615555, 45.617218],
                [14.62611, 45.606941],
                [14.72361, 45.531387],
                [14.818054000000132, 45.46611],
                [14.82297, 45.46476700000011],
                [14.831673, 45.465454],
                [14.863714, 45.468658],
                [14.907776, 45.476662],
                [14.91132, 45.4785],
                [14.91361, 45.481667],
                [14.918644, 45.493149],
                [14.9790670000001, 45.500473],
                [15.090555, 45.47277100000014],
                [15.0935, 45.47026100000011],
                [15.150555, 45.431938],
                [15.162794, 45.42664],
                [15.174458, 45.425819],
                [15.277222, 45.462776],
                [15.306358, 45.534805],
                [15.30416, 45.53777300000013],
                [15.30267700000013, 45.54097],
                [15.294, 45.594536],
                [15.307089000000133, 45.6298680000001],
                [15.352591, 45.651756],
                [15.368055, 45.702774],
                [15.367498, 45.70694],
                [15.365555, 45.709717],
                [15.358610000000112, 45.714439],
                [15.34833, 45.715553],
                [15.30416, 45.706383],
                [15.305, 45.698051],
                [15.305, 45.693886],
                [15.302776, 45.69083],
                [15.29417, 45.68777],
                [15.28972, 45.689163],
                [15.283333, 45.694717],
                [15.28083, 45.701385],
                [15.281666, 45.705826000000116],
                [15.291943, 45.731110000000115],
                [15.29611, 45.73749500000014],
                [15.309166, 45.751938],
                [15.322498, 45.761383],
                [15.333887, 45.76638800000012],
                [15.49944, 45.835831],
                [15.602777, 45.84861000000012],
                [15.60944, 45.84861000000012],
                [15.61472, 45.8475],
                [15.620277, 45.842216],
                [15.624722, 45.836662],
                [15.634722, 45.82972],
                [15.646387, 45.823883],
                [15.650833, 45.823051],
                [15.656666, 45.82332600000012],
                [15.694443, 45.84194200000013],
                [15.697777, 45.84416],
                [15.72444, 45.93860600000011],
                [15.719444, 46.038887],
                [15.718332, 46.0472180000001],
                [15.714722, 46.053604],
                [15.711666, 46.05583],
                [15.706944, 46.057495],
                [15.679165, 46.065826],
                [15.661388000000102, 46.06721],
                [15.656944000000124, 46.06944],
                [15.636389, 46.082222],
                [15.629444, 46.086937],
                [15.606388, 46.11582900000013],
                [15.599722, 46.142494],
                [15.60111, 46.14611100000013],
                [15.611944, 46.166939],
                [15.649166, 46.213882],
                [15.65472, 46.219444],
                [15.661388000000102, 46.22388],
                [15.67139, 46.226387],
                [15.676666, 46.226662],
                [15.695276, 46.225273],
                [15.797777, 46.23333],
                [16.01722, 46.29805],
                [16.07777, 46.32888800000012],
                [16.08111, 46.33111],
                [16.083332, 46.33416],
                [16.079441, 46.349998],
                [16.0775, 46.352776],
                [16.07416, 46.363609],
                [16.074718, 46.37249800000012],
                [16.07592, 46.384331],
                [16.135830000000112, 46.40527],
                [16.139999, 46.40666],
                [16.266109000000142, 46.419441],
                [16.25, 46.486107],
                [16.24944, 46.49027],
                [16.251858, 46.498924],
                [16.258331, 46.506943],
                [16.2675, 46.514442],
                [16.292507000000114, 46.53081500000013],
                [16.335552, 46.533882],
                [16.38416, 46.53583],
                [16.461388, 46.52166],
                [16.466389000000106, 46.520271],
                [16.49361, 46.510551],
                [16.495831, 46.5075],
                [16.494438, 46.50332600000013],
                [16.498055, 46.501389],
                [16.517792, 46.491646],
                [16.556412, 46.47890500000011],
                [16.5725, 46.475273],
              ],
            ],
          ],
        },
        id: 16,
        NAME: 'Croatia',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Lithuania',
          id: 17,
          label: 'Lithuania',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.124,
          year: '2023',
          centroid: [23.8813, 55.1694],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [21.044441, 55.32638500000013],
                [20.984814, 55.27655],
                [20.942833, 55.287201],
                [20.982773, 55.330826],
                [21.002499, 55.352493],
                [21.039440000000127, 55.40082600000011],
                [21.04472, 55.411659],
                [21.049999, 55.422493000000145],
                [21.064442, 55.45166],
                [21.083054000000118, 55.499718],
                [21.088608, 55.514717],
                [21.09249, 55.53110500000014],
                [21.09444, 55.548882],
                [21.09583, 55.594154],
                [21.096386, 55.665268],
                [21.095276, 55.67832900000013],
                [21.09249, 55.703323000000125],
                [21.0883290000001, 55.718048],
                [21.09, 55.719986],
                [21.097218, 55.714714],
                [21.10944, 55.703606],
                [21.114998000000128, 55.697487],
                [21.122498, 55.688324],
                [21.127773, 55.677773000000116],
                [21.13472, 55.629158],
                [21.128052, 55.574997],
                [21.10305, 55.42083],
                [21.04888, 55.333054],
                [21.044441, 55.32638500000013],
              ],
            ],
            [
              [
                [25.000000000000114, 56.29555],
                [25.072498, 56.219154],
                [25.08111, 56.210548],
                [25.096943, 56.2011],
                [25.106106, 56.197212],
                [25.133884, 56.188881],
                [25.145828, 56.186104000000114],
                [25.160275000000127, 56.184433],
                [25.18305, 56.183327],
                [25.262497, 56.180824],
                [25.327496, 56.16916],
                [25.429718, 56.166382],
                [25.582775, 56.151382000000126],
                [25.696941, 56.115273000000116],
                [25.699162, 56.10804700000011],
                [25.704994000000113, 56.098045],
                [25.707771, 56.09499],
                [25.714996, 56.08998900000012],
                [25.891106, 55.99943500000012],
                [25.932217, 55.980545],
                [25.942219000000136, 55.97694],
                [25.996384, 55.959717000000126],
                [26.01427500000011, 55.955154],
                [26.058331, 55.93804200000011],
                [26.19083000000012, 55.86749300000014],
                [26.20166, 55.859993],
                [26.210827, 55.85166],
                [26.221939000000134, 55.83999],
                [26.239162, 55.818886],
                [26.240273, 55.814995],
                [26.256943, 55.78472],
                [26.263332, 55.775269],
                [26.268887, 55.76944],
                [26.275276, 55.76416000000012],
                [26.313332, 55.73972],
                [26.338608000000136, 55.72637900000012],
                [26.35833, 55.71888],
                [26.375553, 55.714157],
                [26.498329000000126, 55.686378],
                [26.51083, 55.683876],
                [26.53138700000011, 55.68082400000014],
                [26.57527, 55.676102],
                [26.59138, 55.67499500000014],
                [26.613209, 55.674835],
                [26.620831, 55.661934],
                [26.624439, 55.642769],
                [26.62916, 55.605827],
                [26.62916, 55.601662],
                [26.62666, 55.593048],
                [26.526665, 55.44694],
                [26.457218000000125, 55.349716],
                [26.455551, 55.345543],
                [26.45583, 55.34138],
                [26.45916, 55.338882000000126],
                [26.472771, 55.3336],
                [26.505833, 55.323883],
                [26.528885, 55.317772],
                [26.554718, 55.313049],
                [26.56694, 55.314713],
                [26.619164, 55.329437],
                [26.631386000000134, 55.33111],
                [26.645828000000108, 55.330276],
                [26.766941, 55.31360600000011],
                [26.783886, 55.308884],
                [26.80110900000011, 55.301102],
                [26.811665, 55.293610000000115],
                [26.81971700000014, 55.285271],
                [26.81971700000014, 55.281105],
                [26.813885, 55.274994000000106],
                [26.79972, 55.264442],
                [26.792221, 55.259163000000115],
                [26.775276000000133, 55.250549],
                [26.641663000000108, 55.190826],
                [26.521385000000123, 55.148331],
                [26.502777, 55.152214],
                [26.48166300000014, 55.15499],
                [26.284164, 55.14804800000013],
                [26.27611, 55.143326],
                [26.25944, 55.129715],
                [26.25333, 55.123604],
                [26.249718000000144, 55.11082],
                [26.250832000000116, 55.090546],
                [26.250275, 55.08194],
                [26.24833, 55.071106],
                [26.219440000000134, 55.029991],
                [26.209995, 55.021378],
                [26.16083, 54.977211],
                [26.07638500000013, 54.96194],
                [25.94333, 54.95499],
                [25.929996, 54.9561],
                [25.911942, 54.953606],
                [25.87722, 54.942215],
                [25.873051, 54.93999],
                [25.795277, 54.875824],
                [25.78889, 54.87027],
                [25.73888, 54.79305],
                [25.73666, 54.789436],
                [25.736107000000118, 54.785],
                [25.726940000000127, 54.68305],
                [25.727219000000105, 54.666664],
                [25.731106, 54.655823],
                [25.733051, 54.652489],
                [25.748604000000114, 54.626381],
                [25.75666, 54.61777],
                [25.761387000000127, 54.611382],
                [25.764164, 54.60444],
                [25.765274, 54.59249100000011],
                [25.765553, 54.58832600000011],
                [25.764164, 54.57916300000011],
                [25.75555400000013, 54.56999],
                [25.74888, 54.564438],
                [25.731106, 54.55166],
                [25.71833, 54.545273],
                [25.666939, 54.53082300000011],
                [25.658329, 54.526657],
                [25.648884, 54.517494],
                [25.55722, 54.36610400000012],
                [25.553051, 54.359161],
                [25.550274, 54.351105],
                [25.547497, 54.332771],
                [25.547497, 54.328606],
                [25.548607000000118, 54.324997],
                [25.55139, 54.3219380000001],
                [25.55833, 54.3169400000001],
                [25.568886, 54.31360600000011],
                [25.58194, 54.31166100000013],
                [25.611107, 54.311378],
                [25.641384, 54.314438],
                [25.659161, 54.31721],
                [25.67555, 54.320831],
                [25.691105, 54.324997],
                [25.698330000000112, 54.330276],
                [25.70111, 54.333328],
                [25.705273, 54.335266000000104],
                [25.710552, 54.3336],
                [25.717495, 54.328606],
                [25.804996, 54.250832],
                [25.807774, 54.248047],
                [25.80805, 54.2438810000001],
                [25.793053, 54.175270000000125],
                [25.79, 54.16721300000012],
                [25.785275, 54.16054],
                [25.7716640000001, 54.154991],
                [25.766109, 54.153877],
                [25.681107, 54.137772],
                [25.66916, 54.136108],
                [25.662216, 54.136108],
                [25.551941, 54.143051],
                [25.53889, 54.145],
                [25.534443, 54.14694200000014],
                [25.504719, 54.183052],
                [25.5061070000001, 54.18721],
                [25.54139, 54.197769],
                [25.547775, 54.203323],
                [25.575829, 54.23638],
                [25.577221000000122, 54.240273],
                [25.57444, 54.243607],
                [25.564720000000136, 54.25193800000011],
                [25.50333, 54.301933],
                [25.498882, 54.304161],
                [25.47805, 54.306656],
                [25.471661, 54.306099],
                [25.46610600000014, 54.30499300000014],
                [25.45194, 54.299721],
                [25.438328, 54.28889],
                [25.424164000000133, 54.2736],
                [25.41722, 54.26833],
                [25.40583, 54.26111],
                [25.391663, 54.255829],
                [25.372498, 54.254166],
                [25.345829, 54.252777],
                [25.2075, 54.22137500000014],
                [25.201385, 54.21054800000013],
                [25.17888, 54.186104],
                [25.161942, 54.172493],
                [25.101387, 54.14444],
                [25.082497000000103, 54.137497],
                [25.07194, 54.13472],
                [25.043053, 54.12971],
                [25.030552, 54.129990000000134],
                [25.02444, 54.13110400000011],
                [25.010277, 54.13694],
                [25.006664000000114, 54.139435],
                [25.001389, 54.145271],
                [24.986107, 54.154709],
                [24.97583, 54.157768],
                [24.968884, 54.1586],
                [24.955273, 54.158043],
                [24.86305, 54.14666],
                [24.85083, 54.145],
                [24.840275000000133, 54.14222],
                [24.836941000000138, 54.139717],
                [24.799721, 54.10833000000014],
                [24.79694, 54.10527],
                [24.79555, 54.10139],
                [24.80139, 54.091377],
                [24.810555, 54.07888],
                [24.82249800000011, 54.06388],
                [24.826107, 54.061378],
                [24.83083, 54.054993],
                [24.838329, 54.04193900000013],
                [24.840553, 54.034439],
                [24.84138, 54.018051],
                [24.839439, 54.00416600000011],
                [24.836109, 53.996658],
                [24.829163, 53.986382],
                [24.820831, 53.977211],
                [24.734718, 53.96888000000013],
                [24.727772, 53.9686],
                [24.720829, 53.969437],
                [24.712772, 53.973877],
                [24.70805, 53.97999],
                [24.704163000000108, 53.990829],
                [24.702217, 53.994156],
                [24.696663, 54],
                [24.69166, 54.00166300000012],
                [24.685272, 54.00194],
                [24.612217, 53.992218],
                [24.523052, 53.954712],
                [24.505833, 53.946098],
                [24.471661, 53.924713],
                [24.463329, 53.920547],
                [24.406384, 53.895],
                [24.392494, 53.88971700000013],
                [24.38694, 53.8886],
                [24.38083, 53.888046],
                [24.277775000000133, 53.89971900000012],
                [24.269165, 53.903877],
                [24.26277, 53.90915700000011],
                [24.25972, 53.9161],
                [24.259163, 53.924438],
                [24.25333, 53.93443],
                [24.244995, 53.943047],
                [24.238605, 53.948326],
                [24.223606, 53.9575],
                [24.209438, 53.963326],
                [24.197216, 53.96555],
                [24.175552, 53.967491],
                [24.155273000000136, 53.966385000000116],
                [24.143887, 53.964157],
                [24.134995000000117, 53.960274],
                [24.123886, 53.95305],
                [24.12138, 53.949997],
                [24.110275, 53.942490000000134],
                [24.100552000000107, 53.93943],
                [24.088608, 53.937492000000134],
                [24.07527, 53.93665],
                [24.016109, 53.93721],
                [23.986107000000118, 53.93888],
                [23.898884, 53.940544],
                [23.78388600000011, 53.93555],
                [23.70944, 53.923882],
                [23.59888500000011, 53.928879],
                [23.58971800000012, 53.93277],
                [23.5686070000001, 53.93915600000014],
                [23.54361, 53.94332],
                [23.51667, 53.946655000000135],
                [23.50404, 53.947044],
                [23.508053, 53.960548],
                [23.517776, 54.030273000000136],
                [23.51722, 54.0472180000001],
                [23.49416, 54.11721],
                [23.48444000000012, 54.138329],
                [23.45916000000011, 54.172768],
                [23.456383, 54.17555],
                [23.361942000000113, 54.23193],
                [23.350273, 54.238884],
                [23.333054, 54.247215],
                [23.20444, 54.287216000000114],
                [23.115829, 54.304436],
                [23.003052, 54.37999],
                [23.001991, 54.381054],
                [23, 54.383049],
                [22.99277100000012, 54.387772],
                [22.987495, 54.38916000000012],
                [22.870274, 54.408043],
                [22.85611, 54.4086],
                [22.843609, 54.406937],
                [22.826664, 54.40332],
                [22.81361, 54.397491],
                [22.810829, 54.39444],
                [22.78588, 54.36384],
                [22.776386, 54.376938],
                [22.740829, 54.419441],
                [22.731384, 54.42749],
                [22.713608, 54.439713],
                [22.707069, 54.44812],
                [22.702217, 54.455826],
                [22.694439000000102, 54.47332],
                [22.691383, 54.493607],
                [22.69389, 54.522766000000104],
                [22.695827, 54.53611],
                [22.719162, 54.691376],
                [22.721107, 54.694992],
                [22.74527, 54.71720900000014],
                [22.809441, 54.769714000000135],
                [22.81833, 54.773605],
                [22.83194, 54.77444],
                [22.837776, 54.77582600000011],
                [22.84249, 54.777489],
                [22.84944, 54.782768],
                [22.86138, 54.80027],
                [22.867775, 54.810547],
                [22.869164, 54.81443800000011],
                [22.869164, 54.82332600000012],
                [22.864998000000128, 54.8386],
                [22.853329, 54.875824],
                [22.84944, 54.88749700000011],
                [22.84249, 54.89694],
                [22.834995000000106, 54.901657],
                [22.732216000000108, 54.962494],
                [22.726662, 54.963882000000126],
                [22.719440000000134, 54.963608],
                [22.70166, 54.96054800000013],
                [22.68222, 54.95832800000011],
                [22.659161, 54.9586],
                [22.653049000000124, 54.959717000000126],
                [22.64833, 54.9616620000001],
                [22.643887, 54.963608],
                [22.640831000000105, 54.966385000000116],
                [22.63861, 54.96971100000013],
                [22.603607, 55.0430530000001],
                [22.602219000000105, 55.046661],
                [22.51277, 55.063324],
                [22.27972, 55.06721],
                [22.25805300000013, 55.066383],
                [22.197216, 55.06166],
                [22.184162, 55.060272],
                [22.146385, 55.05526700000013],
                [22.140553000000125, 55.053879],
                [22.13583, 55.0522160000001],
                [22.13222, 55.04943800000012],
                [22.124439, 55.040276],
                [22.121109, 55.037498],
                [22.108608, 55.030823],
                [22.09805, 55.028046],
                [22.077221, 55.026657],
                [22.061943, 55.027489],
                [22.050274, 55.029991],
                [21.732216000000108, 55.132767],
                [21.722771, 55.136658],
                [21.71999, 55.139435],
                [21.715549, 55.1461],
                [21.654442, 55.17887900000011],
                [21.640274, 55.18471],
                [21.56416, 55.19721],
                [21.431385, 55.251938],
                [21.389717, 55.282768],
                [21.38128300000011, 55.287094],
                [21.374165, 55.288605],
                [21.367878000000132, 55.288307],
                [21.363308, 55.28685800000011],
                [21.327656, 55.27063],
                [21.30027, 55.25888800000013],
                [21.280552000000114, 55.251938],
                [21.26915, 55.249306000000104],
                [21.263935000000117, 55.248985],
                [21.268602, 55.260639],
                [21.266163, 55.275684],
                [21.271448, 55.279343],
                [21.288609, 55.28333],
                [21.289719, 55.28749800000014],
                [21.289165, 55.291664],
                [21.27673, 55.32284900000013],
                [21.253965000000107, 55.334641],
                [21.255999, 55.36594800000012],
                [21.238516000000118, 55.36676],
                [21.230789, 55.359848],
                [21.194603, 55.34074],
                [21.183626000000118, 55.34074],
                [21.186878, 55.353344],
                [21.241768, 55.418396],
                [21.24787, 55.4371],
                [21.247215, 55.463326],
                [21.244438, 55.470543000000134],
                [21.197495000000117, 55.574997],
                [21.145275, 55.676102],
                [21.143051, 55.679161],
                [21.116386, 55.709435],
                [21.109997, 55.715],
                [21.097496, 55.722488],
                [21.079163, 55.730545],
                [21.07611, 55.73333],
                [21.073887000000127, 55.73666],
                [21.05833, 55.78166],
                [21.04472, 55.882767],
                [21.043331, 55.90416],
                [21.0430530000001, 55.916664],
                [21.047775, 55.927773],
                [21.057774, 55.945541000000105],
                [21.062218, 55.95694],
                [21.066666, 55.977768],
                [21.067219000000136, 55.991379],
                [21.060555000000136, 56.04999500000014],
                [21.057774, 56.061935],
                [21.051685, 56.077309],
                [21.05805, 56.079437],
                [21.089165, 56.08416000000011],
                [21.108887, 56.08665500000012],
                [21.123886, 56.087494],
                [21.146664, 56.088043],
                [21.19721600000014, 56.083328],
                [21.204716, 56.083878],
                [21.209717, 56.085548],
                [21.21805, 56.08998900000012],
                [21.223328, 56.0961],
                [21.228882, 56.10721600000011],
                [21.23388, 56.123047],
                [21.2347180000001, 56.141106],
                [21.239162, 56.16220900000013],
                [21.244438, 56.168327],
                [21.258888000000127, 56.178604],
                [21.34583, 56.23555],
                [21.354443, 56.23999],
                [21.361107, 56.24082900000013],
                [21.37666300000012, 56.241104],
                [21.384995000000117, 56.24082900000013],
                [21.39138400000013, 56.2397160000001],
                [21.40777, 56.23943300000013],
                [21.42194, 56.240547000000106],
                [21.427773, 56.241936],
                [21.44777, 56.248878],
                [21.56666600000011, 56.295273],
                [21.735550000000103, 56.32333],
                [21.905273, 56.36916],
                [22.038609, 56.41277],
                [22.04888, 56.41610000000014],
                [22.067219000000136, 56.419441],
                [22.13944, 56.423607],
                [22.154442, 56.42416],
                [22.309441000000106, 56.403877],
                [22.481384, 56.40638],
                [22.497215, 56.40638],
                [22.519165, 56.40443],
                [22.553608, 56.39971900000012],
                [22.586941, 56.394714],
                [22.611942000000113, 56.389992],
                [22.623329, 56.38694],
                [22.628052, 56.384995],
                [22.63583, 56.380272000000105],
                [22.643608, 56.375267],
                [22.653606, 56.36721],
                [22.661385, 56.362495],
                [22.671108, 56.3586],
                [22.691383, 56.35666],
                [22.827221000000122, 56.37915800000013],
                [22.837498, 56.38249200000013],
                [22.846107, 56.38694],
                [22.86027, 56.397491],
                [22.886383, 56.41027100000014],
                [22.916939, 56.420547],
                [22.92805, 56.423325],
                [22.93388, 56.424438],
                [22.94138, 56.423882000000106],
                [22.94694, 56.4222180000001],
                [22.955551, 56.4180530000001],
                [22.98666, 56.3986],
                [22.99277100000012, 56.39305],
                [22.999161, 56.383331],
                [23.008331, 56.366104],
                [23.013054, 56.35555],
                [23.018055000000118, 56.34943],
                [23.03138700000011, 56.33416],
                [23.0375, 56.328606],
                [23.053886, 56.319443],
                [23.068054, 56.313606],
                [23.096107, 56.30582400000014],
                [23.104443, 56.30555],
                [23.110275, 56.306656],
                [23.129997000000117, 56.313881],
                [23.147217000000126, 56.32249],
                [23.18027500000011, 56.345543],
                [23.181385, 56.348877],
                [23.177494, 56.351105],
                [23.171108000000117, 56.352219],
                [23.16805, 56.35527],
                [23.167496, 56.359161],
                [23.171108000000117, 56.36194],
                [23.182217, 56.36472],
                [23.296108, 56.380821],
                [23.32, 56.380272000000105],
                [23.332218000000125, 56.377769000000114],
                [23.35833, 56.36916],
                [23.36777500000011, 56.364998],
                [23.441662, 56.345268],
                [23.454441, 56.343048],
                [23.525276, 56.33416],
                [23.547497000000135, 56.334717000000126],
                [23.559441, 56.337212000000136],
                [23.56805, 56.341377000000136],
                [23.578884, 56.3491590000001],
                [23.584721, 56.35555],
                [23.596943, 56.362213],
                [23.608608, 56.364159],
                [23.726383000000112, 56.361382],
                [23.741104, 56.359993000000145],
                [23.873608, 56.34277],
                [23.948883, 56.332214000000135],
                [23.99138, 56.322769],
                [24.008331, 56.318054],
                [24.065273, 56.28555300000011],
                [24.07444, 56.281662],
                [24.135830000000112, 56.26416],
                [24.147774, 56.26138300000014],
                [24.16333, 56.261108],
                [24.175274, 56.263329],
                [24.265, 56.289436],
                [24.320274, 56.308327],
                [24.332218, 56.310547],
                [24.339718, 56.310822000000144],
                [24.345276000000126, 56.309158],
                [24.364719, 56.30166],
                [24.378883, 56.29555],
                [24.404163, 56.281937],
                [24.41833, 56.2761],
                [24.42944, 56.272766000000104],
                [24.44944, 56.269714],
                [24.47333, 56.26915700000012],
                [24.479996, 56.269714],
                [24.558331, 56.28833],
                [24.56277, 56.29055],
                [24.582497, 56.312492],
                [24.60278, 56.32916300000011],
                [24.653328, 56.365829],
                [24.87944, 56.448601],
                [24.89138400000013, 56.450829],
                [24.899719, 56.450546],
                [24.906105, 56.449432],
                [24.91555, 56.445267],
                [24.922218, 56.439987],
                [24.94222, 56.40694],
                [24.956661, 56.38249200000013],
                [24.970551000000114, 56.353607],
                [24.981937, 56.32916300000011],
                [24.99305, 56.304993],
                [25.000000000000114, 56.29555],
              ],
            ],
          ],
        },
        id: 17,
        NAME: 'Lithuania',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Portugal',
          id: 18,
          label: 'Portugal',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.119,
          year: '2023',
          centroid: [-8.2245, 39.3999],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [-8.20472, 41.87471800000014],
              [-8.201117, 41.87249800000012],
              [-8.187778, 41.873886],
              [-8.181114, 41.87249800000012],
              [-8.175556, 41.871109],
              [-8.16528, 41.86305],
              [-8.16111, 41.857498],
              [-8.16, 41.842773],
              [-8.16167, 41.8275],
              [-8.163807, 41.817184],
              [-8.140556, 41.80916600000012],
              [-8.13167, 41.80916600000012],
              [-8.08778, 41.809441000000106],
              [-8.067501, 41.815277],
              [-8.055065, 41.81952],
              [-8.035278, 41.827217],
              [-7.93222, 41.87471800000014],
              [-7.921112, 41.880829],
              [-7.88, 41.85277600000012],
              [-7.873334, 41.85249],
              [-7.866945, 41.85555],
              [-7.84917, 41.864441],
              [-7.759445, 41.8975],
              [-7.70583, 41.904442],
              [-7.6925, 41.904999],
              [-7.686389, 41.903053],
              [-7.59806, 41.865273],
              [-7.609167, 41.845551],
              [-7.611945, 41.834999],
              [-7.607779, 41.83111],
              [-7.426667, 41.82222],
              [-7.41056, 41.823326],
              [-7.331112, 41.84499],
              [-7.26833, 41.863609],
              [-7.207348, 41.883835],
              [-7.200556, 41.88361],
              [-7.18694, 41.898331],
              [-7.17361, 41.922775],
              [-7.17472, 41.928055],
              [-7.183056, 41.93777],
              [-7.187222, 41.975273],
              [-7.18278, 41.979439],
              [-7.14, 41.994164],
              [-7.13361, 41.994995],
              [-7.125556, 41.99305],
              [-7.10528, 41.986938],
              [-7.092501, 41.98027],
              [-7.081112, 41.966385],
              [-7.08167, 41.96138800000011],
              [-7.0775, 41.957497],
              [-7.063056, 41.951385],
              [-7.05611, 41.95111],
              [-7.01444, 41.952499],
              [-7.003056, 41.9566650000001],
              [-6.982848, 41.973862],
              [-6.94472, 41.952774],
              [-6.93611, 41.94944],
              [-6.90611, 41.944717],
              [-6.71694, 41.936661],
              [-6.696945, 41.936661],
              [-6.6875, 41.936661],
              [-6.618334, 41.940552],
              [-6.6025, 41.94888],
              [-6.594167, 41.95361],
              [-6.548612, 41.921944],
              [-6.52806, 41.839439],
              [-6.547501, 41.764999],
              [-6.55222, 41.698051000000135],
              [-6.55139, 41.691109],
              [-6.539445, 41.679443],
              [-6.50611, 41.661385],
              [-6.4975, 41.65749],
              [-6.469167, 41.666664],
              [-6.452778, 41.67472],
              [-6.434167, 41.680275],
              [-6.42472, 41.679718],
              [-6.34722, 41.67222],
              [-6.303612, 41.66333],
              [-6.26, 41.643051],
              [-6.25222, 41.637772],
              [-6.19444, 41.593048000000124],
              [-6.18722, 41.57972000000012],
              [-6.18875, 41.576057000000105],
              [-6.191389, 41.569717],
              [-6.203611, 41.548332],
              [-6.210556, 41.538887],
              [-6.217501, 41.52944200000013],
              [-6.29583, 41.436104],
              [-6.357779, 41.38055400000013],
              [-6.438056, 41.318886],
              [-6.51028, 41.265],
              [-6.558333, 41.242218],
              [-6.58, 41.239716],
              [-6.59833, 41.244164],
              [-6.618056, 41.246384],
              [-6.64389, 41.24472],
              [-6.686389, 41.212494000000106],
              [-6.690556, 41.208054],
              [-6.75333, 41.136665],
              [-6.75417, 41.112495],
              [-6.75444, 41.102493],
              [-6.768612, 41.07777],
              [-6.780278, 41.06360600000011],
              [-6.805556, 41.045555],
              [-6.835, 41.031662],
              [-6.848333, 41.02861000000013],
              [-6.92441, 41.03096],
              [-6.931667, 41.01805100000013],
              [-6.92944, 41.013054],
              [-6.891389, 40.974716000000114],
              [-6.87167, 40.95916],
              [-6.865556, 40.956383],
              [-6.85722, 40.94749500000012],
              [-6.803889, 40.874161],
              [-6.79972, 40.856110000000115],
              [-6.801667, 40.848885],
              [-6.81944, 40.73333],
              [-6.79611, 40.52444],
              [-6.815556, 40.38777],
              [-6.83111, 40.317215],
              [-6.862303, 40.271523000000116],
              [-6.873889, 40.263329],
              [-6.88278, 40.260277],
              [-6.91028, 40.256386],
              [-6.946526, 40.25898],
              [-7.005834, 40.23083],
              [-7.01083, 40.222771],
              [-7.02722, 40.18777],
              [-7.013056, 40.139442],
              [-7.004723, 40.126106],
              [-6.98722, 40.120552],
              [-6.97806, 40.117775],
              [-6.96, 40.115829],
              [-6.95056, 40.11666],
              [-6.9425, 40.112778],
              [-6.93472, 40.1075],
              [-6.928889, 40.101662],
              [-6.8825, 40.044167],
              [-6.87056, 40.02166000000011],
              [-6.87083, 40.01028],
              [-6.989722, 39.724716],
              [-7.01722, 39.67499500000014],
              [-7.04812, 39.665253],
              [-7.05763, 39.662254],
              [-7.146111, 39.658607],
              [-7.1525, 39.658882],
              [-7.166112, 39.661942000000124],
              [-7.205556, 39.66722],
              [-7.260279, 39.672218],
              [-7.266945, 39.67194400000011],
              [-7.307222, 39.656662],
              [-7.32556, 39.648605],
              [-7.33083, 39.644722],
              [-7.3375, 39.643883],
              [-7.4075, 39.64833],
              [-7.41472, 39.649162],
              [-7.5325, 39.669418],
              [-7.526945, 39.64],
              [-7.523056, 39.633331],
              [-7.505834, 39.605827],
              [-7.499722, 39.599716000000114],
              [-7.38, 39.496109],
              [-7.371389, 39.491386],
              [-7.32278, 39.388329],
              [-7.31361, 39.34471900000011],
              [-7.24278, 39.213051],
              [-7.149167, 39.116661],
              [-7.1425, 39.111107],
              [-7.13389, 39.108604],
              [-7.115834, 39.104164],
              [-7.10278, 39.104721],
              [-7.065556, 39.114716],
              [-7.05667, 39.11805],
              [-7.05056, 39.124161],
              [-7.040278, 39.12277200000011],
              [-7.02139, 39.11639],
              [-7.005, 39.10721600000011],
              [-6.98278, 39.09138],
              [-6.961112, 39.056664],
              [-6.95479, 39.026382],
              [-6.956944, 39.019997],
              [-7.06, 38.86055],
              [-7.08417, 38.835548],
              [-7.16417, 38.781944],
              [-7.207355, 38.749268],
              [-7.24556, 38.73389],
              [-7.257223, 38.728333],
              [-7.260279, 38.72305300000011],
              [-7.265556, 38.708328],
              [-7.267222, 38.703331],
              [-7.32111, 38.44944],
              [-7.313056, 38.439995],
              [-7.304167, 38.435829],
              [-7.28889, 38.42694100000011],
              [-7.280834, 38.4222180000001],
              [-7.274445, 38.41666],
              [-7.192223, 38.320274],
              [-7.16972, 38.284439],
              [-7.145, 38.246109],
              [-7.13, 38.22583],
              [-7.10222, 38.18916300000012],
              [-7.10111, 38.184166],
              [-7.08778, 38.174438],
              [-7.081112, 38.17472],
              [-7.02833, 38.187492],
              [-7.01694, 38.19166600000011],
              [-7.01167, 38.195549],
              [-7.01028, 38.200554],
              [-6.993334, 38.209442],
              [-6.96139, 38.21583],
              [-6.947779, 38.21833],
              [-6.94056, 38.217773000000136],
              [-6.93375, 38.209068],
              [-6.939167, 38.17805],
              [-6.94389, 38.162773],
              [-6.95167, 38.14],
              [-7.00139, 38.034164],
              [-7.006667, 38.028053000000114],
              [-7.12361, 38.00999500000012],
              [-7.21083, 37.996941],
              [-7.24556, 37.990829],
              [-7.25444, 37.987495],
              [-7.259445, 37.98166700000013],
              [-7.25472, 37.974716],
              [-7.25194, 37.95944200000014],
              [-7.25194, 37.933609],
              [-7.25361, 37.92832900000013],
              [-7.27833, 37.87083],
              [-7.285, 37.860275],
              [-7.320001, 37.815277],
              [-7.379168, 37.77444],
              [-7.394723, 37.7649990000001],
              [-7.42306, 37.74388900000014],
              [-7.446945, 37.69944],
              [-7.524445, 37.552498],
              [-7.512534, 37.528549],
              [-7.503056, 37.522499],
              [-7.48472, 37.498886],
              [-7.47139, 37.481384000000105],
              [-7.46139, 37.457222],
              [-7.44722, 37.41861],
              [-7.43472, 37.366943],
              [-7.43185, 37.253189],
              [-7.414445, 37.186104],
              [-7.423612, 37.174995],
              [-7.43833, 37.178329],
              [-7.45083, 37.179161],
              [-7.47194, 37.177773],
              [-7.553056, 37.155548],
              [-7.56611, 37.150833],
              [-7.5775, 37.145828],
              [-7.58333, 37.143051],
              [-7.613056, 37.128609],
              [-7.616389, 37.123604],
              [-7.615001, 37.11833200000012],
              [-7.61722, 37.113327],
              [-7.62194, 37.109993],
              [-7.75833, 37.035],
              [-7.89778, 37.008888],
              [-7.97306, 37.00833100000011],
              [-8.00806, 37.018608],
              [-8.017778, 37.025551],
              [-8.039446, 37.039993],
              [-8.04972, 37.04610400000013],
              [-8.06778, 37.054718],
              [-8.104168, 37.07166],
              [-8.1175, 37.076942000000145],
              [-8.17528, 37.092216],
              [-8.3675, 37.103882],
              [-8.380001, 37.100273],
              [-8.39833, 37.092773],
              [-8.41722, 37.088608],
              [-8.43639, 37.085548],
              [-8.44278, 37.086662],
              [-8.511112, 37.10305000000011],
              [-8.65889, 37.108887],
              [-8.81472, 37.06694],
              [-8.926668, 37.016106],
              [-8.984446, 37.020271],
              [-8.99028, 37.02304800000013],
              [-8.99139, 37.028053],
              [-8.990835, 37.033882],
              [-8.984167, 37.0522160000001],
              [-8.95917, 37.0925],
              [-8.95083, 37.101105],
              [-8.94528, 37.103882],
              [-8.94111, 37.107773],
              [-8.926111, 37.127495000000124],
              [-8.922779, 37.132774],
              [-8.913612, 37.147499],
              [-8.905834, 37.16166],
              [-8.90333, 37.166664],
              [-8.85806, 37.27277400000014],
              [-8.82889, 37.380554],
              [-8.795862, 37.44251],
              [-8.78722, 37.524162],
              [-8.7875, 37.722221],
              [-8.80583, 37.76638800000012],
              [-8.791866, 37.819092],
              [-8.79139, 37.824165],
              [-8.79056, 37.83416],
              [-8.794445, 37.897217],
              [-8.797501, 37.91277300000013],
              [-8.79972, 37.91777],
              [-8.80556, 37.92832900000013],
              [-8.81056, 37.931938000000116],
              [-8.84222, 38.009438],
              [-8.83667, 38.019997],
              [-8.80806, 38.086105],
              [-8.80556, 38.091942],
              [-8.796112, 38.118332],
              [-8.789446, 38.139442],
              [-8.77917, 38.18055],
              [-8.77582, 38.211761],
              [-8.77694, 38.250549],
              [-8.7775, 38.262215],
              [-8.77972, 38.30110900000011],
              [-8.78639, 38.32888800000012],
              [-8.79222, 38.34916],
              [-8.8025, 38.374443],
              [-8.72333, 38.41666],
              [-8.673334, 38.413887],
              [-8.76889, 38.51722],
              [-8.89222, 38.518051],
              [-8.905001, 38.517494],
              [-8.91139, 38.516106],
              [-8.92639, 38.503883],
              [-8.99278, 38.463608],
              [-9.062778, 38.437218],
              [-9.083612, 38.43305],
              [-9.18389, 38.419716],
              [-9.200279, 38.45166],
              [-9.184446, 38.475273],
              [-9.18306, 38.48083],
              [-9.179167, 38.506660000000124],
              [-9.17861, 38.511665],
              [-9.182501, 38.531944000000124],
              [-9.18528, 38.541939],
              [-9.20389, 38.59277],
              [-9.206945, 38.598053],
              [-9.218613, 38.617218],
              [-9.22167, 38.621666],
              [-9.23333, 38.63528],
              [-9.246389, 38.64666],
              [-9.27444, 38.66416],
              [-9.278612, 38.66861],
              [-9.27195, 38.671104],
              [-9.215279, 38.67832900000013],
              [-9.16889, 38.678886],
              [-9.150557, 38.676941],
              [-9.07445, 38.631104],
              [-9.028057, 38.699997],
              [-9.015556, 38.729439],
              [-8.964169, 38.75833100000011],
              [-8.951389, 38.763054000000125],
              [-8.93861, 38.7649990000001],
              [-8.91975, 38.765892],
              [-8.91972, 38.770271],
              [-8.928057, 38.79805],
              [-8.93083, 38.802773],
              [-8.955849, 38.84085800000014],
              [-8.96667, 38.834717],
              [-8.972502, 38.838608000000136],
              [-8.979168, 38.846939],
              [-8.9825, 38.851944],
              [-8.98389, 38.857216],
              [-8.99194, 38.892776],
              [-8.98695, 38.908607],
              [-8.984446, 38.947777],
              [-8.990835, 38.945274],
              [-8.99917, 38.93694],
              [-9.00278, 38.932495],
              [-9.06528, 38.855],
              [-9.07639, 38.835548],
              [-9.08167, 38.825554],
              [-9.087778, 38.810272],
              [-9.09056, 38.799721],
              [-9.092501, 38.783051],
              [-9.093613, 38.77304800000013],
              [-9.093334, 38.76749400000011],
              [-9.09167, 38.76221],
              [-9.092779, 38.75222],
              [-9.097778, 38.742493],
              [-9.106945, 38.727219],
              [-9.113611, 38.7175],
              [-9.12, 38.71416],
              [-9.13333, 38.709999],
              [-9.2125, 38.69082600000013],
              [-9.322224, 38.676666],
              [-9.429724, 38.6919400000001],
              [-9.46139, 38.698051],
              [-9.47389, 38.703049],
              [-9.484446, 38.709999],
              [-9.49472, 38.78527],
              [-9.49306, 38.790276],
              [-9.48778, 38.799995],
              [-9.46583, 38.834717],
              [-9.45917, 38.844444],
              [-9.450556, 38.851944],
              [-9.447224, 38.856667],
              [-9.442501, 38.866661],
              [-9.43778, 38.876938],
              [-9.42195, 38.91805],
              [-9.41417, 38.94416],
              [-9.411112, 38.95472],
              [-9.41417, 38.984161],
              [-9.41556, 38.98944100000011],
              [-9.41722, 38.99472],
              [-9.4225, 38.998604000000114],
              [-9.42639, 39.00361],
              [-9.42611, 39.019440000000145],
              [-9.41917, 39.078606],
              [-9.39667, 39.117775],
              [-9.36639, 39.160553],
              [-9.363056, 39.16555],
              [-9.342501, 39.215271],
              [-9.33694, 39.234444],
              [-9.337223, 39.25582900000012],
              [-9.3375, 39.270828],
              [-9.338345, 39.292976],
              [-9.361668, 39.348328],
              [-9.3575, 39.364998],
              [-9.293335, 39.391388],
              [-9.22722, 39.435272],
              [-9.14417, 39.526382000000126],
              [-9.085556, 39.615],
              [-9.07944, 39.640274],
              [-9.047501, 39.73221600000011],
              [-9.026945, 39.775551],
              [-8.98472, 39.850555],
              [-8.93195, 39.964165],
              [-8.896362, 40.0454],
              [-8.89306, 40.050278000000105],
              [-8.88889, 40.059715],
              [-8.874723, 40.096107],
              [-8.86278, 40.130829],
              [-8.86195, 40.14804800000013],
              [-8.88139, 40.242775],
              [-8.85056, 40.306938],
              [-8.84028, 40.336388],
              [-8.800001, 40.46833],
              [-8.790279, 40.50416600000011],
              [-8.785866, 40.52070600000013],
              [-8.782501, 40.537773],
              [-8.77806, 40.55778],
              [-8.77694, 40.562492],
              [-8.74539, 40.628387],
              [-8.72989, 40.63705],
              [-8.721724, 40.638718],
              [-8.691668, 40.66111],
              [-8.66083, 40.68721800000014],
              [-8.65944, 40.69500000000011],
              [-8.678335, 40.775833],
              [-8.70306, 40.718605],
              [-8.71961, 40.691277],
              [-8.727278, 40.680611],
              [-8.73128, 40.67961],
              [-8.73528, 40.680275],
              [-8.73361, 40.689438],
              [-8.72667, 40.727776],
              [-8.717779, 40.752777],
              [-8.702778, 40.794167],
              [-8.6975, 40.799438],
              [-8.69306, 40.814995000000124],
              [-8.67778, 40.869164],
              [-8.66806, 40.903885000000116],
              [-8.646112, 40.997215],
              [-8.645, 41.00804900000014],
              [-8.64554, 41.018578],
              [-8.65722, 41.041939],
              [-8.729445, 41.23666400000013],
              [-8.78972, 41.421387],
              [-8.778841, 41.467575],
              [-8.781113, 41.484444],
              [-8.79972, 41.566666],
              [-8.81509, 41.617241],
              [-8.86945, 41.716660000000104],
              [-8.876667, 41.731941],
              [-8.880001, 41.746666],
              [-8.881668, 41.75666],
              [-8.880001, 41.83888],
              [-8.87945, 41.843887],
              [-8.86861, 41.857773],
              [-8.85611, 41.870277],
              [-8.81361, 41.902496],
              [-8.786217, 41.91909],
              [-8.75242, 41.931732],
              [-8.74501, 41.952499],
              [-8.74445, 41.961937],
              [-8.743057, 41.96666],
              [-8.73861, 41.97138200000012],
              [-8.64, 42.045273],
              [-8.62083, 42.05360400000012],
              [-8.606945, 42.059166],
              [-8.521389, 42.082771],
              [-8.51472, 42.08332800000011],
              [-8.47361, 42.084717000000126],
              [-8.44611, 42.084717000000126],
              [-8.31056, 42.103607],
              [-8.25194, 42.13861],
              [-8.201223, 42.15274],
              [-8.19444, 42.1486],
              [-8.09, 42.068886000000134],
              [-8.085556, 42.06472],
              [-8.079723, 42.054161],
              [-8.08167, 42.03],
              [-8.0825, 42.02527600000013],
              [-8.085, 42.020271],
              [-8.08944, 42.01639],
              [-8.09556, 42.013329],
              [-8.10889, 42.008606],
              [-8.134724, 41.99889],
              [-8.16528, 41.974442],
              [-8.20472, 41.933609000000104],
              [-8.212778, 41.92388],
              [-8.218613, 41.9136],
              [-8.219168, 41.90861],
              [-8.217779, 41.903885],
              [-8.20472, 41.87471800000014],
            ],
          ],
        },
        id: 18,
        NAME: 'Portugal',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Denmark',
          id: 19,
          label: 'Denmark',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.094,
          year: '2023',
          centroid: [9.5018, 56.2639],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [11.513887, 54.82972000000012],
                [11.564444, 54.82194],
                [11.6425, 54.877777],
                [11.64167, 54.900833],
                [11.64194, 54.903885],
                [11.64389, 54.9061],
                [11.64861100000013, 54.906662],
                [11.656944, 54.903885],
                [11.708611, 54.87527],
                [11.73527700000011, 54.854996],
                [11.845, 54.7699970000001],
                [11.849443000000122, 54.765831],
                [11.861666, 54.746109],
                [11.862221, 54.74305],
                [11.858332, 54.689438],
                [11.85611, 54.68332700000013],
                [11.84417, 54.669441],
                [11.833887, 54.66111],
                [11.785, 54.639999],
                [11.77555500000011, 54.64083],
                [11.73639, 54.645271],
                [11.7225, 54.651108000000136],
                [11.693888, 54.655548000000124],
                [11.640554, 54.6625],
                [11.588333, 54.66360500000013],
                [11.57888800000012, 54.66333],
                [11.522499, 54.64194],
                [11.4725, 54.622772],
                [11.466389, 54.61999500000013],
                [11.46139, 54.618889],
                [11.45555, 54.619438],
                [11.451387, 54.620552],
                [11.377222, 54.64666],
                [11.35027700000012, 54.65888200000012],
                [11.315277, 54.675552],
                [11.278055000000109, 54.699715],
                [11.26222, 54.70722],
                [11.24583200000012, 54.711662],
                [11.190554000000134, 54.725555],
                [11.144444, 54.736938],
                [11.125555, 54.740273000000116],
                [11.099165, 54.742493],
                [11.03167, 54.756104],
                [11.02611, 54.75861],
                [11.019722000000115, 54.762772],
                [10.994999, 54.78278],
                [10.99111, 54.787216],
                [10.989891000000114, 54.79085],
                [11.025276, 54.81443800000011],
                [11.013611, 54.890274],
                [11.014444, 54.895828],
                [11.027498, 54.910271],
                [11.031944, 54.914719],
                [11.042221, 54.9230500000001],
                [11.05778, 54.934998],
                [11.07139, 54.940826],
                [11.118889, 54.95083],
                [11.136389, 54.95388800000012],
                [11.164444, 54.956665],
                [11.193144, 54.957397],
                [11.239721, 54.957222000000115],
                [11.275555, 54.94971],
                [11.288332, 54.943054],
                [11.33111, 54.91944100000012],
                [11.336111, 54.91555],
                [11.339998, 54.911385],
                [11.347221, 54.89611100000013],
                [11.35111000000012, 54.891937],
                [11.361111, 54.883888],
                [11.393332, 54.86805],
                [11.408888, 54.86249],
                [11.513887, 54.82972000000012],
              ],
            ],
            [
              [
                [12.03805, 54.892494],
                [12.060833, 54.891106],
                [12.07944300000014, 54.89361],
                [12.085278, 54.89361],
                [12.095554, 54.892494],
                [12.10361, 54.890274],
                [12.11055, 54.88749700000011],
                [12.119444000000101, 54.882217],
                [12.136665, 54.868607],
                [12.16805, 54.84166],
                [12.169443, 54.839165],
                [12.16861, 54.8361],
                [12.166666, 54.83388500000012],
                [12.158333, 54.82861],
                [12.11972, 54.806389],
                [12.10722, 54.799721],
                [12.08861, 54.79361],
                [12.0783330000001, 54.789162],
                [12.071943, 54.785828],
                [12.055277000000103, 54.774719],
                [11.98139, 54.710274],
                [11.969721000000106, 54.69944],
                [11.96305500000011, 54.68527],
                [11.96083, 54.675827],
                [11.958611000000133, 54.66333],
                [11.959999, 54.64777400000014],
                [11.96305500000011, 54.629715],
                [11.967777, 54.609444],
                [11.974443, 54.58694],
                [11.978888, 54.576111],
                [11.98, 54.570274],
                [11.978611, 54.567215],
                [11.969166, 54.56221800000014],
                [11.964443, 54.561661],
                [11.94472, 54.56749700000012],
                [11.929443000000106, 54.572777],
                [11.92305, 54.576111],
                [11.871944, 54.651382],
                [11.871111, 54.66722],
                [11.877777, 54.6877750000001],
                [11.891943, 54.701111],
                [11.899166, 54.71860500000014],
                [11.85611, 54.7741620000001],
                [11.80194, 54.839165],
                [11.792776, 54.844719],
                [11.781944, 54.84888500000011],
                [11.755554, 54.85472],
                [11.751944, 54.859161],
                [11.708611, 54.936661],
                [11.713333, 54.94167],
                [11.73222, 54.954437],
                [11.742222, 54.95916],
                [11.750832, 54.960831],
                [11.766943, 54.9616620000001],
                [11.846666, 54.95611],
                [11.850587, 54.954784],
                [11.865035, 54.947559000000126],
                [11.99694, 54.903885],
                [12.019999, 54.896385],
                [12.03805, 54.892494],
              ],
            ],
            [
              [
                [10.432777, 54.84166],
                [10.407221000000106, 54.82139],
                [10.399443000000133, 54.824165],
                [10.248333000000116, 54.90416],
                [10.243055, 54.907776],
                [10.190832, 54.958054],
                [10.185555, 54.968048],
                [10.184166, 54.97361],
                [10.18861, 54.97805],
                [10.285555, 54.936104],
                [10.306665, 54.926941],
                [10.440832, 54.86388],
                [10.432777, 54.84166],
              ],
            ],
            [
              [
                [12.557499, 54.964165],
                [12.557499, 54.960831],
                [12.55611, 54.957771],
                [12.548054, 54.94916500000011],
                [12.544722, 54.94722000000013],
                [12.53666, 54.94500000000011],
                [12.52055, 54.94416],
                [12.501665, 54.94722000000013],
                [12.472776, 54.955826],
                [12.463888, 54.9574970000001],
                [12.40416, 54.96305100000012],
                [12.377222, 54.96305100000012],
                [12.361666, 54.962219],
                [12.338055, 54.958885],
                [12.311943, 54.950554000000125],
                [12.30888700000014, 54.948883],
                [12.264166, 54.919167],
                [12.18361, 54.880272],
                [12.16361000000012, 54.88304900000014],
                [12.150833, 54.886108],
                [12.115833000000123, 54.90416],
                [12.132221, 54.95138500000013],
                [12.135832, 54.956665],
                [12.177776, 54.982498000000135],
                [12.311943, 55.03527100000014],
                [12.395277, 55.032494],
                [12.452221000000122, 55.026939],
                [12.50666600000011, 55.015831],
                [12.527777000000128, 55.01028],
                [12.532776, 55.00666],
                [12.536388000000102, 55.00193800000011],
                [12.554722, 54.972221],
                [12.557499, 54.964165],
              ],
            ],
            [
              [
                [10.615, 54.950272],
                [10.565277, 54.94611],
                [10.555832000000123, 54.946938],
                [10.549166000000127, 54.949997],
                [10.51694300000014, 54.97888200000011],
                [10.513054, 54.98333],
                [10.49861, 55.00166300000012],
                [10.49861, 55.006386],
                [10.504999, 55.00944],
                [10.622499, 55.043884000000105],
                [10.631943, 55.043327],
                [10.674444000000108, 54.994438],
                [10.677221, 54.98944100000011],
                [10.674721, 54.98333],
                [10.671110000000112, 54.97805],
                [10.666666000000134, 54.97361],
                [10.615, 54.950272],
              ],
            ],
            [
              [
                [9.792500000000132, 55.07499700000011],
                [9.96611, 55.012497],
                [9.97194, 55.00889],
                [10, 54.983719],
                [10.004721, 54.979721],
                [10.042221, 54.940277],
                [10.04389, 54.937775],
                [10.069166, 54.895264],
                [10.071943, 54.88999200000012],
                [10.073055, 54.88082],
                [10.07111, 54.87471000000011],
                [10.067499000000112, 54.87305],
                [9.988888, 54.859993],
                [9.978611000000114, 54.85860400000013],
                [9.956388, 54.85805],
                [9.936388000000136, 54.860275],
                [9.926943, 54.86249],
                [9.895832, 54.87166600000012],
                [9.804165, 54.899437],
                [9.785831, 54.9061],
                [9.781387, 54.910271],
                [9.77861, 54.91555],
                [9.772499, 54.92889],
                [9.758333, 54.961388],
                [9.75861, 54.97888200000011],
                [9.760555, 54.98111],
                [9.765276, 54.98055],
                [9.781387, 54.96916],
                [9.819166, 54.946663],
                [9.829166, 54.94194],
                [9.836943, 54.93972],
                [9.842222000000106, 54.939995],
                [9.84417, 54.942215],
                [9.843611, 54.945274],
                [9.83888800000011, 54.970551],
                [9.836111, 54.976387],
                [9.798887, 55.01111],
                [9.793610000000115, 55.014999],
                [9.782776, 55.015549],
                [9.741943, 55.012215],
                [9.718054000000109, 55.00944],
                [9.700832, 55.00972],
                [9.696665, 55.010551],
                [9.681110000000103, 55.015274],
                [9.674721, 55.018326],
                [9.63222100000013, 55.046944],
                [9.630554, 55.04943800000012],
                [9.630833, 55.052773],
                [9.639444, 55.058609],
                [9.66472, 55.067772],
                [9.707777000000135, 55.080826000000116],
                [9.716944000000126, 55.0825],
                [9.754166, 55.08444],
                [9.77194, 55.080826000000116],
                [9.792500000000132, 55.07499700000011],
              ],
            ],
            [
              [
                [10.756943, 54.777222],
                [10.714722000000108, 54.72499800000014],
                [10.703609, 54.725555],
                [10.697222, 54.729164],
                [10.688332, 54.737495],
                [10.674999, 54.75388],
                [10.655554, 54.802498],
                [10.651943, 54.83721900000012],
                [10.68194, 54.908607],
                [10.693609, 54.922218],
                [10.736666000000127, 54.959717000000126],
                [10.76639, 54.97694],
                [10.773333, 54.979721],
                [10.790277, 54.98389],
                [10.796944, 54.98694],
                [10.801388, 54.991104],
                [10.85055, 55.044998],
                [10.886389000000122, 55.104721],
                [10.891109, 55.113052],
                [10.907499, 55.138611],
                [10.91139, 55.14361],
                [10.925833, 55.155273],
                [10.93222, 55.158882],
                [10.935833, 55.160271],
                [10.944443, 55.1616590000001],
                [10.949165, 55.16111],
                [10.955, 55.157494],
                [10.958887, 55.15277100000014],
                [10.95972, 55.149994],
                [10.958887, 55.14444],
                [10.936943, 55.09],
                [10.93111, 55.075829],
                [10.91055, 55.02833],
                [10.89777800000013, 55.001106],
                [10.895832, 54.997772],
                [10.88611, 54.988884],
                [10.876944, 54.98333],
                [10.857777000000112, 54.967773],
                [10.838888, 54.943329],
                [10.786943, 54.84388700000011],
                [10.756943, 54.777222],
              ],
            ],
            [
              [
                [15.051666, 54.99499500000013],
                [15.042500000000132, 54.99472],
                [14.942499000000112, 55.013329],
                [14.881943, 55.028885],
                [14.746944, 55.065277],
                [14.729443, 55.072777],
                [14.679722, 55.099716],
                [14.677776, 55.101944],
                [14.698889, 55.214996],
                [14.744165, 55.29249600000014],
                [14.746387, 55.295555],
                [14.759998, 55.304443000000106],
                [14.763887, 55.30555],
                [14.769999, 55.30555],
                [14.798611, 55.281944000000124],
                [14.80555500000014, 55.276108],
                [14.81278, 55.2691650000001],
                [14.82, 55.260826],
                [14.825277, 55.25694],
                [14.83861, 55.250549],
                [14.88722, 55.22943900000013],
                [14.9975, 55.18721800000014],
                [15.064999, 55.162498],
                [15.07361, 55.159721],
                [15.090832, 55.155273],
                [15.123055, 55.148888],
                [15.134165, 55.144165],
                [15.141109, 55.138611],
                [15.148611, 55.12917],
                [15.15, 55.089165],
                [15.148333, 55.0825],
                [15.107222, 55.02583],
                [15.10333, 55.02055400000012],
                [15.07667, 55.001106],
                [15.061388, 54.99638],
                [15.051666, 54.99499500000013],
              ],
            ],
            [
              [
                [8.46361, 55.33416],
                [8.45278, 55.333885],
                [8.439165, 55.339996],
                [8.429722, 55.34805300000011],
                [8.403055, 55.37944],
                [8.388887, 55.398048],
                [8.356943, 55.45221700000013],
                [8.360277, 55.45777],
                [8.365555, 55.461662],
                [8.38083300000011, 55.466385],
                [8.389444, 55.468048000000124],
                [8.401388, 55.4675],
                [8.45833, 55.42638],
                [8.461111, 55.421387],
                [8.47333, 55.342499],
                [8.471388, 55.336388],
                [8.46361, 55.33416],
              ],
            ],
            [
              [
                [10.745277000000101, 55.482216],
                [10.79055, 55.362778],
                [10.82833, 55.306664],
                [10.834721, 55.293884],
                [10.834444, 55.29027600000012],
                [10.815832, 55.20527600000014],
                [10.81167, 55.186386],
                [10.785555000000102, 55.12805],
                [10.782776, 55.122498],
                [10.779444, 55.117775],
                [10.740276, 55.06721],
                [10.733332000000132, 55.064438],
                [10.725555, 55.062218],
                [10.66555, 55.060555000000136],
                [10.627222, 55.060829],
                [10.616388000000143, 55.060555000000136],
                [10.598888000000102, 55.05805],
                [10.584166, 55.052773],
                [10.529444, 55.02944200000013],
                [10.519444, 55.02861],
                [10.49778, 55.028885],
                [10.15278, 55.08444],
                [10.13528, 55.117218],
                [10.150555, 55.121941000000106],
                [10.154444, 55.126938],
                [10.15278, 55.132774],
                [10.15, 55.137497],
                [10.11861, 55.17889],
                [10.108332, 55.186386],
                [10.098610000000122, 55.18805],
                [10.005833, 55.193329],
                [9.896944, 55.279716],
                [9.89667, 55.28583],
                [9.888332, 55.33666],
                [9.88722, 55.34221600000012],
                [9.810833, 55.436661],
                [9.768055, 55.466942],
                [9.72889, 55.47416],
                [9.684999, 55.49110400000012],
                [9.678333, 55.494438000000116],
                [9.675554, 55.49916100000013],
                [9.679998000000126, 55.503609],
                [9.74861, 55.540276],
                [9.81305, 55.547493],
                [9.82416, 55.54722],
                [9.832499, 55.54471600000011],
                [9.834721000000116, 55.539993],
                [9.835278, 55.5275],
                [9.8375, 55.522499],
                [9.843332, 55.518883],
                [9.85639, 55.512497],
                [9.864721, 55.509995],
                [9.883333, 55.505829],
                [9.895277000000135, 55.505554],
                [9.904999, 55.505829],
                [9.921665, 55.50972],
                [9.935833, 55.515],
                [10.0003, 55.541264000000126],
                [10.073889, 55.556664000000126],
                [10.124722, 55.568054],
                [10.148611, 55.57416500000011],
                [10.164721, 55.578606],
                [10.177776, 55.584442],
                [10.2125, 55.59888],
                [10.2897210000001, 55.614998],
                [10.29889, 55.616661],
                [10.309721, 55.616943],
                [10.327221000000122, 55.61193800000012],
                [10.39917, 55.588882],
                [10.405554, 55.585548],
                [10.484722, 55.53249],
                [10.473610000000122, 55.515],
                [10.452221, 55.481667],
                [10.445276, 55.47861],
                [10.427776, 55.468048000000124],
                [10.42222, 55.464439],
                [10.416111, 55.452774],
                [10.4175, 55.44722],
                [10.420277, 55.442497],
                [10.42555, 55.438606],
                [10.437498, 55.43777],
                [10.46889, 55.437218],
                [10.478611, 55.438049],
                [10.60027700000012, 55.482773],
                [10.60611, 55.486382],
                [10.60889, 55.49249300000014],
                [10.61417, 55.51944],
                [10.6175, 55.563889],
                [10.612778, 55.592499],
                [10.607222, 55.602493],
                [10.603333, 55.607216],
                [10.610554, 55.617218],
                [10.613888, 55.618607],
                [10.619165, 55.619164],
                [10.62694, 55.616661],
                [10.63444, 55.610275],
                [10.658054, 55.589996],
                [10.662498, 55.585274],
                [10.744444000000101, 55.496666],
                [10.747221, 55.49110400000012],
                [10.745277000000101, 55.482216],
              ],
            ],
            [
              [
                [12.579443, 55.551384],
                [12.570833000000107, 55.549438],
                [12.559999, 55.55055],
                [12.5525, 55.55305],
                [12.546665, 55.556664000000126],
                [12.527222, 55.57278],
                [12.52222, 55.57694],
                [12.5175, 55.58416],
                [12.511665, 55.606667],
                [12.51194, 55.6097180000001],
                [12.513887, 55.612495],
                [12.521839, 55.619118],
                [12.550278, 55.63694],
                [12.55861, 55.642494],
                [12.57833, 55.666382],
                [12.590277, 55.68110700000011],
                [12.60611, 55.69611],
                [12.60999900000013, 55.694717],
                [12.61611, 55.688049],
                [12.650122, 55.640987],
                [12.666943, 55.616661],
                [12.67639, 55.59888],
                [12.678333000000123, 55.593605],
                [12.67861, 55.59055],
                [12.675833, 55.588608000000136],
                [12.579443, 55.551384],
              ],
            ],
            [
              [
                [10.630554, 55.865555],
                [10.639999000000103, 55.86360900000011],
                [10.65083, 55.86360900000011],
                [10.65889, 55.86582900000013],
                [10.663332000000139, 55.8702770000001],
                [10.665833000000134, 55.876389],
                [10.666893, 55.892586],
                [10.666943000000117, 55.875549],
                [10.66555, 55.86860700000011],
                [10.613888, 55.76332900000011],
                [10.608055, 55.75972000000013],
                [10.60027700000012, 55.75750000000011],
                [10.58917, 55.75750000000011],
                [10.54472, 55.761108],
                [10.53417, 55.762497],
                [10.527498, 55.765831],
                [10.524721000000113, 55.77082800000011],
                [10.511665, 55.80194100000011],
                [10.511665, 55.80805],
                [10.516388, 55.970833],
                [10.523611, 55.98138],
                [10.540833, 55.99277500000011],
                [10.547499, 55.995827],
                [10.555277, 55.99805],
                [10.562498000000119, 55.996109000000104],
                [10.560833, 55.98944100000011],
                [10.557499, 55.984161],
                [10.556665000000123, 55.969719],
                [10.560555, 55.952774],
                [10.619999, 55.873055],
                [10.623888, 55.868889],
                [10.630554, 55.865555],
              ],
            ],
            [
              [
                [12.567221, 55.992218],
                [12.53, 55.94971],
                [12.525555, 55.94194],
                [12.516943, 55.92555],
                [12.515554, 55.91944100000012],
                [12.519165, 55.911385],
                [12.55887, 55.8672370000001],
                [12.566944, 55.857498],
                [12.57444, 55.848053],
                [12.575832, 55.845551000000114],
                [12.596388, 55.79888],
                [12.59861, 55.793327],
                [12.599998, 55.76722],
                [12.600277, 55.75444],
                [12.58417, 55.735275],
                [12.59944, 55.707222000000115],
                [12.600277, 55.704163],
                [12.59611, 55.69944],
                [12.561388, 55.666939],
                [12.549999, 55.657219],
                [12.540833, 55.650833],
                [12.524166, 55.639442000000145],
                [12.502777, 55.631386],
                [12.496944, 55.606667],
                [12.49555400000014, 55.603882],
                [12.49222200000014, 55.602219000000105],
                [12.486666000000127, 55.601662],
                [12.448055, 55.60416],
                [12.444721, 55.604996],
                [12.441666, 55.607216],
                [12.435833, 55.614166],
                [12.432499, 55.615555],
                [12.421665, 55.616386],
                [12.403889, 55.616661],
                [12.39138800000012, 55.613609],
                [12.380833, 55.609993000000145],
                [12.344444000000124, 55.593048],
                [12.339458, 55.590206],
                [12.269444000000135, 55.55999800000012],
                [12.253332, 55.552498],
                [12.24444, 55.54361],
                [12.20583, 55.50222],
                [12.19611, 55.490273000000116],
                [12.191666000000112, 55.482216],
                [12.190832, 55.47861],
                [12.190554000000134, 55.465553],
                [12.19278, 55.45777],
                [12.195276, 55.45221700000013],
                [12.200554000000125, 55.444717],
                [12.20666, 55.438332],
                [12.224165, 55.427773],
                [12.23166700000013, 55.42443800000012],
                [12.297777, 55.40305],
                [12.343611000000124, 55.401665],
                [12.363888, 55.39889],
                [12.37666, 55.395271],
                [12.399443, 55.381104],
                [12.430555, 55.361664],
                [12.43611, 55.357498000000135],
                [12.444166, 55.348328],
                [12.45194400000014, 55.336388],
                [12.453609, 55.330551],
                [12.462776, 55.29277],
                [12.461666, 55.286385],
                [12.449165, 55.276382],
                [12.443333, 55.272499],
                [12.425833000000125, 55.261665],
                [12.412498, 55.25582900000012],
                [12.333887, 55.234993],
                [12.32528, 55.23333],
                [12.315554, 55.23277300000012],
                [12.293888, 55.23305],
                [12.272499, 55.233887],
                [12.243889, 55.23693800000012],
                [12.20333, 55.22805000000011],
                [12.176109, 55.220551000000114],
                [12.036110000000122, 55.17333200000013],
                [12.025555, 55.169441],
                [12.014999000000103, 55.161385],
                [12.013054, 55.158607],
                [12.012777, 55.155548],
                [12.013054, 55.152496],
                [12.015276, 55.150276],
                [12.018055, 55.148605],
                [12.058054, 55.133049],
                [12.065554, 55.130554],
                [12.075, 55.12888],
                [12.086943, 55.12888],
                [12.096109, 55.1294400000001],
                [12.115000000000123, 55.132774],
                [12.130554, 55.13361],
                [12.149443000000133, 55.130272],
                [12.17333, 55.12277200000011],
                [12.17916, 55.11972],
                [12.18111, 55.117218],
                [12.181389000000138, 55.114166],
                [12.173611, 55.00499700000012],
                [12.173054, 55.001389],
                [12.171665, 54.998886],
                [12.166666, 54.995552],
                [12.158609, 54.99277500000011],
                [12.071943, 54.968605],
                [12.041111, 54.966385000000116],
                [12.013332, 54.96833],
                [11.99499900000012, 54.971382],
                [11.97833, 54.97916],
                [11.953333, 54.998886],
                [11.949999, 55.00027],
                [11.945833, 55.00193800000011],
                [11.936388, 55.003326],
                [11.91389, 55.004715],
                [11.91028, 55.003326],
                [11.896387000000118, 54.991386],
                [11.895555, 54.98832700000014],
                [11.896111, 54.98583200000013],
                [11.900913000000116, 54.97882],
                [11.859722, 55.013885],
                [11.840277, 55.023331],
                [11.730555, 55.060555000000136],
                [11.783054000000106, 55.1325],
                [11.797777, 55.15583],
                [11.741110000000106, 55.198883],
                [11.730833000000132, 55.20361],
                [11.717777, 55.20666],
                [11.69451, 55.20760300000012],
                [11.683332, 55.204163],
                [11.658333, 55.18721800000014],
                [11.61222, 55.18721800000014],
                [11.553055, 55.190826],
                [11.543055, 55.192772000000105],
                [11.518888, 55.199997],
                [11.453888, 55.212494],
                [11.42778, 55.21583],
                [11.41694, 55.21583],
                [11.400276, 55.21222],
                [11.350832, 55.201385],
                [11.323055, 55.190552],
                [11.30611, 55.188889],
                [11.27277800000013, 55.192772000000105],
                [11.262499, 55.19444],
                [11.253054, 55.196388],
                [11.246666, 55.19971],
                [11.244165, 55.20444],
                [11.187777, 55.338882000000126],
                [11.218054, 55.393608],
                [11.217222, 55.399162],
                [11.203609000000142, 55.44888300000014],
                [11.149166, 55.56749700000012],
                [11.144444, 55.5774990000001],
                [11.089167, 55.662773],
                [11.083611, 55.669998],
                [11.075277, 55.672775000000115],
                [10.994165, 55.692497],
                [10.879999, 55.729439],
                [10.87361, 55.7325],
                [10.878054, 55.736938],
                [10.88722, 55.738327],
                [10.897221, 55.739166000000125],
                [10.940832000000114, 55.738884],
                [10.953054, 55.73805],
                [11.129444, 55.721664],
                [11.138611, 55.713608],
                [11.152777000000128, 55.707771],
                [11.168610000000115, 55.70277],
                [11.18916, 55.699165],
                [11.201111, 55.698051],
                [11.211111, 55.698883],
                [11.34333, 55.74749800000012],
                [11.486944, 55.84166],
                [11.49638700000014, 55.85083],
                [11.500000000000114, 55.85611],
                [11.506388, 55.867218],
                [11.511665, 55.8794400000001],
                [11.5158330000001, 55.891937],
                [11.516388, 55.89833],
                [11.51028, 55.91416],
                [11.50778, 55.918884],
                [11.491665, 55.930275],
                [11.478611, 55.93694],
                [11.470276000000126, 55.939438],
                [11.449165, 55.94249700000012],
                [11.379721, 55.946938],
                [11.359722, 55.94916500000011],
                [11.283333, 55.971382],
                [11.278055000000109, 55.975273],
                [11.274166, 55.97943900000013],
                [11.273333, 55.991661000000136],
                [11.31278, 55.98111],
                [11.409166, 55.961388],
                [11.60639, 55.936386],
                [11.664444000000117, 55.94166600000011],
                [11.706388000000118, 55.95082900000011],
                [11.737778000000105, 55.959442],
                [11.74472, 55.962494],
                [11.752777, 55.964439],
                [11.76389, 55.964722],
                [11.772778, 55.962219],
                [11.778610000000128, 55.95832800000011],
                [11.781944, 55.95416300000011],
                [11.778332, 55.948608],
                [11.73972, 55.92139],
                [11.670277000000112, 55.890549],
                [11.67055, 55.814163],
                [11.7175, 55.793327],
                [11.727499000000137, 55.794716],
                [11.732777, 55.794441],
                [11.73639, 55.7930530000001],
                [11.745277000000101, 55.784164],
                [11.765554, 55.75861],
                [11.79972, 55.687218],
                [11.799999, 55.683884],
                [11.79444, 55.66166],
                [11.819721, 55.674721],
                [11.822498, 55.676666],
                [11.825554, 55.682495],
                [11.832083000000125, 55.707016000000124],
                [11.843611, 55.764442],
                [11.902777, 55.925827],
                [11.905277, 55.927773],
                [11.914165, 55.929718],
                [11.924999000000128, 55.92889],
                [11.941111, 55.924438],
                [11.959444000000133, 55.917221],
                [11.986944, 55.90472],
                [11.99278, 55.901108],
                [11.998888, 55.89444],
                [12.001389, 55.88916],
                [12.035276, 55.806389],
                [12.04055, 55.793327],
                [12.055555, 55.751389],
                [12.05694, 55.742218],
                [12.056389, 55.736107],
                [12.054443, 55.729996],
                [12.050833, 55.724442000000124],
                [12.045555, 55.720551],
                [12.031111, 55.71527100000014],
                [12.02611, 55.714722],
                [12.009722, 55.71527100000014],
                [11.970554000000106, 55.717499],
                [11.936666, 55.676941],
                [11.935833, 55.6533280000001],
                [12.05722, 55.6533280000001],
                [12.061943, 55.658051000000114],
                [12.092222, 55.698326],
                [12.093887000000109, 55.711105],
                [12.092222, 55.722496],
                [12.090832, 55.72805],
                [12.087776, 55.738884],
                [12.07222, 55.76453800000013],
                [12.042221, 55.91917],
                [12.03972, 55.924164],
                [12.014721, 55.956108],
                [12.007500000000107, 55.959442],
                [11.97917, 55.95666],
                [11.933887, 55.949997],
                [11.886665, 55.93694],
                [11.87611, 55.936104],
                [11.866388, 55.93721800000014],
                [11.853611, 55.943886000000134],
                [11.848610000000122, 55.947777],
                [11.845833, 55.9524990000001],
                [11.84833, 55.958611],
                [11.859444, 55.966660000000104],
                [11.865833, 55.969719],
                [11.919167, 55.994438],
                [12.174166, 56.103607000000125],
                [12.200277, 56.11222],
                [12.275, 56.12722],
                [12.290554, 56.12888],
                [12.301666, 56.128609],
                [12.312498000000119, 56.12722],
                [12.331388, 56.124161],
                [12.51417, 56.08777600000013],
                [12.533609, 56.080826000000116],
                [12.612499, 56.045273],
                [12.618889, 56.041939],
                [12.61972, 56.039444],
                [12.618055, 56.03388200000012],
                [12.593887, 56.004715],
                [12.58417, 55.999443],
                [12.573332000000107, 55.995827],
                [12.567221, 55.992218],
              ],
            ],
            [
              [
                [11.565832, 56.67083000000014],
                [11.556665, 56.66944100000012],
                [11.545832000000132, 56.67083000000014],
                [11.503054, 56.70166],
                [11.503332000000114, 56.707771],
                [11.51028, 56.710831],
                [11.637777, 56.722771],
                [11.648054, 56.723328],
                [11.64861100000013, 56.719994],
                [11.565832, 56.67083000000014],
              ],
            ],
            [
              [
                [8.924721, 56.91861],
                [8.878887000000134, 56.79860700000012],
                [8.831388, 56.743332],
                [8.77, 56.69360400000011],
                [8.766943, 56.692215],
                [8.744999, 56.68722],
                [8.734999, 56.685555],
                [8.655277, 56.67416400000013],
                [8.63694, 56.69722000000013],
                [8.603054, 56.72583],
                [8.563889000000131, 56.73722],
                [8.55472200000014, 56.738884],
                [8.542776000000117, 56.738609],
                [8.52472, 56.731384],
                [8.519722, 56.73111],
                [8.514166, 56.731941],
                [8.510832000000107, 56.733604],
                [8.509165, 56.73555],
                [8.509722, 56.741661000000136],
                [8.546110000000112, 56.793327],
                [8.617005, 56.830849],
                [8.647499, 56.88721],
                [8.65, 56.889442],
                [8.658054000000106, 56.89138800000012],
                [8.66889, 56.892776],
                [8.696943, 56.89222],
                [8.733332, 56.894165],
                [8.73889, 56.894722000000115],
                [8.81361, 56.904999],
                [8.817221, 56.906662],
                [8.82639, 56.914719],
                [8.83917, 56.935555],
                [8.85333, 56.95166000000012],
                [8.855833, 56.953888],
                [8.85972, 56.95527600000014],
                [8.865276, 56.955551],
                [8.899721, 56.95527600000014],
                [8.91083, 56.94832600000012],
                [8.924721, 56.92249],
                [8.924721, 56.91861],
              ],
            ],
            [
              [
                [9.974274, 57.07173200000011],
                [10.12361, 57.018326000000116],
                [10.146944, 57.0075],
                [10.157499, 57.003052],
                [10.179443000000106, 56.994164],
                [10.20472100000012, 56.987495],
                [10.218054, 56.984161],
                [10.22833, 56.982498],
                [10.24583200000012, 56.981941],
                [10.311891, 56.981304],
                [10.288055, 56.963051],
                [10.282221, 56.952217],
                [10.272221, 56.926384],
                [10.26916, 56.917221],
                [10.26833, 56.90416],
                [10.281111, 56.825554],
                [10.286110000000122, 56.801666],
                [10.286943000000122, 56.798882000000106],
                [10.305277, 56.748055],
                [10.24055, 56.717773],
                [10.15944, 56.720551],
                [10.154444, 56.719994],
                [9.866388000000143, 56.65028],
                [9.88639, 56.64194],
                [9.93305400000014, 56.641663],
                [10.003611, 56.65916],
                [10.077221, 56.686104],
                [10.17722, 56.696388],
                [10.31611, 56.69611],
                [10.33861, 56.695274],
                [10.3475, 56.689995],
                [10.353333, 56.6827770000001],
                [10.36055, 56.670273],
                [10.361944, 56.664444],
                [10.36360900000011, 56.645],
                [10.36360900000011, 56.638885],
                [10.35861, 56.631660000000124],
                [10.34094, 56.62260400000014],
                [10.331989, 56.616249],
                [10.329277, 56.614441],
                [10.31278, 56.611774],
                [10.307943, 56.610443],
                [10.285276, 56.600555],
                [10.273333, 56.59305],
                [10.245554, 56.57332600000012],
                [10.218887, 56.55305],
                [10.210554000000116, 56.535553],
                [10.187777, 56.4686],
                [10.230833, 56.47305],
                [10.22611, 56.489166],
                [10.224165, 56.506943],
                [10.223888000000102, 56.53833],
                [10.230276, 56.54944],
                [10.236666, 56.553604],
                [10.308666, 56.57815900000014],
                [10.329666, 56.56999200000013],
                [10.330499, 56.56616200000013],
                [10.358332000000132, 56.562218],
                [10.36055, 56.55971],
                [10.36861, 56.553329],
                [10.41472, 56.528053],
                [10.42583, 56.5241620000001],
                [10.508888000000127, 56.510826],
                [10.530277, 56.50833],
                [10.584999, 56.511383],
                [10.646111, 56.52166],
                [10.76528, 56.532494],
                [10.786943, 56.534164],
                [10.84417, 56.523888],
                [10.85111, 56.52082800000011],
                [10.86083200000013, 56.515831],
                [10.872499, 56.508888],
                [10.960833, 56.445],
                [10.963055, 56.439438],
                [10.921389, 56.343605],
                [10.907499, 56.328606],
                [10.744999, 56.163887],
                [10.673887, 56.18777],
                [10.683054, 56.189163],
                [10.68639, 56.19416],
                [10.69222, 56.206383],
                [10.69194, 56.21221900000012],
                [10.690554, 56.217773000000136],
                [10.684444, 56.22110700000013],
                [10.66861, 56.226662],
                [10.6475, 56.229439],
                [10.636389, 56.229439],
                [10.625555000000134, 56.228333],
                [10.617777, 56.22639],
                [10.611111, 56.22361],
                [10.589722, 56.207222],
                [10.555277, 56.17694100000011],
                [10.549166000000127, 56.166382],
                [10.547777, 56.16],
                [10.550554, 56.15471600000012],
                [10.554165, 56.149994],
                [10.57222, 56.132774],
                [10.57778, 56.123055],
                [10.57555, 56.116661],
                [10.571388, 56.111382],
                [10.559999000000118, 56.103607000000125],
                [10.553610000000106, 56.10083],
                [10.545832000000132, 56.098885],
                [10.535831, 56.09833],
                [10.524166, 56.09861],
                [10.515276, 56.10083],
                [10.39, 56.161942],
                [10.353054, 56.19527],
                [10.358332000000132, 56.199715],
                [10.4275, 56.22110700000013],
                [10.43694, 56.221939],
                [10.442499000000112, 56.21833],
                [10.479443000000117, 56.220551000000114],
                [10.508333, 56.265],
                [10.5075, 56.270828],
                [10.501944, 56.274162],
                [10.44861, 56.291939],
                [10.40055500000011, 56.290833],
                [10.24679, 56.178551],
                [10.231943, 56.16666],
                [10.219166, 56.151665],
                [10.216110000000128, 56.146111],
                [10.215, 56.139717],
                [10.220833, 56.129715],
                [10.226387000000102, 56.125832000000116],
                [10.238888, 56.11916],
                [10.244165, 56.114998],
                [10.255833, 56.095551],
                [10.261665000000107, 56.07972],
                [10.279722, 56.018883],
                [10.251944, 55.920555],
                [10.249722000000133, 55.91416],
                [10.193054, 55.83305400000012],
                [10.189165, 55.828049],
                [10.183054, 55.824715],
                [10.17305, 55.826942000000145],
                [10.150555, 55.834999],
                [10.143888000000118, 55.838333],
                [10.140276, 55.843048000000124],
                [10.137499000000105, 55.84833],
                [10.13499800000011, 55.85916],
                [10.132221, 55.864441],
                [10.126665, 55.86833200000012],
                [10.11972, 55.87166600000012],
                [10.105555, 55.87722],
                [10.09389, 55.878609],
                [10.061388, 55.878609],
                [10.04972, 55.878319],
                [10.01229, 55.8746220000001],
                [9.982498, 55.87166600000012],
                [9.871666, 55.84999800000014],
                [9.86555, 55.84638200000012],
                [9.867222, 55.8408280000001],
                [9.873888, 55.837776],
                [9.882221, 55.83527400000014],
                [9.892221, 55.833328],
                [9.922777, 55.82861],
                [9.956388, 55.825],
                [10, 55.82164],
                [10.040277, 55.81694],
                [10.04861, 55.81443800000011],
                [10.045832, 55.750275],
                [9.992777, 55.704994],
                [9.831665, 55.671387],
                [9.811666, 55.66944],
                [9.802221, 55.670273],
                [9.737498, 55.683773],
                [9.73267, 55.6852760000001],
                [9.72516, 55.689606],
                [9.68778, 55.703606],
                [9.671944, 55.708885],
                [9.649721, 55.711388],
                [9.638887000000125, 55.711388],
                [9.55722, 55.708885],
                [9.55, 55.705826],
                [9.552776, 55.70055],
                [9.558332, 55.696663],
                [9.566387, 55.694443],
                [9.574165, 55.69332900000012],
                [9.585278, 55.69332900000012],
                [9.616665, 55.695],
                [9.639444, 55.692772],
                [9.652777, 55.68666100000013],
                [9.721722, 55.653107],
                [9.819166, 55.604721],
                [9.70417, 55.53110500000014],
                [9.592777, 55.426109],
                [9.588333, 55.421661],
                [9.5875, 55.414719000000105],
                [9.590277000000128, 55.41027100000014],
                [9.59805, 55.401665],
                [9.603611000000114, 55.3975],
                [9.610275000000115, 55.39444],
                [9.599998000000141, 55.378326],
                [9.596943000000124, 55.373329000000126],
                [9.596666000000141, 55.367218],
                [9.66111, 55.28749800000014],
                [9.6675, 55.28083],
                [9.67333200000013, 55.277222],
                [9.683887, 55.272774],
                [9.69444, 55.268883],
                [9.706944000000135, 55.265549],
                [9.71111100000013, 55.26111],
                [9.712221000000113, 55.258331],
                [9.711666, 55.244995],
                [9.711388000000113, 55.241661],
                [9.71, 55.23888],
                [9.68861, 55.196938],
                [9.683054, 55.19249700000012],
                [9.676388, 55.189995],
                [9.660555, 55.185272],
                [9.638611, 55.180832],
                [9.633888, 55.181664000000126],
                [9.619999, 55.19111],
                [9.606943000000115, 55.193886],
                [9.590555, 55.193054],
                [9.577221, 55.190552],
                [9.565277, 55.18721800000014],
                [9.489443000000108, 55.151939],
                [9.463055, 55.128609],
                [9.45917, 55.123886],
                [9.461943, 55.11805],
                [9.5075, 55.050278],
                [9.548611, 55.032494],
                [9.636389, 55.016388],
                [9.71917, 54.99472],
                [9.722776, 54.99305],
                [9.727499, 54.98944100000011],
                [9.73305, 54.982498000000135],
                [9.746666000000118, 54.947777],
                [9.76417, 54.901665],
                [9.768055, 54.891106],
                [9.75028, 54.84111],
                [9.747221, 54.8361],
                [9.742777, 54.831383],
                [9.737221, 54.827774],
                [9.726665, 54.827499],
                [9.627777, 54.851944],
                [9.620554, 54.85527000000013],
                [9.614166, 54.890549],
                [9.63361, 54.901108],
                [9.642776, 54.9025],
                [9.646944, 54.906944000000124],
                [9.648054000000116, 54.9138870000001],
                [9.643888, 54.91833],
                [9.638611, 54.922218],
                [9.63222100000013, 54.925278000000105],
                [9.612778000000105, 54.928329],
                [9.601944, 54.92860400000012],
                [9.593054, 54.926941],
                [9.502777, 54.86833200000012],
                [9.458055000000115, 54.838608000000136],
                [9.45278, 54.835],
                [9.448332000000107, 54.83027600000014],
                [9.445358, 54.825401],
                [9.414721, 54.833328],
                [9.3925, 54.83527400000014],
                [9.378611, 54.82972000000012],
                [9.368889, 54.82278],
                [9.36861, 54.820831],
                [9.358889, 54.812492],
                [9.342777, 54.808609000000104],
                [9.253611, 54.80888],
                [9.243055, 54.816383],
                [9.23361, 54.82444],
                [9.22805, 54.83416],
                [9.23361, 54.845551000000114],
                [9.22416, 54.853607],
                [9.168888, 54.86499800000013],
                [8.94111, 54.905548],
                [8.919998000000135, 54.908051],
                [8.8413010000001, 54.913689],
                [8.82889, 54.9138870000001],
                [8.785831, 54.9061],
                [8.763054, 54.898888],
                [8.754721000000131, 54.897217],
                [8.719444, 54.891106],
                [8.699444, 54.892776],
                [8.68611, 54.898888],
                [8.66454, 54.913094],
                [8.654722000000106, 54.981941],
                [8.676109, 55.114166],
                [8.561388000000136, 55.10083],
                [8.561943, 55.094719],
                [8.560833, 55.088051],
                [8.556389, 55.083328],
                [8.504166000000112, 55.061943],
                [8.49583200000012, 55.060272],
                [8.487499, 55.06277],
                [8.480833, 55.06583],
                [8.471388, 55.073608],
                [8.468054, 55.084999],
                [8.456944, 55.123886],
                [8.45833, 55.130554],
                [8.47, 55.169998000000135],
                [8.471943, 55.17582700000014],
                [8.47555, 55.181389],
                [8.483055, 55.19111],
                [8.488333000000125, 55.195],
                [8.506388, 55.19749500000012],
                [8.55805400000014, 55.19416],
                [8.568054000000132, 55.193329],
                [8.585554, 55.188606],
                [8.592777, 55.185555],
                [8.593616, 55.179817],
                [8.588333, 55.176384],
                [8.567221000000131, 55.16861],
                [8.561666, 55.164719],
                [8.553888, 55.154442],
                [8.554443, 55.149719],
                [8.56916600000011, 55.144165],
                [8.58475, 55.140495],
                [8.632158000000118, 55.13239],
                [8.643888, 55.13110400000011],
                [8.68361, 55.1325],
                [8.688889, 55.136383],
                [8.691387000000134, 55.14222],
                [8.692221, 55.1491620000001],
                [8.689444, 55.160271],
                [8.661388000000102, 55.203331],
                [8.658054000000106, 55.258606],
                [8.658609, 55.301666],
                [8.662498, 55.31360600000011],
                [8.663887000000102, 55.320549],
                [8.66222, 55.3325],
                [8.63805, 55.402771],
                [8.623888, 55.427498],
                [8.612499000000128, 55.434715],
                [8.599443, 55.44111],
                [8.589722, 55.44305400000013],
                [8.536110000000122, 55.449165],
                [8.48, 55.453888],
                [8.468054, 55.454163],
                [8.44972, 55.451942],
                [8.439999, 55.45221700000013],
                [8.30749900000012, 55.553329],
                [8.256943, 55.49110400000012],
                [8.104166000000134, 55.53777300000013],
                [8.091389, 55.54471600000011],
                [8.087221, 55.548882],
                [8.087221, 55.554993],
                [8.093332, 55.565826],
                [8.11944, 55.59333],
                [8.126665000000116, 55.603333],
                [8.13944400000014, 55.624718],
                [8.17861, 55.710548],
                [8.18222, 55.72305300000011],
                [8.185555000000136, 55.74305],
                [8.183611, 55.75527],
                [8.16639, 55.84833],
                [8.15333, 55.899162],
                [8.14305, 55.93805],
                [8.134443, 55.959442],
                [8.126665000000116, 55.979721],
                [8.12611, 55.983055],
                [8.127222, 55.98555],
                [8.130833, 55.98693800000012],
                [8.13944400000014, 55.984718],
                [8.1475, 55.97694400000012],
                [8.152222000000108, 55.968605],
                [8.154722, 55.96361],
                [8.158333, 55.953606],
                [8.161943000000122, 55.942772],
                [8.168055, 55.920555],
                [8.173332, 55.897499],
                [8.18222, 55.83944],
                [8.183332, 55.814720000000136],
                [8.186388000000136, 55.809998],
                [8.193609, 55.80805],
                [8.202221, 55.809998],
                [8.276667, 55.834999],
                [8.32389, 55.85611],
                [8.3941650000001, 55.891937],
                [8.397221, 55.897499],
                [8.38528, 55.92333],
                [8.31694, 56.010826],
                [8.31694, 56.01722000000012],
                [8.313055, 56.04666],
                [8.312498, 56.050278000000105],
                [8.31111, 56.053055],
                [8.308887, 56.054718],
                [8.270832, 56.07499700000011],
                [8.255, 56.082771],
                [8.22389, 56.092773],
                [8.146111, 56.111107],
                [8.141109, 56.111664],
                [8.137499, 56.110832],
                [8.141109, 56.10249],
                [8.145277000000135, 56.080826000000116],
                [8.14639, 56.071106],
                [8.14639, 56.067497],
                [8.1425, 55.999161],
                [8.14194300000014, 55.996384],
                [8.133333, 55.994164],
                [8.127222, 55.994438],
                [8.119165, 55.996941],
                [8.113888, 56.000832],
                [8.108332, 56.01777600000014],
                [8.10111, 56.052216],
                [8.10166500000014, 56.071388],
                [8.10555, 56.11805],
                [8.12278, 56.3491590000001],
                [8.11999900000012, 56.450272],
                [8.118332, 56.53083],
                [8.12083200000012, 56.549995],
                [8.12278, 56.556107],
                [8.156111, 56.63777],
                [8.165277, 56.6533280000001],
                [8.175554, 56.66777],
                [8.194721, 56.69138],
                [8.209166, 56.707771],
                [8.212221, 56.70944200000014],
                [8.216665, 56.71054800000013],
                [8.221109, 56.70944200000014],
                [8.22416, 56.707771],
                [8.229166, 56.703331],
                [8.237778000000105, 56.6877750000001],
                [8.223331, 56.66499],
                [8.211388, 56.653885],
                [8.206388, 56.646385],
                [8.203888, 56.638054],
                [8.2058320000001, 56.635551],
                [8.24972, 56.604996],
                [8.32722, 56.579994],
                [8.390554000000122, 56.582222],
                [8.40167, 56.581108],
                [8.415833, 56.578331],
                [8.470833, 56.561104000000114],
                [8.51916, 56.54305],
                [8.592222, 56.50388],
                [8.626665, 56.478607000000125],
                [8.629721, 56.47666],
                [8.632776, 56.47527300000013],
                [8.646944000000133, 56.472771],
                [8.653055, 56.472771],
                [8.728333, 56.48222],
                [8.739443000000108, 56.486382],
                [8.745832, 56.49305],
                [8.747221, 56.498886],
                [8.756914, 56.549],
                [8.758055000000127, 56.549721],
                [8.763054, 56.553886],
                [8.765554000000122, 56.556389],
                [8.766109, 56.558609000000104],
                [8.764444, 56.56443800000011],
                [8.759443, 56.568604],
                [8.729443000000117, 56.57944],
                [8.712776, 56.58416],
                [8.70666, 56.587776],
                [8.680832, 56.614166],
                [8.68028, 56.617218],
                [8.68111, 56.619995],
                [8.838333, 56.715828],
                [8.845554000000106, 56.729439],
                [8.862778, 56.750832000000116],
                [8.873055, 56.762497],
                [8.952499, 56.804718],
                [8.9675, 56.80583],
                [9.070000000000107, 56.80778],
                [9.07557, 56.807449],
                [9.105276000000117, 56.79583],
                [9.111387, 56.79277000000013],
                [9.113333, 56.790276],
                [9.152498, 56.70388800000012],
                [9.144999, 56.70083],
                [9.134722, 56.693329],
                [9.055277, 56.63055400000013],
                [9.053333, 56.628052],
                [9.043333, 56.602219000000105],
                [9.043333, 56.599159],
                [9.04611, 56.590553000000114],
                [9.055555, 56.571663],
                [9.05861, 56.56694],
                [9.064165000000116, 56.56305],
                [9.073332000000107, 56.561386],
                [9.081388, 56.563332000000116],
                [9.09111, 56.568886],
                [9.093611, 56.57139],
                [9.101387, 56.583611],
                [9.100277, 56.589996],
                [9.09833, 56.592773000000136],
                [9.097500000000139, 56.59861000000012],
                [9.099443000000122, 56.60443900000013],
                [9.103888, 56.609161],
                [9.106943, 56.61055],
                [9.177776, 56.626663],
                [9.210833, 56.63304900000014],
                [9.225832, 56.63444],
                [9.248888, 56.633331],
                [9.274166, 56.629997],
                [9.280054, 56.62316],
                [9.284056, 56.619164],
                [9.284389, 56.615334],
                [9.28355, 56.611832],
                [9.281944, 56.604164],
                [9.273333, 56.602219000000105],
                [9.264999000000103, 56.599159],
                [9.25166, 56.583328],
                [9.25083, 56.58027600000014],
                [9.2675, 56.558327],
                [9.27833, 56.547775],
                [9.312498, 56.52555100000012],
                [9.31722, 56.524994],
                [9.321665, 56.52555100000012],
                [9.371111, 56.540833000000134],
                [9.373055000000136, 56.54305],
                [9.373888000000136, 56.546104],
                [9.37611, 56.55888],
                [9.376389, 56.564995],
                [9.370832, 56.568886],
                [9.361666000000127, 56.570549],
                [9.344166, 56.56638],
                [9.323056000000122, 56.67638],
                [9.32, 56.68139],
                [9.304443, 56.699997],
                [9.301943000000108, 56.702217],
                [9.294722, 56.70499],
                [9.288887, 56.705551],
                [9.28028, 56.70416],
                [9.276388, 56.703049000000135],
                [9.273333, 56.701111],
                [9.26638800000012, 56.695],
                [9.260555000000124, 56.69138],
                [9.186388, 56.66972],
                [9.180832000000123, 56.66944100000012],
                [9.173332, 56.67194400000011],
                [9.16972, 56.673882],
                [9.16611, 56.67805],
                [9.165, 56.892494],
                [9.178200000000118, 56.916031],
                [9.290277000000117, 56.99555],
                [9.301109, 57.000000000000114],
                [9.309444, 57.001938],
                [9.365555, 57.012215],
                [9.409721, 57.018326000000116],
                [9.42555, 57.02],
                [9.46694, 57.01944],
                [9.47805, 57.018883],
                [9.51694300000014, 57.01611],
                [9.521944, 57.015549],
                [9.551109, 57.007217],
                [9.559166000000118, 57.00471],
                [9.68611, 57.038605],
                [9.76417, 57.05332900000013],
                [9.774721, 57.054161],
                [9.80722, 57.050552],
                [9.853611, 57.04555],
                [9.939999000000114, 57.054161],
                [9.945, 57.05499300000014],
                [9.95167, 57.05832700000013],
                [9.966499, 57.066544],
                [9.974274, 57.07173200000011],
              ],
            ],
            [
              [
                [11.19583, 57.310829000000126],
                [11.079166, 57.2502750000001],
                [11.05833200000012, 57.24082900000013],
                [11.023888, 57.22972],
                [10.997499, 57.22333],
                [10.982222, 57.22166],
                [10.961943000000133, 57.238052],
                [10.949999000000105, 57.24582700000013],
                [10.93388700000014, 57.2502750000001],
                [10.922499, 57.250832],
                [10.907776, 57.248329],
                [10.896111, 57.24472],
                [10.884722, 57.24555],
                [10.874998, 57.24777200000011],
                [10.865, 57.25222],
                [10.855, 57.260826],
                [10.854443000000117, 57.26305],
                [10.860554, 57.26722],
                [10.918055, 57.301109],
                [10.921389, 57.302773],
                [11.02583, 57.320274],
                [11.144444, 57.33138300000013],
                [11.15028, 57.33166],
                [11.183887, 57.3274990000001],
                [11.188889, 57.32638500000013],
                [11.191944, 57.324997],
                [11.194443, 57.322777],
                [11.19694, 57.31416300000012],
                [11.19583, 57.310829000000126],
              ],
            ],
            [
              [
                [10.43249900000012, 57.592216],
                [10.43111, 57.579163],
                [10.435833000000116, 57.551384],
                [10.438332000000116, 57.543327],
                [10.44472100000013, 57.532776000000126],
                [10.448332000000107, 57.52833],
                [10.453054, 57.5241620000001],
                [10.528055000000109, 57.41389],
                [10.54222, 57.22999600000014],
                [10.534721, 57.223885],
                [10.53083, 57.22166],
                [10.51333, 57.214722],
                [10.45333, 57.184715],
                [10.442778, 57.176666],
                [10.423887, 57.157219],
                [10.414165, 57.143326],
                [10.33662, 56.991665],
                [10.24499900000012, 56.9897160000001],
                [10.22805, 56.991104],
                [10.218611, 56.992775],
                [10.193054, 57.002777],
                [10.151943, 57.02471900000012],
                [10.11972, 57.041664],
                [10.031944, 57.083046],
                [10.02083, 57.086929],
                [10.01166, 57.089157],
                [10.006666, 57.089989],
                [10.00028, 57.08967],
                [9.5, 57.046387],
                [9.289444000000117, 57.00471],
                [9.269722, 56.998329],
                [9.25528, 56.996109],
                [9.243889000000138, 56.99555],
                [9.23389, 56.997215],
                [9.221388, 57.00138900000013],
                [9.20361, 57.011665],
                [9.181389, 57.023888],
                [9.15917, 57.035271],
                [9.140554000000122, 57.04277],
                [9.115549, 57.052773000000116],
                [9.118610000000103, 57.04805],
                [9.12028, 57.03916],
                [9.115833, 57.034996],
                [9.107498000000135, 57.03249],
                [9.03861000000012, 57.01194],
                [9.032776, 57.011665],
                [9.027777000000128, 57.01277],
                [9.027222, 57.015549],
                [9.028610000000128, 57.018608],
                [9.0275, 57.021111],
                [9.021387, 57.024437],
                [9.01055, 57.025833],
                [9.000555, 57.024994000000106],
                [8.885832000000107, 56.997498],
                [8.827166, 56.971069],
                [8.775, 56.95194],
                [8.766109, 56.94971],
                [8.754999, 56.950554],
                [8.73555, 56.95666],
                [8.724443000000122, 56.957497],
                [8.68111, 56.949997],
                [8.67333, 56.94722],
                [8.670832, 56.945274],
                [8.619165000000123, 56.88555],
                [8.617222, 56.873329],
                [8.617777, 56.863052],
                [8.616943000000106, 56.85694100000012],
                [8.611666000000127, 56.84861],
                [8.607498, 56.844162],
                [8.57249800000011, 56.81944],
                [8.563889000000131, 56.813606],
                [8.56, 56.812218],
                [8.533054, 56.803886],
                [8.51444, 56.800552],
                [8.50111, 56.7972180000001],
                [8.491665000000125, 56.792496],
                [8.48722, 56.788055],
                [8.48361, 56.782494],
                [8.48278, 56.779999],
                [8.46305500000011, 56.697777],
                [8.415797, 56.678127],
                [8.44171, 56.67435],
                [8.445214, 56.674011],
                [8.48838000000012, 56.67034],
                [8.51444, 56.66777],
                [8.519444000000135, 56.668610000000115],
                [8.53583, 56.673882],
                [8.550833, 56.68222],
                [8.57028, 56.688889],
                [8.58, 56.68972],
                [8.584999, 56.689163],
                [8.591389, 56.686104],
                [8.594999, 56.680832],
                [8.60722, 56.63055400000013],
                [8.59889, 56.60833],
                [8.5975, 56.60611],
                [8.554998, 56.582497],
                [8.549444, 56.582222],
                [8.54139, 56.584442],
                [8.532221, 56.589439],
                [8.524166, 56.595276000000126],
                [8.47805, 56.631386],
                [8.4591, 56.642181],
                [8.457266, 56.645184],
                [8.453599, 56.64918],
                [8.448765, 56.65301],
                [8.43693, 56.65852],
                [8.398278, 56.672043000000144],
                [8.36833, 56.677216],
                [8.248888, 56.698608],
                [8.240276, 56.707222000000115],
                [8.23860900000011, 56.712776],
                [8.235554, 56.736938],
                [8.234999, 56.755554],
                [8.235832, 56.768883],
                [8.236387, 56.775551],
                [8.245832, 56.806664],
                [8.25611, 56.822777],
                [8.26417, 56.83277],
                [8.29055, 56.860275000000115],
                [8.336666, 56.905548],
                [8.378887, 56.945549],
                [8.450554000000125, 57.004997],
                [8.577221000000122, 57.096107],
                [8.60389, 57.11472],
                [8.617222, 57.121666],
                [8.624166, 57.124443],
                [8.628611, 57.125275],
                [8.639444, 57.12471800000014],
                [8.654444, 57.121666],
                [8.713888, 57.10611],
                [8.737221, 57.102219],
                [8.766109, 57.101105],
                [8.804998, 57.10388200000011],
                [8.846666, 57.10833],
                [8.89416, 57.11999500000013],
                [9.017221, 57.15361],
                [9.079721, 57.145271],
                [9.16139, 57.137497],
                [9.19611, 57.136108],
                [9.243889000000138, 57.13694],
                [9.26528, 57.138885],
                [9.38416500000011, 57.150276],
                [9.39, 57.151108000000136],
                [9.406944000000124, 57.156944],
                [9.458887, 57.176109],
                [9.47361, 57.181664],
                [9.49583200000012, 57.190277],
                [9.540833, 57.213882],
                [9.54666, 57.2175],
                [9.580555, 57.241104],
                [9.649443, 57.303329],
                [9.707777000000135, 57.364998],
                [9.720554, 57.37944],
                [9.731388, 57.395271],
                [9.763611, 57.435555],
                [9.772778, 57.444717],
                [9.793333000000132, 57.462219],
                [9.949720000000127, 57.583611],
                [9.960278, 57.588333],
                [9.971109, 57.589439],
                [10, 57.58972200000011],
                [10.04361, 57.588608000000136],
                [10.104166, 57.58972200000011],
                [10.12861, 57.590271],
                [10.16111, 57.592216],
                [10.18111, 57.594994],
                [10.218332, 57.602219000000105],
                [10.26694, 57.613052],
                [10.2897210000001, 57.62082700000013],
                [10.300833, 57.625549],
                [10.408333, 57.673607],
                [10.45333, 57.69749500000012],
                [10.51, 57.725273],
                [10.5375, 57.737495],
                [10.544167, 57.740273],
                [10.56111, 57.74528],
                [10.577221, 57.746666],
                [10.605276, 57.744164000000126],
                [10.644999, 57.737495],
                [10.645953000000134, 57.736267],
                [10.62194, 57.727776],
                [10.578054, 57.710831],
                [10.560276000000101, 57.7024990000001],
                [10.526388, 57.683609],
                [10.505554000000132, 57.666664],
                [10.48111, 57.645828],
                [10.461666, 57.628609],
                [10.454721, 57.622215],
                [10.447498, 57.61499800000013],
                [10.437777, 57.603333],
                [10.43249900000012, 57.592216],
              ],
            ],
          ],
        },
        id: 19,
        NAME: 'Denmark',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Austria',
          id: 20,
          label: 'Austria',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.085,
          year: '2023',
          centroid: [14.5501, 47.5162],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [13.833611, 48.773605],
              [13.858055, 48.770554],
              [13.88361, 48.763611],
              [13.99, 48.717773],
              [14.007221, 48.710274],
              [14.049166, 48.674721],
              [14.051388, 48.671944],
              [14.0525, 48.668327],
              [14.0525, 48.664162],
              [14.184166, 48.596107],
              [14.278332, 48.582497],
              [14.390276, 48.592499],
              [14.446388, 48.618889],
              [14.505554, 48.628326],
              [14.608889, 48.628883],
              [14.615, 48.628052],
              [14.652498, 48.609444],
              [14.656387, 48.607498],
              [14.70028, 48.581379],
              [14.704166, 48.583611],
              [14.706665, 48.586662],
              [14.718611, 48.602219],
              [14.720276, 48.605827],
              [14.721388, 48.643326],
              [14.715832, 48.652771],
              [14.714722, 48.660553],
              [14.722221, 48.684715],
              [14.72611, 48.69194],
              [14.730276, 48.698608],
              [14.812498, 48.781387],
              [14.815832, 48.783882],
              [14.830276, 48.787498],
              [14.836388, 48.787498],
              [14.849443, 48.786385],
              [14.885555, 48.782776],
              [14.958887, 48.794716],
              [14.984999, 48.939163],
              [14.978054, 48.973053],
              [14.978054, 48.977219],
              [14.98111, 48.984718],
              [14.996944, 49.0075],
              [15.011389, 49.015274],
              [15.025833, 49.018883],
              [15.031387, 49.018608],
              [15.065554, 49.014717],
              [15.156666, 48.999718],
              [15.301388, 48.987778],
              [15.353333, 48.985832],
              [15.364721, 48.983604],
              [15.3925, 48.97361],
              [15.451666, 48.951111],
              [15.509722, 48.921661],
              [15.519165, 48.918327],
              [15.546665, 48.912216],
              [15.564439, 48.909164],
              [15.584999, 48.899162],
              [15.683332, 48.864716],
              [15.68861, 48.863327],
              [15.746387, 48.858604],
              [15.849432, 48.859703],
              [15.964167, 48.804718],
              [16.021664, 48.777222],
              [16.060555, 48.760277],
              [16.081108, 48.754715],
              [16.103333, 48.75],
              [16.333054, 48.733055],
              [16.370552, 48.733887],
              [16.376389, 48.734444],
              [16.386387, 48.736382],
              [16.395275, 48.739441],
              [16.403332, 48.74305],
              [16.413055, 48.750549],
              [16.417774, 48.756943],
              [16.430832, 48.782219],
              [16.451664, 48.806389],
              [16.457497, 48.811943],
              [16.461941, 48.813332],
              [16.537498, 48.812775],
              [16.54361, 48.811943],
              [16.644997, 48.79055],
              [16.65583, 48.787773],
              [16.667221, 48.781387],
              [16.711666, 48.746384],
              [16.782776, 48.720551],
              [16.78833, 48.719162],
              [16.827221, 48.715828],
              [16.838608, 48.71666],
              [16.863052, 48.722221],
              [16.871944, 48.724998],
              [16.875832, 48.727219],
              [16.885277, 48.729439],
              [16.899719, 48.722221],
              [16.913055, 48.708885],
              [16.91861, 48.703331],
              [16.919998, 48.700272],
              [16.946182, 48.619064],
              [16.943333, 48.573326],
              [16.933331, 48.532776],
              [16.907497, 48.506943],
              [16.866943, 48.470276],
              [16.864441, 48.467216],
              [16.855831, 48.44944],
              [16.840275, 48.376389],
              [16.839996, 48.372215],
              [16.84222, 48.365273],
              [16.845276, 48.358604],
              [16.8475, 48.355827],
              [16.920555, 48.283882],
              [16.927219, 48.280273],
              [16.94972, 48.278049],
              [16.950832, 48.257774],
              [16.953888, 48.242775],
              [16.975277, 48.188332],
              [16.998016, 48.169701],
              [17.023331, 48.150276],
              [17.03075, 48.145859],
              [17.040051, 48.142464],
              [17.069145, 48.135265],
              [17.081108, 48.088333],
              [17.116665, 48.038605],
              [17.166386, 48.012497],
              [17.146942, 48],
              [17.108055, 47.971382],
              [17.060555, 47.876938],
              [17.054443, 47.847221],
              [17.054996, 47.799721],
              [17.058609, 47.789444],
              [17.068607, 47.768326],
              [17.071663, 47.728607],
              [17.053886, 47.709442],
              [16.955276, 47.694717],
              [16.910831, 47.690826],
              [16.824444, 47.683884],
              [16.768608, 47.684715],
              [16.761944, 47.685272],
              [16.7575, 47.686943],
              [16.737221, 47.700829],
              [16.734444, 47.703331],
              [16.729164, 47.713051],
              [16.725555, 47.727493],
              [16.723331, 47.730553],
              [16.715832, 47.734718],
              [16.635555, 47.760277],
              [16.612221, 47.759163],
              [16.561386, 47.75666],
              [16.555832, 47.756104],
              [16.450554, 47.698051],
              [16.426941, 47.671387],
              [16.425831, 47.668327],
              [16.429443, 47.666107],
              [16.44833, 47.659721],
              [16.493053, 47.64666],
              [16.590832, 47.629166],
              [16.602497, 47.628609],
              [16.624722, 47.635826],
              [16.630833, 47.635826],
              [16.636665, 47.63472],
              [16.645275, 47.631943],
              [16.648888, 47.629715],
              [16.663887, 47.617218],
              [16.668888, 47.611664],
              [16.713886, 47.543884],
              [16.705276, 47.521111],
              [16.655205, 47.458153],
              [16.592499, 47.425278],
              [16.482777, 47.418053],
              [16.470833, 47.419716],
              [16.459164, 47.419167],
              [16.454998, 47.41777],
              [16.451942, 47.415276],
              [16.450554, 47.41111],
              [16.450554, 47.407219],
              [16.456387, 47.368889],
              [16.491108, 47.283882],
              [16.491665, 47.279999],
              [16.477219, 47.261383],
              [16.47361, 47.259438],
              [16.469166, 47.257774],
              [16.444721, 47.244438],
              [16.420555, 47.213333],
              [16.420555, 47.20916],
              [16.421944, 47.205826],
              [16.452499, 47.148888],
              [16.456108, 47.146942],
              [16.461666, 47.146385],
              [16.466942, 47.146942],
              [16.505554, 47.114998],
              [16.510555, 47.009995],
              [16.510555, 47.00666],
              [16.506943, 47.004715],
              [16.497776, 47.00222],
              [16.481388, 47.000549],
              [16.445, 47.004715],
              [16.412498, 47.007774],
              [16.346943, 47.009995],
              [16.302776, 47.011383],
              [16.276665, 46.988052],
              [16.253609, 46.958328],
              [16.139721, 46.879997],
              [16.136108, 46.877777],
              [16.111805, 46.86972],
              [16.009308, 46.835487],
              [15.99361, 46.834717],
              [15.988609, 46.833611],
              [15.985554, 46.831108],
              [15.985554, 46.826942],
              [15.987778, 46.759163],
              [15.988054, 46.751106],
              [15.868332, 46.723053],
              [15.849722, 46.723328],
              [15.832777, 46.722221],
              [15.806665, 46.718605],
              [15.602499, 46.686661],
              [15.406111, 46.652496],
              [15.139444, 46.657219],
              [15.105276, 46.657219],
              [15.100555, 46.656105],
              [15.074408, 46.648571],
              [15.064444, 46.651939],
              [15.045832, 46.652222],
              [14.870554, 46.615829],
              [14.864443, 46.610832],
              [14.834999, 46.574715],
              [14.832499, 46.566666],
              [14.824999, 46.541382],
              [14.814722, 46.512772],
              [14.811666, 46.509995],
              [14.544998, 46.407494],
              [14.478054, 46.419441],
              [14.159443, 46.440826],
              [14.154165, 46.44194],
              [14.150555, 46.443886],
              [14.131666, 46.458328],
              [14.12611, 46.467773],
              [14.119165, 46.476662],
              [14.112499, 46.48111],
              [14.084721, 46.488609],
              [14.079721, 46.489716],
              [13.936943, 46.515831],
              [13.845554, 46.519997],
              [13.77611, 46.518326],
              [13.718655, 46.526611],
              [13.611111, 46.54805],
              [13.558054, 46.555832],
              [13.551943, 46.556664],
              [13.428888, 46.563049],
              [13.2575, 46.561943],
              [12.827499, 46.630272],
              [12.82361, 46.632217],
              [12.787777, 46.644997],
              [12.768888, 46.650833],
              [12.76222, 46.651108],
              [12.753332, 46.648331],
              [12.747929, 46.644493],
              [12.743332, 46.641388],
              [12.738609, 46.640274],
              [12.732498, 46.641106],
              [12.728054, 46.642494],
              [12.692499, 46.659721],
              [12.590277, 46.658882],
              [12.554443, 46.661659],
              [12.486174, 46.682365],
              [12.440554, 46.690826],
              [12.410276, 46.702774],
              [12.398333, 46.708328],
              [12.388887, 46.715553],
              [12.378611, 46.726662],
              [12.301666, 46.84111],
              [12.232222, 46.888885],
              [12.189722, 46.906105],
              [12.181389, 46.909721],
              [12.160276, 46.928055],
              [12.13611, 46.966942],
              [12.127777, 47.001663],
              [12.127222, 47.00972],
              [12.128887, 47.013329],
              [12.134165, 47.019165],
              [12.138332, 47.020828],
              [12.152777, 47.024437],
              [12.185276, 47.028885],
              [12.189999, 47.029999],
              [12.19861, 47.033882],
              [12.204443, 47.039162],
              [12.223888, 47.063049],
              [12.230833, 47.07222],
              [12.23111, 47.080826],
              [12.22611, 47.086662],
              [12.221666, 47.088333],
              [12.189165, 47.094719],
              [12.183054, 47.094444],
              [12.140131, 47.084812],
              [12.075277, 47.059441],
              [11.766666, 46.978882],
              [11.755833, 46.977493],
              [11.736387, 46.977776],
              [11.725832, 46.979996],
              [11.71361, 46.994164],
              [11.706665, 46.998604],
              [11.628611, 47.012497],
              [11.615276, 47.013054],
              [11.483889, 47.01416],
              [11.186388, 46.970276],
              [11.171389, 46.96666],
              [11.164444, 46.962219],
              [11.118055, 46.929993],
              [11.111666, 46.924995],
              [11.099443, 46.914993],
              [11.096666, 46.912498],
              [11.094444, 46.909164],
              [11.094721, 46.904999],
              [11.098888, 46.89444],
              [11.098055, 46.885277],
              [11.096666, 46.88166],
              [11.072498, 46.824997],
              [11.070276, 46.821938],
              [11.018888, 46.774162],
              [11.014721, 46.772499],
              [10.887777, 46.771111],
              [10.834166, 46.786942],
              [10.791666, 46.801384],
              [10.764444, 46.822777],
              [10.766109, 46.826385],
              [10.764444, 46.83416],
              [10.758055, 46.838882],
              [10.689444, 46.872215],
              [10.684721, 46.873604],
              [10.679443, 46.874718],
              [10.666943, 46.874718],
              [10.651388, 46.871941],
              [10.6425, 46.868889],
              [10.599722, 46.857773],
              [10.566387, 46.849159],
              [10.560833, 46.84861],
              [10.497776, 46.85527],
              [10.477777, 46.864441],
              [10.474443, 46.866943],
              [10.471235, 46.871353],
              [10.488913, 46.934212],
              [10.487499, 46.937775],
              [10.429998, 46.984161],
              [10.400833, 47.001106],
              [10.391109, 47.003609],
              [10.385555, 47.002777],
              [10.357222, 46.997215],
              [10.353611, 46.994995],
              [10.345833, 46.986382],
              [10.323332, 46.955551],
              [10.313332, 46.933609],
              [10.231388, 46.878883],
              [10.22361, 46.874992],
              [10.170555, 46.857216],
              [10.15111, 46.852776],
              [10.141807, 46.851341],
              [10.140276, 46.851105],
              [10.122776, 46.849716],
              [10.109444, 46.850273],
              [10.058887, 46.866386],
              [9.934999, 46.912773],
              [9.879444, 46.939156],
              [9.87611, 46.941658],
              [9.87361, 46.958603],
              [9.873333, 46.962769],
              [9.875555, 46.970543],
              [9.880833, 46.98082],
              [9.889444, 46.993324],
              [9.893055, 47.000267],
              [9.891943, 47.003876],
              [9.875555, 47.022491],
              [9.870277, 47.023598],
              [9.719444, 47.050278],
              [9.6325, 47.056664],
              [9.598635, 47.063835],
              [9.603611, 47.065826],
              [9.610277, 47.070274],
              [9.627222, 47.086388],
              [9.634998, 47.094994],
              [9.63611, 47.103607],
              [9.633888, 47.130554],
              [9.622776, 47.150551],
              [9.566387, 47.243889],
              [9.533569, 47.274544],
              [9.539999, 47.284164],
              [9.599722, 47.354164],
              [9.605276, 47.359993],
              [9.614443, 47.367493],
              [9.624422, 47.367252],
              [9.625832, 47.367218],
              [9.631388, 47.36805],
              [9.641666, 47.369995],
              [9.650555, 47.373055],
              [9.664999, 47.381386],
              [9.669998, 47.387772],
              [9.673054, 47.394997],
              [9.673332, 47.398605],
              [9.65361, 47.455551],
              [9.65111, 47.458328],
              [9.646944, 47.460274],
              [9.611666, 47.468887],
              [9.594166, 47.46833],
              [9.590277, 47.470276],
              [9.567499, 47.491104],
              [9.562222, 47.496666],
              [9.559721, 47.499718],
              [9.557772, 47.505783],
              [9.566724, 47.540451],
              [9.577914, 47.537418],
              [9.607064, 47.529514],
              [9.610482, 47.529514],
              [9.651506, 47.529514],
              [9.692531, 47.529514],
              [9.7292, 47.535297],
              [9.736387, 47.546944],
              [9.743055, 47.560829],
              [9.749443, 47.570831],
              [9.763054, 47.584717],
              [9.773611, 47.591385],
              [9.782499, 47.594444],
              [9.808332, 47.594719],
              [9.81361, 47.593605],
              [9.955, 47.539719],
              [10.043055, 47.495277],
              [10.231388, 47.381386],
              [10.232777, 47.373604],
              [10.231388, 47.369995],
              [10.211666, 47.322495],
              [10.173332, 47.274719],
              [10.221943, 47.275276],
              [10.228054, 47.275551],
              [10.232777, 47.276665],
              [10.274443, 47.288887],
              [10.329443, 47.308327],
              [10.337221, 47.312492],
              [10.339998, 47.314995],
              [10.429722, 47.396111],
              [10.473331, 47.435555],
              [10.474165, 47.43972],
              [10.469721, 47.476387],
              [10.469166, 47.480553],
              [10.467499, 47.483604],
              [10.458332, 47.491104],
              [10.436388, 47.52916],
              [10.426943, 47.576942],
              [10.429998, 47.57972],
              [10.434166, 47.581383],
              [10.443609, 47.583885],
              [10.4725, 47.591385],
              [10.478054, 47.591942],
              [10.482777, 47.590553],
              [10.484444, 47.587219],
              [10.484165, 47.582771],
              [10.569443, 47.540276],
              [10.690832, 47.553886],
              [10.909443, 47.518051],
              [10.971109, 47.403328],
              [10.97361, 47.400551],
              [10.978333, 47.399162],
              [10.98361, 47.398048],
              [11.008333, 47.395828],
              [11.02861, 47.395271],
              [11.095554, 47.396111],
              [11.112499, 47.396942],
              [11.296389, 47.428886],
              [11.457499, 47.512215],
              [11.505278, 47.509163],
              [11.554443, 47.515549],
              [11.574444, 47.519997],
              [11.577776, 47.521942],
              [11.583611, 47.527222],
              [11.683054, 47.584717],
              [11.919998, 47.614166],
              [12.006388, 47.624443],
              [12.059999, 47.620552],
              [12.111111, 47.614716],
              [12.141388, 47.611107],
              [12.195745, 47.608124],
              [12.199377, 47.61026],
              [12.20472, 47.61496],
              [12.206388, 47.618607],
              [12.207777, 47.62722],
              [12.206856, 47.639534],
              [12.201111, 47.657494],
              [12.455, 47.66777],
              [12.508888, 47.635277],
              [12.512777, 47.633331],
              [12.518055, 47.632217],
              [12.566666, 47.641937],
              [12.57639, 47.644165],
              [12.596943, 47.667496],
              [12.602777, 47.672775],
              [12.606943, 47.674438],
              [12.665833, 47.684998],
              [12.722776, 47.684441],
              [12.735554, 47.684166],
              [12.74472, 47.681107],
              [12.82361, 47.627495],
              [12.829166, 47.622215],
              [12.830832, 47.618889],
              [12.827776, 47.616386],
              [12.814444, 47.616943],
              [12.808887, 47.616386],
              [12.800278, 47.613052],
              [12.787777, 47.589439],
              [12.78611, 47.585831],
              [12.789444, 47.579437],
              [12.80361, 47.55722],
              [12.809721, 47.552216],
              [12.952686, 47.478477],
              [12.963055, 47.475555],
              [13.004999, 47.469444],
              [13.011665, 47.469162],
              [13.016666, 47.470276],
              [13.050278, 47.493889],
              [13.053055, 47.496384],
              [13.054998, 47.5],
              [13.100277, 47.640831],
              [13.099998, 47.644997],
              [13.08, 47.684441],
              [13.074999, 47.690277],
              [13.058332, 47.706108],
              [13.034443, 47.722221],
              [13.024443, 47.724998],
              [13.019165, 47.725273],
              [13.014166, 47.724159],
              [13.003332, 47.717773],
              [12.995554, 47.714165],
              [12.99111, 47.712494],
              [12.984999, 47.712219],
              [12.923611, 47.714722],
              [12.9175, 47.715553],
              [12.911943, 47.720833],
              [12.910831, 47.724442],
              [12.911388, 47.729164],
              [12.912498, 47.733055],
              [12.939722, 47.784721],
              [12.94861, 47.79277],
              [12.967777, 47.807777],
              [12.973331, 47.813332],
              [13.008888, 47.854164],
              [12.966665, 47.906944],
              [12.918888, 47.957771],
              [12.865342, 47.994598],
              [12.863194, 48],
              [12.858332, 48.012215],
              [12.853333, 48.017776],
              [12.8375, 48.029999],
              [12.805555, 48.049721],
              [12.792776, 48.059441],
              [12.768332, 48.079163],
              [12.764166, 48.085274],
              [12.754444, 48.105553],
              [12.753332, 48.109161],
              [12.754999, 48.116943],
              [12.758333, 48.123886],
              [12.760832, 48.12722],
              [12.7675, 48.131943],
              [12.867498, 48.200829],
              [12.874998, 48.204994],
              [13.017776, 48.259438],
              [13.154444, 48.292221],
              [13.258055, 48.298882],
              [13.27861, 48.303055],
              [13.291943, 48.307495],
              [13.313055, 48.315826],
              [13.334999, 48.328606],
              [13.394999, 48.366104],
              [13.419167, 48.38694],
              [13.421665, 48.389999],
              [13.423332, 48.393608],
              [13.435833, 48.423607],
              [13.439999, 48.435272],
              [13.457222, 48.513329],
              [13.457777, 48.517776],
              [13.447498, 48.544441],
              [13.443609, 48.550552],
              [13.435276, 48.556938],
              [13.434999, 48.561104],
              [13.441666, 48.565552],
              [13.450554, 48.568886],
              [13.505278, 48.583054],
              [13.515276, 48.585274],
              [13.526943, 48.584999],
              [13.602777, 48.568054],
              [13.651667, 48.554161],
              [13.657776, 48.549164],
              [13.666943, 48.537216],
              [13.674721, 48.533051],
              [13.683054, 48.529442],
              [13.725996, 48.515587],
              [13.8025, 48.581108],
              [13.804998, 48.58416],
              [13.822777, 48.617218],
              [13.825277, 48.625275],
              [13.826944, 48.638885],
              [13.826666, 48.643051],
              [13.814722, 48.738052],
              [13.833611, 48.773605],
            ],
          ],
        },
        id: 20,
        NAME: 'Austria',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Slovakia',
          id: 21,
          label: 'Slovakia',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.084,
          year: '2023',
          centroid: [19.699, 48.669],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [17.251656, 48.024994],
              [17.241713, 48.025551],
              [17.236664, 48.025833],
              [17.19083, 48.023048],
              [17.180832, 48.021111],
              [17.176388, 48.01944],
              [17.166386, 48.012497],
              [17.116665, 48.038605],
              [17.081108, 48.088333],
              [17.069145, 48.135265],
              [17.040051, 48.142464],
              [17.03075, 48.145859],
              [17.023331, 48.150276],
              [16.998016, 48.169701],
              [16.975277, 48.188332],
              [16.953888, 48.242775],
              [16.950832, 48.257774],
              [16.94972, 48.278049],
              [16.927219, 48.280273],
              [16.920555, 48.283882],
              [16.8475, 48.355827],
              [16.845276, 48.358604],
              [16.84222, 48.365273],
              [16.839996, 48.372215],
              [16.840275, 48.376389],
              [16.855831, 48.44944],
              [16.864441, 48.467216],
              [16.866943, 48.470276],
              [16.907497, 48.506943],
              [16.933331, 48.532776],
              [16.943333, 48.573326],
              [16.946182, 48.619064],
              [16.988331, 48.681664],
              [17.022499, 48.743607],
              [17.038887, 48.765274],
              [17.044167, 48.771385],
              [17.110554, 48.830551],
              [17.113888, 48.833054],
              [17.187908, 48.869446],
              [17.230274, 48.873055],
              [17.239998, 48.872772],
              [17.252777, 48.870827],
              [17.33083, 48.850273],
              [17.376389, 48.827499],
              [17.38583, 48.823326],
              [17.390274, 48.822777],
              [17.403889, 48.822777],
              [17.41861, 48.82666],
              [17.502777, 48.838882],
              [17.645554, 48.851944],
              [17.654999, 48.851944],
              [17.677498, 48.851944],
              [17.712219, 48.85611],
              [17.7575, 48.876663],
              [17.763054, 48.879715],
              [17.841942, 48.928329],
              [17.91111, 48.984993],
              [18.075279, 49.041943],
              [18.121944, 49.082771],
              [18.147778, 49.115555],
              [18.151386, 49.124443],
              [18.150833, 49.129997],
              [18.145277, 49.145],
              [18.15583, 49.159721],
              [18.158886, 49.165276],
              [18.161942, 49.174164],
              [18.174164, 49.210274],
              [18.174721, 49.241661],
              [18.175831, 49.244438],
              [18.179722, 49.249443],
              [18.208054, 49.284164],
              [18.212776, 49.288055],
              [18.216389, 49.289162],
              [18.269997, 49.299995],
              [18.281387, 49.301941],
              [18.30722, 49.303886],
              [18.317776, 49.307495],
              [18.379444, 49.330276],
              [18.386944, 49.335831],
              [18.541111, 49.453331],
              [18.546108, 49.457497],
              [18.548332, 49.463608],
              [18.547775, 49.478333],
              [18.548332, 49.481667],
              [18.551388, 49.486938],
              [18.562222, 49.493889],
              [18.568886, 49.496109],
              [18.581108, 49.497772],
              [18.655552, 49.504166],
              [18.792774, 49.513885],
              [18.851246, 49.517357],
              [18.968609, 49.481667],
              [18.96833, 49.456383],
              [18.970833, 49.405273],
              [18.971664, 49.402771],
              [18.973053, 49.400551],
              [18.978054, 49.39666],
              [18.993332, 49.39444],
              [19.031666, 49.391937],
              [19.155552, 49.399994],
              [19.163609, 49.400551],
              [19.185276, 49.409996],
              [19.198055, 49.418053],
              [19.195274, 49.430832],
              [19.203331, 49.444717],
              [19.240276, 49.50444],
              [19.244442, 49.509163],
              [19.264721, 49.524162],
              [19.270275, 49.527771],
              [19.276386, 49.530548],
              [19.447777, 49.60083],
              [19.475555, 49.599998],
              [19.520981, 49.574165],
              [19.535275, 49.535553],
              [19.574997, 49.461105],
              [19.579166, 49.45694],
              [19.658607, 49.406662],
              [19.710552, 49.397499],
              [19.768608, 49.408051],
              [19.781387, 49.408607],
              [19.786388, 49.408051],
              [19.790276, 49.406662],
              [19.791664, 49.404442],
              [19.804996, 49.364716],
              [19.826664, 49.28083],
              [19.826942, 49.278053],
              [19.826111, 49.275276],
              [19.824165, 49.272774],
              [19.821388, 49.271111],
              [19.798054, 49.252777],
              [19.773609, 49.233055],
              [19.765831, 49.215828],
              [19.766109, 49.213051],
              [19.771111, 49.206383],
              [19.778889, 49.201111],
              [19.789444, 49.196938],
              [19.794441, 49.196388],
              [19.839165, 49.191666],
              [19.846664, 49.19194],
              [19.86791, 49.197132],
              [19.907776, 49.224159],
              [19.913055, 49.227493],
              [19.916386, 49.228882],
              [19.936386, 49.23111],
              [19.97472, 49.227219],
              [19.984444, 49.225555],
              [19.995277, 49.221664],
              [20.002514, 49.213585],
              [20.020554, 49.19944],
              [20.039165, 49.188889],
              [20.064163, 49.177773],
              [20.074444, 49.175278],
              [20.081387, 49.175278],
              [20.084999, 49.177498],
              [20.089443, 49.183884],
              [20.091663, 49.196106],
              [20.093609, 49.213608],
              [20.103333, 49.248604],
              [20.143608, 49.314995],
              [20.206665, 49.340271],
              [20.327774, 49.383331],
              [20.360554, 49.393051],
              [20.602776, 49.395554],
              [20.740833, 49.388885],
              [20.812496, 49.330826],
              [20.910831, 49.296104],
              [20.916386, 49.296104],
              [20.95583, 49.301666],
              [20.980553, 49.308327],
              [20.984165, 49.310555],
              [21.035553, 49.359718],
              [21.049442, 49.408882],
              [21.051666, 49.412216],
              [21.066944, 49.420555],
              [21.076111, 49.423607],
              [21.278889, 49.456665],
              [21.285, 49.456108],
              [21.400845, 49.429054],
              [21.436386, 49.413887],
              [21.441109, 49.412498],
              [21.459442, 49.41111],
              [21.465832, 49.411385],
              [21.470833, 49.412773],
              [21.500832, 49.422218],
              [21.533607, 49.429718],
              [21.606388, 49.436661],
              [21.618889, 49.436386],
              [21.838055, 49.384438],
              [21.956944, 49.341385],
              [21.960278, 49.339165],
              [22.018887, 49.277496],
              [22.021385, 49.270271],
              [22.025276, 49.247215],
              [22.024166, 49.228882],
              [22.024719, 49.224716],
              [22.025833, 49.221107],
              [22.030277, 49.214996],
              [22.037777, 49.210831],
              [22.047497, 49.207771],
              [22.224998, 49.154716],
              [22.323887, 49.138611],
              [22.343052, 49.139442],
              [22.354721, 49.137497],
              [22.533054, 49.089439],
              [22.5425, 49.086388],
              [22.558052, 49.079437],
              [22.551662, 49.039436],
              [22.538887, 48.999161],
              [22.53722, 48.995544],
              [22.534164, 48.99305],
              [22.529163, 48.991661],
              [22.461384, 48.949432],
              [22.424995, 48.889435],
              [22.389164, 48.804993],
              [22.389164, 48.797218],
              [22.387497, 48.79361],
              [22.331108, 48.689987],
              [22.328884, 48.686935],
              [22.323608, 48.681107],
              [22.235271, 48.62471],
              [22.173607, 48.592766],
              [22.166939, 48.588043],
              [22.158886, 48.580276],
              [22.157219, 48.57666],
              [22.156105, 48.568054],
              [22.151442, 48.411919],
              [22.150555, 48.408607],
              [22.110832, 48.380272],
              [22.101665, 48.37722],
              [22.096107, 48.376389],
              [22.085831, 48.378052],
              [22.073055, 48.383606],
              [22.056664, 48.386665],
              [22.029442, 48.387497],
              [21.964996, 48.381943],
              [21.935833, 48.379166],
              [21.862778, 48.365555],
              [21.853054, 48.363052],
              [21.848888, 48.361382],
              [21.845276, 48.358604],
              [21.835831, 48.351105],
              [21.828331, 48.342216],
              [21.824165, 48.340271],
              [21.784443, 48.340553],
              [21.777496, 48.340828],
              [21.731388, 48.351105],
              [21.726665, 48.352493],
              [21.718609, 48.356384],
              [21.712776, 48.361382],
              [21.628052, 48.44944],
              [21.622776, 48.46833],
              [21.622776, 48.476944],
              [21.621666, 48.485275],
              [21.620552, 48.488884],
              [21.616665, 48.495552],
              [21.614166, 48.498329],
              [21.507221, 48.548882],
              [21.447777, 48.573883],
              [21.442776, 48.575272],
              [21.43111, 48.576111],
              [21.308712, 48.54805],
              [21.253887, 48.522217],
              [21.153332, 48.511108],
              [21.084442, 48.513611],
              [20.955276, 48.522499],
              [20.949718, 48.523605],
              [20.940277, 48.526382],
              [20.869999, 48.550827],
              [20.847775, 48.563606],
              [20.839165, 48.571663],
              [20.830276, 48.574997],
              [20.818607, 48.576385],
              [20.811665, 48.57666],
              [20.713333, 48.56916],
              [20.660553, 48.563332],
              [20.645275, 48.559998],
              [20.539719, 48.536942],
              [20.500832, 48.50444],
              [20.499443, 48.483059],
              [20.458611, 48.455276],
              [20.443607, 48.442215],
              [20.435833, 48.433609],
              [20.416386, 48.405273],
              [20.411942, 48.394165],
              [20.405277, 48.371109],
              [20.40361, 48.362778],
              [20.400555, 48.355553],
              [20.366943, 48.308884],
              [20.359165, 48.300278],
              [20.340832, 48.28611],
              [20.317219, 48.269722],
              [20.299721, 48.258606],
              [20.291943, 48.254715],
              [20.286663, 48.253883],
              [20.280277, 48.254166],
              [20.276386, 48.256104],
              [20.235554, 48.274994],
              [20.140553, 48.226105],
              [20.09333, 48.198326],
              [20.05933, 48.176308],
              [20.015274, 48.174995],
              [20.004997, 48.172775],
              [19.974442, 48.156662],
              [19.963608, 48.150276],
              [19.941944, 48.137215],
              [19.937775, 48.135277],
              [19.91861, 48.129997],
              [19.912498, 48.129715],
              [19.907776, 48.130272],
              [19.90361, 48.131943],
              [19.788887, 48.181664],
              [19.7925, 48.193054],
              [19.791111, 48.196938],
              [19.787777, 48.199165],
              [19.783607, 48.201111],
              [19.754997, 48.209442],
              [19.66222, 48.231941],
              [19.644444, 48.233887],
              [19.630554, 48.233887],
              [19.540016, 48.213196],
              [19.532513, 48.210861],
              [19.524166, 48.205826],
              [19.50861, 48.17305],
              [19.501663, 48.150276],
              [19.498608, 48.138329],
              [19.494442, 48.127495],
              [19.480553, 48.095551],
              [19.476383, 48.089165],
              [19.472218, 48.087219],
              [19.460548, 48.085831],
              [19.208336, 48.059448],
              [19.13945, 48.061676],
              [19.041714, 48.070641],
              [19.00127, 48.068954],
              [18.989799, 48.067101],
              [18.965675, 48.059799],
              [18.910069, 48.058258],
              [18.904503, 48.057693],
              [18.849098, 48.051064],
              [18.841576, 48.047195],
              [18.827366, 48.036125],
              [18.771664, 47.965553],
              [18.760555, 47.926109],
              [18.75972, 47.921661],
              [18.758888, 47.907494],
              [18.759441, 47.90361],
              [18.766941, 47.877777],
              [18.769997, 47.874992],
              [18.774441, 47.873329],
              [18.787777, 47.871666],
              [18.792221, 47.86972],
              [18.82, 47.855553],
              [18.853611, 47.833054],
              [18.855831, 47.830276],
              [18.84972, 47.817772],
              [18.788055, 47.817215],
              [18.765831, 47.815552],
              [18.749729, 47.813156],
              [18.738609, 47.807495],
              [18.732498, 47.797218],
              [18.726944, 47.791107],
              [18.720554, 47.78611],
              [18.690552, 47.770271],
              [18.675278, 47.762497],
              [18.67083, 47.760826],
              [18.655277, 47.758606],
              [18.636944, 47.759163],
              [18.597221, 47.763054],
              [18.540833, 47.767494],
              [18.451664, 47.767776],
              [18.446941, 47.766937],
              [18.41333, 47.753883],
              [18.378609, 47.747215],
              [18.337498, 47.740829],
              [18.312222, 47.737778],
              [18.297222, 47.737221],
              [18.195831, 47.747772],
              [18.131664, 47.755272],
              [18.119164, 47.756943],
              [18.086109, 47.759438],
              [17.976109, 47.763611],
              [17.916386, 47.75222],
              [17.901386, 47.749161],
              [17.896942, 47.747551],
              [17.790161, 47.746056],
              [17.784409, 47.746803],
              [17.712219, 47.770554],
              [17.485867, 47.877968],
              [17.466389, 47.888329],
              [17.457775, 47.895828],
              [17.448887, 47.907776],
              [17.447498, 47.91111],
              [17.442219, 47.916664],
              [17.411884, 47.944748],
              [17.355553, 47.988884],
              [17.340553, 47.997498],
              [17.335831, 47.998329],
              [17.311943, 47.998055],
              [17.273331, 48.001663],
              [17.264442, 48.004997],
              [17.26083, 48.007217],
              [17.254166, 48.016106],
              [17.251656, 48.024994],
            ],
          ],
        },
        id: 21,
        NAME: 'Slovakia',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Latvia',
          id: 22,
          label: 'Latvia',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.067,
          year: '2023',
          centroid: [24.6032, 56.8796],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [21.068607, 56.435547],
              [21.057774, 56.510551],
              [21.026665, 56.614159],
              [21.039719, 56.644157],
              [21.049442, 56.671936],
              [21.056107, 56.691376],
              [21.06472, 56.742767],
              [21.065273, 56.751938],
              [21.064163, 56.777771],
              [21.062775, 56.78611],
              [21.053349, 56.808739],
              [21.050274, 56.819717],
              [21.051941, 56.832771],
              [21.053608, 56.83638],
              [21.060555, 56.84166],
              [21.064999, 56.84388],
              [21.069996, 56.845825],
              [21.144997, 56.872765],
              [21.224438, 56.906654],
              [21.261387, 56.922768],
              [21.356106, 56.986107],
              [21.359718, 56.988602],
              [21.391663, 57.021935],
              [21.399719, 57.03138],
              [21.409439, 57.049438],
              [21.41555, 57.069443],
              [21.415829, 57.087212],
              [21.414997, 57.099998],
              [21.411385, 57.124435],
              [21.412216, 57.234436],
              [21.412773, 57.243607],
              [21.415829, 57.278046],
              [21.416939, 57.282211],
              [21.420551, 57.289436],
              [21.428883, 57.298882],
              [21.439438, 57.306938],
              [21.452496, 57.313324],
              [21.464718, 57.320549],
              [21.482494, 57.333878],
              [21.596107, 57.443321],
              [21.639996, 57.488884],
              [21.66555, 57.516663],
              [21.674164, 57.530823],
              [21.679718, 57.536942],
              [21.70583, 57.559715],
              [21.724716, 57.572495],
              [21.73333, 57.576942],
              [21.754997, 57.583328],
              [21.849442, 57.594994],
              [21.863052, 57.596657],
              [21.901108, 57.593605],
              [21.914719, 57.591377],
              [21.930828, 57.590546],
              [21.981937, 57.59388],
              [22.00111, 57.597214],
              [22.012218, 57.600273],
              [22.027222, 57.605827],
              [22.049164, 57.616661],
              [22.098331, 57.633881],
              [22.281387, 57.684715],
              [22.474438, 57.738045],
              [22.485828, 57.741104],
              [22.582775, 57.755272],
              [22.603607, 57.7575],
              [22.610275, 57.756386],
              [22.613331, 57.753609],
              [22.614719, 57.75],
              [22.609161, 57.743881],
              [22.601662, 57.738327],
              [22.598885, 57.735268],
              [22.584442, 57.697769],
              [22.583054, 57.684433],
              [22.584164, 57.676102],
              [22.591385, 57.644714],
              [22.595551, 57.633881],
              [22.599998, 57.627213],
              [22.637218, 57.588882],
              [22.649441, 57.581665],
              [22.672218, 57.571106],
              [22.75111, 57.535271],
              [22.905273, 57.454712],
              [22.934719, 57.434158],
              [22.942772, 57.429436],
              [22.952496, 57.424995],
              [23.014164, 57.398605],
              [23.049164, 57.385269],
              [23.083607, 57.375824],
              [23.103607, 57.37249],
              [23.134163, 57.365829],
              [23.137218, 57.363052],
              [23.167496, 57.312767],
              [23.239437, 57.172218],
              [23.242771, 57.165268],
              [23.249161, 57.114716],
              [23.253052, 57.103882],
              [23.259163, 57.098045],
              [23.305832, 57.073326],
              [23.327496, 57.06221],
              [23.341942, 57.056099],
              [23.351387, 57.052216],
              [23.586109, 56.976654],
              [23.646107, 56.966934],
              [23.660275, 56.964996],
              [23.668606, 56.964714],
              [23.765274, 56.968323],
              [23.785831, 56.970268],
              [23.850273, 56.983879],
              [23.873608, 56.988884],
              [23.955273, 57.011383],
              [23.984993, 57.022217],
              [24.155273, 57.097488],
              [24.223328, 57.128876],
              [24.366108, 57.213608],
              [24.373608, 57.21888],
              [24.38694, 57.229988],
              [24.400829, 57.245827],
              [24.407497, 57.25666],
              [24.413052, 57.272766],
              [24.41333, 57.281662],
              [24.410553, 57.346382],
              [24.407772, 57.362213],
              [24.362217, 57.580826],
              [24.332218, 57.698044],
              [24.329441, 57.700829],
              [24.307774, 57.724991],
              [24.303608, 57.731659],
              [24.297218, 57.744995],
              [24.289719, 57.792496],
              [24.286663, 57.824715],
              [24.288052, 57.83416],
              [24.294441, 57.850273],
              [24.31498, 57.871826],
              [24.32444, 57.87027],
              [24.373051, 57.868881],
              [24.402496, 57.870544],
              [24.420273, 57.874435],
              [24.427773, 57.879433],
              [24.433884, 57.885826],
              [24.438328, 57.892769],
              [24.441105, 57.900826],
              [24.443329, 57.904434],
              [24.453049, 57.913322],
              [24.542774, 57.95166],
              [24.553608, 57.954712],
              [24.560555, 57.955551],
              [24.723885, 57.964996],
              [25.015831, 58.039436],
              [25.03833, 58.05027],
              [25.060829, 58.061104],
              [25.069996, 58.065269],
              [25.091663, 58.071663],
              [25.124439, 58.076103],
              [25.139164, 58.07666],
              [25.163052, 58.075829],
              [25.169994, 58.07444],
              [25.179718, 58.070274],
              [25.192493, 58.059433],
              [25.199718, 58.049995],
              [25.203884, 58.039162],
              [25.207218, 58.028046],
              [25.210827, 58.012497],
              [25.214996, 58.005829],
              [25.223885, 57.997215],
              [25.232494, 57.992767],
              [25.247215, 57.992493],
              [25.285831, 58.003052],
              [25.294441, 58.0075],
              [25.299999, 58.01416],
              [25.300552, 58.018883],
              [25.300274, 58.026939],
              [25.296944, 58.038048],
              [25.29472, 58.041382],
              [25.288887, 58.047218],
              [25.264442, 58.061378],
              [25.263054, 58.06916],
              [25.266941, 58.076942],
              [25.275555, 58.081665],
              [25.28722, 58.08416],
              [25.294998, 58.084435],
              [25.301662, 58.083054],
              [25.307499, 58.081383],
              [25.421661, 58.035553],
              [25.436108, 58.029434],
              [25.439995, 58.026939],
              [25.444996, 58.020828],
              [25.44944, 58.005829],
              [25.453327, 57.999435],
              [25.461105, 57.994438],
              [25.618053, 57.918327],
              [25.622772, 57.916382],
              [25.801388, 57.865829],
              [25.836384, 57.86055],
              [25.883053, 57.855827],
              [25.946941, 57.853882],
              [26.034996, 57.823326],
              [26.204441, 57.694992],
              [26.274166, 57.629715],
              [26.287498, 57.618881],
              [26.299164, 57.611382],
              [26.313332, 57.604996],
              [26.511387, 57.5261],
              [26.523609, 57.523048],
              [26.538887, 57.522217],
              [26.602776, 57.525826],
              [26.608887, 57.526939],
              [26.612774, 57.529434],
              [26.615273, 57.533051],
              [26.619995, 57.544998],
              [26.626385, 57.551102],
              [26.634995, 57.555824],
              [26.697773, 57.575554],
              [26.873051, 57.630547],
              [26.883884, 57.633606],
              [26.898331, 57.633881],
              [26.906105, 57.633049],
              [26.969994, 57.623322],
              [26.996105, 57.618324],
              [27.018608, 57.611382],
              [27.03194, 57.604713],
              [27.03944, 57.599716],
              [27.051662, 57.588326],
              [27.070274, 57.567497],
              [27.080551, 57.563606],
              [27.087219, 57.56221],
              [27.310276, 57.53138],
              [27.372059, 57.535637],
              [27.424995, 57.531937],
              [27.44944, 57.531105],
              [27.471661, 57.53138],
              [27.547218, 57.536385],
              [27.542774, 57.493607],
              [27.526386, 57.449432],
              [27.525555, 57.445824],
              [27.525555, 57.441658],
              [27.527222, 57.438599],
              [27.53833, 57.430824],
              [27.562496, 57.420547],
              [27.580276, 57.415825],
              [27.606384, 57.410545],
              [27.687218, 57.37999],
              [27.825275, 57.323883],
              [27.849163, 57.313606],
              [27.85305, 57.311104],
              [27.861107, 57.302216],
              [27.865551, 57.291939],
              [27.866386, 57.288048],
              [27.863884, 57.262497],
              [27.851387, 57.187767],
              [27.848331, 57.174164],
              [27.846386, 57.169991],
              [27.774719, 57.057213],
              [27.70166, 56.914711],
              [27.731106, 56.869156],
              [27.762497, 56.873604],
              [27.79361, 56.877769],
              [27.80722, 56.878876],
              [27.815552, 56.878326],
              [27.837776, 56.875549],
              [27.860554, 56.868881],
              [27.935272, 56.827217],
              [27.938885, 56.82444],
              [27.940552, 56.821106],
              [27.940552, 56.81694],
              [27.933605, 56.801102],
              [27.931107, 56.797493],
              [27.924717, 56.791382],
              [27.917496, 56.78611],
              [27.943607, 56.722763],
              [28.009441, 56.648331],
              [28.114162, 56.517494],
              [28.147774, 56.471375],
              [28.182774, 56.40638],
              [28.233051, 56.289436],
              [28.23555, 56.282211],
              [28.237774, 56.271103],
              [28.237495, 56.262772],
              [28.199162, 56.18499],
              [28.194996, 56.17749],
              [28.184994, 56.163322],
              [28.181938, 56.160545],
              [28.168011, 56.150154],
              [28.161663, 56.154991],
              [28.154716, 56.159988],
              [28.149998, 56.162209],
              [28.132217, 56.166664],
              [28.124996, 56.16777],
              [28.118328, 56.167213],
              [27.92944, 56.113327],
              [27.925552, 56.110825],
              [27.918327, 56.100273],
              [27.916664, 56.0961],
              [27.902218, 56.074997],
              [27.89333, 56.065544],
              [27.796108, 56.001106],
              [27.712494, 55.9561],
              [27.654995, 55.929161],
              [27.647217, 55.924164],
              [27.641663, 55.912491],
              [27.63055, 55.864159],
              [27.630276, 55.855827],
              [27.633884, 55.849159],
              [27.633884, 55.844994],
              [27.632774, 55.840546],
              [27.631107, 55.83638],
              [27.619995, 55.818329],
              [27.601662, 55.793327],
              [27.598824, 55.791718],
              [27.559719, 55.789162],
              [27.531109, 55.788887],
              [27.310829, 55.807495],
              [27.211662, 55.825829],
              [27.156105, 55.846382],
              [27.149441, 55.846657],
              [26.989994, 55.834717],
              [26.981663, 55.829994],
              [26.908051, 55.778603],
              [26.901939, 55.772491],
              [26.888607, 55.750832],
              [26.885551, 55.742767],
              [26.883331, 55.739159],
              [26.875553, 55.729156],
              [26.863331, 55.716934],
              [26.849998, 55.710823],
              [26.765831, 55.687492],
              [26.745274, 55.686653],
              [26.731663, 55.688881],
              [26.692051, 55.701736],
              [26.668884, 55.705826],
              [26.661663, 55.705826],
              [26.651108, 55.702774],
              [26.633331, 55.69471],
              [26.629719, 55.692215],
              [26.619995, 55.683601],
              [26.613209, 55.674835],
              [26.591385, 55.674995],
              [26.575275, 55.676102],
              [26.531387, 55.680824],
              [26.51083, 55.683876],
              [26.498329, 55.686378],
              [26.375553, 55.714157],
              [26.35833, 55.71888],
              [26.338608, 55.726379],
              [26.313332, 55.739716],
              [26.275276, 55.76416],
              [26.268887, 55.76944],
              [26.263332, 55.775269],
              [26.256943, 55.784721],
              [26.240273, 55.814995],
              [26.239162, 55.818886],
              [26.221939, 55.839989],
              [26.210827, 55.851662],
              [26.20166, 55.859993],
              [26.19083, 55.867493],
              [26.058331, 55.938042],
              [26.014275, 55.955154],
              [25.996384, 55.959717],
              [25.942219, 55.976936],
              [25.932217, 55.980545],
              [25.891106, 55.999435],
              [25.714996, 56.089989],
              [25.707771, 56.094994],
              [25.704994, 56.098045],
              [25.699162, 56.108047],
              [25.696941, 56.115273],
              [25.582775, 56.151382],
              [25.429718, 56.166382],
              [25.327496, 56.169159],
              [25.262497, 56.180824],
              [25.183052, 56.183327],
              [25.160275, 56.184433],
              [25.145828, 56.186104],
              [25.133884, 56.188881],
              [25.106106, 56.197212],
              [25.096943, 56.201103],
              [25.081108, 56.210548],
              [25.072498, 56.219154],
              [25, 56.295547],
              [24.99305, 56.304993],
              [24.981937, 56.329163],
              [24.970551, 56.353607],
              [24.956661, 56.382492],
              [24.942219, 56.406937],
              [24.922218, 56.439987],
              [24.91555, 56.445267],
              [24.906105, 56.449432],
              [24.899719, 56.450546],
              [24.891384, 56.450829],
              [24.87944, 56.448601],
              [24.653328, 56.365829],
              [24.602776, 56.329163],
              [24.582497, 56.312492],
              [24.562775, 56.29055],
              [24.558331, 56.28833],
              [24.479996, 56.269714],
              [24.473328, 56.269157],
              [24.44944, 56.269714],
              [24.42944, 56.272766],
              [24.418327, 56.2761],
              [24.404163, 56.281937],
              [24.378883, 56.295547],
              [24.364719, 56.301659],
              [24.345276, 56.309158],
              [24.339718, 56.310822],
              [24.332218, 56.310547],
              [24.320274, 56.308327],
              [24.264999, 56.289436],
              [24.175274, 56.263329],
              [24.16333, 56.261108],
              [24.147774, 56.261383],
              [24.13583, 56.26416],
              [24.07444, 56.281662],
              [24.065273, 56.285553],
              [24.008331, 56.318054],
              [23.991383, 56.322769],
              [23.948883, 56.332214],
              [23.873608, 56.342766],
              [23.741104, 56.359993],
              [23.726383, 56.361382],
              [23.608608, 56.364159],
              [23.596943, 56.362213],
              [23.584721, 56.355553],
              [23.578884, 56.349159],
              [23.568054, 56.341377],
              [23.559441, 56.337212],
              [23.547497, 56.334717],
              [23.525276, 56.33416],
              [23.454441, 56.343048],
              [23.441662, 56.345268],
              [23.367775, 56.364998],
              [23.35833, 56.369156],
              [23.332218, 56.377769],
              [23.319996, 56.380272],
              [23.296108, 56.380821],
              [23.182217, 56.364716],
              [23.171108, 56.361938],
              [23.167496, 56.359161],
              [23.168053, 56.35527],
              [23.171108, 56.352219],
              [23.177494, 56.351105],
              [23.181385, 56.348877],
              [23.180275, 56.345543],
              [23.147217, 56.322495],
              [23.129997, 56.313881],
              [23.110275, 56.306656],
              [23.104443, 56.30555],
              [23.096107, 56.305824],
              [23.068054, 56.313606],
              [23.053886, 56.319443],
              [23.037498, 56.328606],
              [23.031387, 56.33416],
              [23.018055, 56.349434],
              [23.013054, 56.355553],
              [23.008331, 56.366104],
              [22.999161, 56.383331],
              [22.992771, 56.393051],
              [22.98666, 56.398605],
              [22.955551, 56.418053],
              [22.946941, 56.422218],
              [22.941383, 56.423882],
              [22.933884, 56.424438],
              [22.928051, 56.423325],
              [22.916939, 56.420547],
              [22.886383, 56.410271],
              [22.860275, 56.397491],
              [22.846107, 56.38694],
              [22.837498, 56.382492],
              [22.827221, 56.379158],
              [22.691383, 56.356659],
              [22.671108, 56.358604],
              [22.661385, 56.362495],
              [22.653606, 56.36721],
              [22.643608, 56.375267],
              [22.63583, 56.380272],
              [22.628052, 56.384995],
              [22.623329, 56.38694],
              [22.611942, 56.389992],
              [22.586941, 56.394714],
              [22.553608, 56.399719],
              [22.519165, 56.404434],
              [22.497215, 56.40638],
              [22.481384, 56.40638],
              [22.309441, 56.403877],
              [22.154442, 56.424164],
              [22.139439, 56.423607],
              [22.067219, 56.419441],
              [22.048885, 56.4161],
              [22.038609, 56.412766],
              [21.905273, 56.369156],
              [21.73555, 56.323326],
              [21.566666, 56.295273],
              [21.447773, 56.248878],
              [21.427773, 56.241936],
              [21.42194, 56.240547],
              [21.407772, 56.239433],
              [21.391384, 56.239716],
              [21.384995, 56.240829],
              [21.376663, 56.241104],
              [21.361107, 56.240829],
              [21.354443, 56.23999],
              [21.345829, 56.23555],
              [21.258888, 56.178604],
              [21.244438, 56.168327],
              [21.239162, 56.162209],
              [21.234718, 56.141106],
              [21.233883, 56.123047],
              [21.228882, 56.107216],
              [21.223328, 56.0961],
              [21.218052, 56.089989],
              [21.209717, 56.085548],
              [21.204716, 56.083878],
              [21.197216, 56.083328],
              [21.146664, 56.088043],
              [21.123886, 56.087494],
              [21.108887, 56.086655],
              [21.089165, 56.08416],
              [21.058052, 56.079437],
              [21.051685, 56.077309],
              [21.046387, 56.109161],
              [21.039165, 56.127487],
              [21.025829, 56.156097],
              [21.018887, 56.165825],
              [21.006386, 56.176941],
              [21.00222, 56.179161],
              [20.988884, 56.189987],
              [20.975273, 56.229988],
              [20.971939, 56.245827],
              [20.968605, 56.363609],
              [20.995548, 56.508331],
              [20.999718, 56.510551],
              [21.016388, 56.510277],
              [21.023052, 56.509438],
              [21.02861, 56.508049],
              [21.031666, 56.504997],
              [21.044441, 56.458328],
              [21.068607, 56.435547],
            ],
          ],
        },
        id: 22,
        NAME: 'Latvia',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Luxembourg',
          id: 23,
          label: 'Luxembourg',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.056,
          year: '2023',
          centroid: [6.1296, 49.8153],
        },
        geometry: {
          type: 'Polygon',
          coordinates: [
            [
              [6.026256, 50.181252],
              [6.02861, 50.166107],
              [6.031111, 50.160828],
              [6.033889, 50.159164],
              [6.12, 50.131943],
              [6.134414, 50.127846],
              [6.130278, 50.121941],
              [6.128055, 50.116386],
              [6.118333, 50.090828],
              [6.112778, 50.058884],
              [6.113333, 50.055832],
              [6.130555, 50.013885],
              [6.140555, 49.993889],
              [6.173055, 49.952217],
              [6.175278, 49.949997],
              [6.234166, 49.897499],
              [6.250278, 49.884163],
              [6.255278, 49.880554],
              [6.315938, 49.855316],
              [6.321111, 49.848328],
              [6.395555, 49.817772],
              [6.429722, 49.808884],
              [6.481944, 49.811104],
              [6.522222, 49.811104],
              [6.524444, 49.808609],
              [6.524722, 49.80555],
              [6.505835, 49.706627],
              [6.484722, 49.696106],
              [6.473055, 49.693604],
              [6.46611, 49.691109],
              [6.420833, 49.665833],
              [6.356486, 49.525864],
              [6.362778, 49.489166],
              [6.36217, 49.459389],
              [6.328333, 49.469162],
              [6.302777, 49.476662],
              [6.247318, 49.505974],
              [6.239721, 49.507774],
              [6.229722, 49.508331],
              [6.165277, 49.504715],
              [6.156111, 49.503883],
              [6.124166, 49.489716],
              [6.123055, 49.487221],
              [6.122499, 49.480553],
              [6.12, 49.471664],
              [6.118055, 49.469719],
              [6.094444, 49.454163],
              [6.090555, 49.453049],
              [5.981388, 49.448326],
              [5.977777, 49.448608],
              [5.855277, 49.501106],
              [5.838611, 49.51416],
              [5.811666, 49.536385],
              [5.809999, 49.538887],
              [5.80788, 49.545044],
              [5.834167, 49.549164],
              [5.837777, 49.550278],
              [5.863055, 49.571663],
              [5.900277, 49.640549],
              [5.899166, 49.662773],
              [5.87615, 49.709885],
              [5.869444, 49.719719],
              [5.790277, 49.78083],
              [5.764999, 49.789993],
              [5.750833, 49.791107],
              [5.748055, 49.79277],
              [5.746666, 49.795273],
              [5.734444, 49.834999],
              [5.747777, 49.907494],
              [5.770833, 49.95166],
              [5.774722, 49.956108],
              [5.777499, 49.957771],
              [5.791389, 49.962494],
              [5.834444, 49.986938],
              [5.883055, 50.077217],
              [5.883055, 50.080551],
              [5.886666, 50.098885],
              [5.889444, 50.104164],
              [5.891666, 50.10611],
              [5.969722, 50.16861],
              [5.976388, 50.171387],
              [6.013888, 50.181389],
              [6.021944, 50.18222],
              [6.026256, 50.181252],
            ],
          ],
        },
        id: 23,
        NAME: 'Luxembourg',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'France',
          id: 24,
          label: 'France',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.05,
          year: '2023',
          centroid: [2.2137, 46.6034],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [9.48583200000013, 42.615273000000116],
                [9.49472, 42.603607000000125],
                [9.482777000000112, 42.613052],
                [9.47778, 42.617218],
                [9.465277, 42.630829],
                [9.457777, 42.643326],
                [9.48583200000013, 42.615273000000116],
              ],
            ],
            [
              [
                [9.446665, 42.67889],
                [9.448055000000124, 42.64944],
                [9.452221, 42.630272],
                [9.473888, 42.582222],
                [9.47805, 42.576111],
                [9.50555, 42.56388900000013],
                [9.509998, 42.563606],
                [9.51139, 42.56721],
                [9.511665, 42.571663000000115],
                [9.509443, 42.578049],
                [9.503054, 42.59166],
                [9.497221, 42.60083],
                [9.50028, 42.59861],
                [9.520277000000135, 42.572495],
                [9.531666, 42.54916],
                [9.533888000000104, 42.54193900000013],
                [9.562222, 42.272774],
                [9.559999000000118, 42.19221],
                [9.55555500000014, 42.127777],
                [9.553333000000123, 42.115555],
                [9.54583, 42.102219],
                [9.448055000000124, 41.999443],
                [9.42555, 41.975],
                [9.41111, 41.954163],
                [9.405554, 41.934998],
                [9.397192, 41.875931],
                [9.396666, 41.862778],
                [9.398611, 41.85083],
                [9.402498, 41.84027100000014],
                [9.404444, 41.828331],
                [9.404165, 41.819160000000124],
                [9.398888, 41.698883],
                [9.382776, 41.658882],
                [9.379444, 41.651939],
                [9.366665, 41.638611],
                [9.32055, 41.60249],
                [9.27167, 41.520554],
                [9.241943, 41.451942],
                [9.247499, 41.425827],
                [9.25194, 41.42610900000011],
                [9.254166000000112, 41.423332],
                [9.254166000000112, 41.418610000000115],
                [9.25278, 41.41499],
                [9.248888, 41.40888200000012],
                [9.2225, 41.368607],
                [9.219166, 41.366386],
                [9.214443, 41.365555],
                [9.18611, 41.364166],
                [9.180832000000123, 41.3647160000001],
                [9.17722, 41.366661],
                [9.132221, 41.3941650000001],
                [9.115833, 41.431938000000116],
                [8.978054, 41.476662],
                [8.97389, 41.47805],
                [8.94111, 41.489441],
                [8.9175, 41.49971800000014],
                [8.791943, 41.55555],
                [8.789165, 41.55805],
                [8.78861, 41.562218],
                [8.78555, 41.613327],
                [8.792776, 41.6294400000001],
                [8.79472, 41.6325],
                [8.801666, 41.636665],
                [8.80611, 41.637772],
                [8.810833, 41.63694],
                [8.812498000000119, 41.63361],
                [8.816111, 41.631660000000124],
                [8.82111, 41.6325],
                [8.87361, 41.64694200000014],
                [8.876665000000116, 41.649162],
                [8.913887, 41.676384],
                [8.919443, 41.68138900000014],
                [8.921389, 41.684441],
                [8.921389, 41.68805],
                [8.919722, 41.69138],
                [8.916111, 41.693329],
                [8.911110000000122, 41.69416],
                [8.878887000000134, 41.698051000000135],
                [8.85667, 41.69832600000012],
                [8.85055, 41.698608],
                [8.840832, 41.700554],
                [8.79694400000011, 41.710274],
                [8.725832000000139, 41.72943900000013],
                [8.705, 41.75944],
                [8.74778, 41.810555],
                [8.78889, 41.853333],
                [8.803055, 41.8975],
                [8.802500000000123, 41.901665],
                [8.800833, 41.904999],
                [8.784166000000141, 41.92443800000012],
                [8.78111, 41.926666],
                [8.773054, 41.929993],
                [8.749722, 41.933327],
                [8.744165, 41.933609000000104],
                [8.740555, 41.931938],
                [8.738054, 41.929161000000136],
                [8.735832, 41.921387],
                [8.732777000000112, 41.91916700000013],
                [8.717222, 41.912498],
                [8.707222, 41.910828],
                [8.66861, 41.908333],
                [8.627222, 41.90666],
                [8.592777, 41.956940000000145],
                [8.58861, 41.963051],
                [8.589443, 41.96611],
                [8.593054, 41.968048000000124],
                [8.61360900000011, 41.97083],
                [8.634998, 41.96833],
                [8.646111000000133, 41.969162],
                [8.664999, 41.982498],
                [8.6675, 41.98527],
                [8.66805, 41.988327],
                [8.659443, 42.008331],
                [8.740555, 42.040833],
                [8.744999, 42.046944],
                [8.744999, 42.051384],
                [8.742222, 42.058327],
                [8.68111, 42.106384],
                [8.63889, 42.12028],
                [8.608332000000132, 42.13277],
                [8.587221, 42.169716],
                [8.570555000000127, 42.22166],
                [8.618332000000123, 42.25305200000014],
                [8.648888, 42.25833100000011],
                [8.68222, 42.265274],
                [8.68611, 42.26722],
                [8.688055000000134, 42.270271],
                [8.687498, 42.27444],
                [8.685833000000116, 42.277496],
                [8.631666, 42.336937],
                [8.615833000000123, 42.348328],
                [8.60722, 42.35110500000013],
                [8.594721, 42.35139],
                [8.584166, 42.349998],
                [8.575832000000105, 42.383606],
                [8.665277, 42.51111],
                [8.71472, 42.566666],
                [8.721666, 42.57444],
                [8.886944, 42.62805],
                [9.055277, 42.677498],
                [9.058332, 42.68916300000012],
                [9.060833000000116, 42.69194],
                [9.083887, 42.710831],
                [9.087221, 42.713051],
                [9.115833, 42.728607],
                [9.11944, 42.73027000000013],
                [9.148333, 42.73333],
                [9.153332, 42.73333],
                [9.251389, 42.720833],
                [9.254999000000112, 42.71888700000011],
                [9.269444, 42.702217],
                [9.27833, 42.690552],
                [9.283888, 42.676666000000125],
                [9.28694, 42.674438],
                [9.290833000000134, 42.67333200000013],
                [9.29389, 42.67555],
                [9.31139, 42.690277],
                [9.31722, 42.69527],
                [9.319166, 42.69832600000012],
                [9.34111, 42.734161],
                [9.342499, 42.737778],
                [9.343332, 42.74666600000012],
                [9.338888, 42.79055],
                [9.337221000000113, 42.798332],
                [9.33027600000014, 42.811386],
                [9.321665, 42.81889],
                [9.31139, 42.82972],
                [9.309166, 42.8325],
                [9.308054, 42.836105],
                [9.340832, 42.994438000000116],
                [9.344721, 43.000832],
                [9.34861, 43.002495000000124],
                [9.3530540000001, 43.003883],
                [9.383333, 43.00861],
                [9.418333, 43.010277],
                [9.424166, 43.01055],
                [9.458332, 42.989716],
                [9.460833, 42.986382],
                [9.489443000000108, 42.814438],
                [9.489166000000125, 42.805275],
                [9.485554, 42.793884],
                [9.468887, 42.7691650000001],
                [9.46611, 42.76194],
                [9.455, 42.718605],
                [9.448332000000107, 42.68721800000014],
                [9.446665, 42.67889],
              ],
            ],
            [
              [
                [-1.19444, 45.82249500000012],
                [-1.211945, 45.806938],
                [-1.23972, 45.858887],
                [-1.250834, 45.873604],
                [-1.28222, 45.905548000000124],
                [-1.285833, 45.907776],
                [-1.31667, 45.923607],
                [-1.33917, 45.935829],
                [-1.365556, 45.950272],
                [-1.37361, 45.958054],
                [-1.376111, 45.96527100000014],
                [-1.403056, 46.046661],
                [-1.40167, 46.050552],
                [-1.396111, 46.051109],
                [-1.38472, 46.04943800000012],
                [-1.363611, 46.044716],
                [-1.359167, 46.0430530000001],
                [-1.273334, 45.995827],
                [-1.23306, 45.964722],
                [-1.17306, 45.898605],
                [-1.170833, 45.891663],
                [-1.170556, 45.88749700000011],
                [-1.18194, 45.84777100000014],
                [-1.18694, 45.83166],
                [-1.18889, 45.828049],
                [-1.19444, 45.82249500000012],
              ],
            ],
            [
              [
                [-1.26083, 46.156387],
                [-1.284167, 46.155548],
                [-1.299445, 46.156662],
                [-1.31861, 46.160828],
                [-1.50694, 46.20416300000011],
                [-1.520556, 46.20916],
                [-1.531389, 46.215271],
                [-1.53444, 46.217773000000136],
                [-1.55222, 46.241104],
                [-1.553056, 46.244995],
                [-1.551944, 46.248055000000136],
                [-1.548333, 46.25],
                [-1.503056, 46.25555400000013],
                [-1.492222, 46.25666],
                [-1.480278, 46.25666],
                [-1.474445, 46.25583],
                [-1.291667, 46.198051000000135],
                [-1.255556, 46.168327],
                [-1.254167, 46.164993],
                [-1.254167, 46.160828],
                [-1.256667, 46.157776],
                [-1.26083, 46.156387],
              ],
            ],
            [
              [
                [-2.27083, 46.69332900000012],
                [-2.276389, 46.692772],
                [-2.36389, 46.698051],
                [-2.37, 46.701385],
                [-2.37833, 46.70916000000011],
                [-2.385278, 46.717773],
                [-2.385, 46.72555],
                [-2.38194, 46.72805],
                [-2.36611, 46.735275000000115],
                [-2.360834, 46.736107],
                [-2.354167, 46.7355500000001],
                [-2.33361, 46.73055],
                [-2.303056, 46.71860500000014],
                [-2.276111, 46.704437],
                [-2.273056, 46.702217],
                [-2.268611, 46.696388],
                [-2.27083, 46.69332900000012],
              ],
            ],
            [
              [
                [-2.196945, 47.01722000000012],
                [-2.14333, 46.953049000000135],
                [-2.13722, 46.943886000000134],
                [-2.13556, 46.936386],
                [-2.13639, 46.919167],
                [-2.14139, 46.907776],
                [-2.145, 46.90583],
                [-2.18278, 46.94916500000011],
                [-2.199445, 46.961105],
                [-2.208889, 46.963882000000126],
                [-2.221667, 46.965271],
                [-2.234445, 46.965553],
                [-2.24472, 46.963882000000126],
                [-2.250834, 46.963882000000126],
                [-2.25667, 46.964722],
                [-2.262778, 46.969719],
                [-2.28472, 47.02055400000012],
                [-2.277223, 47.027496],
                [-2.25667, 47.030548000000124],
                [-2.24556, 47.031944],
                [-2.23278, 47.030548000000124],
                [-2.22194, 47.02861],
                [-2.20778, 47.02388800000011],
                [-2.196945, 47.01722000000012],
              ],
            ],
            [
              [
                [-3.06667, 47.306664],
                [-3.08167, 47.289444],
                [-3.08583, 47.28777300000013],
                [-3.108334, 47.295555],
                [-3.118333, 47.29805],
                [-3.16417, 47.30332900000013],
                [-3.16944, 47.30360400000012],
                [-3.188889, 47.302773000000116],
                [-3.20528, 47.300278000000105],
                [-3.21111, 47.300827],
                [-3.21583, 47.302498],
                [-3.22306, 47.306664],
                [-3.2375, 47.315277],
                [-3.239167, 47.31860400000011],
                [-3.260278, 47.365273],
                [-3.26083, 47.369438],
                [-3.25861, 47.376106],
                [-3.25222, 47.390549],
                [-3.24889, 47.39277600000014],
                [-3.243333, 47.391663],
                [-3.06333, 47.320274],
                [-3.06139, 47.317215],
                [-3.063056, 47.31360600000011],
                [-3.06667, 47.306664],
              ],
            ],
            [
              [
                [-5.055, 48.454163],
                [-5.10139, 48.44221],
                [-5.134723, 48.45472],
                [-5.134723, 48.458328],
                [-5.13111, 48.46083],
                [-5.10556, 48.474716],
                [-5.06944, 48.482498],
                [-5.064723, 48.483055],
                [-5.055, 48.48027],
                [-5.04889, 48.47777600000012],
                [-5.045, 48.46860500000014],
                [-5.05194, 48.45694],
                [-5.055, 48.454163],
              ],
            ],
            [
              [
                [-3.57667, 48.803886],
                [-3.582222, 48.803886],
                [-3.58278, 48.80722],
                [-3.579722, 48.809715],
                [-3.575556, 48.81249],
                [-3.570834, 48.81277],
                [-3.56528, 48.81166],
                [-3.56333, 48.808609],
                [-3.56611, 48.80583200000012],
                [-3.57667, 48.803886],
              ],
            ],
            [
              [
                [2.541667000000132, 51.09111],
                [2.5975, 50.99582700000013],
                [2.597777, 50.92582700000014],
                [2.650555, 50.816109],
                [2.781944000000124, 50.75555400000013],
                [2.867503, 50.713379],
                [2.898056, 50.703049],
                [2.943055, 50.741386],
                [2.960556, 50.7575],
                [3.008611, 50.7691650000001],
                [3.02, 50.77055400000012],
                [3.026988, 50.76984],
                [3.041667, 50.777222],
                [3.050833000000125, 50.780273],
                [3.11638900000014, 50.791664],
                [3.14333, 50.790833],
                [3.149722, 50.78999],
                [3.154444, 50.78833],
                [3.162222, 50.783607],
                [3.164722, 50.780548000000124],
                [3.182874, 50.757050000000106],
                [3.187222000000133, 50.74667],
                [3.197778, 50.727219000000105],
                [3.242222, 50.66805],
                [3.243055, 50.660271],
                [3.278611000000126, 50.541664],
                [3.28, 50.53833],
                [3.29555, 50.525551],
                [3.298611, 50.523048],
                [3.367222, 50.495552],
                [3.37278, 50.49499500000013],
                [3.4525, 50.509438],
                [3.456666, 50.511383],
                [3.518055, 50.518883],
                [3.607778, 50.495827],
                [3.620155, 50.490044000000125],
                [3.654444000000126, 50.4616620000001],
                [3.657728, 50.45887],
                [3.66055, 50.45638300000013],
                [3.66889, 50.44416],
                [3.67055, 50.440826],
                [3.67167, 50.43332700000013],
                [3.676944, 50.395271],
                [3.774722000000111, 50.353882],
                [3.889722, 50.339996],
                [3.98389, 50.345276000000126],
                [4.033177, 50.35643],
                [4.038333, 50.3555530000001],
                [4.165, 50.283051],
                [4.194444, 50.23749500000014],
                [4.17139, 50.137215],
                [4.147222, 50.009995],
                [4.149238, 49.978371],
                [4.174179, 49.979881],
                [4.183055000000138, 49.97639],
                [4.215261, 49.95960200000013],
                [4.231111000000112, 49.96249],
                [4.24805, 49.964439],
                [4.317222, 49.969719],
                [4.413333, 49.949165],
                [4.43001, 49.945007],
                [4.445833, 49.940552],
                [4.458333, 49.938606],
                [4.46417, 49.93889],
                [4.510555, 49.947495],
                [4.673611, 49.996384],
                [4.67972200000014, 50.001938],
                [4.69444, 50.041939],
                [4.697499, 50.05555],
                [4.693889, 50.06194],
                [4.687778, 50.067215],
                [4.688055, 50.07111],
                [4.693055, 50.08332800000011],
                [4.696944, 50.09083],
                [4.763055, 50.135551],
                [4.81472, 50.165833],
                [4.819166, 50.16722],
                [4.832503, 50.16861],
                [4.882777, 50.154716],
                [4.894722, 50.140274],
                [4.894444, 50.13611],
                [4.8875, 50.131104],
                [4.883333, 50.129166],
                [4.880555, 50.12639],
                [4.853333, 50.095551],
                [4.838888, 50.06916],
                [4.820833, 49.992775],
                [4.863889, 49.80722],
                [4.873055000000136, 49.797218],
                [4.906666, 49.789719000000105],
                [4.912777000000119, 49.78889],
                [4.924444, 49.789444],
                [4.93528, 49.790833],
                [4.944722, 49.79361],
                [4.959167, 49.802216],
                [4.984444, 49.804718],
                [4.996666, 49.80249800000013],
                [5.331111, 49.656662],
                [5.392305, 49.62255],
                [5.39861100000013, 49.621384],
                [5.415, 49.613327],
                [5.42722, 49.60694],
                [5.437778, 49.59999800000014],
                [5.474166, 49.541107],
                [5.475555, 49.537773],
                [5.47611, 49.534164],
                [5.47389, 49.530548],
                [5.465278, 49.52166],
                [5.46361, 49.51778],
                [5.47028, 49.508888],
                [5.47305, 49.506104],
                [5.4775, 49.50416600000011],
                [5.514444, 49.508888],
                [5.530555000000106, 49.511108],
                [5.59333, 49.526382],
                [5.631944, 49.535828],
                [5.70222, 49.5430530000001],
                [5.792222, 49.54583],
                [5.80788, 49.545044],
                [5.809999, 49.538887],
                [5.811666, 49.53638],
                [5.838611, 49.51416000000012],
                [5.85528, 49.501106],
                [5.977777000000117, 49.448608],
                [5.98139, 49.448326],
                [6.090555, 49.453049],
                [6.094444000000124, 49.454163],
                [6.118055, 49.46971900000011],
                [6.12, 49.471664],
                [6.122499, 49.48055],
                [6.123055, 49.48722],
                [6.12417, 49.48972],
                [6.156111, 49.50388],
                [6.165277000000117, 49.504715],
                [6.229722, 49.50833100000011],
                [6.23972, 49.507774],
                [6.247318, 49.50597],
                [6.302777, 49.476662],
                [6.32833, 49.469162],
                [6.36217, 49.45939],
                [6.41139, 49.47555],
                [6.416111, 49.47583],
                [6.468333, 49.461388],
                [6.50833, 49.442772],
                [6.532222, 49.43083200000012],
                [6.540555, 49.425827],
                [6.546111, 49.41944],
                [6.594722000000104, 49.363052],
                [6.686944, 49.244995],
                [6.716389000000106, 49.191383],
                [6.714722, 49.18888900000013],
                [6.714167, 49.185829],
                [6.715, 49.18305],
                [6.723611, 49.171661],
                [6.727500000000134, 49.167496],
                [6.730833, 49.166107],
                [6.735, 49.165276],
                [6.82194, 49.153885],
                [6.831388, 49.15305],
                [6.838888, 49.154999],
                [6.844166, 49.158333],
                [6.85944400000011, 49.172493000000145],
                [6.861111, 49.174995],
                [6.861111, 49.177773],
                [6.859722, 49.179993],
                [6.855000000000132, 49.183884],
                [6.849722, 49.190552],
                [6.84111, 49.203331000000105],
                [6.840278, 49.206108],
                [6.841389, 49.20888500000012],
                [6.843055, 49.211388],
                [6.8475, 49.215271],
                [6.853889, 49.218048000000124],
                [6.920555, 49.220551],
                [6.930555, 49.22083],
                [6.934166, 49.219719],
                [7.019444, 49.187492],
                [7.090555, 49.127495],
                [7.151667, 49.121109000000104],
                [7.287777, 49.111107],
                [7.29167, 49.11222],
                [7.36, 49.14222],
                [7.361666, 49.14444],
                [7.367222, 49.160553],
                [7.369015, 49.16878],
                [7.371944, 49.17083],
                [7.375278, 49.171944],
                [7.38361, 49.173332],
                [7.41361, 49.17694100000011],
                [7.423611, 49.1772160000001],
                [7.432500000000118, 49.175827],
                [7.486944, 49.164162],
                [7.625833000000114, 49.06916],
                [7.63028, 49.065277],
                [7.652089, 49.04493700000012],
                [7.66889, 49.04222],
                [7.737499, 49.04277],
                [7.821388, 49.046387],
                [7.933332000000121, 49.048882],
                [7.938611, 49.048882],
                [8.039721, 49.01111],
                [8.051943, 49.005272],
                [8.155554000000109, 48.97639],
                [8.22608, 48.964417],
                [8.20611, 48.95888],
                [8.190554, 48.951942000000145],
                [8.139166, 48.895554],
                [8.135832, 48.890831],
                [8.121666, 48.864998],
                [8.112499, 48.846382],
                [8.110277, 48.8408280000001],
                [8.10639, 48.82222],
                [8.103888, 48.816666],
                [8.092222, 48.803604],
                [7.96194400000013, 48.7241590000001],
                [7.88, 48.66416],
                [7.80222, 48.575829],
                [7.745403000000124, 48.42495],
                [7.736666, 48.3986],
                [7.736666, 48.389442000000145],
                [7.743055, 48.371109000000104],
                [7.75177, 48.345406],
                [7.750833, 48.3366620000001],
                [7.746111, 48.330551],
                [7.693333, 48.276382],
                [7.607729, 48.164185],
                [7.580832, 48.122772],
                [7.578888, 48.11972000000014],
                [7.576898, 48.113152],
                [7.569722000000127, 48.08916],
                [7.568889000000127, 48.085274],
                [7.56667, 48.059998],
                [7.56919, 48.044777],
                [7.571666, 48.037216000000114],
                [7.574444, 48.034439],
                [7.583888, 48.02722200000011],
                [7.61361, 48.006104],
                [7.618518, 48],
                [7.622499000000118, 47.993889],
                [7.624444, 47.98610700000012],
                [7.624166, 47.97694400000012],
                [7.622222, 47.96916],
                [7.584167, 47.903328],
                [7.557221, 47.862778000000105],
                [7.526667, 47.788055],
                [7.510833, 47.703331],
                [7.513333000000102, 47.68694],
                [7.51944, 47.66833],
                [7.521944, 47.66555],
                [7.528889, 47.66083],
                [7.540277000000117, 47.655],
                [7.56111, 47.641663],
                [7.567222, 47.636665],
                [7.585833, 47.60833],
                [7.589722000000108, 47.60194400000012],
                [7.589747, 47.5926970000001],
                [7.588268, 47.58448],
                [7.586944, 47.585],
                [7.567222, 47.583611],
                [7.557221, 47.581383],
                [7.550833, 47.576385],
                [7.546665, 47.56555200000014],
                [7.521667, 47.55971],
                [7.513055, 47.556664000000126],
                [7.501389, 47.55055],
                [7.49861, 47.5480500000001],
                [7.497222, 47.544441],
                [7.502222, 47.500549],
                [7.49694, 47.494995],
                [7.452777, 47.46999],
                [7.433054, 47.460548],
                [7.41555, 47.44527],
                [7.388333, 47.43416600000012],
                [7.3825, 47.432495],
                [7.358055, 47.433609],
                [7.355897, 47.434017],
                [7.343611, 47.438606],
                [7.336944, 47.439438],
                [7.308332000000121, 47.440277],
                [7.275555000000111, 47.432495],
                [7.251389, 47.421944],
                [7.24694, 47.42083],
                [7.24111, 47.421944],
                [7.187499, 47.44221],
                [7.178333, 47.445831],
                [7.14642, 47.499054000000115],
                [7.025, 47.508049],
                [6.990555, 47.497215],
                [6.884444, 47.372772],
                [6.88111, 47.36472],
                [6.879999, 47.360275],
                [6.88111, 47.356941],
                [6.931389000000138, 47.35889],
                [6.980833, 47.361664],
                [7.00083, 47.364998],
                [6.971666, 47.291939],
                [6.839722, 47.17361],
                [6.8375, 47.171104],
                [6.838888, 47.16777],
                [6.84972, 47.164989000000105],
                [6.793333, 47.130829],
                [6.69944, 47.06388900000013],
                [6.678333, 47.034164],
                [6.639722, 47.004166],
                [6.629722, 46.99721],
                [6.620832, 46.994438],
                [6.566388, 46.979996],
                [6.528333, 46.971664],
                [6.460278, 46.895828],
                [6.446944, 46.839439],
                [6.45861, 46.785271],
                [6.4575, 46.78083],
                [6.452777, 46.77444],
                [6.434999000000118, 46.758049],
                [6.366666, 46.720551],
                [6.355, 46.714439],
                [6.346666, 46.711388],
                [6.26917, 46.6827770000001],
                [6.129999000000112, 46.59333],
                [6.12778, 46.589996],
                [6.127222, 46.585831],
                [6.129722000000129, 46.583054],
                [6.13528, 46.539719],
                [6.086944, 46.44944],
                [6.071111, 46.426384],
                [6.111111, 46.40972],
                [6.148333, 46.38861],
                [6.151667, 46.386383],
                [6.157222, 46.37722],
                [6.158333, 46.373886],
                [6.15861, 46.369995],
                [6.154166, 46.36305],
                [6.120277, 46.31194],
                [6.115, 46.30555],
                [6.106109, 46.297489],
                [6.118055, 46.26805100000013],
                [6.119166, 46.264442000000145],
                [6.117222, 46.260551],
                [6.107778, 46.253052],
                [6.0825, 46.24667],
                [6.072499, 46.249718],
                [6.060833, 46.250549],
                [6.03, 46.241386],
                [6.009166, 46.233887],
                [5.98139, 46.221939],
                [5.968055, 46.212494],
                [5.966666, 46.209442],
                [5.96611, 46.20528],
                [5.967222, 46.20194],
                [5.996388, 46.14694200000014],
                [6.12361, 46.148048],
                [6.133611, 46.14944],
                [6.152222, 46.15361000000013],
                [6.185833, 46.17083],
                [6.189166, 46.17333200000013],
                [6.245555, 46.21833],
                [6.271944000000133, 46.26194],
                [6.24375, 46.31551],
                [6.22805, 46.319717],
                [6.225555, 46.322495],
                [6.23, 46.333885],
                [6.236388, 46.34471900000011],
                [6.243333, 46.354996],
                [6.246388, 46.357773],
                [6.295555, 46.39416],
                [6.31111, 46.401382],
                [6.32833, 46.406944],
                [6.491944, 46.453049],
                [6.51028, 46.457771],
                [6.52, 46.45916],
                [6.633611, 46.464165],
                [6.702777, 46.45472000000012],
                [6.737778, 46.447495],
                [6.791389, 46.434166],
                [6.800278, 46.43055],
                [6.803055, 46.427773],
                [6.808332, 46.41861],
                [6.809444, 46.415276],
                [6.807016, 46.404228],
                [6.8, 46.378326],
                [6.78083, 46.166107],
                [6.781111, 46.162498],
                [6.78389, 46.148048],
                [6.788055, 46.14222],
                [6.873888, 46.088051],
                [6.933055000000138, 46.055275],
                [7.005833000000109, 45.999443],
                [7.00861, 45.996666],
                [7.030555, 45.96194],
                [7.03805, 45.931938000000116],
                [6.99667, 45.885551],
                [6.987499, 45.876938],
                [6.980833, 45.872215],
                [6.973055, 45.868889],
                [6.943889, 45.85833],
                [6.92222, 45.852219000000105],
                [6.908055, 45.849442],
                [6.896111000000133, 45.850273],
                [6.874999, 45.85611],
                [6.869721, 45.855827],
                [6.81861, 45.839165],
                [6.808888, 45.831383],
                [6.807221000000141, 45.827217],
                [6.79972, 45.796661],
                [6.798970000000111, 45.78067],
                [6.80778, 45.73444400000011],
                [6.809722000000136, 45.72777600000012],
                [6.814166000000114, 45.72194],
                [6.969444, 45.596939],
                [6.98972, 45.53333],
                [6.99944, 45.518326000000116],
                [7.002777, 45.516106],
                [7.089159, 45.47686],
                [7.146944, 45.43055],
                [7.15861, 45.377495],
                [7.129167, 45.262215],
                [7.127777, 45.25777],
                [7.124999000000116, 45.254997],
                [7.064722, 45.223053],
                [6.939444, 45.179443],
                [6.826944, 45.149719],
                [6.816388000000131, 45.156387],
                [6.771944, 45.16805],
                [6.760833, 45.168327],
                [6.6975, 45.15027600000013],
                [6.688889, 45.147774],
                [6.675833, 45.143883],
                [6.637777, 45.12610600000011],
                [6.634121, 45.124001],
                [6.627222000000131, 45.11944],
                [6.621666000000118, 45.11388],
                [6.61976, 45.110138],
                [6.661666, 45.039993],
                [6.746944, 44.91944],
                [6.751111, 44.91722],
                [6.775277000000131, 44.905548000000124],
                [6.84083, 44.874161],
                [6.85777800000011, 44.866661000000136],
                [6.89222100000012, 44.860275],
                [6.904444, 44.859161],
                [6.917777, 44.86193800000012],
                [6.936388, 44.871384],
                [6.948333, 44.869995],
                [6.964444, 44.865829],
                [6.973888, 44.862778],
                [7.002777, 44.852776],
                [7.009999, 44.84861000000012],
                [7.031666, 44.83138300000013],
                [7.02833, 44.74472],
                [6.980277, 44.691666],
                [6.970555000000104, 44.684715],
                [6.950833, 44.664719000000105],
                [6.852777, 44.540833],
                [6.853611000000114, 44.517776],
                [6.876944, 44.376663],
                [6.878888, 44.373604],
                [6.9763880000001, 44.284164],
                [7.031388, 44.246941],
                [7.348332, 44.131943],
                [7.353333000000134, 44.131104],
                [7.418888, 44.125549],
                [7.423055, 44.126663],
                [7.466389000000106, 44.138611],
                [7.52028, 44.1561],
                [7.61472, 44.180275],
                [7.66222, 44.17083000000014],
                [7.657777000000124, 44.144722],
                [7.658333, 44.137215],
                [7.661666, 44.131104],
                [7.66889, 44.122772],
                [7.709045000000117, 44.09130900000014],
                [7.70833, 44.07944],
                [7.70417, 44.07222],
                [7.66, 44.00833],
                [7.657222, 44.005272],
                [7.59833, 43.964722],
                [7.50111, 43.88694],
                [7.495, 43.88166],
                [7.493333, 43.877777],
                [7.492222, 43.869438],
                [7.493333, 43.862221],
                [7.49861, 43.849442],
                [7.512500000000102, 43.82111],
                [7.528055, 43.788605],
                [7.519722, 43.790833],
                [7.50778, 43.792221],
                [7.48417, 43.782776],
                [7.439293000000134, 43.757523000000106],
                [7.438333000000114, 43.760277],
                [7.432500000000118, 43.769165],
                [7.429444, 43.771385],
                [7.42472, 43.773048],
                [7.419999000000132, 43.772499],
                [7.41611, 43.770554],
                [7.403055000000109, 43.76138300000014],
                [7.387777, 43.748604],
                [7.386389000000122, 43.74555],
                [7.386389000000122, 43.74194],
                [7.391609, 43.727547],
                [7.31861, 43.709717],
                [7.25472, 43.70444],
                [7.238889, 43.69888],
                [7.15861, 43.66305],
                [7.152778000000126, 43.658051],
                [7.07472, 43.57222],
                [6.89222100000012, 43.43583],
                [6.88417, 43.433327],
                [6.84639, 43.424164],
                [6.794167, 43.422775],
                [6.636389, 43.311104000000114],
                [6.6375, 43.287773],
                [6.68444, 43.287216],
                [6.689444, 43.285553],
                [6.696944, 43.28139],
                [6.700277000000142, 43.275551],
                [6.699721000000125, 43.271385],
                [6.69778, 43.268051],
                [6.6416660000001, 43.184998],
                [6.599444, 43.192497],
                [6.5275, 43.189163],
                [6.406111, 43.163055],
                [6.18694, 43.12861],
                [6.178888, 43.125549],
                [6.172222, 43.121384],
                [6.166666000000134, 43.115555],
                [6.16472, 43.112221],
                [6.161944, 43.103607],
                [6.157222, 43.067215],
                [6.165277000000117, 43.05055],
                [6.137777, 43.055832],
                [6.11555, 43.06444],
                [6.062222, 43.101387],
                [5.955555, 43.118332],
                [5.936666000000116, 43.09083],
                [5.937222000000133, 43.087219],
                [5.929722, 43.083611],
                [5.871388, 43.05971],
                [5.86222, 43.05749500000013],
                [5.838611, 43.05999800000012],
                [5.8291660000001, 43.06305],
                [5.781111, 43.0824970000001],
                [5.776111, 43.088051],
                [5.77583, 43.09194200000013],
                [5.7775, 43.100555],
                [5.78361, 43.104996],
                [5.791389, 43.10833],
                [5.817499, 43.114998],
                [5.815555000000131, 43.12028],
                [5.68922, 43.188507],
                [5.68134, 43.190102],
                [5.671666, 43.191666],
                [5.52, 43.209999],
                [5.415833, 43.21666],
                [5.39805, 43.217773],
                [5.380278, 43.219162],
                [5.36361, 43.221939000000134],
                [5.35666700000013, 43.2263870000001],
                [5.35111, 43.23111],
                [5.35111, 43.235275],
                [5.355556, 43.247772],
                [5.360833, 43.253609],
                [5.367222, 43.25833100000011],
                [5.372222, 43.264717],
                [5.373888, 43.26888300000013],
                [5.373888, 43.276665],
                [5.36389, 43.328331000000105],
                [5.361666, 43.33527400000014],
                [5.348611, 43.351944],
                [5.335555, 43.361382],
                [5.322222000000124, 43.366661],
                [5.316111, 43.36749300000014],
                [5.30639, 43.365555],
                [5.272222, 43.356384],
                [5.258333, 43.34833],
                [5.250000000000114, 43.345276],
                [5.22305, 43.33944],
                [5.213055, 43.338608],
                [5.09639, 43.336937],
                [5.057777, 43.341385],
                [5.0388880000001, 43.347496],
                [5.03083, 43.35139],
                [5.042277, 43.37766],
                [5.040444, 43.381496],
                [5.04078, 43.38866],
                [5.041944, 43.391167],
                [5.04561, 43.393997],
                [5.063944, 43.401833],
                [5.074778, 43.404495],
                [5.077777, 43.404663],
                [5.092277, 43.402828],
                [5.14222100000012, 43.416107000000125],
                [5.151388000000111, 43.417221],
                [5.188611, 43.43388],
                [5.23056, 43.464165],
                [5.232499, 43.467499],
                [5.230833, 43.490273],
                [5.2272210000001, 43.496109000000104],
                [5.031388, 43.556664],
                [5.023055000000113, 43.553886],
                [5.021111, 43.54999500000014],
                [5.010833, 43.516663],
                [5.009722, 43.512215],
                [5.01667, 43.488884],
                [5.02277800000013, 43.484161],
                [5.028055000000109, 43.482498000000135],
                [5.045278, 43.480827],
                [5.0525, 43.47694400000012],
                [5.057500000000118, 43.471382],
                [5.039555, 43.458607],
                [5.04072200000013, 43.45427],
                [5.041222000000118, 43.44744],
                [5.04055, 43.439941],
                [5.0397210000001, 43.437607],
                [5.035722000000135, 43.434772],
                [5.017388, 43.428272],
                [4.994722, 43.425274],
                [4.991555, 43.425774],
                [4.988555, 43.42894],
                [4.957777, 43.424995],
                [4.935555, 43.432777],
                [4.924999, 43.435272],
                [4.919167, 43.435555],
                [4.876111, 43.423882],
                [4.853611, 43.41333],
                [4.83005, 43.411385],
                [4.828388, 43.406551],
                [4.833388, 43.404221],
                [4.839889, 43.403217],
                [4.842555, 43.399887],
                [4.844889, 43.391384],
                [4.83939, 43.390217],
                [4.822722, 43.395885],
                [4.815055, 43.399216],
                [4.793388, 43.409554],
                [4.783889, 43.414219],
                [4.75, 43.423607],
                [4.743889000000138, 43.42860400000012],
                [4.740833, 43.435272],
                [4.740833, 43.438606],
                [4.741944, 43.45138500000013],
                [4.75, 43.48693800000012],
                [4.750833, 43.49528],
                [4.751111, 43.507217],
                [4.74917, 43.51805100000013],
                [4.746666, 43.52499],
                [4.739444, 43.537216000000114],
                [4.71667, 43.565277],
                [4.711666, 43.570274],
                [4.705, 43.57499700000011],
                [4.696666, 43.57777],
                [4.727221, 43.44166600000011],
                [4.73277800000011, 43.428329],
                [4.736111, 43.42222],
                [4.741666, 43.417496],
                [4.73189, 43.400444],
                [4.741555000000119, 43.395775],
                [4.747221000000138, 43.393944],
                [4.76472200000012, 43.3861],
                [4.768722000000139, 43.383442000000116],
                [4.771055, 43.38010800000012],
                [4.772555, 43.375938],
                [4.77272, 43.373608],
                [4.771888, 43.37144],
                [4.767388, 43.36894],
                [4.75089, 43.36911],
                [4.652778, 43.359718],
                [4.619166, 43.361107],
                [4.606944000000112, 43.361938],
                [4.60139, 43.363052],
                [4.583888, 43.369995],
                [4.573333, 43.379997],
                [4.572499000000107, 43.387772],
                [4.57444, 43.391106],
                [4.591389, 43.40749],
                [4.598055, 43.417496],
                [4.601666, 43.424995],
                [4.60111, 43.42860400000012],
                [4.597221, 43.434166],
                [4.59111, 43.43916300000012],
                [4.583888, 43.443329],
                [4.565555, 43.449997],
                [4.535555000000102, 43.45832800000011],
                [4.50611, 43.462776],
                [4.47389, 43.461937],
                [4.453333, 43.46054800000013],
                [4.439166, 43.458885],
                [4.421944, 43.453888],
                [4.32583, 43.457222],
                [4.321111, 43.45832800000011],
                [4.318055, 43.461105],
                [4.316111, 43.464722],
                [4.317499, 43.471664],
                [4.321111, 43.492493],
                [4.319166, 43.499718],
                [4.31778, 43.503883],
                [4.30944, 43.512215],
                [4.28611, 43.50555400000013],
                [4.251389000000131, 43.493889],
                [4.24722, 43.491943],
                [4.241433, 43.485954],
                [4.29194, 43.45916],
                [4.28778, 43.45694],
                [4.205, 43.460274],
                [4.190555, 43.461937],
                [4.16222, 43.47111],
                [4.13111, 43.491661000000136],
                [4.124722, 43.498329],
                [4.124444, 43.505272000000105],
                [4.126666, 43.508331],
                [4.136389, 43.50805],
                [4.13833, 43.51138],
                [4.138888, 43.518883],
                [4.138055, 43.526108000000136],
                [4.133055, 43.536659],
                [4.127777, 43.543053],
                [4.117222, 43.55138],
                [4.10805, 43.55499300000014],
                [4.09639, 43.55805],
                [4.062222, 43.563332],
                [4.050278, 43.562218],
                [3.964722, 43.540833],
                [3.918611, 43.52388800000011],
                [3.90778, 43.518608],
                [3.843611, 43.47555],
                [3.7225, 43.41166],
                [3.546667, 43.319717],
                [3.430555, 43.286942],
                [3.41528, 43.28860500000013],
                [3.405278, 43.2866590000001],
                [3.335, 43.265274],
                [3.313056000000131, 43.25527],
                [3.25805, 43.22749],
                [3.14111, 43.138885],
                [3.081388000000118, 43.069443],
                [3.07777700000014, 43.04138200000011],
                [3.045278, 42.954163],
                [3.003611, 42.881104],
                [2.963889, 42.848328],
                [2.961389, 42.844994],
                [2.96, 42.83777600000013],
                [2.972777, 42.812218],
                [2.979167, 42.806664],
                [3.012222, 42.79805],
                [3.03805, 42.728333],
                [3.040833000000134, 42.616943000000106],
                [3.041944, 42.60833000000014],
                [3.049444000000108, 42.553886],
                [3.053889, 42.546661],
                [3.060277, 42.539719000000105],
                [3.06889, 42.53638500000011],
                [3.091389, 42.528885],
                [3.110278, 42.526939],
                [3.119722, 42.52471900000012],
                [3.139722, 42.51916],
                [3.143055, 42.516388],
                [3.16, 42.478333000000134],
                [3.174444, 42.445549],
                [3.177655000000129, 42.436806],
                [3.17111100000011, 42.435555],
                [3.158333000000141, 42.433327],
                [3.106111, 42.429161],
                [3.092222, 42.42999300000014],
                [3.075833, 42.439438],
                [3.049444000000108, 42.459717000000126],
                [3.047778000000108, 42.46971900000011],
                [3.045278, 42.474716],
                [2.95, 42.48055],
                [2.724722, 42.41944100000012],
                [2.678333, 42.401665],
                [2.65722, 42.38444],
                [2.656944, 42.37944],
                [2.674444000000108, 42.357216],
                [2.666389, 42.34194200000013],
                [2.54194, 42.332497],
                [2.525833, 42.333328],
                [2.484722, 42.343048000000124],
                [2.46972, 42.353333],
                [2.442778, 42.37638900000013],
                [2.438889, 42.38055400000013],
                [2.332222, 42.418053],
                [2.280534, 42.434288],
                [2.269166, 42.43722],
                [2.2625, 42.436661],
                [2.151389, 42.421387],
                [2.137777, 42.417221],
                [2.129167000000109, 42.408051],
                [2.124166, 42.39833],
                [2.123055000000136, 42.393326000000116],
                [2.116944, 42.383331],
                [2.093611, 42.364166],
                [2.062222, 42.356941],
                [2.023889000000111, 42.352219000000105],
                [2.017222, 42.35305000000011],
                [2.004722000000129, 42.357216],
                [1.987778000000105, 42.367775],
                [1.976666000000137, 42.374718],
                [1.968889, 42.384163000000115],
                [1.95917, 42.41083],
                [1.906389000000104, 42.446938],
                [1.851389, 42.469994],
                [1.78, 42.48832700000014],
                [1.723611, 42.50944],
                [1.723333, 42.515274],
                [1.724444, 42.524994],
                [1.725278, 42.529999],
                [1.735278, 42.554443],
                [1.74305500000014, 42.563606],
                [1.753889, 42.57],
                [1.768055, 42.571106],
                [1.774722, 42.571106],
                [1.78172, 42.569962],
                [1.73861, 42.616386],
                [1.698333, 42.62610600000011],
                [1.563056, 42.655548],
                [1.556389, 42.656387],
                [1.491944000000103, 42.65361],
                [1.481111000000112, 42.647217000000126],
                [1.445833000000107, 42.601944],
                [1.41722, 42.65083],
                [1.390278000000137, 42.688332000000116],
                [1.359167000000127, 42.715271],
                [1.328333, 42.719994],
                [1.321666, 42.714996],
                [1.17389, 42.709717],
                [1.150833, 42.72361000000012],
                [1.144722, 42.727776],
                [1.1408330000001, 42.731941],
                [1.137778000000139, 42.73693800000012],
                [1.1408330000001, 42.741661],
                [1.1400000000001, 42.753052],
                [1.132222000000127, 42.760826],
                [1.121111, 42.768608],
                [1.091666, 42.78444],
                [1.085, 42.785271],
                [0.896944, 42.813049],
                [0.823611000000142, 42.833054],
                [0.72, 42.859161],
                [0.712222, 42.858604],
                [0.692778, 42.853607],
                [0.66778, 42.839165],
                [0.651944, 42.784996],
                [0.655555000000106, 42.754166],
                [0.668056, 42.748055000000136],
                [0.681389000000138, 42.72943900000013],
                [0.683889, 42.713051],
                [0.683056, 42.70805],
                [0.680000000000121, 42.693329],
                [0.675506, 42.688484],
                [0.661667, 42.69194],
                [0.59556, 42.695],
                [0.56, 42.69583100000011],
                [0.509167, 42.69194],
                [0.501667000000111, 42.69138],
                [0.43278, 42.686661],
                [0.2725, 42.702499],
                [0.269722000000115, 42.707771],
                [0.261944000000142, 42.717499],
                [0.186389, 42.7347180000001],
                [0.178611, 42.735275],
                [0.172222, 42.73333],
                [0.14417, 42.722221000000104],
                [0.111944000000108, 42.709442],
                [0.008333, 42.68693],
                [0, 42.68544],
                [-0.00556, 42.68499800000012],
                [-0.05056, 42.69194],
                [-0.057222, 42.69416],
                [-0.06194, 42.69778],
                [-0.06194, 42.703331],
                [-0.060833, 42.70916],
                [-0.063056, 42.71583],
                [-0.12361, 42.7575],
                [-0.151944, 42.776657],
                [-0.18, 42.78444],
                [-0.20556, 42.794167],
                [-0.2625, 42.817497],
                [-0.300833, 42.839439],
                [-0.30556, 42.844162],
                [-0.308739, 42.848381],
                [-0.315, 42.835831],
                [-0.31778, 42.83111],
                [-0.323611, 42.82666],
                [-0.39194, 42.796387],
                [-0.54944, 42.77861],
                [-0.562222, 42.781387],
                [-0.712778, 42.88250000000011],
                [-0.718889, 42.88666500000011],
                [-0.72389, 42.891388],
                [-0.73194, 42.899162],
                [-0.73389, 42.90444200000013],
                [-0.73278, 42.909164],
                [-0.72332, 42.918945],
                [-0.722778, 42.922493000000145],
                [-0.72417, 42.937218],
                [-0.742778, 42.9611],
                [-0.746667, 42.965553],
                [-0.76, 42.96611],
                [-0.76694, 42.964722],
                [-0.786945, 42.95694],
                [-0.79056, 42.9525],
                [-0.81861, 42.946106],
                [-0.93417, 42.9525],
                [-0.946389, 42.955826000000116],
                [-0.99361, 42.976105],
                [-1.07278, 43.00639],
                [-1.200556, 43.04583],
                [-1.300278, 43.071663],
                [-1.34306, 43.039162],
                [-1.346667, 43.034721],
                [-1.360278, 43.031662],
                [-1.398056, 43.03805],
                [-1.42778, 43.04361],
                [-1.43444, 43.045555],
                [-1.445833, 43.051666000000125],
                [-1.45, 43.056664000000126],
                [-1.47056, 43.085831],
                [-1.4725, 43.09111],
                [-1.46889, 43.095833],
                [-1.45861, 43.10305],
                [-1.45167, 43.10305],
                [-1.429445, 43.116386],
                [-1.42222, 43.123604000000114],
                [-1.41139, 43.136665],
                [-1.385, 43.20166],
                [-1.38278, 43.217773],
                [-1.3825, 43.24721],
                [-1.38417, 43.25305200000014],
                [-1.39139, 43.262772],
                [-1.40889, 43.27304800000013],
                [-1.50361, 43.287773],
                [-1.65556, 43.309441],
                [-1.69278, 43.30778],
                [-1.711389, 43.304161000000136],
                [-1.73038, 43.29898100000014],
                [-1.776945, 43.3425],
                [-1.78088, 43.359924],
                [-1.73, 43.378883],
                [-1.666945, 43.385277],
                [-1.595, 43.43388],
                [-1.585278, 43.44138],
                [-1.53194, 43.509995],
                [-1.528056, 43.514999],
                [-1.48667, 43.57054900000014],
                [-1.443889, 43.640549000000135],
                [-1.4425, 43.66555],
                [-1.44028, 43.691383],
                [-1.42472, 43.784721],
                [-1.34694, 44.053604],
                [-1.34194, 44.07],
                [-1.333889, 44.085548],
                [-1.32917, 44.08972200000011],
                [-1.326389, 44.094444],
                [-1.305, 44.195549],
                [-1.26417, 44.393326],
                [-1.25861, 44.452217],
                [-1.24894, 44.49911],
                [-1.24961, 44.511772],
                [-1.25011, 44.515106],
                [-1.23378, 44.558109],
                [-1.208611, 44.625832000000116],
                [-1.15639, 44.658333],
                [-1.146389, 44.65583],
                [-1.12611, 44.651108000000136],
                [-1.094167, 44.65333],
                [-1.085834, 44.654160000000104],
                [-1.054167, 44.66],
                [-1.046389, 44.66333],
                [-1.04056, 44.66861],
                [-1.03611, 44.675278],
                [-1.03694, 44.68305],
                [-1.057222, 44.70805400000012],
                [-1.0625, 44.713608],
                [-1.12111, 44.754997],
                [-1.13444, 44.763611],
                [-1.158334, 44.773888],
                [-1.16889, 44.776108],
                [-1.176667, 44.772774],
                [-1.22556, 44.713051],
                [-1.23417, 44.699715],
                [-1.24, 44.689720000000136],
                [-1.245, 44.678329],
                [-1.248056, 44.67083],
                [-1.250278, 44.662498],
                [-1.2475, 44.757774],
                [-1.207222, 45.01332900000011],
                [-1.168334, 45.208611],
                [-1.15194, 45.37138],
                [-1.15222, 45.39222],
                [-1.148611, 45.427498],
                [-1.14111, 45.4897160000001],
                [-1.138889, 45.498055000000136],
                [-1.095, 45.552773000000116],
                [-1.08389, 45.564438],
                [-1.07667, 45.56860400000011],
                [-1.06806, 45.57083],
                [-1.058056, 45.571388],
                [-1.05361, 45.565826],
                [-1.05194, 45.558327],
                [-1.05222, 45.554161],
                [-1.053334, 45.550278000000105],
                [-1.059167, 45.539444],
                [-1.06111, 45.53083],
                [-1.061389, 45.527222],
                [-1.05778, 45.520828],
                [-1.045, 45.511665],
                [-0.99889, 45.47943900000013],
                [-0.99194, 45.474998],
                [-0.983889, 45.47110700000013],
                [-0.97056, 45.466385],
                [-0.947222, 45.463051],
                [-0.93694, 45.460548],
                [-0.92222, 45.452499],
                [-0.91556, 45.44778],
                [-0.80806, 45.367218],
                [-0.80222, 45.362495],
                [-0.7975, 45.35694100000012],
                [-0.77111, 45.3219380000001],
                [-0.759167, 45.30444],
                [-0.73611, 45.23549700000012],
                [-0.73444, 45.231331],
                [-0.733111, 45.224663],
                [-0.73361, 45.209496000000115],
                [-0.730611, 45.19133],
                [-0.714722, 45.130554],
                [-0.70639, 45.111382000000106],
                [-0.699445, 45.09861],
                [-0.54583, 44.89638500000012],
                [-0.54056, 44.890831000000105],
                [-0.53667, 44.89555400000012],
                [-0.53667, 44.89971900000012],
                [-0.53917, 44.983604],
                [-0.54167, 44.990273],
                [-0.554167, 45.023331],
                [-0.605, 45.05194100000011],
                [-0.61972, 45.060272],
                [-0.632222, 45.069717],
                [-0.643889, 45.079994],
                [-0.648056, 45.085831],
                [-0.65528, 45.098328],
                [-0.668333, 45.12416100000013],
                [-0.67306, 45.138054],
                [-0.70604, 45.32205],
                [-0.717778, 45.35721600000011],
                [-0.745833, 45.419998000000135],
                [-0.749722, 45.426384],
                [-0.77667, 45.4611],
                [-0.78639, 45.471939],
                [-0.80361, 45.487221],
                [-0.8625, 45.528885],
                [-1.000278, 45.61444100000011],
                [-1.08167, 45.65555],
                [-1.08972, 45.659439],
                [-1.165833, 45.68749],
                [-1.22333, 45.700554],
                [-1.23278, 45.698608],
                [-1.240834, 45.70166],
                [-1.24281, 45.70782500000013],
                [-1.242778, 45.710274],
                [-1.23444, 45.77583],
                [-1.23056, 45.78805],
                [-1.22556, 45.793884],
                [-1.188909, 45.799889],
                [-1.14594, 45.80294],
                [-1.148056, 45.867775],
                [-1.0775, 45.89666000000011],
                [-1.070833, 45.901382],
                [-1.06778, 45.908882],
                [-1.053334, 46.01221],
                [-1.05056, 46.034439],
                [-1.05194, 46.037773],
                [-1.05361, 46.041107],
                [-1.12, 46.125832],
                [-1.148611, 46.153328],
                [-1.10583, 46.258606],
                [-1.11463, 46.31658],
                [-1.16222, 46.326942],
                [-1.16806, 46.326942],
                [-1.172778, 46.325829],
                [-1.2, 46.31832900000012],
                [-1.20417, 46.316666],
                [-1.207778, 46.31472],
                [-1.21333, 46.30916600000012],
                [-1.215278, 46.30555],
                [-1.220278, 46.289719],
                [-1.26583, 46.30499300000014],
                [-1.46972, 46.39278],
                [-1.6543, 46.445358],
                [-1.78639, 46.488327],
                [-1.82194, 46.566109],
                [-1.8275, 46.583885],
                [-1.86056, 46.63777],
                [-1.91389, 46.68860600000011],
                [-1.91972, 46.69360400000011],
                [-2.007223, 46.76166500000011],
                [-2.033334, 46.776382000000126],
                [-2.05889, 46.786942],
                [-2.082778, 46.79860700000012],
                [-2.10139, 46.809166],
                [-2.10806, 46.813606],
                [-2.12, 46.82361],
                [-2.130834, 46.838333],
                [-2.133334, 46.849716000000114],
                [-2.133889, 46.891388],
                [-2.13, 46.89833],
                [-2.12444, 46.90416],
                [-2.087778, 46.94166600000011],
                [-2.03472, 46.98166700000013],
                [-1.98432, 47.031624],
                [-1.98417, 47.034439],
                [-1.9875, 47.040833],
                [-2.00028, 47.05916600000012],
                [-2.008334, 47.06721],
                [-2.02417, 47.079163],
                [-2.051667, 47.097221],
                [-2.05889, 47.100555],
                [-2.0725, 47.10527],
                [-2.11, 47.117218],
                [-2.11528, 47.118332],
                [-2.17083, 47.126663],
                [-2.165167, 47.22110700000013],
                [-2.160167, 47.23994],
                [-2.157167, 47.243275],
                [-2.154667, 47.244274],
                [-2.134167, 47.278053],
                [-2.043612, 47.287216],
                [-1.998889, 47.282219],
                [-1.938334, 47.274162],
                [-1.91889, 47.26944],
                [-1.91917, 47.266663],
                [-1.90333, 47.25444],
                [-1.89167, 47.248604],
                [-1.8025, 47.211937],
                [-1.773056, 47.20805400000012],
                [-1.746389, 47.206940000000145],
                [-1.735, 47.207771],
                [-1.73, 47.20916],
                [-1.72861, 47.210831],
                [-1.88389, 47.28666],
                [-1.896945, 47.290833],
                [-1.921389, 47.297775000000115],
                [-2.00333, 47.31916],
                [-2.022223, 47.320549],
                [-2.034167, 47.320274],
                [-2.12944, 47.309715],
                [-2.18756, 47.284607],
                [-2.194722, 47.27544],
                [-2.273334, 47.241661],
                [-2.28917, 47.23888],
                [-2.43361, 47.26249700000011],
                [-2.480278, 47.277222],
                [-2.53556, 47.294998],
                [-2.540278, 47.29666],
                [-2.54139, 47.300278000000105],
                [-2.5275, 47.38611],
                [-2.47972, 47.413055],
                [-2.46667, 47.417496],
                [-2.4475, 47.408333],
                [-2.44056, 47.403885],
                [-2.406389, 47.407494],
                [-2.41056, 47.42305],
                [-2.4596, 47.45299],
                [-2.471111, 47.44694],
                [-2.47667, 47.44638800000013],
                [-2.481112, 47.447777],
                [-2.48472, 47.45027],
                [-2.48694, 47.453049],
                [-2.491667, 47.49305],
                [-2.48667, 47.498604],
                [-2.481112, 47.49944],
                [-2.474445, 47.49916100000013],
                [-2.42278, 47.49944],
                [-2.37472, 47.5],
                [-2.36861, 47.5002750000001],
                [-2.36389, 47.501663],
                [-2.361111, 47.504166],
                [-2.38833, 47.510277],
                [-2.50944, 47.52916],
                [-2.58083, 47.537773],
                [-2.663611, 47.512772],
                [-2.79306, 47.48888],
                [-2.818334, 47.49360700000011],
                [-2.83361, 47.497215],
                [-2.837778, 47.49916100000013],
                [-2.86994, 47.540276],
                [-2.87028, 47.542774],
                [-2.868445, 47.547104],
                [-2.865945, 47.548107],
                [-2.864111, 47.548607],
                [-2.845611, 47.548107],
                [-2.81078, 47.544941],
                [-2.775278, 47.54722],
                [-2.755, 47.543884],
                [-2.736945, 47.543884],
                [-2.732778, 47.545555],
                [-2.687222, 47.59416],
                [-2.685, 47.597221000000104],
                [-2.680556, 47.613052],
                [-2.681111, 47.617218],
                [-2.694723, 47.634995],
                [-2.698056, 47.637215],
                [-2.70417, 47.638054],
                [-2.88883, 47.599720000000104],
                [-2.925333, 47.581051],
                [-3.09167, 47.584717],
                [-3.09528, 47.58722],
                [-3.119722, 47.598328],
                [-3.125, 47.599442],
                [-3.12722, 47.59638],
                [-3.128334, 47.587494],
                [-3.12889, 47.52916],
                [-3.126667, 47.52166],
                [-3.12028, 47.500549],
                [-3.09611, 47.484993],
                [-3.08611, 47.47361],
                [-3.10639, 47.472221],
                [-3.13139, 47.47527],
                [-3.13389, 47.47805],
                [-3.150278, 47.524994],
                [-3.148612, 47.52861],
                [-3.140833, 47.532776],
                [-3.13639, 47.5388870000001],
                [-3.135, 47.542496],
                [-3.13194, 47.559441],
                [-3.13139, 47.568604],
                [-3.13222, 47.57666000000012],
                [-3.134445, 47.58416],
                [-3.14, 47.59388700000011],
                [-3.150278, 47.6097180000001],
                [-3.157222, 47.61388],
                [-3.190556, 47.62861],
                [-3.21694, 47.650551],
                [-3.50889, 47.7586060000001],
                [-3.633266, 47.77745800000014],
                [-3.79278, 47.793884000000105],
                [-3.833889, 47.800552],
                [-3.84806, 47.805832],
                [-3.87528, 47.824165],
                [-3.88833, 47.833611],
                [-3.89111, 47.83638800000011],
                [-3.904445, 47.85278],
                [-3.98222, 47.889717],
                [-4.10139, 47.874992000000134],
                [-4.151112, 47.854439],
                [-4.155834, 47.8361],
                [-4.15528, 47.831940000000145],
                [-4.15972, 47.825554],
                [-4.1675, 47.81721],
                [-4.18278, 47.804161],
                [-4.209445, 47.79943800000012],
                [-4.215, 47.79860700000012],
                [-4.255834, 47.794716],
                [-4.26944, 47.794998],
                [-4.36194, 47.802773],
                [-4.366389, 47.804161],
                [-4.369167, 47.806938],
                [-4.37194, 47.821106],
                [-4.3725, 47.82527],
                [-4.370556, 47.82861],
                [-4.366945, 47.83083],
                [-4.34833, 47.835548],
                [-4.34583, 47.838051],
                [-4.344167, 47.841942],
                [-4.343334, 47.84944],
                [-4.343889, 47.85361],
                [-4.35, 47.871941000000106],
                [-4.36389, 47.898888],
                [-4.39222, 47.934441],
                [-4.419445, 47.960831],
                [-4.43611, 47.9725],
                [-4.45083, 47.980827],
                [-4.48486, 48],
                [-4.495831, 48.005836],
                [-4.524721, 48.021111],
                [-4.529443, 48.022499],
                [-4.541943, 48.01722000000012],
                [-4.591111, 48.01694],
                [-4.689167, 48.03],
                [-4.69444, 48.03138700000011],
                [-4.718334, 48.037773],
                [-4.72614, 48.04058],
                [-4.710556, 48.065552],
                [-4.70806, 48.06832900000012],
                [-4.7025, 48.069160000000124],
                [-4.360001, 48.113327],
                [-4.34778, 48.112495],
                [-4.331944, 48.104439],
                [-4.30611, 48.09861],
                [-4.3, 48.09805300000011],
                [-4.29472, 48.098885],
                [-4.291667, 48.1013870000001],
                [-4.28361, 48.11472],
                [-4.28222, 48.118332],
                [-4.27611, 48.13916000000012],
                [-4.27528, 48.143326],
                [-4.27556, 48.151939],
                [-4.27806, 48.159164],
                [-4.30222, 48.19305400000013],
                [-4.31028, 48.201385],
                [-4.32028, 48.208328],
                [-4.441389, 48.238327],
                [-4.46194, 48.24249300000014],
                [-4.47472, 48.242218],
                [-4.48472, 48.239441],
                [-4.49306, 48.236107],
                [-4.495001, 48.232773],
                [-4.49389, 48.229164],
                [-4.49389, 48.225555],
                [-4.511111, 48.2],
                [-4.53722, 48.176109],
                [-4.54083, 48.17388],
                [-4.552501, 48.172775],
                [-4.555834, 48.174995],
                [-4.62028, 48.26722],
                [-4.62389, 48.281944000000124],
                [-4.62139, 48.284721],
                [-4.57361, 48.328049000000135],
                [-4.55944, 48.336105],
                [-4.55111, 48.339439],
                [-4.53583, 48.343048],
                [-4.531112, 48.341660000000104],
                [-4.531389, 48.33805100000012],
                [-4.54194, 48.318329],
                [-4.55139, 48.306107],
                [-4.55083, 48.30305],
                [-4.54528, 48.298332],
                [-4.535278, 48.29138200000011],
                [-4.530556, 48.28999],
                [-4.408334, 48.283607],
                [-4.26333, 48.284721],
                [-4.205278, 48.29471600000011],
                [-4.18611, 48.299995],
                [-4.18861, 48.301384],
                [-4.3, 48.320549],
                [-4.40222, 48.328331],
                [-4.43861, 48.333054],
                [-4.44213, 48.34175],
                [-4.440556, 48.354996],
                [-4.605278, 48.344719],
                [-4.71139, 48.334717000000126],
                [-4.75278, 48.33332800000011],
                [-4.758889, 48.333885],
                [-4.76361, 48.335274],
                [-4.767222, 48.337494],
                [-4.775, 48.35055],
                [-4.784167, 48.366943],
                [-4.78472, 48.37028],
                [-4.790278, 48.421387],
                [-4.790278, 48.426109],
                [-4.77778, 48.509438],
                [-4.77556, 48.512772],
                [-4.758056, 48.533051],
                [-4.74389, 48.54583],
                [-4.72889, 48.55888],
                [-4.701945, 48.57],
                [-4.6975, 48.571663],
                [-4.63194, 48.57972000000012],
                [-4.625556, 48.579994],
                [-4.604167, 48.57194],
                [-4.600278, 48.57],
                [-4.596945, 48.567772000000105],
                [-4.58972, 48.55999800000012],
                [-4.58694, 48.573883],
                [-4.565556, 48.62083],
                [-4.56361, 48.623886],
                [-4.54167, 48.635277],
                [-4.536945, 48.63638300000014],
                [-4.35417, 48.674164],
                [-4.17194, 48.687492],
                [-3.99361, 48.722771],
                [-3.968056, 48.72555],
                [-3.97194, 48.714165],
                [-3.97361, 48.705826],
                [-3.9725, 48.702217],
                [-3.96417, 48.68527200000011],
                [-3.949445, 48.6561],
                [-3.8575, 48.636108],
                [-3.851111, 48.655548],
                [-3.86111, 48.68055],
                [-3.86028, 48.683609],
                [-3.83333, 48.713882000000126],
                [-3.83056, 48.716660000000104],
                [-3.81056, 48.726105],
                [-3.72806, 48.712776],
                [-3.717778, 48.710274],
                [-3.678334, 48.69472],
                [-3.638611, 48.681938000000116],
                [-3.59611, 48.675827],
                [-3.583056, 48.675827],
                [-3.575278, 48.679718],
                [-3.531945, 48.739166000000125],
                [-3.56278, 48.764717],
                [-3.5675, 48.76611],
                [-3.57778, 48.764999],
                [-3.580556, 48.76694],
                [-3.58167, 48.774994],
                [-3.580556, 48.78360700000013],
                [-3.5775, 48.791107],
                [-3.575278, 48.794167],
                [-3.536667, 48.825829],
                [-3.5125, 48.837219],
                [-3.47472, 48.8408280000001],
                [-3.38, 48.82194],
                [-3.366389, 48.82666],
                [-3.23139, 48.86860700000011],
                [-3.220834, 48.870552],
                [-3.12444, 48.864998],
                [-3.06083, 48.826385],
                [-2.87917, 48.67889],
                [-2.81194, 48.614166],
                [-2.72056, 48.533051],
                [-2.695556, 48.513054000000125],
                [-2.68528, 48.50166],
                [-2.474445, 48.622498],
                [-2.464723, 48.629997],
                [-2.462778, 48.63304900000014],
                [-2.461667, 48.637215],
                [-2.418334, 48.65361000000013],
                [-2.307222, 48.67610900000011],
                [-2.284445, 48.672218],
                [-2.128334, 48.638611],
                [-2.03928, 48.599552],
                [-2.03961, 48.596886],
                [-1.98222, 48.51416],
                [-1.97722, 48.512497],
                [-1.9725, 48.512772],
                [-1.94944, 48.524719],
                [-1.94647, 48.52654300000012],
                [-1.94361, 48.529999],
                [-1.94194, 48.533607],
                [-1.95278, 48.57666],
                [-1.95528, 48.57944],
                [-1.963611, 48.587494],
                [-1.969445, 48.592773000000136],
                [-1.97889, 48.595833],
                [-1.984445, 48.59610700000013],
                [-1.99444, 48.593605],
                [-2.006667, 48.602776],
                [-2.008778, 48.630775],
                [-2.01411, 48.642273],
                [-2.01678, 48.64844],
                [-2.01711, 48.65094],
                [-1.98806, 48.68694],
                [-1.9325, 48.69722000000013],
                [-1.84889, 48.70916],
                [-1.84611, 48.70916],
                [-1.83889, 48.689163],
                [-1.83861, 48.684998],
                [-1.84083, 48.681938000000116],
                [-1.84444, 48.679718],
                [-1.861111, 48.672775000000115],
                [-1.867222, 48.657776],
                [-1.87, 48.649994000000106],
                [-1.854167, 48.628883],
                [-1.846667, 48.62055],
                [-1.84028, 48.615555],
                [-1.825556, 48.611382000000106],
                [-1.812222, 48.61055],
                [-1.78722, 48.61055],
                [-1.72278, 48.611107],
                [-1.64917, 48.615273],
                [-1.633056, 48.617775],
                [-1.61944, 48.622215],
                [-1.61083, 48.62611],
                [-1.588626, 48.639679],
                [-1.521111, 48.63638300000014],
                [-1.465, 48.637215],
                [-1.36889, 48.64361],
                [-1.449722, 48.675552],
                [-1.48972, 48.685829],
                [-1.49889, 48.689163],
                [-1.56056, 48.74472],
                [-1.5625, 48.747772],
                [-1.563611, 48.75166300000012],
                [-1.578611, 48.83778],
                [-1.57556, 48.862778000000105],
                [-1.564167, 48.91444],
                [-1.556389, 49.015831000000105],
                [-1.57667, 49.008331],
                [-1.58083, 49.00666],
                [-1.585, 49.00888800000013],
                [-1.589445, 49.015],
                [-1.5975, 49.04027600000012],
                [-1.61, 49.089439],
                [-1.60972, 49.215],
                [-1.68111, 49.294441],
                [-1.70583, 49.318329],
                [-1.740834, 49.351662],
                [-1.75, 49.359444],
                [-1.7775, 49.373604000000114],
                [-1.79, 49.374992],
                [-1.80278, 49.374443],
                [-1.80917, 49.37527],
                [-1.812222, 49.377777],
                [-1.84556, 49.49971800000014],
                [-1.846667, 49.568329],
                [-1.84, 49.578331000000105],
                [-1.83806, 49.58638800000011],
                [-1.83833, 49.59833],
                [-1.84194, 49.61360900000011],
                [-1.84861, 49.635826],
                [-1.855278, 49.64944],
                [-1.857778, 49.652222],
                [-1.864444, 49.656944000000124],
                [-1.88389, 49.66305],
                [-1.900278, 49.66638200000011],
                [-1.91306, 49.66777],
                [-1.941667, 49.67333],
                [-1.94556, 49.67555],
                [-1.94611, 49.679443],
                [-1.94444, 49.71611],
                [-1.944167, 49.720551],
                [-1.941667, 49.723885],
                [-1.938056, 49.72583],
                [-1.93278, 49.72722],
                [-1.92639, 49.727493],
                [-1.91444, 49.72555],
                [-1.84472, 49.713882000000126],
                [-1.71528, 49.680275],
                [-1.673611, 49.664719],
                [-1.670833, 49.66166],
                [-1.666945, 49.659721],
                [-1.64944, 49.657776],
                [-1.620556, 49.655273],
                [-1.53722, 49.656662],
                [-1.518813, 49.658356],
                [-1.50111, 49.664444],
                [-1.482778, 49.67555],
                [-1.47972, 49.678329],
                [-1.472778, 49.687492],
                [-1.46667, 49.697777],
                [-1.41083, 49.70499400000011],
                [-1.38, 49.70694],
                [-1.37306, 49.70666],
                [-1.322778, 49.70082900000011],
                [-1.288611, 49.694443],
                [-1.26417, 49.684166],
                [-1.23861, 49.65583],
                [-1.23056, 49.630272],
                [-1.22722, 49.619164],
                [-1.22778, 49.614441],
                [-1.23028, 49.611382],
                [-1.259167, 49.59833],
                [-1.29222, 49.58388500000012],
                [-1.296111, 49.5816650000001],
                [-1.30139, 49.575829],
                [-1.30444, 49.568329],
                [-1.305, 49.563606],
                [-1.303056, 49.547493000000145],
                [-1.29833, 49.537216],
                [-1.291945, 49.527771],
                [-1.28722, 49.522217],
                [-1.26417, 49.49638],
                [-1.256667, 49.48805],
                [-1.251389, 49.48221600000011],
                [-1.23806, 49.46833],
                [-1.165278, 49.406662],
                [-1.11389, 49.365273],
                [-1.105278, 49.373604000000114],
                [-1.09167, 49.38304900000014],
                [-1.08472, 49.38777],
                [-1.07278, 49.393608],
                [-1.06778, 49.394722],
                [-0.976944, 49.39666000000011],
                [-0.92778, 49.394722],
                [-0.92139, 49.393883],
                [-0.90917, 49.383606],
                [-0.901945, 49.379166],
                [-0.887778, 49.374443],
                [-0.868056, 49.368607],
                [-0.85139, 49.364998],
                [-0.827222, 49.361664],
                [-0.72556, 49.351662],
                [-0.62194, 49.344994],
                [-0.58056, 49.345276000000126],
                [-0.50306, 49.34610700000013],
                [-0.42417, 49.34194200000013],
                [-0.410833, 49.34083],
                [-0.38222, 49.331108],
                [-0.369722, 49.325554],
                [-0.36, 49.32222],
                [-0.301111, 49.30416],
                [-0.2875, 49.299995],
                [-0.22833, 49.283607],
                [-0.104167, 49.299164],
                [-0.09333, 49.301109],
                [-0.073333, 49.30555],
                [-0.039444, 49.31472],
                [0, 49.32877],
                [0.062222000000133, 49.35194400000012],
                [0.079167, 49.358887],
                [0.085556, 49.364166],
                [0.098611, 49.378883],
                [0.113611, 49.391388],
                [0.131944, 49.4025],
                [0.149167, 49.409439],
                [0.169444, 49.41416],
                [0.235278, 49.427216],
                [0.270278, 49.430275],
                [0.29524, 49.431458],
                [0.368611, 49.439438],
                [0.384722, 49.44221],
                [0.424722, 49.45166],
                [0.45138900000012, 49.461105],
                [0.46333, 49.466942],
                [0.474167, 49.47361],
                [0.494444, 49.48805],
                [0.49166700000012, 49.48805],
                [0.48333300000013, 49.484444],
                [0.441389000000129, 49.471664],
                [0.388056, 49.457771],
                [0.371667, 49.455551],
                [0.353611, 49.454163],
                [0.3225, 49.453049],
                [0.309167000000116, 49.453331],
                [0.25611, 49.457222000000115],
                [0.160833, 49.468887],
                [0.119167, 49.48472],
                [0.107222, 49.490829],
                [0.078056, 49.51166500000011],
                [0.073889, 49.51778],
                [0.074167000000102, 49.526665],
                [0.07722200000012, 49.534164],
                [0.16972, 49.688889],
                [0.184444, 49.702774],
                [0.187500000000114, 49.705276],
                [0.208889, 49.718048],
                [0.213333, 49.719719],
                [0.266944, 49.73360400000013],
                [0.31111, 49.74499500000013],
                [0.426944000000105, 49.788605],
                [0.563333000000114, 49.84471900000011],
                [0.585833, 49.85277600000012],
                [0.640278000000137, 49.86610400000012],
                [0.683333, 49.873604],
                [0.694722, 49.874992],
                [0.71333, 49.87555],
                [1.068611, 49.926109],
                [1.073611, 49.927216],
                [1.201944, 49.969719],
                [1.22, 49.97610500000013],
                [1.2325, 49.981667],
                [1.37243, 50.065781],
                [1.39389, 50.07471],
                [1.409444, 50.083054],
                [1.435555, 50.098328],
                [1.441944, 50.103333000000134],
                [1.461111, 50.124161],
                [1.505555, 50.201942],
                [1.534167, 50.288605],
                [1.53472, 50.292221],
                [1.549444, 50.352493],
                [1.552778, 50.359993],
                [1.555278, 50.363052],
                [1.56, 50.3647160000001],
                [1.585278, 50.370277],
                [1.598333, 50.37055],
                [1.603851, 50.36879],
                [1.562778, 50.39611],
                [1.560278, 50.399162],
                [1.558055, 50.4061],
                [1.577222, 50.528053000000114],
                [1.564167, 50.68471],
                [1.564444, 50.705826],
                [1.598611000000119, 50.809166],
                [1.625, 50.877777],
                [1.733333, 50.942497],
                [1.745833000000118, 50.948051],
                [1.768889, 50.95583],
                [1.792778, 50.962776],
                [1.943333000000109, 50.9952770000001],
                [2.23528, 51.03805],
                [2.35944400000011, 51.054443],
                [2.38472, 51.051941],
                [2.407222, 51.054993],
                [2.42305, 51.058052],
                [2.492222, 51.07611],
                [2.5166660000001, 51.082771],
                [2.541667000000132, 51.09111],
              ],
            ],
          ],
        },
        id: 24,
        NAME: 'France',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Finland',
          id: 25,
          label: 'Finland',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.04,
          year: '2023',
          centroid: [25.7482, 61.9241],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [23.705826, 59.9272160000001],
                [23.649437, 59.92083],
                [23.616386, 59.925552],
                [23.596664, 59.923882000000106],
                [23.50722100000013, 59.91555000000011],
                [23.40222200000011, 59.90083],
                [23.391109, 59.901382],
                [23.38055, 59.903053000000114],
                [23.37278, 59.90638700000011],
                [23.369999, 59.91138500000011],
                [23.370831, 59.91693900000013],
                [23.38388, 59.925827],
                [23.51833, 59.95861],
                [23.527775, 59.959717],
                [23.53833, 59.960274],
                [23.54944, 59.959717],
                [23.723328, 59.933884],
                [23.729439, 59.931938],
                [23.726383000000112, 59.929718],
                [23.705826, 59.9272160000001],
              ],
            ],
            [
              [
                [22.833611, 59.956383],
                [22.843052000000114, 59.953331000000105],
                [22.94028, 59.9566650000001],
                [22.981937, 59.95861],
                [23.00193800000011, 59.960548],
                [23.054161, 59.95861],
                [23.068054, 59.95555100000013],
                [23.072498, 59.951111],
                [23.07194, 59.94554900000014],
                [23.05611, 59.90333],
                [23.049999000000128, 59.8986],
                [23.040554, 59.897217],
                [23.018055000000118, 59.899994],
                [22.945831000000112, 59.90222200000011],
                [22.927776, 59.8986],
                [22.9175, 59.898331],
                [22.885277, 59.901939],
                [22.87722, 59.905273000000136],
                [22.847496, 59.919441],
                [22.80778, 59.94527],
                [22.803333, 59.949715],
                [22.802219, 59.954994],
                [22.808887, 59.9675],
                [22.815, 59.972496],
                [22.82361, 59.974716],
                [22.830555000000118, 59.972221],
                [22.831387, 59.966942],
                [22.8291660000001, 59.96083],
                [22.833611, 59.956383],
              ],
            ],
            [
              [
                [22.43888500000014, 59.99582700000013],
                [22.38138, 59.98666400000013],
                [22.373329000000126, 59.98999800000013],
                [22.367714, 60],
                [22.353333000000134, 60.034164],
                [22.34833, 60.049438],
                [22.349442, 60.060829000000126],
                [22.35194, 60.06694],
                [22.35778, 60.071663],
                [22.364719, 60.07582900000011],
                [22.40444200000013, 60.083885],
                [22.415833, 60.081383],
                [22.434444, 60.076385],
                [22.440552, 60.07249500000012],
                [22.445831, 60.06444],
                [22.451385, 60.054993],
                [22.4525, 60.04972],
                [22.450275, 60.01416],
                [22.44778, 60.008049],
                [22.44263500000011, 60],
                [22.43888500000014, 59.99582700000013],
              ],
            ],
            [
              [
                [21.598053, 60.098053],
                [21.520554, 60.093605],
                [21.51083, 60.096664],
                [21.484722, 60.10833],
                [21.48527, 60.11388],
                [21.50194, 60.139442],
                [21.52972000000011, 60.154716],
                [21.552776, 60.164444],
                [21.562222000000133, 60.165833],
                [21.596386, 60.16499],
                [21.633331, 60.16166],
                [21.646664, 60.159721],
                [21.655552000000114, 60.155548000000124],
                [21.655277, 60.14555400000012],
                [21.63833, 60.109993000000145],
                [21.63528, 60.10472],
                [21.598053, 60.098053],
              ],
            ],
            [
              [
                [21.748886, 60.111382000000106],
                [21.73917, 60.109993000000145],
                [21.72777600000012, 60.110275],
                [21.703331, 60.112495],
                [21.695274, 60.115829],
                [21.704441, 60.166939],
                [21.708885, 60.179161],
                [21.715553, 60.183052],
                [21.723331, 60.186386],
                [21.827221000000122, 60.19082600000013],
                [21.856388, 60.191666],
                [21.87278, 60.184715],
                [21.885277, 60.177216],
                [21.88472, 60.171387],
                [21.864719, 60.155],
                [21.78500000000014, 60.118889],
                [21.748886, 60.111382000000106],
              ],
            ],
            [
              [
                [21.39666, 60.17860400000012],
                [21.385277, 60.156662],
                [21.307499, 60.173882],
                [21.271942, 60.184715],
                [21.268330000000105, 60.188049],
                [21.273888000000113, 60.193054],
                [21.28749800000014, 60.201111],
                [21.296108, 60.203331],
                [21.30555, 60.204994],
                [21.338886000000116, 60.204994],
                [21.350277, 60.20472],
                [21.386387, 60.188049],
                [21.39666, 60.17860400000012],
              ],
            ],
            [
              [
                [22.000832, 60.12944],
                [21.990276000000108, 60.128883],
                [21.962219, 60.1325],
                [21.952221, 60.13528],
                [21.943054, 60.143883],
                [21.93861, 60.164719],
                [21.937496, 60.169998],
                [21.942219, 60.175827],
                [21.949997, 60.178886],
                [22.032776000000126, 60.205276],
                [22.060833, 60.20388800000012],
                [22.07, 60.195274],
                [22.07027, 60.19082600000013],
                [22.030552000000114, 60.142776],
                [22.023888000000113, 60.138885],
                [22.000832, 60.12944],
              ],
            ],
            [
              [
                [25.84861, 60.195549],
                [25.83, 60.192497],
                [25.81889, 60.195274],
                [25.813053, 60.199165],
                [25.810555, 60.204163],
                [25.81444, 60.20916],
                [25.821663, 60.21305100000012],
                [25.839443, 60.216942],
                [25.85166, 60.215553],
                [25.874996, 60.211105],
                [25.869720000000143, 60.207771],
                [25.855831, 60.19944],
                [25.84861, 60.195549],
              ],
            ],
            [
              [
                [22.824444, 60.227219],
                [22.834999, 60.19389],
                [22.847221, 60.124718],
                [22.848053, 60.119438],
                [22.839165, 60.09638],
                [22.83583, 60.09111],
                [22.73611, 60.00305],
                [22.72666, 60.001663],
                [22.68222, 59.99777200000011],
                [22.67610900000011, 60.001663],
                [22.633331, 60.004715],
                [22.601109000000122, 59.98333000000014],
                [22.60133, 60],
                [22.600277, 60.004997],
                [22.572498, 60.027496],
                [22.528889000000106, 60.00610400000011],
                [22.521111000000133, 60.00305],
                [22.51166, 60.001663],
                [22.472771, 59.996941000000106],
                [22.469463000000133, 60],
                [22.471132, 60.072083000000134],
                [22.424164, 60.10833],
                [22.415276, 60.152222],
                [22.430275, 60.194443],
                [22.443607, 60.213333],
                [22.449718000000132, 60.21833],
                [22.4575, 60.221382],
                [22.467777, 60.221939000000134],
                [22.47416, 60.218048],
                [22.47527700000012, 60.21277600000013],
                [22.587776, 60.2025],
                [22.645275, 60.21083],
                [22.7325, 60.21999],
                [22.824444, 60.227219],
              ],
            ],
            [
              [
                [22.24222200000014, 60.18110700000011],
                [22.224163, 60.17749800000013],
                [22.215275, 60.179443000000106],
                [22.214165, 60.184715],
                [22.2125, 60.200829],
                [22.217777000000126, 60.21860500000014],
                [22.222775000000127, 60.224442],
                [22.228611, 60.22916],
                [22.23555, 60.23333],
                [22.242496, 60.23722],
                [22.25027, 60.240273],
                [22.284721, 60.249443],
                [22.29444100000012, 60.248604],
                [22.30611, 60.22305300000011],
                [22.302776, 60.217773],
                [22.291111000000114, 60.208054],
                [22.264442, 60.191383],
                [22.24222200000014, 60.18110700000011],
              ],
            ],
            [
              [
                [25.677219, 60.234993],
                [25.634998, 60.19805],
                [25.598053, 60.207771],
                [25.59111, 60.210548],
                [25.56166, 60.260551000000135],
                [25.561108, 60.265831],
                [25.576664, 60.290833],
                [25.585552, 60.2930530000001],
                [25.595276, 60.29193900000013],
                [25.60472, 60.28860500000013],
                [25.673885, 60.25055],
                [25.679722, 60.24638],
                [25.681942, 60.24166],
                [25.677219, 60.234993],
              ],
            ],
            [
              [
                [22.34222000000011, 60.28305],
                [22.335831, 60.268326],
                [22.33083, 60.262497],
                [22.320274, 60.26194],
                [22.310555, 60.2649990000001],
                [22.297222, 60.266937],
                [22.285831, 60.26722],
                [22.277222, 60.2649990000001],
                [22.234722, 60.252777],
                [22.226944, 60.24971800000014],
                [22.21333, 60.24166],
                [22.21888700000011, 60.269722],
                [22.20916, 60.2725],
                [22.144722000000115, 60.281105],
                [22.14138800000012, 60.277771],
                [22.179443, 60.2736],
                [22.180553, 60.268326],
                [22.177219, 60.263054],
                [22.169441, 60.25999500000012],
                [22.151108, 60.256104],
                [22.12917, 60.255829],
                [22.078888, 60.261383],
                [22.071941, 60.263885],
                [22.068886, 60.268608],
                [22.069164000000114, 60.28527100000014],
                [22.069721, 60.291107],
                [22.075554, 60.29583],
                [22.096107, 60.30778],
                [22.20583, 60.30917],
                [22.21722, 60.308884],
                [22.241943, 60.306389],
                [22.318054, 60.293327],
                [22.34111, 60.28833],
                [22.34222000000011, 60.28305],
              ],
            ],
            [
              [
                [22.383331000000112, 60.28833],
                [22.373608000000104, 60.286942],
                [22.315277, 60.316666],
                [22.32527, 60.334717],
                [22.33111, 60.339722],
                [22.338886000000116, 60.342773],
                [22.39666, 60.351105],
                [22.402775, 60.34944],
                [22.472221, 60.327774],
                [22.476944, 60.32361],
                [22.47361, 60.31833],
                [22.4675, 60.313606],
                [22.460552, 60.309441],
                [22.452774, 60.306389],
                [22.418888, 60.296387],
                [22.383331000000112, 60.28833],
              ],
            ],
            [
              [
                [21.982777000000112, 60.324165],
                [21.972221, 60.32361],
                [21.959721000000116, 60.324715],
                [21.946388, 60.326942000000145],
                [21.89944, 60.335274],
                [21.818886, 60.35805],
                [21.79639, 60.36860700000011],
                [21.789997, 60.372498],
                [21.78527, 60.376938],
                [21.784721, 60.387772],
                [21.80499600000013, 60.459442],
                [21.807499, 60.465553],
                [21.81611, 60.46777],
                [21.826664, 60.466385],
                [21.896385, 60.444443],
                [21.933331, 60.416664],
                [21.996666, 60.358887],
                [21.999443, 60.337494000000106],
                [21.99722, 60.331383],
                [21.982777000000112, 60.324165],
              ],
            ],
            [
              [
                [21.75166, 60.498329],
                [21.691666, 60.450272],
                [21.684444, 60.452774],
                [21.684998, 60.458611],
                [21.688889, 60.469444],
                [21.695, 60.482216],
                [21.699165, 60.488884],
                [21.73, 60.520271],
                [21.736664, 60.524162],
                [21.745552, 60.526382],
                [21.756943, 60.526108],
                [21.763332, 60.522499],
                [21.76388500000013, 60.515831000000105],
                [21.757500000000107, 60.503052],
                [21.75166, 60.498329],
              ],
            ],
            [
              [
                [21.32889, 60.48111],
                [21.323608, 60.477493],
                [21.275833, 60.47805],
                [21.23, 60.54777],
                [21.226944000000117, 60.55249800000013],
                [21.23111, 60.55694],
                [21.25027, 60.55499300000014],
                [21.278053000000114, 60.54028],
                [21.283886, 60.53583],
                [21.298332, 60.52277400000014],
                [21.321388, 60.495827],
                [21.32889, 60.48111],
              ],
            ],
            [
              [
                [21.483330000000137, 60.520271],
                [21.432499, 60.469719],
                [21.419167, 60.471664],
                [21.409164, 60.474442],
                [21.324997, 60.51611],
                [21.32194, 60.543053],
                [21.332775, 60.553886],
                [21.338608, 60.556389],
                [21.358055, 60.559441000000106],
                [21.369442, 60.55916600000012],
                [21.39278, 60.556664],
                [21.457497, 60.53583],
                [21.47583, 60.529442],
                [21.480553, 60.525276],
                [21.483330000000137, 60.520271],
              ],
            ],
            [
              [
                [21.29028, 60.61222],
                [21.289165, 60.56139],
                [21.276665, 60.562492000000134],
                [21.2305530000001, 60.590553],
                [21.22110700000013, 60.59916],
                [21.21805, 60.60388200000011],
                [21.213886, 60.613884],
                [21.214165, 60.61972000000014],
                [21.21833, 60.623886],
                [21.25583, 60.643051],
                [21.2666660000001, 60.643608],
                [21.276108, 60.63499500000012],
                [21.29028, 60.61222],
              ],
            ],
            [
              [
                [21.3275, 60.87722],
                [21.31861, 60.874992],
                [21.263885, 60.879166],
                [21.245831, 60.94999700000011],
                [21.254166, 60.958885],
                [21.268055000000118, 60.964722],
                [21.28666, 60.96860500000014],
                [21.296387, 60.967773],
                [21.304722, 60.964439],
                [21.32194, 60.953606],
                [21.3475, 60.932495],
                [21.35722, 60.92194],
                [21.3275, 60.87722],
              ],
            ],
            [
              [
                [21.080276, 63.281387],
                [21.29222, 63.23944100000011],
                [21.299721, 63.24333],
                [21.348331, 63.254166],
                [21.370552, 63.256386],
                [21.41333, 63.25138900000013],
                [21.41861, 63.246941],
                [21.427219, 63.196938],
                [21.42083, 63.192215],
                [21.309998, 63.15361],
                [21.300552, 63.151382000000126],
                [21.279442, 63.148331],
                [21.246944, 63.144722000000115],
                [21.252220000000136, 63.15277100000014],
                [21.248055000000136, 63.15610500000014],
                [21.195000000000107, 63.187492],
                [21.18611, 63.190826],
                [21.182777, 63.185555],
                [21.182220000000143, 63.179993],
                [21.175831, 63.174995],
                [21.165276, 63.173607],
                [21.15166, 63.174438],
                [21.144722000000115, 63.178329],
                [21.132774, 63.192215],
                [21.09889, 63.23610700000012],
                [21.081387, 63.27055400000012],
                [21.08, 63.275833],
                [21.080276, 63.281387],
              ],
            ],
            [
              [
                [22.180832, 63.265274],
                [22.17028, 63.263885],
                [22.078331000000105, 63.279442],
                [22.061108, 63.289719],
                [22.044167, 63.301941],
                [22.040833, 63.306938000000116],
                [22.046387, 63.31027200000011],
                [22.075275, 63.317215],
                [22.08583, 63.31860400000011],
                [22.192497000000117, 63.3219380000001],
                [22.197498, 63.32],
                [22.206944000000135, 63.30555],
                [22.21, 63.300827],
                [22.207497, 63.294716],
                [22.186386, 63.270828],
                [22.180832, 63.265274],
              ],
            ],
            [
              [
                [21.32333, 63.28916],
                [21.315552, 63.287216],
                [21.23333, 63.320274],
                [21.231941, 63.325554000000125],
                [21.238331, 63.330276],
                [21.29111, 63.349998],
                [21.301666, 63.3513870000001],
                [21.338608, 63.351662],
                [21.352219, 63.35055],
                [21.37611, 63.345276],
                [21.38111, 63.34111000000013],
                [21.378887000000134, 63.334999],
                [21.345554000000106, 63.30110900000011],
                [21.32333, 63.28916],
              ],
            ],
            [
              [
                [22.873608, 63.799995],
                [22.868332000000123, 63.770554],
                [22.853333, 63.776939],
                [22.81694, 63.780548],
                [22.770275, 63.784164],
                [22.750832000000116, 63.779716],
                [22.706665, 63.775276],
                [22.679443000000106, 63.78527],
                [22.672497, 63.789162],
                [22.671387, 63.794441],
                [22.672222, 63.79805],
                [22.676941, 63.804443],
                [22.683609, 63.809441],
                [22.70305, 63.82055],
                [22.80611, 63.876938],
                [22.866665, 63.87416100000013],
                [22.880554, 63.87277],
                [22.89222, 63.871109],
                [22.897499, 63.866943000000106],
                [22.916943, 63.83305400000012],
                [22.918331, 63.827774],
                [22.917221, 63.82194],
                [22.91166, 63.816383],
                [22.88777, 63.815277],
                [22.879997, 63.811386],
                [22.876389, 63.806107],
                [22.873608, 63.799995],
              ],
            ],
            [
              [
                [24.734997000000135, 64.944443],
                [24.72277, 64.94415],
                [24.707497000000103, 64.94638],
                [24.603054, 64.96193],
                [24.596107, 64.96582],
                [24.585831, 64.972488],
                [24.56805400000013, 64.990555],
                [24.551666, 65.0249940000001],
                [24.554996, 65.031097],
                [24.562222, 65.03583],
                [24.615555, 65.056381],
                [24.624996000000124, 65.05915800000014],
                [24.64583, 65.063599],
                [24.67805, 65.068878],
                [24.700832, 65.071381],
                [24.808609, 65.078049],
                [24.833611000000133, 65.07859800000011],
                [24.848053000000107, 65.07721],
                [25.018887, 65.04361000000011],
                [25.03, 65.040543],
                [25.035, 65.036102],
                [25.029442, 65.02970900000014],
                [25.021111000000133, 65.027771],
                [25.000000000000114, 65.025848],
                [24.961109000000135, 65.02442900000011],
                [24.84666, 65.003601],
                [24.820274, 64.963882],
                [24.734997000000135, 64.944443],
              ],
            ],
            [
              [
                [24.462219, 65.763885],
                [24.449718, 65.76361],
                [24.43694, 65.769714],
                [24.440552, 65.775833],
                [24.454441, 65.78610200000014],
                [24.465275000000133, 65.78833],
                [24.48, 65.786942],
                [24.495831, 65.784714],
                [24.50305200000014, 65.78054800000012],
                [24.5, 65.776657],
                [24.462219, 65.763885],
              ],
            ],
            [
              [
                [28.165833, 69.91221600000011],
                [28.19722000000013, 69.90638700000011],
                [28.22666500000014, 69.90222200000011],
                [28.276108000000136, 69.896652],
                [28.31028, 69.890823],
                [28.32333, 69.8875],
                [28.339165, 69.87944],
                [28.34472, 69.87498],
                [28.358330000000137, 69.85083],
                [28.358330000000137, 69.845551],
                [28.366665, 69.836105],
                [28.37194, 69.83166],
                [28.379719, 69.8274990000001],
                [28.404999, 69.821655],
                [28.694721, 69.7686],
                [28.744164, 69.75972],
                [28.909721, 69.733887],
                [28.94611, 69.72861],
                [28.992222, 69.72248800000011],
                [29.009441, 69.72055100000011],
                [29.09889, 69.70805400000012],
                [29.106667, 69.703888],
                [29.127499, 69.685822],
                [29.176109, 69.635269],
                [29.183887, 69.626099],
                [29.29472, 69.49527000000012],
                [29.299721, 69.48555],
                [29.299721, 69.48027000000013],
                [29.285553, 69.46360800000014],
                [29.2691650000001, 69.4519350000001],
                [29.122219, 69.37082],
                [29.064163, 69.343887],
                [29.033333, 69.33055100000013],
                [29.002499, 69.31721500000015],
                [28.991665000000125, 69.31388900000013],
                [28.931664, 69.28860500000013],
                [28.92194400000011, 69.284164],
                [28.902775, 69.274994],
                [28.83639, 69.242767],
                [28.82694, 69.23805],
                [28.819164, 69.231934],
                [28.796665, 69.188324],
                [28.784164, 69.16055],
                [28.78167, 69.149719],
                [28.781944, 69.13415],
                [28.784443, 69.123886],
                [28.786942, 69.119156],
                [28.802219, 69.10554500000012],
                [28.827499, 69.0935970000001],
                [28.857777000000112, 69.082214],
                [28.890553, 69.07138],
                [28.9573400000001, 69.05162],
                [28.91333, 69.04332],
                [28.877777, 69.036102],
                [28.8555530000001, 69.029709],
                [28.746387, 68.99721],
                [28.456944000000135, 68.91832],
                [28.446663, 68.9147190000001],
                [28.43916300000012, 68.908325],
                [28.431942, 68.896942],
                [28.43222, 68.886383],
                [28.447498, 68.878326],
                [28.4625, 68.87527],
                [28.479164, 68.873596],
                [28.509163000000115, 68.872772],
                [28.564999, 68.87443500000012],
                [28.705830000000105, 68.878326],
                [28.737778000000105, 68.87582],
                [28.792774, 68.85777],
                [28.812775, 68.850266],
                [28.81555200000014, 68.848877],
                [28.820553, 68.844437],
                [28.803333, 68.815826],
                [28.796108, 68.804443],
                [28.76416, 68.757767],
                [28.759163, 68.751938],
                [28.73860900000011, 68.73416],
                [28.654999, 68.679993],
                [28.525833, 68.589722],
                [28.510277, 68.578049],
                [28.46583, 68.540833],
                [28.458611, 68.534714],
                [28.457497, 68.53194],
                [28.559998, 68.385818],
                [28.663055, 68.239441],
                [28.69333300000011, 68.197495],
                [28.696663000000115, 68.19332900000012],
                [28.823330000000112, 68.17248500000011],
                [29.16, 68.11665],
                [29.35694100000012, 68.08248900000012],
                [29.38361, 68.062485],
                [29.539444, 67.93888900000013],
                [29.691666, 67.815277],
                [29.7275, 67.80332900000013],
                [29.9025, 67.740829],
                [30.02861, 67.69472],
                [29.977776, 67.572495],
                [29.964722, 67.54443400000014],
                [29.95472, 67.53277600000013],
                [29.932777, 67.513885],
                [29.899998, 67.492493],
                [29.881664000000114, 67.48359700000015],
                [29.745552, 67.41638],
                [29.525276000000133, 67.293884],
                [29.156944000000124, 67.03082300000011],
                [29.134163, 67.013611],
                [29.0925, 66.97583],
                [29.087776, 66.969986],
                [29.083054000000118, 66.958603],
                [29.079998, 66.943604],
                [29.075275, 66.911377],
                [29.07499700000011, 66.89582800000011],
                [29.07499700000011, 66.87999],
                [29.077221000000122, 66.874985],
                [29.086388000000113, 66.860825],
                [29.09333, 66.85138],
                [29.097775, 66.84693900000013],
                [29.123055, 66.824707],
                [29.13444, 66.8161],
                [29.202774, 66.77442900000011],
                [29.22110700000013, 66.76694],
                [29.246109000000104, 66.75499],
                [29.25972, 66.746658],
                [29.273331, 66.73832700000014],
                [29.318886, 66.70887800000014],
                [29.33, 66.700272],
                [29.35027700000012, 66.682495],
                [29.359444, 66.673325],
                [29.385548, 66.62831100000011],
                [29.41416500000014, 66.5999910000001],
                [29.554443, 66.470276],
                [29.56792400000012, 66.42857400000014],
                [29.573055000000124, 66.41137700000013],
                [29.574718, 66.406937],
                [29.577499000000103, 66.401657],
                [29.583332, 66.39221],
                [29.590275, 66.38276700000011],
                [29.62527, 66.33638],
                [29.63861100000014, 66.32249500000012],
                [29.770832, 66.214157],
                [29.782219, 66.205276],
                [29.799164, 66.19249],
                [29.82611100000014, 66.175552],
                [29.849998, 66.16360500000013],
                [29.87638900000013, 66.15222200000011],
                [29.897221, 66.140823],
                [29.910275, 66.12693800000011],
                [29.918888, 66.112778],
                [29.94833, 66.049713],
                [30.032219, 65.92221100000012],
                [30.09111000000013, 65.842773],
                [30.09666, 65.833328],
                [30.1025, 65.8186],
                [30.134163, 65.71916],
                [30.134998, 65.709152],
                [30.135277, 65.70359800000011],
                [30.13361, 65.676941],
                [30.123886, 65.66499],
                [30.111664000000133, 65.66527],
                [30.085278, 65.67139],
                [30.06805400000013, 65.679443],
                [30.03611000000012, 65.68999],
                [30.024441, 65.69110100000012],
                [29.99249600000013, 65.68527200000011],
                [29.818886, 65.65332000000012],
                [29.834164, 65.588333],
                [29.798054, 65.53749],
                [29.77916, 65.530273],
                [29.761387, 65.523041],
                [29.746109, 65.514435],
                [29.738331, 65.48111000000011],
                [29.739719, 65.455551],
                [29.745552, 65.4147190000001],
                [29.75, 65.352768],
                [29.74944, 65.347763],
                [29.747498, 65.341934],
                [29.70611, 65.31972],
                [29.679996, 65.306931],
                [29.662220000000104, 65.298874],
                [29.620831, 65.276657],
                [29.605274000000122, 65.26582300000013],
                [29.598888, 65.25972],
                [29.596943, 65.253876],
                [29.596386, 65.24889],
                [29.599163, 65.24360700000011],
                [29.60305, 65.239441],
                [29.609444, 65.23527],
                [29.62639, 65.22749],
                [29.639721000000122, 65.224442],
                [29.65222200000011, 65.22333],
                [29.6655540000001, 65.22333],
                [29.73722, 65.226654],
                [29.787498, 65.226379],
                [29.81389, 65.224442],
                [29.827499, 65.22249],
                [29.843052000000114, 65.219986],
                [29.853611, 65.21611],
                [29.866108, 65.20805400000012],
                [29.869999, 65.203323],
                [29.87278, 65.19832],
                [29.874443, 65.12582],
                [29.873886, 65.12082],
                [29.864719, 65.116653],
                [29.836666, 65.106934],
                [29.806942, 65.099152],
                [29.773888, 65.09471],
                [29.726387000000102, 65.092499],
                [29.683609, 65.08444],
                [29.664719000000105, 65.079163],
                [29.65472, 65.075546],
                [29.63722, 65.06832900000012],
                [29.628887, 65.063049],
                [29.622498, 65.056381],
                [29.616665000000125, 65.044998],
                [29.609444, 65.02304],
                [29.60639, 65.007217],
                [29.60666700000013, 65.001663],
                [29.609997000000135, 64.991943],
                [29.636665, 64.92805],
                [29.644997, 64.91387900000012],
                [29.652775, 64.904709],
                [29.67194, 64.887207],
                [29.714443, 64.852219],
                [29.730553, 64.839432],
                [29.736664, 64.83499100000012],
                [29.755, 64.822495],
                [29.774441, 64.809708],
                [29.79416700000013, 64.797211],
                [29.804722, 64.7938840000001],
                [29.818333, 64.792496],
                [29.843052000000114, 64.792496],
                [29.8916660000001, 64.793045],
                [29.926388, 64.794708],
                [29.95027, 64.795547],
                [30.04805, 64.795547],
                [30.074444, 64.79361],
                [30.08778, 64.79166],
                [30.115833, 64.785828],
                [30.126389, 64.78248600000012],
                [30.140831, 64.774155],
                [30.144722000000115, 64.76998900000012],
                [30.20916, 64.67277500000012],
                [30.210552, 64.66777],
                [30.208611, 64.6624910000001],
                [30.199165, 64.65027],
                [30.186386, 64.63777],
                [30.17889, 64.631653],
                [30.17028, 64.628052],
                [30.141666, 64.61943100000013],
                [30.07249800000011, 64.60443],
                [30.033333, 64.599152],
                [30.020554000000118, 64.5961],
                [29.980831, 64.585831],
                [29.974998, 64.5811000000001],
                [29.974998, 64.57443],
                [29.986942000000113, 64.55305],
                [30.00967, 64.51286],
                [30.01139, 64.511658],
                [30.04888, 64.50249],
                [30.068607, 64.49472],
                [30.087219, 64.483047],
                [30.088608, 64.478333],
                [30.088333, 64.467773],
                [30.083054, 64.45221],
                [30.061386, 64.422485],
                [30.053608, 64.404999],
                [30.065552, 64.396942],
                [30.11889, 64.36916],
                [30.12722, 64.36499],
                [30.135277, 64.361374],
                [30.156109, 64.354156],
                [30.17028, 64.35137900000012],
                [30.196941, 64.348877],
                [30.321663, 64.329437],
                [30.359444, 64.31972],
                [30.389721, 64.30943300000013],
                [30.55278, 64.248322],
                [30.560833000000116, 64.24443100000013],
                [30.56666600000011, 64.23999],
                [30.573887, 64.23082],
                [30.576664000000108, 64.22610500000013],
                [30.578053, 64.221375],
                [30.611111000000108, 64.101654],
                [30.614441000000113, 64.08665500000012],
                [30.611664, 64.075821],
                [30.608887, 64.06499],
                [30.595276000000126, 64.046936],
                [30.558887, 64.02055400000012],
                [30.54361, 64.009995],
                [30.52861000000013, 64],
                [30.48860900000011, 63.977776],
                [30.47194, 63.968887],
                [30.398052, 63.93055],
                [30.27861, 63.832771],
                [30.263611, 63.82222],
                [30.25583300000011, 63.817772000000105],
                [30.210552, 63.80082700000014],
                [30.134998, 63.779999],
                [30.114719, 63.775276],
                [30.063053, 63.76666300000011],
                [30.033054, 63.76082600000012],
                [30.013054, 63.756386000000134],
                [30.004719, 63.75278],
                [29.996712, 63.74802],
                [29.993332, 63.743607],
                [29.995831, 63.738884],
                [30.00333, 63.729439],
                [30.206387, 63.612778],
                [30.228333, 63.600555],
                [30.244442, 63.593048],
                [30.254719000000136, 63.58972],
                [30.308887, 63.57249500000012],
                [30.357498000000135, 63.55999800000012],
                [30.391388, 63.549995],
                [30.399441, 63.546104],
                [30.4525, 63.508049],
                [30.461941, 63.49916100000013],
                [30.472775, 63.48555],
                [30.4775, 63.481110000000115],
                [30.481667, 63.47861],
                [30.648888000000113, 63.439720000000136],
                [30.714722, 63.42443800000012],
                [30.91222, 63.353607],
                [31.186386, 63.238327],
                [31.219719, 63.223053],
                [31.236664000000133, 63.21027400000014],
                [31.24222200000014, 63.205551],
                [31.245831000000123, 63.20111],
                [31.38305, 63.06916],
                [31.514999000000103, 62.986938],
                [31.524166, 62.978333000000134],
                [31.588928000000124, 62.91441300000014],
                [31.574997, 62.901382],
                [31.521664, 62.853333],
                [31.501389, 62.835548],
                [31.480553, 62.818886],
                [31.4675, 62.806389],
                [31.429996, 62.758888],
                [31.32194, 62.615273],
                [31.310555, 62.598053],
                [31.294167, 62.56416],
                [31.280277, 62.53611],
                [31.269165, 62.51861],
                [31.25972, 62.507774],
                [31.251942, 62.50332600000013],
                [31.082775, 62.41305],
                [30.964165, 62.339165],
                [30.834442, 62.27138500000012],
                [30.7925, 62.253883],
                [30.704166, 62.21054800000013],
                [30.6325, 62.166107000000125],
                [30.396111, 62.01666300000011],
                [30.300552, 61.95611],
                [30.203888, 61.890549],
                [30.155102, 61.85635],
                [30.142174000000125, 61.846954],
                [30.005554, 61.739441],
                [29.991386, 61.729439],
                [29.809166, 61.60833],
                [29.79472, 61.5991590000001],
                [29.683331000000123, 61.533882],
                [29.652496, 61.517776],
                [29.497498, 61.436661],
                [29.362499, 61.364166],
                [29.348053000000107, 61.35527],
                [29.334164, 61.345276],
                [29.301941, 61.31832900000012],
                [29.285076000000117, 61.302864],
                [29.277496, 61.294716],
                [29.271111, 61.289444],
                [29.249722, 61.27583],
                [29.21361, 61.253326],
                [29.174164, 61.235275],
                [29.157497, 61.22888200000011],
                [29.071941, 61.19944],
                [28.970833, 61.16277300000013],
                [28.820553, 61.106941],
                [28.812775, 61.103333],
                [28.719997, 61.04527],
                [28.674164, 61.00166],
                [28.65222200000011, 60.976105],
                [28.638885, 60.96611000000013],
                [28.6311070000001, 60.962494000000106],
                [28.62249800000012, 60.959717],
                [28.612499, 60.958885],
                [28.57777, 60.961662],
                [28.547775000000115, 60.958885],
                [28.529163, 60.954994],
                [28.520554, 60.952217],
                [28.466389, 60.92528],
                [28.38888500000013, 60.886665],
                [28.351109, 60.865829],
                [28.344166, 60.861382],
                [28.338055, 60.855827],
                [28.33444, 60.849998],
                [28.3325, 60.84416],
                [28.326385, 60.838882000000126],
                [28.298611, 60.820549],
                [28.269444000000135, 60.804161],
                [28.246387, 60.793327],
                [28.09388700000011, 60.71221900000012],
                [27.88472, 60.58916],
                [27.807831, 60.546402],
                [27.80666, 60.548607],
                [27.789997, 60.566109],
                [27.785275, 60.570549],
                [27.774719, 60.573883],
                [27.76277, 60.574715],
                [27.75222, 60.574165],
                [27.74361, 60.572495],
                [27.739441, 60.567497],
                [27.734997, 60.551666],
                [27.734165000000132, 60.535553],
                [27.738052, 60.51138300000014],
                [27.671108000000117, 60.50444],
                [27.60667, 60.506104],
                [27.47666500000014, 60.506386],
                [27.472221000000104, 60.502495],
                [27.473053, 60.476387],
                [27.29555, 60.503883],
                [27.271942, 60.525276],
                [27.270832, 60.541939],
                [27.223053000000107, 60.58194],
                [27.215275000000133, 60.585548],
                [27.031387, 60.53889],
                [27.02555500000011, 60.53333],
                [27.020554, 60.52694],
                [26.9675, 60.445274],
                [26.960278, 60.44194],
                [26.9525, 60.445549],
                [26.905277000000126, 60.47610500000013],
                [26.811108, 60.47277],
                [26.739441, 60.448883],
                [26.666943000000117, 60.426666000000125],
                [26.56361, 60.42805],
                [26.503052, 60.443054],
                [26.497219, 60.446938],
                [26.483608000000117, 60.46],
                [26.474998, 60.468605],
                [26.473053, 60.473328],
                [26.474163, 60.47916],
                [26.48, 60.48555],
                [26.564163, 60.574165],
                [26.575832000000105, 60.585548],
                [26.594997, 60.59805300000011],
                [26.617222, 60.605827],
                [26.628887000000134, 60.608055],
                [26.648888, 60.60889],
                [26.668331, 60.607498],
                [26.68889, 60.597771],
                [26.702499, 60.586105],
                [26.734997, 60.575272],
                [26.753887, 60.571663000000115],
                [26.754997, 60.577217],
                [26.721943, 60.617775],
                [26.69527, 60.640831],
                [26.68861, 60.64416],
                [26.659164, 60.6475],
                [26.645554, 60.645271],
                [26.61555, 60.640274],
                [26.60722, 60.63694],
                [26.54608900000011, 60.58192],
                [26.52694300000013, 60.565277],
                [26.461941, 60.5075],
                [26.456944, 60.500832],
                [26.45388800000012, 60.494995],
                [26.452774, 60.483887],
                [26.459442, 60.469444],
                [26.468052, 60.46054800000013],
                [26.471664, 60.455826],
                [26.478333000000134, 60.446938],
                [26.48222, 60.43694],
                [26.47916400000014, 60.431107],
                [26.47277, 60.426384],
                [26.458611, 60.416107000000125],
                [26.421665, 60.391937],
                [26.411388000000102, 60.39138800000012],
                [26.146111, 60.393883],
                [26.06111, 60.423882],
                [26.051388, 60.427498],
                [26.046665, 60.41583],
                [26.111664, 60.330276],
                [26.109722, 60.324715],
                [26.104721, 60.31805400000013],
                [26.094444, 60.306107],
                [26.083054, 60.294998],
                [26.074444, 60.2930530000001],
                [26.041943, 60.2930530000001],
                [26.036942000000124, 60.29610400000013],
                [26.03805, 60.30194100000011],
                [26.04361, 60.30722],
                [26.04639, 60.313606],
                [26.044441, 60.31833],
                [26.04055, 60.322495],
                [25.996109, 60.344719],
                [25.893608, 60.38805],
                [25.884163, 60.39138800000012],
                [25.83805500000011, 60.401108],
                [25.838333, 60.395828],
                [25.863609, 60.385826],
                [25.87833, 60.379997],
                [25.909443, 60.360275000000115],
                [25.915276, 60.35583],
                [25.9180530000001, 60.35139],
                [25.928608, 60.248604],
                [25.927776000000108, 60.244438],
                [25.919998, 60.24166],
                [25.910275000000127, 60.240273],
                [25.899166, 60.240273],
                [25.887497, 60.24166],
                [25.881664, 60.245552],
                [25.880554, 60.251106],
                [25.877777, 60.26082600000012],
                [25.873886, 60.27082800000011],
                [25.870831, 60.275551],
                [25.864998, 60.27944200000013],
                [25.753887, 60.314720000000136],
                [25.744776, 60.310219],
                [25.740442000000144, 60.30738800000012],
                [25.742775, 60.29805],
                [25.741665, 60.29055],
                [25.74555, 60.28611000000012],
                [25.788055, 60.268608],
                [25.799999000000128, 60.26722],
                [25.829166, 60.27082800000011],
                [25.84111000000013, 60.26944],
                [25.845833, 60.2649990000001],
                [25.780277, 60.232773],
                [25.769444, 60.234444],
                [25.720554, 60.248055],
                [25.674164, 60.275276],
                [25.65361, 60.29166],
                [25.649719, 60.296387],
                [25.647778, 60.301109],
                [25.647778, 60.335548],
                [25.657497, 60.337494000000106],
                [25.6675, 60.337494000000106],
                [25.693554, 60.339382],
                [25.694553, 60.342216],
                [25.69339, 60.34522],
                [25.690277, 60.35694],
                [25.683331, 60.36055],
                [25.6725, 60.362778000000105],
                [25.66222, 60.362221],
                [25.652775000000133, 60.360275000000115],
                [25.576111, 60.328888],
                [25.545277, 60.311104000000114],
                [25.48944, 60.245827],
                [25.478886, 60.248329000000126],
                [25.367775, 60.255829],
                [25.200832000000105, 60.241943],
                [25.192219000000136, 60.239998],
                [25.148888000000113, 60.22361],
                [25.14638, 60.219444],
                [25.156109, 60.216385000000116],
                [25.180832000000123, 60.213333],
                [25.19333300000011, 60.21083],
                [25.201111, 60.2075],
                [25.203331000000105, 60.20277],
                [25.19527, 60.186386],
                [25.188053, 60.18222],
                [25.06583, 60.156105],
                [24.958878, 60.136681000000124],
                [24.949436000000105, 60.135559],
                [24.85083, 60.13666],
                [24.75111, 60.13694],
                [24.603333, 60.121941],
                [24.608887, 60.095276000000126],
                [24.60805, 60.08972200000011],
                [24.591942, 60.056664000000126],
                [24.586666, 60.05305],
                [24.48222, 59.991386],
                [24.462776000000133, 59.989441],
                [24.421104, 59.987221],
                [24.421387, 60.027222],
                [24.366665, 60.068054],
                [24.355, 60.070549],
                [24.333054, 60.071938],
                [24.292221, 60.068604],
                [24.285275, 60.06444],
                [24.281944, 60.059441],
                [24.216942, 60.039444],
                [24.07416, 60.01527],
                [23.7972180000001, 59.961937],
                [23.70194, 59.95444],
                [23.62833, 59.95221700000013],
                [23.61805, 59.951942],
                [23.5613570000001, 59.970669],
                [23.50979, 59.96849],
                [23.434444, 59.950554],
                [23.426662, 59.953888],
                [23.43083, 59.960274],
                [23.479443, 59.996666],
                [23.521942, 60.019165],
                [23.537498, 60.02527600000013],
                [23.5425, 60.03110500000014],
                [23.54611, 60.067215],
                [23.53833, 60.06972],
                [23.519444, 60.066109],
                [23.493889000000138, 60.058327],
                [23.365829, 59.94221],
                [23.252499000000114, 59.839165],
                [23.246109, 59.8366620000001],
                [23.193886, 59.82777],
                [22.909721, 59.80499300000014],
                [22.889721, 59.80639],
                [22.891941, 59.810829],
                [22.93472, 59.840553],
                [23.086941000000138, 59.87916600000011],
                [23.114998, 59.884438],
                [23.156109, 59.8836060000001],
                [23.16555, 59.88611],
                [23.257217, 59.919441],
                [23.29666, 59.95861],
                [23.325577, 60],
                [23.33833, 60.02],
                [23.335278, 60.027496],
                [23.33083, 60.028328],
                [23.317234, 60.02066],
                [23.311234, 60.014832],
                [23.297009000000116, 60],
                [23.280273, 59.979439],
                [23.250549, 59.94527],
                [23.234718, 59.932495],
                [23.224995, 59.926109],
                [23.215549000000124, 59.924995],
                [23.117496, 59.922493],
                [23.10722, 59.922493],
                [23.101109, 59.926109],
                [23.098053000000107, 59.93083],
                [23.0975, 59.935829],
                [23.107777, 59.96833],
                [23.114441, 59.972221],
                [23.16694, 59.985275000000115],
                [23.202496, 59.993332],
                [23.21856300000013, 60],
                [23.224720000000104, 60.00332600000013],
                [23.25972, 60.03555300000011],
                [23.250000000000114, 60.038605],
                [23.19833, 60.04722],
                [23.18555, 60.04833200000013],
                [23.14666, 60.046104],
                [23.126389, 60.04416700000013],
                [23.109444, 60.039444],
                [23.101665, 60.036385],
                [23.083885, 60.03221900000011],
                [23.073887, 60.031387],
                [23.049442, 60.03611],
                [22.995831, 60.054443],
                [22.987778, 60.057777],
                [22.985554, 60.062775],
                [22.992496, 60.081108],
                [23.00361, 60.091385],
                [23.017288, 60.10122],
                [23.04361, 60.116661],
                [23.041943, 60.120827],
                [23.027775, 60.128052],
                [23.022499, 60.129166],
                [22.967499, 60.11193800000012],
                [22.90610900000013, 60.12638900000013],
                [22.87444, 60.14555400000012],
                [22.86972, 60.179161],
                [22.901386000000116, 60.213333],
                [22.90721900000011, 60.21833],
                [22.92, 60.227219],
                [22.93361, 60.23472],
                [22.964443, 60.248329000000126],
                [22.97111, 60.25222],
                [23.011387000000127, 60.277496],
                [23.023052, 60.286942],
                [23.086388, 60.34166],
                [23.086941000000138, 60.346939],
                [23.07889, 60.350555],
                [23.066944, 60.35305],
                [23.055832000000123, 60.353333],
                [22.91917, 60.304161],
                [22.808331, 60.26194],
                [22.793888, 60.25499700000012],
                [22.760555, 60.244164000000126],
                [22.74361, 60.23972],
                [22.72555, 60.234993],
                [22.699165, 60.22916],
                [22.66278, 60.222221],
                [22.574997, 60.210548],
                [22.55595, 60.213326],
                [22.451385, 60.240273],
                [22.44722, 60.244438],
                [22.460278, 60.261108],
                [22.46527, 60.26666300000011],
                [22.480274, 60.28139],
                [22.488052, 60.285],
                [22.53611, 60.312492],
                [22.62028, 60.3702770000001],
                [22.62611, 60.374992000000134],
                [22.631386, 60.38110400000011],
                [22.63361, 60.38694],
                [22.632221, 60.391937],
                [22.62278, 60.393051],
                [22.483608, 60.391937],
                [22.276943, 60.385826],
                [22.259163000000115, 60.398048],
                [22.23666, 60.408333],
                [22.17583100000013, 60.43138900000014],
                [22.114719, 60.448883],
                [22.08361, 60.443886000000134],
                [22.01444, 60.465271],
                [21.971107, 60.488052],
                [21.949165000000107, 60.513054],
                [21.947498, 60.518608],
                [21.937496, 60.52138500000012],
                [21.86972, 60.524162],
                [21.851944, 60.524162],
                [21.83972200000011, 60.524162],
                [21.8375, 60.51833],
                [21.84166, 60.50805],
                [21.863052, 60.471939],
                [21.803055, 60.482498000000135],
                [21.796665, 60.55583200000012],
                [21.796944, 60.56194],
                [21.799999, 60.5669400000001],
                [21.81361, 60.575829],
                [21.828888, 60.58194],
                [21.830555000000118, 60.59499],
                [21.824444, 60.61916],
                [21.775, 60.60305],
                [21.76638800000012, 60.599716],
                [21.664165, 60.55249800000013],
                [21.58833, 60.50694],
                [21.587776, 60.51194],
                [21.576942, 60.562492000000134],
                [21.557499, 60.56832900000012],
                [21.545555, 60.570831],
                [21.51861, 60.574715],
                [21.5075, 60.574715],
                [21.497219, 60.573608],
                [21.489719, 60.57],
                [21.47361, 60.56472],
                [21.452774, 60.562492000000134],
                [21.429996, 60.573326],
                [21.418331, 60.585274],
                [21.358608, 60.65361],
                [21.354721, 60.67360700000012],
                [21.355, 60.683609000000104],
                [21.363609, 60.686386],
                [21.386108, 60.686386],
                [21.392498000000103, 60.755554],
                [21.35555, 60.814995],
                [21.328331, 60.865273],
                [21.387775, 60.94082600000013],
                [21.405552, 61.030548],
                [21.44444, 61.167221],
                [21.493889, 61.23555],
                [21.54444100000012, 61.276382],
                [21.554443, 61.309441],
                [21.530552, 61.44722],
                [21.519444, 61.509163000000115],
                [21.51083, 61.51249700000011],
                [21.497498, 61.52],
                [21.465275, 61.550552],
                [21.4725, 61.562492000000134],
                [21.493332000000123, 61.573883],
                [21.50333000000012, 61.57305],
                [21.603333000000134, 61.544716],
                [21.659721000000104, 61.533607],
                [21.668053, 61.54694400000011],
                [21.601387, 61.601662],
                [21.535275, 61.65333],
                [21.470276, 61.755272],
                [21.47083, 61.760826],
                [21.478333, 61.772774],
                [21.489441, 61.797775],
                [21.488052, 61.80305],
                [21.410553, 61.890549],
                [21.363331, 61.929443000000106],
                [21.299603, 61.941826000000106],
                [21.28889, 61.944717],
                [21.280277, 61.948051],
                [21.25333, 62.005554],
                [21.285553, 62.06944],
                [21.305832000000123, 62.108887],
                [21.333885, 62.153885000000116],
                [21.37778, 62.179443],
                [21.382774, 62.185272],
                [21.389999000000103, 62.203606],
                [21.38861, 62.208885],
                [21.371666, 62.259995],
                [21.33667, 62.348885],
                [21.32777, 62.352219],
                [21.25916, 62.375832000000116],
                [21.155552, 62.412773],
                [21.111664000000133, 62.45166],
                [21.114998000000128, 62.491386],
                [21.1252750000001, 62.547493],
                [21.067497, 62.591660000000104],
                [21.064163, 62.596382],
                [21.064720000000136, 62.612221],
                [21.101944, 62.762772],
                [21.106110000000115, 62.76944],
                [21.112499000000128, 62.77444],
                [21.13028, 62.787773],
                [21.137497, 62.791939],
                [21.29805, 62.860832],
                [21.339722, 62.85472],
                [21.351944, 62.85443900000013],
                [21.362499, 62.855827],
                [21.370831, 62.859161],
                [21.37722, 62.86388],
                [21.382500000000107, 62.86972],
                [21.396385, 62.886665],
                [21.433331, 62.943329],
                [21.445831, 62.967499],
                [21.450554, 63.006386],
                [21.434166, 63.030273000000136],
                [21.434719, 63.035828],
                [21.439163, 63.042496],
                [21.49555, 63.06583],
                [21.50611, 63.06721],
                [21.51972, 63.06611],
                [21.537498, 63.059441],
                [21.54444100000012, 63.05555],
                [21.54722, 63.04527300000012],
                [21.552219, 63.040833],
                [21.561108, 63.037498],
                [21.619999, 63.018608],
                [21.670277, 63.01777600000014],
                [21.67972200000014, 63.019997],
                [21.686108, 63.024994],
                [21.6827770000001, 63.029716],
                [21.677776, 63.03388],
                [21.658607, 63.04583],
                [21.651665, 63.049721],
                [21.611385, 63.06805400000013],
                [21.575275, 63.075829],
                [21.566387000000134, 63.079163],
                [21.561108, 63.08361],
                [21.521942000000138, 63.120552],
                [21.51527, 63.129997],
                [21.501663, 63.159721],
                [21.492496, 63.19194],
                [21.49305, 63.19749500000012],
                [21.4977760000001, 63.21],
                [21.504166, 63.21472200000011],
                [21.53416, 63.228607],
                [21.542774, 63.231941],
                [21.555553, 63.22943900000013],
                [21.56444, 63.22610500000013],
                [21.569443, 63.221939],
                [21.570831000000112, 63.21666],
                [21.576111, 63.21222],
                [21.583054, 63.208611],
                [21.63361, 63.193054],
                [21.647221, 63.19194],
                [21.690277, 63.20916],
                [21.869164, 63.25694],
                [21.881943, 63.25666],
                [21.890831000000105, 63.253326],
                [21.892776, 63.206108],
                [21.96666, 63.183052],
                [22.086109, 63.22277100000014],
                [22.179722, 63.230827],
                [22.21694200000013, 63.236382000000106],
                [22.337219, 63.2736],
                [22.342777, 63.279442],
                [22.36777, 63.310555],
                [22.371387, 63.31582600000013],
                [22.35555, 63.339722],
                [22.327221, 63.366104],
                [22.320274, 63.36999500000013],
                [22.298611, 63.375832000000116],
                [22.27194, 63.386108],
                [22.203053, 63.417221],
                [22.198055, 63.421387],
                [22.191666, 63.430832],
                [22.185555, 63.440552],
                [22.186108000000104, 63.446106],
                [22.188053, 63.463051],
                [22.283886, 63.524162],
                [22.292500000000132, 63.527222],
                [22.32888800000012, 63.52166],
                [22.337776, 63.518326],
                [22.37611, 63.489716],
                [22.39638, 63.472496],
                [22.429443, 63.498886],
                [22.489441, 63.565826],
                [22.50528, 63.583611],
                [22.51298100000014, 63.598732],
                [22.504166, 63.60777300000012],
                [22.5, 63.617493],
                [22.502777, 63.623886],
                [22.589165, 63.695549],
                [22.65694, 63.698883],
                [22.668888, 63.69944],
                [22.68055, 63.697777],
                [22.699718, 63.685829],
                [22.70277, 63.68110700000011],
                [22.707775, 63.66499],
                [22.70611, 63.653885],
                [22.733608, 63.621666],
                [22.740833, 63.61777500000011],
                [22.752499, 63.618332],
                [22.78055, 63.625832],
                [22.824444, 63.641388],
                [22.899998, 63.698608],
                [22.931389000000138, 63.755829],
                [22.930275, 63.76082600000012],
                [22.925278, 63.765274],
                [22.918331, 63.76916],
                [22.92333, 63.801109],
                [23.066387, 63.85083],
                [23.143055, 63.876938],
                [23.152775, 63.879166],
                [23.19527, 63.885277],
                [23.206108, 63.886665],
                [23.318886000000134, 63.89666000000011],
                [23.371944, 63.938889],
                [23.368889, 63.943604],
                [23.371387, 63.98693800000012],
                [23.379997, 64.04222],
                [23.38472, 64.0486],
                [23.395832, 64.049988],
                [23.42055, 64.049988],
                [23.434719, 64.04887400000013],
                [23.511387, 64.03637700000013],
                [23.602219000000105, 64.064438],
                [23.60833, 64.09833],
                [23.652222, 64.140823],
                [23.694164, 64.1586],
                [23.711662000000103, 64.1629],
                [23.722221, 64.184158],
                [23.855274, 64.2438810000001],
                [23.926666000000125, 64.2691650000001],
                [23.923885, 64.28498800000011],
                [23.92999600000013, 64.29693600000013],
                [23.99222200000014, 64.381104],
                [23.999443, 64.38582],
                [24.11999900000012, 64.436386],
                [24.209721, 64.47276],
                [24.278053, 64.49693300000013],
                [24.33527800000013, 64.51971400000014],
                [24.34333, 64.523605],
                [24.359165, 64.543045],
                [24.376663, 64.579712],
                [24.375832, 64.584991],
                [24.367222, 64.599442],
                [24.367496, 64.610275],
                [24.36861, 64.616104],
                [24.37167, 64.622208],
                [24.376942, 64.628601],
                [24.424999000000128, 64.6752780000001],
                [24.535275000000127, 64.74137900000011],
                [24.535553, 64.75221],
                [24.536942, 64.795822],
                [24.542221, 64.80249],
                [24.73111, 64.854431],
                [24.803333000000123, 64.869156],
                [25.000000000000114, 64.892212],
                [25.075832, 64.910828],
                [25.086388, 64.912766],
                [25.09972, 64.912216],
                [25.112778, 64.90943900000013],
                [25.11972, 64.905548],
                [25.180275, 64.8669430000001],
                [25.191387, 64.84776],
                [25.196388, 64.84332300000011],
                [25.2275, 64.820831],
                [25.233330000000137, 64.81776400000012],
                [25.246387, 64.814987],
                [25.26083, 64.81359900000012],
                [25.297497000000135, 64.814438],
                [25.31944, 64.81776400000012],
                [25.339996, 64.82193],
                [25.359722, 64.826935],
                [25.364166, 64.83194],
                [25.366943, 64.891663],
                [25.365555, 64.902222],
                [25.360832, 64.906662],
                [25.34861000000012, 64.9086],
                [25.33722, 64.90721],
                [25.317219, 64.902222],
                [25.30305, 64.90388500000012],
                [25.233608, 64.92776500000014],
                [25.226665, 64.931656],
                [25.190277, 64.96193],
                [25.188332, 64.96611],
                [25.208054, 64.987213],
                [25.21860900000013, 64.989166],
                [25.311943, 64.983047],
                [25.32333, 64.98193400000014],
                [25.339165, 64.974442],
                [25.359997, 64.962494],
                [25.37611, 64.954712],
                [25.407497, 64.94472],
                [25.420830000000137, 64.94415],
                [25.44055, 64.949158],
                [25.44722000000013, 64.954712],
                [25.448608, 64.960541],
                [25.413055, 65.03416400000015],
                [25.37055, 65.079437],
                [25.360832, 65.088333],
                [25.346943, 65.096375],
                [25.298054, 65.10804700000011],
                [25.284721, 65.110825],
                [25.267498000000103, 65.16999800000013],
                [25.29305, 65.26639],
                [25.301109, 65.29361],
                [25.324997, 65.3458250000001],
                [25.355274000000122, 65.410828],
                [25.357498, 65.445541],
                [25.356941, 65.450821],
                [25.353333, 65.476944],
                [25.349163, 65.480545],
                [25.310833000000116, 65.511108],
                [25.296665, 65.51916],
                [25.21972, 65.55249],
                [25.210552, 65.556107],
                [25.196941, 65.558884],
                [25.18222, 65.560272],
                [25.16972, 65.559998],
                [25.15333, 65.55166600000013],
                [25.140831, 65.5511],
                [25.123333, 65.55749500000013],
                [25.10889, 65.565277],
                [25.094719, 65.57332],
                [25.092735, 65.591873],
                [25.086666, 65.603043],
                [25.079441, 65.60693400000014],
                [25.070274, 65.61055],
                [24.89805200000012, 65.647018],
                [24.88444, 65.64976],
                [24.796108, 65.658325],
                [24.771664, 65.656662],
                [24.752499, 65.650543],
                [24.74472, 65.645828],
                [24.66917, 65.65470900000014],
                [24.56277, 65.723328],
                [24.557499, 65.727768],
                [24.554722, 65.73249800000013],
                [24.553333, 65.753876],
                [24.553608, 65.764709],
                [24.553886, 65.775543],
                [24.556389, 65.786942],
                [24.561943, 65.79332],
                [24.629997, 65.854431],
                [24.68916, 65.8961],
                [24.631386, 65.88916],
                [24.62166600000012, 65.886108],
                [24.563332, 65.830276],
                [24.560833, 65.819153],
                [24.538609000000122, 65.795273],
                [24.448952000000133, 65.79427],
                [24.419998, 65.768326],
                [24.40944, 65.766388],
                [24.226109, 65.771942],
                [24.214443, 65.774994],
                [24.176666, 65.789154],
                [24.173332, 65.7938840000001],
                [24.167007, 65.814026],
                [24.16861, 65.819992],
                [24.166664, 65.830551],
                [24.160553, 65.84],
                [24.031387, 66.020264],
                [23.967777000000126, 66.072495],
                [23.94861, 66.10137900000012],
                [23.940277, 66.12138400000015],
                [23.930832, 66.135544],
                [23.92555, 66.139999],
                [23.912498, 66.148331],
                [23.89333, 66.15527],
                [23.879444, 66.15805100000011],
                [23.864166, 66.159164],
                [23.84805, 66.161377],
                [23.82027, 66.16666],
                [23.80833, 66.169708],
                [23.754719, 66.184998],
                [23.735275, 66.19194],
                [23.727776, 66.195831],
                [23.722221, 66.20027],
                [23.71917, 66.204987],
                [23.68472, 66.263321],
                [23.66639, 66.30222],
                [23.661942000000124, 66.31221],
                [23.660831, 66.317215],
                [23.639164, 66.430542],
                [23.640274, 66.436096],
                [23.6466640000001, 66.448318],
                [23.652222, 66.454712],
                [23.658886, 66.460541],
                [23.66639, 66.46527100000014],
                [23.725277, 66.50082],
                [23.80722, 66.53777],
                [23.826942, 66.5438840000001],
                [23.861942, 66.5486],
                [23.87194, 66.551666],
                [23.878609, 66.55722],
                [23.884163, 66.56388900000013],
                [23.887497, 66.569992],
                [23.891941, 66.5816650000001],
                [23.902775, 66.680267],
                [23.90083, 66.712494],
                [23.891109000000142, 66.737778],
                [23.89, 66.743042],
                [23.89361, 66.749161],
                [23.936943, 66.786942],
                [23.948055, 66.788879],
                [23.987778, 66.790268],
                [23.999722, 66.791382],
                [24.006386, 66.794998],
                [24.00777, 66.800552],
                [24.00111, 66.81027200000011],
                [23.949997, 66.87082],
                [23.94111, 66.87999],
                [23.935833000000116, 66.884155],
                [23.866943000000106, 66.931107],
                [23.787777, 66.9813840000001],
                [23.75777, 66.9919430000001],
                [23.744442, 67.00000000000011],
                [23.73111, 67.008331],
                [23.68111, 67.047485],
                [23.580555000000118, 67.147491],
                [23.571663, 67.156662],
                [23.57055, 67.161942],
                [23.586666, 67.23498500000011],
                [23.594444, 67.24638],
                [23.6055530000001, 67.25943000000012],
                [23.614441, 67.263321],
                [23.624722, 67.26638800000012],
                [23.63583, 67.2686],
                [23.683052, 67.27554],
                [23.708054, 67.27804600000013],
                [23.73166700000013, 67.28166],
                [23.741665000000125, 67.28471400000012],
                [23.749722, 67.28944400000012],
                [23.773331, 67.31443800000011],
                [23.781944, 67.326385],
                [23.783054, 67.332214],
                [23.768887, 67.41083],
                [23.76777600000014, 67.41610700000012],
                [23.761944, 67.420273],
                [23.734997000000135, 67.426102],
                [23.581944000000135, 67.449997],
                [23.549164, 67.453323],
                [23.536663, 67.451935],
                [23.527496, 67.448044],
                [23.51194, 67.438599],
                [23.50055300000014, 67.436386],
                [23.486942, 67.43805],
                [23.474442000000124, 67.44110100000012],
                [23.464165, 67.44472],
                [23.44833, 67.4524990000001],
                [23.43111, 67.46554600000013],
                [23.428886, 67.47583],
                [23.429996, 67.485825],
                [23.433331000000123, 67.491943],
                [23.471943000000124, 67.5563810000001],
                [23.507774, 67.66554300000013],
                [23.49139, 67.712494],
                [23.469997, 67.8169400000001],
                [23.471107, 67.82276900000011],
                [23.48333, 67.86305],
                [23.486942, 67.86916],
                [23.492496, 67.87582],
                [23.511108, 67.8836060000001],
                [23.545555, 67.889999],
                [23.59638600000011, 67.89526],
                [23.607777, 67.897491],
                [23.644722, 67.913055],
                [23.65277, 67.918045],
                [23.659721, 67.9236],
                [23.665554, 67.929993],
                [23.667221, 67.936386],
                [23.666111000000114, 67.941666],
                [23.656944000000124, 67.950821],
                [23.648888, 67.95471],
                [23.638332000000105, 67.95805400000012],
                [23.53167, 67.99249],
                [23.394444000000135, 68.042496],
                [23.376942, 68.055542],
                [23.36749600000013, 68.06471],
                [23.353333000000134, 68.083603],
                [23.066944, 68.286377],
                [23.058609, 68.290268],
                [23.04805, 68.29388],
                [22.969444, 68.31776400000012],
                [22.936386, 68.32222],
                [22.910275, 68.328323],
                [22.899719, 68.3316650000001],
                [22.86360900000011, 68.357498],
                [22.829720000000123, 68.383881],
                [22.82361, 68.388046],
                [22.67388, 68.42082],
                [22.659721, 68.422485],
                [22.58166, 68.42722],
                [22.5, 68.440132],
                [22.43055, 68.45166000000012],
                [22.371944, 68.46361],
                [22.1675, 68.46443],
                [22.15083, 68.46554600000013],
                [22.06388900000013, 68.4761],
                [22.050552, 68.47916],
                [22.041943, 68.483047],
                [22.038055, 68.487778],
                [22.035, 68.498047],
                [22.0225, 68.50665300000014],
                [22.003887, 68.51944000000015],
                [21.99778, 68.5236],
                [21.959442, 68.5438840000001],
                [21.933887, 68.555267],
                [21.89722, 68.569992],
                [21.881386, 68.572495],
                [21.864719, 68.573608],
                [21.82472, 68.570267],
                [21.809166, 68.570541],
                [21.773331, 68.574432],
                [21.757500000000107, 68.576935],
                [21.735554, 68.5836],
                [21.71833, 68.59111000000013],
                [21.710552, 68.60055],
                [21.711109, 68.606384],
                [21.714165, 68.612488],
                [21.710278, 68.617218],
                [21.701664, 68.62082],
                [21.64277600000014, 68.642487],
                [21.62305, 68.649429],
                [21.601109000000122, 68.6561],
                [21.585278, 68.6586],
                [21.55055, 68.661652],
                [21.500832, 68.66832],
                [21.487499000000128, 68.67139],
                [21.465553000000114, 68.678055],
                [21.452774, 68.686661],
                [21.44861, 68.691101],
                [21.420555, 68.724152],
                [21.21666, 68.81610100000012],
                [21.207775, 68.81972],
                [21.081387, 68.86665],
                [21.05888700000014, 68.873322],
                [21.02472, 68.877487],
                [20.990833, 68.87944],
                [20.959442000000138, 68.87999],
                [20.94472, 68.88138],
                [20.91527600000012, 68.886658],
                [20.904163, 68.889999],
                [20.895275, 68.8936000000001],
                [20.888611, 68.898041],
                [20.88277, 68.90777600000013],
                [20.88305300000013, 68.91333],
                [20.888885, 68.925827],
                [20.915554, 68.939438],
                [20.93111, 68.946381],
                [20.938332, 68.952774],
                [20.938889, 68.958328],
                [20.9327770000001, 68.96832300000011],
                [20.92860800000011, 68.97305],
                [20.908886, 68.9855500000001],
                [20.884441, 68.997498],
                [20.866665, 69.00499],
                [20.84638600000011, 69.011932],
                [20.79166, 69.023331],
                [20.744164, 69.0311],
                [20.65006, 69.04379300000011],
                [20.60416400000014, 69.05305],
                [20.580929, 69.0603],
                [20.609444, 69.06944],
                [20.675, 69.08721900000012],
                [20.69749800000011, 69.09277],
                [20.72389, 69.095825],
                [20.738331, 69.096375],
                [20.773888, 69.0935970000001],
                [20.82222, 69.08638],
                [20.835831, 69.083603],
                [20.935555, 69.0586090000001],
                [20.98055, 69.04527],
                [21.033054, 69.0333250000001],
                [21.059444, 69.034439],
                [21.067497, 69.03915400000011],
                [21.074165, 69.04499800000013],
                [21.084721, 69.058044],
                [21.10139, 69.083328],
                [21.109722, 69.0961],
                [21.112499000000128, 69.1022190000001],
                [21.113052, 69.108047],
                [21.0791660000001, 69.11776700000013],
                [21.06611, 69.12638900000013],
                [21.053608, 69.140549],
                [21.04222, 69.16083],
                [21.02805, 69.208054],
                [21.0325, 69.21304],
                [21.039165, 69.218887],
                [21.054996, 69.228607],
                [21.320831, 69.326111],
                [21.68194, 69.284714],
                [21.9946020000001, 69.07836900000012],
                [22.04139, 69.05222],
                [22.208332, 68.95498700000013],
                [22.203053, 68.951111],
                [22.197498, 68.944717],
                [22.194164, 68.938599],
                [22.19722, 68.928055],
                [22.27889, 68.88165300000014],
                [22.346664, 68.84471100000013],
                [22.34861, 68.842499],
                [22.363888, 68.804718],
                [22.369720000000143, 68.786102],
                [22.398331, 68.7111],
                [22.5, 68.728989],
                [22.549999, 68.73778],
                [22.802776000000108, 68.691376],
                [22.86360900000011, 68.69305],
                [23.063889, 68.695541],
                [23.072498, 68.691666],
                [23.09916, 68.674713],
                [23.139442, 68.649155],
                [23.16472, 68.637497],
                [23.18861, 68.631104],
                [23.204166, 68.62860100000012],
                [23.260555, 68.636383],
                [23.281944000000124, 68.642487],
                [23.291386000000102, 68.64637800000014],
                [23.333054, 68.659439],
                [23.407776, 68.680832],
                [23.46722, 68.691666],
                [23.517498000000103, 68.69861],
                [23.583054000000118, 68.70527600000014],
                [23.664165, 68.71138],
                [23.679722, 68.710831],
                [23.69278, 68.71221900000012],
                [23.703609000000142, 68.715271],
                [23.711941, 68.719986],
                [23.740833, 68.74249],
                [23.762497, 68.75943],
                [23.78388600000011, 68.776382],
                [23.796108, 68.789154],
                [23.802219, 68.79582],
                [23.816666, 68.819992],
                [23.821388000000127, 68.825272],
                [23.83, 68.829987],
                [23.856388, 68.83249],
                [23.899441000000138, 68.83387800000014],
                [23.97639, 68.83249],
                [24.029163, 68.82666],
                [24.04472, 68.823883],
                [24.055553, 68.8205410000001],
                [24.066109, 68.81694],
                [24.082775, 68.809158],
                [24.088608, 68.804718],
                [24.09222000000011, 68.799988],
                [24.098053000000107, 68.79582],
                [24.120552, 68.7836],
                [24.19666, 68.751663],
                [24.215553, 68.746384],
                [24.33833, 68.71360800000014],
                [24.351387, 68.710541],
                [24.363331, 68.708328],
                [24.416943, 68.70166],
                [24.45027, 68.69888],
                [24.513332, 68.695831],
                [24.578888, 68.691376],
                [24.628887, 68.68721],
                [24.69028, 68.676376],
                [24.75444, 68.660263],
                [24.773331, 68.652771],
                [24.79777, 68.640823],
                [24.81166500000012, 68.63249],
                [24.82889, 68.619431],
                [24.834442000000138, 68.61499000000015],
                [24.843624, 68.60601800000012],
                [24.855862, 68.59201],
                [24.859203, 68.587341],
                [24.93492, 68.580811],
                [25.07638500000013, 68.62138400000015],
                [25.095833, 68.62916600000011],
                [25.103333000000134, 68.63472000000013],
                [25.109722, 68.641098],
                [25.111385, 68.646652],
                [25.104721, 68.656387],
                [25.10305, 68.66666],
                [25.10611, 68.678055],
                [25.15472, 68.767776],
                [25.166664, 68.78583],
                [25.17305, 68.792221],
                [25.188332, 68.803329],
                [25.214443, 68.81749],
                [25.234165, 68.825272],
                [25.36389, 68.873886],
                [25.38472, 68.88055],
                [25.406944000000124, 68.886383],
                [25.43111, 68.890549],
                [25.444443, 68.891663],
                [25.47333, 68.892212],
                [25.49028, 68.890823],
                [25.508053, 68.88832100000013],
                [25.554443, 68.88026],
                [25.57111, 68.878601],
                [25.585552, 68.878876],
                [25.612221, 68.88138],
                [25.623333, 68.884155],
                [25.63222, 68.888885],
                [25.647499, 68.89971900000012],
                [25.652775000000133, 68.90638700000011],
                [25.661388000000102, 68.911652],
                [25.692219, 68.933884],
                [25.76111, 68.989166],
                [25.768330000000105, 69.04527],
                [25.73222, 69.109161],
                [25.708332, 69.206375],
                [25.707775, 69.211655],
                [25.71333, 69.255264],
                [25.739441000000113, 69.31832900000012],
                [25.749722, 69.336105],
                [25.754997, 69.34220900000014],
                [25.770554000000118, 69.353882],
                [25.811665, 69.36860700000011],
                [25.82972, 69.37805],
                [25.833611000000133, 69.38415500000013],
                [25.83583, 69.389435],
                [25.874165, 69.486374],
                [25.949165, 69.57805],
                [25.957497, 69.59027100000014],
                [25.963608, 69.601944],
                [25.971107, 69.61888],
                [25.973331, 69.624161],
                [25.97472, 69.630264],
                [25.97416, 69.635269],
                [25.964722, 69.649719],
                [25.94778, 69.65805],
                [25.942497, 69.66222],
                [25.94194, 69.667221],
                [25.945831, 69.673325],
                [25.952774, 69.679993],
                [25.965832, 69.691376],
                [25.978333, 69.701935],
                [25.988331, 69.7066650000001],
                [25.99889, 69.71054],
                [26.009998, 69.713333],
                [26.10055, 69.726379],
                [26.134441, 69.73498500000011],
                [26.15583, 69.74249],
                [26.174164000000133, 69.751663],
                [26.36944, 69.84999],
                [26.378052, 69.854431],
                [26.395, 69.865555],
                [26.402222, 69.871933],
                [26.416111000000114, 69.889999],
                [26.424164, 69.901932],
                [26.43583, 69.914444],
                [26.449997, 69.927216],
                [26.470554, 69.93527200000011],
                [26.483055, 69.937485],
                [26.601944, 69.950272],
                [26.61639, 69.95166],
                [26.80658, 69.95206],
                [26.85722, 69.948608],
                [26.865276000000108, 69.944717],
                [26.866108, 69.934433],
                [26.87222, 69.929718],
                [26.884998, 69.926666],
                [26.90361, 69.92416400000013],
                [27.03722, 69.90805100000011],
                [27.054443, 69.907486],
                [27.068886, 69.9086],
                [27.08083, 69.910553],
                [27.20611, 69.93332],
                [27.28055, 69.94722],
                [27.291943000000117, 69.949997],
                [27.303055, 69.95389],
                [27.31028, 69.9602660000001],
                [27.306942, 69.970276],
                [27.303886, 69.975266],
                [27.297497, 69.979431],
                [27.29555, 69.98443600000013],
                [27.299999, 69.99055],
                [27.42139, 70.01666300000011],
                [27.567497, 70.06388900000013],
                [27.57333, 70.068878],
                [27.599442000000124, 70.072495],
                [27.87305, 70.088043],
                [27.902496, 70.088882],
                [27.918888, 70.088333],
                [27.926556, 70.087158],
                [27.936108, 70.084442],
                [27.944164000000114, 70.08027600000014],
                [27.960552, 70.06694],
                [27.968887, 70.05749500000013],
                [27.97472, 70.04805],
                [27.974998, 70.04277],
                [27.9725, 70.037216],
                [27.973331, 70.016388],
                [27.979164, 70.006653],
                [27.98472, 70.00221],
                [27.998055, 69.993607],
                [28.094166, 69.938599],
                [28.109997, 69.93054200000012],
                [28.1525, 69.915543],
                [28.165833, 69.91221600000011],
              ],
            ],
          ],
        },
        id: 25,
        NAME: 'Finland',
      },
      {
        type: 'Feature',
        properties: {
          NAME: 'Sweden',
          id: 26,
          label: 'Sweden',
          unit: (
      <span>
        kgCO<sub>2e</sub>/kWh
      </span>
    )  ,
          type: 'eGRID subregion',
          value: 0.008,
          year: '2023',
          centroid: [18.6435, 60.1282],
        },
        geometry: {
          type: 'MultiPolygon',
          coordinates: [
            [
              [
                [16.83667, 56.826942],
                [16.82805, 56.82527],
                [16.816944, 56.825829],
                [16.808331000000123, 56.824165],
                [16.785, 56.809998],
                [16.779442, 56.80583],
                [16.77027500000014, 56.79583],
                [16.72666500000014, 56.702217],
                [16.63555, 56.51888300000013],
                [16.576664, 56.406944],
                [16.57055300000013, 56.394440000000145],
                [16.56944, 56.388054],
                [16.57027, 56.37693800000011],
                [16.571941, 56.371666],
                [16.575275, 56.367218],
                [16.575554, 56.361382],
                [16.57166, 56.354996],
                [16.553055, 56.32638500000013],
                [16.49611, 56.24082900000013],
                [16.486385, 56.231384000000105],
                [16.47361, 56.224442],
                [16.43722, 56.21138800000011],
                [16.429722, 56.20888500000012],
                [16.420830000000137, 56.2111],
                [16.416111000000114, 56.215271],
                [16.410831, 56.225],
                [16.403332, 56.274162],
                [16.3916660000001, 56.465],
                [16.393330000000105, 56.529160000000104],
                [16.39583, 56.535828],
                [16.420277, 56.58638800000011],
                [16.5425, 56.776382],
                [16.611942, 56.868332],
                [16.616665, 56.873604],
                [16.629166, 56.879166],
                [16.645, 56.88361],
                [16.749443, 56.93972],
                [16.848053000000107, 57.064163],
                [16.9, 57.13499500000012],
                [16.959442, 57.22361],
                [16.963055, 57.229439],
                [16.965553000000114, 57.241661],
                [16.960278, 57.256943],
                [16.959164, 57.274162],
                [16.960552, 57.280273],
                [16.96611, 57.29361],
                [16.973331, 57.305275],
                [16.982777, 57.31555200000014],
                [16.99305, 57.32471],
                [17.00999800000011, 57.337494],
                [17.02222, 57.344994],
                [17.035553000000107, 57.35194400000012],
                [17.05666, 57.359161],
                [17.09861, 57.350555],
                [17.10555, 57.348328],
                [17.124165, 57.32083100000011],
                [17.05055, 57.186661],
                [17.008888, 57.131943],
                [16.961109000000135, 57.075272],
                [16.926666, 57.038055],
                [16.88028, 56.929718],
                [16.848331, 56.843887],
                [16.84111000000013, 56.832222],
                [16.83667, 56.826942],
              ],
            ],
            [
              [
                [18.20611, 56.911942],
                [18.168888, 56.909996],
                [18.147778, 56.911942],
                [18.140274, 56.914993],
                [18.142498, 56.920273],
                [18.15833, 56.94166600000011],
                [18.209164, 56.989166],
                [18.256664, 57.032219],
                [18.254444, 57.079163],
                [18.173332, 57.141937],
                [18.14833, 57.235275000000115],
                [18.158054, 57.315826],
                [18.142498, 57.409439],
                [18.115276000000108, 57.480827],
                [18.110275, 57.496109],
                [18.109997, 57.513054000000125],
                [18.111385, 57.51944],
                [18.119164, 57.531105],
                [18.138611, 57.551109],
                [18.179165, 57.588333],
                [18.191441, 57.596138],
                [18.211941000000138, 57.60583],
                [18.227776, 57.611382000000106],
                [18.242222, 57.61749300000014],
                [18.249165, 57.62082700000013],
                [18.27611, 57.634163000000115],
                [18.29472, 57.645828],
                [18.338886, 57.68166],
                [18.355831000000137, 57.69583100000011],
                [18.381943, 57.718605],
                [18.40166, 57.738609],
                [18.41972, 57.76028],
                [18.456387, 57.802773],
                [18.461388, 57.8077770000001],
                [18.46722, 57.811943],
                [18.48111, 57.8186],
                [18.681942, 57.913605],
                [18.689999, 57.916107],
                [18.71611, 57.9211],
                [18.725, 57.922775],
                [18.88194, 57.919716],
                [18.902496, 57.918327],
                [18.914165, 57.917496],
                [19.004719, 57.908607],
                [19.00611, 57.90361],
                [19.003887000000134, 57.898888],
                [19.033333, 57.826942],
                [18.92944, 57.739716],
                [18.848888, 57.72111],
                [18.809166, 57.703606],
                [18.793331, 57.65916],
                [18.75972, 57.508049],
                [18.768055, 57.472221],
                [18.769444, 57.46722],
                [18.78833, 57.448326],
                [18.71444300000013, 57.246941000000106],
                [18.711941, 57.241661],
                [18.658054, 57.22083],
                [18.551941, 57.18278],
                [18.514721000000122, 57.169441],
                [18.498333, 57.165276],
                [18.455555, 57.156944],
                [18.43944, 57.152771],
                [18.417221, 57.14416],
                [18.39722, 57.134163],
                [18.39139, 57.12999700000012],
                [18.386665, 57.124992],
                [18.345554, 57.07972],
                [18.341389, 57.073883],
                [18.339165, 57.06860400000011],
                [18.335552, 57.02333],
                [18.335831, 57.017494],
                [18.34333, 57.014442],
                [18.34666, 56.998604000000114],
                [18.302498, 56.937492],
                [18.294998000000135, 56.93471],
                [18.215553, 56.91305],
                [18.20611, 56.911942],
              ],
            ],
            [
              [
                [19.334442, 57.955826],
                [19.286663, 57.937492],
                [19.277496, 57.940277],
                [19.274441, 57.945],
                [19.26805, 57.94861],
                [19.256664, 57.94944],
                [19.23805, 57.94694],
                [19.170555, 57.929443],
                [19.16277700000012, 57.92694100000011],
                [19.150833, 57.91861],
                [19.14583, 57.913605],
                [19.1416660000001, 57.90778],
                [19.14, 57.901665],
                [19.12611, 57.839722],
                [19.09333, 57.851944],
                [19.077774, 57.85833],
                [19.073055, 57.862495],
                [19.037498, 57.896385],
                [19.034443, 57.901108],
                [19.034443, 57.912498],
                [19.03611, 57.91861],
                [19.088886, 57.970276000000126],
                [19.095833, 57.97361],
                [19.10472, 57.975273],
                [19.285831, 57.976662],
                [19.296387, 57.976662],
                [19.307499, 57.974442],
                [19.3325, 57.965271],
                [19.335552, 57.960548],
                [19.334442, 57.955826],
              ],
            ],
            [
              [
                [11.594444, 57.93249500000013],
                [11.584999, 57.930832],
                [11.57472, 57.931664000000126],
                [11.528055, 57.948051],
                [11.522499, 57.951942000000145],
                [11.518125, 57.98069],
                [11.509722, 57.9897160000001],
                [11.498333, 58.006943],
                [11.497221, 58.012772],
                [11.498055000000136, 58.031387],
                [11.501944, 58.03666],
                [11.520555, 58.047775000000115],
                [11.53, 58.049164],
                [11.735884, 58.041714],
                [11.741110000000106, 58.030548],
                [11.742222, 58.024994000000106],
                [11.736944, 58.00444],
                [11.734165000000132, 57.998604],
                [11.729166, 57.993889],
                [11.72278, 57.990273],
                [11.659443, 57.957497],
                [11.646111, 57.950829],
                [11.594444, 57.93249500000013],
              ],
            ],
            [
              [
                [16.816666, 58.116104],
                [16.78333, 58.096664],
                [16.77861, 58.10055],
                [16.778053000000114, 58.106384],
                [16.781944, 58.112221],
                [16.78778, 58.116386],
                [16.801109, 58.123329000000126],
                [16.810833, 58.124443],
                [16.818886, 58.12138],
                [16.816666, 58.116104],
              ],
            ],
            [
              [
                [11.806389000000138, 58.120552],
                [11.800278, 58.116943],
                [11.714722, 58.101105],
                [11.67639, 58.098885],
                [11.624722, 58.107498000000135],
                [11.62361, 58.11305],
                [11.60666700000013, 58.118607],
                [11.583055000000115, 58.118889],
                [11.553333, 58.115273],
                [11.467222, 58.101387],
                [11.46583, 58.095833],
                [11.46361000000013, 58.071663],
                [11.464998, 58.066109],
                [11.454721, 58.07249],
                [11.450554, 58.076942],
                [11.40111, 58.130272000000105],
                [11.402777, 58.13694],
                [11.410555, 58.1475],
                [11.668888, 58.284439],
                [11.6775, 58.2866590000001],
                [11.708887000000118, 58.285828],
                [11.721666000000141, 58.284721],
                [11.736666000000127, 58.281662],
                [11.786665, 58.245552],
                [11.809999, 58.224442000000124],
                [11.812498, 58.219162],
                [11.81361, 58.213608],
                [11.815832, 58.171944],
                [11.814722, 58.147217],
                [11.81111, 58.1336060000001],
                [11.806389000000138, 58.120552],
              ],
            ],
            [
              [
                [19.23694, 58.33722],
                [19.226109, 58.33722],
                [19.21833, 58.340271],
                [19.18722, 58.381386],
                [19.184166, 58.38611],
                [19.186665, 58.391388],
                [19.224998, 58.38971700000013],
                [19.261665, 58.384163000000115],
                [19.30583, 58.37527],
                [19.324718000000132, 58.36972],
                [19.331108, 58.366104],
                [19.3275, 58.361664],
                [19.315277, 58.353333],
                [19.302219, 58.34610700000013],
                [19.294167, 58.343605],
                [19.285275000000127, 58.34194200000013],
                [19.23694, 58.33722],
              ],
            ],
            [
              [
                [17.691387, 58.91693900000013],
                [17.706387, 58.90444200000013],
                [17.695831000000112, 58.905548],
                [17.676388, 58.916382],
                [17.67139, 58.920555],
                [17.66444, 58.929993],
                [17.641109000000142, 58.9658280000001],
                [17.63916, 58.971107],
                [17.63916, 58.97666],
                [17.641941, 58.989166],
                [17.660553000000107, 59.039719],
                [17.667774, 59.05222],
                [17.67583100000013, 59.054718],
                [17.682220000000143, 59.051109],
                [17.696388, 59.039719],
                [17.71805, 59.018051],
                [17.721664, 59.007774],
                [17.720276000000126, 59.001663],
                [17.71611, 58.99555],
                [17.70417, 58.987221],
                [17.69611, 58.975555],
                [17.690277, 58.950829],
                [17.687775, 58.92694100000011],
                [17.688053, 58.921387],
                [17.691387, 58.91693900000013],
              ],
            ],
            [
              [
                [18.40583, 59.023888],
                [18.377499000000114, 59.01944],
                [18.365555, 59.020271],
                [18.36055, 59.02444],
                [18.357498, 59.02916],
                [18.35722, 59.034996],
                [18.396942000000138, 59.080826],
                [18.40721900000011, 59.09083],
                [18.41333, 59.094994],
                [18.444164, 59.115829],
                [18.450554000000125, 59.11805],
                [18.459721, 59.11972],
                [18.469719, 59.120552],
                [18.47916400000014, 59.11999500000013],
                [18.491665, 59.102776],
                [18.490555, 59.098053],
                [18.424164, 59.036385],
                [18.40583, 59.023888],
              ],
            ],
            [
              [
                [18.537220000000104, 59.223885],
                [18.52722200000011, 59.22305300000011],
                [18.515274, 59.223885],
                [18.503887, 59.22583],
                [18.435555, 59.253609],
                [18.42889, 59.25722],
                [18.389442, 59.284721],
                [18.391941, 59.290276],
                [18.46666, 59.29277],
                [18.478886, 59.29194],
                [18.49472, 59.290833000000134],
                [18.50361, 59.288887],
                [18.601944, 59.25750000000011],
                [18.610275000000115, 59.25416600000011],
                [18.57194, 59.23221600000011],
                [18.56361, 59.229721],
                [18.537220000000104, 59.223885],
              ],
            ],
            [
              [
                [17.78694, 59.31055],
                [17.77777, 59.308609000000104],
                [17.75444, 59.309441],
                [17.721664, 59.31611],
                [17.686943, 59.328049],
                [17.671944, 59.334717],
                [17.661942, 59.343048000000124],
                [17.617496, 59.397774],
                [17.605553, 59.416664],
                [17.610554, 59.42166],
                [17.61861, 59.424438],
                [17.627777, 59.42610900000011],
                [17.63888500000013, 59.42610900000011],
                [17.65055500000011, 59.424164],
                [17.7375, 59.393326000000116],
                [17.744164, 59.389717],
                [17.773888, 59.37277],
                [17.777222, 59.36805],
                [17.789165, 59.32138800000013],
                [17.789165, 59.315826],
                [17.78694, 59.31055],
              ],
            ],
            [
              [
                [17.734722, 59.2961],
                [17.817497, 59.277771],
                [17.75805300000013, 59.28083],
                [17.681942, 59.289719],
                [17.658886, 59.293884],
                [17.649166, 59.29639],
                [17.63916, 59.299164],
                [17.6227760000001, 59.30527500000011],
                [17.610832, 59.313049],
                [17.52055, 59.406944000000124],
                [17.518887, 59.411942000000124],
                [17.52027500000014, 59.41833],
                [17.523609000000135, 59.422775000000115],
                [17.53167, 59.425278],
                [17.539165, 59.426666],
                [17.57055300000013, 59.42860400000012],
                [17.6227760000001, 59.378609],
                [17.629719, 59.369438],
                [17.63694, 59.34888500000011],
                [17.637218, 59.343048000000124],
                [17.635555000000124, 59.336937],
                [17.636108, 59.325554],
                [17.63777, 59.320549],
                [17.647778, 59.317772000000105],
                [17.734722, 59.2961],
              ],
            ],
            [
              [
                [17.26638800000012, 59.374443],
                [17.256386000000134, 59.373329],
                [17.231110000000115, 59.375549],
                [17.155552000000114, 59.383606],
                [17.147221, 59.386665],
                [17.070274, 59.45388800000012],
                [17.070000000000107, 59.459442],
                [17.089722, 59.46],
                [17.150555, 59.45666],
                [17.236111, 59.44971],
                [17.256943, 59.446663],
                [17.266941, 59.44416],
                [17.28028, 59.43694],
                [17.31611, 59.408051],
                [17.31805, 59.403053],
                [17.317219, 59.398048],
                [17.30972, 59.394165],
                [17.26638800000012, 59.374443],
              ],
            ],
            [
              [
                [18.575554, 59.44833],
                [18.565277, 59.44749],
                [18.553055, 59.44833],
                [18.526665, 59.468605],
                [18.521664, 59.472771],
                [18.519997, 59.4836],
                [18.519997, 59.48944100000011],
                [18.522778, 59.49472],
                [18.528889, 59.498886],
                [18.570274, 59.526382],
                [18.610832, 59.546661],
                [18.63361, 59.55583200000012],
                [18.64361, 59.556664],
                [18.73889, 59.548332],
                [18.746944, 59.544998],
                [18.732498, 59.53833],
                [18.724442, 59.535828],
                [18.715275, 59.534164],
                [18.66805, 59.526665],
                [18.591389000000106, 59.501106],
                [18.588608, 59.495552],
                [18.590275000000133, 59.490555],
                [18.60694100000012, 59.46721600000012],
                [18.605274, 59.461105],
                [18.583611000000133, 59.45082900000011],
                [18.575554, 59.44833],
              ],
            ],
            [
              [
                [18.57, 60.30778],
                [18.56166500000012, 60.30527500000011],
                [18.549164000000133, 60.306107],
                [18.521111, 60.315826],
                [18.512775, 60.31916],
                [18.401108, 60.365273000000116],
                [18.394165, 60.374718],
                [18.3925, 60.37971],
                [18.381943, 60.41638200000011],
                [18.37166600000012, 60.494164],
                [18.37416500000012, 60.499718],
                [18.380554, 60.503883],
                [18.39, 60.50555400000013],
                [18.408886, 60.499718],
                [18.422497, 60.486664],
                [18.456108, 60.427498],
                [18.507221, 60.348053],
                [18.537220000000104, 60.3425],
                [18.572777, 60.313332],
                [18.57, 60.30778],
              ],
            ],
            [
              [
                [17.509163, 62.363327],
                [17.484722, 62.36305],
                [17.456665, 62.365273000000116],
                [17.444164, 62.367493],
                [17.42222, 62.372498],
                [17.416664, 62.37666],
                [17.41277700000012, 62.381386000000134],
                [17.369164, 62.46666],
                [17.36722200000014, 62.471664],
                [17.373333, 62.474442],
                [17.46305500000011, 62.461662],
                [17.472221, 62.458328],
                [17.51444, 62.41444400000012],
                [17.5425, 62.36610400000012],
                [17.509163, 62.363327],
              ],
            ],
            [
              [
                [18.060833000000116, 62.67083],
                [18.04972, 62.669998],
                [18.04166, 62.6722180000001],
                [18.03611, 62.67638],
                [18.02666, 62.685272],
                [18.02305200000012, 62.689995000000124],
                [18.019165, 62.700272],
                [18.022499, 62.712494000000106],
                [18.03916, 62.7355500000001],
                [18.04583, 62.739716],
                [18.060276, 62.74388900000014],
                [18.070553, 62.745552],
                [18.129719000000136, 62.74055],
                [18.141388, 62.739166],
                [18.146942, 62.734993],
                [18.153053000000114, 62.72888],
                [18.15694, 62.71833],
                [18.155, 62.712219],
                [18.114166, 62.686943],
                [18.10722, 62.682777],
                [18.099442, 62.67944],
                [18.060833000000116, 62.67083],
              ],
            ],
            [
              [
                [20.885555, 63.75166300000012],
                [20.875832, 63.749161],
                [20.84083, 63.763054000000125],
                [20.8375, 63.767776],
                [20.838055, 63.773331],
                [20.84222, 63.779999],
                [20.8475, 63.785828],
                [20.855, 63.789993],
                [20.873333, 63.795555],
                [20.88499800000011, 63.79610400000013],
                [20.899998, 63.79416700000013],
                [20.91111, 63.791382],
                [20.92194400000011, 63.782776000000126],
                [20.92860800000011, 63.773331],
                [20.92722, 63.768608],
                [20.885555, 63.75166300000012],
              ],
            ],
            [
              [
                [21.809166, 68.570541],
                [21.82472, 68.570267],
                [21.864719, 68.573608],
                [21.881386, 68.572495],
                [21.89722, 68.569992],
                [21.933887, 68.555267],
                [21.959442, 68.5438840000001],
                [21.99778, 68.5236],
                [22.003887, 68.51944000000015],
                [22.0225, 68.50665300000014],
                [22.035, 68.498047],
                [22.038055, 68.487778],
                [22.041943, 68.483047],
                [22.050552, 68.47916],
                [22.06388900000013, 68.4761],
                [22.15083, 68.46554600000013],
                [22.1675, 68.46443],
                [22.371944, 68.46361],
                [22.43055, 68.45166000000012],
                [22.5, 68.440132],
                [22.58166, 68.42722],
                [22.659721, 68.422485],
                [22.67388, 68.42082],
                [22.82361, 68.388046],
                [22.829720000000123, 68.383881],
                [22.86360900000011, 68.357498],
                [22.899719, 68.3316650000001],
                [22.910275, 68.328323],
                [22.936386, 68.32222],
                [22.969444, 68.31776400000012],
                [23.04805, 68.29388],
                [23.058609, 68.290268],
                [23.066944, 68.286377],
                [23.353333000000134, 68.083603],
                [23.36749600000013, 68.06471],
                [23.376942, 68.055542],
                [23.394444000000135, 68.042496],
                [23.53167, 67.99249],
                [23.638332000000105, 67.95805400000012],
                [23.648888, 67.95471],
                [23.656944000000124, 67.950821],
                [23.666111000000114, 67.941666],
                [23.667221, 67.936386],
                [23.665554, 67.929993],
                [23.659721, 67.9236],
                [23.65277, 67.918045],
                [23.644722, 67.913055],
                [23.607777, 67.897491],
                [23.59638600000011, 67.89526],
                [23.545555, 67.889999],
                [23.511108, 67.8836060000001],
                [23.492496, 67.87582],
                [23.486942, 67.86916],
                [23.48333, 67.86305],
                [23.471107, 67.82276900000011],
                [23.469997, 67.8169400000001],
                [23.49139, 67.712494],
                [23.507774, 67.66554300000013],
                [23.471943000000124, 67.5563810000001],
                [23.433331000000123, 67.491943],
                [23.429996, 67.485825],
                [23.428886, 67.47583],
                [23.43111, 67.46554600000013],
                [23.44833, 67.4524990000001],
                [23.464165, 67.44472],
                [23.474442000000124, 67.44110100000012],
                [23.486942, 67.43805],
                [23.50055300000014, 67.436386],
                [23.51194, 67.438599],
                [23.527496, 67.448044],
                [23.536663, 67.451935],
                [23.549164, 67.453323],
                [23.581944000000135, 67.449997],
                [23.734997000000135, 67.426102],
                [23.761944, 67.420273],
                [23.76777600000014, 67.41610700000012],
                [23.768887, 67.41083],
                [23.783054, 67.332214],
                [23.781944, 67.326385],
                [23.773331, 67.31443800000011],
                [23.749722, 67.28944400000012],
                [23.741665000000125, 67.28471400000012],
                [23.73166700000013, 67.28166],
                [23.708054, 67.27804600000013],
                [23.683052, 67.27554],
                [23.63583, 67.2686],
                [23.624722, 67.26638800000012],
                [23.614441, 67.263321],
                [23.6055530000001, 67.25943000000012],
                [23.594444, 67.24638],
                [23.586666, 67.23498500000011],
                [23.57055, 67.161942],
                [23.571663, 67.156662],
                [23.580555000000118, 67.147491],
                [23.68111, 67.047485],
                [23.73111, 67.008331],
                [23.744442, 67.00000000000011],
                [23.75777, 66.9919430000001],
                [23.787777, 66.9813840000001],
                [23.866943000000106, 66.931107],
                [23.935833000000116, 66.884155],
                [23.94111, 66.87999],
                [23.949997, 66.87082],
                [24.00111, 66.81027200000011],
                [24.00777, 66.800552],
                [24.006386, 66.794998],
                [23.999722, 66.791382],
                [23.987778, 66.790268],
                [23.948055, 66.788879],
                [23.936943, 66.786942],
                [23.89361, 66.749161],
                [23.89, 66.743042],
                [23.891109000000142, 66.737778],
                [23.90083, 66.712494],
                [23.902775, 66.680267],
                [23.891941, 66.5816650000001],
                [23.887497, 66.569992],
                [23.884163, 66.56388900000013],
                [23.878609, 66.55722],
                [23.87194, 66.551666],
                [23.861942, 66.5486],
                [23.826942, 66.5438840000001],
                [23.80722, 66.53777],
                [23.725277, 66.50082],
                [23.66639, 66.46527100000014],
                [23.658886, 66.460541],
                [23.652222, 66.454712],
                [23.6466640000001, 66.448318],
                [23.640274, 66.436096],
                [23.639164, 66.430542],
                [23.660831, 66.317215],
                [23.661942000000124, 66.31221],
                [23.66639, 66.30222],
                [23.68472, 66.263321],
                [23.71917, 66.204987],
                [23.722221, 66.20027],
                [23.727776, 66.195831],
                [23.735275, 66.19194],
                [23.754719, 66.184998],
                [23.80833, 66.169708],
                [23.82027, 66.16666],
                [23.84805, 66.161377],
                [23.864166, 66.159164],
                [23.879444, 66.15805100000011],
                [23.89333, 66.15527],
                [23.912498, 66.148331],
                [23.92555, 66.139999],
                [23.930832, 66.135544],
                [23.940277, 66.12138400000015],
                [23.94861, 66.10137900000012],
                [23.967777000000126, 66.072495],
                [24.031387, 66.020264],
                [24.160553, 65.84],
                [24.166664, 65.830551],
                [24.16861, 65.819992],
                [24.167007, 65.814026],
                [24.15305, 65.80554200000012],
                [24.144444000000135, 65.801666],
                [24.12111, 65.79887400000013],
                [24.10611, 65.80028],
                [24.08083, 65.806107],
                [24.05222, 65.808044],
                [24.04027600000012, 65.806656],
                [23.986111, 65.792496],
                [23.956108, 65.784164],
                [23.95194, 65.778885],
                [23.94861, 65.772766],
                [23.943333, 65.766388],
                [23.936943, 65.76082],
                [23.928333, 65.75694],
                [23.91666, 65.75776700000011],
                [23.773888000000113, 65.79277000000013],
                [23.77277800000013, 65.797775],
                [23.65389, 65.8063810000001],
                [23.51833, 65.800827],
                [23.434719, 65.760544],
                [23.394444000000135, 65.767487],
                [23.249722, 65.800827],
                [23.23444, 65.76361],
                [23.141109, 65.714722],
                [23.131664, 65.711655],
                [23.08111, 65.698883],
                [23.073608, 65.702774],
                [23.00027, 65.752777],
                [22.828888, 65.815277],
                [22.826385, 65.825546],
                [22.823055, 65.830551],
                [22.790276, 65.856384],
                [22.723331, 65.886108],
                [22.675831, 65.902222],
                [22.644722, 65.905548],
                [22.637218000000132, 65.90277100000014],
                [22.638611, 65.897766],
                [22.64971900000012, 65.88888500000013],
                [22.666943, 65.881653],
                [22.674442, 65.877777],
                [22.679996, 65.873596],
                [22.683331000000123, 65.868881],
                [22.70472, 65.807495],
                [22.684998, 65.763885],
                [22.677776, 65.759155],
                [22.66944, 65.75499],
                [22.66, 65.75193800000011],
                [22.648609, 65.75055],
                [22.651386, 65.75665300000014],
                [22.656387, 65.76332100000013],
                [22.657219, 65.76887],
                [22.650555, 65.77832],
                [22.608608000000117, 65.796936],
                [22.479164, 65.851105],
                [22.451385, 65.85611000000011],
                [22.41861, 65.85943600000013],
                [22.375553, 65.86082],
                [22.363888, 65.85916],
                [22.35778, 65.85582000000011],
                [22.329166, 65.82971],
                [22.25777, 65.69110100000012],
                [22.249054, 65.632492],
                [22.27272, 65.627655],
                [22.281054, 65.626152],
                [22.289387, 65.62599200000011],
                [22.300554, 65.6298220000001],
                [22.31667, 65.61804200000012],
                [22.321388, 65.6247100000001],
                [22.32222000000013, 65.630264],
                [22.31667, 65.63472],
                [22.309166, 65.638611],
                [22.298054, 65.647217],
                [22.286942000000124, 65.65998800000011],
                [22.283607, 65.66499],
                [22.289719, 65.66832000000011],
                [22.30360800000011, 65.665833],
                [22.323055000000124, 65.65916400000015],
                [22.385555, 65.628876],
                [22.423611, 65.558884],
                [22.42639, 65.548599],
                [22.423332, 65.542221],
                [22.41639, 65.53749],
                [22.40583, 65.535263],
                [22.39416, 65.53833],
                [22.37916600000011, 65.5458220000001],
                [22.366108, 65.55415],
                [22.241833, 65.577271],
                [22.206329, 65.57877300000013],
                [22.07972, 65.607208],
                [21.86389, 65.666656],
                [21.854164, 65.669998],
                [21.84638600000011, 65.673874],
                [21.840832, 65.67805],
                [21.82694, 65.69722000000013],
                [21.82139, 65.70138500000013],
                [21.766941, 65.722488],
                [21.760830000000112, 65.716934],
                [21.762497, 65.711655],
                [21.77305200000012, 65.69749],
                [21.828053, 65.66527],
                [21.84333, 65.657776],
                [21.8530540000001, 65.654434],
                [22.0225, 65.598053],
                [22.057777, 65.589157],
                [22.11610800000011, 65.58305400000012],
                [22.12583, 65.579712],
                [22.199165, 65.54527300000012],
                [22.194164, 65.54083300000013],
                [22.18499800000012, 65.537766],
                [22.16416500000014, 65.533051],
                [22.05384800000013, 65.517441],
                [22.00027, 65.513611],
                [21.987499, 65.515274],
                [21.90916, 65.52665700000011],
                [21.89944, 65.529999],
                [21.891666, 65.53387],
                [21.887218, 65.537216],
                [21.879997, 65.536652],
                [21.85916, 65.53221100000013],
                [21.8525, 65.529999],
                [21.85805, 65.52583300000015],
                [21.901108, 65.496658],
                [21.914165, 65.488602],
                [21.925831, 65.4855500000001],
                [21.93972, 65.48527500000012],
                [21.922497, 65.506943],
                [21.925278, 65.510818],
                [21.93694, 65.5080410000001],
                [21.97916400000014, 65.48972],
                [22.030277000000126, 65.462219],
                [22.031666, 65.457214],
                [22.017498, 65.428604],
                [22.010555, 65.42387400000013],
                [21.929443, 65.398041],
                [21.675831, 65.391098],
                [21.662220000000104, 65.391388],
                [21.647499, 65.392487],
                [21.635555, 65.39555400000012],
                [21.628052, 65.399155],
                [21.611385, 65.41221600000011],
                [21.60166500000014, 65.415543],
                [21.586941, 65.416382],
                [21.54472, 65.40805100000011],
                [21.47416, 65.386658],
                [21.46833, 65.380829],
                [21.497276000000113, 65.35527],
                [21.506275, 65.3446],
                [21.534277, 65.327271],
                [21.543110000000127, 65.326775],
                [21.57972, 65.31471],
                [21.587776, 65.31888],
                [21.590275, 65.324997],
                [21.586941, 65.329712],
                [21.588886, 65.33221400000014],
                [21.612221, 65.32638500000013],
                [21.621944, 65.323044],
                [21.69722, 65.29138200000011],
                [21.70472, 65.287491],
                [21.704166, 65.281937],
                [21.700832, 65.270264],
                [21.695, 65.264435],
                [21.66389, 65.247498],
                [21.65472, 65.244156],
                [21.588055, 65.234711],
                [21.56528, 65.231659],
                [21.553608, 65.234711],
                [21.548054, 65.238876],
                [21.541111, 65.24832200000014],
                [21.53805, 65.258881],
                [21.493887, 65.28671],
                [21.46888700000011, 65.310883],
                [21.46422200000012, 65.31321000000014],
                [21.33805500000011, 65.36972],
                [21.32444, 65.371933],
                [21.314163, 65.36972],
                [21.266388, 65.34111],
                [21.260555, 65.337494],
                [21.266109, 65.33332800000011],
                [21.32111, 65.323608],
                [21.336941000000138, 65.321655],
                [21.417221, 65.306107],
                [21.50528, 65.248596],
                [21.548054, 65.21944],
                [21.559166, 65.210831],
                [21.613609, 65.16249],
                [21.620552, 65.15304600000013],
                [21.621944, 65.147766],
                [21.621387, 65.142212],
                [21.583885, 65.0627750000001],
                [21.577221, 65.05777],
                [21.56583, 65.056381],
                [21.533703, 65.05875],
                [21.494164, 65.061096],
                [21.48305, 65.059708],
                [21.472775, 65.05722],
                [21.46833, 65.050552],
                [21.4675, 65.044998],
                [21.470554, 65.034439],
                [21.480000000000132, 65.031097],
                [21.466663, 65.007217],
                [21.373333000000116, 64.975555],
                [21.300831, 64.954437],
                [21.254997, 64.949432],
                [21.243889, 64.947769],
                [21.20528, 64.891663],
                [21.20666, 64.886383],
                [21.208885, 64.862488],
                [21.183052, 64.829987],
                [21.131664, 64.818878],
                [21.1227760000001, 64.81805400000013],
                [21.109165000000132, 64.82026700000011],
                [21.0975, 64.82332],
                [21.091942, 64.8275],
                [21.084999, 64.836929],
                [21.086109, 64.84833],
                [21.0825, 64.853043],
                [21.073055, 64.856384],
                [21.060555000000136, 64.85582000000011],
                [21.044998, 64.84776],
                [21.039444000000117, 64.84193],
                [21.036942, 64.83583],
                [21.03611000000012, 64.82443200000012],
                [21.039444000000117, 64.819717],
                [21.044998, 64.815277],
                [21.0825, 64.78860500000013],
                [21.09, 64.784714],
                [21.0975, 64.7810970000001],
                [21.10694, 64.777771],
                [21.125608000000113, 64.77582600000011],
                [21.134275000000116, 64.7751540000001],
                [21.159443, 64.77554],
                [21.214996, 64.78277600000013],
                [21.229443000000117, 64.78194],
                [21.258331, 64.777496],
                [21.292774, 64.768875],
                [21.30222, 64.76555],
                [21.3077770000001, 64.761383],
                [21.310833, 64.75082],
                [21.304996, 64.66194200000012],
                [21.289719, 64.663879],
                [21.278332, 64.6666560000001],
                [21.268608, 64.669998],
                [21.23889, 64.68527200000011],
                [21.161942, 64.7227630000001],
                [21.143721, 64.724442],
                [21.13622, 64.725433],
                [21.121721, 64.724602],
                [21.105000000000132, 64.7227630000001],
                [21.104443, 64.716934],
                [21.111942, 64.69110100000012],
                [21.118889, 64.681381],
                [21.133888, 64.67387400000013],
                [21.271385000000123, 64.615265],
                [21.356941, 64.59082],
                [21.361385, 64.597214],
                [21.366943, 64.603043],
                [21.373333000000116, 64.60527000000013],
                [21.465275, 64.57554600000014],
                [21.55416, 64.532486],
                [21.585, 64.439713],
                [21.458054000000118, 64.361099],
                [21.390553, 64.335266],
                [21.32222, 64.309998],
                [21.313332, 64.306931],
                [21.28611, 64.29832],
                [21.276108, 64.29582],
                [21.267220000000123, 64.294998],
                [21.25972, 64.298599],
                [21.258331, 64.30388],
                [21.254997, 64.308609],
                [21.24277500000011, 64.31027200000011],
                [21.234997, 64.30610700000011],
                [20.971664, 64.148605],
                [20.9575, 64.139435],
                [20.954166, 64.134155],
                [20.905, 64.049438],
                [20.895554, 64.002487],
                [20.79389, 63.886383],
                [20.777775, 63.869164],
                [20.770275, 63.86499800000013],
                [20.728611000000114, 63.848053],
                [20.638332, 63.813332],
                [20.535, 63.799164],
                [20.50805300000013, 63.82027],
                [20.499722, 63.82278],
                [20.494164, 63.81916],
                [20.44778, 63.75833100000011],
                [20.41777, 63.697777],
                [20.41361, 63.691109],
                [20.38694, 63.67416400000013],
                [20.37917, 63.672493],
                [20.369999, 63.675552],
                [20.316666, 63.659996],
                [20.298611, 63.64638500000012],
                [20.263885, 63.665833],
                [20.1, 63.65583],
                [20.011944, 63.635826],
                [19.899441, 63.609161],
                [19.893055000000118, 63.60638],
                [19.775276000000133, 63.533333],
                [19.74916500000012, 63.516663],
                [19.747219, 63.510551],
                [19.74889, 63.505272],
                [19.754166, 63.50110600000011],
                [19.761665, 63.497215],
                [19.768887, 63.487778000000105],
                [19.779163, 63.462494000000106],
                [19.772644000000128, 63.457535],
                [19.704998, 63.431938],
                [19.68305, 63.429718],
                [19.6680530000001, 63.431389],
                [19.641109, 63.442497],
                [19.635830000000112, 63.44666],
                [19.639999000000103, 63.45916000000011],
                [19.643055, 63.46444],
                [19.64333, 63.46999],
                [19.639721, 63.474716000000114],
                [19.61639, 63.49472],
                [19.501663, 63.549438],
                [19.475555, 63.55971],
                [19.463608000000136, 63.561104],
                [19.453053, 63.559441],
                [19.42805, 63.549438],
                [19.422775, 63.54583],
                [19.42444, 63.54055],
                [19.47361000000012, 63.453049],
                [19.44722, 63.440277],
                [19.365833, 63.434998],
                [19.351665, 63.435272],
                [19.31833300000011, 63.449165],
                [19.31277, 63.453331000000105],
                [19.309185000000127, 63.463608],
                [19.296665, 63.463608],
                [19.289444000000117, 63.459442],
                [19.283333, 63.45444],
                [19.27833, 63.44861],
                [19.274441, 63.44194],
                [19.27583, 63.419716],
                [19.277496, 63.408882],
                [19.23055, 63.3275],
                [19.158607, 63.315277],
                [19.14, 63.31027200000011],
                [19.058609000000104, 63.25361],
                [19.045555, 63.244438],
                [19.04055, 63.238609],
                [19.04416700000013, 63.22805000000011],
                [19.049721, 63.21833],
                [19.05972, 63.216385],
                [19.08527800000013, 63.214165],
                [19.108608, 63.213608000000136],
                [19.110275, 63.20832800000011],
                [19.066666, 63.178604],
                [19.058331, 63.175278],
                [19.046944, 63.174438],
                [19.036942, 63.176384],
                [18.9725, 63.21],
                [18.966942, 63.214439],
                [18.963333, 63.21888700000011],
                [18.965, 63.225273],
                [18.96527, 63.230827],
                [18.95611, 63.24528],
                [18.90361, 63.272774],
                [18.88972, 63.2736],
                [18.811554000000115, 63.251774],
                [18.806053, 63.25027],
                [18.802887000000112, 63.248108],
                [18.80105, 63.244942],
                [18.8033870000001, 63.242107],
                [18.810055, 63.24044],
                [18.847219, 63.234104000000116],
                [18.88389, 63.227104],
                [18.908054, 63.21027400000014],
                [18.915276, 63.20666],
                [18.8975, 63.19166600000011],
                [18.784721, 63.161942],
                [18.775833, 63.162773],
                [18.761108, 63.170273],
                [18.751942, 63.18471],
                [18.74866500000013, 63.192436],
                [18.752163, 63.19560600000011],
                [18.757664, 63.1971],
                [18.765331000000117, 63.1971],
                [18.78083, 63.194439],
                [18.794, 63.195938],
                [18.791832, 63.198772],
                [18.787331, 63.20093900000012],
                [18.780664, 63.202606],
                [18.77183200000013, 63.20361],
                [18.73616, 63.20760700000011],
                [18.728664, 63.20760700000011],
                [18.722332, 63.206604],
                [18.719831, 63.203773000000126],
                [18.720997, 63.200775],
                [18.73555, 63.17249],
                [18.739166, 63.16777],
                [18.647221, 63.14055],
                [18.566944, 63.11749300000014],
                [18.382221, 63.051666],
                [18.28916500000014, 62.99721],
                [18.34666, 62.98805],
                [18.367222, 62.99139],
                [18.39, 62.993332],
                [18.4025, 62.993332],
                [18.524998, 62.98583200000013],
                [18.539719000000105, 62.984444],
                [18.552498000000128, 62.98221600000011],
                [18.561943, 62.97888200000011],
                [18.567497, 62.974716],
                [18.576664, 62.965828],
                [18.580276, 62.955551],
                [18.576385, 62.951111],
                [18.473888, 62.862495],
                [18.466942, 62.85833],
                [18.208611000000133, 62.77861],
                [18.19944, 62.776108],
                [18.12611, 62.765831],
                [18.082775, 62.781105],
                [18.104443000000117, 62.804161000000136],
                [18.129166, 62.804443],
                [18.138332000000105, 62.806938],
                [18.145275, 62.811104000000114],
                [18.144997, 62.816666],
                [18.137775, 62.820549],
                [18.073330000000112, 62.836662],
                [18.03722, 62.839165],
                [17.984997, 62.82222],
                [17.978333, 62.818054],
                [17.97472, 62.811386],
                [17.927498, 62.842499],
                [17.87222, 62.918610000000115],
                [17.862499, 62.933052],
                [17.84333, 62.962219],
                [17.828331, 62.993332],
                [17.820274, 62.995827],
                [17.701664, 62.995552],
                [17.696663, 62.991943],
                [17.70222, 62.987778],
                [17.7305530000001, 62.972771],
                [17.752777, 62.96194],
                [17.771385000000123, 62.955551],
                [17.793610000000115, 62.950554000000125],
                [17.834721000000116, 62.93332700000013],
                [17.88194, 62.883606],
                [17.99472, 62.730553],
                [18.004444, 62.70472],
                [18.004719, 62.69332900000012],
                [17.996387, 62.65666],
                [17.991386, 62.653053000000114],
                [17.979164, 62.652771],
                [17.964443, 62.66027100000014],
                [17.956944, 62.669441],
                [17.946388000000127, 62.669998],
                [17.879719, 62.669441],
                [17.874165, 62.664444],
                [17.877777, 62.659721000000104],
                [17.88528, 62.656105],
                [17.966389, 62.63444],
                [18.034721, 62.62639],
                [18.045555, 62.623604000000114],
                [18.048054, 62.601387],
                [18.04472, 62.589165],
                [17.978054, 62.555275],
                [17.84333, 62.487221],
                [17.83555200000012, 62.483887],
                [17.82527, 62.482216],
                [17.81194, 62.482773],
                [17.789719, 62.499443],
                [17.780552, 62.502495000000124],
                [17.767220000000123, 62.50332600000013],
                [17.72361000000012, 62.498886],
                [17.693333, 62.493607],
                [17.685555, 62.490273],
                [17.658607, 62.473328],
                [17.654163, 62.467216],
                [17.661663, 62.45805400000012],
                [17.676388, 62.450829],
                [17.67139, 62.43777],
                [17.619164, 62.434166],
                [17.605831000000137, 62.434998],
                [17.564163, 62.440277],
                [17.54583, 62.44638800000013],
                [17.53833, 62.449997],
                [17.528889, 62.45888500000012],
                [17.513885, 62.477219000000105],
                [17.50444, 62.486107],
                [17.47472, 62.506386],
                [17.437496, 62.53],
                [17.422497, 62.537216],
                [17.40916, 62.538055],
                [17.401386, 62.534439000000134],
                [17.334442, 62.49194],
                [17.328888, 62.486938],
                [17.325554, 62.48027000000013],
                [17.359722, 62.360275000000115],
                [17.371944, 62.329163],
                [17.375832, 62.32444],
                [17.465275, 62.265549],
                [17.502497, 62.25849],
                [17.552164, 62.25016],
                [17.576998000000117, 62.247162],
                [17.623886, 62.23944100000011],
                [17.645554, 62.234161],
                [17.65472000000011, 62.23111],
                [17.649719, 62.227493],
                [17.59999800000014, 62.209442],
                [17.556664, 62.195549],
                [17.545277, 62.196938],
                [17.537777, 62.200554000000125],
                [17.535831, 62.205551],
                [17.538609000000122, 62.211105],
                [17.555641, 62.216953],
                [17.567001, 62.22633400000012],
                [17.55786, 62.235104],
                [17.542677, 62.23152],
                [17.53243, 62.23004],
                [17.519958, 62.230782],
                [17.509464, 62.22893],
                [17.510036000000127, 62.204578],
                [17.508038, 62.200584000000106],
                [17.483253000000104, 62.125145],
                [17.463608, 62.006386000000134],
                [17.45166, 61.996941],
                [17.445, 61.992775],
                [17.437222000000133, 61.989441],
                [17.427498, 61.987778],
                [17.418331000000137, 61.990829],
                [17.408607, 61.992493],
                [17.399998, 61.989998],
                [17.393330000000105, 61.9855500000001],
                [17.354164, 61.951111],
                [17.349720000000104, 61.945274],
                [17.345276000000126, 61.92638],
                [17.336388000000113, 61.818054],
                [17.38566600000013, 61.756496],
                [17.440277, 61.726944],
                [17.46971900000011, 61.732216],
                [17.48389, 61.73083],
                [17.49472, 61.72805],
                [17.5, 61.723885],
                [17.523609000000135, 61.70166],
                [17.523609000000135, 61.696106],
                [17.50111, 61.639717],
                [17.498886, 61.63582600000012],
                [17.493610000000103, 61.630829],
                [17.487221, 61.626389],
                [17.477219, 61.62471800000014],
                [17.445274, 61.62888],
                [17.432777, 61.631104],
                [17.42194400000011, 61.63916000000012],
                [17.419998, 61.64444],
                [17.414165, 61.65416],
                [17.39, 61.687218],
                [17.386108, 61.69194],
                [17.36811, 61.700386],
                [17.354109, 61.706551000000104],
                [17.33944300000013, 61.712494000000106],
                [17.32694, 61.714439],
                [17.23389, 61.722496],
                [17.22083, 61.723053],
                [17.15, 61.72138200000012],
                [17.140274, 61.719719],
                [17.142220000000123, 61.714439],
                [17.149441, 61.71083],
                [17.15833, 61.70777],
                [17.18388700000014, 61.704994],
                [17.194721, 61.706108],
                [17.207775, 61.705276],
                [17.220276, 61.703331000000105],
                [17.26083, 61.69111],
                [17.269722000000115, 61.688049],
                [17.27166, 61.68305],
                [17.26861, 61.67638],
                [17.263054000000125, 61.67110400000013],
                [17.189999000000114, 61.63611],
                [17.18111, 61.63333100000011],
                [17.171387, 61.63166],
                [17.15833, 61.63222],
                [17.146111, 61.634163],
                [17.128052, 61.640549],
                [17.09861, 61.602776],
                [17.11777500000011, 61.55555],
                [17.162777, 61.52166000000011],
                [17.1680530000001, 61.517494],
                [17.222775, 61.44194],
                [17.21972, 61.429443],
                [17.213333, 61.425278],
                [17.171387, 61.420555],
                [17.15416, 61.42805],
                [17.150555, 61.432777],
                [17.139721000000122, 61.431664000000126],
                [17.109444, 61.408051],
                [17.10416400000014, 61.403053],
                [17.102776, 61.39694200000014],
                [17.104721, 61.39166],
                [17.144997, 61.357773],
                [17.20472, 61.328606],
                [17.213608, 61.325554],
                [17.20361, 61.278885],
                [17.18111, 61.190277],
                [17.162754, 61.046661],
                [17.150555, 60.945],
                [17.15444200000013, 60.940552],
                [17.201664, 60.916939],
                [17.24110800000011, 60.895828],
                [17.24472, 60.89111],
                [17.276108, 60.843048],
                [17.283607, 60.77166000000011],
                [17.28527, 60.731941],
                [17.275276, 60.676109],
                [17.359722, 60.640549000000135],
                [17.3771, 60.618988],
                [17.397499, 60.62916600000011],
                [17.40610900000013, 60.63166],
                [17.52055, 60.643051],
                [17.555275, 60.643326],
                [17.578331000000105, 60.6399990000001],
                [17.609165000000132, 60.63222],
                [17.63583, 60.618607],
                [17.649719, 60.611382],
                [17.656944, 60.601944],
                [17.651665, 60.596939000000134],
                [17.644165, 60.59360500000014],
                [17.60944400000011, 60.58416],
                [17.602219, 60.580551],
                [17.6025, 60.574997],
                [17.607777, 60.55610700000011],
                [17.609722, 60.550827],
                [17.629444, 60.522499],
                [17.63472000000013, 60.51833],
                [17.65361, 60.50694],
                [17.66222, 60.503883],
                [17.682777, 60.498604000000114],
                [17.693054, 60.496109000000104],
                [17.73111, 60.491661000000136],
                [17.740555, 60.493607],
                [17.740276, 60.499161],
                [17.734997, 60.50888800000013],
                [17.727776, 60.51833],
                [17.726109000000122, 60.523331],
                [17.725555, 60.534721],
                [17.72889, 60.541382],
                [17.73305, 60.547493],
                [17.773052, 60.57111],
                [17.842499, 60.59],
                [17.880554, 60.596939000000134],
                [17.891109, 60.597771],
                [17.937222, 60.59805300000011],
                [17.949718000000132, 60.597221],
                [17.95833, 60.594162],
                [17.965275, 60.590553],
                [17.970554, 60.586388],
                [17.993332000000123, 60.558884],
                [18.099998, 60.453049000000135],
                [18.21416, 60.343048000000124],
                [18.227776, 60.330276],
                [18.234444, 60.32666],
                [18.243889000000138, 60.328331000000105],
                [18.25222, 60.33083],
                [18.25861, 60.334999],
                [18.26667, 60.345276],
                [18.273052, 60.34944],
                [18.2825, 60.35139],
                [18.31388900000013, 60.353882],
                [18.431942, 60.343887],
                [18.44028, 60.3408280000001],
                [18.44722000000013, 60.331383],
                [18.46583, 60.29943800000012],
                [18.574165, 60.25],
                [18.601109, 60.241104],
                [18.607777, 60.23722],
                [18.606110000000115, 60.23111],
                [18.59861, 60.227776],
                [18.58, 60.224442],
                [18.55694, 60.224442],
                [18.531109, 60.226944],
                [18.470833, 60.234993],
                [18.448887, 60.23972],
                [18.44055200000014, 60.24277],
                [18.425278, 60.24971800000014],
                [18.388332, 60.266937],
                [18.374722, 60.2741620000001],
                [18.354164, 60.290833],
                [18.325554, 60.310829],
                [18.315277, 60.313332],
                [18.31361, 60.30722],
                [18.31388900000013, 60.301384],
                [18.396111000000133, 60.208054],
                [18.421665, 60.187218],
                [18.507431, 60.15266],
                [18.531666, 60.153053],
                [18.62611, 60.145828],
                [18.639442, 60.1441650000001],
                [18.711388000000113, 60.128052],
                [18.776665, 60.110832],
                [18.816387000000134, 60.09638],
                [18.81472, 60.090271],
                [18.81472, 60.078888],
                [18.816387000000134, 60.073883],
                [18.823055000000124, 60.05888],
                [18.886665, 59.96278],
                [18.89333, 59.953331000000105],
                [18.904999, 59.93999],
                [18.909721000000104, 59.935829],
                [18.92972200000014, 59.924721],
                [18.95022, 59.92033],
                [18.96372, 59.92033],
                [19.00722100000013, 59.912773],
                [19.045555, 59.899162],
                [19.070553, 59.889717],
                [19.07, 59.838608],
                [19.068333, 59.8324970000001],
                [19.065552, 59.827217],
                [19.059166, 59.823051000000135],
                [19.05055, 59.822777],
                [19.04055, 59.825272],
                [19.02583, 59.832222000000115],
                [18.96922, 59.865608],
                [18.936108, 59.86999500000013],
                [18.864719, 59.79805],
                [18.934719, 59.783607],
                [18.96860900000013, 59.783607],
                [19.07389, 59.774162],
                [19.08055, 59.770554],
                [19.082222, 59.765274],
                [19.081944000000135, 59.75972],
                [19.075275, 59.740555],
                [19.07, 59.735832],
                [19.03221900000011, 59.719994],
                [18.99139, 59.71666],
                [18.98, 59.71666],
                [18.95361, 59.719994],
                [18.841389, 59.712494],
                [18.74555, 59.68916300000012],
                [18.71722, 59.67139],
                [18.69444, 59.645271],
                [18.699997, 59.64249],
                [18.71027800000013, 59.643326],
                [18.728611, 59.64666],
                [18.739998000000128, 59.64666],
                [18.74472, 59.64249],
                [18.73416, 59.63250000000011],
                [18.666386, 59.591385],
                [18.645554, 59.580551],
                [18.37833000000012, 59.467499],
                [18.368332000000123, 59.466385000000116],
                [18.31722, 59.47361],
                [18.27972, 59.476662],
                [18.270554, 59.474998],
                [18.259443, 59.448051000000135],
                [18.259443, 59.44472],
                [18.276665, 59.41777],
                [18.28167, 59.413605],
                [18.28833, 59.409996],
                [18.299721, 59.407776],
                [18.32611100000014, 59.404442],
                [18.335831, 59.401939],
                [18.337498, 59.39666000000011],
                [18.331387, 59.392494],
                [18.32222, 59.390831000000105],
                [18.311108000000104, 59.390831000000105],
                [18.174999000000128, 59.405548],
                [18.165, 59.408051],
                [18.16, 59.412216],
                [18.16249800000014, 59.41749600000014],
                [18.176941, 59.424438],
                [18.188053, 59.424438],
                [18.19805, 59.42166],
                [18.203777, 59.427719],
                [18.19927600000011, 59.442551],
                [18.198277, 59.445721000000106],
                [18.195831, 59.455276],
                [18.18694, 59.45694],
                [18.124443, 59.45472],
                [18.115555, 59.453049000000135],
                [18.08972, 59.43721800000014],
                [18.084721, 59.431938000000116],
                [18.057220000000143, 59.391388],
                [18.088886, 59.367218],
                [18.091389, 59.334442],
                [18.00736000000012, 59.34496300000012],
                [17.94111, 59.335548],
                [17.928886, 59.33638800000011],
                [17.9175, 59.338608000000136],
                [17.89777800000013, 59.34388700000011],
                [17.859165, 59.35611],
                [17.832775, 59.36499800000013],
                [17.816109, 59.371109],
                [17.801388, 59.377777],
                [17.782776, 59.38916],
                [17.76444, 59.400551],
                [17.75777, 59.409996],
                [17.7575, 59.42139],
                [17.758888000000127, 59.427498],
                [17.78, 59.48555],
                [17.78722, 59.498329000000126],
                [17.79139, 59.504166],
                [17.801941, 59.51472],
                [17.81639, 59.52166],
                [17.841663, 59.52833],
                [17.845276, 59.533051000000114],
                [17.822777, 59.580826000000116],
                [17.816109, 59.59027],
                [17.809166, 59.593887],
                [17.751942, 59.638611],
                [17.71722, 59.66333],
                [17.724163, 59.653885000000116],
                [17.722221000000104, 59.62610600000011],
                [17.71805, 59.620277],
                [17.710552, 59.61888900000014],
                [17.6425, 59.637497],
                [17.603962, 59.65063],
                [17.59222, 59.656105],
                [17.598331, 59.660271],
                [17.607498, 59.661942],
                [17.62805, 59.662216],
                [17.64027, 59.66333],
                [17.648331, 59.665833000000134],
                [17.652496, 59.671661],
                [17.653339, 59.682129],
                [17.654163, 59.71805],
                [17.6313, 59.784073],
                [17.62805, 59.78889],
                [17.594166, 59.806938000000116],
                [17.58778, 59.804718],
                [17.588055, 59.793610000000115],
                [17.586666, 59.787216],
                [17.58361, 59.780548],
                [17.579441, 59.774719],
                [17.574444, 59.769722],
                [17.5425, 59.749443],
                [17.534443, 59.746941],
                [17.513885, 59.744995],
                [17.448055000000124, 59.73555],
                [17.44472100000013, 59.676109],
                [17.510555, 59.587219],
                [17.520832, 59.579163],
                [17.527496, 59.575554],
                [17.535831, 59.57222],
                [17.543152000000134, 59.573006],
                [17.52166, 59.611382],
                [17.515553, 59.63833],
                [17.513332, 59.65471600000012],
                [17.50889, 59.68777],
                [17.50861, 59.693329],
                [17.509998, 59.69944],
                [17.513054, 59.706383],
                [17.537498, 59.732216],
                [17.588886, 59.73693800000012],
                [17.59999800000014, 59.73693800000012],
                [17.611664000000133, 59.734993],
                [17.618332, 59.731384000000105],
                [17.6202770000001, 59.72639],
                [17.61610800000011, 59.695549],
                [17.561171000000115, 59.668449],
                [17.58971, 59.639427],
                [17.694164, 59.607498],
                [17.74222200000014, 59.590553],
                [17.757221, 59.583885],
                [17.7675, 59.569717],
                [17.78666, 59.535828],
                [17.785, 59.52944200000013],
                [17.737221, 59.446938],
                [17.73111, 59.442772],
                [17.72, 59.442772],
                [17.551941, 59.488609],
                [17.543888, 59.491661000000136],
                [17.525276, 59.503052],
                [17.52027500000014, 59.507217],
                [17.519089, 59.510254],
                [17.51833, 59.512215],
                [17.5225, 59.51805],
                [17.546082, 59.536987],
                [17.50027, 59.539719000000105],
                [17.490276000000108, 59.542496],
                [17.44694, 59.55722],
                [17.43861, 59.560272],
                [17.377777, 59.604721],
                [17.37278, 59.608887],
                [17.370831000000123, 59.614166],
                [17.37055, 59.61972],
                [17.386108, 59.651108],
                [17.38361, 59.654999],
                [17.375553, 59.652222],
                [17.344166, 59.62277200000011],
                [17.353333, 59.606110000000115],
                [17.370831000000123, 59.583054],
                [17.403332, 59.55333],
                [17.406666, 59.548607],
                [17.408607, 59.543327],
                [17.419167, 59.49277500000011],
                [17.41944100000012, 59.487221],
                [17.418053, 59.48111],
                [17.41, 59.46916],
                [17.398888, 59.46916],
                [17.325554, 59.48805],
                [17.26194, 59.50444],
                [17.25528, 59.508049],
                [17.18528, 59.53860500000013],
                [17.117222, 59.547775],
                [17.068054, 59.54361],
                [17.06194, 59.539444],
                [17.031387, 59.53638500000011],
                [17.019165, 59.537216000000114],
                [16.94972, 59.54361],
                [16.93972, 59.54610400000013],
                [16.8649640000001, 59.58473],
                [16.826385, 59.585274],
                [16.786942, 59.558884],
                [16.66166, 59.54805],
                [16.658054000000106, 59.55249800000013],
                [16.623055, 59.5816650000001],
                [16.616386, 59.585274],
                [16.565277, 59.60916],
                [16.551941000000113, 59.6105500000001],
                [16.541943000000117, 59.60944400000011],
                [16.53389, 59.60694100000012],
                [16.50166300000012, 59.596382],
                [16.495552, 59.591942],
                [16.49749800000012, 59.586937],
                [16.52166, 59.571663000000115],
                [16.542221, 59.561104],
                [16.547497, 59.556938],
                [16.546108000000117, 59.550827],
                [16.543331, 59.543884000000105],
                [16.53833, 59.53889],
                [16.489166000000125, 59.502014],
                [16.4725, 59.49749800000012],
                [16.329998, 59.467773],
                [16.178055, 59.464996],
                [16.16861, 59.465271],
                [16.10166, 59.471107],
                [16.091663, 59.473328],
                [16.06639, 59.482498000000135],
                [16.044167, 59.492493],
                [16.03555, 59.495552],
                [16.025555, 59.497772],
                [16.020275, 59.49499500000013],
                [16.022221, 59.48972],
                [16.026108, 59.485275],
                [16.041664, 59.473053],
                [16.066109, 59.457771],
                [16.072777, 59.454437],
                [16.08138700000012, 59.45138500000013],
                [16.101387, 59.446388],
                [16.11305, 59.444443],
                [16.169167, 59.439995],
                [16.181389, 59.439438],
                [16.261387, 59.4425],
                [16.276417, 59.443985],
                [16.304722, 59.450272],
                [16.313889, 59.451942],
                [16.335, 59.453331],
                [16.659443000000124, 59.4741590000001],
                [16.67, 59.473053],
                [16.679996, 59.470551],
                [16.686665, 59.46721600000012],
                [16.69028, 59.462494],
                [16.700554, 59.454437],
                [16.75, 59.424164],
                [16.80611, 59.390549],
                [16.8127750000001, 59.38694],
                [16.822777, 59.3844380000001],
                [16.869999, 59.381386],
                [16.88111, 59.381660000000124],
                [16.889999000000103, 59.383331],
                [16.893055, 59.39],
                [16.89416, 59.39611100000013],
                [16.89222, 59.401382],
                [16.885555000000124, 59.405],
                [16.86222, 59.405273],
                [16.85083, 59.40749],
                [16.84222000000011, 59.41055300000011],
                [16.808887, 59.422493],
                [16.79222, 59.42860400000012],
                [16.72666500000014, 59.453606],
                [16.697777, 59.46721600000012],
                [16.69278, 59.471382],
                [16.693333, 59.476105],
                [16.82889, 59.491386],
                [16.840275000000133, 59.48944100000011],
                [16.848888000000102, 59.486382],
                [16.8975, 59.467499],
                [16.924442000000113, 59.453331],
                [16.93555, 59.446388],
                [16.945831, 59.43833],
                [16.95444, 59.429718],
                [16.961388000000113, 59.420273],
                [17.111664, 59.374443],
                [17.174442, 59.373055000000136],
                [17.280552, 59.356667],
                [17.302219, 59.351944],
                [17.310555, 59.34888500000011],
                [17.315552, 59.344719],
                [17.317497, 59.33972200000011],
                [17.31611, 59.333328],
                [17.311943, 59.327499],
                [17.306110000000103, 59.323326],
                [17.298054, 59.320831],
                [17.287777, 59.319717],
                [17.26388500000013, 59.290833000000134],
                [17.25194, 59.269722],
                [17.253887000000134, 59.258888],
                [17.286942, 59.25904800000012],
                [17.29194, 59.25722],
                [17.365276, 59.248604],
                [17.375832, 59.247498],
                [17.387775, 59.246941],
                [17.398052, 59.247772],
                [17.39611, 59.25278],
                [17.386108, 59.261108],
                [17.379444, 59.264717],
                [17.364166, 59.277222],
                [17.358887, 59.286942],
                [17.355, 59.297218],
                [17.349442, 59.318329],
                [17.35083, 59.32444],
                [17.361942, 59.324715],
                [17.413055, 59.312218],
                [17.44278, 59.304718],
                [17.470833, 59.29639],
                [17.58583, 59.282219],
                [17.740276, 59.26944],
                [17.847221, 59.264442],
                [17.908054, 59.297218],
                [17.940552, 59.316666],
                [17.94749800000011, 59.32],
                [17.97639, 59.331383],
                [17.98444400000011, 59.33388500000012],
                [17.996666, 59.33305400000012],
                [18.016666, 59.32222],
                [18.026386000000116, 59.319717],
                [18.052498, 59.316383],
                [18.074718, 59.316666],
                [18.13361, 59.31805],
                [18.206944, 59.32944],
                [18.242092000000127, 59.34708400000011],
                [18.250832000000116, 59.354439],
                [18.272221, 59.364441],
                [18.280277000000126, 59.36694],
                [18.289444000000117, 59.368607],
                [18.34861, 59.373329],
                [18.39222, 59.368607],
                [18.40361000000013, 59.366661],
                [18.43972, 59.355],
                [18.44472100000013, 59.35083],
                [18.441275, 59.34477],
                [18.43694, 59.342773000000136],
                [18.43211, 59.341278],
                [18.434998, 59.33638800000011],
                [18.45472, 59.331108],
                [18.46666, 59.33027600000014],
                [18.474163, 59.334442],
                [18.478611, 59.340271],
                [18.478333000000134, 59.34583],
                [18.468609, 59.365555],
                [18.450275, 59.394165],
                [18.431389000000138, 59.421104],
                [18.42805, 59.425827],
                [18.42805, 59.43138900000014],
                [18.43444, 59.433609],
                [18.47722, 59.43527200000011],
                [18.498333, 59.43055],
                [18.523052, 59.421104],
                [18.52972, 59.41749600000014],
                [18.607777, 59.37194],
                [18.612778, 59.36805],
                [18.640274, 59.338882],
                [18.648609, 59.32444],
                [18.650276, 59.31916],
                [18.646942, 59.312492],
                [18.639721, 59.309166],
                [18.630554, 59.30749500000013],
                [18.593052, 59.301666000000125],
                [18.522221, 59.29583],
                [18.389164, 59.30194100000011],
                [18.37722, 59.302498],
                [18.35361, 59.30555],
                [18.343609, 59.30749500000013],
                [18.335278, 59.31055],
                [18.337776, 59.31611],
                [18.3365, 59.322052],
                [18.328833, 59.325054],
                [18.318886, 59.32833],
                [18.27722, 59.310829000000126],
                [18.26944, 59.268608],
                [18.309998, 59.21971900000011],
                [18.311386, 59.1325],
                [18.230274, 59.118607],
                [18.221386, 59.116943],
                [18.140274, 59.09083],
                [18.021385, 59.041939],
                [17.895832, 58.90972],
                [17.89278, 58.903053],
                [17.891388, 58.89666],
                [17.89194, 58.874161],
                [17.894722, 58.85889],
                [17.789444, 58.94305400000013],
                [17.756664000000114, 59.018326000000116],
                [17.768887, 59.096664],
                [17.768330000000105, 59.113609],
                [17.7666660000001, 59.118889],
                [17.764721000000122, 59.123886],
                [17.759163000000115, 59.126663],
                [17.66861, 59.166382],
                [17.663887, 59.16833],
                [17.624165, 59.07444],
                [17.611664000000133, 59.04055],
                [17.610275000000115, 59.034439000000134],
                [17.612221, 59.029442],
                [17.617222, 59.02527600000013],
                [17.62555, 59.01639],
                [17.62889, 59.011665],
                [17.61360900000011, 58.974716000000114],
                [17.578327000000115, 58.95050800000013],
                [17.59139, 58.943604],
                [17.630554, 58.914993],
                [17.62917, 58.908882],
                [17.62611, 58.901939],
                [17.58333, 58.849442000000124],
                [17.578888, 58.845551],
                [17.349998, 58.752220000000136],
                [17.271111, 58.73693800000012],
                [17.22361, 58.7305530000001],
                [17.156666, 58.73277300000012],
                [17.093609, 58.76249700000011],
                [17.083332, 58.76361],
                [17.032776, 58.750549],
                [17.02861000000013, 58.746941],
                [17.033607, 58.74277500000011],
                [17.082222, 58.723053],
                [17.134163, 58.702217],
                [17.145554000000118, 58.700272],
                [17.143055000000118, 58.69472],
                [17.13833, 58.68972],
                [17.034443000000124, 58.637215],
                [16.915276, 58.616943000000106],
                [16.90528, 58.61610400000012],
                [16.89333, 58.616661],
                [16.789719, 58.623604],
                [16.736122000000137, 58.62899],
                [16.677776, 58.63694],
                [16.461388, 58.655548],
                [16.436386, 58.65749],
                [16.41278, 58.658882],
                [16.29833200000013, 58.66305],
                [16.242222, 58.664719],
                [16.233608, 58.66305],
                [16.193607, 58.627495000000124],
                [16.293331, 58.61360900000011],
                [16.37055, 58.60527],
                [16.41166, 58.613327],
                [16.432499, 58.637772],
                [16.436665, 58.64138800000012],
                [16.649441000000138, 58.620552],
                [16.710831, 58.606667],
                [16.72722, 58.600555],
                [16.777496, 58.581383],
                [16.928608, 58.492493],
                [16.93861, 58.484161],
                [16.83472, 58.445],
                [16.826942, 58.442215],
                [16.80916600000012, 58.43860600000011],
                [16.75444, 58.429443000000106],
                [16.737778, 58.42860400000012],
                [16.600555, 58.4469380000001],
                [16.578053, 58.450829],
                [16.568619, 58.453239],
                [16.548885, 58.45833],
                [16.5325, 58.464439],
                [16.514721, 58.469994],
                [16.496666, 58.475273],
                [16.47555, 58.479721],
                [16.435555, 58.479996],
                [16.425552, 58.47916],
                [16.416943, 58.477219],
                [16.41333, 58.474716],
                [16.573055, 58.435829],
                [16.68361, 58.41083],
                [16.693886000000134, 58.409721],
                [16.71, 58.40361],
                [16.769997, 58.367218],
                [16.78889, 58.32222],
                [16.824718, 58.19944],
                [16.825832, 58.176666],
                [16.80282, 58.138672],
                [16.764471, 58.125179],
                [16.742811, 58.08612],
                [16.731806, 58.049198],
                [16.75027, 58.012772],
                [16.743610000000103, 58.009163000000115],
                [16.639252, 57.98749],
                [16.622498, 57.988609],
                [16.61389, 57.986938],
                [16.62194, 57.983887],
                [16.6555, 57.977745],
                [16.671944, 57.98027000000013],
                [16.725277, 57.974159],
                [16.733055, 57.97110700000013],
                [16.739998, 57.961937],
                [16.744164, 57.953049],
                [16.742561000000137, 57.950333],
                [16.773331, 57.92360700000012],
                [16.778053000000114, 57.919441],
                [16.78, 57.91444400000012],
                [16.770554000000118, 57.884438],
                [16.763885, 57.881104],
                [16.749443, 57.874992],
                [16.741665, 57.872498],
                [16.732498000000135, 57.87277200000011],
                [16.65916, 57.88333100000011],
                [16.622219, 57.890274],
                [16.61360900000011, 57.89222],
                [16.6025, 57.922775],
                [16.60611, 57.925278],
                [16.60278, 57.940277],
                [16.518608, 57.99694],
                [16.510555, 57.996384],
                [16.502777, 57.993889],
                [16.49861, 57.990273],
                [16.495552, 57.98555],
                [16.494442, 57.97943900000013],
                [16.522331000000122, 57.87783],
                [16.56433, 57.854164],
                [16.677219, 57.765549],
                [16.693333, 57.753883],
                [16.703331, 57.745552],
                [16.700706, 57.74015],
                [16.692219, 57.738884],
                [16.68444, 57.742218],
                [16.618889, 57.77138500000012],
                [16.615555, 57.776108000000136],
                [16.61138, 57.78638500000011],
                [16.60278, 57.794716],
                [16.590553000000114, 57.802773],
                [16.561108, 57.821388],
                [16.554722, 57.82499700000011],
                [16.418610000000115, 57.893326],
                [16.418888, 57.88721],
                [16.420830000000137, 57.88250000000011],
                [16.463421, 57.849297],
                [16.469753, 57.844627],
                [16.47642, 57.839966],
                [16.593775, 57.773163],
                [16.605442, 57.76683],
                [16.660553000000107, 57.741104],
                [16.692219, 57.721939],
                [16.701942, 57.713882000000126],
                [16.710278, 57.705276],
                [16.7125, 57.699997],
                [16.625553, 57.61972],
                [16.6325, 57.552216],
                [16.68916300000012, 57.485275],
                [16.693333, 57.47527300000013],
                [16.693333, 57.469162],
                [16.67139, 57.41083],
                [16.664719, 57.407494],
                [16.65583, 57.405],
                [16.63694, 57.403053000000114],
                [16.63222, 57.38166],
                [16.63111, 57.37693800000011],
                [16.62416500000012, 57.374443],
                [16.60083, 57.377495],
                [16.566387, 57.383331],
                [16.554996, 57.383606],
                [16.546108000000117, 57.38166],
                [16.541943000000117, 57.37693800000011],
                [16.472221, 57.290276],
                [16.46722000000011, 57.27666],
                [16.464722, 57.264442],
                [16.455555, 57.205276],
                [16.455276, 57.200554],
                [16.458054, 57.178329],
                [16.460278, 57.167496],
                [16.46722000000011, 57.15860700000013],
                [16.513885, 57.117218],
                [16.523331, 57.11666],
                [16.530277000000126, 57.119438],
                [16.539997, 57.120552],
                [16.546108000000117, 57.116943],
                [16.563332, 57.093887],
                [16.5841640000001, 57.049438],
                [16.584721, 57.043884],
                [16.50166300000012, 57.03666],
                [16.49277, 57.03916],
                [16.454441, 56.95527600000014],
                [16.440552, 56.89388300000013],
                [16.426666, 56.843605],
                [16.407776, 56.79555],
                [16.375, 56.720833],
                [16.308052, 56.655],
                [16.30055, 56.65833],
                [16.29055, 56.65916],
                [16.272499, 56.656662],
                [16.253609, 56.64611],
                [16.21611, 56.607216],
                [16.123886, 56.461662],
                [16.117222, 56.449715],
                [16.10416, 56.425552],
                [16.090553, 56.394997],
                [16.054722, 56.313606],
                [16.043331000000137, 56.268883],
                [16.008331, 56.217773000000136],
                [15.99861, 56.208328],
                [15.86555, 56.09222],
                [15.78861, 56.111938],
                [15.77583, 56.147774],
                [15.658888, 56.178886],
                [15.59805, 56.194717],
                [15.37528, 56.138054000000125],
                [15.225832, 56.151108],
                [15.08888800000011, 56.16],
                [14.84805, 56.161385],
                [14.717222000000106, 56.1616590000001],
                [14.696665, 56.16111000000012],
                [14.69055, 56.15778],
                [14.686666, 56.152771],
                [14.679722, 56.13250000000011],
                [14.679443000000106, 56.120552],
                [14.681944000000101, 56.11555],
                [14.686666, 56.111382],
                [14.69278, 56.108055],
                [14.709999, 56.10277600000012],
                [14.714722, 56.09916],
                [14.750832000000116, 56.059715],
                [14.76778, 56.03638500000011],
                [14.76667, 56.030273000000136],
                [14.738333000000125, 56.010826],
                [14.72, 56.00027],
                [14.63528, 56.0075],
                [14.620832, 56.029442],
                [14.603611, 56.051941],
                [14.558887, 56.05722],
                [14.551388, 56.055275],
                [14.541388, 56.051109],
                [14.51166, 56.0375],
                [14.36944, 55.958885],
                [14.330276, 55.93694],
                [14.263611, 55.886108],
                [14.24472, 55.866943000000106],
                [14.232777, 55.85166],
                [14.217222, 55.83027600000014],
                [14.207777000000135, 55.812492],
                [14.202776, 55.799721],
                [14.200554, 55.79277000000013],
                [14.196665, 55.779716],
                [14.193333, 55.76666300000011],
                [14.190832, 55.74166],
                [14.19111, 55.731384],
                [14.19222, 55.72583],
                [14.19611, 55.715828],
                [14.203333, 55.70694],
                [14.217777000000126, 55.694717],
                [14.276943, 55.647217],
                [14.341389, 55.578606],
                [14.363333000000125, 55.551941],
                [14.37028, 55.54277],
                [14.37278, 55.53777300000013],
                [14.369165, 55.531662],
                [14.361944000000108, 55.522774],
                [14.336666, 55.50110600000011],
                [14.312498, 55.48666400000013],
                [14.193546, 55.386147],
                [14.16305, 55.380272000000105],
                [14.122499, 55.37944],
                [14.05888700000014, 55.38611],
                [14.0375, 55.38944],
                [14.00472, 55.40583],
                [13.969444, 55.42110400000013],
                [13.93583, 55.431389],
                [13.911943, 55.433884],
                [13.89139, 55.433609],
                [13.73055, 55.425552],
                [13.710278, 55.424164],
                [13.6416660000001, 55.417496],
                [13.632221, 55.415833],
                [13.497776000000101, 55.38222],
                [13.465832, 55.3736],
                [13.429722, 55.35666700000013],
                [13.418333, 55.352493],
                [13.375555000000134, 55.339996],
                [13.344721000000106, 55.339165],
                [13.300833, 55.340828],
                [13.289999000000137, 55.341942],
                [12.982222, 55.400551],
                [12.918055, 55.538605],
                [12.91639, 55.54416700000013],
                [12.914444, 55.56221800000014],
                [12.914721, 55.56555200000014],
                [12.91639, 55.568329],
                [12.922499, 55.57471],
                [12.93111, 55.581108],
                [12.960278, 55.59111],
                [12.981943, 55.599159],
                [13.034721000000104, 55.623886],
                [13.0405540000001, 55.627495],
                [13.044998, 55.6325],
                [13.05888700000014, 55.662773],
                [13.063332, 55.68222],
                [13.0625, 55.684998],
                [13.059721, 55.693054],
                [12.92805, 55.823051],
                [12.91277700000012, 55.838051],
                [12.681389, 56.061943],
                [12.66361, 56.078606],
                [12.63389, 56.10305],
                [12.623888, 56.107773],
                [12.615, 56.109444],
                [12.609722, 56.111664],
                [12.58111, 56.14166300000011],
                [12.453054000000122, 56.29333],
                [12.451666, 56.297775000000115],
                [12.461666, 56.298332],
                [12.47389, 56.297218],
                [12.629166, 56.258888],
                [12.645277000000135, 56.25332600000013],
                [12.718681, 56.222778],
                [12.78722, 56.222221000000104],
                [12.794443, 56.223053],
                [12.801943000000108, 56.225555],
                [12.813332000000116, 56.232773],
                [12.824165, 56.241661],
                [12.830089, 56.250000000000114],
                [12.83166, 56.252220000000136],
                [12.834721, 56.25804900000014],
                [12.835, 56.26416],
                [12.833055, 56.269165],
                [12.740833, 56.352219],
                [12.730555, 56.359444],
                [12.72389, 56.36305],
                [12.676109, 56.379715],
                [12.66389, 56.380272000000105],
                [12.644722, 56.38472],
                [12.636665, 56.38777],
                [12.62611, 56.395271],
                [12.62278, 56.399994],
                [12.622221, 56.411942],
                [12.62639, 56.424721],
                [12.62861, 56.431389],
                [12.63194, 56.436943],
                [12.635555, 56.44221],
                [12.641388, 56.446106],
                [12.672777, 56.463608],
                [12.67972200000014, 56.466385],
                [12.721943000000124, 56.4675],
                [12.732498, 56.4675],
                [12.74917, 56.464722],
                [12.78583, 56.450272],
                [12.793333, 56.447777],
                [12.812498, 56.44332900000012],
                [12.832777000000135, 56.439720000000136],
                [12.85265, 56.439919],
                [12.86861, 56.441383],
                [12.87611, 56.4436],
                [12.88361, 56.446388],
                [12.90111, 56.457222],
                [12.910831, 56.466942],
                [12.918055, 56.478333],
                [12.930277, 56.50110600000011],
                [12.937498, 56.521111],
                [12.93694, 56.532494],
                [12.933332, 56.543327],
                [12.93139, 56.54833200000013],
                [12.91722, 56.57861],
                [12.887499000000105, 56.638329],
                [12.876665, 56.646385],
                [12.86916, 56.648888],
                [12.821665, 56.65833],
                [12.813332000000116, 56.656662],
                [12.785000000000139, 56.643608],
                [12.758055, 56.64],
                [12.72527700000012, 56.63971700000013],
                [12.718611000000124, 56.643326000000116],
                [12.67083, 56.67610900000011],
                [12.613609, 56.746941],
                [12.599998, 56.777771],
                [12.59833, 56.783333],
                [12.599165, 56.79583],
                [12.601387, 56.8025],
                [12.599998, 56.80805],
                [12.597500000000139, 56.813332],
                [12.593332, 56.817497],
                [12.579443, 56.830276],
                [12.573889, 56.83388500000012],
                [12.484722, 56.88166],
                [12.468332, 56.887772],
                [12.41805, 56.897217000000126],
                [12.35027700000012, 56.914444],
                [12.3475, 56.91916700000013],
                [12.349998, 56.969994],
                [12.28611, 57.03249],
                [12.25361, 57.04805],
                [12.237778, 57.059715],
                [12.149443000000133, 57.183884],
                [12.146666, 57.188332],
                [12.109999, 57.25],
                [12.13472, 57.27555100000012],
                [12.148611, 57.28110500000014],
                [12.15138800000011, 57.287216],
                [12.14583, 57.309166],
                [12.094999, 57.426941],
                [12.058332, 57.45472],
                [12.05139, 57.457771],
                [12.043888, 57.45972],
                [12.036943000000122, 57.45694],
                [12.011665000000107, 57.43416600000012],
                [12.007776, 57.428886],
                [12.005833, 57.422218],
                [12.00861, 57.41138500000011],
                [12.007776, 57.405],
                [11.989443, 57.3475],
                [11.986111, 57.341385],
                [11.97917, 57.343605],
                [11.94278, 57.376106],
                [11.917776, 57.40222200000011],
                [11.904165, 57.42194400000011],
                [11.901388, 57.426666],
                [11.906666, 57.5149990000001],
                [11.911112, 57.52665],
                [11.913332, 57.52861],
                [11.915833, 57.534439],
                [11.922222, 57.56388900000013],
                [11.913332, 57.613609],
                [11.91055, 57.618607],
                [11.906387, 57.623329],
                [11.897499, 57.624443],
                [11.894444, 57.61833200000012],
                [11.862499, 57.607773],
                [11.83, 57.661385],
                [11.86861, 57.68055],
                [11.887777, 57.693886000000134],
                [11.75055, 57.688889],
                [11.741388, 57.688606],
                [11.704443, 57.693329],
                [11.698889000000122, 57.69722000000013],
                [11.699720000000127, 57.71583],
                [11.72305, 57.80722],
                [11.668055, 57.84583],
                [11.688055, 57.88166],
                [11.69416600000011, 57.885277],
                [11.702221000000122, 57.88721],
                [11.711666, 57.88916],
                [11.741388, 57.89222],
                [11.75722, 57.897217000000126],
                [11.795555, 58.0061],
                [11.801388, 58.026382],
                [11.80055, 58.038055],
                [11.799166, 58.043884],
                [11.79361, 58.0480500000001],
                [11.776667, 58.05314],
                [11.776667, 58.059441000000106],
                [11.79611, 58.095276],
                [11.83722, 58.154716],
                [11.87028, 58.19111],
                [11.88083, 58.19999700000011],
                [11.884722, 58.205276],
                [11.88611, 58.211937],
                [11.798054, 58.318329],
                [11.734999, 58.328331],
                [11.723331, 58.328888],
                [11.622776, 58.276108],
                [11.6075, 58.262772],
                [11.594721000000106, 58.255272],
                [11.53611, 58.23027],
                [11.526388, 58.230553],
                [11.5158330000001, 58.23194100000012],
                [11.49528, 58.236107],
                [11.405554, 58.261108],
                [11.384165, 58.311943],
                [11.238333000000125, 58.346939],
                [11.201387000000125, 58.399437],
                [11.235554, 58.505272000000105],
                [11.254166, 58.551109],
                [11.257221, 58.556938],
                [11.266388, 58.57944],
                [11.26111, 58.632217],
                [11.259443, 58.637772],
                [11.252222, 58.653053],
                [11.24778, 58.65749],
                [11.210278, 58.679718],
                [11.180832, 58.70916],
                [11.17805, 58.713882],
                [11.176943, 58.730827],
                [11.181665, 58.747772],
                [11.200832, 58.769997],
                [11.218054, 58.78416],
                [11.229166000000134, 58.79222],
                [11.233889, 58.79694400000011],
                [11.236111000000108, 58.803604],
                [11.233055, 58.833054],
                [11.23139, 58.845276],
                [11.194166, 58.917496],
                [11.166666, 58.92443800000012],
                [11.131943, 58.935272],
                [11.123055000000136, 58.938332],
                [11.115833000000123, 58.941383],
                [11.106943, 58.95],
                [11.113333, 59.003609],
                [11.119165000000123, 59.015831],
                [11.127499000000114, 59.02638],
                [11.166388, 59.064438],
                [11.172499, 59.068604],
                [11.18667, 59.074997],
                [11.204166, 59.079437],
                [11.26555, 59.093887],
                [11.314999000000114, 59.101387],
                [11.324999000000105, 59.0991590000001],
                [11.338333, 59.091942],
                [11.349998000000141, 59.084442],
                [11.373333, 59.050827],
                [11.401667, 59.012772],
                [11.419443, 58.989716],
                [11.427082, 58.98578600000013],
                [11.429192, 58.98764],
                [11.423054, 58.926666],
                [11.422777, 58.92027300000012],
                [11.424999, 58.903053],
                [11.426109, 58.897217],
                [11.42778, 58.893051],
                [11.431944, 58.88861],
                [11.439165000000116, 58.885277],
                [11.450832, 58.883888],
                [11.463055, 58.88361],
                [11.49667, 58.88472000000013],
                [11.585833, 58.89666],
                [11.599968000000104, 58.899185],
                [11.621387, 58.904716],
                [11.626665000000116, 58.909164],
                [11.75111, 59.090271],
                [11.75305, 59.09722],
                [11.751944, 59.102776],
                [11.746387, 59.112778],
                [11.742222, 59.117493],
                [11.739443, 59.122498],
                [11.739443, 59.12722],
                [11.750832, 59.174438],
                [11.754444, 59.188049],
                [11.759165, 59.200829],
                [11.764721, 59.211662],
                [11.769547, 59.217537],
                [11.784721, 59.23027],
                [11.792288, 59.236641000000134],
                [11.795277, 59.23917],
                [11.79833, 59.245277],
                [11.798887, 59.257774],
                [11.796944, 59.275276],
                [11.79083, 59.303329],
                [11.783054000000106, 59.324715],
                [11.739166, 59.429718],
                [11.667776000000117, 59.59166],
                [11.666248, 59.595482],
                [11.75639, 59.635551000000135],
                [11.76417, 59.63833],
                [11.781666, 59.642776],
                [11.811666000000116, 59.646942],
                [11.820555, 59.648888],
                [11.82833, 59.651939],
                [11.896387000000118, 59.695],
                [11.900833, 59.70111],
                [11.902777, 59.707771],
                [11.903332, 59.720276000000126],
                [11.903055, 59.738327],
                [11.89885, 59.772469],
                [11.896387000000118, 59.784721],
                [11.891109, 59.79472],
                [11.886665, 59.79916400000013],
                [11.881109, 59.803886],
                [11.86944, 59.811661],
                [11.815960000000132, 59.8461],
                [11.852777000000117, 59.861382],
                [11.875832, 59.86999500000013],
                [11.956944, 59.896942],
                [11.968054, 59.89777400000014],
                [11.98, 59.896111],
                [11.998055, 59.890549],
                [12.008333000000107, 59.88861],
                [12.034166, 59.88611],
                [12.10722, 59.88582600000012],
                [12.129721, 59.88694],
                [12.14, 59.88832900000011],
                [12.16305, 59.896942],
                [12.191944, 59.91027100000014],
                [12.310276000000101, 59.968887],
                [12.32361, 59.97639],
                [12.461943, 60.063606],
                [12.476944, 60.076385],
                [12.489166, 60.098328],
                [12.494165000000123, 60.11110700000012],
                [12.49638700000014, 60.11805],
                [12.498333, 60.124718],
                [12.502777, 60.144722],
                [12.5075, 60.16944100000012],
                [12.508055, 60.175552],
                [12.508333, 60.181938000000116],
                [12.507776, 60.19360400000011],
                [12.504444, 60.210548],
                [12.527777000000128, 60.33416000000011],
                [12.53777700000012, 60.343887],
                [12.57194, 60.378052],
                [12.589722, 60.399162],
                [12.597500000000139, 60.424995],
                [12.60278, 60.44277],
                [12.607498000000135, 60.462494],
                [12.608055, 60.468605],
                [12.605833, 60.479996],
                [12.594444, 60.51694],
                [12.5875, 60.526665],
                [12.50583300000011, 60.62999700000012],
                [12.424999, 60.71027400000014],
                [12.38611, 60.750832],
                [12.378887000000134, 60.760277],
                [12.364721, 60.779442],
                [12.353611000000114, 60.79972],
                [12.35111000000012, 60.804718],
                [12.336111, 60.835831],
                [12.308611, 60.887215],
                [12.271944, 60.946106],
                [12.245554, 60.97305300000011],
                [12.233610000000112, 60.98083],
                [12.217222, 60.99305],
                [12.212776, 60.997498],
                [12.21, 61.002495],
                [12.215555, 61.006943],
                [12.222500000000139, 61.01083],
                [12.24778, 61.01861],
                [12.294167, 61.029442],
                [12.388054000000125, 61.05055],
                [12.40778, 61.053886],
                [12.432499, 61.054443],
                [12.458055, 61.053886],
                [12.500277, 61.05082700000014],
                [12.567221, 61.04805],
                [12.60222, 61.049721],
                [12.621944, 61.053055],
                [12.637825000000134, 61.057541],
                [12.670277, 61.087776],
                [12.772221000000116, 61.20083],
                [12.796665, 61.24499500000013],
                [12.83111, 61.312218],
                [12.85611, 61.36249500000014],
                [12.773888, 61.414719],
                [12.53, 61.566109],
                [12.52305, 61.567215],
                [12.481388, 61.569443],
                [12.468332, 61.56972],
                [12.444721, 61.56860400000011],
                [12.430277000000103, 61.569443],
                [12.40667, 61.573326],
                [12.392776, 61.580551],
                [12.144444, 61.7175],
                [12.12444, 61.72861],
                [12.159443000000124, 61.844444],
                [12.169998, 61.87861],
                [12.181665, 61.91249800000014],
                [12.200277, 61.963333],
                [12.214998, 62.006104],
                [12.25861, 62.142494],
                [12.294617, 62.258217],
                [12.295832000000132, 62.261665],
                [12.291666, 62.272499],
                [12.271387000000118, 62.30805],
                [12.256388, 62.327217],
                [12.245344, 62.337982000000125],
                [12.21, 62.3899990000001],
                [12.19972, 62.40471600000012],
                [12.18444, 62.423882],
                [12.17222, 62.43777],
                [12.14917, 62.46027400000014],
                [12.084721, 62.52916],
                [12.047499, 62.589996],
                [12.046665, 62.665276],
                [12.07278, 62.7158280000001],
                [12.089443, 62.74944],
                [12.066666, 62.80305],
                [12.050278, 62.838882],
                [12.028889, 62.892494],
                [12.058332, 62.918610000000115],
                [12.113333, 62.96721600000012],
                [12.15111, 62.999443],
                [12.16861, 63.015831],
                [12.144165, 63.04527300000012],
                [12.036943000000122, 63.173882],
                [12.027491, 63.182449],
                [11.936388, 63.272217],
                [11.998888, 63.323883],
                [12.0783330000001, 63.38832900000011],
                [12.13722, 63.436661],
                [12.195000000000107, 63.485275000000115],
                [12.17861, 63.512215],
                [12.139444, 63.58416],
                [12.153889000000106, 63.594994],
                [12.346666, 63.72888200000011],
                [12.47305, 63.833328],
                [12.53083, 63.87277],
                [12.63389, 63.942772],
                [12.681944, 63.96721600000012],
                [12.794443, 64.007217],
                [12.846943, 64.025269],
                [12.93805, 64.05332900000013],
                [12.988333000000125, 64.064438],
                [13.032221, 64.071106],
                [13.135555000000124, 64.083603],
                [13.193609, 64.09],
                [13.23, 64.093048],
                [13.29139, 64.08665500000012],
                [13.98166700000013, 64.013046],
                [13.988333000000125, 64.01805100000013],
                [14.14667, 64.173874],
                [14.154722, 64.185822],
                [14.151388, 64.3336],
                [14.149721, 64.34499],
                [14.11639, 64.470551],
                [14.032499, 64.488052],
                [13.900833, 64.507492],
                [13.82028, 64.529434],
                [13.68222, 64.5711060000001],
                [13.663332, 64.577209],
                [13.6625, 64.58276400000011],
                [13.664999000000137, 64.58972200000011],
                [13.676943, 64.60777300000012],
                [13.69694, 64.62944],
                [13.7075, 64.63971],
                [13.725571, 64.652267],
                [13.832777000000135, 64.7333220000001],
                [13.879166, 64.771103],
                [13.95583, 64.83554100000015],
                [14.09139, 64.949158],
                [14.235277, 65.04887400000013],
                [14.296438000000137, 65.102127],
                [14.30883, 65.115234],
                [14.319443, 65.12999],
                [14.329166, 65.149719],
                [14.35611, 65.208603],
                [14.368889, 65.24665800000014],
                [14.493055, 65.313599],
                [14.494444000000101, 65.358887],
                [14.49361, 65.37638900000013],
                [14.495277000000101, 65.446381],
                [14.49722, 65.516098],
                [14.50055, 65.585831],
                [14.532221000000106, 65.69611],
                [14.535, 65.702774],
                [14.53944, 65.70887800000014],
                [14.565277, 65.736374],
                [14.588055, 65.75694],
                [14.60389, 65.773331],
                [14.62138700000014, 65.797211],
                [14.63166600000011, 65.816666],
                [14.634722, 65.826935],
                [14.608889, 65.876389],
                [14.58027600000014, 65.931107],
                [14.56944, 65.94943200000012],
                [14.54055, 66.007492],
                [14.534721, 66.025269],
                [14.519165, 66.07888800000012],
                [14.509165, 66.11472],
                [14.505, 66.13249200000013],
                [14.717777, 66.140549],
                [14.981388, 66.149155],
                [15.025276, 66.149994],
                [15.468054, 66.28387],
                [15.446854, 66.32138],
                [15.400555, 66.406937],
                [15.371387, 66.461655],
                [15.362778, 66.479996],
                [15.527777, 66.558044],
                [15.625832, 66.60582000000011],
                [15.73111, 66.68499800000012],
                [16.00999800000011, 66.890823],
                [16.353886, 67.017776],
                [16.40583, 67.16333],
                [16.399166, 67.177765],
                [16.36138, 67.237778],
                [16.3375, 67.260818],
                [16.26194, 67.305542],
                [16.220554, 67.329987],
                [16.204720000000123, 67.337494],
                [16.161663, 67.35582],
                [16.13861100000014, 67.36749],
                [16.11111, 67.383606],
                [16.10416, 67.387772],
                [16.089722, 67.401657],
                [16.086941000000138, 67.406662],
                [16.085831, 67.41165200000012],
                [16.192219000000136, 67.5],
                [16.206108, 67.50166300000012],
                [16.3825, 67.515549],
                [16.403332, 67.529999],
                [16.508331000000112, 67.60916],
                [16.57027, 67.656937],
                [16.57694, 67.66554300000013],
                [16.588055, 67.68222000000014],
                [16.6202770000001, 67.732208],
                [16.68472, 67.83221],
                [16.726944000000117, 67.899155],
                [17.188332, 68.030273],
                [17.234547, 68.062103],
                [17.252583, 68.07457],
                [17.273609, 68.090546],
                [17.5925, 68.029709],
                [17.648888, 68.01416],
                [17.68027, 68.0044400000001],
                [17.74333, 67.984711],
                [17.801941, 67.964157],
                [17.82, 67.95694],
                [17.83111, 67.953598],
                [17.858055, 67.94861],
                [17.884163, 67.945541],
                [17.939720000000136, 67.99777200000011],
                [18.135555, 68.150269],
                [18.155277, 68.16611],
                [18.103886, 68.280823],
                [18.085831, 68.31776400000012],
                [18.069443, 68.35443],
                [18.053333, 68.39109800000011],
                [18.04583, 68.40943900000013],
                [18.058052, 68.439987],
                [18.08166, 68.490829],
                [18.09083, 68.50776700000011],
                [18.099541, 68.508926],
                [18.149441, 68.515274],
                [18.35805, 68.539154],
                [18.611942, 68.475266],
                [18.952221, 68.487778],
                [19.41333, 68.419434],
                [19.543888, 68.399719],
                [19.71722, 68.37277200000011],
                [19.860554, 68.3499910000001],
                [19.898331, 68.341385],
                [19.92388, 68.336655],
                [19.9377750000001, 68.3374940000001],
                [19.94805, 68.34082],
                [19.956665, 68.344711],
                [19.96416, 68.34971600000011],
                [19.976665, 68.36137400000013],
                [20.006664, 68.38110400000011],
                [20.03028, 68.394989],
                [20.048054, 68.40332000000012],
                [20.07583, 68.414719],
                [20.167221, 68.44388],
                [20.175831, 68.448044],
                [20.198608, 68.462769],
                [20.208611, 68.47583],
                [20.211109, 68.48220800000013],
                [20.088055, 68.501663],
                [19.956387, 68.5438840000001],
                [20.063053, 68.583054],
                [20.177219, 68.646942],
                [20.202499000000103, 68.662216],
                [20.23833100000013, 68.691376],
                [20.313889, 68.75471500000015],
                [20.35027700000012, 68.78665200000012],
                [20.314720000000136, 68.92833],
                [20.238888, 68.968597],
                [20.096943, 69.042221],
                [20.535275, 69.05638],
                [20.580929, 69.0603],
                [20.60416400000014, 69.05305],
                [20.65006, 69.04379300000011],
                [20.744164, 69.0311],
                [20.79166, 69.023331],
                [20.84638600000011, 69.011932],
                [20.866665, 69.00499],
                [20.884441, 68.997498],
                [20.908886, 68.9855500000001],
                [20.92860800000011, 68.97305],
                [20.9327770000001, 68.96832300000011],
                [20.938889, 68.958328],
                [20.938332, 68.952774],
                [20.93111, 68.946381],
                [20.915554, 68.939438],
                [20.888885, 68.925827],
                [20.88305300000013, 68.91333],
                [20.88277, 68.90777600000013],
                [20.888611, 68.898041],
                [20.895275, 68.8936000000001],
                [20.904163, 68.889999],
                [20.91527600000012, 68.886658],
                [20.94472, 68.88138],
                [20.959442000000138, 68.87999],
                [20.990833, 68.87944],
                [21.02472, 68.877487],
                [21.05888700000014, 68.873322],
                [21.081387, 68.86665],
                [21.207775, 68.81972],
                [21.21666, 68.81610100000012],
                [21.420555, 68.724152],
                [21.44861, 68.691101],
                [21.452774, 68.686661],
                [21.465553000000114, 68.678055],
                [21.487499000000128, 68.67139],
                [21.500832, 68.66832],
                [21.55055, 68.661652],
                [21.585278, 68.6586],
                [21.601109000000122, 68.6561],
                [21.62305, 68.649429],
                [21.64277600000014, 68.642487],
                [21.701664, 68.62082],
                [21.710278, 68.617218],
                [21.714165, 68.612488],
                [21.711109, 68.606384],
                [21.710552, 68.60055],
                [21.71833, 68.59111000000013],
                [21.735554, 68.5836],
                [21.757500000000107, 68.576935],
                [21.773331, 68.574432],
                [21.809166, 68.570541],
              ],
            ],
          ],
        },
        id: 26,
        NAME: 'Sweden',
      },
    ],
  }
  
  export default europegeo
  